import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
import * as ApolloReactHooks from '@dreamstack/artemis';
export type Maybe<T> = T | null;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  /**
   * A date-time string at UTC, such as 2007-12-03T10:15:30Z,
   *     compliant with the 'date-time' format outlined in section 5.6 of
   *     the RFC 3339 profile of the ISO 8601 standard for representation
   *     of dates and times using the Gregorian calendar.
   */
  DateTime: any;
  /** The 'Dimension' type represents dimensions as whole numeric values between `1` and `4000`. */
  Dimension: any;
  /** The 'Quality' type represents quality as whole numeric values between `1` and `100`. */
  Quality: any;
  /** The 'HexColor' type represents color in `rgb:ffffff` string format. */
  HexColor: any;
  /** The `JSON` scalar type represents JSON values as specified by [ECMA-404](http://www.ecma-international.org/publications/files/ECMA-ST/ECMA-404.pdf). */
  JSON: any;
};

export type Query = {
  __typename?: 'Query';
  asset?: Maybe<Asset>;
  assetCollection?: Maybe<AssetCollection>;
  regionDescriptionText?: Maybe<RegionDescriptionText>;
  regionDescriptionTextCollection?: Maybe<RegionDescriptionTextCollection>;
  blockTable?: Maybe<BlockTable>;
  blockTableCollection?: Maybe<BlockTableCollection>;
  navBarEntry?: Maybe<NavBarEntry>;
  navBarEntryCollection?: Maybe<NavBarEntryCollection>;
  footer?: Maybe<Footer>;
  footerCollection?: Maybe<FooterCollection>;
  blockCustom?: Maybe<BlockCustom>;
  blockCustomCollection?: Maybe<BlockCustomCollection>;
  blockBigTitleNavigation?: Maybe<BlockBigTitleNavigation>;
  blockBigTitleNavigationCollection?: Maybe<BlockBigTitleNavigationCollection>;
  seo?: Maybe<Seo>;
  seoCollection?: Maybe<SeoCollection>;
  staticPage?: Maybe<StaticPage>;
  staticPageCollection?: Maybe<StaticPageCollection>;
  blockHiddenWithConsent?: Maybe<BlockHiddenWithConsent>;
  blockHiddenWithConsentCollection?: Maybe<BlockHiddenWithConsentCollection>;
  blockCallToActionButton?: Maybe<BlockCallToActionButton>;
  blockCallToActionButtonCollection?: Maybe<BlockCallToActionButtonCollection>;
  heroImage?: Maybe<HeroImage>;
  heroImageCollection?: Maybe<HeroImageCollection>;
  blockSpeechBubble?: Maybe<BlockSpeechBubble>;
  blockSpeechBubbleCollection?: Maybe<BlockSpeechBubbleCollection>;
  blockRibbon?: Maybe<BlockRibbon>;
  blockRibbonCollection?: Maybe<BlockRibbonCollection>;
  blockSliderEntry?: Maybe<BlockSliderEntry>;
  blockSliderEntryCollection?: Maybe<BlockSliderEntryCollection>;
  blockSlider?: Maybe<BlockSlider>;
  blockSliderCollection?: Maybe<BlockSliderCollection>;
  lexiconArticle?: Maybe<LexiconArticle>;
  lexiconArticleCollection?: Maybe<LexiconArticleCollection>;
  blockTextCloud?: Maybe<BlockTextCloud>;
  blockTextCloudCollection?: Maybe<BlockTextCloudCollection>;
  blockFullsizeImage?: Maybe<BlockFullsizeImage>;
  blockFullsizeImageCollection?: Maybe<BlockFullsizeImageCollection>;
  blockOneColumn?: Maybe<BlockOneColumn>;
  blockOneColumnCollection?: Maybe<BlockOneColumnCollection>;
  blockRichText?: Maybe<BlockRichText>;
  blockRichTextCollection?: Maybe<BlockRichTextCollection>;
  blockTwoColumn?: Maybe<BlockTwoColumn>;
  blockTwoColumnCollection?: Maybe<BlockTwoColumnCollection>;
  blockAccordion?: Maybe<BlockAccordion>;
  blockAccordionCollection?: Maybe<BlockAccordionCollection>;
  blockAnalystRating?: Maybe<BlockAnalystRating>;
  blockAnalystRatingCollection?: Maybe<BlockAnalystRatingCollection>;
  blockAccordionEntry?: Maybe<BlockAccordionEntry>;
  blockAccordionEntryCollection?: Maybe<BlockAccordionEntryCollection>;
  blockImageGallery?: Maybe<BlockImageGallery>;
  blockImageGalleryCollection?: Maybe<BlockImageGalleryCollection>;
  newsArticle?: Maybe<NewsArticle>;
  newsArticleCollection?: Maybe<NewsArticleCollection>;
  blockSubNavigation?: Maybe<BlockSubNavigation>;
  blockSubNavigationCollection?: Maybe<BlockSubNavigationCollection>;
  blockHighlightRealEstate?: Maybe<BlockHighlightRealEstate>;
  blockHighlightRealEstateCollection?: Maybe<BlockHighlightRealEstateCollection>;
  highlightedRealEstate?: Maybe<HighlightedRealEstate>;
  highlightedRealEstateCollection?: Maybe<HighlightedRealEstateCollection>;
  blockLinkSection?: Maybe<BlockLinkSection>;
  blockLinkSectionCollection?: Maybe<BlockLinkSectionCollection>;
  linkSectionEntry?: Maybe<LinkSectionEntry>;
  linkSectionEntryCollection?: Maybe<LinkSectionEntryCollection>;
  projectPage?: Maybe<ProjectPage>;
  projectPageCollection?: Maybe<ProjectPageCollection>;
  blockVideo?: Maybe<BlockVideo>;
  blockVideoCollection?: Maybe<BlockVideoCollection>;
  partner?: Maybe<Partner>;
  partnerCollection?: Maybe<PartnerCollection>;
  projectLink?: Maybe<ProjectLink>;
  projectLinkCollection?: Maybe<ProjectLinkCollection>;
  projectImageMap?: Maybe<ProjectImageMap>;
  projectImageMapCollection?: Maybe<ProjectImageMapCollection>;
  blockProjectLinkSection?: Maybe<BlockProjectLinkSection>;
  blockProjectLinkSectionCollection?: Maybe<BlockProjectLinkSectionCollection>;
  downloadableFile?: Maybe<DownloadableFile>;
  downloadableFileCollection?: Maybe<DownloadableFileCollection>;
  personAccordionEntry?: Maybe<PersonAccordionEntry>;
  personAccordionEntryCollection?: Maybe<PersonAccordionEntryCollection>;
  blockPartnerGrid?: Maybe<BlockPartnerGrid>;
  blockPartnerGridCollection?: Maybe<BlockPartnerGridCollection>;
  blockStockPrice?: Maybe<BlockStockPrice>;
  blockStockPriceCollection?: Maybe<BlockStockPriceCollection>;
  navigationEntry?: Maybe<NavigationEntry>;
  navigationEntryCollection?: Maybe<NavigationEntryCollection>;
  latestDownload?: Maybe<LatestDownload>;
  latestDownloadCollection?: Maybe<LatestDownloadCollection>;
  blockThreeColumn?: Maybe<BlockThreeColumn>;
  blockThreeColumnCollection?: Maybe<BlockThreeColumnCollection>;
  newsArticleContact?: Maybe<NewsArticleContact>;
  newsArticleContactCollection?: Maybe<NewsArticleContactCollection>;
  barChartWithBackground?: Maybe<BarChartWithBackground>;
  barChartWithBackgroundCollection?: Maybe<BarChartWithBackgroundCollection>;
  blockPersonAccordion?: Maybe<BlockPersonAccordion>;
  blockPersonAccordionCollection?: Maybe<BlockPersonAccordionCollection>;
  entryCollection?: Maybe<EntryCollection>;
  _node?: Maybe<_Node>;
};


export type QueryAssetArgs = {
  id: Scalars['String'];
  preview?: Maybe<Scalars['Boolean']>;
  locale?: Maybe<Scalars['String']>;
};


export type QueryAssetCollectionArgs = {
  skip?: Maybe<Scalars['Int']>;
  limit?: Maybe<Scalars['Int']>;
  preview?: Maybe<Scalars['Boolean']>;
  locale?: Maybe<Scalars['String']>;
  where?: Maybe<AssetFilter>;
  order?: Maybe<Array<Maybe<AssetOrder>>>;
};


export type QueryRegionDescriptionTextArgs = {
  id: Scalars['String'];
  preview?: Maybe<Scalars['Boolean']>;
  locale?: Maybe<Scalars['String']>;
};


export type QueryRegionDescriptionTextCollectionArgs = {
  skip?: Maybe<Scalars['Int']>;
  limit?: Maybe<Scalars['Int']>;
  preview?: Maybe<Scalars['Boolean']>;
  locale?: Maybe<Scalars['String']>;
  where?: Maybe<RegionDescriptionTextFilter>;
  order?: Maybe<Array<Maybe<RegionDescriptionTextOrder>>>;
};


export type QueryBlockTableArgs = {
  id: Scalars['String'];
  preview?: Maybe<Scalars['Boolean']>;
  locale?: Maybe<Scalars['String']>;
};


export type QueryBlockTableCollectionArgs = {
  skip?: Maybe<Scalars['Int']>;
  limit?: Maybe<Scalars['Int']>;
  preview?: Maybe<Scalars['Boolean']>;
  locale?: Maybe<Scalars['String']>;
  where?: Maybe<BlockTableFilter>;
  order?: Maybe<Array<Maybe<BlockTableOrder>>>;
};


export type QueryNavBarEntryArgs = {
  id: Scalars['String'];
  preview?: Maybe<Scalars['Boolean']>;
  locale?: Maybe<Scalars['String']>;
};


export type QueryNavBarEntryCollectionArgs = {
  skip?: Maybe<Scalars['Int']>;
  limit?: Maybe<Scalars['Int']>;
  preview?: Maybe<Scalars['Boolean']>;
  locale?: Maybe<Scalars['String']>;
  where?: Maybe<NavBarEntryFilter>;
  order?: Maybe<Array<Maybe<NavBarEntryOrder>>>;
};


export type QueryFooterArgs = {
  id: Scalars['String'];
  preview?: Maybe<Scalars['Boolean']>;
  locale?: Maybe<Scalars['String']>;
};


export type QueryFooterCollectionArgs = {
  skip?: Maybe<Scalars['Int']>;
  limit?: Maybe<Scalars['Int']>;
  preview?: Maybe<Scalars['Boolean']>;
  locale?: Maybe<Scalars['String']>;
  where?: Maybe<FooterFilter>;
  order?: Maybe<Array<Maybe<FooterOrder>>>;
};


export type QueryBlockCustomArgs = {
  id: Scalars['String'];
  preview?: Maybe<Scalars['Boolean']>;
  locale?: Maybe<Scalars['String']>;
};


export type QueryBlockCustomCollectionArgs = {
  skip?: Maybe<Scalars['Int']>;
  limit?: Maybe<Scalars['Int']>;
  preview?: Maybe<Scalars['Boolean']>;
  locale?: Maybe<Scalars['String']>;
  where?: Maybe<BlockCustomFilter>;
  order?: Maybe<Array<Maybe<BlockCustomOrder>>>;
};


export type QueryBlockBigTitleNavigationArgs = {
  id: Scalars['String'];
  preview?: Maybe<Scalars['Boolean']>;
  locale?: Maybe<Scalars['String']>;
};


export type QueryBlockBigTitleNavigationCollectionArgs = {
  skip?: Maybe<Scalars['Int']>;
  limit?: Maybe<Scalars['Int']>;
  preview?: Maybe<Scalars['Boolean']>;
  locale?: Maybe<Scalars['String']>;
  where?: Maybe<BlockBigTitleNavigationFilter>;
  order?: Maybe<Array<Maybe<BlockBigTitleNavigationOrder>>>;
};


export type QuerySeoArgs = {
  id: Scalars['String'];
  preview?: Maybe<Scalars['Boolean']>;
  locale?: Maybe<Scalars['String']>;
};


export type QuerySeoCollectionArgs = {
  skip?: Maybe<Scalars['Int']>;
  limit?: Maybe<Scalars['Int']>;
  preview?: Maybe<Scalars['Boolean']>;
  locale?: Maybe<Scalars['String']>;
  where?: Maybe<SeoFilter>;
  order?: Maybe<Array<Maybe<SeoOrder>>>;
};


export type QueryStaticPageArgs = {
  id: Scalars['String'];
  preview?: Maybe<Scalars['Boolean']>;
  locale?: Maybe<Scalars['String']>;
};


export type QueryStaticPageCollectionArgs = {
  skip?: Maybe<Scalars['Int']>;
  limit?: Maybe<Scalars['Int']>;
  preview?: Maybe<Scalars['Boolean']>;
  locale?: Maybe<Scalars['String']>;
  where?: Maybe<StaticPageFilter>;
  order?: Maybe<Array<Maybe<StaticPageOrder>>>;
};


export type QueryBlockHiddenWithConsentArgs = {
  id: Scalars['String'];
  preview?: Maybe<Scalars['Boolean']>;
  locale?: Maybe<Scalars['String']>;
};


export type QueryBlockHiddenWithConsentCollectionArgs = {
  skip?: Maybe<Scalars['Int']>;
  limit?: Maybe<Scalars['Int']>;
  preview?: Maybe<Scalars['Boolean']>;
  locale?: Maybe<Scalars['String']>;
  where?: Maybe<BlockHiddenWithConsentFilter>;
  order?: Maybe<Array<Maybe<BlockHiddenWithConsentOrder>>>;
};


export type QueryBlockCallToActionButtonArgs = {
  id: Scalars['String'];
  preview?: Maybe<Scalars['Boolean']>;
  locale?: Maybe<Scalars['String']>;
};


export type QueryBlockCallToActionButtonCollectionArgs = {
  skip?: Maybe<Scalars['Int']>;
  limit?: Maybe<Scalars['Int']>;
  preview?: Maybe<Scalars['Boolean']>;
  locale?: Maybe<Scalars['String']>;
  where?: Maybe<BlockCallToActionButtonFilter>;
  order?: Maybe<Array<Maybe<BlockCallToActionButtonOrder>>>;
};


export type QueryHeroImageArgs = {
  id: Scalars['String'];
  preview?: Maybe<Scalars['Boolean']>;
  locale?: Maybe<Scalars['String']>;
};


export type QueryHeroImageCollectionArgs = {
  skip?: Maybe<Scalars['Int']>;
  limit?: Maybe<Scalars['Int']>;
  preview?: Maybe<Scalars['Boolean']>;
  locale?: Maybe<Scalars['String']>;
  where?: Maybe<HeroImageFilter>;
  order?: Maybe<Array<Maybe<HeroImageOrder>>>;
};


export type QueryBlockSpeechBubbleArgs = {
  id: Scalars['String'];
  preview?: Maybe<Scalars['Boolean']>;
  locale?: Maybe<Scalars['String']>;
};


export type QueryBlockSpeechBubbleCollectionArgs = {
  skip?: Maybe<Scalars['Int']>;
  limit?: Maybe<Scalars['Int']>;
  preview?: Maybe<Scalars['Boolean']>;
  locale?: Maybe<Scalars['String']>;
  where?: Maybe<BlockSpeechBubbleFilter>;
  order?: Maybe<Array<Maybe<BlockSpeechBubbleOrder>>>;
};


export type QueryBlockRibbonArgs = {
  id: Scalars['String'];
  preview?: Maybe<Scalars['Boolean']>;
  locale?: Maybe<Scalars['String']>;
};


export type QueryBlockRibbonCollectionArgs = {
  skip?: Maybe<Scalars['Int']>;
  limit?: Maybe<Scalars['Int']>;
  preview?: Maybe<Scalars['Boolean']>;
  locale?: Maybe<Scalars['String']>;
  where?: Maybe<BlockRibbonFilter>;
  order?: Maybe<Array<Maybe<BlockRibbonOrder>>>;
};


export type QueryBlockSliderEntryArgs = {
  id: Scalars['String'];
  preview?: Maybe<Scalars['Boolean']>;
  locale?: Maybe<Scalars['String']>;
};


export type QueryBlockSliderEntryCollectionArgs = {
  skip?: Maybe<Scalars['Int']>;
  limit?: Maybe<Scalars['Int']>;
  preview?: Maybe<Scalars['Boolean']>;
  locale?: Maybe<Scalars['String']>;
  where?: Maybe<BlockSliderEntryFilter>;
  order?: Maybe<Array<Maybe<BlockSliderEntryOrder>>>;
};


export type QueryBlockSliderArgs = {
  id: Scalars['String'];
  preview?: Maybe<Scalars['Boolean']>;
  locale?: Maybe<Scalars['String']>;
};


export type QueryBlockSliderCollectionArgs = {
  skip?: Maybe<Scalars['Int']>;
  limit?: Maybe<Scalars['Int']>;
  preview?: Maybe<Scalars['Boolean']>;
  locale?: Maybe<Scalars['String']>;
  where?: Maybe<BlockSliderFilter>;
  order?: Maybe<Array<Maybe<BlockSliderOrder>>>;
};


export type QueryLexiconArticleArgs = {
  id: Scalars['String'];
  preview?: Maybe<Scalars['Boolean']>;
  locale?: Maybe<Scalars['String']>;
};


export type QueryLexiconArticleCollectionArgs = {
  skip?: Maybe<Scalars['Int']>;
  limit?: Maybe<Scalars['Int']>;
  preview?: Maybe<Scalars['Boolean']>;
  locale?: Maybe<Scalars['String']>;
  where?: Maybe<LexiconArticleFilter>;
  order?: Maybe<Array<Maybe<LexiconArticleOrder>>>;
};


export type QueryBlockTextCloudArgs = {
  id: Scalars['String'];
  preview?: Maybe<Scalars['Boolean']>;
  locale?: Maybe<Scalars['String']>;
};


export type QueryBlockTextCloudCollectionArgs = {
  skip?: Maybe<Scalars['Int']>;
  limit?: Maybe<Scalars['Int']>;
  preview?: Maybe<Scalars['Boolean']>;
  locale?: Maybe<Scalars['String']>;
  where?: Maybe<BlockTextCloudFilter>;
  order?: Maybe<Array<Maybe<BlockTextCloudOrder>>>;
};


export type QueryBlockFullsizeImageArgs = {
  id: Scalars['String'];
  preview?: Maybe<Scalars['Boolean']>;
  locale?: Maybe<Scalars['String']>;
};


export type QueryBlockFullsizeImageCollectionArgs = {
  skip?: Maybe<Scalars['Int']>;
  limit?: Maybe<Scalars['Int']>;
  preview?: Maybe<Scalars['Boolean']>;
  locale?: Maybe<Scalars['String']>;
  where?: Maybe<BlockFullsizeImageFilter>;
  order?: Maybe<Array<Maybe<BlockFullsizeImageOrder>>>;
};


export type QueryBlockOneColumnArgs = {
  id: Scalars['String'];
  preview?: Maybe<Scalars['Boolean']>;
  locale?: Maybe<Scalars['String']>;
};


export type QueryBlockOneColumnCollectionArgs = {
  skip?: Maybe<Scalars['Int']>;
  limit?: Maybe<Scalars['Int']>;
  preview?: Maybe<Scalars['Boolean']>;
  locale?: Maybe<Scalars['String']>;
  where?: Maybe<BlockOneColumnFilter>;
  order?: Maybe<Array<Maybe<BlockOneColumnOrder>>>;
};


export type QueryBlockRichTextArgs = {
  id: Scalars['String'];
  preview?: Maybe<Scalars['Boolean']>;
  locale?: Maybe<Scalars['String']>;
};


export type QueryBlockRichTextCollectionArgs = {
  skip?: Maybe<Scalars['Int']>;
  limit?: Maybe<Scalars['Int']>;
  preview?: Maybe<Scalars['Boolean']>;
  locale?: Maybe<Scalars['String']>;
  where?: Maybe<BlockRichTextFilter>;
  order?: Maybe<Array<Maybe<BlockRichTextOrder>>>;
};


export type QueryBlockTwoColumnArgs = {
  id: Scalars['String'];
  preview?: Maybe<Scalars['Boolean']>;
  locale?: Maybe<Scalars['String']>;
};


export type QueryBlockTwoColumnCollectionArgs = {
  skip?: Maybe<Scalars['Int']>;
  limit?: Maybe<Scalars['Int']>;
  preview?: Maybe<Scalars['Boolean']>;
  locale?: Maybe<Scalars['String']>;
  where?: Maybe<BlockTwoColumnFilter>;
  order?: Maybe<Array<Maybe<BlockTwoColumnOrder>>>;
};


export type QueryBlockAccordionArgs = {
  id: Scalars['String'];
  preview?: Maybe<Scalars['Boolean']>;
  locale?: Maybe<Scalars['String']>;
};


export type QueryBlockAccordionCollectionArgs = {
  skip?: Maybe<Scalars['Int']>;
  limit?: Maybe<Scalars['Int']>;
  preview?: Maybe<Scalars['Boolean']>;
  locale?: Maybe<Scalars['String']>;
  where?: Maybe<BlockAccordionFilter>;
  order?: Maybe<Array<Maybe<BlockAccordionOrder>>>;
};


export type QueryBlockAnalystRatingArgs = {
  id: Scalars['String'];
  preview?: Maybe<Scalars['Boolean']>;
  locale?: Maybe<Scalars['String']>;
};


export type QueryBlockAnalystRatingCollectionArgs = {
  skip?: Maybe<Scalars['Int']>;
  limit?: Maybe<Scalars['Int']>;
  preview?: Maybe<Scalars['Boolean']>;
  locale?: Maybe<Scalars['String']>;
  where?: Maybe<BlockAnalystRatingFilter>;
  order?: Maybe<Array<Maybe<BlockAnalystRatingOrder>>>;
};


export type QueryBlockAccordionEntryArgs = {
  id: Scalars['String'];
  preview?: Maybe<Scalars['Boolean']>;
  locale?: Maybe<Scalars['String']>;
};


export type QueryBlockAccordionEntryCollectionArgs = {
  skip?: Maybe<Scalars['Int']>;
  limit?: Maybe<Scalars['Int']>;
  preview?: Maybe<Scalars['Boolean']>;
  locale?: Maybe<Scalars['String']>;
  where?: Maybe<BlockAccordionEntryFilter>;
  order?: Maybe<Array<Maybe<BlockAccordionEntryOrder>>>;
};


export type QueryBlockImageGalleryArgs = {
  id: Scalars['String'];
  preview?: Maybe<Scalars['Boolean']>;
  locale?: Maybe<Scalars['String']>;
};


export type QueryBlockImageGalleryCollectionArgs = {
  skip?: Maybe<Scalars['Int']>;
  limit?: Maybe<Scalars['Int']>;
  preview?: Maybe<Scalars['Boolean']>;
  locale?: Maybe<Scalars['String']>;
  where?: Maybe<BlockImageGalleryFilter>;
  order?: Maybe<Array<Maybe<BlockImageGalleryOrder>>>;
};


export type QueryNewsArticleArgs = {
  id: Scalars['String'];
  preview?: Maybe<Scalars['Boolean']>;
  locale?: Maybe<Scalars['String']>;
};


export type QueryNewsArticleCollectionArgs = {
  skip?: Maybe<Scalars['Int']>;
  limit?: Maybe<Scalars['Int']>;
  preview?: Maybe<Scalars['Boolean']>;
  locale?: Maybe<Scalars['String']>;
  where?: Maybe<NewsArticleFilter>;
  order?: Maybe<Array<Maybe<NewsArticleOrder>>>;
};


export type QueryBlockSubNavigationArgs = {
  id: Scalars['String'];
  preview?: Maybe<Scalars['Boolean']>;
  locale?: Maybe<Scalars['String']>;
};


export type QueryBlockSubNavigationCollectionArgs = {
  skip?: Maybe<Scalars['Int']>;
  limit?: Maybe<Scalars['Int']>;
  preview?: Maybe<Scalars['Boolean']>;
  locale?: Maybe<Scalars['String']>;
  where?: Maybe<BlockSubNavigationFilter>;
  order?: Maybe<Array<Maybe<BlockSubNavigationOrder>>>;
};


export type QueryBlockHighlightRealEstateArgs = {
  id: Scalars['String'];
  preview?: Maybe<Scalars['Boolean']>;
  locale?: Maybe<Scalars['String']>;
};


export type QueryBlockHighlightRealEstateCollectionArgs = {
  skip?: Maybe<Scalars['Int']>;
  limit?: Maybe<Scalars['Int']>;
  preview?: Maybe<Scalars['Boolean']>;
  locale?: Maybe<Scalars['String']>;
  where?: Maybe<BlockHighlightRealEstateFilter>;
  order?: Maybe<Array<Maybe<BlockHighlightRealEstateOrder>>>;
};


export type QueryHighlightedRealEstateArgs = {
  id: Scalars['String'];
  preview?: Maybe<Scalars['Boolean']>;
  locale?: Maybe<Scalars['String']>;
};


export type QueryHighlightedRealEstateCollectionArgs = {
  skip?: Maybe<Scalars['Int']>;
  limit?: Maybe<Scalars['Int']>;
  preview?: Maybe<Scalars['Boolean']>;
  locale?: Maybe<Scalars['String']>;
  where?: Maybe<HighlightedRealEstateFilter>;
  order?: Maybe<Array<Maybe<HighlightedRealEstateOrder>>>;
};


export type QueryBlockLinkSectionArgs = {
  id: Scalars['String'];
  preview?: Maybe<Scalars['Boolean']>;
  locale?: Maybe<Scalars['String']>;
};


export type QueryBlockLinkSectionCollectionArgs = {
  skip?: Maybe<Scalars['Int']>;
  limit?: Maybe<Scalars['Int']>;
  preview?: Maybe<Scalars['Boolean']>;
  locale?: Maybe<Scalars['String']>;
  where?: Maybe<BlockLinkSectionFilter>;
  order?: Maybe<Array<Maybe<BlockLinkSectionOrder>>>;
};


export type QueryLinkSectionEntryArgs = {
  id: Scalars['String'];
  preview?: Maybe<Scalars['Boolean']>;
  locale?: Maybe<Scalars['String']>;
};


export type QueryLinkSectionEntryCollectionArgs = {
  skip?: Maybe<Scalars['Int']>;
  limit?: Maybe<Scalars['Int']>;
  preview?: Maybe<Scalars['Boolean']>;
  locale?: Maybe<Scalars['String']>;
  where?: Maybe<LinkSectionEntryFilter>;
  order?: Maybe<Array<Maybe<LinkSectionEntryOrder>>>;
};


export type QueryProjectPageArgs = {
  id: Scalars['String'];
  preview?: Maybe<Scalars['Boolean']>;
  locale?: Maybe<Scalars['String']>;
};


export type QueryProjectPageCollectionArgs = {
  skip?: Maybe<Scalars['Int']>;
  limit?: Maybe<Scalars['Int']>;
  preview?: Maybe<Scalars['Boolean']>;
  locale?: Maybe<Scalars['String']>;
  where?: Maybe<ProjectPageFilter>;
  order?: Maybe<Array<Maybe<ProjectPageOrder>>>;
};


export type QueryBlockVideoArgs = {
  id: Scalars['String'];
  preview?: Maybe<Scalars['Boolean']>;
  locale?: Maybe<Scalars['String']>;
};


export type QueryBlockVideoCollectionArgs = {
  skip?: Maybe<Scalars['Int']>;
  limit?: Maybe<Scalars['Int']>;
  preview?: Maybe<Scalars['Boolean']>;
  locale?: Maybe<Scalars['String']>;
  where?: Maybe<BlockVideoFilter>;
  order?: Maybe<Array<Maybe<BlockVideoOrder>>>;
};


export type QueryPartnerArgs = {
  id: Scalars['String'];
  preview?: Maybe<Scalars['Boolean']>;
  locale?: Maybe<Scalars['String']>;
};


export type QueryPartnerCollectionArgs = {
  skip?: Maybe<Scalars['Int']>;
  limit?: Maybe<Scalars['Int']>;
  preview?: Maybe<Scalars['Boolean']>;
  locale?: Maybe<Scalars['String']>;
  where?: Maybe<PartnerFilter>;
  order?: Maybe<Array<Maybe<PartnerOrder>>>;
};


export type QueryProjectLinkArgs = {
  id: Scalars['String'];
  preview?: Maybe<Scalars['Boolean']>;
  locale?: Maybe<Scalars['String']>;
};


export type QueryProjectLinkCollectionArgs = {
  skip?: Maybe<Scalars['Int']>;
  limit?: Maybe<Scalars['Int']>;
  preview?: Maybe<Scalars['Boolean']>;
  locale?: Maybe<Scalars['String']>;
  where?: Maybe<ProjectLinkFilter>;
  order?: Maybe<Array<Maybe<ProjectLinkOrder>>>;
};


export type QueryProjectImageMapArgs = {
  id: Scalars['String'];
  preview?: Maybe<Scalars['Boolean']>;
  locale?: Maybe<Scalars['String']>;
};


export type QueryProjectImageMapCollectionArgs = {
  skip?: Maybe<Scalars['Int']>;
  limit?: Maybe<Scalars['Int']>;
  preview?: Maybe<Scalars['Boolean']>;
  locale?: Maybe<Scalars['String']>;
  where?: Maybe<ProjectImageMapFilter>;
  order?: Maybe<Array<Maybe<ProjectImageMapOrder>>>;
};


export type QueryBlockProjectLinkSectionArgs = {
  id: Scalars['String'];
  preview?: Maybe<Scalars['Boolean']>;
  locale?: Maybe<Scalars['String']>;
};


export type QueryBlockProjectLinkSectionCollectionArgs = {
  skip?: Maybe<Scalars['Int']>;
  limit?: Maybe<Scalars['Int']>;
  preview?: Maybe<Scalars['Boolean']>;
  locale?: Maybe<Scalars['String']>;
  where?: Maybe<BlockProjectLinkSectionFilter>;
  order?: Maybe<Array<Maybe<BlockProjectLinkSectionOrder>>>;
};


export type QueryDownloadableFileArgs = {
  id: Scalars['String'];
  preview?: Maybe<Scalars['Boolean']>;
  locale?: Maybe<Scalars['String']>;
};


export type QueryDownloadableFileCollectionArgs = {
  skip?: Maybe<Scalars['Int']>;
  limit?: Maybe<Scalars['Int']>;
  preview?: Maybe<Scalars['Boolean']>;
  locale?: Maybe<Scalars['String']>;
  where?: Maybe<DownloadableFileFilter>;
  order?: Maybe<Array<Maybe<DownloadableFileOrder>>>;
};


export type QueryPersonAccordionEntryArgs = {
  id: Scalars['String'];
  preview?: Maybe<Scalars['Boolean']>;
  locale?: Maybe<Scalars['String']>;
};


export type QueryPersonAccordionEntryCollectionArgs = {
  skip?: Maybe<Scalars['Int']>;
  limit?: Maybe<Scalars['Int']>;
  preview?: Maybe<Scalars['Boolean']>;
  locale?: Maybe<Scalars['String']>;
  where?: Maybe<PersonAccordionEntryFilter>;
  order?: Maybe<Array<Maybe<PersonAccordionEntryOrder>>>;
};


export type QueryBlockPartnerGridArgs = {
  id: Scalars['String'];
  preview?: Maybe<Scalars['Boolean']>;
  locale?: Maybe<Scalars['String']>;
};


export type QueryBlockPartnerGridCollectionArgs = {
  skip?: Maybe<Scalars['Int']>;
  limit?: Maybe<Scalars['Int']>;
  preview?: Maybe<Scalars['Boolean']>;
  locale?: Maybe<Scalars['String']>;
  where?: Maybe<BlockPartnerGridFilter>;
  order?: Maybe<Array<Maybe<BlockPartnerGridOrder>>>;
};


export type QueryBlockStockPriceArgs = {
  id: Scalars['String'];
  preview?: Maybe<Scalars['Boolean']>;
  locale?: Maybe<Scalars['String']>;
};


export type QueryBlockStockPriceCollectionArgs = {
  skip?: Maybe<Scalars['Int']>;
  limit?: Maybe<Scalars['Int']>;
  preview?: Maybe<Scalars['Boolean']>;
  locale?: Maybe<Scalars['String']>;
  where?: Maybe<BlockStockPriceFilter>;
  order?: Maybe<Array<Maybe<BlockStockPriceOrder>>>;
};


export type QueryNavigationEntryArgs = {
  id: Scalars['String'];
  preview?: Maybe<Scalars['Boolean']>;
  locale?: Maybe<Scalars['String']>;
};


export type QueryNavigationEntryCollectionArgs = {
  skip?: Maybe<Scalars['Int']>;
  limit?: Maybe<Scalars['Int']>;
  preview?: Maybe<Scalars['Boolean']>;
  locale?: Maybe<Scalars['String']>;
  where?: Maybe<NavigationEntryFilter>;
  order?: Maybe<Array<Maybe<NavigationEntryOrder>>>;
};


export type QueryLatestDownloadArgs = {
  id: Scalars['String'];
  preview?: Maybe<Scalars['Boolean']>;
  locale?: Maybe<Scalars['String']>;
};


export type QueryLatestDownloadCollectionArgs = {
  skip?: Maybe<Scalars['Int']>;
  limit?: Maybe<Scalars['Int']>;
  preview?: Maybe<Scalars['Boolean']>;
  locale?: Maybe<Scalars['String']>;
  where?: Maybe<LatestDownloadFilter>;
  order?: Maybe<Array<Maybe<LatestDownloadOrder>>>;
};


export type QueryBlockThreeColumnArgs = {
  id: Scalars['String'];
  preview?: Maybe<Scalars['Boolean']>;
  locale?: Maybe<Scalars['String']>;
};


export type QueryBlockThreeColumnCollectionArgs = {
  skip?: Maybe<Scalars['Int']>;
  limit?: Maybe<Scalars['Int']>;
  preview?: Maybe<Scalars['Boolean']>;
  locale?: Maybe<Scalars['String']>;
  where?: Maybe<BlockThreeColumnFilter>;
  order?: Maybe<Array<Maybe<BlockThreeColumnOrder>>>;
};


export type QueryNewsArticleContactArgs = {
  id: Scalars['String'];
  preview?: Maybe<Scalars['Boolean']>;
  locale?: Maybe<Scalars['String']>;
};


export type QueryNewsArticleContactCollectionArgs = {
  skip?: Maybe<Scalars['Int']>;
  limit?: Maybe<Scalars['Int']>;
  preview?: Maybe<Scalars['Boolean']>;
  locale?: Maybe<Scalars['String']>;
  where?: Maybe<NewsArticleContactFilter>;
  order?: Maybe<Array<Maybe<NewsArticleContactOrder>>>;
};


export type QueryBarChartWithBackgroundArgs = {
  id: Scalars['String'];
  preview?: Maybe<Scalars['Boolean']>;
  locale?: Maybe<Scalars['String']>;
};


export type QueryBarChartWithBackgroundCollectionArgs = {
  skip?: Maybe<Scalars['Int']>;
  limit?: Maybe<Scalars['Int']>;
  preview?: Maybe<Scalars['Boolean']>;
  locale?: Maybe<Scalars['String']>;
  where?: Maybe<BarChartWithBackgroundFilter>;
  order?: Maybe<Array<Maybe<BarChartWithBackgroundOrder>>>;
};


export type QueryBlockPersonAccordionArgs = {
  id: Scalars['String'];
  preview?: Maybe<Scalars['Boolean']>;
  locale?: Maybe<Scalars['String']>;
};


export type QueryBlockPersonAccordionCollectionArgs = {
  skip?: Maybe<Scalars['Int']>;
  limit?: Maybe<Scalars['Int']>;
  preview?: Maybe<Scalars['Boolean']>;
  locale?: Maybe<Scalars['String']>;
  where?: Maybe<BlockPersonAccordionFilter>;
  order?: Maybe<Array<Maybe<BlockPersonAccordionOrder>>>;
};


export type QueryEntryCollectionArgs = {
  skip?: Maybe<Scalars['Int']>;
  limit?: Maybe<Scalars['Int']>;
  preview?: Maybe<Scalars['Boolean']>;
  locale?: Maybe<Scalars['String']>;
  where?: Maybe<EntryFilter>;
  order?: Maybe<Array<Maybe<EntryOrder>>>;
};


export type Query_NodeArgs = {
  id: Scalars['ID'];
  preview?: Maybe<Scalars['Boolean']>;
  locale?: Maybe<Scalars['String']>;
};

/** Represents a binary file in a space. An asset can be any file type. */
export type Asset = {
  __typename?: 'Asset';
  sys: Sys;
  contentfulMetadata: ContentfulMetadata;
  title?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  contentType?: Maybe<Scalars['String']>;
  fileName?: Maybe<Scalars['String']>;
  size?: Maybe<Scalars['Int']>;
  url?: Maybe<Scalars['String']>;
  width?: Maybe<Scalars['Int']>;
  height?: Maybe<Scalars['Int']>;
  linkedFrom?: Maybe<AssetLinkingCollections>;
};


/** Represents a binary file in a space. An asset can be any file type. */
export type AssetTitleArgs = {
  locale?: Maybe<Scalars['String']>;
};


/** Represents a binary file in a space. An asset can be any file type. */
export type AssetDescriptionArgs = {
  locale?: Maybe<Scalars['String']>;
};


/** Represents a binary file in a space. An asset can be any file type. */
export type AssetContentTypeArgs = {
  locale?: Maybe<Scalars['String']>;
};


/** Represents a binary file in a space. An asset can be any file type. */
export type AssetFileNameArgs = {
  locale?: Maybe<Scalars['String']>;
};


/** Represents a binary file in a space. An asset can be any file type. */
export type AssetSizeArgs = {
  locale?: Maybe<Scalars['String']>;
};


/** Represents a binary file in a space. An asset can be any file type. */
export type AssetUrlArgs = {
  transform?: Maybe<ImageTransformOptions>;
  locale?: Maybe<Scalars['String']>;
};


/** Represents a binary file in a space. An asset can be any file type. */
export type AssetWidthArgs = {
  locale?: Maybe<Scalars['String']>;
};


/** Represents a binary file in a space. An asset can be any file type. */
export type AssetHeightArgs = {
  locale?: Maybe<Scalars['String']>;
};


/** Represents a binary file in a space. An asset can be any file type. */
export type AssetLinkedFromArgs = {
  allowedLocales?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type Sys = {
  __typename?: 'Sys';
  id: Scalars['String'];
  spaceId: Scalars['String'];
  environmentId: Scalars['String'];
  publishedAt?: Maybe<Scalars['DateTime']>;
  firstPublishedAt?: Maybe<Scalars['DateTime']>;
  publishedVersion?: Maybe<Scalars['Int']>;
  /** The locale that was requested. */
  locale?: Maybe<Scalars['String']>;
};


export type ContentfulMetadata = {
  __typename?: 'ContentfulMetadata';
  tags: Array<Maybe<ContentfulTag>>;
  concepts: Array<Maybe<TaxonomyConcept>>;
};

/**
 * Represents a taxonomy concept entity for finding and organizing content easily.
 *         Find out more here: https://www.contentful.com/developers/docs/references/content-delivery-api/#/reference/content-concepts
 */
export type TaxonomyConcept = {
  __typename?: 'TaxonomyConcept';
  id?: Maybe<Scalars['String']>;
};

/**
 * Represents a tag entity for finding and organizing content easily.
 *       Find out more here: https://www.contentful.com/developers/docs/references/content-delivery-api/#/reference/content-tags
 */
export type ContentfulTag = {
  __typename?: 'ContentfulTag';
  id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
};

export type ImageTransformOptions = {
  /** Desired width in pixels. Defaults to the original image width. */
  width?: Maybe<Scalars['Dimension']>;
  /** Desired height in pixels. Defaults to the original image height. */
  height?: Maybe<Scalars['Dimension']>;
  /**
   * Desired quality of the image in percents.
   *         Used for `PNG8`, `JPG`, `JPG_PROGRESSIVE` and `WEBP` formats.
   */
  quality?: Maybe<Scalars['Quality']>;
  /**
   * Desired corner radius in pixels.
   *         Results in an image with rounded corners (pass `-1` for a full circle/ellipse).
   *         Defaults to `0`. Uses desired background color as padding color,
   *         unless the format is `JPG` or `JPG_PROGRESSIVE` and resize strategy is `PAD`, then defaults to white.
   */
  cornerRadius?: Maybe<Scalars['Int']>;
  /** Desired resize strategy. Defaults to `FIT`. */
  resizeStrategy?: Maybe<ImageResizeStrategy>;
  /** Desired resize focus area. Defaults to `CENTER`. */
  resizeFocus?: Maybe<ImageResizeFocus>;
  /**
   * Desired background color, used with corner radius or `PAD` resize strategy.
   *         Defaults to transparent (for `PNG`, `PNG8` and `WEBP`) or white (for `JPG` and `JPG_PROGRESSIVE`).
   */
  backgroundColor?: Maybe<Scalars['HexColor']>;
  /** Desired image format. Defaults to the original image format. */
  format?: Maybe<ImageFormat>;
};



export enum ImageResizeStrategy {
  /** Resizes the image to fit into the specified dimensions. */
  Fit = 'FIT',
  /**
   * Resizes the image to the specified dimensions, padding the image if needed.
   *         Uses desired background color as padding color.
   */
  Pad = 'PAD',
  /** Resizes the image to the specified dimensions, cropping the image if needed. */
  Fill = 'FILL',
  /** Resizes the image to the specified dimensions, changing the original aspect ratio if needed. */
  Scale = 'SCALE',
  /** Crops a part of the original image to fit into the specified dimensions. */
  Crop = 'CROP',
  /** Creates a thumbnail from the image. */
  Thumb = 'THUMB'
}

export enum ImageResizeFocus {
  /** Focus the resizing on the center. */
  Center = 'CENTER',
  /** Focus the resizing on the top. */
  Top = 'TOP',
  /** Focus the resizing on the top right. */
  TopRight = 'TOP_RIGHT',
  /** Focus the resizing on the right. */
  Right = 'RIGHT',
  /** Focus the resizing on the bottom right. */
  BottomRight = 'BOTTOM_RIGHT',
  /** Focus the resizing on the bottom. */
  Bottom = 'BOTTOM',
  /** Focus the resizing on the bottom left. */
  BottomLeft = 'BOTTOM_LEFT',
  /** Focus the resizing on the left. */
  Left = 'LEFT',
  /** Focus the resizing on the top left. */
  TopLeft = 'TOP_LEFT',
  /** Focus the resizing on the largest face. */
  Face = 'FACE',
  /** Focus the resizing on the area containing all the faces. */
  Faces = 'FACES'
}


export enum ImageFormat {
  /** JPG image format. */
  Jpg = 'JPG',
  /**
   * Progressive JPG format stores multiple passes of an image in progressively higher detail.
   *         When a progressive image is loading, the viewer will first see a lower quality pixelated version which
   *         will gradually improve in detail, until the image is fully downloaded. This is to display an image as
   *         early as possible to make the layout look as designed.
   */
  JpgProgressive = 'JPG_PROGRESSIVE',
  /** PNG image format */
  Png = 'PNG',
  /**
   * 8-bit PNG images support up to 256 colors and weigh less than the standard 24-bit PNG equivalent.
   *         The 8-bit PNG format is mostly used for simple images, such as icons or logos.
   */
  Png8 = 'PNG8',
  /** WebP image format. */
  Webp = 'WEBP',
  Avif = 'AVIF'
}

export type AssetLinkingCollections = {
  __typename?: 'AssetLinkingCollections';
  entryCollection?: Maybe<EntryCollection>;
  heroImageCollection?: Maybe<HeroImageCollection>;
  blockRibbonCollection?: Maybe<BlockRibbonCollection>;
  blockSliderEntryCollection?: Maybe<BlockSliderEntryCollection>;
  blockFullsizeImageCollection?: Maybe<BlockFullsizeImageCollection>;
  blockOneColumnCollection?: Maybe<BlockOneColumnCollection>;
  blockAnalystRatingCollection?: Maybe<BlockAnalystRatingCollection>;
  blockImageGalleryCollection?: Maybe<BlockImageGalleryCollection>;
  newsArticleCollection?: Maybe<NewsArticleCollection>;
  highlightedRealEstateCollection?: Maybe<HighlightedRealEstateCollection>;
  partnerCollection?: Maybe<PartnerCollection>;
  projectLinkCollection?: Maybe<ProjectLinkCollection>;
  projectImageMapCollection?: Maybe<ProjectImageMapCollection>;
  downloadableFileCollection?: Maybe<DownloadableFileCollection>;
  personAccordionEntryCollection?: Maybe<PersonAccordionEntryCollection>;
  navigationEntryCollection?: Maybe<NavigationEntryCollection>;
};


export type AssetLinkingCollectionsEntryCollectionArgs = {
  skip?: Maybe<Scalars['Int']>;
  limit?: Maybe<Scalars['Int']>;
  preview?: Maybe<Scalars['Boolean']>;
  locale?: Maybe<Scalars['String']>;
};


export type AssetLinkingCollectionsHeroImageCollectionArgs = {
  skip?: Maybe<Scalars['Int']>;
  limit?: Maybe<Scalars['Int']>;
  preview?: Maybe<Scalars['Boolean']>;
  locale?: Maybe<Scalars['String']>;
};


export type AssetLinkingCollectionsBlockRibbonCollectionArgs = {
  skip?: Maybe<Scalars['Int']>;
  limit?: Maybe<Scalars['Int']>;
  preview?: Maybe<Scalars['Boolean']>;
  locale?: Maybe<Scalars['String']>;
};


export type AssetLinkingCollectionsBlockSliderEntryCollectionArgs = {
  skip?: Maybe<Scalars['Int']>;
  limit?: Maybe<Scalars['Int']>;
  preview?: Maybe<Scalars['Boolean']>;
  locale?: Maybe<Scalars['String']>;
};


export type AssetLinkingCollectionsBlockFullsizeImageCollectionArgs = {
  skip?: Maybe<Scalars['Int']>;
  limit?: Maybe<Scalars['Int']>;
  preview?: Maybe<Scalars['Boolean']>;
  locale?: Maybe<Scalars['String']>;
};


export type AssetLinkingCollectionsBlockOneColumnCollectionArgs = {
  skip?: Maybe<Scalars['Int']>;
  limit?: Maybe<Scalars['Int']>;
  preview?: Maybe<Scalars['Boolean']>;
  locale?: Maybe<Scalars['String']>;
};


export type AssetLinkingCollectionsBlockAnalystRatingCollectionArgs = {
  skip?: Maybe<Scalars['Int']>;
  limit?: Maybe<Scalars['Int']>;
  preview?: Maybe<Scalars['Boolean']>;
  locale?: Maybe<Scalars['String']>;
};


export type AssetLinkingCollectionsBlockImageGalleryCollectionArgs = {
  skip?: Maybe<Scalars['Int']>;
  limit?: Maybe<Scalars['Int']>;
  preview?: Maybe<Scalars['Boolean']>;
  locale?: Maybe<Scalars['String']>;
};


export type AssetLinkingCollectionsNewsArticleCollectionArgs = {
  skip?: Maybe<Scalars['Int']>;
  limit?: Maybe<Scalars['Int']>;
  preview?: Maybe<Scalars['Boolean']>;
  locale?: Maybe<Scalars['String']>;
};


export type AssetLinkingCollectionsHighlightedRealEstateCollectionArgs = {
  skip?: Maybe<Scalars['Int']>;
  limit?: Maybe<Scalars['Int']>;
  preview?: Maybe<Scalars['Boolean']>;
  locale?: Maybe<Scalars['String']>;
};


export type AssetLinkingCollectionsPartnerCollectionArgs = {
  skip?: Maybe<Scalars['Int']>;
  limit?: Maybe<Scalars['Int']>;
  preview?: Maybe<Scalars['Boolean']>;
  locale?: Maybe<Scalars['String']>;
};


export type AssetLinkingCollectionsProjectLinkCollectionArgs = {
  skip?: Maybe<Scalars['Int']>;
  limit?: Maybe<Scalars['Int']>;
  preview?: Maybe<Scalars['Boolean']>;
  locale?: Maybe<Scalars['String']>;
};


export type AssetLinkingCollectionsProjectImageMapCollectionArgs = {
  skip?: Maybe<Scalars['Int']>;
  limit?: Maybe<Scalars['Int']>;
  preview?: Maybe<Scalars['Boolean']>;
  locale?: Maybe<Scalars['String']>;
};


export type AssetLinkingCollectionsDownloadableFileCollectionArgs = {
  skip?: Maybe<Scalars['Int']>;
  limit?: Maybe<Scalars['Int']>;
  preview?: Maybe<Scalars['Boolean']>;
  locale?: Maybe<Scalars['String']>;
};


export type AssetLinkingCollectionsPersonAccordionEntryCollectionArgs = {
  skip?: Maybe<Scalars['Int']>;
  limit?: Maybe<Scalars['Int']>;
  preview?: Maybe<Scalars['Boolean']>;
  locale?: Maybe<Scalars['String']>;
};


export type AssetLinkingCollectionsNavigationEntryCollectionArgs = {
  skip?: Maybe<Scalars['Int']>;
  limit?: Maybe<Scalars['Int']>;
  preview?: Maybe<Scalars['Boolean']>;
  locale?: Maybe<Scalars['String']>;
};

export type EntryCollection = {
  __typename?: 'EntryCollection';
  total: Scalars['Int'];
  skip: Scalars['Int'];
  limit: Scalars['Int'];
  items: Array<Maybe<Entry>>;
};

export type Entry = {
  sys: Sys;
  contentfulMetadata: ContentfulMetadata;
};

export type HeroImageCollection = {
  __typename?: 'HeroImageCollection';
  total: Scalars['Int'];
  skip: Scalars['Int'];
  limit: Scalars['Int'];
  items: Array<Maybe<HeroImage>>;
};

/** This is the hero image component [See type definition](https://app.contentful.com/spaces/0j0b0fue4dp9/content_types/heroImage) */
export type HeroImage = Entry & _Node & {
  __typename?: 'HeroImage';
  sys: Sys;
  contentfulMetadata: ContentfulMetadata;
  linkedFrom?: Maybe<HeroImageLinkingCollections>;
  _id: Scalars['ID'];
  backgroundImage?: Maybe<Asset>;
  title?: Maybe<Scalars['String']>;
  subtitle?: Maybe<Scalars['String']>;
  size?: Maybe<Scalars['String']>;
};


/** This is the hero image component [See type definition](https://app.contentful.com/spaces/0j0b0fue4dp9/content_types/heroImage) */
export type HeroImageLinkedFromArgs = {
  allowedLocales?: Maybe<Array<Maybe<Scalars['String']>>>;
};


/** This is the hero image component [See type definition](https://app.contentful.com/spaces/0j0b0fue4dp9/content_types/heroImage) */
export type HeroImageBackgroundImageArgs = {
  preview?: Maybe<Scalars['Boolean']>;
  locale?: Maybe<Scalars['String']>;
};


/** This is the hero image component [See type definition](https://app.contentful.com/spaces/0j0b0fue4dp9/content_types/heroImage) */
export type HeroImageTitleArgs = {
  locale?: Maybe<Scalars['String']>;
};


/** This is the hero image component [See type definition](https://app.contentful.com/spaces/0j0b0fue4dp9/content_types/heroImage) */
export type HeroImageSubtitleArgs = {
  locale?: Maybe<Scalars['String']>;
};


/** This is the hero image component [See type definition](https://app.contentful.com/spaces/0j0b0fue4dp9/content_types/heroImage) */
export type HeroImageSizeArgs = {
  locale?: Maybe<Scalars['String']>;
};

export type _Node = {
  _id: Scalars['ID'];
};

export type HeroImageLinkingCollections = {
  __typename?: 'HeroImageLinkingCollections';
  entryCollection?: Maybe<EntryCollection>;
  staticPageCollection?: Maybe<StaticPageCollection>;
};


export type HeroImageLinkingCollectionsEntryCollectionArgs = {
  skip?: Maybe<Scalars['Int']>;
  limit?: Maybe<Scalars['Int']>;
  preview?: Maybe<Scalars['Boolean']>;
  locale?: Maybe<Scalars['String']>;
};


export type HeroImageLinkingCollectionsStaticPageCollectionArgs = {
  skip?: Maybe<Scalars['Int']>;
  limit?: Maybe<Scalars['Int']>;
  preview?: Maybe<Scalars['Boolean']>;
  locale?: Maybe<Scalars['String']>;
  order?: Maybe<Array<Maybe<HeroImageLinkingCollectionsStaticPageCollectionOrder>>>;
};

export type StaticPageCollection = {
  __typename?: 'StaticPageCollection';
  total: Scalars['Int'];
  skip: Scalars['Int'];
  limit: Scalars['Int'];
  items: Array<Maybe<StaticPage>>;
};

/** [See type definition](https://app.contentful.com/spaces/0j0b0fue4dp9/content_types/staticPage) */
export type StaticPage = Entry & _Node & {
  __typename?: 'StaticPage';
  sys: Sys;
  contentfulMetadata: ContentfulMetadata;
  linkedFrom?: Maybe<StaticPageLinkingCollections>;
  _id: Scalars['ID'];
  pageTitle?: Maybe<Scalars['String']>;
  slug?: Maybe<Scalars['String']>;
  seo?: Maybe<Seo>;
  hero?: Maybe<HeroImage>;
  blocksCollection?: Maybe<StaticPageBlocksCollection>;
  standalone?: Maybe<Scalars['Boolean']>;
  showNewsletterFooter?: Maybe<Scalars['Boolean']>;
  showContactFooter?: Maybe<Scalars['Boolean']>;
  pageTag?: Maybe<Scalars['String']>;
  newsType?: Maybe<Scalars['String']>;
  removePaddingBottom?: Maybe<Scalars['Boolean']>;
  region?: Maybe<Scalars['String']>;
};


/** [See type definition](https://app.contentful.com/spaces/0j0b0fue4dp9/content_types/staticPage) */
export type StaticPageLinkedFromArgs = {
  allowedLocales?: Maybe<Array<Maybe<Scalars['String']>>>;
};


/** [See type definition](https://app.contentful.com/spaces/0j0b0fue4dp9/content_types/staticPage) */
export type StaticPagePageTitleArgs = {
  locale?: Maybe<Scalars['String']>;
};


/** [See type definition](https://app.contentful.com/spaces/0j0b0fue4dp9/content_types/staticPage) */
export type StaticPageSlugArgs = {
  locale?: Maybe<Scalars['String']>;
};


/** [See type definition](https://app.contentful.com/spaces/0j0b0fue4dp9/content_types/staticPage) */
export type StaticPageSeoArgs = {
  preview?: Maybe<Scalars['Boolean']>;
  locale?: Maybe<Scalars['String']>;
  where?: Maybe<SeoFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/0j0b0fue4dp9/content_types/staticPage) */
export type StaticPageHeroArgs = {
  preview?: Maybe<Scalars['Boolean']>;
  locale?: Maybe<Scalars['String']>;
  where?: Maybe<HeroImageFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/0j0b0fue4dp9/content_types/staticPage) */
export type StaticPageBlocksCollectionArgs = {
  skip?: Maybe<Scalars['Int']>;
  limit?: Maybe<Scalars['Int']>;
  preview?: Maybe<Scalars['Boolean']>;
  locale?: Maybe<Scalars['String']>;
  where?: Maybe<StaticPageBlocksFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/0j0b0fue4dp9/content_types/staticPage) */
export type StaticPageStandaloneArgs = {
  locale?: Maybe<Scalars['String']>;
};


/** [See type definition](https://app.contentful.com/spaces/0j0b0fue4dp9/content_types/staticPage) */
export type StaticPageShowNewsletterFooterArgs = {
  locale?: Maybe<Scalars['String']>;
};


/** [See type definition](https://app.contentful.com/spaces/0j0b0fue4dp9/content_types/staticPage) */
export type StaticPageShowContactFooterArgs = {
  locale?: Maybe<Scalars['String']>;
};


/** [See type definition](https://app.contentful.com/spaces/0j0b0fue4dp9/content_types/staticPage) */
export type StaticPagePageTagArgs = {
  locale?: Maybe<Scalars['String']>;
};


/** [See type definition](https://app.contentful.com/spaces/0j0b0fue4dp9/content_types/staticPage) */
export type StaticPageNewsTypeArgs = {
  locale?: Maybe<Scalars['String']>;
};


/** [See type definition](https://app.contentful.com/spaces/0j0b0fue4dp9/content_types/staticPage) */
export type StaticPageRemovePaddingBottomArgs = {
  locale?: Maybe<Scalars['String']>;
};


/** [See type definition](https://app.contentful.com/spaces/0j0b0fue4dp9/content_types/staticPage) */
export type StaticPageRegionArgs = {
  locale?: Maybe<Scalars['String']>;
};

export type StaticPageLinkingCollections = {
  __typename?: 'StaticPageLinkingCollections';
  entryCollection?: Maybe<EntryCollection>;
  navBarEntryCollection?: Maybe<NavBarEntryCollection>;
  blockBigTitleNavigationCollection?: Maybe<BlockBigTitleNavigationCollection>;
  navigationEntryCollection?: Maybe<NavigationEntryCollection>;
};


export type StaticPageLinkingCollectionsEntryCollectionArgs = {
  skip?: Maybe<Scalars['Int']>;
  limit?: Maybe<Scalars['Int']>;
  preview?: Maybe<Scalars['Boolean']>;
  locale?: Maybe<Scalars['String']>;
};


export type StaticPageLinkingCollectionsNavBarEntryCollectionArgs = {
  skip?: Maybe<Scalars['Int']>;
  limit?: Maybe<Scalars['Int']>;
  preview?: Maybe<Scalars['Boolean']>;
  locale?: Maybe<Scalars['String']>;
  order?: Maybe<Array<Maybe<StaticPageLinkingCollectionsNavBarEntryCollectionOrder>>>;
};


export type StaticPageLinkingCollectionsBlockBigTitleNavigationCollectionArgs = {
  skip?: Maybe<Scalars['Int']>;
  limit?: Maybe<Scalars['Int']>;
  preview?: Maybe<Scalars['Boolean']>;
  locale?: Maybe<Scalars['String']>;
  order?: Maybe<Array<Maybe<StaticPageLinkingCollectionsBlockBigTitleNavigationCollectionOrder>>>;
};


export type StaticPageLinkingCollectionsNavigationEntryCollectionArgs = {
  skip?: Maybe<Scalars['Int']>;
  limit?: Maybe<Scalars['Int']>;
  preview?: Maybe<Scalars['Boolean']>;
  locale?: Maybe<Scalars['String']>;
  order?: Maybe<Array<Maybe<StaticPageLinkingCollectionsNavigationEntryCollectionOrder>>>;
};

export type NavBarEntryCollection = {
  __typename?: 'NavBarEntryCollection';
  total: Scalars['Int'];
  skip: Scalars['Int'];
  limit: Scalars['Int'];
  items: Array<Maybe<NavBarEntry>>;
};

/** [See type definition](https://app.contentful.com/spaces/0j0b0fue4dp9/content_types/navBarEntry) */
export type NavBarEntry = Entry & _Node & {
  __typename?: 'NavBarEntry';
  sys: Sys;
  contentfulMetadata: ContentfulMetadata;
  linkedFrom?: Maybe<NavBarEntryLinkingCollections>;
  _id: Scalars['ID'];
  label?: Maybe<Scalars['String']>;
  staticPage?: Maybe<StaticPage>;
  subEntriesCollection?: Maybe<NavBarEntrySubEntriesCollection>;
  position?: Maybe<Scalars['Int']>;
  navType?: Maybe<Scalars['String']>;
  url?: Maybe<Scalars['String']>;
};


/** [See type definition](https://app.contentful.com/spaces/0j0b0fue4dp9/content_types/navBarEntry) */
export type NavBarEntryLinkedFromArgs = {
  allowedLocales?: Maybe<Array<Maybe<Scalars['String']>>>;
};


/** [See type definition](https://app.contentful.com/spaces/0j0b0fue4dp9/content_types/navBarEntry) */
export type NavBarEntryLabelArgs = {
  locale?: Maybe<Scalars['String']>;
};


/** [See type definition](https://app.contentful.com/spaces/0j0b0fue4dp9/content_types/navBarEntry) */
export type NavBarEntryStaticPageArgs = {
  preview?: Maybe<Scalars['Boolean']>;
  locale?: Maybe<Scalars['String']>;
  where?: Maybe<StaticPageFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/0j0b0fue4dp9/content_types/navBarEntry) */
export type NavBarEntrySubEntriesCollectionArgs = {
  skip?: Maybe<Scalars['Int']>;
  limit?: Maybe<Scalars['Int']>;
  preview?: Maybe<Scalars['Boolean']>;
  locale?: Maybe<Scalars['String']>;
  where?: Maybe<NavBarEntryFilter>;
  order?: Maybe<Array<Maybe<NavBarEntrySubEntriesCollectionOrder>>>;
};


/** [See type definition](https://app.contentful.com/spaces/0j0b0fue4dp9/content_types/navBarEntry) */
export type NavBarEntryPositionArgs = {
  locale?: Maybe<Scalars['String']>;
};


/** [See type definition](https://app.contentful.com/spaces/0j0b0fue4dp9/content_types/navBarEntry) */
export type NavBarEntryNavTypeArgs = {
  locale?: Maybe<Scalars['String']>;
};


/** [See type definition](https://app.contentful.com/spaces/0j0b0fue4dp9/content_types/navBarEntry) */
export type NavBarEntryUrlArgs = {
  locale?: Maybe<Scalars['String']>;
};

export type NavBarEntryLinkingCollections = {
  __typename?: 'NavBarEntryLinkingCollections';
  entryCollection?: Maybe<EntryCollection>;
  navBarEntryCollection?: Maybe<NavBarEntryCollection>;
  blockSubNavigationCollection?: Maybe<BlockSubNavigationCollection>;
};


export type NavBarEntryLinkingCollectionsEntryCollectionArgs = {
  skip?: Maybe<Scalars['Int']>;
  limit?: Maybe<Scalars['Int']>;
  preview?: Maybe<Scalars['Boolean']>;
  locale?: Maybe<Scalars['String']>;
};


export type NavBarEntryLinkingCollectionsNavBarEntryCollectionArgs = {
  skip?: Maybe<Scalars['Int']>;
  limit?: Maybe<Scalars['Int']>;
  preview?: Maybe<Scalars['Boolean']>;
  locale?: Maybe<Scalars['String']>;
  order?: Maybe<Array<Maybe<NavBarEntryLinkingCollectionsNavBarEntryCollectionOrder>>>;
};


export type NavBarEntryLinkingCollectionsBlockSubNavigationCollectionArgs = {
  skip?: Maybe<Scalars['Int']>;
  limit?: Maybe<Scalars['Int']>;
  preview?: Maybe<Scalars['Boolean']>;
  locale?: Maybe<Scalars['String']>;
  order?: Maybe<Array<Maybe<NavBarEntryLinkingCollectionsBlockSubNavigationCollectionOrder>>>;
};

export enum NavBarEntryLinkingCollectionsNavBarEntryCollectionOrder {
  LabelAsc = 'label_ASC',
  LabelDesc = 'label_DESC',
  PositionAsc = 'position_ASC',
  PositionDesc = 'position_DESC',
  NavTypeAsc = 'navType_ASC',
  NavTypeDesc = 'navType_DESC',
  UrlAsc = 'url_ASC',
  UrlDesc = 'url_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export type BlockSubNavigationCollection = {
  __typename?: 'BlockSubNavigationCollection';
  total: Scalars['Int'];
  skip: Scalars['Int'];
  limit: Scalars['Int'];
  items: Array<Maybe<BlockSubNavigation>>;
};

/** [See type definition](https://app.contentful.com/spaces/0j0b0fue4dp9/content_types/blockSubNavigation) */
export type BlockSubNavigation = Entry & _Node & {
  __typename?: 'BlockSubNavigation';
  sys: Sys;
  contentfulMetadata: ContentfulMetadata;
  linkedFrom?: Maybe<BlockSubNavigationLinkingCollections>;
  _id: Scalars['ID'];
  internalDescription?: Maybe<Scalars['String']>;
  navBarEntriesCollection?: Maybe<BlockSubNavigationNavBarEntriesCollection>;
};


/** [See type definition](https://app.contentful.com/spaces/0j0b0fue4dp9/content_types/blockSubNavigation) */
export type BlockSubNavigationLinkedFromArgs = {
  allowedLocales?: Maybe<Array<Maybe<Scalars['String']>>>;
};


/** [See type definition](https://app.contentful.com/spaces/0j0b0fue4dp9/content_types/blockSubNavigation) */
export type BlockSubNavigationInternalDescriptionArgs = {
  locale?: Maybe<Scalars['String']>;
};


/** [See type definition](https://app.contentful.com/spaces/0j0b0fue4dp9/content_types/blockSubNavigation) */
export type BlockSubNavigationNavBarEntriesCollectionArgs = {
  skip?: Maybe<Scalars['Int']>;
  limit?: Maybe<Scalars['Int']>;
  preview?: Maybe<Scalars['Boolean']>;
  locale?: Maybe<Scalars['String']>;
  where?: Maybe<NavBarEntryFilter>;
  order?: Maybe<Array<Maybe<BlockSubNavigationNavBarEntriesCollectionOrder>>>;
};

export type BlockSubNavigationLinkingCollections = {
  __typename?: 'BlockSubNavigationLinkingCollections';
  entryCollection?: Maybe<EntryCollection>;
  staticPageCollection?: Maybe<StaticPageCollection>;
};


export type BlockSubNavigationLinkingCollectionsEntryCollectionArgs = {
  skip?: Maybe<Scalars['Int']>;
  limit?: Maybe<Scalars['Int']>;
  preview?: Maybe<Scalars['Boolean']>;
  locale?: Maybe<Scalars['String']>;
};


export type BlockSubNavigationLinkingCollectionsStaticPageCollectionArgs = {
  skip?: Maybe<Scalars['Int']>;
  limit?: Maybe<Scalars['Int']>;
  preview?: Maybe<Scalars['Boolean']>;
  locale?: Maybe<Scalars['String']>;
  order?: Maybe<Array<Maybe<BlockSubNavigationLinkingCollectionsStaticPageCollectionOrder>>>;
};

export enum BlockSubNavigationLinkingCollectionsStaticPageCollectionOrder {
  PageTitleAsc = 'pageTitle_ASC',
  PageTitleDesc = 'pageTitle_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  StandaloneAsc = 'standalone_ASC',
  StandaloneDesc = 'standalone_DESC',
  ShowNewsletterFooterAsc = 'showNewsletterFooter_ASC',
  ShowNewsletterFooterDesc = 'showNewsletterFooter_DESC',
  ShowContactFooterAsc = 'showContactFooter_ASC',
  ShowContactFooterDesc = 'showContactFooter_DESC',
  PageTagAsc = 'pageTag_ASC',
  PageTagDesc = 'pageTag_DESC',
  NewsTypeAsc = 'newsType_ASC',
  NewsTypeDesc = 'newsType_DESC',
  RemovePaddingBottomAsc = 'removePaddingBottom_ASC',
  RemovePaddingBottomDesc = 'removePaddingBottom_DESC',
  RegionAsc = 'region_ASC',
  RegionDesc = 'region_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export type BlockSubNavigationNavBarEntriesCollection = {
  __typename?: 'BlockSubNavigationNavBarEntriesCollection';
  total: Scalars['Int'];
  skip: Scalars['Int'];
  limit: Scalars['Int'];
  items: Array<Maybe<NavBarEntry>>;
};

export type NavBarEntryFilter = {
  staticPage?: Maybe<CfStaticPageNestedFilter>;
  subEntries?: Maybe<CfNavBarEntryNestedFilter>;
  sys?: Maybe<SysFilter>;
  contentfulMetadata?: Maybe<ContentfulMetadataFilter>;
  label_exists?: Maybe<Scalars['Boolean']>;
  label?: Maybe<Scalars['String']>;
  label_not?: Maybe<Scalars['String']>;
  label_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  label_not_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  label_contains?: Maybe<Scalars['String']>;
  label_not_contains?: Maybe<Scalars['String']>;
  staticPage_exists?: Maybe<Scalars['Boolean']>;
  subEntriesCollection_exists?: Maybe<Scalars['Boolean']>;
  position_exists?: Maybe<Scalars['Boolean']>;
  position?: Maybe<Scalars['Int']>;
  position_not?: Maybe<Scalars['Int']>;
  position_in?: Maybe<Array<Maybe<Scalars['Int']>>>;
  position_not_in?: Maybe<Array<Maybe<Scalars['Int']>>>;
  position_gt?: Maybe<Scalars['Int']>;
  position_gte?: Maybe<Scalars['Int']>;
  position_lt?: Maybe<Scalars['Int']>;
  position_lte?: Maybe<Scalars['Int']>;
  navType_exists?: Maybe<Scalars['Boolean']>;
  navType?: Maybe<Scalars['String']>;
  navType_not?: Maybe<Scalars['String']>;
  navType_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  navType_not_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  navType_contains?: Maybe<Scalars['String']>;
  navType_not_contains?: Maybe<Scalars['String']>;
  url_exists?: Maybe<Scalars['Boolean']>;
  url?: Maybe<Scalars['String']>;
  url_not?: Maybe<Scalars['String']>;
  url_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  url_not_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  url_contains?: Maybe<Scalars['String']>;
  url_not_contains?: Maybe<Scalars['String']>;
  OR?: Maybe<Array<Maybe<NavBarEntryFilter>>>;
  AND?: Maybe<Array<Maybe<NavBarEntryFilter>>>;
};

export type CfStaticPageNestedFilter = {
  sys?: Maybe<SysFilter>;
  contentfulMetadata?: Maybe<ContentfulMetadataFilter>;
  pageTitle_exists?: Maybe<Scalars['Boolean']>;
  pageTitle?: Maybe<Scalars['String']>;
  pageTitle_not?: Maybe<Scalars['String']>;
  pageTitle_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  pageTitle_not_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  pageTitle_contains?: Maybe<Scalars['String']>;
  pageTitle_not_contains?: Maybe<Scalars['String']>;
  slug_exists?: Maybe<Scalars['Boolean']>;
  slug?: Maybe<Scalars['String']>;
  slug_not?: Maybe<Scalars['String']>;
  slug_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  slug_not_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  slug_contains?: Maybe<Scalars['String']>;
  slug_not_contains?: Maybe<Scalars['String']>;
  seo_exists?: Maybe<Scalars['Boolean']>;
  hero_exists?: Maybe<Scalars['Boolean']>;
  blocksCollection_exists?: Maybe<Scalars['Boolean']>;
  standalone_exists?: Maybe<Scalars['Boolean']>;
  standalone?: Maybe<Scalars['Boolean']>;
  standalone_not?: Maybe<Scalars['Boolean']>;
  showNewsletterFooter_exists?: Maybe<Scalars['Boolean']>;
  showNewsletterFooter?: Maybe<Scalars['Boolean']>;
  showNewsletterFooter_not?: Maybe<Scalars['Boolean']>;
  showContactFooter_exists?: Maybe<Scalars['Boolean']>;
  showContactFooter?: Maybe<Scalars['Boolean']>;
  showContactFooter_not?: Maybe<Scalars['Boolean']>;
  pageTag_exists?: Maybe<Scalars['Boolean']>;
  pageTag?: Maybe<Scalars['String']>;
  pageTag_not?: Maybe<Scalars['String']>;
  pageTag_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  pageTag_not_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  pageTag_contains?: Maybe<Scalars['String']>;
  pageTag_not_contains?: Maybe<Scalars['String']>;
  newsType_exists?: Maybe<Scalars['Boolean']>;
  newsType?: Maybe<Scalars['String']>;
  newsType_not?: Maybe<Scalars['String']>;
  newsType_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  newsType_not_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  newsType_contains?: Maybe<Scalars['String']>;
  newsType_not_contains?: Maybe<Scalars['String']>;
  removePaddingBottom_exists?: Maybe<Scalars['Boolean']>;
  removePaddingBottom?: Maybe<Scalars['Boolean']>;
  removePaddingBottom_not?: Maybe<Scalars['Boolean']>;
  region_exists?: Maybe<Scalars['Boolean']>;
  region?: Maybe<Scalars['String']>;
  region_not?: Maybe<Scalars['String']>;
  region_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  region_not_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  region_contains?: Maybe<Scalars['String']>;
  region_not_contains?: Maybe<Scalars['String']>;
  OR?: Maybe<Array<Maybe<CfStaticPageNestedFilter>>>;
  AND?: Maybe<Array<Maybe<CfStaticPageNestedFilter>>>;
};

export type SysFilter = {
  id_exists?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['String']>;
  id_not?: Maybe<Scalars['String']>;
  id_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  id_not_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  id_contains?: Maybe<Scalars['String']>;
  id_not_contains?: Maybe<Scalars['String']>;
  publishedAt_exists?: Maybe<Scalars['Boolean']>;
  publishedAt?: Maybe<Scalars['DateTime']>;
  publishedAt_not?: Maybe<Scalars['DateTime']>;
  publishedAt_in?: Maybe<Array<Maybe<Scalars['DateTime']>>>;
  publishedAt_not_in?: Maybe<Array<Maybe<Scalars['DateTime']>>>;
  publishedAt_gt?: Maybe<Scalars['DateTime']>;
  publishedAt_gte?: Maybe<Scalars['DateTime']>;
  publishedAt_lt?: Maybe<Scalars['DateTime']>;
  publishedAt_lte?: Maybe<Scalars['DateTime']>;
  firstPublishedAt_exists?: Maybe<Scalars['Boolean']>;
  firstPublishedAt?: Maybe<Scalars['DateTime']>;
  firstPublishedAt_not?: Maybe<Scalars['DateTime']>;
  firstPublishedAt_in?: Maybe<Array<Maybe<Scalars['DateTime']>>>;
  firstPublishedAt_not_in?: Maybe<Array<Maybe<Scalars['DateTime']>>>;
  firstPublishedAt_gt?: Maybe<Scalars['DateTime']>;
  firstPublishedAt_gte?: Maybe<Scalars['DateTime']>;
  firstPublishedAt_lt?: Maybe<Scalars['DateTime']>;
  firstPublishedAt_lte?: Maybe<Scalars['DateTime']>;
  publishedVersion_exists?: Maybe<Scalars['Boolean']>;
  publishedVersion?: Maybe<Scalars['Float']>;
  publishedVersion_not?: Maybe<Scalars['Float']>;
  publishedVersion_in?: Maybe<Array<Maybe<Scalars['Float']>>>;
  publishedVersion_not_in?: Maybe<Array<Maybe<Scalars['Float']>>>;
  publishedVersion_gt?: Maybe<Scalars['Float']>;
  publishedVersion_gte?: Maybe<Scalars['Float']>;
  publishedVersion_lt?: Maybe<Scalars['Float']>;
  publishedVersion_lte?: Maybe<Scalars['Float']>;
};

export type ContentfulMetadataFilter = {
  tags_exists?: Maybe<Scalars['Boolean']>;
  tags?: Maybe<ContentfulMetadataTagsFilter>;
  concepts_exists?: Maybe<Scalars['Boolean']>;
  concepts?: Maybe<ContentfulMetadataConceptsFilter>;
};

export type ContentfulMetadataConceptsFilter = {
  id_contains_all?: Maybe<Array<Maybe<Scalars['String']>>>;
  id_contains_some?: Maybe<Array<Maybe<Scalars['String']>>>;
  id_contains_none?: Maybe<Array<Maybe<Scalars['String']>>>;
  descendants?: Maybe<ContentfulMetadataConceptsDescendantsFilter>;
};

export type ContentfulMetadataConceptsDescendantsFilter = {
  id_contains_all?: Maybe<Array<Maybe<Scalars['String']>>>;
  id_contains_some?: Maybe<Array<Maybe<Scalars['String']>>>;
  id_contains_none?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type ContentfulMetadataTagsFilter = {
  id_contains_all?: Maybe<Array<Maybe<Scalars['String']>>>;
  id_contains_some?: Maybe<Array<Maybe<Scalars['String']>>>;
  id_contains_none?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type CfNavBarEntryNestedFilter = {
  sys?: Maybe<SysFilter>;
  contentfulMetadata?: Maybe<ContentfulMetadataFilter>;
  label_exists?: Maybe<Scalars['Boolean']>;
  label?: Maybe<Scalars['String']>;
  label_not?: Maybe<Scalars['String']>;
  label_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  label_not_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  label_contains?: Maybe<Scalars['String']>;
  label_not_contains?: Maybe<Scalars['String']>;
  staticPage_exists?: Maybe<Scalars['Boolean']>;
  subEntriesCollection_exists?: Maybe<Scalars['Boolean']>;
  position_exists?: Maybe<Scalars['Boolean']>;
  position?: Maybe<Scalars['Int']>;
  position_not?: Maybe<Scalars['Int']>;
  position_in?: Maybe<Array<Maybe<Scalars['Int']>>>;
  position_not_in?: Maybe<Array<Maybe<Scalars['Int']>>>;
  position_gt?: Maybe<Scalars['Int']>;
  position_gte?: Maybe<Scalars['Int']>;
  position_lt?: Maybe<Scalars['Int']>;
  position_lte?: Maybe<Scalars['Int']>;
  navType_exists?: Maybe<Scalars['Boolean']>;
  navType?: Maybe<Scalars['String']>;
  navType_not?: Maybe<Scalars['String']>;
  navType_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  navType_not_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  navType_contains?: Maybe<Scalars['String']>;
  navType_not_contains?: Maybe<Scalars['String']>;
  url_exists?: Maybe<Scalars['Boolean']>;
  url?: Maybe<Scalars['String']>;
  url_not?: Maybe<Scalars['String']>;
  url_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  url_not_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  url_contains?: Maybe<Scalars['String']>;
  url_not_contains?: Maybe<Scalars['String']>;
  OR?: Maybe<Array<Maybe<CfNavBarEntryNestedFilter>>>;
  AND?: Maybe<Array<Maybe<CfNavBarEntryNestedFilter>>>;
};

export enum BlockSubNavigationNavBarEntriesCollectionOrder {
  LabelAsc = 'label_ASC',
  LabelDesc = 'label_DESC',
  PositionAsc = 'position_ASC',
  PositionDesc = 'position_DESC',
  NavTypeAsc = 'navType_ASC',
  NavTypeDesc = 'navType_DESC',
  UrlAsc = 'url_ASC',
  UrlDesc = 'url_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum NavBarEntryLinkingCollectionsBlockSubNavigationCollectionOrder {
  InternalDescriptionAsc = 'internalDescription_ASC',
  InternalDescriptionDesc = 'internalDescription_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export type StaticPageFilter = {
  seo?: Maybe<CfSeoNestedFilter>;
  hero?: Maybe<CfHeroImageNestedFilter>;
  blocks?: Maybe<CfblocksMultiTypeNestedFilter>;
  sys?: Maybe<SysFilter>;
  contentfulMetadata?: Maybe<ContentfulMetadataFilter>;
  pageTitle_exists?: Maybe<Scalars['Boolean']>;
  pageTitle?: Maybe<Scalars['String']>;
  pageTitle_not?: Maybe<Scalars['String']>;
  pageTitle_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  pageTitle_not_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  pageTitle_contains?: Maybe<Scalars['String']>;
  pageTitle_not_contains?: Maybe<Scalars['String']>;
  slug_exists?: Maybe<Scalars['Boolean']>;
  slug?: Maybe<Scalars['String']>;
  slug_not?: Maybe<Scalars['String']>;
  slug_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  slug_not_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  slug_contains?: Maybe<Scalars['String']>;
  slug_not_contains?: Maybe<Scalars['String']>;
  seo_exists?: Maybe<Scalars['Boolean']>;
  hero_exists?: Maybe<Scalars['Boolean']>;
  blocksCollection_exists?: Maybe<Scalars['Boolean']>;
  standalone_exists?: Maybe<Scalars['Boolean']>;
  standalone?: Maybe<Scalars['Boolean']>;
  standalone_not?: Maybe<Scalars['Boolean']>;
  showNewsletterFooter_exists?: Maybe<Scalars['Boolean']>;
  showNewsletterFooter?: Maybe<Scalars['Boolean']>;
  showNewsletterFooter_not?: Maybe<Scalars['Boolean']>;
  showContactFooter_exists?: Maybe<Scalars['Boolean']>;
  showContactFooter?: Maybe<Scalars['Boolean']>;
  showContactFooter_not?: Maybe<Scalars['Boolean']>;
  pageTag_exists?: Maybe<Scalars['Boolean']>;
  pageTag?: Maybe<Scalars['String']>;
  pageTag_not?: Maybe<Scalars['String']>;
  pageTag_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  pageTag_not_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  pageTag_contains?: Maybe<Scalars['String']>;
  pageTag_not_contains?: Maybe<Scalars['String']>;
  newsType_exists?: Maybe<Scalars['Boolean']>;
  newsType?: Maybe<Scalars['String']>;
  newsType_not?: Maybe<Scalars['String']>;
  newsType_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  newsType_not_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  newsType_contains?: Maybe<Scalars['String']>;
  newsType_not_contains?: Maybe<Scalars['String']>;
  removePaddingBottom_exists?: Maybe<Scalars['Boolean']>;
  removePaddingBottom?: Maybe<Scalars['Boolean']>;
  removePaddingBottom_not?: Maybe<Scalars['Boolean']>;
  region_exists?: Maybe<Scalars['Boolean']>;
  region?: Maybe<Scalars['String']>;
  region_not?: Maybe<Scalars['String']>;
  region_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  region_not_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  region_contains?: Maybe<Scalars['String']>;
  region_not_contains?: Maybe<Scalars['String']>;
  OR?: Maybe<Array<Maybe<StaticPageFilter>>>;
  AND?: Maybe<Array<Maybe<StaticPageFilter>>>;
};

export type CfSeoNestedFilter = {
  sys?: Maybe<SysFilter>;
  contentfulMetadata?: Maybe<ContentfulMetadataFilter>;
  title_exists?: Maybe<Scalars['Boolean']>;
  title?: Maybe<Scalars['String']>;
  title_not?: Maybe<Scalars['String']>;
  title_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  title_not_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  title_contains?: Maybe<Scalars['String']>;
  title_not_contains?: Maybe<Scalars['String']>;
  keywords_exists?: Maybe<Scalars['Boolean']>;
  keywords_contains_all?: Maybe<Array<Maybe<Scalars['String']>>>;
  keywords_contains_some?: Maybe<Array<Maybe<Scalars['String']>>>;
  keywords_contains_none?: Maybe<Array<Maybe<Scalars['String']>>>;
  description_exists?: Maybe<Scalars['Boolean']>;
  description?: Maybe<Scalars['String']>;
  description_not?: Maybe<Scalars['String']>;
  description_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  description_not_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  description_contains?: Maybe<Scalars['String']>;
  description_not_contains?: Maybe<Scalars['String']>;
  noFollowNoIndex_exists?: Maybe<Scalars['Boolean']>;
  noFollowNoIndex?: Maybe<Scalars['Boolean']>;
  noFollowNoIndex_not?: Maybe<Scalars['Boolean']>;
  OR?: Maybe<Array<Maybe<CfSeoNestedFilter>>>;
  AND?: Maybe<Array<Maybe<CfSeoNestedFilter>>>;
};

export type CfHeroImageNestedFilter = {
  sys?: Maybe<SysFilter>;
  contentfulMetadata?: Maybe<ContentfulMetadataFilter>;
  backgroundImage_exists?: Maybe<Scalars['Boolean']>;
  title_exists?: Maybe<Scalars['Boolean']>;
  title?: Maybe<Scalars['String']>;
  title_not?: Maybe<Scalars['String']>;
  title_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  title_not_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  title_contains?: Maybe<Scalars['String']>;
  title_not_contains?: Maybe<Scalars['String']>;
  subtitle_exists?: Maybe<Scalars['Boolean']>;
  subtitle?: Maybe<Scalars['String']>;
  subtitle_not?: Maybe<Scalars['String']>;
  subtitle_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  subtitle_not_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  subtitle_contains?: Maybe<Scalars['String']>;
  subtitle_not_contains?: Maybe<Scalars['String']>;
  size_exists?: Maybe<Scalars['Boolean']>;
  size?: Maybe<Scalars['String']>;
  size_not?: Maybe<Scalars['String']>;
  size_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  size_not_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  size_contains?: Maybe<Scalars['String']>;
  size_not_contains?: Maybe<Scalars['String']>;
  OR?: Maybe<Array<Maybe<CfHeroImageNestedFilter>>>;
  AND?: Maybe<Array<Maybe<CfHeroImageNestedFilter>>>;
};

export type CfblocksMultiTypeNestedFilter = {
  sys?: Maybe<SysFilter>;
  contentfulMetadata?: Maybe<ContentfulMetadataFilter>;
  OR?: Maybe<Array<Maybe<CfblocksMultiTypeNestedFilter>>>;
  AND?: Maybe<Array<Maybe<CfblocksMultiTypeNestedFilter>>>;
};

export type NavBarEntrySubEntriesCollection = {
  __typename?: 'NavBarEntrySubEntriesCollection';
  total: Scalars['Int'];
  skip: Scalars['Int'];
  limit: Scalars['Int'];
  items: Array<Maybe<NavBarEntry>>;
};

export enum NavBarEntrySubEntriesCollectionOrder {
  LabelAsc = 'label_ASC',
  LabelDesc = 'label_DESC',
  PositionAsc = 'position_ASC',
  PositionDesc = 'position_DESC',
  NavTypeAsc = 'navType_ASC',
  NavTypeDesc = 'navType_DESC',
  UrlAsc = 'url_ASC',
  UrlDesc = 'url_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum StaticPageLinkingCollectionsNavBarEntryCollectionOrder {
  LabelAsc = 'label_ASC',
  LabelDesc = 'label_DESC',
  PositionAsc = 'position_ASC',
  PositionDesc = 'position_DESC',
  NavTypeAsc = 'navType_ASC',
  NavTypeDesc = 'navType_DESC',
  UrlAsc = 'url_ASC',
  UrlDesc = 'url_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export type BlockBigTitleNavigationCollection = {
  __typename?: 'BlockBigTitleNavigationCollection';
  total: Scalars['Int'];
  skip: Scalars['Int'];
  limit: Scalars['Int'];
  items: Array<Maybe<BlockBigTitleNavigation>>;
};

/** Title, subtitle and navigation text element [See type definition](https://app.contentful.com/spaces/0j0b0fue4dp9/content_types/blockBigTitleNavigation) */
export type BlockBigTitleNavigation = Entry & _Node & {
  __typename?: 'BlockBigTitleNavigation';
  sys: Sys;
  contentfulMetadata: ContentfulMetadata;
  linkedFrom?: Maybe<BlockBigTitleNavigationLinkingCollections>;
  _id: Scalars['ID'];
  internalDescription?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  subTitle?: Maybe<Scalars['String']>;
  staticPageReference?: Maybe<StaticPage>;
  buttonText?: Maybe<Scalars['String']>;
  additionalInfoText?: Maybe<Scalars['String']>;
  url?: Maybe<Scalars['String']>;
};


/** Title, subtitle and navigation text element [See type definition](https://app.contentful.com/spaces/0j0b0fue4dp9/content_types/blockBigTitleNavigation) */
export type BlockBigTitleNavigationLinkedFromArgs = {
  allowedLocales?: Maybe<Array<Maybe<Scalars['String']>>>;
};


/** Title, subtitle and navigation text element [See type definition](https://app.contentful.com/spaces/0j0b0fue4dp9/content_types/blockBigTitleNavigation) */
export type BlockBigTitleNavigationInternalDescriptionArgs = {
  locale?: Maybe<Scalars['String']>;
};


/** Title, subtitle and navigation text element [See type definition](https://app.contentful.com/spaces/0j0b0fue4dp9/content_types/blockBigTitleNavigation) */
export type BlockBigTitleNavigationTitleArgs = {
  locale?: Maybe<Scalars['String']>;
};


/** Title, subtitle and navigation text element [See type definition](https://app.contentful.com/spaces/0j0b0fue4dp9/content_types/blockBigTitleNavigation) */
export type BlockBigTitleNavigationSubTitleArgs = {
  locale?: Maybe<Scalars['String']>;
};


/** Title, subtitle and navigation text element [See type definition](https://app.contentful.com/spaces/0j0b0fue4dp9/content_types/blockBigTitleNavigation) */
export type BlockBigTitleNavigationStaticPageReferenceArgs = {
  preview?: Maybe<Scalars['Boolean']>;
  locale?: Maybe<Scalars['String']>;
  where?: Maybe<StaticPageFilter>;
};


/** Title, subtitle and navigation text element [See type definition](https://app.contentful.com/spaces/0j0b0fue4dp9/content_types/blockBigTitleNavigation) */
export type BlockBigTitleNavigationButtonTextArgs = {
  locale?: Maybe<Scalars['String']>;
};


/** Title, subtitle and navigation text element [See type definition](https://app.contentful.com/spaces/0j0b0fue4dp9/content_types/blockBigTitleNavigation) */
export type BlockBigTitleNavigationAdditionalInfoTextArgs = {
  locale?: Maybe<Scalars['String']>;
};


/** Title, subtitle and navigation text element [See type definition](https://app.contentful.com/spaces/0j0b0fue4dp9/content_types/blockBigTitleNavigation) */
export type BlockBigTitleNavigationUrlArgs = {
  locale?: Maybe<Scalars['String']>;
};

export type BlockBigTitleNavigationLinkingCollections = {
  __typename?: 'BlockBigTitleNavigationLinkingCollections';
  entryCollection?: Maybe<EntryCollection>;
  staticPageCollection?: Maybe<StaticPageCollection>;
  blockHiddenWithConsentCollection?: Maybe<BlockHiddenWithConsentCollection>;
  blockOneColumnCollection?: Maybe<BlockOneColumnCollection>;
  blockTwoColumnCollection?: Maybe<BlockTwoColumnCollection>;
  blockHighlightRealEstateCollection?: Maybe<BlockHighlightRealEstateCollection>;
  projectPageCollection?: Maybe<ProjectPageCollection>;
};


export type BlockBigTitleNavigationLinkingCollectionsEntryCollectionArgs = {
  skip?: Maybe<Scalars['Int']>;
  limit?: Maybe<Scalars['Int']>;
  preview?: Maybe<Scalars['Boolean']>;
  locale?: Maybe<Scalars['String']>;
};


export type BlockBigTitleNavigationLinkingCollectionsStaticPageCollectionArgs = {
  skip?: Maybe<Scalars['Int']>;
  limit?: Maybe<Scalars['Int']>;
  preview?: Maybe<Scalars['Boolean']>;
  locale?: Maybe<Scalars['String']>;
  order?: Maybe<Array<Maybe<BlockBigTitleNavigationLinkingCollectionsStaticPageCollectionOrder>>>;
};


export type BlockBigTitleNavigationLinkingCollectionsBlockHiddenWithConsentCollectionArgs = {
  skip?: Maybe<Scalars['Int']>;
  limit?: Maybe<Scalars['Int']>;
  preview?: Maybe<Scalars['Boolean']>;
  locale?: Maybe<Scalars['String']>;
  order?: Maybe<Array<Maybe<BlockBigTitleNavigationLinkingCollectionsBlockHiddenWithConsentCollectionOrder>>>;
};


export type BlockBigTitleNavigationLinkingCollectionsBlockOneColumnCollectionArgs = {
  skip?: Maybe<Scalars['Int']>;
  limit?: Maybe<Scalars['Int']>;
  preview?: Maybe<Scalars['Boolean']>;
  locale?: Maybe<Scalars['String']>;
  order?: Maybe<Array<Maybe<BlockBigTitleNavigationLinkingCollectionsBlockOneColumnCollectionOrder>>>;
};


export type BlockBigTitleNavigationLinkingCollectionsBlockTwoColumnCollectionArgs = {
  skip?: Maybe<Scalars['Int']>;
  limit?: Maybe<Scalars['Int']>;
  preview?: Maybe<Scalars['Boolean']>;
  locale?: Maybe<Scalars['String']>;
  order?: Maybe<Array<Maybe<BlockBigTitleNavigationLinkingCollectionsBlockTwoColumnCollectionOrder>>>;
};


export type BlockBigTitleNavigationLinkingCollectionsBlockHighlightRealEstateCollectionArgs = {
  skip?: Maybe<Scalars['Int']>;
  limit?: Maybe<Scalars['Int']>;
  preview?: Maybe<Scalars['Boolean']>;
  locale?: Maybe<Scalars['String']>;
  order?: Maybe<Array<Maybe<BlockBigTitleNavigationLinkingCollectionsBlockHighlightRealEstateCollectionOrder>>>;
};


export type BlockBigTitleNavigationLinkingCollectionsProjectPageCollectionArgs = {
  skip?: Maybe<Scalars['Int']>;
  limit?: Maybe<Scalars['Int']>;
  preview?: Maybe<Scalars['Boolean']>;
  locale?: Maybe<Scalars['String']>;
  order?: Maybe<Array<Maybe<BlockBigTitleNavigationLinkingCollectionsProjectPageCollectionOrder>>>;
};

export enum BlockBigTitleNavigationLinkingCollectionsStaticPageCollectionOrder {
  PageTitleAsc = 'pageTitle_ASC',
  PageTitleDesc = 'pageTitle_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  StandaloneAsc = 'standalone_ASC',
  StandaloneDesc = 'standalone_DESC',
  ShowNewsletterFooterAsc = 'showNewsletterFooter_ASC',
  ShowNewsletterFooterDesc = 'showNewsletterFooter_DESC',
  ShowContactFooterAsc = 'showContactFooter_ASC',
  ShowContactFooterDesc = 'showContactFooter_DESC',
  PageTagAsc = 'pageTag_ASC',
  PageTagDesc = 'pageTag_DESC',
  NewsTypeAsc = 'newsType_ASC',
  NewsTypeDesc = 'newsType_DESC',
  RemovePaddingBottomAsc = 'removePaddingBottom_ASC',
  RemovePaddingBottomDesc = 'removePaddingBottom_DESC',
  RegionAsc = 'region_ASC',
  RegionDesc = 'region_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export type BlockHiddenWithConsentCollection = {
  __typename?: 'BlockHiddenWithConsentCollection';
  total: Scalars['Int'];
  skip: Scalars['Int'];
  limit: Scalars['Int'];
  items: Array<Maybe<BlockHiddenWithConsent>>;
};

/** Parent Block that can be used to hide children behind a specific Consent. [See type definition](https://app.contentful.com/spaces/0j0b0fue4dp9/content_types/blockHiddenWithConsent) */
export type BlockHiddenWithConsent = Entry & _Node & {
  __typename?: 'BlockHiddenWithConsent';
  sys: Sys;
  contentfulMetadata: ContentfulMetadata;
  linkedFrom?: Maybe<BlockHiddenWithConsentLinkingCollections>;
  _id: Scalars['ID'];
  consentType?: Maybe<Scalars['String']>;
  childBlocksCollection?: Maybe<BlockHiddenWithConsentChildBlocksCollection>;
};


/** Parent Block that can be used to hide children behind a specific Consent. [See type definition](https://app.contentful.com/spaces/0j0b0fue4dp9/content_types/blockHiddenWithConsent) */
export type BlockHiddenWithConsentLinkedFromArgs = {
  allowedLocales?: Maybe<Array<Maybe<Scalars['String']>>>;
};


/** Parent Block that can be used to hide children behind a specific Consent. [See type definition](https://app.contentful.com/spaces/0j0b0fue4dp9/content_types/blockHiddenWithConsent) */
export type BlockHiddenWithConsentConsentTypeArgs = {
  locale?: Maybe<Scalars['String']>;
};


/** Parent Block that can be used to hide children behind a specific Consent. [See type definition](https://app.contentful.com/spaces/0j0b0fue4dp9/content_types/blockHiddenWithConsent) */
export type BlockHiddenWithConsentChildBlocksCollectionArgs = {
  skip?: Maybe<Scalars['Int']>;
  limit?: Maybe<Scalars['Int']>;
  preview?: Maybe<Scalars['Boolean']>;
  locale?: Maybe<Scalars['String']>;
  where?: Maybe<BlockHiddenWithConsentChildBlocksFilter>;
};

export type BlockHiddenWithConsentLinkingCollections = {
  __typename?: 'BlockHiddenWithConsentLinkingCollections';
  entryCollection?: Maybe<EntryCollection>;
  staticPageCollection?: Maybe<StaticPageCollection>;
};


export type BlockHiddenWithConsentLinkingCollectionsEntryCollectionArgs = {
  skip?: Maybe<Scalars['Int']>;
  limit?: Maybe<Scalars['Int']>;
  preview?: Maybe<Scalars['Boolean']>;
  locale?: Maybe<Scalars['String']>;
};


export type BlockHiddenWithConsentLinkingCollectionsStaticPageCollectionArgs = {
  skip?: Maybe<Scalars['Int']>;
  limit?: Maybe<Scalars['Int']>;
  preview?: Maybe<Scalars['Boolean']>;
  locale?: Maybe<Scalars['String']>;
  order?: Maybe<Array<Maybe<BlockHiddenWithConsentLinkingCollectionsStaticPageCollectionOrder>>>;
};

export enum BlockHiddenWithConsentLinkingCollectionsStaticPageCollectionOrder {
  PageTitleAsc = 'pageTitle_ASC',
  PageTitleDesc = 'pageTitle_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  StandaloneAsc = 'standalone_ASC',
  StandaloneDesc = 'standalone_DESC',
  ShowNewsletterFooterAsc = 'showNewsletterFooter_ASC',
  ShowNewsletterFooterDesc = 'showNewsletterFooter_DESC',
  ShowContactFooterAsc = 'showContactFooter_ASC',
  ShowContactFooterDesc = 'showContactFooter_DESC',
  PageTagAsc = 'pageTag_ASC',
  PageTagDesc = 'pageTag_DESC',
  NewsTypeAsc = 'newsType_ASC',
  NewsTypeDesc = 'newsType_DESC',
  RemovePaddingBottomAsc = 'removePaddingBottom_ASC',
  RemovePaddingBottomDesc = 'removePaddingBottom_DESC',
  RegionAsc = 'region_ASC',
  RegionDesc = 'region_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export type BlockHiddenWithConsentChildBlocksCollection = {
  __typename?: 'BlockHiddenWithConsentChildBlocksCollection';
  total: Scalars['Int'];
  skip: Scalars['Int'];
  limit: Scalars['Int'];
  items: Array<Maybe<BlockHiddenWithConsentChildBlocksItem>>;
};

export type BlockHiddenWithConsentChildBlocksItem = BlockAccordion | BlockBigTitleNavigation | BlockCallToActionButton | BlockCustom | BlockFullsizeImage | BlockHighlightRealEstate | BlockImageGallery | BlockLinkSection | BlockOneColumn | BlockPersonAccordion | BlockRibbon | BlockRichText | BlockSlider | BlockSpeechBubble | BlockTable | BlockTextCloud | BlockThreeColumn | BlockTwoColumn | BlockVideo | HighlightedRealEstate | PersonAccordionEntry;

/** [See type definition](https://app.contentful.com/spaces/0j0b0fue4dp9/content_types/blockAccordion) */
export type BlockAccordion = Entry & _Node & {
  __typename?: 'BlockAccordion';
  sys: Sys;
  contentfulMetadata: ContentfulMetadata;
  linkedFrom?: Maybe<BlockAccordionLinkingCollections>;
  _id: Scalars['ID'];
  internalDescription?: Maybe<Scalars['String']>;
  accordionEntryCollection?: Maybe<BlockAccordionAccordionEntryCollection>;
  aquaColor?: Maybe<Scalars['Boolean']>;
  smallSize?: Maybe<Scalars['Boolean']>;
  widgetType?: Maybe<Scalars['String']>;
  isControlled?: Maybe<Scalars['Boolean']>;
};


/** [See type definition](https://app.contentful.com/spaces/0j0b0fue4dp9/content_types/blockAccordion) */
export type BlockAccordionLinkedFromArgs = {
  allowedLocales?: Maybe<Array<Maybe<Scalars['String']>>>;
};


/** [See type definition](https://app.contentful.com/spaces/0j0b0fue4dp9/content_types/blockAccordion) */
export type BlockAccordionInternalDescriptionArgs = {
  locale?: Maybe<Scalars['String']>;
};


/** [See type definition](https://app.contentful.com/spaces/0j0b0fue4dp9/content_types/blockAccordion) */
export type BlockAccordionAccordionEntryCollectionArgs = {
  skip?: Maybe<Scalars['Int']>;
  limit?: Maybe<Scalars['Int']>;
  preview?: Maybe<Scalars['Boolean']>;
  locale?: Maybe<Scalars['String']>;
  where?: Maybe<BlockAccordionEntryFilter>;
  order?: Maybe<Array<Maybe<BlockAccordionAccordionEntryCollectionOrder>>>;
};


/** [See type definition](https://app.contentful.com/spaces/0j0b0fue4dp9/content_types/blockAccordion) */
export type BlockAccordionAquaColorArgs = {
  locale?: Maybe<Scalars['String']>;
};


/** [See type definition](https://app.contentful.com/spaces/0j0b0fue4dp9/content_types/blockAccordion) */
export type BlockAccordionSmallSizeArgs = {
  locale?: Maybe<Scalars['String']>;
};


/** [See type definition](https://app.contentful.com/spaces/0j0b0fue4dp9/content_types/blockAccordion) */
export type BlockAccordionWidgetTypeArgs = {
  locale?: Maybe<Scalars['String']>;
};


/** [See type definition](https://app.contentful.com/spaces/0j0b0fue4dp9/content_types/blockAccordion) */
export type BlockAccordionIsControlledArgs = {
  locale?: Maybe<Scalars['String']>;
};

export type BlockAccordionLinkingCollections = {
  __typename?: 'BlockAccordionLinkingCollections';
  entryCollection?: Maybe<EntryCollection>;
  staticPageCollection?: Maybe<StaticPageCollection>;
  blockHiddenWithConsentCollection?: Maybe<BlockHiddenWithConsentCollection>;
  blockOneColumnCollection?: Maybe<BlockOneColumnCollection>;
  blockTwoColumnCollection?: Maybe<BlockTwoColumnCollection>;
  newsArticleCollection?: Maybe<NewsArticleCollection>;
  projectPageCollection?: Maybe<ProjectPageCollection>;
};


export type BlockAccordionLinkingCollectionsEntryCollectionArgs = {
  skip?: Maybe<Scalars['Int']>;
  limit?: Maybe<Scalars['Int']>;
  preview?: Maybe<Scalars['Boolean']>;
  locale?: Maybe<Scalars['String']>;
};


export type BlockAccordionLinkingCollectionsStaticPageCollectionArgs = {
  skip?: Maybe<Scalars['Int']>;
  limit?: Maybe<Scalars['Int']>;
  preview?: Maybe<Scalars['Boolean']>;
  locale?: Maybe<Scalars['String']>;
  order?: Maybe<Array<Maybe<BlockAccordionLinkingCollectionsStaticPageCollectionOrder>>>;
};


export type BlockAccordionLinkingCollectionsBlockHiddenWithConsentCollectionArgs = {
  skip?: Maybe<Scalars['Int']>;
  limit?: Maybe<Scalars['Int']>;
  preview?: Maybe<Scalars['Boolean']>;
  locale?: Maybe<Scalars['String']>;
  order?: Maybe<Array<Maybe<BlockAccordionLinkingCollectionsBlockHiddenWithConsentCollectionOrder>>>;
};


export type BlockAccordionLinkingCollectionsBlockOneColumnCollectionArgs = {
  skip?: Maybe<Scalars['Int']>;
  limit?: Maybe<Scalars['Int']>;
  preview?: Maybe<Scalars['Boolean']>;
  locale?: Maybe<Scalars['String']>;
  order?: Maybe<Array<Maybe<BlockAccordionLinkingCollectionsBlockOneColumnCollectionOrder>>>;
};


export type BlockAccordionLinkingCollectionsBlockTwoColumnCollectionArgs = {
  skip?: Maybe<Scalars['Int']>;
  limit?: Maybe<Scalars['Int']>;
  preview?: Maybe<Scalars['Boolean']>;
  locale?: Maybe<Scalars['String']>;
  order?: Maybe<Array<Maybe<BlockAccordionLinkingCollectionsBlockTwoColumnCollectionOrder>>>;
};


export type BlockAccordionLinkingCollectionsNewsArticleCollectionArgs = {
  skip?: Maybe<Scalars['Int']>;
  limit?: Maybe<Scalars['Int']>;
  preview?: Maybe<Scalars['Boolean']>;
  locale?: Maybe<Scalars['String']>;
  order?: Maybe<Array<Maybe<BlockAccordionLinkingCollectionsNewsArticleCollectionOrder>>>;
};


export type BlockAccordionLinkingCollectionsProjectPageCollectionArgs = {
  skip?: Maybe<Scalars['Int']>;
  limit?: Maybe<Scalars['Int']>;
  preview?: Maybe<Scalars['Boolean']>;
  locale?: Maybe<Scalars['String']>;
  order?: Maybe<Array<Maybe<BlockAccordionLinkingCollectionsProjectPageCollectionOrder>>>;
};

export enum BlockAccordionLinkingCollectionsStaticPageCollectionOrder {
  PageTitleAsc = 'pageTitle_ASC',
  PageTitleDesc = 'pageTitle_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  StandaloneAsc = 'standalone_ASC',
  StandaloneDesc = 'standalone_DESC',
  ShowNewsletterFooterAsc = 'showNewsletterFooter_ASC',
  ShowNewsletterFooterDesc = 'showNewsletterFooter_DESC',
  ShowContactFooterAsc = 'showContactFooter_ASC',
  ShowContactFooterDesc = 'showContactFooter_DESC',
  PageTagAsc = 'pageTag_ASC',
  PageTagDesc = 'pageTag_DESC',
  NewsTypeAsc = 'newsType_ASC',
  NewsTypeDesc = 'newsType_DESC',
  RemovePaddingBottomAsc = 'removePaddingBottom_ASC',
  RemovePaddingBottomDesc = 'removePaddingBottom_DESC',
  RegionAsc = 'region_ASC',
  RegionDesc = 'region_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum BlockAccordionLinkingCollectionsBlockHiddenWithConsentCollectionOrder {
  ConsentTypeAsc = 'consentType_ASC',
  ConsentTypeDesc = 'consentType_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export type BlockOneColumnCollection = {
  __typename?: 'BlockOneColumnCollection';
  total: Scalars['Int'];
  skip: Scalars['Int'];
  limit: Scalars['Int'];
  items: Array<Maybe<BlockOneColumn>>;
};

/** Layout only block [See type definition](https://app.contentful.com/spaces/0j0b0fue4dp9/content_types/blockOneColumn) */
export type BlockOneColumn = Entry & _Node & {
  __typename?: 'BlockOneColumn';
  sys: Sys;
  contentfulMetadata: ContentfulMetadata;
  linkedFrom?: Maybe<BlockOneColumnLinkingCollections>;
  _id: Scalars['ID'];
  internalDescription?: Maybe<Scalars['String']>;
  mainColumnCollection?: Maybe<BlockOneColumnMainColumnCollection>;
  enableBlackBackground?: Maybe<Scalars['Boolean']>;
  backgroundImage?: Maybe<Asset>;
  smallMainColumnOverImage?: Maybe<Scalars['Boolean']>;
  backgroundColor?: Maybe<Scalars['String']>;
  padding?: Maybe<Scalars['String']>;
  withExtraPadding?: Maybe<Scalars['Boolean']>;
};


/** Layout only block [See type definition](https://app.contentful.com/spaces/0j0b0fue4dp9/content_types/blockOneColumn) */
export type BlockOneColumnLinkedFromArgs = {
  allowedLocales?: Maybe<Array<Maybe<Scalars['String']>>>;
};


/** Layout only block [See type definition](https://app.contentful.com/spaces/0j0b0fue4dp9/content_types/blockOneColumn) */
export type BlockOneColumnInternalDescriptionArgs = {
  locale?: Maybe<Scalars['String']>;
};


/** Layout only block [See type definition](https://app.contentful.com/spaces/0j0b0fue4dp9/content_types/blockOneColumn) */
export type BlockOneColumnMainColumnCollectionArgs = {
  skip?: Maybe<Scalars['Int']>;
  limit?: Maybe<Scalars['Int']>;
  preview?: Maybe<Scalars['Boolean']>;
  locale?: Maybe<Scalars['String']>;
  where?: Maybe<BlockOneColumnMainColumnFilter>;
};


/** Layout only block [See type definition](https://app.contentful.com/spaces/0j0b0fue4dp9/content_types/blockOneColumn) */
export type BlockOneColumnEnableBlackBackgroundArgs = {
  locale?: Maybe<Scalars['String']>;
};


/** Layout only block [See type definition](https://app.contentful.com/spaces/0j0b0fue4dp9/content_types/blockOneColumn) */
export type BlockOneColumnBackgroundImageArgs = {
  preview?: Maybe<Scalars['Boolean']>;
  locale?: Maybe<Scalars['String']>;
};


/** Layout only block [See type definition](https://app.contentful.com/spaces/0j0b0fue4dp9/content_types/blockOneColumn) */
export type BlockOneColumnSmallMainColumnOverImageArgs = {
  locale?: Maybe<Scalars['String']>;
};


/** Layout only block [See type definition](https://app.contentful.com/spaces/0j0b0fue4dp9/content_types/blockOneColumn) */
export type BlockOneColumnBackgroundColorArgs = {
  locale?: Maybe<Scalars['String']>;
};


/** Layout only block [See type definition](https://app.contentful.com/spaces/0j0b0fue4dp9/content_types/blockOneColumn) */
export type BlockOneColumnPaddingArgs = {
  locale?: Maybe<Scalars['String']>;
};


/** Layout only block [See type definition](https://app.contentful.com/spaces/0j0b0fue4dp9/content_types/blockOneColumn) */
export type BlockOneColumnWithExtraPaddingArgs = {
  locale?: Maybe<Scalars['String']>;
};

export type BlockOneColumnLinkingCollections = {
  __typename?: 'BlockOneColumnLinkingCollections';
  entryCollection?: Maybe<EntryCollection>;
  staticPageCollection?: Maybe<StaticPageCollection>;
  blockHiddenWithConsentCollection?: Maybe<BlockHiddenWithConsentCollection>;
  blockOneColumnCollection?: Maybe<BlockOneColumnCollection>;
};


export type BlockOneColumnLinkingCollectionsEntryCollectionArgs = {
  skip?: Maybe<Scalars['Int']>;
  limit?: Maybe<Scalars['Int']>;
  preview?: Maybe<Scalars['Boolean']>;
  locale?: Maybe<Scalars['String']>;
};


export type BlockOneColumnLinkingCollectionsStaticPageCollectionArgs = {
  skip?: Maybe<Scalars['Int']>;
  limit?: Maybe<Scalars['Int']>;
  preview?: Maybe<Scalars['Boolean']>;
  locale?: Maybe<Scalars['String']>;
  order?: Maybe<Array<Maybe<BlockOneColumnLinkingCollectionsStaticPageCollectionOrder>>>;
};


export type BlockOneColumnLinkingCollectionsBlockHiddenWithConsentCollectionArgs = {
  skip?: Maybe<Scalars['Int']>;
  limit?: Maybe<Scalars['Int']>;
  preview?: Maybe<Scalars['Boolean']>;
  locale?: Maybe<Scalars['String']>;
  order?: Maybe<Array<Maybe<BlockOneColumnLinkingCollectionsBlockHiddenWithConsentCollectionOrder>>>;
};


export type BlockOneColumnLinkingCollectionsBlockOneColumnCollectionArgs = {
  skip?: Maybe<Scalars['Int']>;
  limit?: Maybe<Scalars['Int']>;
  preview?: Maybe<Scalars['Boolean']>;
  locale?: Maybe<Scalars['String']>;
  order?: Maybe<Array<Maybe<BlockOneColumnLinkingCollectionsBlockOneColumnCollectionOrder>>>;
};

export enum BlockOneColumnLinkingCollectionsStaticPageCollectionOrder {
  PageTitleAsc = 'pageTitle_ASC',
  PageTitleDesc = 'pageTitle_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  StandaloneAsc = 'standalone_ASC',
  StandaloneDesc = 'standalone_DESC',
  ShowNewsletterFooterAsc = 'showNewsletterFooter_ASC',
  ShowNewsletterFooterDesc = 'showNewsletterFooter_DESC',
  ShowContactFooterAsc = 'showContactFooter_ASC',
  ShowContactFooterDesc = 'showContactFooter_DESC',
  PageTagAsc = 'pageTag_ASC',
  PageTagDesc = 'pageTag_DESC',
  NewsTypeAsc = 'newsType_ASC',
  NewsTypeDesc = 'newsType_DESC',
  RemovePaddingBottomAsc = 'removePaddingBottom_ASC',
  RemovePaddingBottomDesc = 'removePaddingBottom_DESC',
  RegionAsc = 'region_ASC',
  RegionDesc = 'region_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum BlockOneColumnLinkingCollectionsBlockHiddenWithConsentCollectionOrder {
  ConsentTypeAsc = 'consentType_ASC',
  ConsentTypeDesc = 'consentType_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum BlockOneColumnLinkingCollectionsBlockOneColumnCollectionOrder {
  InternalDescriptionAsc = 'internalDescription_ASC',
  InternalDescriptionDesc = 'internalDescription_DESC',
  EnableBlackBackgroundAsc = 'enableBlackBackground_ASC',
  EnableBlackBackgroundDesc = 'enableBlackBackground_DESC',
  SmallMainColumnOverImageAsc = 'smallMainColumnOverImage_ASC',
  SmallMainColumnOverImageDesc = 'smallMainColumnOverImage_DESC',
  BackgroundColorAsc = 'backgroundColor_ASC',
  BackgroundColorDesc = 'backgroundColor_DESC',
  PaddingAsc = 'padding_ASC',
  PaddingDesc = 'padding_DESC',
  WithExtraPaddingAsc = 'withExtraPadding_ASC',
  WithExtraPaddingDesc = 'withExtraPadding_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export type BlockOneColumnMainColumnCollection = {
  __typename?: 'BlockOneColumnMainColumnCollection';
  total: Scalars['Int'];
  skip: Scalars['Int'];
  limit: Scalars['Int'];
  items: Array<Maybe<BlockOneColumnMainColumnItem>>;
};

export type BlockOneColumnMainColumnItem = BlockAccordion | BlockAnalystRating | BlockBigTitleNavigation | BlockCallToActionButton | BlockCustom | BlockFullsizeImage | BlockHighlightRealEstate | BlockLinkSection | BlockOneColumn | BlockPartnerGrid | BlockPersonAccordion | BlockRibbon | BlockRichText | BlockStockPrice | BlockTable | BlockThreeColumn | BlockTwoColumn | BlockVideo;

/** [See type definition](https://app.contentful.com/spaces/0j0b0fue4dp9/content_types/blockAnalystRating) */
export type BlockAnalystRating = Entry & _Node & {
  __typename?: 'BlockAnalystRating';
  sys: Sys;
  contentfulMetadata: ContentfulMetadata;
  linkedFrom?: Maybe<BlockAnalystRatingLinkingCollections>;
  _id: Scalars['ID'];
  name?: Maybe<Scalars['String']>;
  company?: Maybe<Scalars['String']>;
  targetPrice?: Maybe<Scalars['Float']>;
  date?: Maybe<Scalars['DateTime']>;
  recommendation?: Maybe<Scalars['String']>;
  download?: Maybe<Asset>;
  coverageCurrentlySuspended?: Maybe<Scalars['Boolean']>;
  noteText?: Maybe<Scalars['String']>;
};


/** [See type definition](https://app.contentful.com/spaces/0j0b0fue4dp9/content_types/blockAnalystRating) */
export type BlockAnalystRatingLinkedFromArgs = {
  allowedLocales?: Maybe<Array<Maybe<Scalars['String']>>>;
};


/** [See type definition](https://app.contentful.com/spaces/0j0b0fue4dp9/content_types/blockAnalystRating) */
export type BlockAnalystRatingNameArgs = {
  locale?: Maybe<Scalars['String']>;
};


/** [See type definition](https://app.contentful.com/spaces/0j0b0fue4dp9/content_types/blockAnalystRating) */
export type BlockAnalystRatingCompanyArgs = {
  locale?: Maybe<Scalars['String']>;
};


/** [See type definition](https://app.contentful.com/spaces/0j0b0fue4dp9/content_types/blockAnalystRating) */
export type BlockAnalystRatingTargetPriceArgs = {
  locale?: Maybe<Scalars['String']>;
};


/** [See type definition](https://app.contentful.com/spaces/0j0b0fue4dp9/content_types/blockAnalystRating) */
export type BlockAnalystRatingDateArgs = {
  locale?: Maybe<Scalars['String']>;
};


/** [See type definition](https://app.contentful.com/spaces/0j0b0fue4dp9/content_types/blockAnalystRating) */
export type BlockAnalystRatingRecommendationArgs = {
  locale?: Maybe<Scalars['String']>;
};


/** [See type definition](https://app.contentful.com/spaces/0j0b0fue4dp9/content_types/blockAnalystRating) */
export type BlockAnalystRatingDownloadArgs = {
  preview?: Maybe<Scalars['Boolean']>;
  locale?: Maybe<Scalars['String']>;
};


/** [See type definition](https://app.contentful.com/spaces/0j0b0fue4dp9/content_types/blockAnalystRating) */
export type BlockAnalystRatingCoverageCurrentlySuspendedArgs = {
  locale?: Maybe<Scalars['String']>;
};


/** [See type definition](https://app.contentful.com/spaces/0j0b0fue4dp9/content_types/blockAnalystRating) */
export type BlockAnalystRatingNoteTextArgs = {
  locale?: Maybe<Scalars['String']>;
};

export type BlockAnalystRatingLinkingCollections = {
  __typename?: 'BlockAnalystRatingLinkingCollections';
  entryCollection?: Maybe<EntryCollection>;
  staticPageCollection?: Maybe<StaticPageCollection>;
  blockOneColumnCollection?: Maybe<BlockOneColumnCollection>;
};


export type BlockAnalystRatingLinkingCollectionsEntryCollectionArgs = {
  skip?: Maybe<Scalars['Int']>;
  limit?: Maybe<Scalars['Int']>;
  preview?: Maybe<Scalars['Boolean']>;
  locale?: Maybe<Scalars['String']>;
};


export type BlockAnalystRatingLinkingCollectionsStaticPageCollectionArgs = {
  skip?: Maybe<Scalars['Int']>;
  limit?: Maybe<Scalars['Int']>;
  preview?: Maybe<Scalars['Boolean']>;
  locale?: Maybe<Scalars['String']>;
  order?: Maybe<Array<Maybe<BlockAnalystRatingLinkingCollectionsStaticPageCollectionOrder>>>;
};


export type BlockAnalystRatingLinkingCollectionsBlockOneColumnCollectionArgs = {
  skip?: Maybe<Scalars['Int']>;
  limit?: Maybe<Scalars['Int']>;
  preview?: Maybe<Scalars['Boolean']>;
  locale?: Maybe<Scalars['String']>;
  order?: Maybe<Array<Maybe<BlockAnalystRatingLinkingCollectionsBlockOneColumnCollectionOrder>>>;
};

export enum BlockAnalystRatingLinkingCollectionsStaticPageCollectionOrder {
  PageTitleAsc = 'pageTitle_ASC',
  PageTitleDesc = 'pageTitle_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  StandaloneAsc = 'standalone_ASC',
  StandaloneDesc = 'standalone_DESC',
  ShowNewsletterFooterAsc = 'showNewsletterFooter_ASC',
  ShowNewsletterFooterDesc = 'showNewsletterFooter_DESC',
  ShowContactFooterAsc = 'showContactFooter_ASC',
  ShowContactFooterDesc = 'showContactFooter_DESC',
  PageTagAsc = 'pageTag_ASC',
  PageTagDesc = 'pageTag_DESC',
  NewsTypeAsc = 'newsType_ASC',
  NewsTypeDesc = 'newsType_DESC',
  RemovePaddingBottomAsc = 'removePaddingBottom_ASC',
  RemovePaddingBottomDesc = 'removePaddingBottom_DESC',
  RegionAsc = 'region_ASC',
  RegionDesc = 'region_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum BlockAnalystRatingLinkingCollectionsBlockOneColumnCollectionOrder {
  InternalDescriptionAsc = 'internalDescription_ASC',
  InternalDescriptionDesc = 'internalDescription_DESC',
  EnableBlackBackgroundAsc = 'enableBlackBackground_ASC',
  EnableBlackBackgroundDesc = 'enableBlackBackground_DESC',
  SmallMainColumnOverImageAsc = 'smallMainColumnOverImage_ASC',
  SmallMainColumnOverImageDesc = 'smallMainColumnOverImage_DESC',
  BackgroundColorAsc = 'backgroundColor_ASC',
  BackgroundColorDesc = 'backgroundColor_DESC',
  PaddingAsc = 'padding_ASC',
  PaddingDesc = 'padding_DESC',
  WithExtraPaddingAsc = 'withExtraPadding_ASC',
  WithExtraPaddingDesc = 'withExtraPadding_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

/** [See type definition](https://app.contentful.com/spaces/0j0b0fue4dp9/content_types/blockCallToActionButton) */
export type BlockCallToActionButton = Entry & _Node & {
  __typename?: 'BlockCallToActionButton';
  sys: Sys;
  contentfulMetadata: ContentfulMetadata;
  linkedFrom?: Maybe<BlockCallToActionButtonLinkingCollections>;
  _id: Scalars['ID'];
  label?: Maybe<Scalars['String']>;
  url?: Maybe<Scalars['String']>;
  hideIcon?: Maybe<Scalars['Boolean']>;
  useNewWindow?: Maybe<Scalars['Boolean']>;
  color?: Maybe<Scalars['String']>;
  variant?: Maybe<Scalars['String']>;
};


/** [See type definition](https://app.contentful.com/spaces/0j0b0fue4dp9/content_types/blockCallToActionButton) */
export type BlockCallToActionButtonLinkedFromArgs = {
  allowedLocales?: Maybe<Array<Maybe<Scalars['String']>>>;
};


/** [See type definition](https://app.contentful.com/spaces/0j0b0fue4dp9/content_types/blockCallToActionButton) */
export type BlockCallToActionButtonLabelArgs = {
  locale?: Maybe<Scalars['String']>;
};


/** [See type definition](https://app.contentful.com/spaces/0j0b0fue4dp9/content_types/blockCallToActionButton) */
export type BlockCallToActionButtonUrlArgs = {
  locale?: Maybe<Scalars['String']>;
};


/** [See type definition](https://app.contentful.com/spaces/0j0b0fue4dp9/content_types/blockCallToActionButton) */
export type BlockCallToActionButtonHideIconArgs = {
  locale?: Maybe<Scalars['String']>;
};


/** [See type definition](https://app.contentful.com/spaces/0j0b0fue4dp9/content_types/blockCallToActionButton) */
export type BlockCallToActionButtonUseNewWindowArgs = {
  locale?: Maybe<Scalars['String']>;
};


/** [See type definition](https://app.contentful.com/spaces/0j0b0fue4dp9/content_types/blockCallToActionButton) */
export type BlockCallToActionButtonColorArgs = {
  locale?: Maybe<Scalars['String']>;
};


/** [See type definition](https://app.contentful.com/spaces/0j0b0fue4dp9/content_types/blockCallToActionButton) */
export type BlockCallToActionButtonVariantArgs = {
  locale?: Maybe<Scalars['String']>;
};

export type BlockCallToActionButtonLinkingCollections = {
  __typename?: 'BlockCallToActionButtonLinkingCollections';
  entryCollection?: Maybe<EntryCollection>;
  staticPageCollection?: Maybe<StaticPageCollection>;
  blockHiddenWithConsentCollection?: Maybe<BlockHiddenWithConsentCollection>;
  blockOneColumnCollection?: Maybe<BlockOneColumnCollection>;
  blockTwoColumnCollection?: Maybe<BlockTwoColumnCollection>;
  blockAccordionEntryCollection?: Maybe<BlockAccordionEntryCollection>;
  newsArticleCollection?: Maybe<NewsArticleCollection>;
  projectPageCollection?: Maybe<ProjectPageCollection>;
};


export type BlockCallToActionButtonLinkingCollectionsEntryCollectionArgs = {
  skip?: Maybe<Scalars['Int']>;
  limit?: Maybe<Scalars['Int']>;
  preview?: Maybe<Scalars['Boolean']>;
  locale?: Maybe<Scalars['String']>;
};


export type BlockCallToActionButtonLinkingCollectionsStaticPageCollectionArgs = {
  skip?: Maybe<Scalars['Int']>;
  limit?: Maybe<Scalars['Int']>;
  preview?: Maybe<Scalars['Boolean']>;
  locale?: Maybe<Scalars['String']>;
  order?: Maybe<Array<Maybe<BlockCallToActionButtonLinkingCollectionsStaticPageCollectionOrder>>>;
};


export type BlockCallToActionButtonLinkingCollectionsBlockHiddenWithConsentCollectionArgs = {
  skip?: Maybe<Scalars['Int']>;
  limit?: Maybe<Scalars['Int']>;
  preview?: Maybe<Scalars['Boolean']>;
  locale?: Maybe<Scalars['String']>;
  order?: Maybe<Array<Maybe<BlockCallToActionButtonLinkingCollectionsBlockHiddenWithConsentCollectionOrder>>>;
};


export type BlockCallToActionButtonLinkingCollectionsBlockOneColumnCollectionArgs = {
  skip?: Maybe<Scalars['Int']>;
  limit?: Maybe<Scalars['Int']>;
  preview?: Maybe<Scalars['Boolean']>;
  locale?: Maybe<Scalars['String']>;
  order?: Maybe<Array<Maybe<BlockCallToActionButtonLinkingCollectionsBlockOneColumnCollectionOrder>>>;
};


export type BlockCallToActionButtonLinkingCollectionsBlockTwoColumnCollectionArgs = {
  skip?: Maybe<Scalars['Int']>;
  limit?: Maybe<Scalars['Int']>;
  preview?: Maybe<Scalars['Boolean']>;
  locale?: Maybe<Scalars['String']>;
  order?: Maybe<Array<Maybe<BlockCallToActionButtonLinkingCollectionsBlockTwoColumnCollectionOrder>>>;
};


export type BlockCallToActionButtonLinkingCollectionsBlockAccordionEntryCollectionArgs = {
  skip?: Maybe<Scalars['Int']>;
  limit?: Maybe<Scalars['Int']>;
  preview?: Maybe<Scalars['Boolean']>;
  locale?: Maybe<Scalars['String']>;
  order?: Maybe<Array<Maybe<BlockCallToActionButtonLinkingCollectionsBlockAccordionEntryCollectionOrder>>>;
};


export type BlockCallToActionButtonLinkingCollectionsNewsArticleCollectionArgs = {
  skip?: Maybe<Scalars['Int']>;
  limit?: Maybe<Scalars['Int']>;
  preview?: Maybe<Scalars['Boolean']>;
  locale?: Maybe<Scalars['String']>;
  order?: Maybe<Array<Maybe<BlockCallToActionButtonLinkingCollectionsNewsArticleCollectionOrder>>>;
};


export type BlockCallToActionButtonLinkingCollectionsProjectPageCollectionArgs = {
  skip?: Maybe<Scalars['Int']>;
  limit?: Maybe<Scalars['Int']>;
  preview?: Maybe<Scalars['Boolean']>;
  locale?: Maybe<Scalars['String']>;
  order?: Maybe<Array<Maybe<BlockCallToActionButtonLinkingCollectionsProjectPageCollectionOrder>>>;
};

export enum BlockCallToActionButtonLinkingCollectionsStaticPageCollectionOrder {
  PageTitleAsc = 'pageTitle_ASC',
  PageTitleDesc = 'pageTitle_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  StandaloneAsc = 'standalone_ASC',
  StandaloneDesc = 'standalone_DESC',
  ShowNewsletterFooterAsc = 'showNewsletterFooter_ASC',
  ShowNewsletterFooterDesc = 'showNewsletterFooter_DESC',
  ShowContactFooterAsc = 'showContactFooter_ASC',
  ShowContactFooterDesc = 'showContactFooter_DESC',
  PageTagAsc = 'pageTag_ASC',
  PageTagDesc = 'pageTag_DESC',
  NewsTypeAsc = 'newsType_ASC',
  NewsTypeDesc = 'newsType_DESC',
  RemovePaddingBottomAsc = 'removePaddingBottom_ASC',
  RemovePaddingBottomDesc = 'removePaddingBottom_DESC',
  RegionAsc = 'region_ASC',
  RegionDesc = 'region_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum BlockCallToActionButtonLinkingCollectionsBlockHiddenWithConsentCollectionOrder {
  ConsentTypeAsc = 'consentType_ASC',
  ConsentTypeDesc = 'consentType_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum BlockCallToActionButtonLinkingCollectionsBlockOneColumnCollectionOrder {
  InternalDescriptionAsc = 'internalDescription_ASC',
  InternalDescriptionDesc = 'internalDescription_DESC',
  EnableBlackBackgroundAsc = 'enableBlackBackground_ASC',
  EnableBlackBackgroundDesc = 'enableBlackBackground_DESC',
  SmallMainColumnOverImageAsc = 'smallMainColumnOverImage_ASC',
  SmallMainColumnOverImageDesc = 'smallMainColumnOverImage_DESC',
  BackgroundColorAsc = 'backgroundColor_ASC',
  BackgroundColorDesc = 'backgroundColor_DESC',
  PaddingAsc = 'padding_ASC',
  PaddingDesc = 'padding_DESC',
  WithExtraPaddingAsc = 'withExtraPadding_ASC',
  WithExtraPaddingDesc = 'withExtraPadding_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export type BlockTwoColumnCollection = {
  __typename?: 'BlockTwoColumnCollection';
  total: Scalars['Int'];
  skip: Scalars['Int'];
  limit: Scalars['Int'];
  items: Array<Maybe<BlockTwoColumn>>;
};

/** Layout only block [See type definition](https://app.contentful.com/spaces/0j0b0fue4dp9/content_types/blockTwoColumn) */
export type BlockTwoColumn = Entry & _Node & {
  __typename?: 'BlockTwoColumn';
  sys: Sys;
  contentfulMetadata: ContentfulMetadata;
  linkedFrom?: Maybe<BlockTwoColumnLinkingCollections>;
  _id: Scalars['ID'];
  internalDescription?: Maybe<Scalars['String']>;
  leftColumnCollection?: Maybe<BlockTwoColumnLeftColumnCollection>;
  rightColumnCollection?: Maybe<BlockTwoColumnRightColumnCollection>;
  rightColumnOffset?: Maybe<Scalars['Boolean']>;
  verticalCenterLeftColumn?: Maybe<Scalars['Boolean']>;
  verticalCenterRightColumn?: Maybe<Scalars['Boolean']>;
  leftColumnTextRight?: Maybe<Scalars['Boolean']>;
  variant?: Maybe<Scalars['String']>;
  mobileColumnOrder?: Maybe<Scalars['String']>;
  appendContactAndNewsletterCtAs?: Maybe<Scalars['Boolean']>;
};


/** Layout only block [See type definition](https://app.contentful.com/spaces/0j0b0fue4dp9/content_types/blockTwoColumn) */
export type BlockTwoColumnLinkedFromArgs = {
  allowedLocales?: Maybe<Array<Maybe<Scalars['String']>>>;
};


/** Layout only block [See type definition](https://app.contentful.com/spaces/0j0b0fue4dp9/content_types/blockTwoColumn) */
export type BlockTwoColumnInternalDescriptionArgs = {
  locale?: Maybe<Scalars['String']>;
};


/** Layout only block [See type definition](https://app.contentful.com/spaces/0j0b0fue4dp9/content_types/blockTwoColumn) */
export type BlockTwoColumnLeftColumnCollectionArgs = {
  skip?: Maybe<Scalars['Int']>;
  limit?: Maybe<Scalars['Int']>;
  preview?: Maybe<Scalars['Boolean']>;
  locale?: Maybe<Scalars['String']>;
  where?: Maybe<BlockTwoColumnLeftColumnFilter>;
};


/** Layout only block [See type definition](https://app.contentful.com/spaces/0j0b0fue4dp9/content_types/blockTwoColumn) */
export type BlockTwoColumnRightColumnCollectionArgs = {
  skip?: Maybe<Scalars['Int']>;
  limit?: Maybe<Scalars['Int']>;
  preview?: Maybe<Scalars['Boolean']>;
  locale?: Maybe<Scalars['String']>;
  where?: Maybe<BlockTwoColumnRightColumnFilter>;
};


/** Layout only block [See type definition](https://app.contentful.com/spaces/0j0b0fue4dp9/content_types/blockTwoColumn) */
export type BlockTwoColumnRightColumnOffsetArgs = {
  locale?: Maybe<Scalars['String']>;
};


/** Layout only block [See type definition](https://app.contentful.com/spaces/0j0b0fue4dp9/content_types/blockTwoColumn) */
export type BlockTwoColumnVerticalCenterLeftColumnArgs = {
  locale?: Maybe<Scalars['String']>;
};


/** Layout only block [See type definition](https://app.contentful.com/spaces/0j0b0fue4dp9/content_types/blockTwoColumn) */
export type BlockTwoColumnVerticalCenterRightColumnArgs = {
  locale?: Maybe<Scalars['String']>;
};


/** Layout only block [See type definition](https://app.contentful.com/spaces/0j0b0fue4dp9/content_types/blockTwoColumn) */
export type BlockTwoColumnLeftColumnTextRightArgs = {
  locale?: Maybe<Scalars['String']>;
};


/** Layout only block [See type definition](https://app.contentful.com/spaces/0j0b0fue4dp9/content_types/blockTwoColumn) */
export type BlockTwoColumnVariantArgs = {
  locale?: Maybe<Scalars['String']>;
};


/** Layout only block [See type definition](https://app.contentful.com/spaces/0j0b0fue4dp9/content_types/blockTwoColumn) */
export type BlockTwoColumnMobileColumnOrderArgs = {
  locale?: Maybe<Scalars['String']>;
};


/** Layout only block [See type definition](https://app.contentful.com/spaces/0j0b0fue4dp9/content_types/blockTwoColumn) */
export type BlockTwoColumnAppendContactAndNewsletterCtAsArgs = {
  locale?: Maybe<Scalars['String']>;
};

export type BlockTwoColumnLinkingCollections = {
  __typename?: 'BlockTwoColumnLinkingCollections';
  entryCollection?: Maybe<EntryCollection>;
  staticPageCollection?: Maybe<StaticPageCollection>;
  blockHiddenWithConsentCollection?: Maybe<BlockHiddenWithConsentCollection>;
  blockOneColumnCollection?: Maybe<BlockOneColumnCollection>;
  blockAccordionEntryCollection?: Maybe<BlockAccordionEntryCollection>;
  newsArticleCollection?: Maybe<NewsArticleCollection>;
  projectPageCollection?: Maybe<ProjectPageCollection>;
};


export type BlockTwoColumnLinkingCollectionsEntryCollectionArgs = {
  skip?: Maybe<Scalars['Int']>;
  limit?: Maybe<Scalars['Int']>;
  preview?: Maybe<Scalars['Boolean']>;
  locale?: Maybe<Scalars['String']>;
};


export type BlockTwoColumnLinkingCollectionsStaticPageCollectionArgs = {
  skip?: Maybe<Scalars['Int']>;
  limit?: Maybe<Scalars['Int']>;
  preview?: Maybe<Scalars['Boolean']>;
  locale?: Maybe<Scalars['String']>;
  order?: Maybe<Array<Maybe<BlockTwoColumnLinkingCollectionsStaticPageCollectionOrder>>>;
};


export type BlockTwoColumnLinkingCollectionsBlockHiddenWithConsentCollectionArgs = {
  skip?: Maybe<Scalars['Int']>;
  limit?: Maybe<Scalars['Int']>;
  preview?: Maybe<Scalars['Boolean']>;
  locale?: Maybe<Scalars['String']>;
  order?: Maybe<Array<Maybe<BlockTwoColumnLinkingCollectionsBlockHiddenWithConsentCollectionOrder>>>;
};


export type BlockTwoColumnLinkingCollectionsBlockOneColumnCollectionArgs = {
  skip?: Maybe<Scalars['Int']>;
  limit?: Maybe<Scalars['Int']>;
  preview?: Maybe<Scalars['Boolean']>;
  locale?: Maybe<Scalars['String']>;
  order?: Maybe<Array<Maybe<BlockTwoColumnLinkingCollectionsBlockOneColumnCollectionOrder>>>;
};


export type BlockTwoColumnLinkingCollectionsBlockAccordionEntryCollectionArgs = {
  skip?: Maybe<Scalars['Int']>;
  limit?: Maybe<Scalars['Int']>;
  preview?: Maybe<Scalars['Boolean']>;
  locale?: Maybe<Scalars['String']>;
  order?: Maybe<Array<Maybe<BlockTwoColumnLinkingCollectionsBlockAccordionEntryCollectionOrder>>>;
};


export type BlockTwoColumnLinkingCollectionsNewsArticleCollectionArgs = {
  skip?: Maybe<Scalars['Int']>;
  limit?: Maybe<Scalars['Int']>;
  preview?: Maybe<Scalars['Boolean']>;
  locale?: Maybe<Scalars['String']>;
  order?: Maybe<Array<Maybe<BlockTwoColumnLinkingCollectionsNewsArticleCollectionOrder>>>;
};


export type BlockTwoColumnLinkingCollectionsProjectPageCollectionArgs = {
  skip?: Maybe<Scalars['Int']>;
  limit?: Maybe<Scalars['Int']>;
  preview?: Maybe<Scalars['Boolean']>;
  locale?: Maybe<Scalars['String']>;
  order?: Maybe<Array<Maybe<BlockTwoColumnLinkingCollectionsProjectPageCollectionOrder>>>;
};

export enum BlockTwoColumnLinkingCollectionsStaticPageCollectionOrder {
  PageTitleAsc = 'pageTitle_ASC',
  PageTitleDesc = 'pageTitle_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  StandaloneAsc = 'standalone_ASC',
  StandaloneDesc = 'standalone_DESC',
  ShowNewsletterFooterAsc = 'showNewsletterFooter_ASC',
  ShowNewsletterFooterDesc = 'showNewsletterFooter_DESC',
  ShowContactFooterAsc = 'showContactFooter_ASC',
  ShowContactFooterDesc = 'showContactFooter_DESC',
  PageTagAsc = 'pageTag_ASC',
  PageTagDesc = 'pageTag_DESC',
  NewsTypeAsc = 'newsType_ASC',
  NewsTypeDesc = 'newsType_DESC',
  RemovePaddingBottomAsc = 'removePaddingBottom_ASC',
  RemovePaddingBottomDesc = 'removePaddingBottom_DESC',
  RegionAsc = 'region_ASC',
  RegionDesc = 'region_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum BlockTwoColumnLinkingCollectionsBlockHiddenWithConsentCollectionOrder {
  ConsentTypeAsc = 'consentType_ASC',
  ConsentTypeDesc = 'consentType_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum BlockTwoColumnLinkingCollectionsBlockOneColumnCollectionOrder {
  InternalDescriptionAsc = 'internalDescription_ASC',
  InternalDescriptionDesc = 'internalDescription_DESC',
  EnableBlackBackgroundAsc = 'enableBlackBackground_ASC',
  EnableBlackBackgroundDesc = 'enableBlackBackground_DESC',
  SmallMainColumnOverImageAsc = 'smallMainColumnOverImage_ASC',
  SmallMainColumnOverImageDesc = 'smallMainColumnOverImage_DESC',
  BackgroundColorAsc = 'backgroundColor_ASC',
  BackgroundColorDesc = 'backgroundColor_DESC',
  PaddingAsc = 'padding_ASC',
  PaddingDesc = 'padding_DESC',
  WithExtraPaddingAsc = 'withExtraPadding_ASC',
  WithExtraPaddingDesc = 'withExtraPadding_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export type BlockAccordionEntryCollection = {
  __typename?: 'BlockAccordionEntryCollection';
  total: Scalars['Int'];
  skip: Scalars['Int'];
  limit: Scalars['Int'];
  items: Array<Maybe<BlockAccordionEntry>>;
};

/** [See type definition](https://app.contentful.com/spaces/0j0b0fue4dp9/content_types/blockAccordionEntry) */
export type BlockAccordionEntry = Entry & _Node & {
  __typename?: 'BlockAccordionEntry';
  sys: Sys;
  contentfulMetadata: ContentfulMetadata;
  linkedFrom?: Maybe<BlockAccordionEntryLinkingCollections>;
  _id: Scalars['ID'];
  title?: Maybe<Scalars['String']>;
  blocksCollection?: Maybe<BlockAccordionEntryBlocksCollection>;
  titleWhenExpanded?: Maybe<Scalars['String']>;
};


/** [See type definition](https://app.contentful.com/spaces/0j0b0fue4dp9/content_types/blockAccordionEntry) */
export type BlockAccordionEntryLinkedFromArgs = {
  allowedLocales?: Maybe<Array<Maybe<Scalars['String']>>>;
};


/** [See type definition](https://app.contentful.com/spaces/0j0b0fue4dp9/content_types/blockAccordionEntry) */
export type BlockAccordionEntryTitleArgs = {
  locale?: Maybe<Scalars['String']>;
};


/** [See type definition](https://app.contentful.com/spaces/0j0b0fue4dp9/content_types/blockAccordionEntry) */
export type BlockAccordionEntryBlocksCollectionArgs = {
  skip?: Maybe<Scalars['Int']>;
  limit?: Maybe<Scalars['Int']>;
  preview?: Maybe<Scalars['Boolean']>;
  locale?: Maybe<Scalars['String']>;
  where?: Maybe<BlockAccordionEntryBlocksFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/0j0b0fue4dp9/content_types/blockAccordionEntry) */
export type BlockAccordionEntryTitleWhenExpandedArgs = {
  locale?: Maybe<Scalars['String']>;
};

export type BlockAccordionEntryLinkingCollections = {
  __typename?: 'BlockAccordionEntryLinkingCollections';
  entryCollection?: Maybe<EntryCollection>;
  staticPageCollection?: Maybe<StaticPageCollection>;
  blockAccordionCollection?: Maybe<BlockAccordionCollection>;
  newsArticleCollection?: Maybe<NewsArticleCollection>;
  projectPageCollection?: Maybe<ProjectPageCollection>;
};


export type BlockAccordionEntryLinkingCollectionsEntryCollectionArgs = {
  skip?: Maybe<Scalars['Int']>;
  limit?: Maybe<Scalars['Int']>;
  preview?: Maybe<Scalars['Boolean']>;
  locale?: Maybe<Scalars['String']>;
};


export type BlockAccordionEntryLinkingCollectionsStaticPageCollectionArgs = {
  skip?: Maybe<Scalars['Int']>;
  limit?: Maybe<Scalars['Int']>;
  preview?: Maybe<Scalars['Boolean']>;
  locale?: Maybe<Scalars['String']>;
  order?: Maybe<Array<Maybe<BlockAccordionEntryLinkingCollectionsStaticPageCollectionOrder>>>;
};


export type BlockAccordionEntryLinkingCollectionsBlockAccordionCollectionArgs = {
  skip?: Maybe<Scalars['Int']>;
  limit?: Maybe<Scalars['Int']>;
  preview?: Maybe<Scalars['Boolean']>;
  locale?: Maybe<Scalars['String']>;
  order?: Maybe<Array<Maybe<BlockAccordionEntryLinkingCollectionsBlockAccordionCollectionOrder>>>;
};


export type BlockAccordionEntryLinkingCollectionsNewsArticleCollectionArgs = {
  skip?: Maybe<Scalars['Int']>;
  limit?: Maybe<Scalars['Int']>;
  preview?: Maybe<Scalars['Boolean']>;
  locale?: Maybe<Scalars['String']>;
  order?: Maybe<Array<Maybe<BlockAccordionEntryLinkingCollectionsNewsArticleCollectionOrder>>>;
};


export type BlockAccordionEntryLinkingCollectionsProjectPageCollectionArgs = {
  skip?: Maybe<Scalars['Int']>;
  limit?: Maybe<Scalars['Int']>;
  preview?: Maybe<Scalars['Boolean']>;
  locale?: Maybe<Scalars['String']>;
  order?: Maybe<Array<Maybe<BlockAccordionEntryLinkingCollectionsProjectPageCollectionOrder>>>;
};

export enum BlockAccordionEntryLinkingCollectionsStaticPageCollectionOrder {
  PageTitleAsc = 'pageTitle_ASC',
  PageTitleDesc = 'pageTitle_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  StandaloneAsc = 'standalone_ASC',
  StandaloneDesc = 'standalone_DESC',
  ShowNewsletterFooterAsc = 'showNewsletterFooter_ASC',
  ShowNewsletterFooterDesc = 'showNewsletterFooter_DESC',
  ShowContactFooterAsc = 'showContactFooter_ASC',
  ShowContactFooterDesc = 'showContactFooter_DESC',
  PageTagAsc = 'pageTag_ASC',
  PageTagDesc = 'pageTag_DESC',
  NewsTypeAsc = 'newsType_ASC',
  NewsTypeDesc = 'newsType_DESC',
  RemovePaddingBottomAsc = 'removePaddingBottom_ASC',
  RemovePaddingBottomDesc = 'removePaddingBottom_DESC',
  RegionAsc = 'region_ASC',
  RegionDesc = 'region_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export type BlockAccordionCollection = {
  __typename?: 'BlockAccordionCollection';
  total: Scalars['Int'];
  skip: Scalars['Int'];
  limit: Scalars['Int'];
  items: Array<Maybe<BlockAccordion>>;
};

export enum BlockAccordionEntryLinkingCollectionsBlockAccordionCollectionOrder {
  InternalDescriptionAsc = 'internalDescription_ASC',
  InternalDescriptionDesc = 'internalDescription_DESC',
  AquaColorAsc = 'aquaColor_ASC',
  AquaColorDesc = 'aquaColor_DESC',
  SmallSizeAsc = 'smallSize_ASC',
  SmallSizeDesc = 'smallSize_DESC',
  WidgetTypeAsc = 'widgetType_ASC',
  WidgetTypeDesc = 'widgetType_DESC',
  IsControlledAsc = 'isControlled_ASC',
  IsControlledDesc = 'isControlled_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export type NewsArticleCollection = {
  __typename?: 'NewsArticleCollection';
  total: Scalars['Int'];
  skip: Scalars['Int'];
  limit: Scalars['Int'];
  items: Array<Maybe<NewsArticle>>;
};

/** [See type definition](https://app.contentful.com/spaces/0j0b0fue4dp9/content_types/newsArticle) */
export type NewsArticle = Entry & _Node & {
  __typename?: 'NewsArticle';
  sys: Sys;
  contentfulMetadata: ContentfulMetadata;
  linkedFrom?: Maybe<NewsArticleLinkingCollections>;
  _id: Scalars['ID'];
  newsType?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  slug?: Maybe<Scalars['String']>;
  image?: Maybe<Asset>;
  date?: Maybe<Scalars['DateTime']>;
  hideDate?: Maybe<Scalars['Boolean']>;
  previewText?: Maybe<Scalars['String']>;
  blocksCollection?: Maybe<NewsArticleBlocksCollection>;
  contactsCollection?: Maybe<NewsArticleContactsCollection>;
  file?: Maybe<Asset>;
};


/** [See type definition](https://app.contentful.com/spaces/0j0b0fue4dp9/content_types/newsArticle) */
export type NewsArticleLinkedFromArgs = {
  allowedLocales?: Maybe<Array<Maybe<Scalars['String']>>>;
};


/** [See type definition](https://app.contentful.com/spaces/0j0b0fue4dp9/content_types/newsArticle) */
export type NewsArticleNewsTypeArgs = {
  locale?: Maybe<Scalars['String']>;
};


/** [See type definition](https://app.contentful.com/spaces/0j0b0fue4dp9/content_types/newsArticle) */
export type NewsArticleTitleArgs = {
  locale?: Maybe<Scalars['String']>;
};


/** [See type definition](https://app.contentful.com/spaces/0j0b0fue4dp9/content_types/newsArticle) */
export type NewsArticleSlugArgs = {
  locale?: Maybe<Scalars['String']>;
};


/** [See type definition](https://app.contentful.com/spaces/0j0b0fue4dp9/content_types/newsArticle) */
export type NewsArticleImageArgs = {
  preview?: Maybe<Scalars['Boolean']>;
  locale?: Maybe<Scalars['String']>;
};


/** [See type definition](https://app.contentful.com/spaces/0j0b0fue4dp9/content_types/newsArticle) */
export type NewsArticleDateArgs = {
  locale?: Maybe<Scalars['String']>;
};


/** [See type definition](https://app.contentful.com/spaces/0j0b0fue4dp9/content_types/newsArticle) */
export type NewsArticleHideDateArgs = {
  locale?: Maybe<Scalars['String']>;
};


/** [See type definition](https://app.contentful.com/spaces/0j0b0fue4dp9/content_types/newsArticle) */
export type NewsArticlePreviewTextArgs = {
  locale?: Maybe<Scalars['String']>;
};


/** [See type definition](https://app.contentful.com/spaces/0j0b0fue4dp9/content_types/newsArticle) */
export type NewsArticleBlocksCollectionArgs = {
  skip?: Maybe<Scalars['Int']>;
  limit?: Maybe<Scalars['Int']>;
  preview?: Maybe<Scalars['Boolean']>;
  locale?: Maybe<Scalars['String']>;
  where?: Maybe<NewsArticleBlocksFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/0j0b0fue4dp9/content_types/newsArticle) */
export type NewsArticleContactsCollectionArgs = {
  skip?: Maybe<Scalars['Int']>;
  limit?: Maybe<Scalars['Int']>;
  preview?: Maybe<Scalars['Boolean']>;
  locale?: Maybe<Scalars['String']>;
  where?: Maybe<NewsArticleContactFilter>;
  order?: Maybe<Array<Maybe<NewsArticleContactsCollectionOrder>>>;
};


/** [See type definition](https://app.contentful.com/spaces/0j0b0fue4dp9/content_types/newsArticle) */
export type NewsArticleFileArgs = {
  preview?: Maybe<Scalars['Boolean']>;
  locale?: Maybe<Scalars['String']>;
};

export type NewsArticleLinkingCollections = {
  __typename?: 'NewsArticleLinkingCollections';
  entryCollection?: Maybe<EntryCollection>;
};


export type NewsArticleLinkingCollectionsEntryCollectionArgs = {
  skip?: Maybe<Scalars['Int']>;
  limit?: Maybe<Scalars['Int']>;
  preview?: Maybe<Scalars['Boolean']>;
  locale?: Maybe<Scalars['String']>;
};

export type NewsArticleBlocksCollection = {
  __typename?: 'NewsArticleBlocksCollection';
  total: Scalars['Int'];
  skip: Scalars['Int'];
  limit: Scalars['Int'];
  items: Array<Maybe<NewsArticleBlocksItem>>;
};

export type NewsArticleBlocksItem = BlockAccordion | BlockAccordionEntry | BlockCallToActionButton | BlockRichText | BlockTable | BlockTwoColumn;

/** [See type definition](https://app.contentful.com/spaces/0j0b0fue4dp9/content_types/blockRichText) */
export type BlockRichText = Entry & _Node & {
  __typename?: 'BlockRichText';
  sys: Sys;
  contentfulMetadata: ContentfulMetadata;
  linkedFrom?: Maybe<BlockRichTextLinkingCollections>;
  _id: Scalars['ID'];
  internalDescription?: Maybe<Scalars['String']>;
  richText?: Maybe<BlockRichTextRichText>;
  textAlignCenter?: Maybe<Scalars['Boolean']>;
  superscript?: Maybe<Scalars['String']>;
  superscriptFontSize?: Maybe<Scalars['String']>;
};


/** [See type definition](https://app.contentful.com/spaces/0j0b0fue4dp9/content_types/blockRichText) */
export type BlockRichTextLinkedFromArgs = {
  allowedLocales?: Maybe<Array<Maybe<Scalars['String']>>>;
};


/** [See type definition](https://app.contentful.com/spaces/0j0b0fue4dp9/content_types/blockRichText) */
export type BlockRichTextInternalDescriptionArgs = {
  locale?: Maybe<Scalars['String']>;
};


/** [See type definition](https://app.contentful.com/spaces/0j0b0fue4dp9/content_types/blockRichText) */
export type BlockRichTextRichTextArgs = {
  locale?: Maybe<Scalars['String']>;
};


/** [See type definition](https://app.contentful.com/spaces/0j0b0fue4dp9/content_types/blockRichText) */
export type BlockRichTextTextAlignCenterArgs = {
  locale?: Maybe<Scalars['String']>;
};


/** [See type definition](https://app.contentful.com/spaces/0j0b0fue4dp9/content_types/blockRichText) */
export type BlockRichTextSuperscriptArgs = {
  locale?: Maybe<Scalars['String']>;
};


/** [See type definition](https://app.contentful.com/spaces/0j0b0fue4dp9/content_types/blockRichText) */
export type BlockRichTextSuperscriptFontSizeArgs = {
  locale?: Maybe<Scalars['String']>;
};

export type BlockRichTextLinkingCollections = {
  __typename?: 'BlockRichTextLinkingCollections';
  entryCollection?: Maybe<EntryCollection>;
  staticPageCollection?: Maybe<StaticPageCollection>;
  blockHiddenWithConsentCollection?: Maybe<BlockHiddenWithConsentCollection>;
  lexiconArticleCollection?: Maybe<LexiconArticleCollection>;
  blockOneColumnCollection?: Maybe<BlockOneColumnCollection>;
  blockTwoColumnCollection?: Maybe<BlockTwoColumnCollection>;
  blockAccordionEntryCollection?: Maybe<BlockAccordionEntryCollection>;
  newsArticleCollection?: Maybe<NewsArticleCollection>;
  projectPageCollection?: Maybe<ProjectPageCollection>;
};


export type BlockRichTextLinkingCollectionsEntryCollectionArgs = {
  skip?: Maybe<Scalars['Int']>;
  limit?: Maybe<Scalars['Int']>;
  preview?: Maybe<Scalars['Boolean']>;
  locale?: Maybe<Scalars['String']>;
};


export type BlockRichTextLinkingCollectionsStaticPageCollectionArgs = {
  skip?: Maybe<Scalars['Int']>;
  limit?: Maybe<Scalars['Int']>;
  preview?: Maybe<Scalars['Boolean']>;
  locale?: Maybe<Scalars['String']>;
  order?: Maybe<Array<Maybe<BlockRichTextLinkingCollectionsStaticPageCollectionOrder>>>;
};


export type BlockRichTextLinkingCollectionsBlockHiddenWithConsentCollectionArgs = {
  skip?: Maybe<Scalars['Int']>;
  limit?: Maybe<Scalars['Int']>;
  preview?: Maybe<Scalars['Boolean']>;
  locale?: Maybe<Scalars['String']>;
  order?: Maybe<Array<Maybe<BlockRichTextLinkingCollectionsBlockHiddenWithConsentCollectionOrder>>>;
};


export type BlockRichTextLinkingCollectionsLexiconArticleCollectionArgs = {
  skip?: Maybe<Scalars['Int']>;
  limit?: Maybe<Scalars['Int']>;
  preview?: Maybe<Scalars['Boolean']>;
  locale?: Maybe<Scalars['String']>;
  order?: Maybe<Array<Maybe<BlockRichTextLinkingCollectionsLexiconArticleCollectionOrder>>>;
};


export type BlockRichTextLinkingCollectionsBlockOneColumnCollectionArgs = {
  skip?: Maybe<Scalars['Int']>;
  limit?: Maybe<Scalars['Int']>;
  preview?: Maybe<Scalars['Boolean']>;
  locale?: Maybe<Scalars['String']>;
  order?: Maybe<Array<Maybe<BlockRichTextLinkingCollectionsBlockOneColumnCollectionOrder>>>;
};


export type BlockRichTextLinkingCollectionsBlockTwoColumnCollectionArgs = {
  skip?: Maybe<Scalars['Int']>;
  limit?: Maybe<Scalars['Int']>;
  preview?: Maybe<Scalars['Boolean']>;
  locale?: Maybe<Scalars['String']>;
  order?: Maybe<Array<Maybe<BlockRichTextLinkingCollectionsBlockTwoColumnCollectionOrder>>>;
};


export type BlockRichTextLinkingCollectionsBlockAccordionEntryCollectionArgs = {
  skip?: Maybe<Scalars['Int']>;
  limit?: Maybe<Scalars['Int']>;
  preview?: Maybe<Scalars['Boolean']>;
  locale?: Maybe<Scalars['String']>;
  order?: Maybe<Array<Maybe<BlockRichTextLinkingCollectionsBlockAccordionEntryCollectionOrder>>>;
};


export type BlockRichTextLinkingCollectionsNewsArticleCollectionArgs = {
  skip?: Maybe<Scalars['Int']>;
  limit?: Maybe<Scalars['Int']>;
  preview?: Maybe<Scalars['Boolean']>;
  locale?: Maybe<Scalars['String']>;
  order?: Maybe<Array<Maybe<BlockRichTextLinkingCollectionsNewsArticleCollectionOrder>>>;
};


export type BlockRichTextLinkingCollectionsProjectPageCollectionArgs = {
  skip?: Maybe<Scalars['Int']>;
  limit?: Maybe<Scalars['Int']>;
  preview?: Maybe<Scalars['Boolean']>;
  locale?: Maybe<Scalars['String']>;
  order?: Maybe<Array<Maybe<BlockRichTextLinkingCollectionsProjectPageCollectionOrder>>>;
};

export enum BlockRichTextLinkingCollectionsStaticPageCollectionOrder {
  PageTitleAsc = 'pageTitle_ASC',
  PageTitleDesc = 'pageTitle_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  StandaloneAsc = 'standalone_ASC',
  StandaloneDesc = 'standalone_DESC',
  ShowNewsletterFooterAsc = 'showNewsletterFooter_ASC',
  ShowNewsletterFooterDesc = 'showNewsletterFooter_DESC',
  ShowContactFooterAsc = 'showContactFooter_ASC',
  ShowContactFooterDesc = 'showContactFooter_DESC',
  PageTagAsc = 'pageTag_ASC',
  PageTagDesc = 'pageTag_DESC',
  NewsTypeAsc = 'newsType_ASC',
  NewsTypeDesc = 'newsType_DESC',
  RemovePaddingBottomAsc = 'removePaddingBottom_ASC',
  RemovePaddingBottomDesc = 'removePaddingBottom_DESC',
  RegionAsc = 'region_ASC',
  RegionDesc = 'region_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum BlockRichTextLinkingCollectionsBlockHiddenWithConsentCollectionOrder {
  ConsentTypeAsc = 'consentType_ASC',
  ConsentTypeDesc = 'consentType_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export type LexiconArticleCollection = {
  __typename?: 'LexiconArticleCollection';
  total: Scalars['Int'];
  skip: Scalars['Int'];
  limit: Scalars['Int'];
  items: Array<Maybe<LexiconArticle>>;
};

/** [See type definition](https://app.contentful.com/spaces/0j0b0fue4dp9/content_types/lexiconArticle) */
export type LexiconArticle = Entry & _Node & {
  __typename?: 'LexiconArticle';
  sys: Sys;
  contentfulMetadata: ContentfulMetadata;
  linkedFrom?: Maybe<LexiconArticleLinkingCollections>;
  _id: Scalars['ID'];
  title?: Maybe<Scalars['String']>;
  slug?: Maybe<Scalars['String']>;
  lexiconLetter?: Maybe<Scalars['String']>;
  previewText?: Maybe<Scalars['String']>;
  blocksCollection?: Maybe<LexiconArticleBlocksCollection>;
};


/** [See type definition](https://app.contentful.com/spaces/0j0b0fue4dp9/content_types/lexiconArticle) */
export type LexiconArticleLinkedFromArgs = {
  allowedLocales?: Maybe<Array<Maybe<Scalars['String']>>>;
};


/** [See type definition](https://app.contentful.com/spaces/0j0b0fue4dp9/content_types/lexiconArticle) */
export type LexiconArticleTitleArgs = {
  locale?: Maybe<Scalars['String']>;
};


/** [See type definition](https://app.contentful.com/spaces/0j0b0fue4dp9/content_types/lexiconArticle) */
export type LexiconArticleSlugArgs = {
  locale?: Maybe<Scalars['String']>;
};


/** [See type definition](https://app.contentful.com/spaces/0j0b0fue4dp9/content_types/lexiconArticle) */
export type LexiconArticleLexiconLetterArgs = {
  locale?: Maybe<Scalars['String']>;
};


/** [See type definition](https://app.contentful.com/spaces/0j0b0fue4dp9/content_types/lexiconArticle) */
export type LexiconArticlePreviewTextArgs = {
  locale?: Maybe<Scalars['String']>;
};


/** [See type definition](https://app.contentful.com/spaces/0j0b0fue4dp9/content_types/lexiconArticle) */
export type LexiconArticleBlocksCollectionArgs = {
  skip?: Maybe<Scalars['Int']>;
  limit?: Maybe<Scalars['Int']>;
  preview?: Maybe<Scalars['Boolean']>;
  locale?: Maybe<Scalars['String']>;
  where?: Maybe<BlockRichTextFilter>;
  order?: Maybe<Array<Maybe<LexiconArticleBlocksCollectionOrder>>>;
};

export type LexiconArticleLinkingCollections = {
  __typename?: 'LexiconArticleLinkingCollections';
  entryCollection?: Maybe<EntryCollection>;
};


export type LexiconArticleLinkingCollectionsEntryCollectionArgs = {
  skip?: Maybe<Scalars['Int']>;
  limit?: Maybe<Scalars['Int']>;
  preview?: Maybe<Scalars['Boolean']>;
  locale?: Maybe<Scalars['String']>;
};

export type LexiconArticleBlocksCollection = {
  __typename?: 'LexiconArticleBlocksCollection';
  total: Scalars['Int'];
  skip: Scalars['Int'];
  limit: Scalars['Int'];
  items: Array<Maybe<BlockRichText>>;
};

export type BlockRichTextFilter = {
  sys?: Maybe<SysFilter>;
  contentfulMetadata?: Maybe<ContentfulMetadataFilter>;
  internalDescription_exists?: Maybe<Scalars['Boolean']>;
  internalDescription?: Maybe<Scalars['String']>;
  internalDescription_not?: Maybe<Scalars['String']>;
  internalDescription_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  internalDescription_not_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  internalDescription_contains?: Maybe<Scalars['String']>;
  internalDescription_not_contains?: Maybe<Scalars['String']>;
  richText_exists?: Maybe<Scalars['Boolean']>;
  richText_contains?: Maybe<Scalars['String']>;
  richText_not_contains?: Maybe<Scalars['String']>;
  textAlignCenter_exists?: Maybe<Scalars['Boolean']>;
  textAlignCenter?: Maybe<Scalars['Boolean']>;
  textAlignCenter_not?: Maybe<Scalars['Boolean']>;
  superscript_exists?: Maybe<Scalars['Boolean']>;
  superscript?: Maybe<Scalars['String']>;
  superscript_not?: Maybe<Scalars['String']>;
  superscript_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  superscript_not_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  superscript_contains?: Maybe<Scalars['String']>;
  superscript_not_contains?: Maybe<Scalars['String']>;
  superscriptFontSize_exists?: Maybe<Scalars['Boolean']>;
  superscriptFontSize?: Maybe<Scalars['String']>;
  superscriptFontSize_not?: Maybe<Scalars['String']>;
  superscriptFontSize_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  superscriptFontSize_not_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  superscriptFontSize_contains?: Maybe<Scalars['String']>;
  superscriptFontSize_not_contains?: Maybe<Scalars['String']>;
  OR?: Maybe<Array<Maybe<BlockRichTextFilter>>>;
  AND?: Maybe<Array<Maybe<BlockRichTextFilter>>>;
};

export enum LexiconArticleBlocksCollectionOrder {
  InternalDescriptionAsc = 'internalDescription_ASC',
  InternalDescriptionDesc = 'internalDescription_DESC',
  TextAlignCenterAsc = 'textAlignCenter_ASC',
  TextAlignCenterDesc = 'textAlignCenter_DESC',
  SuperscriptAsc = 'superscript_ASC',
  SuperscriptDesc = 'superscript_DESC',
  SuperscriptFontSizeAsc = 'superscriptFontSize_ASC',
  SuperscriptFontSizeDesc = 'superscriptFontSize_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum BlockRichTextLinkingCollectionsLexiconArticleCollectionOrder {
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  LexiconLetterAsc = 'lexiconLetter_ASC',
  LexiconLetterDesc = 'lexiconLetter_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum BlockRichTextLinkingCollectionsBlockOneColumnCollectionOrder {
  InternalDescriptionAsc = 'internalDescription_ASC',
  InternalDescriptionDesc = 'internalDescription_DESC',
  EnableBlackBackgroundAsc = 'enableBlackBackground_ASC',
  EnableBlackBackgroundDesc = 'enableBlackBackground_DESC',
  SmallMainColumnOverImageAsc = 'smallMainColumnOverImage_ASC',
  SmallMainColumnOverImageDesc = 'smallMainColumnOverImage_DESC',
  BackgroundColorAsc = 'backgroundColor_ASC',
  BackgroundColorDesc = 'backgroundColor_DESC',
  PaddingAsc = 'padding_ASC',
  PaddingDesc = 'padding_DESC',
  WithExtraPaddingAsc = 'withExtraPadding_ASC',
  WithExtraPaddingDesc = 'withExtraPadding_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum BlockRichTextLinkingCollectionsBlockTwoColumnCollectionOrder {
  InternalDescriptionAsc = 'internalDescription_ASC',
  InternalDescriptionDesc = 'internalDescription_DESC',
  RightColumnOffsetAsc = 'rightColumnOffset_ASC',
  RightColumnOffsetDesc = 'rightColumnOffset_DESC',
  VerticalCenterLeftColumnAsc = 'verticalCenterLeftColumn_ASC',
  VerticalCenterLeftColumnDesc = 'verticalCenterLeftColumn_DESC',
  VerticalCenterRightColumnAsc = 'verticalCenterRightColumn_ASC',
  VerticalCenterRightColumnDesc = 'verticalCenterRightColumn_DESC',
  LeftColumnTextRightAsc = 'leftColumnTextRight_ASC',
  LeftColumnTextRightDesc = 'leftColumnTextRight_DESC',
  VariantAsc = 'variant_ASC',
  VariantDesc = 'variant_DESC',
  MobileColumnOrderAsc = 'mobileColumnOrder_ASC',
  MobileColumnOrderDesc = 'mobileColumnOrder_DESC',
  AppendContactAndNewsletterCtAsAsc = 'appendContactAndNewsletterCTAs_ASC',
  AppendContactAndNewsletterCtAsDesc = 'appendContactAndNewsletterCTAs_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum BlockRichTextLinkingCollectionsBlockAccordionEntryCollectionOrder {
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC',
  TitleWhenExpandedAsc = 'titleWhenExpanded_ASC',
  TitleWhenExpandedDesc = 'titleWhenExpanded_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum BlockRichTextLinkingCollectionsNewsArticleCollectionOrder {
  NewsTypeAsc = 'newsType_ASC',
  NewsTypeDesc = 'newsType_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  DateAsc = 'date_ASC',
  DateDesc = 'date_DESC',
  HideDateAsc = 'hideDate_ASC',
  HideDateDesc = 'hideDate_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export type ProjectPageCollection = {
  __typename?: 'ProjectPageCollection';
  total: Scalars['Int'];
  skip: Scalars['Int'];
  limit: Scalars['Int'];
  items: Array<Maybe<ProjectPage>>;
};

/** [See type definition](https://app.contentful.com/spaces/0j0b0fue4dp9/content_types/projectPage) */
export type ProjectPage = Entry & _Node & {
  __typename?: 'ProjectPage';
  sys: Sys;
  contentfulMetadata: ContentfulMetadata;
  linkedFrom?: Maybe<ProjectPageLinkingCollections>;
  _id: Scalars['ID'];
  internalName?: Maybe<Scalars['String']>;
  propstackProjectId?: Maybe<Scalars['Int']>;
  blocksBelowImagesCollection?: Maybe<ProjectPageBlocksBelowImagesCollection>;
};


/** [See type definition](https://app.contentful.com/spaces/0j0b0fue4dp9/content_types/projectPage) */
export type ProjectPageLinkedFromArgs = {
  allowedLocales?: Maybe<Array<Maybe<Scalars['String']>>>;
};


/** [See type definition](https://app.contentful.com/spaces/0j0b0fue4dp9/content_types/projectPage) */
export type ProjectPageInternalNameArgs = {
  locale?: Maybe<Scalars['String']>;
};


/** [See type definition](https://app.contentful.com/spaces/0j0b0fue4dp9/content_types/projectPage) */
export type ProjectPagePropstackProjectIdArgs = {
  locale?: Maybe<Scalars['String']>;
};


/** [See type definition](https://app.contentful.com/spaces/0j0b0fue4dp9/content_types/projectPage) */
export type ProjectPageBlocksBelowImagesCollectionArgs = {
  skip?: Maybe<Scalars['Int']>;
  limit?: Maybe<Scalars['Int']>;
  preview?: Maybe<Scalars['Boolean']>;
  locale?: Maybe<Scalars['String']>;
  where?: Maybe<ProjectPageBlocksBelowImagesFilter>;
};

export type ProjectPageLinkingCollections = {
  __typename?: 'ProjectPageLinkingCollections';
  entryCollection?: Maybe<EntryCollection>;
};


export type ProjectPageLinkingCollectionsEntryCollectionArgs = {
  skip?: Maybe<Scalars['Int']>;
  limit?: Maybe<Scalars['Int']>;
  preview?: Maybe<Scalars['Boolean']>;
  locale?: Maybe<Scalars['String']>;
};

export type ProjectPageBlocksBelowImagesCollection = {
  __typename?: 'ProjectPageBlocksBelowImagesCollection';
  total: Scalars['Int'];
  skip: Scalars['Int'];
  limit: Scalars['Int'];
  items: Array<Maybe<ProjectPageBlocksBelowImagesItem>>;
};

export type ProjectPageBlocksBelowImagesItem = BarChartWithBackground | BlockAccordion | BlockAccordionEntry | BlockBigTitleNavigation | BlockCallToActionButton | BlockCustom | BlockFullsizeImage | BlockHighlightRealEstate | BlockPartnerGrid | BlockPersonAccordion | BlockRibbon | BlockRichText | BlockTable | BlockThreeColumn | BlockTwoColumn | BlockVideo;

/** [See type definition](https://app.contentful.com/spaces/0j0b0fue4dp9/content_types/barChartWithBackground) */
export type BarChartWithBackground = Entry & _Node & {
  __typename?: 'BarChartWithBackground';
  sys: Sys;
  contentfulMetadata: ContentfulMetadata;
  linkedFrom?: Maybe<BarChartWithBackgroundLinkingCollections>;
  _id: Scalars['ID'];
  title?: Maybe<Scalars['String']>;
  bars?: Maybe<Scalars['JSON']>;
};


/** [See type definition](https://app.contentful.com/spaces/0j0b0fue4dp9/content_types/barChartWithBackground) */
export type BarChartWithBackgroundLinkedFromArgs = {
  allowedLocales?: Maybe<Array<Maybe<Scalars['String']>>>;
};


/** [See type definition](https://app.contentful.com/spaces/0j0b0fue4dp9/content_types/barChartWithBackground) */
export type BarChartWithBackgroundTitleArgs = {
  locale?: Maybe<Scalars['String']>;
};


/** [See type definition](https://app.contentful.com/spaces/0j0b0fue4dp9/content_types/barChartWithBackground) */
export type BarChartWithBackgroundBarsArgs = {
  locale?: Maybe<Scalars['String']>;
};

export type BarChartWithBackgroundLinkingCollections = {
  __typename?: 'BarChartWithBackgroundLinkingCollections';
  entryCollection?: Maybe<EntryCollection>;
  staticPageCollection?: Maybe<StaticPageCollection>;
  projectPageCollection?: Maybe<ProjectPageCollection>;
};


export type BarChartWithBackgroundLinkingCollectionsEntryCollectionArgs = {
  skip?: Maybe<Scalars['Int']>;
  limit?: Maybe<Scalars['Int']>;
  preview?: Maybe<Scalars['Boolean']>;
  locale?: Maybe<Scalars['String']>;
};


export type BarChartWithBackgroundLinkingCollectionsStaticPageCollectionArgs = {
  skip?: Maybe<Scalars['Int']>;
  limit?: Maybe<Scalars['Int']>;
  preview?: Maybe<Scalars['Boolean']>;
  locale?: Maybe<Scalars['String']>;
  order?: Maybe<Array<Maybe<BarChartWithBackgroundLinkingCollectionsStaticPageCollectionOrder>>>;
};


export type BarChartWithBackgroundLinkingCollectionsProjectPageCollectionArgs = {
  skip?: Maybe<Scalars['Int']>;
  limit?: Maybe<Scalars['Int']>;
  preview?: Maybe<Scalars['Boolean']>;
  locale?: Maybe<Scalars['String']>;
  order?: Maybe<Array<Maybe<BarChartWithBackgroundLinkingCollectionsProjectPageCollectionOrder>>>;
};

export enum BarChartWithBackgroundLinkingCollectionsStaticPageCollectionOrder {
  PageTitleAsc = 'pageTitle_ASC',
  PageTitleDesc = 'pageTitle_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  StandaloneAsc = 'standalone_ASC',
  StandaloneDesc = 'standalone_DESC',
  ShowNewsletterFooterAsc = 'showNewsletterFooter_ASC',
  ShowNewsletterFooterDesc = 'showNewsletterFooter_DESC',
  ShowContactFooterAsc = 'showContactFooter_ASC',
  ShowContactFooterDesc = 'showContactFooter_DESC',
  PageTagAsc = 'pageTag_ASC',
  PageTagDesc = 'pageTag_DESC',
  NewsTypeAsc = 'newsType_ASC',
  NewsTypeDesc = 'newsType_DESC',
  RemovePaddingBottomAsc = 'removePaddingBottom_ASC',
  RemovePaddingBottomDesc = 'removePaddingBottom_DESC',
  RegionAsc = 'region_ASC',
  RegionDesc = 'region_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum BarChartWithBackgroundLinkingCollectionsProjectPageCollectionOrder {
  InternalNameAsc = 'internal_name_ASC',
  InternalNameDesc = 'internal_name_DESC',
  PropstackProjectIdAsc = 'propstackProjectId_ASC',
  PropstackProjectIdDesc = 'propstackProjectId_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}


/** [See type definition](https://app.contentful.com/spaces/0j0b0fue4dp9/content_types/blockCustom) */
export type BlockCustom = Entry & _Node & {
  __typename?: 'BlockCustom';
  sys: Sys;
  contentfulMetadata: ContentfulMetadata;
  linkedFrom?: Maybe<BlockCustomLinkingCollections>;
  _id: Scalars['ID'];
  customBlockType?: Maybe<Scalars['String']>;
};


/** [See type definition](https://app.contentful.com/spaces/0j0b0fue4dp9/content_types/blockCustom) */
export type BlockCustomLinkedFromArgs = {
  allowedLocales?: Maybe<Array<Maybe<Scalars['String']>>>;
};


/** [See type definition](https://app.contentful.com/spaces/0j0b0fue4dp9/content_types/blockCustom) */
export type BlockCustomCustomBlockTypeArgs = {
  locale?: Maybe<Scalars['String']>;
};

export type BlockCustomLinkingCollections = {
  __typename?: 'BlockCustomLinkingCollections';
  entryCollection?: Maybe<EntryCollection>;
  staticPageCollection?: Maybe<StaticPageCollection>;
  blockHiddenWithConsentCollection?: Maybe<BlockHiddenWithConsentCollection>;
  blockOneColumnCollection?: Maybe<BlockOneColumnCollection>;
  blockTwoColumnCollection?: Maybe<BlockTwoColumnCollection>;
  blockAccordionEntryCollection?: Maybe<BlockAccordionEntryCollection>;
  projectPageCollection?: Maybe<ProjectPageCollection>;
};


export type BlockCustomLinkingCollectionsEntryCollectionArgs = {
  skip?: Maybe<Scalars['Int']>;
  limit?: Maybe<Scalars['Int']>;
  preview?: Maybe<Scalars['Boolean']>;
  locale?: Maybe<Scalars['String']>;
};


export type BlockCustomLinkingCollectionsStaticPageCollectionArgs = {
  skip?: Maybe<Scalars['Int']>;
  limit?: Maybe<Scalars['Int']>;
  preview?: Maybe<Scalars['Boolean']>;
  locale?: Maybe<Scalars['String']>;
  order?: Maybe<Array<Maybe<BlockCustomLinkingCollectionsStaticPageCollectionOrder>>>;
};


export type BlockCustomLinkingCollectionsBlockHiddenWithConsentCollectionArgs = {
  skip?: Maybe<Scalars['Int']>;
  limit?: Maybe<Scalars['Int']>;
  preview?: Maybe<Scalars['Boolean']>;
  locale?: Maybe<Scalars['String']>;
  order?: Maybe<Array<Maybe<BlockCustomLinkingCollectionsBlockHiddenWithConsentCollectionOrder>>>;
};


export type BlockCustomLinkingCollectionsBlockOneColumnCollectionArgs = {
  skip?: Maybe<Scalars['Int']>;
  limit?: Maybe<Scalars['Int']>;
  preview?: Maybe<Scalars['Boolean']>;
  locale?: Maybe<Scalars['String']>;
  order?: Maybe<Array<Maybe<BlockCustomLinkingCollectionsBlockOneColumnCollectionOrder>>>;
};


export type BlockCustomLinkingCollectionsBlockTwoColumnCollectionArgs = {
  skip?: Maybe<Scalars['Int']>;
  limit?: Maybe<Scalars['Int']>;
  preview?: Maybe<Scalars['Boolean']>;
  locale?: Maybe<Scalars['String']>;
  order?: Maybe<Array<Maybe<BlockCustomLinkingCollectionsBlockTwoColumnCollectionOrder>>>;
};


export type BlockCustomLinkingCollectionsBlockAccordionEntryCollectionArgs = {
  skip?: Maybe<Scalars['Int']>;
  limit?: Maybe<Scalars['Int']>;
  preview?: Maybe<Scalars['Boolean']>;
  locale?: Maybe<Scalars['String']>;
  order?: Maybe<Array<Maybe<BlockCustomLinkingCollectionsBlockAccordionEntryCollectionOrder>>>;
};


export type BlockCustomLinkingCollectionsProjectPageCollectionArgs = {
  skip?: Maybe<Scalars['Int']>;
  limit?: Maybe<Scalars['Int']>;
  preview?: Maybe<Scalars['Boolean']>;
  locale?: Maybe<Scalars['String']>;
  order?: Maybe<Array<Maybe<BlockCustomLinkingCollectionsProjectPageCollectionOrder>>>;
};

export enum BlockCustomLinkingCollectionsStaticPageCollectionOrder {
  PageTitleAsc = 'pageTitle_ASC',
  PageTitleDesc = 'pageTitle_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  StandaloneAsc = 'standalone_ASC',
  StandaloneDesc = 'standalone_DESC',
  ShowNewsletterFooterAsc = 'showNewsletterFooter_ASC',
  ShowNewsletterFooterDesc = 'showNewsletterFooter_DESC',
  ShowContactFooterAsc = 'showContactFooter_ASC',
  ShowContactFooterDesc = 'showContactFooter_DESC',
  PageTagAsc = 'pageTag_ASC',
  PageTagDesc = 'pageTag_DESC',
  NewsTypeAsc = 'newsType_ASC',
  NewsTypeDesc = 'newsType_DESC',
  RemovePaddingBottomAsc = 'removePaddingBottom_ASC',
  RemovePaddingBottomDesc = 'removePaddingBottom_DESC',
  RegionAsc = 'region_ASC',
  RegionDesc = 'region_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum BlockCustomLinkingCollectionsBlockHiddenWithConsentCollectionOrder {
  ConsentTypeAsc = 'consentType_ASC',
  ConsentTypeDesc = 'consentType_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum BlockCustomLinkingCollectionsBlockOneColumnCollectionOrder {
  InternalDescriptionAsc = 'internalDescription_ASC',
  InternalDescriptionDesc = 'internalDescription_DESC',
  EnableBlackBackgroundAsc = 'enableBlackBackground_ASC',
  EnableBlackBackgroundDesc = 'enableBlackBackground_DESC',
  SmallMainColumnOverImageAsc = 'smallMainColumnOverImage_ASC',
  SmallMainColumnOverImageDesc = 'smallMainColumnOverImage_DESC',
  BackgroundColorAsc = 'backgroundColor_ASC',
  BackgroundColorDesc = 'backgroundColor_DESC',
  PaddingAsc = 'padding_ASC',
  PaddingDesc = 'padding_DESC',
  WithExtraPaddingAsc = 'withExtraPadding_ASC',
  WithExtraPaddingDesc = 'withExtraPadding_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum BlockCustomLinkingCollectionsBlockTwoColumnCollectionOrder {
  InternalDescriptionAsc = 'internalDescription_ASC',
  InternalDescriptionDesc = 'internalDescription_DESC',
  RightColumnOffsetAsc = 'rightColumnOffset_ASC',
  RightColumnOffsetDesc = 'rightColumnOffset_DESC',
  VerticalCenterLeftColumnAsc = 'verticalCenterLeftColumn_ASC',
  VerticalCenterLeftColumnDesc = 'verticalCenterLeftColumn_DESC',
  VerticalCenterRightColumnAsc = 'verticalCenterRightColumn_ASC',
  VerticalCenterRightColumnDesc = 'verticalCenterRightColumn_DESC',
  LeftColumnTextRightAsc = 'leftColumnTextRight_ASC',
  LeftColumnTextRightDesc = 'leftColumnTextRight_DESC',
  VariantAsc = 'variant_ASC',
  VariantDesc = 'variant_DESC',
  MobileColumnOrderAsc = 'mobileColumnOrder_ASC',
  MobileColumnOrderDesc = 'mobileColumnOrder_DESC',
  AppendContactAndNewsletterCtAsAsc = 'appendContactAndNewsletterCTAs_ASC',
  AppendContactAndNewsletterCtAsDesc = 'appendContactAndNewsletterCTAs_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum BlockCustomLinkingCollectionsBlockAccordionEntryCollectionOrder {
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC',
  TitleWhenExpandedAsc = 'titleWhenExpanded_ASC',
  TitleWhenExpandedDesc = 'titleWhenExpanded_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum BlockCustomLinkingCollectionsProjectPageCollectionOrder {
  InternalNameAsc = 'internal_name_ASC',
  InternalNameDesc = 'internal_name_DESC',
  PropstackProjectIdAsc = 'propstackProjectId_ASC',
  PropstackProjectIdDesc = 'propstackProjectId_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

/** Image which covers the whole screen width [See type definition](https://app.contentful.com/spaces/0j0b0fue4dp9/content_types/blockFullsizeImage) */
export type BlockFullsizeImage = Entry & _Node & {
  __typename?: 'BlockFullsizeImage';
  sys: Sys;
  contentfulMetadata: ContentfulMetadata;
  linkedFrom?: Maybe<BlockFullsizeImageLinkingCollections>;
  _id: Scalars['ID'];
  internalDescription?: Maybe<Scalars['String']>;
  image?: Maybe<Asset>;
  downloadFile?: Maybe<Asset>;
  maxWidthParent?: Maybe<Scalars['Boolean']>;
};


/** Image which covers the whole screen width [See type definition](https://app.contentful.com/spaces/0j0b0fue4dp9/content_types/blockFullsizeImage) */
export type BlockFullsizeImageLinkedFromArgs = {
  allowedLocales?: Maybe<Array<Maybe<Scalars['String']>>>;
};


/** Image which covers the whole screen width [See type definition](https://app.contentful.com/spaces/0j0b0fue4dp9/content_types/blockFullsizeImage) */
export type BlockFullsizeImageInternalDescriptionArgs = {
  locale?: Maybe<Scalars['String']>;
};


/** Image which covers the whole screen width [See type definition](https://app.contentful.com/spaces/0j0b0fue4dp9/content_types/blockFullsizeImage) */
export type BlockFullsizeImageImageArgs = {
  preview?: Maybe<Scalars['Boolean']>;
  locale?: Maybe<Scalars['String']>;
};


/** Image which covers the whole screen width [See type definition](https://app.contentful.com/spaces/0j0b0fue4dp9/content_types/blockFullsizeImage) */
export type BlockFullsizeImageDownloadFileArgs = {
  preview?: Maybe<Scalars['Boolean']>;
  locale?: Maybe<Scalars['String']>;
};


/** Image which covers the whole screen width [See type definition](https://app.contentful.com/spaces/0j0b0fue4dp9/content_types/blockFullsizeImage) */
export type BlockFullsizeImageMaxWidthParentArgs = {
  locale?: Maybe<Scalars['String']>;
};

export type BlockFullsizeImageLinkingCollections = {
  __typename?: 'BlockFullsizeImageLinkingCollections';
  entryCollection?: Maybe<EntryCollection>;
  staticPageCollection?: Maybe<StaticPageCollection>;
  blockHiddenWithConsentCollection?: Maybe<BlockHiddenWithConsentCollection>;
  blockOneColumnCollection?: Maybe<BlockOneColumnCollection>;
  blockTwoColumnCollection?: Maybe<BlockTwoColumnCollection>;
  projectPageCollection?: Maybe<ProjectPageCollection>;
};


export type BlockFullsizeImageLinkingCollectionsEntryCollectionArgs = {
  skip?: Maybe<Scalars['Int']>;
  limit?: Maybe<Scalars['Int']>;
  preview?: Maybe<Scalars['Boolean']>;
  locale?: Maybe<Scalars['String']>;
};


export type BlockFullsizeImageLinkingCollectionsStaticPageCollectionArgs = {
  skip?: Maybe<Scalars['Int']>;
  limit?: Maybe<Scalars['Int']>;
  preview?: Maybe<Scalars['Boolean']>;
  locale?: Maybe<Scalars['String']>;
  order?: Maybe<Array<Maybe<BlockFullsizeImageLinkingCollectionsStaticPageCollectionOrder>>>;
};


export type BlockFullsizeImageLinkingCollectionsBlockHiddenWithConsentCollectionArgs = {
  skip?: Maybe<Scalars['Int']>;
  limit?: Maybe<Scalars['Int']>;
  preview?: Maybe<Scalars['Boolean']>;
  locale?: Maybe<Scalars['String']>;
  order?: Maybe<Array<Maybe<BlockFullsizeImageLinkingCollectionsBlockHiddenWithConsentCollectionOrder>>>;
};


export type BlockFullsizeImageLinkingCollectionsBlockOneColumnCollectionArgs = {
  skip?: Maybe<Scalars['Int']>;
  limit?: Maybe<Scalars['Int']>;
  preview?: Maybe<Scalars['Boolean']>;
  locale?: Maybe<Scalars['String']>;
  order?: Maybe<Array<Maybe<BlockFullsizeImageLinkingCollectionsBlockOneColumnCollectionOrder>>>;
};


export type BlockFullsizeImageLinkingCollectionsBlockTwoColumnCollectionArgs = {
  skip?: Maybe<Scalars['Int']>;
  limit?: Maybe<Scalars['Int']>;
  preview?: Maybe<Scalars['Boolean']>;
  locale?: Maybe<Scalars['String']>;
  order?: Maybe<Array<Maybe<BlockFullsizeImageLinkingCollectionsBlockTwoColumnCollectionOrder>>>;
};


export type BlockFullsizeImageLinkingCollectionsProjectPageCollectionArgs = {
  skip?: Maybe<Scalars['Int']>;
  limit?: Maybe<Scalars['Int']>;
  preview?: Maybe<Scalars['Boolean']>;
  locale?: Maybe<Scalars['String']>;
  order?: Maybe<Array<Maybe<BlockFullsizeImageLinkingCollectionsProjectPageCollectionOrder>>>;
};

export enum BlockFullsizeImageLinkingCollectionsStaticPageCollectionOrder {
  PageTitleAsc = 'pageTitle_ASC',
  PageTitleDesc = 'pageTitle_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  StandaloneAsc = 'standalone_ASC',
  StandaloneDesc = 'standalone_DESC',
  ShowNewsletterFooterAsc = 'showNewsletterFooter_ASC',
  ShowNewsletterFooterDesc = 'showNewsletterFooter_DESC',
  ShowContactFooterAsc = 'showContactFooter_ASC',
  ShowContactFooterDesc = 'showContactFooter_DESC',
  PageTagAsc = 'pageTag_ASC',
  PageTagDesc = 'pageTag_DESC',
  NewsTypeAsc = 'newsType_ASC',
  NewsTypeDesc = 'newsType_DESC',
  RemovePaddingBottomAsc = 'removePaddingBottom_ASC',
  RemovePaddingBottomDesc = 'removePaddingBottom_DESC',
  RegionAsc = 'region_ASC',
  RegionDesc = 'region_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum BlockFullsizeImageLinkingCollectionsBlockHiddenWithConsentCollectionOrder {
  ConsentTypeAsc = 'consentType_ASC',
  ConsentTypeDesc = 'consentType_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum BlockFullsizeImageLinkingCollectionsBlockOneColumnCollectionOrder {
  InternalDescriptionAsc = 'internalDescription_ASC',
  InternalDescriptionDesc = 'internalDescription_DESC',
  EnableBlackBackgroundAsc = 'enableBlackBackground_ASC',
  EnableBlackBackgroundDesc = 'enableBlackBackground_DESC',
  SmallMainColumnOverImageAsc = 'smallMainColumnOverImage_ASC',
  SmallMainColumnOverImageDesc = 'smallMainColumnOverImage_DESC',
  BackgroundColorAsc = 'backgroundColor_ASC',
  BackgroundColorDesc = 'backgroundColor_DESC',
  PaddingAsc = 'padding_ASC',
  PaddingDesc = 'padding_DESC',
  WithExtraPaddingAsc = 'withExtraPadding_ASC',
  WithExtraPaddingDesc = 'withExtraPadding_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum BlockFullsizeImageLinkingCollectionsBlockTwoColumnCollectionOrder {
  InternalDescriptionAsc = 'internalDescription_ASC',
  InternalDescriptionDesc = 'internalDescription_DESC',
  RightColumnOffsetAsc = 'rightColumnOffset_ASC',
  RightColumnOffsetDesc = 'rightColumnOffset_DESC',
  VerticalCenterLeftColumnAsc = 'verticalCenterLeftColumn_ASC',
  VerticalCenterLeftColumnDesc = 'verticalCenterLeftColumn_DESC',
  VerticalCenterRightColumnAsc = 'verticalCenterRightColumn_ASC',
  VerticalCenterRightColumnDesc = 'verticalCenterRightColumn_DESC',
  LeftColumnTextRightAsc = 'leftColumnTextRight_ASC',
  LeftColumnTextRightDesc = 'leftColumnTextRight_DESC',
  VariantAsc = 'variant_ASC',
  VariantDesc = 'variant_DESC',
  MobileColumnOrderAsc = 'mobileColumnOrder_ASC',
  MobileColumnOrderDesc = 'mobileColumnOrder_DESC',
  AppendContactAndNewsletterCtAsAsc = 'appendContactAndNewsletterCTAs_ASC',
  AppendContactAndNewsletterCtAsDesc = 'appendContactAndNewsletterCTAs_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum BlockFullsizeImageLinkingCollectionsProjectPageCollectionOrder {
  InternalNameAsc = 'internal_name_ASC',
  InternalNameDesc = 'internal_name_DESC',
  PropstackProjectIdAsc = 'propstackProjectId_ASC',
  PropstackProjectIdDesc = 'propstackProjectId_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

/** Displays properties or projects in a slider highlight block [See type definition](https://app.contentful.com/spaces/0j0b0fue4dp9/content_types/blockHighlightRealEstate) */
export type BlockHighlightRealEstate = Entry & _Node & {
  __typename?: 'BlockHighlightRealEstate';
  sys: Sys;
  contentfulMetadata: ContentfulMetadata;
  linkedFrom?: Maybe<BlockHighlightRealEstateLinkingCollections>;
  _id: Scalars['ID'];
  internalDescription?: Maybe<Scalars['String']>;
  bigTitleNavigation?: Maybe<BlockBigTitleNavigation>;
  highlightedRealEstatesCollection?: Maybe<BlockHighlightRealEstateHighlightedRealEstatesCollection>;
  variant?: Maybe<Scalars['String']>;
};


/** Displays properties or projects in a slider highlight block [See type definition](https://app.contentful.com/spaces/0j0b0fue4dp9/content_types/blockHighlightRealEstate) */
export type BlockHighlightRealEstateLinkedFromArgs = {
  allowedLocales?: Maybe<Array<Maybe<Scalars['String']>>>;
};


/** Displays properties or projects in a slider highlight block [See type definition](https://app.contentful.com/spaces/0j0b0fue4dp9/content_types/blockHighlightRealEstate) */
export type BlockHighlightRealEstateInternalDescriptionArgs = {
  locale?: Maybe<Scalars['String']>;
};


/** Displays properties or projects in a slider highlight block [See type definition](https://app.contentful.com/spaces/0j0b0fue4dp9/content_types/blockHighlightRealEstate) */
export type BlockHighlightRealEstateBigTitleNavigationArgs = {
  preview?: Maybe<Scalars['Boolean']>;
  locale?: Maybe<Scalars['String']>;
  where?: Maybe<BlockBigTitleNavigationFilter>;
};


/** Displays properties or projects in a slider highlight block [See type definition](https://app.contentful.com/spaces/0j0b0fue4dp9/content_types/blockHighlightRealEstate) */
export type BlockHighlightRealEstateHighlightedRealEstatesCollectionArgs = {
  skip?: Maybe<Scalars['Int']>;
  limit?: Maybe<Scalars['Int']>;
  preview?: Maybe<Scalars['Boolean']>;
  locale?: Maybe<Scalars['String']>;
  where?: Maybe<HighlightedRealEstateFilter>;
  order?: Maybe<Array<Maybe<BlockHighlightRealEstateHighlightedRealEstatesCollectionOrder>>>;
};


/** Displays properties or projects in a slider highlight block [See type definition](https://app.contentful.com/spaces/0j0b0fue4dp9/content_types/blockHighlightRealEstate) */
export type BlockHighlightRealEstateVariantArgs = {
  locale?: Maybe<Scalars['String']>;
};

export type BlockHighlightRealEstateLinkingCollections = {
  __typename?: 'BlockHighlightRealEstateLinkingCollections';
  entryCollection?: Maybe<EntryCollection>;
  staticPageCollection?: Maybe<StaticPageCollection>;
  blockHiddenWithConsentCollection?: Maybe<BlockHiddenWithConsentCollection>;
  blockOneColumnCollection?: Maybe<BlockOneColumnCollection>;
  projectPageCollection?: Maybe<ProjectPageCollection>;
};


export type BlockHighlightRealEstateLinkingCollectionsEntryCollectionArgs = {
  skip?: Maybe<Scalars['Int']>;
  limit?: Maybe<Scalars['Int']>;
  preview?: Maybe<Scalars['Boolean']>;
  locale?: Maybe<Scalars['String']>;
};


export type BlockHighlightRealEstateLinkingCollectionsStaticPageCollectionArgs = {
  skip?: Maybe<Scalars['Int']>;
  limit?: Maybe<Scalars['Int']>;
  preview?: Maybe<Scalars['Boolean']>;
  locale?: Maybe<Scalars['String']>;
  order?: Maybe<Array<Maybe<BlockHighlightRealEstateLinkingCollectionsStaticPageCollectionOrder>>>;
};


export type BlockHighlightRealEstateLinkingCollectionsBlockHiddenWithConsentCollectionArgs = {
  skip?: Maybe<Scalars['Int']>;
  limit?: Maybe<Scalars['Int']>;
  preview?: Maybe<Scalars['Boolean']>;
  locale?: Maybe<Scalars['String']>;
  order?: Maybe<Array<Maybe<BlockHighlightRealEstateLinkingCollectionsBlockHiddenWithConsentCollectionOrder>>>;
};


export type BlockHighlightRealEstateLinkingCollectionsBlockOneColumnCollectionArgs = {
  skip?: Maybe<Scalars['Int']>;
  limit?: Maybe<Scalars['Int']>;
  preview?: Maybe<Scalars['Boolean']>;
  locale?: Maybe<Scalars['String']>;
  order?: Maybe<Array<Maybe<BlockHighlightRealEstateLinkingCollectionsBlockOneColumnCollectionOrder>>>;
};


export type BlockHighlightRealEstateLinkingCollectionsProjectPageCollectionArgs = {
  skip?: Maybe<Scalars['Int']>;
  limit?: Maybe<Scalars['Int']>;
  preview?: Maybe<Scalars['Boolean']>;
  locale?: Maybe<Scalars['String']>;
  order?: Maybe<Array<Maybe<BlockHighlightRealEstateLinkingCollectionsProjectPageCollectionOrder>>>;
};

export enum BlockHighlightRealEstateLinkingCollectionsStaticPageCollectionOrder {
  PageTitleAsc = 'pageTitle_ASC',
  PageTitleDesc = 'pageTitle_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  StandaloneAsc = 'standalone_ASC',
  StandaloneDesc = 'standalone_DESC',
  ShowNewsletterFooterAsc = 'showNewsletterFooter_ASC',
  ShowNewsletterFooterDesc = 'showNewsletterFooter_DESC',
  ShowContactFooterAsc = 'showContactFooter_ASC',
  ShowContactFooterDesc = 'showContactFooter_DESC',
  PageTagAsc = 'pageTag_ASC',
  PageTagDesc = 'pageTag_DESC',
  NewsTypeAsc = 'newsType_ASC',
  NewsTypeDesc = 'newsType_DESC',
  RemovePaddingBottomAsc = 'removePaddingBottom_ASC',
  RemovePaddingBottomDesc = 'removePaddingBottom_DESC',
  RegionAsc = 'region_ASC',
  RegionDesc = 'region_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum BlockHighlightRealEstateLinkingCollectionsBlockHiddenWithConsentCollectionOrder {
  ConsentTypeAsc = 'consentType_ASC',
  ConsentTypeDesc = 'consentType_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum BlockHighlightRealEstateLinkingCollectionsBlockOneColumnCollectionOrder {
  InternalDescriptionAsc = 'internalDescription_ASC',
  InternalDescriptionDesc = 'internalDescription_DESC',
  EnableBlackBackgroundAsc = 'enableBlackBackground_ASC',
  EnableBlackBackgroundDesc = 'enableBlackBackground_DESC',
  SmallMainColumnOverImageAsc = 'smallMainColumnOverImage_ASC',
  SmallMainColumnOverImageDesc = 'smallMainColumnOverImage_DESC',
  BackgroundColorAsc = 'backgroundColor_ASC',
  BackgroundColorDesc = 'backgroundColor_DESC',
  PaddingAsc = 'padding_ASC',
  PaddingDesc = 'padding_DESC',
  WithExtraPaddingAsc = 'withExtraPadding_ASC',
  WithExtraPaddingDesc = 'withExtraPadding_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum BlockHighlightRealEstateLinkingCollectionsProjectPageCollectionOrder {
  InternalNameAsc = 'internal_name_ASC',
  InternalNameDesc = 'internal_name_DESC',
  PropstackProjectIdAsc = 'propstackProjectId_ASC',
  PropstackProjectIdDesc = 'propstackProjectId_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export type BlockBigTitleNavigationFilter = {
  staticPageReference?: Maybe<CfStaticPageNestedFilter>;
  sys?: Maybe<SysFilter>;
  contentfulMetadata?: Maybe<ContentfulMetadataFilter>;
  internalDescription_exists?: Maybe<Scalars['Boolean']>;
  internalDescription?: Maybe<Scalars['String']>;
  internalDescription_not?: Maybe<Scalars['String']>;
  internalDescription_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  internalDescription_not_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  internalDescription_contains?: Maybe<Scalars['String']>;
  internalDescription_not_contains?: Maybe<Scalars['String']>;
  title_exists?: Maybe<Scalars['Boolean']>;
  title?: Maybe<Scalars['String']>;
  title_not?: Maybe<Scalars['String']>;
  title_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  title_not_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  title_contains?: Maybe<Scalars['String']>;
  title_not_contains?: Maybe<Scalars['String']>;
  subTitle_exists?: Maybe<Scalars['Boolean']>;
  subTitle?: Maybe<Scalars['String']>;
  subTitle_not?: Maybe<Scalars['String']>;
  subTitle_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  subTitle_not_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  subTitle_contains?: Maybe<Scalars['String']>;
  subTitle_not_contains?: Maybe<Scalars['String']>;
  staticPageReference_exists?: Maybe<Scalars['Boolean']>;
  buttonText_exists?: Maybe<Scalars['Boolean']>;
  buttonText?: Maybe<Scalars['String']>;
  buttonText_not?: Maybe<Scalars['String']>;
  buttonText_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  buttonText_not_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  buttonText_contains?: Maybe<Scalars['String']>;
  buttonText_not_contains?: Maybe<Scalars['String']>;
  additionalInfoText_exists?: Maybe<Scalars['Boolean']>;
  additionalInfoText?: Maybe<Scalars['String']>;
  additionalInfoText_not?: Maybe<Scalars['String']>;
  additionalInfoText_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  additionalInfoText_not_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  additionalInfoText_contains?: Maybe<Scalars['String']>;
  additionalInfoText_not_contains?: Maybe<Scalars['String']>;
  url_exists?: Maybe<Scalars['Boolean']>;
  url?: Maybe<Scalars['String']>;
  url_not?: Maybe<Scalars['String']>;
  url_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  url_not_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  url_contains?: Maybe<Scalars['String']>;
  url_not_contains?: Maybe<Scalars['String']>;
  OR?: Maybe<Array<Maybe<BlockBigTitleNavigationFilter>>>;
  AND?: Maybe<Array<Maybe<BlockBigTitleNavigationFilter>>>;
};

export type BlockHighlightRealEstateHighlightedRealEstatesCollection = {
  __typename?: 'BlockHighlightRealEstateHighlightedRealEstatesCollection';
  total: Scalars['Int'];
  skip: Scalars['Int'];
  limit: Scalars['Int'];
  items: Array<Maybe<HighlightedRealEstate>>;
};

/** [See type definition](https://app.contentful.com/spaces/0j0b0fue4dp9/content_types/highlightedRealEstate) */
export type HighlightedRealEstate = Entry & _Node & {
  __typename?: 'HighlightedRealEstate';
  sys: Sys;
  contentfulMetadata: ContentfulMetadata;
  linkedFrom?: Maybe<HighlightedRealEstateLinkingCollections>;
  _id: Scalars['ID'];
  internalDescription?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  subTitle?: Maybe<Scalars['String']>;
  rooms?: Maybe<Scalars['String']>;
  squareMeter?: Maybe<Scalars['String']>;
  price?: Maybe<Scalars['String']>;
  pricePerSquareMeter?: Maybe<Scalars['String']>;
  slug?: Maybe<Scalars['String']>;
  image?: Maybe<Asset>;
  isComingSoonProject?: Maybe<Scalars['Boolean']>;
};


/** [See type definition](https://app.contentful.com/spaces/0j0b0fue4dp9/content_types/highlightedRealEstate) */
export type HighlightedRealEstateLinkedFromArgs = {
  allowedLocales?: Maybe<Array<Maybe<Scalars['String']>>>;
};


/** [See type definition](https://app.contentful.com/spaces/0j0b0fue4dp9/content_types/highlightedRealEstate) */
export type HighlightedRealEstateInternalDescriptionArgs = {
  locale?: Maybe<Scalars['String']>;
};


/** [See type definition](https://app.contentful.com/spaces/0j0b0fue4dp9/content_types/highlightedRealEstate) */
export type HighlightedRealEstateTitleArgs = {
  locale?: Maybe<Scalars['String']>;
};


/** [See type definition](https://app.contentful.com/spaces/0j0b0fue4dp9/content_types/highlightedRealEstate) */
export type HighlightedRealEstateSubTitleArgs = {
  locale?: Maybe<Scalars['String']>;
};


/** [See type definition](https://app.contentful.com/spaces/0j0b0fue4dp9/content_types/highlightedRealEstate) */
export type HighlightedRealEstateRoomsArgs = {
  locale?: Maybe<Scalars['String']>;
};


/** [See type definition](https://app.contentful.com/spaces/0j0b0fue4dp9/content_types/highlightedRealEstate) */
export type HighlightedRealEstateSquareMeterArgs = {
  locale?: Maybe<Scalars['String']>;
};


/** [See type definition](https://app.contentful.com/spaces/0j0b0fue4dp9/content_types/highlightedRealEstate) */
export type HighlightedRealEstatePriceArgs = {
  locale?: Maybe<Scalars['String']>;
};


/** [See type definition](https://app.contentful.com/spaces/0j0b0fue4dp9/content_types/highlightedRealEstate) */
export type HighlightedRealEstatePricePerSquareMeterArgs = {
  locale?: Maybe<Scalars['String']>;
};


/** [See type definition](https://app.contentful.com/spaces/0j0b0fue4dp9/content_types/highlightedRealEstate) */
export type HighlightedRealEstateSlugArgs = {
  locale?: Maybe<Scalars['String']>;
};


/** [See type definition](https://app.contentful.com/spaces/0j0b0fue4dp9/content_types/highlightedRealEstate) */
export type HighlightedRealEstateImageArgs = {
  preview?: Maybe<Scalars['Boolean']>;
  locale?: Maybe<Scalars['String']>;
};


/** [See type definition](https://app.contentful.com/spaces/0j0b0fue4dp9/content_types/highlightedRealEstate) */
export type HighlightedRealEstateIsComingSoonProjectArgs = {
  locale?: Maybe<Scalars['String']>;
};

export type HighlightedRealEstateLinkingCollections = {
  __typename?: 'HighlightedRealEstateLinkingCollections';
  entryCollection?: Maybe<EntryCollection>;
  blockHiddenWithConsentCollection?: Maybe<BlockHiddenWithConsentCollection>;
  blockHighlightRealEstateCollection?: Maybe<BlockHighlightRealEstateCollection>;
};


export type HighlightedRealEstateLinkingCollectionsEntryCollectionArgs = {
  skip?: Maybe<Scalars['Int']>;
  limit?: Maybe<Scalars['Int']>;
  preview?: Maybe<Scalars['Boolean']>;
  locale?: Maybe<Scalars['String']>;
};


export type HighlightedRealEstateLinkingCollectionsBlockHiddenWithConsentCollectionArgs = {
  skip?: Maybe<Scalars['Int']>;
  limit?: Maybe<Scalars['Int']>;
  preview?: Maybe<Scalars['Boolean']>;
  locale?: Maybe<Scalars['String']>;
  order?: Maybe<Array<Maybe<HighlightedRealEstateLinkingCollectionsBlockHiddenWithConsentCollectionOrder>>>;
};


export type HighlightedRealEstateLinkingCollectionsBlockHighlightRealEstateCollectionArgs = {
  skip?: Maybe<Scalars['Int']>;
  limit?: Maybe<Scalars['Int']>;
  preview?: Maybe<Scalars['Boolean']>;
  locale?: Maybe<Scalars['String']>;
  order?: Maybe<Array<Maybe<HighlightedRealEstateLinkingCollectionsBlockHighlightRealEstateCollectionOrder>>>;
};

export enum HighlightedRealEstateLinkingCollectionsBlockHiddenWithConsentCollectionOrder {
  ConsentTypeAsc = 'consentType_ASC',
  ConsentTypeDesc = 'consentType_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export type BlockHighlightRealEstateCollection = {
  __typename?: 'BlockHighlightRealEstateCollection';
  total: Scalars['Int'];
  skip: Scalars['Int'];
  limit: Scalars['Int'];
  items: Array<Maybe<BlockHighlightRealEstate>>;
};

export enum HighlightedRealEstateLinkingCollectionsBlockHighlightRealEstateCollectionOrder {
  InternalDescriptionAsc = 'internalDescription_ASC',
  InternalDescriptionDesc = 'internalDescription_DESC',
  VariantAsc = 'variant_ASC',
  VariantDesc = 'variant_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export type HighlightedRealEstateFilter = {
  sys?: Maybe<SysFilter>;
  contentfulMetadata?: Maybe<ContentfulMetadataFilter>;
  internalDescription_exists?: Maybe<Scalars['Boolean']>;
  internalDescription?: Maybe<Scalars['String']>;
  internalDescription_not?: Maybe<Scalars['String']>;
  internalDescription_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  internalDescription_not_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  internalDescription_contains?: Maybe<Scalars['String']>;
  internalDescription_not_contains?: Maybe<Scalars['String']>;
  title_exists?: Maybe<Scalars['Boolean']>;
  title?: Maybe<Scalars['String']>;
  title_not?: Maybe<Scalars['String']>;
  title_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  title_not_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  title_contains?: Maybe<Scalars['String']>;
  title_not_contains?: Maybe<Scalars['String']>;
  subTitle_exists?: Maybe<Scalars['Boolean']>;
  subTitle?: Maybe<Scalars['String']>;
  subTitle_not?: Maybe<Scalars['String']>;
  subTitle_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  subTitle_not_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  subTitle_contains?: Maybe<Scalars['String']>;
  subTitle_not_contains?: Maybe<Scalars['String']>;
  rooms_exists?: Maybe<Scalars['Boolean']>;
  rooms?: Maybe<Scalars['String']>;
  rooms_not?: Maybe<Scalars['String']>;
  rooms_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  rooms_not_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  rooms_contains?: Maybe<Scalars['String']>;
  rooms_not_contains?: Maybe<Scalars['String']>;
  squareMeter_exists?: Maybe<Scalars['Boolean']>;
  squareMeter?: Maybe<Scalars['String']>;
  squareMeter_not?: Maybe<Scalars['String']>;
  squareMeter_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  squareMeter_not_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  squareMeter_contains?: Maybe<Scalars['String']>;
  squareMeter_not_contains?: Maybe<Scalars['String']>;
  price_exists?: Maybe<Scalars['Boolean']>;
  price?: Maybe<Scalars['String']>;
  price_not?: Maybe<Scalars['String']>;
  price_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  price_not_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  price_contains?: Maybe<Scalars['String']>;
  price_not_contains?: Maybe<Scalars['String']>;
  pricePerSquareMeter_exists?: Maybe<Scalars['Boolean']>;
  pricePerSquareMeter?: Maybe<Scalars['String']>;
  pricePerSquareMeter_not?: Maybe<Scalars['String']>;
  pricePerSquareMeter_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  pricePerSquareMeter_not_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  pricePerSquareMeter_contains?: Maybe<Scalars['String']>;
  pricePerSquareMeter_not_contains?: Maybe<Scalars['String']>;
  slug_exists?: Maybe<Scalars['Boolean']>;
  slug?: Maybe<Scalars['String']>;
  slug_not?: Maybe<Scalars['String']>;
  slug_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  slug_not_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  slug_contains?: Maybe<Scalars['String']>;
  slug_not_contains?: Maybe<Scalars['String']>;
  image_exists?: Maybe<Scalars['Boolean']>;
  isComingSoonProject_exists?: Maybe<Scalars['Boolean']>;
  isComingSoonProject?: Maybe<Scalars['Boolean']>;
  isComingSoonProject_not?: Maybe<Scalars['Boolean']>;
  OR?: Maybe<Array<Maybe<HighlightedRealEstateFilter>>>;
  AND?: Maybe<Array<Maybe<HighlightedRealEstateFilter>>>;
};

export enum BlockHighlightRealEstateHighlightedRealEstatesCollectionOrder {
  InternalDescriptionAsc = 'internalDescription_ASC',
  InternalDescriptionDesc = 'internalDescription_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC',
  SubTitleAsc = 'subTitle_ASC',
  SubTitleDesc = 'subTitle_DESC',
  RoomsAsc = 'rooms_ASC',
  RoomsDesc = 'rooms_DESC',
  SquareMeterAsc = 'squareMeter_ASC',
  SquareMeterDesc = 'squareMeter_DESC',
  PriceAsc = 'price_ASC',
  PriceDesc = 'price_DESC',
  PricePerSquareMeterAsc = 'pricePerSquareMeter_ASC',
  PricePerSquareMeterDesc = 'pricePerSquareMeter_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  IsComingSoonProjectAsc = 'isComingSoonProject_ASC',
  IsComingSoonProjectDesc = 'isComingSoonProject_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

/** Displays selected partners in a grid layout [See type definition](https://app.contentful.com/spaces/0j0b0fue4dp9/content_types/blockPartnerGrid) */
export type BlockPartnerGrid = Entry & _Node & {
  __typename?: 'BlockPartnerGrid';
  sys: Sys;
  contentfulMetadata: ContentfulMetadata;
  linkedFrom?: Maybe<BlockPartnerGridLinkingCollections>;
  _id: Scalars['ID'];
  partnersCollection?: Maybe<BlockPartnerGridPartnersCollection>;
};


/** Displays selected partners in a grid layout [See type definition](https://app.contentful.com/spaces/0j0b0fue4dp9/content_types/blockPartnerGrid) */
export type BlockPartnerGridLinkedFromArgs = {
  allowedLocales?: Maybe<Array<Maybe<Scalars['String']>>>;
};


/** Displays selected partners in a grid layout [See type definition](https://app.contentful.com/spaces/0j0b0fue4dp9/content_types/blockPartnerGrid) */
export type BlockPartnerGridPartnersCollectionArgs = {
  skip?: Maybe<Scalars['Int']>;
  limit?: Maybe<Scalars['Int']>;
  preview?: Maybe<Scalars['Boolean']>;
  locale?: Maybe<Scalars['String']>;
  where?: Maybe<PartnerFilter>;
  order?: Maybe<Array<Maybe<BlockPartnerGridPartnersCollectionOrder>>>;
};

export type BlockPartnerGridLinkingCollections = {
  __typename?: 'BlockPartnerGridLinkingCollections';
  entryCollection?: Maybe<EntryCollection>;
  staticPageCollection?: Maybe<StaticPageCollection>;
  blockOneColumnCollection?: Maybe<BlockOneColumnCollection>;
  projectPageCollection?: Maybe<ProjectPageCollection>;
};


export type BlockPartnerGridLinkingCollectionsEntryCollectionArgs = {
  skip?: Maybe<Scalars['Int']>;
  limit?: Maybe<Scalars['Int']>;
  preview?: Maybe<Scalars['Boolean']>;
  locale?: Maybe<Scalars['String']>;
};


export type BlockPartnerGridLinkingCollectionsStaticPageCollectionArgs = {
  skip?: Maybe<Scalars['Int']>;
  limit?: Maybe<Scalars['Int']>;
  preview?: Maybe<Scalars['Boolean']>;
  locale?: Maybe<Scalars['String']>;
  order?: Maybe<Array<Maybe<BlockPartnerGridLinkingCollectionsStaticPageCollectionOrder>>>;
};


export type BlockPartnerGridLinkingCollectionsBlockOneColumnCollectionArgs = {
  skip?: Maybe<Scalars['Int']>;
  limit?: Maybe<Scalars['Int']>;
  preview?: Maybe<Scalars['Boolean']>;
  locale?: Maybe<Scalars['String']>;
  order?: Maybe<Array<Maybe<BlockPartnerGridLinkingCollectionsBlockOneColumnCollectionOrder>>>;
};


export type BlockPartnerGridLinkingCollectionsProjectPageCollectionArgs = {
  skip?: Maybe<Scalars['Int']>;
  limit?: Maybe<Scalars['Int']>;
  preview?: Maybe<Scalars['Boolean']>;
  locale?: Maybe<Scalars['String']>;
  order?: Maybe<Array<Maybe<BlockPartnerGridLinkingCollectionsProjectPageCollectionOrder>>>;
};

export enum BlockPartnerGridLinkingCollectionsStaticPageCollectionOrder {
  PageTitleAsc = 'pageTitle_ASC',
  PageTitleDesc = 'pageTitle_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  StandaloneAsc = 'standalone_ASC',
  StandaloneDesc = 'standalone_DESC',
  ShowNewsletterFooterAsc = 'showNewsletterFooter_ASC',
  ShowNewsletterFooterDesc = 'showNewsletterFooter_DESC',
  ShowContactFooterAsc = 'showContactFooter_ASC',
  ShowContactFooterDesc = 'showContactFooter_DESC',
  PageTagAsc = 'pageTag_ASC',
  PageTagDesc = 'pageTag_DESC',
  NewsTypeAsc = 'newsType_ASC',
  NewsTypeDesc = 'newsType_DESC',
  RemovePaddingBottomAsc = 'removePaddingBottom_ASC',
  RemovePaddingBottomDesc = 'removePaddingBottom_DESC',
  RegionAsc = 'region_ASC',
  RegionDesc = 'region_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum BlockPartnerGridLinkingCollectionsBlockOneColumnCollectionOrder {
  InternalDescriptionAsc = 'internalDescription_ASC',
  InternalDescriptionDesc = 'internalDescription_DESC',
  EnableBlackBackgroundAsc = 'enableBlackBackground_ASC',
  EnableBlackBackgroundDesc = 'enableBlackBackground_DESC',
  SmallMainColumnOverImageAsc = 'smallMainColumnOverImage_ASC',
  SmallMainColumnOverImageDesc = 'smallMainColumnOverImage_DESC',
  BackgroundColorAsc = 'backgroundColor_ASC',
  BackgroundColorDesc = 'backgroundColor_DESC',
  PaddingAsc = 'padding_ASC',
  PaddingDesc = 'padding_DESC',
  WithExtraPaddingAsc = 'withExtraPadding_ASC',
  WithExtraPaddingDesc = 'withExtraPadding_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum BlockPartnerGridLinkingCollectionsProjectPageCollectionOrder {
  InternalNameAsc = 'internal_name_ASC',
  InternalNameDesc = 'internal_name_DESC',
  PropstackProjectIdAsc = 'propstackProjectId_ASC',
  PropstackProjectIdDesc = 'propstackProjectId_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export type BlockPartnerGridPartnersCollection = {
  __typename?: 'BlockPartnerGridPartnersCollection';
  total: Scalars['Int'];
  skip: Scalars['Int'];
  limit: Scalars['Int'];
  items: Array<Maybe<Partner>>;
};

/** Partner or membership [See type definition](https://app.contentful.com/spaces/0j0b0fue4dp9/content_types/partner) */
export type Partner = Entry & _Node & {
  __typename?: 'Partner';
  sys: Sys;
  contentfulMetadata: ContentfulMetadata;
  linkedFrom?: Maybe<PartnerLinkingCollections>;
  _id: Scalars['ID'];
  internalDescription?: Maybe<Scalars['String']>;
  partnerText?: Maybe<Scalars['String']>;
  partnerImage?: Maybe<Asset>;
  href?: Maybe<Scalars['String']>;
};


/** Partner or membership [See type definition](https://app.contentful.com/spaces/0j0b0fue4dp9/content_types/partner) */
export type PartnerLinkedFromArgs = {
  allowedLocales?: Maybe<Array<Maybe<Scalars['String']>>>;
};


/** Partner or membership [See type definition](https://app.contentful.com/spaces/0j0b0fue4dp9/content_types/partner) */
export type PartnerInternalDescriptionArgs = {
  locale?: Maybe<Scalars['String']>;
};


/** Partner or membership [See type definition](https://app.contentful.com/spaces/0j0b0fue4dp9/content_types/partner) */
export type PartnerPartnerTextArgs = {
  locale?: Maybe<Scalars['String']>;
};


/** Partner or membership [See type definition](https://app.contentful.com/spaces/0j0b0fue4dp9/content_types/partner) */
export type PartnerPartnerImageArgs = {
  preview?: Maybe<Scalars['Boolean']>;
  locale?: Maybe<Scalars['String']>;
};


/** Partner or membership [See type definition](https://app.contentful.com/spaces/0j0b0fue4dp9/content_types/partner) */
export type PartnerHrefArgs = {
  locale?: Maybe<Scalars['String']>;
};

export type PartnerLinkingCollections = {
  __typename?: 'PartnerLinkingCollections';
  entryCollection?: Maybe<EntryCollection>;
  blockPartnerGridCollection?: Maybe<BlockPartnerGridCollection>;
};


export type PartnerLinkingCollectionsEntryCollectionArgs = {
  skip?: Maybe<Scalars['Int']>;
  limit?: Maybe<Scalars['Int']>;
  preview?: Maybe<Scalars['Boolean']>;
  locale?: Maybe<Scalars['String']>;
};


export type PartnerLinkingCollectionsBlockPartnerGridCollectionArgs = {
  skip?: Maybe<Scalars['Int']>;
  limit?: Maybe<Scalars['Int']>;
  preview?: Maybe<Scalars['Boolean']>;
  locale?: Maybe<Scalars['String']>;
  order?: Maybe<Array<Maybe<PartnerLinkingCollectionsBlockPartnerGridCollectionOrder>>>;
};

export type BlockPartnerGridCollection = {
  __typename?: 'BlockPartnerGridCollection';
  total: Scalars['Int'];
  skip: Scalars['Int'];
  limit: Scalars['Int'];
  items: Array<Maybe<BlockPartnerGrid>>;
};

export enum PartnerLinkingCollectionsBlockPartnerGridCollectionOrder {
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export type PartnerFilter = {
  sys?: Maybe<SysFilter>;
  contentfulMetadata?: Maybe<ContentfulMetadataFilter>;
  internalDescription_exists?: Maybe<Scalars['Boolean']>;
  internalDescription?: Maybe<Scalars['String']>;
  internalDescription_not?: Maybe<Scalars['String']>;
  internalDescription_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  internalDescription_not_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  internalDescription_contains?: Maybe<Scalars['String']>;
  internalDescription_not_contains?: Maybe<Scalars['String']>;
  partnerText_exists?: Maybe<Scalars['Boolean']>;
  partnerText?: Maybe<Scalars['String']>;
  partnerText_not?: Maybe<Scalars['String']>;
  partnerText_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  partnerText_not_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  partnerText_contains?: Maybe<Scalars['String']>;
  partnerText_not_contains?: Maybe<Scalars['String']>;
  partnerImage_exists?: Maybe<Scalars['Boolean']>;
  href_exists?: Maybe<Scalars['Boolean']>;
  href?: Maybe<Scalars['String']>;
  href_not?: Maybe<Scalars['String']>;
  href_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  href_not_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  href_contains?: Maybe<Scalars['String']>;
  href_not_contains?: Maybe<Scalars['String']>;
  OR?: Maybe<Array<Maybe<PartnerFilter>>>;
  AND?: Maybe<Array<Maybe<PartnerFilter>>>;
};

export enum BlockPartnerGridPartnersCollectionOrder {
  InternalDescriptionAsc = 'internalDescription_ASC',
  InternalDescriptionDesc = 'internalDescription_DESC',
  PartnerTextAsc = 'partnerText_ASC',
  PartnerTextDesc = 'partnerText_DESC',
  HrefAsc = 'href_ASC',
  HrefDesc = 'href_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

/** [See type definition](https://app.contentful.com/spaces/0j0b0fue4dp9/content_types/blockPersonAccordion) */
export type BlockPersonAccordion = Entry & _Node & {
  __typename?: 'BlockPersonAccordion';
  sys: Sys;
  contentfulMetadata: ContentfulMetadata;
  linkedFrom?: Maybe<BlockPersonAccordionLinkingCollections>;
  _id: Scalars['ID'];
  title?: Maybe<Scalars['String']>;
  personEntriesCollection?: Maybe<BlockPersonAccordionPersonEntriesCollection>;
};


/** [See type definition](https://app.contentful.com/spaces/0j0b0fue4dp9/content_types/blockPersonAccordion) */
export type BlockPersonAccordionLinkedFromArgs = {
  allowedLocales?: Maybe<Array<Maybe<Scalars['String']>>>;
};


/** [See type definition](https://app.contentful.com/spaces/0j0b0fue4dp9/content_types/blockPersonAccordion) */
export type BlockPersonAccordionTitleArgs = {
  locale?: Maybe<Scalars['String']>;
};


/** [See type definition](https://app.contentful.com/spaces/0j0b0fue4dp9/content_types/blockPersonAccordion) */
export type BlockPersonAccordionPersonEntriesCollectionArgs = {
  skip?: Maybe<Scalars['Int']>;
  limit?: Maybe<Scalars['Int']>;
  preview?: Maybe<Scalars['Boolean']>;
  locale?: Maybe<Scalars['String']>;
  where?: Maybe<PersonAccordionEntryFilter>;
  order?: Maybe<Array<Maybe<BlockPersonAccordionPersonEntriesCollectionOrder>>>;
};

export type BlockPersonAccordionLinkingCollections = {
  __typename?: 'BlockPersonAccordionLinkingCollections';
  entryCollection?: Maybe<EntryCollection>;
  staticPageCollection?: Maybe<StaticPageCollection>;
  blockHiddenWithConsentCollection?: Maybe<BlockHiddenWithConsentCollection>;
  blockOneColumnCollection?: Maybe<BlockOneColumnCollection>;
  projectPageCollection?: Maybe<ProjectPageCollection>;
};


export type BlockPersonAccordionLinkingCollectionsEntryCollectionArgs = {
  skip?: Maybe<Scalars['Int']>;
  limit?: Maybe<Scalars['Int']>;
  preview?: Maybe<Scalars['Boolean']>;
  locale?: Maybe<Scalars['String']>;
};


export type BlockPersonAccordionLinkingCollectionsStaticPageCollectionArgs = {
  skip?: Maybe<Scalars['Int']>;
  limit?: Maybe<Scalars['Int']>;
  preview?: Maybe<Scalars['Boolean']>;
  locale?: Maybe<Scalars['String']>;
  order?: Maybe<Array<Maybe<BlockPersonAccordionLinkingCollectionsStaticPageCollectionOrder>>>;
};


export type BlockPersonAccordionLinkingCollectionsBlockHiddenWithConsentCollectionArgs = {
  skip?: Maybe<Scalars['Int']>;
  limit?: Maybe<Scalars['Int']>;
  preview?: Maybe<Scalars['Boolean']>;
  locale?: Maybe<Scalars['String']>;
  order?: Maybe<Array<Maybe<BlockPersonAccordionLinkingCollectionsBlockHiddenWithConsentCollectionOrder>>>;
};


export type BlockPersonAccordionLinkingCollectionsBlockOneColumnCollectionArgs = {
  skip?: Maybe<Scalars['Int']>;
  limit?: Maybe<Scalars['Int']>;
  preview?: Maybe<Scalars['Boolean']>;
  locale?: Maybe<Scalars['String']>;
  order?: Maybe<Array<Maybe<BlockPersonAccordionLinkingCollectionsBlockOneColumnCollectionOrder>>>;
};


export type BlockPersonAccordionLinkingCollectionsProjectPageCollectionArgs = {
  skip?: Maybe<Scalars['Int']>;
  limit?: Maybe<Scalars['Int']>;
  preview?: Maybe<Scalars['Boolean']>;
  locale?: Maybe<Scalars['String']>;
  order?: Maybe<Array<Maybe<BlockPersonAccordionLinkingCollectionsProjectPageCollectionOrder>>>;
};

export enum BlockPersonAccordionLinkingCollectionsStaticPageCollectionOrder {
  PageTitleAsc = 'pageTitle_ASC',
  PageTitleDesc = 'pageTitle_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  StandaloneAsc = 'standalone_ASC',
  StandaloneDesc = 'standalone_DESC',
  ShowNewsletterFooterAsc = 'showNewsletterFooter_ASC',
  ShowNewsletterFooterDesc = 'showNewsletterFooter_DESC',
  ShowContactFooterAsc = 'showContactFooter_ASC',
  ShowContactFooterDesc = 'showContactFooter_DESC',
  PageTagAsc = 'pageTag_ASC',
  PageTagDesc = 'pageTag_DESC',
  NewsTypeAsc = 'newsType_ASC',
  NewsTypeDesc = 'newsType_DESC',
  RemovePaddingBottomAsc = 'removePaddingBottom_ASC',
  RemovePaddingBottomDesc = 'removePaddingBottom_DESC',
  RegionAsc = 'region_ASC',
  RegionDesc = 'region_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum BlockPersonAccordionLinkingCollectionsBlockHiddenWithConsentCollectionOrder {
  ConsentTypeAsc = 'consentType_ASC',
  ConsentTypeDesc = 'consentType_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum BlockPersonAccordionLinkingCollectionsBlockOneColumnCollectionOrder {
  InternalDescriptionAsc = 'internalDescription_ASC',
  InternalDescriptionDesc = 'internalDescription_DESC',
  EnableBlackBackgroundAsc = 'enableBlackBackground_ASC',
  EnableBlackBackgroundDesc = 'enableBlackBackground_DESC',
  SmallMainColumnOverImageAsc = 'smallMainColumnOverImage_ASC',
  SmallMainColumnOverImageDesc = 'smallMainColumnOverImage_DESC',
  BackgroundColorAsc = 'backgroundColor_ASC',
  BackgroundColorDesc = 'backgroundColor_DESC',
  PaddingAsc = 'padding_ASC',
  PaddingDesc = 'padding_DESC',
  WithExtraPaddingAsc = 'withExtraPadding_ASC',
  WithExtraPaddingDesc = 'withExtraPadding_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum BlockPersonAccordionLinkingCollectionsProjectPageCollectionOrder {
  InternalNameAsc = 'internal_name_ASC',
  InternalNameDesc = 'internal_name_DESC',
  PropstackProjectIdAsc = 'propstackProjectId_ASC',
  PropstackProjectIdDesc = 'propstackProjectId_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export type BlockPersonAccordionPersonEntriesCollection = {
  __typename?: 'BlockPersonAccordionPersonEntriesCollection';
  total: Scalars['Int'];
  skip: Scalars['Int'];
  limit: Scalars['Int'];
  items: Array<Maybe<PersonAccordionEntry>>;
};

/** [See type definition](https://app.contentful.com/spaces/0j0b0fue4dp9/content_types/personAccordionEntry) */
export type PersonAccordionEntry = Entry & _Node & {
  __typename?: 'PersonAccordionEntry';
  sys: Sys;
  contentfulMetadata: ContentfulMetadata;
  linkedFrom?: Maybe<PersonAccordionEntryLinkingCollections>;
  _id: Scalars['ID'];
  fullName?: Maybe<Scalars['String']>;
  jobTitle?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  portraitImage?: Maybe<Asset>;
};


/** [See type definition](https://app.contentful.com/spaces/0j0b0fue4dp9/content_types/personAccordionEntry) */
export type PersonAccordionEntryLinkedFromArgs = {
  allowedLocales?: Maybe<Array<Maybe<Scalars['String']>>>;
};


/** [See type definition](https://app.contentful.com/spaces/0j0b0fue4dp9/content_types/personAccordionEntry) */
export type PersonAccordionEntryFullNameArgs = {
  locale?: Maybe<Scalars['String']>;
};


/** [See type definition](https://app.contentful.com/spaces/0j0b0fue4dp9/content_types/personAccordionEntry) */
export type PersonAccordionEntryJobTitleArgs = {
  locale?: Maybe<Scalars['String']>;
};


/** [See type definition](https://app.contentful.com/spaces/0j0b0fue4dp9/content_types/personAccordionEntry) */
export type PersonAccordionEntryDescriptionArgs = {
  locale?: Maybe<Scalars['String']>;
};


/** [See type definition](https://app.contentful.com/spaces/0j0b0fue4dp9/content_types/personAccordionEntry) */
export type PersonAccordionEntryPortraitImageArgs = {
  preview?: Maybe<Scalars['Boolean']>;
  locale?: Maybe<Scalars['String']>;
};

export type PersonAccordionEntryLinkingCollections = {
  __typename?: 'PersonAccordionEntryLinkingCollections';
  entryCollection?: Maybe<EntryCollection>;
  blockHiddenWithConsentCollection?: Maybe<BlockHiddenWithConsentCollection>;
  blockPersonAccordionCollection?: Maybe<BlockPersonAccordionCollection>;
};


export type PersonAccordionEntryLinkingCollectionsEntryCollectionArgs = {
  skip?: Maybe<Scalars['Int']>;
  limit?: Maybe<Scalars['Int']>;
  preview?: Maybe<Scalars['Boolean']>;
  locale?: Maybe<Scalars['String']>;
};


export type PersonAccordionEntryLinkingCollectionsBlockHiddenWithConsentCollectionArgs = {
  skip?: Maybe<Scalars['Int']>;
  limit?: Maybe<Scalars['Int']>;
  preview?: Maybe<Scalars['Boolean']>;
  locale?: Maybe<Scalars['String']>;
  order?: Maybe<Array<Maybe<PersonAccordionEntryLinkingCollectionsBlockHiddenWithConsentCollectionOrder>>>;
};


export type PersonAccordionEntryLinkingCollectionsBlockPersonAccordionCollectionArgs = {
  skip?: Maybe<Scalars['Int']>;
  limit?: Maybe<Scalars['Int']>;
  preview?: Maybe<Scalars['Boolean']>;
  locale?: Maybe<Scalars['String']>;
  order?: Maybe<Array<Maybe<PersonAccordionEntryLinkingCollectionsBlockPersonAccordionCollectionOrder>>>;
};

export enum PersonAccordionEntryLinkingCollectionsBlockHiddenWithConsentCollectionOrder {
  ConsentTypeAsc = 'consentType_ASC',
  ConsentTypeDesc = 'consentType_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export type BlockPersonAccordionCollection = {
  __typename?: 'BlockPersonAccordionCollection';
  total: Scalars['Int'];
  skip: Scalars['Int'];
  limit: Scalars['Int'];
  items: Array<Maybe<BlockPersonAccordion>>;
};

export enum PersonAccordionEntryLinkingCollectionsBlockPersonAccordionCollectionOrder {
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export type PersonAccordionEntryFilter = {
  sys?: Maybe<SysFilter>;
  contentfulMetadata?: Maybe<ContentfulMetadataFilter>;
  fullName_exists?: Maybe<Scalars['Boolean']>;
  fullName?: Maybe<Scalars['String']>;
  fullName_not?: Maybe<Scalars['String']>;
  fullName_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  fullName_not_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  fullName_contains?: Maybe<Scalars['String']>;
  fullName_not_contains?: Maybe<Scalars['String']>;
  jobTitle_exists?: Maybe<Scalars['Boolean']>;
  jobTitle?: Maybe<Scalars['String']>;
  jobTitle_not?: Maybe<Scalars['String']>;
  jobTitle_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  jobTitle_not_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  jobTitle_contains?: Maybe<Scalars['String']>;
  jobTitle_not_contains?: Maybe<Scalars['String']>;
  description_exists?: Maybe<Scalars['Boolean']>;
  description?: Maybe<Scalars['String']>;
  description_not?: Maybe<Scalars['String']>;
  description_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  description_not_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  description_contains?: Maybe<Scalars['String']>;
  description_not_contains?: Maybe<Scalars['String']>;
  portraitImage_exists?: Maybe<Scalars['Boolean']>;
  OR?: Maybe<Array<Maybe<PersonAccordionEntryFilter>>>;
  AND?: Maybe<Array<Maybe<PersonAccordionEntryFilter>>>;
};

export enum BlockPersonAccordionPersonEntriesCollectionOrder {
  FullNameAsc = 'fullName_ASC',
  FullNameDesc = 'fullName_DESC',
  JobTitleAsc = 'jobTitle_ASC',
  JobTitleDesc = 'jobTitle_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

/** Oversized ribbon text [See type definition](https://app.contentful.com/spaces/0j0b0fue4dp9/content_types/blockRibbon) */
export type BlockRibbon = Entry & _Node & {
  __typename?: 'BlockRibbon';
  sys: Sys;
  contentfulMetadata: ContentfulMetadata;
  linkedFrom?: Maybe<BlockRibbonLinkingCollections>;
  _id: Scalars['ID'];
  heading1?: Maybe<Scalars['String']>;
  subheading1?: Maybe<Scalars['String']>;
  heading2?: Maybe<Scalars['String']>;
  subheading2?: Maybe<Scalars['String']>;
  heading3?: Maybe<Scalars['String']>;
  subheading3?: Maybe<Scalars['String']>;
  heading4?: Maybe<Scalars['String']>;
  subheading4?: Maybe<Scalars['String']>;
  overlayImage?: Maybe<Asset>;
  variant?: Maybe<Scalars['String']>;
};


/** Oversized ribbon text [See type definition](https://app.contentful.com/spaces/0j0b0fue4dp9/content_types/blockRibbon) */
export type BlockRibbonLinkedFromArgs = {
  allowedLocales?: Maybe<Array<Maybe<Scalars['String']>>>;
};


/** Oversized ribbon text [See type definition](https://app.contentful.com/spaces/0j0b0fue4dp9/content_types/blockRibbon) */
export type BlockRibbonHeading1Args = {
  locale?: Maybe<Scalars['String']>;
};


/** Oversized ribbon text [See type definition](https://app.contentful.com/spaces/0j0b0fue4dp9/content_types/blockRibbon) */
export type BlockRibbonSubheading1Args = {
  locale?: Maybe<Scalars['String']>;
};


/** Oversized ribbon text [See type definition](https://app.contentful.com/spaces/0j0b0fue4dp9/content_types/blockRibbon) */
export type BlockRibbonHeading2Args = {
  locale?: Maybe<Scalars['String']>;
};


/** Oversized ribbon text [See type definition](https://app.contentful.com/spaces/0j0b0fue4dp9/content_types/blockRibbon) */
export type BlockRibbonSubheading2Args = {
  locale?: Maybe<Scalars['String']>;
};


/** Oversized ribbon text [See type definition](https://app.contentful.com/spaces/0j0b0fue4dp9/content_types/blockRibbon) */
export type BlockRibbonHeading3Args = {
  locale?: Maybe<Scalars['String']>;
};


/** Oversized ribbon text [See type definition](https://app.contentful.com/spaces/0j0b0fue4dp9/content_types/blockRibbon) */
export type BlockRibbonSubheading3Args = {
  locale?: Maybe<Scalars['String']>;
};


/** Oversized ribbon text [See type definition](https://app.contentful.com/spaces/0j0b0fue4dp9/content_types/blockRibbon) */
export type BlockRibbonHeading4Args = {
  locale?: Maybe<Scalars['String']>;
};


/** Oversized ribbon text [See type definition](https://app.contentful.com/spaces/0j0b0fue4dp9/content_types/blockRibbon) */
export type BlockRibbonSubheading4Args = {
  locale?: Maybe<Scalars['String']>;
};


/** Oversized ribbon text [See type definition](https://app.contentful.com/spaces/0j0b0fue4dp9/content_types/blockRibbon) */
export type BlockRibbonOverlayImageArgs = {
  preview?: Maybe<Scalars['Boolean']>;
  locale?: Maybe<Scalars['String']>;
};


/** Oversized ribbon text [See type definition](https://app.contentful.com/spaces/0j0b0fue4dp9/content_types/blockRibbon) */
export type BlockRibbonVariantArgs = {
  locale?: Maybe<Scalars['String']>;
};

export type BlockRibbonLinkingCollections = {
  __typename?: 'BlockRibbonLinkingCollections';
  entryCollection?: Maybe<EntryCollection>;
  staticPageCollection?: Maybe<StaticPageCollection>;
  blockHiddenWithConsentCollection?: Maybe<BlockHiddenWithConsentCollection>;
  blockOneColumnCollection?: Maybe<BlockOneColumnCollection>;
  projectPageCollection?: Maybe<ProjectPageCollection>;
};


export type BlockRibbonLinkingCollectionsEntryCollectionArgs = {
  skip?: Maybe<Scalars['Int']>;
  limit?: Maybe<Scalars['Int']>;
  preview?: Maybe<Scalars['Boolean']>;
  locale?: Maybe<Scalars['String']>;
};


export type BlockRibbonLinkingCollectionsStaticPageCollectionArgs = {
  skip?: Maybe<Scalars['Int']>;
  limit?: Maybe<Scalars['Int']>;
  preview?: Maybe<Scalars['Boolean']>;
  locale?: Maybe<Scalars['String']>;
  order?: Maybe<Array<Maybe<BlockRibbonLinkingCollectionsStaticPageCollectionOrder>>>;
};


export type BlockRibbonLinkingCollectionsBlockHiddenWithConsentCollectionArgs = {
  skip?: Maybe<Scalars['Int']>;
  limit?: Maybe<Scalars['Int']>;
  preview?: Maybe<Scalars['Boolean']>;
  locale?: Maybe<Scalars['String']>;
  order?: Maybe<Array<Maybe<BlockRibbonLinkingCollectionsBlockHiddenWithConsentCollectionOrder>>>;
};


export type BlockRibbonLinkingCollectionsBlockOneColumnCollectionArgs = {
  skip?: Maybe<Scalars['Int']>;
  limit?: Maybe<Scalars['Int']>;
  preview?: Maybe<Scalars['Boolean']>;
  locale?: Maybe<Scalars['String']>;
  order?: Maybe<Array<Maybe<BlockRibbonLinkingCollectionsBlockOneColumnCollectionOrder>>>;
};


export type BlockRibbonLinkingCollectionsProjectPageCollectionArgs = {
  skip?: Maybe<Scalars['Int']>;
  limit?: Maybe<Scalars['Int']>;
  preview?: Maybe<Scalars['Boolean']>;
  locale?: Maybe<Scalars['String']>;
  order?: Maybe<Array<Maybe<BlockRibbonLinkingCollectionsProjectPageCollectionOrder>>>;
};

export enum BlockRibbonLinkingCollectionsStaticPageCollectionOrder {
  PageTitleAsc = 'pageTitle_ASC',
  PageTitleDesc = 'pageTitle_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  StandaloneAsc = 'standalone_ASC',
  StandaloneDesc = 'standalone_DESC',
  ShowNewsletterFooterAsc = 'showNewsletterFooter_ASC',
  ShowNewsletterFooterDesc = 'showNewsletterFooter_DESC',
  ShowContactFooterAsc = 'showContactFooter_ASC',
  ShowContactFooterDesc = 'showContactFooter_DESC',
  PageTagAsc = 'pageTag_ASC',
  PageTagDesc = 'pageTag_DESC',
  NewsTypeAsc = 'newsType_ASC',
  NewsTypeDesc = 'newsType_DESC',
  RemovePaddingBottomAsc = 'removePaddingBottom_ASC',
  RemovePaddingBottomDesc = 'removePaddingBottom_DESC',
  RegionAsc = 'region_ASC',
  RegionDesc = 'region_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum BlockRibbonLinkingCollectionsBlockHiddenWithConsentCollectionOrder {
  ConsentTypeAsc = 'consentType_ASC',
  ConsentTypeDesc = 'consentType_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum BlockRibbonLinkingCollectionsBlockOneColumnCollectionOrder {
  InternalDescriptionAsc = 'internalDescription_ASC',
  InternalDescriptionDesc = 'internalDescription_DESC',
  EnableBlackBackgroundAsc = 'enableBlackBackground_ASC',
  EnableBlackBackgroundDesc = 'enableBlackBackground_DESC',
  SmallMainColumnOverImageAsc = 'smallMainColumnOverImage_ASC',
  SmallMainColumnOverImageDesc = 'smallMainColumnOverImage_DESC',
  BackgroundColorAsc = 'backgroundColor_ASC',
  BackgroundColorDesc = 'backgroundColor_DESC',
  PaddingAsc = 'padding_ASC',
  PaddingDesc = 'padding_DESC',
  WithExtraPaddingAsc = 'withExtraPadding_ASC',
  WithExtraPaddingDesc = 'withExtraPadding_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum BlockRibbonLinkingCollectionsProjectPageCollectionOrder {
  InternalNameAsc = 'internal_name_ASC',
  InternalNameDesc = 'internal_name_DESC',
  PropstackProjectIdAsc = 'propstackProjectId_ASC',
  PropstackProjectIdDesc = 'propstackProjectId_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

/** [See type definition](https://app.contentful.com/spaces/0j0b0fue4dp9/content_types/blockTable) */
export type BlockTable = Entry & _Node & {
  __typename?: 'BlockTable';
  sys: Sys;
  contentfulMetadata: ContentfulMetadata;
  linkedFrom?: Maybe<BlockTableLinkingCollections>;
  _id: Scalars['ID'];
  title?: Maybe<Scalars['String']>;
  table?: Maybe<Scalars['JSON']>;
  variant?: Maybe<Scalars['String']>;
};


/** [See type definition](https://app.contentful.com/spaces/0j0b0fue4dp9/content_types/blockTable) */
export type BlockTableLinkedFromArgs = {
  allowedLocales?: Maybe<Array<Maybe<Scalars['String']>>>;
};


/** [See type definition](https://app.contentful.com/spaces/0j0b0fue4dp9/content_types/blockTable) */
export type BlockTableTitleArgs = {
  locale?: Maybe<Scalars['String']>;
};


/** [See type definition](https://app.contentful.com/spaces/0j0b0fue4dp9/content_types/blockTable) */
export type BlockTableTableArgs = {
  locale?: Maybe<Scalars['String']>;
};


/** [See type definition](https://app.contentful.com/spaces/0j0b0fue4dp9/content_types/blockTable) */
export type BlockTableVariantArgs = {
  locale?: Maybe<Scalars['String']>;
};

export type BlockTableLinkingCollections = {
  __typename?: 'BlockTableLinkingCollections';
  entryCollection?: Maybe<EntryCollection>;
  staticPageCollection?: Maybe<StaticPageCollection>;
  blockHiddenWithConsentCollection?: Maybe<BlockHiddenWithConsentCollection>;
  blockOneColumnCollection?: Maybe<BlockOneColumnCollection>;
  blockAccordionEntryCollection?: Maybe<BlockAccordionEntryCollection>;
  newsArticleCollection?: Maybe<NewsArticleCollection>;
  projectPageCollection?: Maybe<ProjectPageCollection>;
};


export type BlockTableLinkingCollectionsEntryCollectionArgs = {
  skip?: Maybe<Scalars['Int']>;
  limit?: Maybe<Scalars['Int']>;
  preview?: Maybe<Scalars['Boolean']>;
  locale?: Maybe<Scalars['String']>;
};


export type BlockTableLinkingCollectionsStaticPageCollectionArgs = {
  skip?: Maybe<Scalars['Int']>;
  limit?: Maybe<Scalars['Int']>;
  preview?: Maybe<Scalars['Boolean']>;
  locale?: Maybe<Scalars['String']>;
  order?: Maybe<Array<Maybe<BlockTableLinkingCollectionsStaticPageCollectionOrder>>>;
};


export type BlockTableLinkingCollectionsBlockHiddenWithConsentCollectionArgs = {
  skip?: Maybe<Scalars['Int']>;
  limit?: Maybe<Scalars['Int']>;
  preview?: Maybe<Scalars['Boolean']>;
  locale?: Maybe<Scalars['String']>;
  order?: Maybe<Array<Maybe<BlockTableLinkingCollectionsBlockHiddenWithConsentCollectionOrder>>>;
};


export type BlockTableLinkingCollectionsBlockOneColumnCollectionArgs = {
  skip?: Maybe<Scalars['Int']>;
  limit?: Maybe<Scalars['Int']>;
  preview?: Maybe<Scalars['Boolean']>;
  locale?: Maybe<Scalars['String']>;
  order?: Maybe<Array<Maybe<BlockTableLinkingCollectionsBlockOneColumnCollectionOrder>>>;
};


export type BlockTableLinkingCollectionsBlockAccordionEntryCollectionArgs = {
  skip?: Maybe<Scalars['Int']>;
  limit?: Maybe<Scalars['Int']>;
  preview?: Maybe<Scalars['Boolean']>;
  locale?: Maybe<Scalars['String']>;
  order?: Maybe<Array<Maybe<BlockTableLinkingCollectionsBlockAccordionEntryCollectionOrder>>>;
};


export type BlockTableLinkingCollectionsNewsArticleCollectionArgs = {
  skip?: Maybe<Scalars['Int']>;
  limit?: Maybe<Scalars['Int']>;
  preview?: Maybe<Scalars['Boolean']>;
  locale?: Maybe<Scalars['String']>;
  order?: Maybe<Array<Maybe<BlockTableLinkingCollectionsNewsArticleCollectionOrder>>>;
};


export type BlockTableLinkingCollectionsProjectPageCollectionArgs = {
  skip?: Maybe<Scalars['Int']>;
  limit?: Maybe<Scalars['Int']>;
  preview?: Maybe<Scalars['Boolean']>;
  locale?: Maybe<Scalars['String']>;
  order?: Maybe<Array<Maybe<BlockTableLinkingCollectionsProjectPageCollectionOrder>>>;
};

export enum BlockTableLinkingCollectionsStaticPageCollectionOrder {
  PageTitleAsc = 'pageTitle_ASC',
  PageTitleDesc = 'pageTitle_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  StandaloneAsc = 'standalone_ASC',
  StandaloneDesc = 'standalone_DESC',
  ShowNewsletterFooterAsc = 'showNewsletterFooter_ASC',
  ShowNewsletterFooterDesc = 'showNewsletterFooter_DESC',
  ShowContactFooterAsc = 'showContactFooter_ASC',
  ShowContactFooterDesc = 'showContactFooter_DESC',
  PageTagAsc = 'pageTag_ASC',
  PageTagDesc = 'pageTag_DESC',
  NewsTypeAsc = 'newsType_ASC',
  NewsTypeDesc = 'newsType_DESC',
  RemovePaddingBottomAsc = 'removePaddingBottom_ASC',
  RemovePaddingBottomDesc = 'removePaddingBottom_DESC',
  RegionAsc = 'region_ASC',
  RegionDesc = 'region_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum BlockTableLinkingCollectionsBlockHiddenWithConsentCollectionOrder {
  ConsentTypeAsc = 'consentType_ASC',
  ConsentTypeDesc = 'consentType_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum BlockTableLinkingCollectionsBlockOneColumnCollectionOrder {
  InternalDescriptionAsc = 'internalDescription_ASC',
  InternalDescriptionDesc = 'internalDescription_DESC',
  EnableBlackBackgroundAsc = 'enableBlackBackground_ASC',
  EnableBlackBackgroundDesc = 'enableBlackBackground_DESC',
  SmallMainColumnOverImageAsc = 'smallMainColumnOverImage_ASC',
  SmallMainColumnOverImageDesc = 'smallMainColumnOverImage_DESC',
  BackgroundColorAsc = 'backgroundColor_ASC',
  BackgroundColorDesc = 'backgroundColor_DESC',
  PaddingAsc = 'padding_ASC',
  PaddingDesc = 'padding_DESC',
  WithExtraPaddingAsc = 'withExtraPadding_ASC',
  WithExtraPaddingDesc = 'withExtraPadding_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum BlockTableLinkingCollectionsBlockAccordionEntryCollectionOrder {
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC',
  TitleWhenExpandedAsc = 'titleWhenExpanded_ASC',
  TitleWhenExpandedDesc = 'titleWhenExpanded_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum BlockTableLinkingCollectionsNewsArticleCollectionOrder {
  NewsTypeAsc = 'newsType_ASC',
  NewsTypeDesc = 'newsType_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  DateAsc = 'date_ASC',
  DateDesc = 'date_DESC',
  HideDateAsc = 'hideDate_ASC',
  HideDateDesc = 'hideDate_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum BlockTableLinkingCollectionsProjectPageCollectionOrder {
  InternalNameAsc = 'internal_name_ASC',
  InternalNameDesc = 'internal_name_DESC',
  PropstackProjectIdAsc = 'propstackProjectId_ASC',
  PropstackProjectIdDesc = 'propstackProjectId_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

/** [See type definition](https://app.contentful.com/spaces/0j0b0fue4dp9/content_types/blockThreeColumn) */
export type BlockThreeColumn = Entry & _Node & {
  __typename?: 'BlockThreeColumn';
  sys: Sys;
  contentfulMetadata: ContentfulMetadata;
  linkedFrom?: Maybe<BlockThreeColumnLinkingCollections>;
  _id: Scalars['ID'];
  internalDescription?: Maybe<Scalars['String']>;
  leftColumnCollection?: Maybe<BlockThreeColumnLeftColumnCollection>;
  middleColumnCollection?: Maybe<BlockThreeColumnMiddleColumnCollection>;
  rightColumnCollection?: Maybe<BlockThreeColumnRightColumnCollection>;
};


/** [See type definition](https://app.contentful.com/spaces/0j0b0fue4dp9/content_types/blockThreeColumn) */
export type BlockThreeColumnLinkedFromArgs = {
  allowedLocales?: Maybe<Array<Maybe<Scalars['String']>>>;
};


/** [See type definition](https://app.contentful.com/spaces/0j0b0fue4dp9/content_types/blockThreeColumn) */
export type BlockThreeColumnInternalDescriptionArgs = {
  locale?: Maybe<Scalars['String']>;
};


/** [See type definition](https://app.contentful.com/spaces/0j0b0fue4dp9/content_types/blockThreeColumn) */
export type BlockThreeColumnLeftColumnCollectionArgs = {
  skip?: Maybe<Scalars['Int']>;
  limit?: Maybe<Scalars['Int']>;
  preview?: Maybe<Scalars['Boolean']>;
  locale?: Maybe<Scalars['String']>;
};


/** [See type definition](https://app.contentful.com/spaces/0j0b0fue4dp9/content_types/blockThreeColumn) */
export type BlockThreeColumnMiddleColumnCollectionArgs = {
  skip?: Maybe<Scalars['Int']>;
  limit?: Maybe<Scalars['Int']>;
  preview?: Maybe<Scalars['Boolean']>;
  locale?: Maybe<Scalars['String']>;
};


/** [See type definition](https://app.contentful.com/spaces/0j0b0fue4dp9/content_types/blockThreeColumn) */
export type BlockThreeColumnRightColumnCollectionArgs = {
  skip?: Maybe<Scalars['Int']>;
  limit?: Maybe<Scalars['Int']>;
  preview?: Maybe<Scalars['Boolean']>;
  locale?: Maybe<Scalars['String']>;
};

export type BlockThreeColumnLinkingCollections = {
  __typename?: 'BlockThreeColumnLinkingCollections';
  entryCollection?: Maybe<EntryCollection>;
  staticPageCollection?: Maybe<StaticPageCollection>;
  blockHiddenWithConsentCollection?: Maybe<BlockHiddenWithConsentCollection>;
  blockOneColumnCollection?: Maybe<BlockOneColumnCollection>;
  projectPageCollection?: Maybe<ProjectPageCollection>;
};


export type BlockThreeColumnLinkingCollectionsEntryCollectionArgs = {
  skip?: Maybe<Scalars['Int']>;
  limit?: Maybe<Scalars['Int']>;
  preview?: Maybe<Scalars['Boolean']>;
  locale?: Maybe<Scalars['String']>;
};


export type BlockThreeColumnLinkingCollectionsStaticPageCollectionArgs = {
  skip?: Maybe<Scalars['Int']>;
  limit?: Maybe<Scalars['Int']>;
  preview?: Maybe<Scalars['Boolean']>;
  locale?: Maybe<Scalars['String']>;
  order?: Maybe<Array<Maybe<BlockThreeColumnLinkingCollectionsStaticPageCollectionOrder>>>;
};


export type BlockThreeColumnLinkingCollectionsBlockHiddenWithConsentCollectionArgs = {
  skip?: Maybe<Scalars['Int']>;
  limit?: Maybe<Scalars['Int']>;
  preview?: Maybe<Scalars['Boolean']>;
  locale?: Maybe<Scalars['String']>;
  order?: Maybe<Array<Maybe<BlockThreeColumnLinkingCollectionsBlockHiddenWithConsentCollectionOrder>>>;
};


export type BlockThreeColumnLinkingCollectionsBlockOneColumnCollectionArgs = {
  skip?: Maybe<Scalars['Int']>;
  limit?: Maybe<Scalars['Int']>;
  preview?: Maybe<Scalars['Boolean']>;
  locale?: Maybe<Scalars['String']>;
  order?: Maybe<Array<Maybe<BlockThreeColumnLinkingCollectionsBlockOneColumnCollectionOrder>>>;
};


export type BlockThreeColumnLinkingCollectionsProjectPageCollectionArgs = {
  skip?: Maybe<Scalars['Int']>;
  limit?: Maybe<Scalars['Int']>;
  preview?: Maybe<Scalars['Boolean']>;
  locale?: Maybe<Scalars['String']>;
  order?: Maybe<Array<Maybe<BlockThreeColumnLinkingCollectionsProjectPageCollectionOrder>>>;
};

export enum BlockThreeColumnLinkingCollectionsStaticPageCollectionOrder {
  PageTitleAsc = 'pageTitle_ASC',
  PageTitleDesc = 'pageTitle_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  StandaloneAsc = 'standalone_ASC',
  StandaloneDesc = 'standalone_DESC',
  ShowNewsletterFooterAsc = 'showNewsletterFooter_ASC',
  ShowNewsletterFooterDesc = 'showNewsletterFooter_DESC',
  ShowContactFooterAsc = 'showContactFooter_ASC',
  ShowContactFooterDesc = 'showContactFooter_DESC',
  PageTagAsc = 'pageTag_ASC',
  PageTagDesc = 'pageTag_DESC',
  NewsTypeAsc = 'newsType_ASC',
  NewsTypeDesc = 'newsType_DESC',
  RemovePaddingBottomAsc = 'removePaddingBottom_ASC',
  RemovePaddingBottomDesc = 'removePaddingBottom_DESC',
  RegionAsc = 'region_ASC',
  RegionDesc = 'region_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum BlockThreeColumnLinkingCollectionsBlockHiddenWithConsentCollectionOrder {
  ConsentTypeAsc = 'consentType_ASC',
  ConsentTypeDesc = 'consentType_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum BlockThreeColumnLinkingCollectionsBlockOneColumnCollectionOrder {
  InternalDescriptionAsc = 'internalDescription_ASC',
  InternalDescriptionDesc = 'internalDescription_DESC',
  EnableBlackBackgroundAsc = 'enableBlackBackground_ASC',
  EnableBlackBackgroundDesc = 'enableBlackBackground_DESC',
  SmallMainColumnOverImageAsc = 'smallMainColumnOverImage_ASC',
  SmallMainColumnOverImageDesc = 'smallMainColumnOverImage_DESC',
  BackgroundColorAsc = 'backgroundColor_ASC',
  BackgroundColorDesc = 'backgroundColor_DESC',
  PaddingAsc = 'padding_ASC',
  PaddingDesc = 'padding_DESC',
  WithExtraPaddingAsc = 'withExtraPadding_ASC',
  WithExtraPaddingDesc = 'withExtraPadding_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum BlockThreeColumnLinkingCollectionsProjectPageCollectionOrder {
  InternalNameAsc = 'internal_name_ASC',
  InternalNameDesc = 'internal_name_DESC',
  PropstackProjectIdAsc = 'propstackProjectId_ASC',
  PropstackProjectIdDesc = 'propstackProjectId_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export type BlockThreeColumnLeftColumnCollection = {
  __typename?: 'BlockThreeColumnLeftColumnCollection';
  total: Scalars['Int'];
  skip: Scalars['Int'];
  limit: Scalars['Int'];
  items: Array<Maybe<Entry>>;
};

export type BlockThreeColumnMiddleColumnCollection = {
  __typename?: 'BlockThreeColumnMiddleColumnCollection';
  total: Scalars['Int'];
  skip: Scalars['Int'];
  limit: Scalars['Int'];
  items: Array<Maybe<Entry>>;
};

export type BlockThreeColumnRightColumnCollection = {
  __typename?: 'BlockThreeColumnRightColumnCollection';
  total: Scalars['Int'];
  skip: Scalars['Int'];
  limit: Scalars['Int'];
  items: Array<Maybe<Entry>>;
};

/** Displays a video component for a given youtube link [See type definition](https://app.contentful.com/spaces/0j0b0fue4dp9/content_types/blockVideo) */
export type BlockVideo = Entry & _Node & {
  __typename?: 'BlockVideo';
  sys: Sys;
  contentfulMetadata: ContentfulMetadata;
  linkedFrom?: Maybe<BlockVideoLinkingCollections>;
  _id: Scalars['ID'];
  internalName?: Maybe<Scalars['String']>;
  headline?: Maybe<Scalars['String']>;
  href?: Maybe<Scalars['String']>;
};


/** Displays a video component for a given youtube link [See type definition](https://app.contentful.com/spaces/0j0b0fue4dp9/content_types/blockVideo) */
export type BlockVideoLinkedFromArgs = {
  allowedLocales?: Maybe<Array<Maybe<Scalars['String']>>>;
};


/** Displays a video component for a given youtube link [See type definition](https://app.contentful.com/spaces/0j0b0fue4dp9/content_types/blockVideo) */
export type BlockVideoInternalNameArgs = {
  locale?: Maybe<Scalars['String']>;
};


/** Displays a video component for a given youtube link [See type definition](https://app.contentful.com/spaces/0j0b0fue4dp9/content_types/blockVideo) */
export type BlockVideoHeadlineArgs = {
  locale?: Maybe<Scalars['String']>;
};


/** Displays a video component for a given youtube link [See type definition](https://app.contentful.com/spaces/0j0b0fue4dp9/content_types/blockVideo) */
export type BlockVideoHrefArgs = {
  locale?: Maybe<Scalars['String']>;
};

export type BlockVideoLinkingCollections = {
  __typename?: 'BlockVideoLinkingCollections';
  entryCollection?: Maybe<EntryCollection>;
  staticPageCollection?: Maybe<StaticPageCollection>;
  blockHiddenWithConsentCollection?: Maybe<BlockHiddenWithConsentCollection>;
  blockOneColumnCollection?: Maybe<BlockOneColumnCollection>;
  projectPageCollection?: Maybe<ProjectPageCollection>;
};


export type BlockVideoLinkingCollectionsEntryCollectionArgs = {
  skip?: Maybe<Scalars['Int']>;
  limit?: Maybe<Scalars['Int']>;
  preview?: Maybe<Scalars['Boolean']>;
  locale?: Maybe<Scalars['String']>;
};


export type BlockVideoLinkingCollectionsStaticPageCollectionArgs = {
  skip?: Maybe<Scalars['Int']>;
  limit?: Maybe<Scalars['Int']>;
  preview?: Maybe<Scalars['Boolean']>;
  locale?: Maybe<Scalars['String']>;
  order?: Maybe<Array<Maybe<BlockVideoLinkingCollectionsStaticPageCollectionOrder>>>;
};


export type BlockVideoLinkingCollectionsBlockHiddenWithConsentCollectionArgs = {
  skip?: Maybe<Scalars['Int']>;
  limit?: Maybe<Scalars['Int']>;
  preview?: Maybe<Scalars['Boolean']>;
  locale?: Maybe<Scalars['String']>;
  order?: Maybe<Array<Maybe<BlockVideoLinkingCollectionsBlockHiddenWithConsentCollectionOrder>>>;
};


export type BlockVideoLinkingCollectionsBlockOneColumnCollectionArgs = {
  skip?: Maybe<Scalars['Int']>;
  limit?: Maybe<Scalars['Int']>;
  preview?: Maybe<Scalars['Boolean']>;
  locale?: Maybe<Scalars['String']>;
  order?: Maybe<Array<Maybe<BlockVideoLinkingCollectionsBlockOneColumnCollectionOrder>>>;
};


export type BlockVideoLinkingCollectionsProjectPageCollectionArgs = {
  skip?: Maybe<Scalars['Int']>;
  limit?: Maybe<Scalars['Int']>;
  preview?: Maybe<Scalars['Boolean']>;
  locale?: Maybe<Scalars['String']>;
  order?: Maybe<Array<Maybe<BlockVideoLinkingCollectionsProjectPageCollectionOrder>>>;
};

export enum BlockVideoLinkingCollectionsStaticPageCollectionOrder {
  PageTitleAsc = 'pageTitle_ASC',
  PageTitleDesc = 'pageTitle_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  StandaloneAsc = 'standalone_ASC',
  StandaloneDesc = 'standalone_DESC',
  ShowNewsletterFooterAsc = 'showNewsletterFooter_ASC',
  ShowNewsletterFooterDesc = 'showNewsletterFooter_DESC',
  ShowContactFooterAsc = 'showContactFooter_ASC',
  ShowContactFooterDesc = 'showContactFooter_DESC',
  PageTagAsc = 'pageTag_ASC',
  PageTagDesc = 'pageTag_DESC',
  NewsTypeAsc = 'newsType_ASC',
  NewsTypeDesc = 'newsType_DESC',
  RemovePaddingBottomAsc = 'removePaddingBottom_ASC',
  RemovePaddingBottomDesc = 'removePaddingBottom_DESC',
  RegionAsc = 'region_ASC',
  RegionDesc = 'region_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum BlockVideoLinkingCollectionsBlockHiddenWithConsentCollectionOrder {
  ConsentTypeAsc = 'consentType_ASC',
  ConsentTypeDesc = 'consentType_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum BlockVideoLinkingCollectionsBlockOneColumnCollectionOrder {
  InternalDescriptionAsc = 'internalDescription_ASC',
  InternalDescriptionDesc = 'internalDescription_DESC',
  EnableBlackBackgroundAsc = 'enableBlackBackground_ASC',
  EnableBlackBackgroundDesc = 'enableBlackBackground_DESC',
  SmallMainColumnOverImageAsc = 'smallMainColumnOverImage_ASC',
  SmallMainColumnOverImageDesc = 'smallMainColumnOverImage_DESC',
  BackgroundColorAsc = 'backgroundColor_ASC',
  BackgroundColorDesc = 'backgroundColor_DESC',
  PaddingAsc = 'padding_ASC',
  PaddingDesc = 'padding_DESC',
  WithExtraPaddingAsc = 'withExtraPadding_ASC',
  WithExtraPaddingDesc = 'withExtraPadding_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum BlockVideoLinkingCollectionsProjectPageCollectionOrder {
  InternalNameAsc = 'internal_name_ASC',
  InternalNameDesc = 'internal_name_DESC',
  PropstackProjectIdAsc = 'propstackProjectId_ASC',
  PropstackProjectIdDesc = 'propstackProjectId_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export type ProjectPageBlocksBelowImagesFilter = {
  sys?: Maybe<SysFilter>;
  contentfulMetadata?: Maybe<ContentfulMetadataFilter>;
  OR?: Maybe<Array<Maybe<ProjectPageBlocksBelowImagesFilter>>>;
  AND?: Maybe<Array<Maybe<ProjectPageBlocksBelowImagesFilter>>>;
};

export enum BlockRichTextLinkingCollectionsProjectPageCollectionOrder {
  InternalNameAsc = 'internal_name_ASC',
  InternalNameDesc = 'internal_name_DESC',
  PropstackProjectIdAsc = 'propstackProjectId_ASC',
  PropstackProjectIdDesc = 'propstackProjectId_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export type BlockRichTextRichText = {
  __typename?: 'BlockRichTextRichText';
  json: Scalars['JSON'];
  links: BlockRichTextRichTextLinks;
};

export type BlockRichTextRichTextLinks = {
  __typename?: 'BlockRichTextRichTextLinks';
  entries: BlockRichTextRichTextEntries;
  assets: BlockRichTextRichTextAssets;
  resources: BlockRichTextRichTextResources;
};

export type BlockRichTextRichTextEntries = {
  __typename?: 'BlockRichTextRichTextEntries';
  inline: Array<Maybe<Entry>>;
  hyperlink: Array<Maybe<Entry>>;
  block: Array<Maybe<Entry>>;
};

export type BlockRichTextRichTextAssets = {
  __typename?: 'BlockRichTextRichTextAssets';
  hyperlink: Array<Maybe<Asset>>;
  block: Array<Maybe<Asset>>;
};

export type BlockRichTextRichTextResources = {
  __typename?: 'BlockRichTextRichTextResources';
  block: Array<BlockRichTextRichTextResourcesBlock>;
  inline: Array<BlockRichTextRichTextResourcesInline>;
  hyperlink: Array<BlockRichTextRichTextResourcesHyperlink>;
};

export type BlockRichTextRichTextResourcesBlock = ResourceLink & {
  __typename?: 'BlockRichTextRichTextResourcesBlock';
  sys: ResourceSys;
};

export type ResourceLink = {
  sys: ResourceSys;
};

export type ResourceSys = {
  __typename?: 'ResourceSys';
  urn: Scalars['String'];
  linkType: Scalars['String'];
};

export type BlockRichTextRichTextResourcesInline = ResourceLink & {
  __typename?: 'BlockRichTextRichTextResourcesInline';
  sys: ResourceSys;
};

export type BlockRichTextRichTextResourcesHyperlink = ResourceLink & {
  __typename?: 'BlockRichTextRichTextResourcesHyperlink';
  sys: ResourceSys;
};

export type NewsArticleBlocksFilter = {
  sys?: Maybe<SysFilter>;
  contentfulMetadata?: Maybe<ContentfulMetadataFilter>;
  OR?: Maybe<Array<Maybe<NewsArticleBlocksFilter>>>;
  AND?: Maybe<Array<Maybe<NewsArticleBlocksFilter>>>;
};

export type NewsArticleContactsCollection = {
  __typename?: 'NewsArticleContactsCollection';
  total: Scalars['Int'];
  skip: Scalars['Int'];
  limit: Scalars['Int'];
  items: Array<Maybe<NewsArticleContact>>;
};

/** Contact person displayed underneath new articles [See type definition](https://app.contentful.com/spaces/0j0b0fue4dp9/content_types/newsArticleContact) */
export type NewsArticleContact = Entry & _Node & {
  __typename?: 'NewsArticleContact';
  sys: Sys;
  contentfulMetadata: ContentfulMetadata;
  linkedFrom?: Maybe<NewsArticleContactLinkingCollections>;
  _id: Scalars['ID'];
  title?: Maybe<Scalars['String']>;
  fullName?: Maybe<Scalars['String']>;
  company?: Maybe<Scalars['String']>;
  street?: Maybe<Scalars['String']>;
  postcode?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  telefon?: Maybe<Scalars['String']>;
};


/** Contact person displayed underneath new articles [See type definition](https://app.contentful.com/spaces/0j0b0fue4dp9/content_types/newsArticleContact) */
export type NewsArticleContactLinkedFromArgs = {
  allowedLocales?: Maybe<Array<Maybe<Scalars['String']>>>;
};


/** Contact person displayed underneath new articles [See type definition](https://app.contentful.com/spaces/0j0b0fue4dp9/content_types/newsArticleContact) */
export type NewsArticleContactTitleArgs = {
  locale?: Maybe<Scalars['String']>;
};


/** Contact person displayed underneath new articles [See type definition](https://app.contentful.com/spaces/0j0b0fue4dp9/content_types/newsArticleContact) */
export type NewsArticleContactFullNameArgs = {
  locale?: Maybe<Scalars['String']>;
};


/** Contact person displayed underneath new articles [See type definition](https://app.contentful.com/spaces/0j0b0fue4dp9/content_types/newsArticleContact) */
export type NewsArticleContactCompanyArgs = {
  locale?: Maybe<Scalars['String']>;
};


/** Contact person displayed underneath new articles [See type definition](https://app.contentful.com/spaces/0j0b0fue4dp9/content_types/newsArticleContact) */
export type NewsArticleContactStreetArgs = {
  locale?: Maybe<Scalars['String']>;
};


/** Contact person displayed underneath new articles [See type definition](https://app.contentful.com/spaces/0j0b0fue4dp9/content_types/newsArticleContact) */
export type NewsArticleContactPostcodeArgs = {
  locale?: Maybe<Scalars['String']>;
};


/** Contact person displayed underneath new articles [See type definition](https://app.contentful.com/spaces/0j0b0fue4dp9/content_types/newsArticleContact) */
export type NewsArticleContactEmailArgs = {
  locale?: Maybe<Scalars['String']>;
};


/** Contact person displayed underneath new articles [See type definition](https://app.contentful.com/spaces/0j0b0fue4dp9/content_types/newsArticleContact) */
export type NewsArticleContactTelefonArgs = {
  locale?: Maybe<Scalars['String']>;
};

export type NewsArticleContactLinkingCollections = {
  __typename?: 'NewsArticleContactLinkingCollections';
  entryCollection?: Maybe<EntryCollection>;
  newsArticleCollection?: Maybe<NewsArticleCollection>;
};


export type NewsArticleContactLinkingCollectionsEntryCollectionArgs = {
  skip?: Maybe<Scalars['Int']>;
  limit?: Maybe<Scalars['Int']>;
  preview?: Maybe<Scalars['Boolean']>;
  locale?: Maybe<Scalars['String']>;
};


export type NewsArticleContactLinkingCollectionsNewsArticleCollectionArgs = {
  skip?: Maybe<Scalars['Int']>;
  limit?: Maybe<Scalars['Int']>;
  preview?: Maybe<Scalars['Boolean']>;
  locale?: Maybe<Scalars['String']>;
  order?: Maybe<Array<Maybe<NewsArticleContactLinkingCollectionsNewsArticleCollectionOrder>>>;
};

export enum NewsArticleContactLinkingCollectionsNewsArticleCollectionOrder {
  NewsTypeAsc = 'newsType_ASC',
  NewsTypeDesc = 'newsType_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  DateAsc = 'date_ASC',
  DateDesc = 'date_DESC',
  HideDateAsc = 'hideDate_ASC',
  HideDateDesc = 'hideDate_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export type NewsArticleContactFilter = {
  sys?: Maybe<SysFilter>;
  contentfulMetadata?: Maybe<ContentfulMetadataFilter>;
  title_exists?: Maybe<Scalars['Boolean']>;
  title?: Maybe<Scalars['String']>;
  title_not?: Maybe<Scalars['String']>;
  title_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  title_not_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  title_contains?: Maybe<Scalars['String']>;
  title_not_contains?: Maybe<Scalars['String']>;
  fullName_exists?: Maybe<Scalars['Boolean']>;
  fullName?: Maybe<Scalars['String']>;
  fullName_not?: Maybe<Scalars['String']>;
  fullName_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  fullName_not_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  fullName_contains?: Maybe<Scalars['String']>;
  fullName_not_contains?: Maybe<Scalars['String']>;
  company_exists?: Maybe<Scalars['Boolean']>;
  company?: Maybe<Scalars['String']>;
  company_not?: Maybe<Scalars['String']>;
  company_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  company_not_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  company_contains?: Maybe<Scalars['String']>;
  company_not_contains?: Maybe<Scalars['String']>;
  street_exists?: Maybe<Scalars['Boolean']>;
  street?: Maybe<Scalars['String']>;
  street_not?: Maybe<Scalars['String']>;
  street_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  street_not_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  street_contains?: Maybe<Scalars['String']>;
  street_not_contains?: Maybe<Scalars['String']>;
  postcode_exists?: Maybe<Scalars['Boolean']>;
  postcode?: Maybe<Scalars['String']>;
  postcode_not?: Maybe<Scalars['String']>;
  postcode_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  postcode_not_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  postcode_contains?: Maybe<Scalars['String']>;
  postcode_not_contains?: Maybe<Scalars['String']>;
  email_exists?: Maybe<Scalars['Boolean']>;
  email?: Maybe<Scalars['String']>;
  email_not?: Maybe<Scalars['String']>;
  email_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  email_not_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  email_contains?: Maybe<Scalars['String']>;
  email_not_contains?: Maybe<Scalars['String']>;
  telefon_exists?: Maybe<Scalars['Boolean']>;
  telefon?: Maybe<Scalars['String']>;
  telefon_not?: Maybe<Scalars['String']>;
  telefon_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  telefon_not_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  telefon_contains?: Maybe<Scalars['String']>;
  telefon_not_contains?: Maybe<Scalars['String']>;
  OR?: Maybe<Array<Maybe<NewsArticleContactFilter>>>;
  AND?: Maybe<Array<Maybe<NewsArticleContactFilter>>>;
};

export enum NewsArticleContactsCollectionOrder {
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC',
  FullNameAsc = 'fullName_ASC',
  FullNameDesc = 'fullName_DESC',
  CompanyAsc = 'company_ASC',
  CompanyDesc = 'company_DESC',
  StreetAsc = 'street_ASC',
  StreetDesc = 'street_DESC',
  PostcodeAsc = 'postcode_ASC',
  PostcodeDesc = 'postcode_DESC',
  EmailAsc = 'email_ASC',
  EmailDesc = 'email_DESC',
  TelefonAsc = 'telefon_ASC',
  TelefonDesc = 'telefon_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum BlockAccordionEntryLinkingCollectionsNewsArticleCollectionOrder {
  NewsTypeAsc = 'newsType_ASC',
  NewsTypeDesc = 'newsType_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  DateAsc = 'date_ASC',
  DateDesc = 'date_DESC',
  HideDateAsc = 'hideDate_ASC',
  HideDateDesc = 'hideDate_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum BlockAccordionEntryLinkingCollectionsProjectPageCollectionOrder {
  InternalNameAsc = 'internal_name_ASC',
  InternalNameDesc = 'internal_name_DESC',
  PropstackProjectIdAsc = 'propstackProjectId_ASC',
  PropstackProjectIdDesc = 'propstackProjectId_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export type BlockAccordionEntryBlocksCollection = {
  __typename?: 'BlockAccordionEntryBlocksCollection';
  total: Scalars['Int'];
  skip: Scalars['Int'];
  limit: Scalars['Int'];
  items: Array<Maybe<BlockAccordionEntryBlocksItem>>;
};

export type BlockAccordionEntryBlocksItem = BlockCallToActionButton | BlockCustom | BlockRichText | BlockTable | BlockTwoColumn;

export type BlockAccordionEntryBlocksFilter = {
  sys?: Maybe<SysFilter>;
  contentfulMetadata?: Maybe<ContentfulMetadataFilter>;
  OR?: Maybe<Array<Maybe<BlockAccordionEntryBlocksFilter>>>;
  AND?: Maybe<Array<Maybe<BlockAccordionEntryBlocksFilter>>>;
};

export enum BlockTwoColumnLinkingCollectionsBlockAccordionEntryCollectionOrder {
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC',
  TitleWhenExpandedAsc = 'titleWhenExpanded_ASC',
  TitleWhenExpandedDesc = 'titleWhenExpanded_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum BlockTwoColumnLinkingCollectionsNewsArticleCollectionOrder {
  NewsTypeAsc = 'newsType_ASC',
  NewsTypeDesc = 'newsType_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  DateAsc = 'date_ASC',
  DateDesc = 'date_DESC',
  HideDateAsc = 'hideDate_ASC',
  HideDateDesc = 'hideDate_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum BlockTwoColumnLinkingCollectionsProjectPageCollectionOrder {
  InternalNameAsc = 'internal_name_ASC',
  InternalNameDesc = 'internal_name_DESC',
  PropstackProjectIdAsc = 'propstackProjectId_ASC',
  PropstackProjectIdDesc = 'propstackProjectId_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export type BlockTwoColumnLeftColumnCollection = {
  __typename?: 'BlockTwoColumnLeftColumnCollection';
  total: Scalars['Int'];
  skip: Scalars['Int'];
  limit: Scalars['Int'];
  items: Array<Maybe<BlockTwoColumnLeftColumnItem>>;
};

export type BlockTwoColumnLeftColumnItem = BlockAccordion | BlockBigTitleNavigation | BlockCallToActionButton | BlockCustom | BlockFullsizeImage | BlockRichText | BlockSpeechBubble | LatestDownload | NavigationEntry;

/** [See type definition](https://app.contentful.com/spaces/0j0b0fue4dp9/content_types/blockSpeechBubble) */
export type BlockSpeechBubble = Entry & _Node & {
  __typename?: 'BlockSpeechBubble';
  sys: Sys;
  contentfulMetadata: ContentfulMetadata;
  linkedFrom?: Maybe<BlockSpeechBubbleLinkingCollections>;
  _id: Scalars['ID'];
  internalDescription?: Maybe<Scalars['String']>;
  text?: Maybe<Scalars['String']>;
  variant?: Maybe<Scalars['String']>;
};


/** [See type definition](https://app.contentful.com/spaces/0j0b0fue4dp9/content_types/blockSpeechBubble) */
export type BlockSpeechBubbleLinkedFromArgs = {
  allowedLocales?: Maybe<Array<Maybe<Scalars['String']>>>;
};


/** [See type definition](https://app.contentful.com/spaces/0j0b0fue4dp9/content_types/blockSpeechBubble) */
export type BlockSpeechBubbleInternalDescriptionArgs = {
  locale?: Maybe<Scalars['String']>;
};


/** [See type definition](https://app.contentful.com/spaces/0j0b0fue4dp9/content_types/blockSpeechBubble) */
export type BlockSpeechBubbleTextArgs = {
  locale?: Maybe<Scalars['String']>;
};


/** [See type definition](https://app.contentful.com/spaces/0j0b0fue4dp9/content_types/blockSpeechBubble) */
export type BlockSpeechBubbleVariantArgs = {
  locale?: Maybe<Scalars['String']>;
};

export type BlockSpeechBubbleLinkingCollections = {
  __typename?: 'BlockSpeechBubbleLinkingCollections';
  entryCollection?: Maybe<EntryCollection>;
  blockHiddenWithConsentCollection?: Maybe<BlockHiddenWithConsentCollection>;
  blockTwoColumnCollection?: Maybe<BlockTwoColumnCollection>;
};


export type BlockSpeechBubbleLinkingCollectionsEntryCollectionArgs = {
  skip?: Maybe<Scalars['Int']>;
  limit?: Maybe<Scalars['Int']>;
  preview?: Maybe<Scalars['Boolean']>;
  locale?: Maybe<Scalars['String']>;
};


export type BlockSpeechBubbleLinkingCollectionsBlockHiddenWithConsentCollectionArgs = {
  skip?: Maybe<Scalars['Int']>;
  limit?: Maybe<Scalars['Int']>;
  preview?: Maybe<Scalars['Boolean']>;
  locale?: Maybe<Scalars['String']>;
  order?: Maybe<Array<Maybe<BlockSpeechBubbleLinkingCollectionsBlockHiddenWithConsentCollectionOrder>>>;
};


export type BlockSpeechBubbleLinkingCollectionsBlockTwoColumnCollectionArgs = {
  skip?: Maybe<Scalars['Int']>;
  limit?: Maybe<Scalars['Int']>;
  preview?: Maybe<Scalars['Boolean']>;
  locale?: Maybe<Scalars['String']>;
  order?: Maybe<Array<Maybe<BlockSpeechBubbleLinkingCollectionsBlockTwoColumnCollectionOrder>>>;
};

export enum BlockSpeechBubbleLinkingCollectionsBlockHiddenWithConsentCollectionOrder {
  ConsentTypeAsc = 'consentType_ASC',
  ConsentTypeDesc = 'consentType_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum BlockSpeechBubbleLinkingCollectionsBlockTwoColumnCollectionOrder {
  InternalDescriptionAsc = 'internalDescription_ASC',
  InternalDescriptionDesc = 'internalDescription_DESC',
  RightColumnOffsetAsc = 'rightColumnOffset_ASC',
  RightColumnOffsetDesc = 'rightColumnOffset_DESC',
  VerticalCenterLeftColumnAsc = 'verticalCenterLeftColumn_ASC',
  VerticalCenterLeftColumnDesc = 'verticalCenterLeftColumn_DESC',
  VerticalCenterRightColumnAsc = 'verticalCenterRightColumn_ASC',
  VerticalCenterRightColumnDesc = 'verticalCenterRightColumn_DESC',
  LeftColumnTextRightAsc = 'leftColumnTextRight_ASC',
  LeftColumnTextRightDesc = 'leftColumnTextRight_DESC',
  VariantAsc = 'variant_ASC',
  VariantDesc = 'variant_DESC',
  MobileColumnOrderAsc = 'mobileColumnOrder_ASC',
  MobileColumnOrderDesc = 'mobileColumnOrder_DESC',
  AppendContactAndNewsletterCtAsAsc = 'appendContactAndNewsletterCTAs_ASC',
  AppendContactAndNewsletterCtAsDesc = 'appendContactAndNewsletterCTAs_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

/** A component that displays the latest Downloadable File of the given FileType (AnnualReport etc.) [See type definition](https://app.contentful.com/spaces/0j0b0fue4dp9/content_types/latestDownload) */
export type LatestDownload = Entry & _Node & {
  __typename?: 'LatestDownload';
  sys: Sys;
  contentfulMetadata: ContentfulMetadata;
  linkedFrom?: Maybe<LatestDownloadLinkingCollections>;
  _id: Scalars['ID'];
  internalDescription?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
};


/** A component that displays the latest Downloadable File of the given FileType (AnnualReport etc.) [See type definition](https://app.contentful.com/spaces/0j0b0fue4dp9/content_types/latestDownload) */
export type LatestDownloadLinkedFromArgs = {
  allowedLocales?: Maybe<Array<Maybe<Scalars['String']>>>;
};


/** A component that displays the latest Downloadable File of the given FileType (AnnualReport etc.) [See type definition](https://app.contentful.com/spaces/0j0b0fue4dp9/content_types/latestDownload) */
export type LatestDownloadInternalDescriptionArgs = {
  locale?: Maybe<Scalars['String']>;
};


/** A component that displays the latest Downloadable File of the given FileType (AnnualReport etc.) [See type definition](https://app.contentful.com/spaces/0j0b0fue4dp9/content_types/latestDownload) */
export type LatestDownloadTypeArgs = {
  locale?: Maybe<Scalars['String']>;
};

export type LatestDownloadLinkingCollections = {
  __typename?: 'LatestDownloadLinkingCollections';
  entryCollection?: Maybe<EntryCollection>;
  staticPageCollection?: Maybe<StaticPageCollection>;
  blockTwoColumnCollection?: Maybe<BlockTwoColumnCollection>;
};


export type LatestDownloadLinkingCollectionsEntryCollectionArgs = {
  skip?: Maybe<Scalars['Int']>;
  limit?: Maybe<Scalars['Int']>;
  preview?: Maybe<Scalars['Boolean']>;
  locale?: Maybe<Scalars['String']>;
};


export type LatestDownloadLinkingCollectionsStaticPageCollectionArgs = {
  skip?: Maybe<Scalars['Int']>;
  limit?: Maybe<Scalars['Int']>;
  preview?: Maybe<Scalars['Boolean']>;
  locale?: Maybe<Scalars['String']>;
  order?: Maybe<Array<Maybe<LatestDownloadLinkingCollectionsStaticPageCollectionOrder>>>;
};


export type LatestDownloadLinkingCollectionsBlockTwoColumnCollectionArgs = {
  skip?: Maybe<Scalars['Int']>;
  limit?: Maybe<Scalars['Int']>;
  preview?: Maybe<Scalars['Boolean']>;
  locale?: Maybe<Scalars['String']>;
  order?: Maybe<Array<Maybe<LatestDownloadLinkingCollectionsBlockTwoColumnCollectionOrder>>>;
};

export enum LatestDownloadLinkingCollectionsStaticPageCollectionOrder {
  PageTitleAsc = 'pageTitle_ASC',
  PageTitleDesc = 'pageTitle_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  StandaloneAsc = 'standalone_ASC',
  StandaloneDesc = 'standalone_DESC',
  ShowNewsletterFooterAsc = 'showNewsletterFooter_ASC',
  ShowNewsletterFooterDesc = 'showNewsletterFooter_DESC',
  ShowContactFooterAsc = 'showContactFooter_ASC',
  ShowContactFooterDesc = 'showContactFooter_DESC',
  PageTagAsc = 'pageTag_ASC',
  PageTagDesc = 'pageTag_DESC',
  NewsTypeAsc = 'newsType_ASC',
  NewsTypeDesc = 'newsType_DESC',
  RemovePaddingBottomAsc = 'removePaddingBottom_ASC',
  RemovePaddingBottomDesc = 'removePaddingBottom_DESC',
  RegionAsc = 'region_ASC',
  RegionDesc = 'region_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum LatestDownloadLinkingCollectionsBlockTwoColumnCollectionOrder {
  InternalDescriptionAsc = 'internalDescription_ASC',
  InternalDescriptionDesc = 'internalDescription_DESC',
  RightColumnOffsetAsc = 'rightColumnOffset_ASC',
  RightColumnOffsetDesc = 'rightColumnOffset_DESC',
  VerticalCenterLeftColumnAsc = 'verticalCenterLeftColumn_ASC',
  VerticalCenterLeftColumnDesc = 'verticalCenterLeftColumn_DESC',
  VerticalCenterRightColumnAsc = 'verticalCenterRightColumn_ASC',
  VerticalCenterRightColumnDesc = 'verticalCenterRightColumn_DESC',
  LeftColumnTextRightAsc = 'leftColumnTextRight_ASC',
  LeftColumnTextRightDesc = 'leftColumnTextRight_DESC',
  VariantAsc = 'variant_ASC',
  VariantDesc = 'variant_DESC',
  MobileColumnOrderAsc = 'mobileColumnOrder_ASC',
  MobileColumnOrderDesc = 'mobileColumnOrder_DESC',
  AppendContactAndNewsletterCtAsAsc = 'appendContactAndNewsletterCTAs_ASC',
  AppendContactAndNewsletterCtAsDesc = 'appendContactAndNewsletterCTAs_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

/** [See type definition](https://app.contentful.com/spaces/0j0b0fue4dp9/content_types/navigationEntry) */
export type NavigationEntry = Entry & _Node & {
  __typename?: 'NavigationEntry';
  sys: Sys;
  contentfulMetadata: ContentfulMetadata;
  linkedFrom?: Maybe<NavigationEntryLinkingCollections>;
  _id: Scalars['ID'];
  image?: Maybe<Asset>;
  title?: Maybe<Scalars['String']>;
  subTitle?: Maybe<Scalars['String']>;
  staticPage?: Maybe<StaticPage>;
  buttonText?: Maybe<Scalars['String']>;
};


/** [See type definition](https://app.contentful.com/spaces/0j0b0fue4dp9/content_types/navigationEntry) */
export type NavigationEntryLinkedFromArgs = {
  allowedLocales?: Maybe<Array<Maybe<Scalars['String']>>>;
};


/** [See type definition](https://app.contentful.com/spaces/0j0b0fue4dp9/content_types/navigationEntry) */
export type NavigationEntryImageArgs = {
  preview?: Maybe<Scalars['Boolean']>;
  locale?: Maybe<Scalars['String']>;
};


/** [See type definition](https://app.contentful.com/spaces/0j0b0fue4dp9/content_types/navigationEntry) */
export type NavigationEntryTitleArgs = {
  locale?: Maybe<Scalars['String']>;
};


/** [See type definition](https://app.contentful.com/spaces/0j0b0fue4dp9/content_types/navigationEntry) */
export type NavigationEntrySubTitleArgs = {
  locale?: Maybe<Scalars['String']>;
};


/** [See type definition](https://app.contentful.com/spaces/0j0b0fue4dp9/content_types/navigationEntry) */
export type NavigationEntryStaticPageArgs = {
  preview?: Maybe<Scalars['Boolean']>;
  locale?: Maybe<Scalars['String']>;
  where?: Maybe<StaticPageFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/0j0b0fue4dp9/content_types/navigationEntry) */
export type NavigationEntryButtonTextArgs = {
  locale?: Maybe<Scalars['String']>;
};

export type NavigationEntryLinkingCollections = {
  __typename?: 'NavigationEntryLinkingCollections';
  entryCollection?: Maybe<EntryCollection>;
  blockTwoColumnCollection?: Maybe<BlockTwoColumnCollection>;
};


export type NavigationEntryLinkingCollectionsEntryCollectionArgs = {
  skip?: Maybe<Scalars['Int']>;
  limit?: Maybe<Scalars['Int']>;
  preview?: Maybe<Scalars['Boolean']>;
  locale?: Maybe<Scalars['String']>;
};


export type NavigationEntryLinkingCollectionsBlockTwoColumnCollectionArgs = {
  skip?: Maybe<Scalars['Int']>;
  limit?: Maybe<Scalars['Int']>;
  preview?: Maybe<Scalars['Boolean']>;
  locale?: Maybe<Scalars['String']>;
  order?: Maybe<Array<Maybe<NavigationEntryLinkingCollectionsBlockTwoColumnCollectionOrder>>>;
};

export enum NavigationEntryLinkingCollectionsBlockTwoColumnCollectionOrder {
  InternalDescriptionAsc = 'internalDescription_ASC',
  InternalDescriptionDesc = 'internalDescription_DESC',
  RightColumnOffsetAsc = 'rightColumnOffset_ASC',
  RightColumnOffsetDesc = 'rightColumnOffset_DESC',
  VerticalCenterLeftColumnAsc = 'verticalCenterLeftColumn_ASC',
  VerticalCenterLeftColumnDesc = 'verticalCenterLeftColumn_DESC',
  VerticalCenterRightColumnAsc = 'verticalCenterRightColumn_ASC',
  VerticalCenterRightColumnDesc = 'verticalCenterRightColumn_DESC',
  LeftColumnTextRightAsc = 'leftColumnTextRight_ASC',
  LeftColumnTextRightDesc = 'leftColumnTextRight_DESC',
  VariantAsc = 'variant_ASC',
  VariantDesc = 'variant_DESC',
  MobileColumnOrderAsc = 'mobileColumnOrder_ASC',
  MobileColumnOrderDesc = 'mobileColumnOrder_DESC',
  AppendContactAndNewsletterCtAsAsc = 'appendContactAndNewsletterCTAs_ASC',
  AppendContactAndNewsletterCtAsDesc = 'appendContactAndNewsletterCTAs_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export type BlockTwoColumnLeftColumnFilter = {
  sys?: Maybe<SysFilter>;
  contentfulMetadata?: Maybe<ContentfulMetadataFilter>;
  OR?: Maybe<Array<Maybe<BlockTwoColumnLeftColumnFilter>>>;
  AND?: Maybe<Array<Maybe<BlockTwoColumnLeftColumnFilter>>>;
};

export type BlockTwoColumnRightColumnCollection = {
  __typename?: 'BlockTwoColumnRightColumnCollection';
  total: Scalars['Int'];
  skip: Scalars['Int'];
  limit: Scalars['Int'];
  items: Array<Maybe<BlockTwoColumnRightColumnItem>>;
};

export type BlockTwoColumnRightColumnItem = BlockAccordion | BlockBigTitleNavigation | BlockCallToActionButton | BlockCustom | BlockFullsizeImage | BlockRichText | BlockSpeechBubble | LatestDownload | NavigationEntry;

export type BlockTwoColumnRightColumnFilter = {
  sys?: Maybe<SysFilter>;
  contentfulMetadata?: Maybe<ContentfulMetadataFilter>;
  OR?: Maybe<Array<Maybe<BlockTwoColumnRightColumnFilter>>>;
  AND?: Maybe<Array<Maybe<BlockTwoColumnRightColumnFilter>>>;
};

export enum BlockCallToActionButtonLinkingCollectionsBlockTwoColumnCollectionOrder {
  InternalDescriptionAsc = 'internalDescription_ASC',
  InternalDescriptionDesc = 'internalDescription_DESC',
  RightColumnOffsetAsc = 'rightColumnOffset_ASC',
  RightColumnOffsetDesc = 'rightColumnOffset_DESC',
  VerticalCenterLeftColumnAsc = 'verticalCenterLeftColumn_ASC',
  VerticalCenterLeftColumnDesc = 'verticalCenterLeftColumn_DESC',
  VerticalCenterRightColumnAsc = 'verticalCenterRightColumn_ASC',
  VerticalCenterRightColumnDesc = 'verticalCenterRightColumn_DESC',
  LeftColumnTextRightAsc = 'leftColumnTextRight_ASC',
  LeftColumnTextRightDesc = 'leftColumnTextRight_DESC',
  VariantAsc = 'variant_ASC',
  VariantDesc = 'variant_DESC',
  MobileColumnOrderAsc = 'mobileColumnOrder_ASC',
  MobileColumnOrderDesc = 'mobileColumnOrder_DESC',
  AppendContactAndNewsletterCtAsAsc = 'appendContactAndNewsletterCTAs_ASC',
  AppendContactAndNewsletterCtAsDesc = 'appendContactAndNewsletterCTAs_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum BlockCallToActionButtonLinkingCollectionsBlockAccordionEntryCollectionOrder {
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC',
  TitleWhenExpandedAsc = 'titleWhenExpanded_ASC',
  TitleWhenExpandedDesc = 'titleWhenExpanded_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum BlockCallToActionButtonLinkingCollectionsNewsArticleCollectionOrder {
  NewsTypeAsc = 'newsType_ASC',
  NewsTypeDesc = 'newsType_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  DateAsc = 'date_ASC',
  DateDesc = 'date_DESC',
  HideDateAsc = 'hideDate_ASC',
  HideDateDesc = 'hideDate_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum BlockCallToActionButtonLinkingCollectionsProjectPageCollectionOrder {
  InternalNameAsc = 'internal_name_ASC',
  InternalNameDesc = 'internal_name_DESC',
  PropstackProjectIdAsc = 'propstackProjectId_ASC',
  PropstackProjectIdDesc = 'propstackProjectId_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

/** Displays multiple links rows among themselves [See type definition](https://app.contentful.com/spaces/0j0b0fue4dp9/content_types/blockLinkSection) */
export type BlockLinkSection = Entry & _Node & {
  __typename?: 'BlockLinkSection';
  sys: Sys;
  contentfulMetadata: ContentfulMetadata;
  linkedFrom?: Maybe<BlockLinkSectionLinkingCollections>;
  _id: Scalars['ID'];
  title?: Maybe<Scalars['String']>;
  linkSectionEntriesCollection?: Maybe<BlockLinkSectionLinkSectionEntriesCollection>;
};


/** Displays multiple links rows among themselves [See type definition](https://app.contentful.com/spaces/0j0b0fue4dp9/content_types/blockLinkSection) */
export type BlockLinkSectionLinkedFromArgs = {
  allowedLocales?: Maybe<Array<Maybe<Scalars['String']>>>;
};


/** Displays multiple links rows among themselves [See type definition](https://app.contentful.com/spaces/0j0b0fue4dp9/content_types/blockLinkSection) */
export type BlockLinkSectionTitleArgs = {
  locale?: Maybe<Scalars['String']>;
};


/** Displays multiple links rows among themselves [See type definition](https://app.contentful.com/spaces/0j0b0fue4dp9/content_types/blockLinkSection) */
export type BlockLinkSectionLinkSectionEntriesCollectionArgs = {
  skip?: Maybe<Scalars['Int']>;
  limit?: Maybe<Scalars['Int']>;
  preview?: Maybe<Scalars['Boolean']>;
  locale?: Maybe<Scalars['String']>;
  where?: Maybe<LinkSectionEntryFilter>;
  order?: Maybe<Array<Maybe<BlockLinkSectionLinkSectionEntriesCollectionOrder>>>;
};

export type BlockLinkSectionLinkingCollections = {
  __typename?: 'BlockLinkSectionLinkingCollections';
  entryCollection?: Maybe<EntryCollection>;
  staticPageCollection?: Maybe<StaticPageCollection>;
  blockHiddenWithConsentCollection?: Maybe<BlockHiddenWithConsentCollection>;
  blockOneColumnCollection?: Maybe<BlockOneColumnCollection>;
};


export type BlockLinkSectionLinkingCollectionsEntryCollectionArgs = {
  skip?: Maybe<Scalars['Int']>;
  limit?: Maybe<Scalars['Int']>;
  preview?: Maybe<Scalars['Boolean']>;
  locale?: Maybe<Scalars['String']>;
};


export type BlockLinkSectionLinkingCollectionsStaticPageCollectionArgs = {
  skip?: Maybe<Scalars['Int']>;
  limit?: Maybe<Scalars['Int']>;
  preview?: Maybe<Scalars['Boolean']>;
  locale?: Maybe<Scalars['String']>;
  order?: Maybe<Array<Maybe<BlockLinkSectionLinkingCollectionsStaticPageCollectionOrder>>>;
};


export type BlockLinkSectionLinkingCollectionsBlockHiddenWithConsentCollectionArgs = {
  skip?: Maybe<Scalars['Int']>;
  limit?: Maybe<Scalars['Int']>;
  preview?: Maybe<Scalars['Boolean']>;
  locale?: Maybe<Scalars['String']>;
  order?: Maybe<Array<Maybe<BlockLinkSectionLinkingCollectionsBlockHiddenWithConsentCollectionOrder>>>;
};


export type BlockLinkSectionLinkingCollectionsBlockOneColumnCollectionArgs = {
  skip?: Maybe<Scalars['Int']>;
  limit?: Maybe<Scalars['Int']>;
  preview?: Maybe<Scalars['Boolean']>;
  locale?: Maybe<Scalars['String']>;
  order?: Maybe<Array<Maybe<BlockLinkSectionLinkingCollectionsBlockOneColumnCollectionOrder>>>;
};

export enum BlockLinkSectionLinkingCollectionsStaticPageCollectionOrder {
  PageTitleAsc = 'pageTitle_ASC',
  PageTitleDesc = 'pageTitle_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  StandaloneAsc = 'standalone_ASC',
  StandaloneDesc = 'standalone_DESC',
  ShowNewsletterFooterAsc = 'showNewsletterFooter_ASC',
  ShowNewsletterFooterDesc = 'showNewsletterFooter_DESC',
  ShowContactFooterAsc = 'showContactFooter_ASC',
  ShowContactFooterDesc = 'showContactFooter_DESC',
  PageTagAsc = 'pageTag_ASC',
  PageTagDesc = 'pageTag_DESC',
  NewsTypeAsc = 'newsType_ASC',
  NewsTypeDesc = 'newsType_DESC',
  RemovePaddingBottomAsc = 'removePaddingBottom_ASC',
  RemovePaddingBottomDesc = 'removePaddingBottom_DESC',
  RegionAsc = 'region_ASC',
  RegionDesc = 'region_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum BlockLinkSectionLinkingCollectionsBlockHiddenWithConsentCollectionOrder {
  ConsentTypeAsc = 'consentType_ASC',
  ConsentTypeDesc = 'consentType_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum BlockLinkSectionLinkingCollectionsBlockOneColumnCollectionOrder {
  InternalDescriptionAsc = 'internalDescription_ASC',
  InternalDescriptionDesc = 'internalDescription_DESC',
  EnableBlackBackgroundAsc = 'enableBlackBackground_ASC',
  EnableBlackBackgroundDesc = 'enableBlackBackground_DESC',
  SmallMainColumnOverImageAsc = 'smallMainColumnOverImage_ASC',
  SmallMainColumnOverImageDesc = 'smallMainColumnOverImage_DESC',
  BackgroundColorAsc = 'backgroundColor_ASC',
  BackgroundColorDesc = 'backgroundColor_DESC',
  PaddingAsc = 'padding_ASC',
  PaddingDesc = 'padding_DESC',
  WithExtraPaddingAsc = 'withExtraPadding_ASC',
  WithExtraPaddingDesc = 'withExtraPadding_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export type BlockLinkSectionLinkSectionEntriesCollection = {
  __typename?: 'BlockLinkSectionLinkSectionEntriesCollection';
  total: Scalars['Int'];
  skip: Scalars['Int'];
  limit: Scalars['Int'];
  items: Array<Maybe<LinkSectionEntry>>;
};

/** Is child of BlockLinkSection [See type definition](https://app.contentful.com/spaces/0j0b0fue4dp9/content_types/linkSectionEntry) */
export type LinkSectionEntry = Entry & _Node & {
  __typename?: 'LinkSectionEntry';
  sys: Sys;
  contentfulMetadata: ContentfulMetadata;
  linkedFrom?: Maybe<LinkSectionEntryLinkingCollections>;
  _id: Scalars['ID'];
  title?: Maybe<Scalars['String']>;
  subTitle?: Maybe<Scalars['String']>;
  href?: Maybe<Scalars['String']>;
};


/** Is child of BlockLinkSection [See type definition](https://app.contentful.com/spaces/0j0b0fue4dp9/content_types/linkSectionEntry) */
export type LinkSectionEntryLinkedFromArgs = {
  allowedLocales?: Maybe<Array<Maybe<Scalars['String']>>>;
};


/** Is child of BlockLinkSection [See type definition](https://app.contentful.com/spaces/0j0b0fue4dp9/content_types/linkSectionEntry) */
export type LinkSectionEntryTitleArgs = {
  locale?: Maybe<Scalars['String']>;
};


/** Is child of BlockLinkSection [See type definition](https://app.contentful.com/spaces/0j0b0fue4dp9/content_types/linkSectionEntry) */
export type LinkSectionEntrySubTitleArgs = {
  locale?: Maybe<Scalars['String']>;
};


/** Is child of BlockLinkSection [See type definition](https://app.contentful.com/spaces/0j0b0fue4dp9/content_types/linkSectionEntry) */
export type LinkSectionEntryHrefArgs = {
  locale?: Maybe<Scalars['String']>;
};

export type LinkSectionEntryLinkingCollections = {
  __typename?: 'LinkSectionEntryLinkingCollections';
  entryCollection?: Maybe<EntryCollection>;
  blockLinkSectionCollection?: Maybe<BlockLinkSectionCollection>;
};


export type LinkSectionEntryLinkingCollectionsEntryCollectionArgs = {
  skip?: Maybe<Scalars['Int']>;
  limit?: Maybe<Scalars['Int']>;
  preview?: Maybe<Scalars['Boolean']>;
  locale?: Maybe<Scalars['String']>;
};


export type LinkSectionEntryLinkingCollectionsBlockLinkSectionCollectionArgs = {
  skip?: Maybe<Scalars['Int']>;
  limit?: Maybe<Scalars['Int']>;
  preview?: Maybe<Scalars['Boolean']>;
  locale?: Maybe<Scalars['String']>;
  order?: Maybe<Array<Maybe<LinkSectionEntryLinkingCollectionsBlockLinkSectionCollectionOrder>>>;
};

export type BlockLinkSectionCollection = {
  __typename?: 'BlockLinkSectionCollection';
  total: Scalars['Int'];
  skip: Scalars['Int'];
  limit: Scalars['Int'];
  items: Array<Maybe<BlockLinkSection>>;
};

export enum LinkSectionEntryLinkingCollectionsBlockLinkSectionCollectionOrder {
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export type LinkSectionEntryFilter = {
  sys?: Maybe<SysFilter>;
  contentfulMetadata?: Maybe<ContentfulMetadataFilter>;
  title_exists?: Maybe<Scalars['Boolean']>;
  title?: Maybe<Scalars['String']>;
  title_not?: Maybe<Scalars['String']>;
  title_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  title_not_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  title_contains?: Maybe<Scalars['String']>;
  title_not_contains?: Maybe<Scalars['String']>;
  subTitle_exists?: Maybe<Scalars['Boolean']>;
  subTitle?: Maybe<Scalars['String']>;
  subTitle_not?: Maybe<Scalars['String']>;
  subTitle_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  subTitle_not_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  subTitle_contains?: Maybe<Scalars['String']>;
  subTitle_not_contains?: Maybe<Scalars['String']>;
  href_exists?: Maybe<Scalars['Boolean']>;
  href?: Maybe<Scalars['String']>;
  href_not?: Maybe<Scalars['String']>;
  href_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  href_not_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  href_contains?: Maybe<Scalars['String']>;
  href_not_contains?: Maybe<Scalars['String']>;
  OR?: Maybe<Array<Maybe<LinkSectionEntryFilter>>>;
  AND?: Maybe<Array<Maybe<LinkSectionEntryFilter>>>;
};

export enum BlockLinkSectionLinkSectionEntriesCollectionOrder {
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC',
  SubTitleAsc = 'subTitle_ASC',
  SubTitleDesc = 'subTitle_DESC',
  HrefAsc = 'href_ASC',
  HrefDesc = 'href_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

/** [See type definition](https://app.contentful.com/spaces/0j0b0fue4dp9/content_types/blockStockPrice) */
export type BlockStockPrice = Entry & _Node & {
  __typename?: 'BlockStockPrice';
  sys: Sys;
  contentfulMetadata: ContentfulMetadata;
  linkedFrom?: Maybe<BlockStockPriceLinkingCollections>;
  _id: Scalars['ID'];
  title?: Maybe<Scalars['String']>;
  stockPriceDescription?: Maybe<Scalars['String']>;
};


/** [See type definition](https://app.contentful.com/spaces/0j0b0fue4dp9/content_types/blockStockPrice) */
export type BlockStockPriceLinkedFromArgs = {
  allowedLocales?: Maybe<Array<Maybe<Scalars['String']>>>;
};


/** [See type definition](https://app.contentful.com/spaces/0j0b0fue4dp9/content_types/blockStockPrice) */
export type BlockStockPriceTitleArgs = {
  locale?: Maybe<Scalars['String']>;
};


/** [See type definition](https://app.contentful.com/spaces/0j0b0fue4dp9/content_types/blockStockPrice) */
export type BlockStockPriceStockPriceDescriptionArgs = {
  locale?: Maybe<Scalars['String']>;
};

export type BlockStockPriceLinkingCollections = {
  __typename?: 'BlockStockPriceLinkingCollections';
  entryCollection?: Maybe<EntryCollection>;
  staticPageCollection?: Maybe<StaticPageCollection>;
  blockOneColumnCollection?: Maybe<BlockOneColumnCollection>;
};


export type BlockStockPriceLinkingCollectionsEntryCollectionArgs = {
  skip?: Maybe<Scalars['Int']>;
  limit?: Maybe<Scalars['Int']>;
  preview?: Maybe<Scalars['Boolean']>;
  locale?: Maybe<Scalars['String']>;
};


export type BlockStockPriceLinkingCollectionsStaticPageCollectionArgs = {
  skip?: Maybe<Scalars['Int']>;
  limit?: Maybe<Scalars['Int']>;
  preview?: Maybe<Scalars['Boolean']>;
  locale?: Maybe<Scalars['String']>;
  order?: Maybe<Array<Maybe<BlockStockPriceLinkingCollectionsStaticPageCollectionOrder>>>;
};


export type BlockStockPriceLinkingCollectionsBlockOneColumnCollectionArgs = {
  skip?: Maybe<Scalars['Int']>;
  limit?: Maybe<Scalars['Int']>;
  preview?: Maybe<Scalars['Boolean']>;
  locale?: Maybe<Scalars['String']>;
  order?: Maybe<Array<Maybe<BlockStockPriceLinkingCollectionsBlockOneColumnCollectionOrder>>>;
};

export enum BlockStockPriceLinkingCollectionsStaticPageCollectionOrder {
  PageTitleAsc = 'pageTitle_ASC',
  PageTitleDesc = 'pageTitle_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  StandaloneAsc = 'standalone_ASC',
  StandaloneDesc = 'standalone_DESC',
  ShowNewsletterFooterAsc = 'showNewsletterFooter_ASC',
  ShowNewsletterFooterDesc = 'showNewsletterFooter_DESC',
  ShowContactFooterAsc = 'showContactFooter_ASC',
  ShowContactFooterDesc = 'showContactFooter_DESC',
  PageTagAsc = 'pageTag_ASC',
  PageTagDesc = 'pageTag_DESC',
  NewsTypeAsc = 'newsType_ASC',
  NewsTypeDesc = 'newsType_DESC',
  RemovePaddingBottomAsc = 'removePaddingBottom_ASC',
  RemovePaddingBottomDesc = 'removePaddingBottom_DESC',
  RegionAsc = 'region_ASC',
  RegionDesc = 'region_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum BlockStockPriceLinkingCollectionsBlockOneColumnCollectionOrder {
  InternalDescriptionAsc = 'internalDescription_ASC',
  InternalDescriptionDesc = 'internalDescription_DESC',
  EnableBlackBackgroundAsc = 'enableBlackBackground_ASC',
  EnableBlackBackgroundDesc = 'enableBlackBackground_DESC',
  SmallMainColumnOverImageAsc = 'smallMainColumnOverImage_ASC',
  SmallMainColumnOverImageDesc = 'smallMainColumnOverImage_DESC',
  BackgroundColorAsc = 'backgroundColor_ASC',
  BackgroundColorDesc = 'backgroundColor_DESC',
  PaddingAsc = 'padding_ASC',
  PaddingDesc = 'padding_DESC',
  WithExtraPaddingAsc = 'withExtraPadding_ASC',
  WithExtraPaddingDesc = 'withExtraPadding_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export type BlockOneColumnMainColumnFilter = {
  sys?: Maybe<SysFilter>;
  contentfulMetadata?: Maybe<ContentfulMetadataFilter>;
  OR?: Maybe<Array<Maybe<BlockOneColumnMainColumnFilter>>>;
  AND?: Maybe<Array<Maybe<BlockOneColumnMainColumnFilter>>>;
};

export enum BlockAccordionLinkingCollectionsBlockOneColumnCollectionOrder {
  InternalDescriptionAsc = 'internalDescription_ASC',
  InternalDescriptionDesc = 'internalDescription_DESC',
  EnableBlackBackgroundAsc = 'enableBlackBackground_ASC',
  EnableBlackBackgroundDesc = 'enableBlackBackground_DESC',
  SmallMainColumnOverImageAsc = 'smallMainColumnOverImage_ASC',
  SmallMainColumnOverImageDesc = 'smallMainColumnOverImage_DESC',
  BackgroundColorAsc = 'backgroundColor_ASC',
  BackgroundColorDesc = 'backgroundColor_DESC',
  PaddingAsc = 'padding_ASC',
  PaddingDesc = 'padding_DESC',
  WithExtraPaddingAsc = 'withExtraPadding_ASC',
  WithExtraPaddingDesc = 'withExtraPadding_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum BlockAccordionLinkingCollectionsBlockTwoColumnCollectionOrder {
  InternalDescriptionAsc = 'internalDescription_ASC',
  InternalDescriptionDesc = 'internalDescription_DESC',
  RightColumnOffsetAsc = 'rightColumnOffset_ASC',
  RightColumnOffsetDesc = 'rightColumnOffset_DESC',
  VerticalCenterLeftColumnAsc = 'verticalCenterLeftColumn_ASC',
  VerticalCenterLeftColumnDesc = 'verticalCenterLeftColumn_DESC',
  VerticalCenterRightColumnAsc = 'verticalCenterRightColumn_ASC',
  VerticalCenterRightColumnDesc = 'verticalCenterRightColumn_DESC',
  LeftColumnTextRightAsc = 'leftColumnTextRight_ASC',
  LeftColumnTextRightDesc = 'leftColumnTextRight_DESC',
  VariantAsc = 'variant_ASC',
  VariantDesc = 'variant_DESC',
  MobileColumnOrderAsc = 'mobileColumnOrder_ASC',
  MobileColumnOrderDesc = 'mobileColumnOrder_DESC',
  AppendContactAndNewsletterCtAsAsc = 'appendContactAndNewsletterCTAs_ASC',
  AppendContactAndNewsletterCtAsDesc = 'appendContactAndNewsletterCTAs_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum BlockAccordionLinkingCollectionsNewsArticleCollectionOrder {
  NewsTypeAsc = 'newsType_ASC',
  NewsTypeDesc = 'newsType_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  DateAsc = 'date_ASC',
  DateDesc = 'date_DESC',
  HideDateAsc = 'hideDate_ASC',
  HideDateDesc = 'hideDate_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum BlockAccordionLinkingCollectionsProjectPageCollectionOrder {
  InternalNameAsc = 'internal_name_ASC',
  InternalNameDesc = 'internal_name_DESC',
  PropstackProjectIdAsc = 'propstackProjectId_ASC',
  PropstackProjectIdDesc = 'propstackProjectId_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export type BlockAccordionAccordionEntryCollection = {
  __typename?: 'BlockAccordionAccordionEntryCollection';
  total: Scalars['Int'];
  skip: Scalars['Int'];
  limit: Scalars['Int'];
  items: Array<Maybe<BlockAccordionEntry>>;
};

export type BlockAccordionEntryFilter = {
  blocks?: Maybe<CfblocksMultiTypeNestedFilter>;
  sys?: Maybe<SysFilter>;
  contentfulMetadata?: Maybe<ContentfulMetadataFilter>;
  title_exists?: Maybe<Scalars['Boolean']>;
  title?: Maybe<Scalars['String']>;
  title_not?: Maybe<Scalars['String']>;
  title_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  title_not_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  title_contains?: Maybe<Scalars['String']>;
  title_not_contains?: Maybe<Scalars['String']>;
  blocksCollection_exists?: Maybe<Scalars['Boolean']>;
  titleWhenExpanded_exists?: Maybe<Scalars['Boolean']>;
  titleWhenExpanded?: Maybe<Scalars['String']>;
  titleWhenExpanded_not?: Maybe<Scalars['String']>;
  titleWhenExpanded_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  titleWhenExpanded_not_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  titleWhenExpanded_contains?: Maybe<Scalars['String']>;
  titleWhenExpanded_not_contains?: Maybe<Scalars['String']>;
  OR?: Maybe<Array<Maybe<BlockAccordionEntryFilter>>>;
  AND?: Maybe<Array<Maybe<BlockAccordionEntryFilter>>>;
};

export enum BlockAccordionAccordionEntryCollectionOrder {
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC',
  TitleWhenExpandedAsc = 'titleWhenExpanded_ASC',
  TitleWhenExpandedDesc = 'titleWhenExpanded_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

/** Displays a gallery for given images. [See type definition](https://app.contentful.com/spaces/0j0b0fue4dp9/content_types/blockImageGallery) */
export type BlockImageGallery = Entry & _Node & {
  __typename?: 'BlockImageGallery';
  sys: Sys;
  contentfulMetadata: ContentfulMetadata;
  linkedFrom?: Maybe<BlockImageGalleryLinkingCollections>;
  _id: Scalars['ID'];
  size?: Maybe<Scalars['String']>;
  imagesCollection?: Maybe<AssetCollection>;
};


/** Displays a gallery for given images. [See type definition](https://app.contentful.com/spaces/0j0b0fue4dp9/content_types/blockImageGallery) */
export type BlockImageGalleryLinkedFromArgs = {
  allowedLocales?: Maybe<Array<Maybe<Scalars['String']>>>;
};


/** Displays a gallery for given images. [See type definition](https://app.contentful.com/spaces/0j0b0fue4dp9/content_types/blockImageGallery) */
export type BlockImageGallerySizeArgs = {
  locale?: Maybe<Scalars['String']>;
};


/** Displays a gallery for given images. [See type definition](https://app.contentful.com/spaces/0j0b0fue4dp9/content_types/blockImageGallery) */
export type BlockImageGalleryImagesCollectionArgs = {
  skip?: Maybe<Scalars['Int']>;
  limit?: Maybe<Scalars['Int']>;
  preview?: Maybe<Scalars['Boolean']>;
  locale?: Maybe<Scalars['String']>;
};

export type BlockImageGalleryLinkingCollections = {
  __typename?: 'BlockImageGalleryLinkingCollections';
  entryCollection?: Maybe<EntryCollection>;
  staticPageCollection?: Maybe<StaticPageCollection>;
  blockHiddenWithConsentCollection?: Maybe<BlockHiddenWithConsentCollection>;
};


export type BlockImageGalleryLinkingCollectionsEntryCollectionArgs = {
  skip?: Maybe<Scalars['Int']>;
  limit?: Maybe<Scalars['Int']>;
  preview?: Maybe<Scalars['Boolean']>;
  locale?: Maybe<Scalars['String']>;
};


export type BlockImageGalleryLinkingCollectionsStaticPageCollectionArgs = {
  skip?: Maybe<Scalars['Int']>;
  limit?: Maybe<Scalars['Int']>;
  preview?: Maybe<Scalars['Boolean']>;
  locale?: Maybe<Scalars['String']>;
  order?: Maybe<Array<Maybe<BlockImageGalleryLinkingCollectionsStaticPageCollectionOrder>>>;
};


export type BlockImageGalleryLinkingCollectionsBlockHiddenWithConsentCollectionArgs = {
  skip?: Maybe<Scalars['Int']>;
  limit?: Maybe<Scalars['Int']>;
  preview?: Maybe<Scalars['Boolean']>;
  locale?: Maybe<Scalars['String']>;
  order?: Maybe<Array<Maybe<BlockImageGalleryLinkingCollectionsBlockHiddenWithConsentCollectionOrder>>>;
};

export enum BlockImageGalleryLinkingCollectionsStaticPageCollectionOrder {
  PageTitleAsc = 'pageTitle_ASC',
  PageTitleDesc = 'pageTitle_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  StandaloneAsc = 'standalone_ASC',
  StandaloneDesc = 'standalone_DESC',
  ShowNewsletterFooterAsc = 'showNewsletterFooter_ASC',
  ShowNewsletterFooterDesc = 'showNewsletterFooter_DESC',
  ShowContactFooterAsc = 'showContactFooter_ASC',
  ShowContactFooterDesc = 'showContactFooter_DESC',
  PageTagAsc = 'pageTag_ASC',
  PageTagDesc = 'pageTag_DESC',
  NewsTypeAsc = 'newsType_ASC',
  NewsTypeDesc = 'newsType_DESC',
  RemovePaddingBottomAsc = 'removePaddingBottom_ASC',
  RemovePaddingBottomDesc = 'removePaddingBottom_DESC',
  RegionAsc = 'region_ASC',
  RegionDesc = 'region_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum BlockImageGalleryLinkingCollectionsBlockHiddenWithConsentCollectionOrder {
  ConsentTypeAsc = 'consentType_ASC',
  ConsentTypeDesc = 'consentType_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export type AssetCollection = {
  __typename?: 'AssetCollection';
  total: Scalars['Int'];
  skip: Scalars['Int'];
  limit: Scalars['Int'];
  items: Array<Maybe<Asset>>;
};

/** A slider block with richt text and image [See type definition](https://app.contentful.com/spaces/0j0b0fue4dp9/content_types/blockSlider) */
export type BlockSlider = Entry & _Node & {
  __typename?: 'BlockSlider';
  sys: Sys;
  contentfulMetadata: ContentfulMetadata;
  linkedFrom?: Maybe<BlockSliderLinkingCollections>;
  _id: Scalars['ID'];
  slidesCollection?: Maybe<BlockSliderSlidesCollection>;
  internalDescription?: Maybe<Scalars['String']>;
};


/** A slider block with richt text and image [See type definition](https://app.contentful.com/spaces/0j0b0fue4dp9/content_types/blockSlider) */
export type BlockSliderLinkedFromArgs = {
  allowedLocales?: Maybe<Array<Maybe<Scalars['String']>>>;
};


/** A slider block with richt text and image [See type definition](https://app.contentful.com/spaces/0j0b0fue4dp9/content_types/blockSlider) */
export type BlockSliderSlidesCollectionArgs = {
  skip?: Maybe<Scalars['Int']>;
  limit?: Maybe<Scalars['Int']>;
  preview?: Maybe<Scalars['Boolean']>;
  locale?: Maybe<Scalars['String']>;
  where?: Maybe<BlockSliderEntryFilter>;
  order?: Maybe<Array<Maybe<BlockSliderSlidesCollectionOrder>>>;
};


/** A slider block with richt text and image [See type definition](https://app.contentful.com/spaces/0j0b0fue4dp9/content_types/blockSlider) */
export type BlockSliderInternalDescriptionArgs = {
  locale?: Maybe<Scalars['String']>;
};

export type BlockSliderLinkingCollections = {
  __typename?: 'BlockSliderLinkingCollections';
  entryCollection?: Maybe<EntryCollection>;
  staticPageCollection?: Maybe<StaticPageCollection>;
  blockHiddenWithConsentCollection?: Maybe<BlockHiddenWithConsentCollection>;
};


export type BlockSliderLinkingCollectionsEntryCollectionArgs = {
  skip?: Maybe<Scalars['Int']>;
  limit?: Maybe<Scalars['Int']>;
  preview?: Maybe<Scalars['Boolean']>;
  locale?: Maybe<Scalars['String']>;
};


export type BlockSliderLinkingCollectionsStaticPageCollectionArgs = {
  skip?: Maybe<Scalars['Int']>;
  limit?: Maybe<Scalars['Int']>;
  preview?: Maybe<Scalars['Boolean']>;
  locale?: Maybe<Scalars['String']>;
  order?: Maybe<Array<Maybe<BlockSliderLinkingCollectionsStaticPageCollectionOrder>>>;
};


export type BlockSliderLinkingCollectionsBlockHiddenWithConsentCollectionArgs = {
  skip?: Maybe<Scalars['Int']>;
  limit?: Maybe<Scalars['Int']>;
  preview?: Maybe<Scalars['Boolean']>;
  locale?: Maybe<Scalars['String']>;
  order?: Maybe<Array<Maybe<BlockSliderLinkingCollectionsBlockHiddenWithConsentCollectionOrder>>>;
};

export enum BlockSliderLinkingCollectionsStaticPageCollectionOrder {
  PageTitleAsc = 'pageTitle_ASC',
  PageTitleDesc = 'pageTitle_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  StandaloneAsc = 'standalone_ASC',
  StandaloneDesc = 'standalone_DESC',
  ShowNewsletterFooterAsc = 'showNewsletterFooter_ASC',
  ShowNewsletterFooterDesc = 'showNewsletterFooter_DESC',
  ShowContactFooterAsc = 'showContactFooter_ASC',
  ShowContactFooterDesc = 'showContactFooter_DESC',
  PageTagAsc = 'pageTag_ASC',
  PageTagDesc = 'pageTag_DESC',
  NewsTypeAsc = 'newsType_ASC',
  NewsTypeDesc = 'newsType_DESC',
  RemovePaddingBottomAsc = 'removePaddingBottom_ASC',
  RemovePaddingBottomDesc = 'removePaddingBottom_DESC',
  RegionAsc = 'region_ASC',
  RegionDesc = 'region_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum BlockSliderLinkingCollectionsBlockHiddenWithConsentCollectionOrder {
  ConsentTypeAsc = 'consentType_ASC',
  ConsentTypeDesc = 'consentType_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export type BlockSliderSlidesCollection = {
  __typename?: 'BlockSliderSlidesCollection';
  total: Scalars['Int'];
  skip: Scalars['Int'];
  limit: Scalars['Int'];
  items: Array<Maybe<BlockSliderEntry>>;
};

/** Child of BlockSlider [See type definition](https://app.contentful.com/spaces/0j0b0fue4dp9/content_types/blockSliderEntry) */
export type BlockSliderEntry = Entry & _Node & {
  __typename?: 'BlockSliderEntry';
  sys: Sys;
  contentfulMetadata: ContentfulMetadata;
  linkedFrom?: Maybe<BlockSliderEntryLinkingCollections>;
  _id: Scalars['ID'];
  richText?: Maybe<BlockSliderEntryRichText>;
  image?: Maybe<Asset>;
  internalDescription?: Maybe<Scalars['String']>;
};


/** Child of BlockSlider [See type definition](https://app.contentful.com/spaces/0j0b0fue4dp9/content_types/blockSliderEntry) */
export type BlockSliderEntryLinkedFromArgs = {
  allowedLocales?: Maybe<Array<Maybe<Scalars['String']>>>;
};


/** Child of BlockSlider [See type definition](https://app.contentful.com/spaces/0j0b0fue4dp9/content_types/blockSliderEntry) */
export type BlockSliderEntryRichTextArgs = {
  locale?: Maybe<Scalars['String']>;
};


/** Child of BlockSlider [See type definition](https://app.contentful.com/spaces/0j0b0fue4dp9/content_types/blockSliderEntry) */
export type BlockSliderEntryImageArgs = {
  preview?: Maybe<Scalars['Boolean']>;
  locale?: Maybe<Scalars['String']>;
};


/** Child of BlockSlider [See type definition](https://app.contentful.com/spaces/0j0b0fue4dp9/content_types/blockSliderEntry) */
export type BlockSliderEntryInternalDescriptionArgs = {
  locale?: Maybe<Scalars['String']>;
};

export type BlockSliderEntryLinkingCollections = {
  __typename?: 'BlockSliderEntryLinkingCollections';
  entryCollection?: Maybe<EntryCollection>;
  blockSliderCollection?: Maybe<BlockSliderCollection>;
};


export type BlockSliderEntryLinkingCollectionsEntryCollectionArgs = {
  skip?: Maybe<Scalars['Int']>;
  limit?: Maybe<Scalars['Int']>;
  preview?: Maybe<Scalars['Boolean']>;
  locale?: Maybe<Scalars['String']>;
};


export type BlockSliderEntryLinkingCollectionsBlockSliderCollectionArgs = {
  skip?: Maybe<Scalars['Int']>;
  limit?: Maybe<Scalars['Int']>;
  preview?: Maybe<Scalars['Boolean']>;
  locale?: Maybe<Scalars['String']>;
  order?: Maybe<Array<Maybe<BlockSliderEntryLinkingCollectionsBlockSliderCollectionOrder>>>;
};

export type BlockSliderCollection = {
  __typename?: 'BlockSliderCollection';
  total: Scalars['Int'];
  skip: Scalars['Int'];
  limit: Scalars['Int'];
  items: Array<Maybe<BlockSlider>>;
};

export enum BlockSliderEntryLinkingCollectionsBlockSliderCollectionOrder {
  InternalDescriptionAsc = 'internalDescription_ASC',
  InternalDescriptionDesc = 'internalDescription_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export type BlockSliderEntryRichText = {
  __typename?: 'BlockSliderEntryRichText';
  json: Scalars['JSON'];
  links: BlockSliderEntryRichTextLinks;
};

export type BlockSliderEntryRichTextLinks = {
  __typename?: 'BlockSliderEntryRichTextLinks';
  entries: BlockSliderEntryRichTextEntries;
  assets: BlockSliderEntryRichTextAssets;
  resources: BlockSliderEntryRichTextResources;
};

export type BlockSliderEntryRichTextEntries = {
  __typename?: 'BlockSliderEntryRichTextEntries';
  inline: Array<Maybe<Entry>>;
  hyperlink: Array<Maybe<Entry>>;
  block: Array<Maybe<Entry>>;
};

export type BlockSliderEntryRichTextAssets = {
  __typename?: 'BlockSliderEntryRichTextAssets';
  hyperlink: Array<Maybe<Asset>>;
  block: Array<Maybe<Asset>>;
};

export type BlockSliderEntryRichTextResources = {
  __typename?: 'BlockSliderEntryRichTextResources';
  block: Array<BlockSliderEntryRichTextResourcesBlock>;
  inline: Array<BlockSliderEntryRichTextResourcesInline>;
  hyperlink: Array<BlockSliderEntryRichTextResourcesHyperlink>;
};

export type BlockSliderEntryRichTextResourcesBlock = ResourceLink & {
  __typename?: 'BlockSliderEntryRichTextResourcesBlock';
  sys: ResourceSys;
};

export type BlockSliderEntryRichTextResourcesInline = ResourceLink & {
  __typename?: 'BlockSliderEntryRichTextResourcesInline';
  sys: ResourceSys;
};

export type BlockSliderEntryRichTextResourcesHyperlink = ResourceLink & {
  __typename?: 'BlockSliderEntryRichTextResourcesHyperlink';
  sys: ResourceSys;
};

export type BlockSliderEntryFilter = {
  sys?: Maybe<SysFilter>;
  contentfulMetadata?: Maybe<ContentfulMetadataFilter>;
  richText_exists?: Maybe<Scalars['Boolean']>;
  richText_contains?: Maybe<Scalars['String']>;
  richText_not_contains?: Maybe<Scalars['String']>;
  image_exists?: Maybe<Scalars['Boolean']>;
  internalDescription_exists?: Maybe<Scalars['Boolean']>;
  internalDescription?: Maybe<Scalars['String']>;
  internalDescription_not?: Maybe<Scalars['String']>;
  internalDescription_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  internalDescription_not_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  internalDescription_contains?: Maybe<Scalars['String']>;
  internalDescription_not_contains?: Maybe<Scalars['String']>;
  OR?: Maybe<Array<Maybe<BlockSliderEntryFilter>>>;
  AND?: Maybe<Array<Maybe<BlockSliderEntryFilter>>>;
};

export enum BlockSliderSlidesCollectionOrder {
  InternalDescriptionAsc = 'internalDescription_ASC',
  InternalDescriptionDesc = 'internalDescription_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

/** [See type definition](https://app.contentful.com/spaces/0j0b0fue4dp9/content_types/blockTextCloud) */
export type BlockTextCloud = Entry & _Node & {
  __typename?: 'BlockTextCloud';
  sys: Sys;
  contentfulMetadata: ContentfulMetadata;
  linkedFrom?: Maybe<BlockTextCloudLinkingCollections>;
  _id: Scalars['ID'];
  fieldName1?: Maybe<Scalars['String']>;
  fieldName2?: Maybe<Scalars['String']>;
  fieldName3?: Maybe<Scalars['String']>;
  fieldName4?: Maybe<Scalars['String']>;
  fieldName5?: Maybe<Scalars['String']>;
};


/** [See type definition](https://app.contentful.com/spaces/0j0b0fue4dp9/content_types/blockTextCloud) */
export type BlockTextCloudLinkedFromArgs = {
  allowedLocales?: Maybe<Array<Maybe<Scalars['String']>>>;
};


/** [See type definition](https://app.contentful.com/spaces/0j0b0fue4dp9/content_types/blockTextCloud) */
export type BlockTextCloudFieldName1Args = {
  locale?: Maybe<Scalars['String']>;
};


/** [See type definition](https://app.contentful.com/spaces/0j0b0fue4dp9/content_types/blockTextCloud) */
export type BlockTextCloudFieldName2Args = {
  locale?: Maybe<Scalars['String']>;
};


/** [See type definition](https://app.contentful.com/spaces/0j0b0fue4dp9/content_types/blockTextCloud) */
export type BlockTextCloudFieldName3Args = {
  locale?: Maybe<Scalars['String']>;
};


/** [See type definition](https://app.contentful.com/spaces/0j0b0fue4dp9/content_types/blockTextCloud) */
export type BlockTextCloudFieldName4Args = {
  locale?: Maybe<Scalars['String']>;
};


/** [See type definition](https://app.contentful.com/spaces/0j0b0fue4dp9/content_types/blockTextCloud) */
export type BlockTextCloudFieldName5Args = {
  locale?: Maybe<Scalars['String']>;
};

export type BlockTextCloudLinkingCollections = {
  __typename?: 'BlockTextCloudLinkingCollections';
  entryCollection?: Maybe<EntryCollection>;
  staticPageCollection?: Maybe<StaticPageCollection>;
  blockHiddenWithConsentCollection?: Maybe<BlockHiddenWithConsentCollection>;
};


export type BlockTextCloudLinkingCollectionsEntryCollectionArgs = {
  skip?: Maybe<Scalars['Int']>;
  limit?: Maybe<Scalars['Int']>;
  preview?: Maybe<Scalars['Boolean']>;
  locale?: Maybe<Scalars['String']>;
};


export type BlockTextCloudLinkingCollectionsStaticPageCollectionArgs = {
  skip?: Maybe<Scalars['Int']>;
  limit?: Maybe<Scalars['Int']>;
  preview?: Maybe<Scalars['Boolean']>;
  locale?: Maybe<Scalars['String']>;
  order?: Maybe<Array<Maybe<BlockTextCloudLinkingCollectionsStaticPageCollectionOrder>>>;
};


export type BlockTextCloudLinkingCollectionsBlockHiddenWithConsentCollectionArgs = {
  skip?: Maybe<Scalars['Int']>;
  limit?: Maybe<Scalars['Int']>;
  preview?: Maybe<Scalars['Boolean']>;
  locale?: Maybe<Scalars['String']>;
  order?: Maybe<Array<Maybe<BlockTextCloudLinkingCollectionsBlockHiddenWithConsentCollectionOrder>>>;
};

export enum BlockTextCloudLinkingCollectionsStaticPageCollectionOrder {
  PageTitleAsc = 'pageTitle_ASC',
  PageTitleDesc = 'pageTitle_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  StandaloneAsc = 'standalone_ASC',
  StandaloneDesc = 'standalone_DESC',
  ShowNewsletterFooterAsc = 'showNewsletterFooter_ASC',
  ShowNewsletterFooterDesc = 'showNewsletterFooter_DESC',
  ShowContactFooterAsc = 'showContactFooter_ASC',
  ShowContactFooterDesc = 'showContactFooter_DESC',
  PageTagAsc = 'pageTag_ASC',
  PageTagDesc = 'pageTag_DESC',
  NewsTypeAsc = 'newsType_ASC',
  NewsTypeDesc = 'newsType_DESC',
  RemovePaddingBottomAsc = 'removePaddingBottom_ASC',
  RemovePaddingBottomDesc = 'removePaddingBottom_DESC',
  RegionAsc = 'region_ASC',
  RegionDesc = 'region_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum BlockTextCloudLinkingCollectionsBlockHiddenWithConsentCollectionOrder {
  ConsentTypeAsc = 'consentType_ASC',
  ConsentTypeDesc = 'consentType_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export type BlockHiddenWithConsentChildBlocksFilter = {
  sys?: Maybe<SysFilter>;
  contentfulMetadata?: Maybe<ContentfulMetadataFilter>;
  OR?: Maybe<Array<Maybe<BlockHiddenWithConsentChildBlocksFilter>>>;
  AND?: Maybe<Array<Maybe<BlockHiddenWithConsentChildBlocksFilter>>>;
};

export enum BlockBigTitleNavigationLinkingCollectionsBlockHiddenWithConsentCollectionOrder {
  ConsentTypeAsc = 'consentType_ASC',
  ConsentTypeDesc = 'consentType_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum BlockBigTitleNavigationLinkingCollectionsBlockOneColumnCollectionOrder {
  InternalDescriptionAsc = 'internalDescription_ASC',
  InternalDescriptionDesc = 'internalDescription_DESC',
  EnableBlackBackgroundAsc = 'enableBlackBackground_ASC',
  EnableBlackBackgroundDesc = 'enableBlackBackground_DESC',
  SmallMainColumnOverImageAsc = 'smallMainColumnOverImage_ASC',
  SmallMainColumnOverImageDesc = 'smallMainColumnOverImage_DESC',
  BackgroundColorAsc = 'backgroundColor_ASC',
  BackgroundColorDesc = 'backgroundColor_DESC',
  PaddingAsc = 'padding_ASC',
  PaddingDesc = 'padding_DESC',
  WithExtraPaddingAsc = 'withExtraPadding_ASC',
  WithExtraPaddingDesc = 'withExtraPadding_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum BlockBigTitleNavigationLinkingCollectionsBlockTwoColumnCollectionOrder {
  InternalDescriptionAsc = 'internalDescription_ASC',
  InternalDescriptionDesc = 'internalDescription_DESC',
  RightColumnOffsetAsc = 'rightColumnOffset_ASC',
  RightColumnOffsetDesc = 'rightColumnOffset_DESC',
  VerticalCenterLeftColumnAsc = 'verticalCenterLeftColumn_ASC',
  VerticalCenterLeftColumnDesc = 'verticalCenterLeftColumn_DESC',
  VerticalCenterRightColumnAsc = 'verticalCenterRightColumn_ASC',
  VerticalCenterRightColumnDesc = 'verticalCenterRightColumn_DESC',
  LeftColumnTextRightAsc = 'leftColumnTextRight_ASC',
  LeftColumnTextRightDesc = 'leftColumnTextRight_DESC',
  VariantAsc = 'variant_ASC',
  VariantDesc = 'variant_DESC',
  MobileColumnOrderAsc = 'mobileColumnOrder_ASC',
  MobileColumnOrderDesc = 'mobileColumnOrder_DESC',
  AppendContactAndNewsletterCtAsAsc = 'appendContactAndNewsletterCTAs_ASC',
  AppendContactAndNewsletterCtAsDesc = 'appendContactAndNewsletterCTAs_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum BlockBigTitleNavigationLinkingCollectionsBlockHighlightRealEstateCollectionOrder {
  InternalDescriptionAsc = 'internalDescription_ASC',
  InternalDescriptionDesc = 'internalDescription_DESC',
  VariantAsc = 'variant_ASC',
  VariantDesc = 'variant_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum BlockBigTitleNavigationLinkingCollectionsProjectPageCollectionOrder {
  InternalNameAsc = 'internal_name_ASC',
  InternalNameDesc = 'internal_name_DESC',
  PropstackProjectIdAsc = 'propstackProjectId_ASC',
  PropstackProjectIdDesc = 'propstackProjectId_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum StaticPageLinkingCollectionsBlockBigTitleNavigationCollectionOrder {
  InternalDescriptionAsc = 'internalDescription_ASC',
  InternalDescriptionDesc = 'internalDescription_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC',
  SubTitleAsc = 'subTitle_ASC',
  SubTitleDesc = 'subTitle_DESC',
  ButtonTextAsc = 'buttonText_ASC',
  ButtonTextDesc = 'buttonText_DESC',
  UrlAsc = 'url_ASC',
  UrlDesc = 'url_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export type NavigationEntryCollection = {
  __typename?: 'NavigationEntryCollection';
  total: Scalars['Int'];
  skip: Scalars['Int'];
  limit: Scalars['Int'];
  items: Array<Maybe<NavigationEntry>>;
};

export enum StaticPageLinkingCollectionsNavigationEntryCollectionOrder {
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC',
  ButtonTextAsc = 'buttonText_ASC',
  ButtonTextDesc = 'buttonText_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

/** [See type definition](https://app.contentful.com/spaces/0j0b0fue4dp9/content_types/seo) */
export type Seo = Entry & _Node & {
  __typename?: 'Seo';
  sys: Sys;
  contentfulMetadata: ContentfulMetadata;
  linkedFrom?: Maybe<SeoLinkingCollections>;
  _id: Scalars['ID'];
  title?: Maybe<Scalars['String']>;
  keywords?: Maybe<Array<Maybe<Scalars['String']>>>;
  description?: Maybe<Scalars['String']>;
  noFollowNoIndex?: Maybe<Scalars['Boolean']>;
};


/** [See type definition](https://app.contentful.com/spaces/0j0b0fue4dp9/content_types/seo) */
export type SeoLinkedFromArgs = {
  allowedLocales?: Maybe<Array<Maybe<Scalars['String']>>>;
};


/** [See type definition](https://app.contentful.com/spaces/0j0b0fue4dp9/content_types/seo) */
export type SeoTitleArgs = {
  locale?: Maybe<Scalars['String']>;
};


/** [See type definition](https://app.contentful.com/spaces/0j0b0fue4dp9/content_types/seo) */
export type SeoKeywordsArgs = {
  locale?: Maybe<Scalars['String']>;
};


/** [See type definition](https://app.contentful.com/spaces/0j0b0fue4dp9/content_types/seo) */
export type SeoDescriptionArgs = {
  locale?: Maybe<Scalars['String']>;
};


/** [See type definition](https://app.contentful.com/spaces/0j0b0fue4dp9/content_types/seo) */
export type SeoNoFollowNoIndexArgs = {
  locale?: Maybe<Scalars['String']>;
};

export type SeoLinkingCollections = {
  __typename?: 'SeoLinkingCollections';
  entryCollection?: Maybe<EntryCollection>;
  regionDescriptionTextCollection?: Maybe<RegionDescriptionTextCollection>;
  staticPageCollection?: Maybe<StaticPageCollection>;
};


export type SeoLinkingCollectionsEntryCollectionArgs = {
  skip?: Maybe<Scalars['Int']>;
  limit?: Maybe<Scalars['Int']>;
  preview?: Maybe<Scalars['Boolean']>;
  locale?: Maybe<Scalars['String']>;
};


export type SeoLinkingCollectionsRegionDescriptionTextCollectionArgs = {
  skip?: Maybe<Scalars['Int']>;
  limit?: Maybe<Scalars['Int']>;
  preview?: Maybe<Scalars['Boolean']>;
  locale?: Maybe<Scalars['String']>;
  order?: Maybe<Array<Maybe<SeoLinkingCollectionsRegionDescriptionTextCollectionOrder>>>;
};


export type SeoLinkingCollectionsStaticPageCollectionArgs = {
  skip?: Maybe<Scalars['Int']>;
  limit?: Maybe<Scalars['Int']>;
  preview?: Maybe<Scalars['Boolean']>;
  locale?: Maybe<Scalars['String']>;
  order?: Maybe<Array<Maybe<SeoLinkingCollectionsStaticPageCollectionOrder>>>;
};

export type RegionDescriptionTextCollection = {
  __typename?: 'RegionDescriptionTextCollection';
  total: Scalars['Int'];
  skip: Scalars['Int'];
  limit: Scalars['Int'];
  items: Array<Maybe<RegionDescriptionText>>;
};

/** Predefined filter that has a SEO friendly slug and statically generated, crawlable contents. The text is displayed at the bottom of the page, mostly for search engines. [See type definition](https://app.contentful.com/spaces/0j0b0fue4dp9/content_types/regionDescriptionText) */
export type RegionDescriptionText = Entry & _Node & {
  __typename?: 'RegionDescriptionText';
  sys: Sys;
  contentfulMetadata: ContentfulMetadata;
  linkedFrom?: Maybe<RegionDescriptionTextLinkingCollections>;
  _id: Scalars['ID'];
  internalDescription?: Maybe<Scalars['String']>;
  slug?: Maybe<Scalars['String']>;
  seo?: Maybe<Seo>;
  regionDescription?: Maybe<RegionDescriptionTextRegionDescription>;
  city?: Maybe<Scalars['String']>;
  location?: Maybe<Scalars['String']>;
  constructionAge?: Maybe<Scalars['String']>;
  otherFilter?: Maybe<Array<Maybe<Scalars['String']>>>;
  rented?: Maybe<Scalars['String']>;
  rsCategory?: Maybe<Array<Maybe<Scalars['String']>>>;
  roomsMin?: Maybe<Scalars['Int']>;
  roomsMax?: Maybe<Scalars['Int']>;
  squareMetersMin?: Maybe<Scalars['Int']>;
  squareMetersMax?: Maybe<Scalars['Int']>;
};


/** Predefined filter that has a SEO friendly slug and statically generated, crawlable contents. The text is displayed at the bottom of the page, mostly for search engines. [See type definition](https://app.contentful.com/spaces/0j0b0fue4dp9/content_types/regionDescriptionText) */
export type RegionDescriptionTextLinkedFromArgs = {
  allowedLocales?: Maybe<Array<Maybe<Scalars['String']>>>;
};


/** Predefined filter that has a SEO friendly slug and statically generated, crawlable contents. The text is displayed at the bottom of the page, mostly for search engines. [See type definition](https://app.contentful.com/spaces/0j0b0fue4dp9/content_types/regionDescriptionText) */
export type RegionDescriptionTextInternalDescriptionArgs = {
  locale?: Maybe<Scalars['String']>;
};


/** Predefined filter that has a SEO friendly slug and statically generated, crawlable contents. The text is displayed at the bottom of the page, mostly for search engines. [See type definition](https://app.contentful.com/spaces/0j0b0fue4dp9/content_types/regionDescriptionText) */
export type RegionDescriptionTextSlugArgs = {
  locale?: Maybe<Scalars['String']>;
};


/** Predefined filter that has a SEO friendly slug and statically generated, crawlable contents. The text is displayed at the bottom of the page, mostly for search engines. [See type definition](https://app.contentful.com/spaces/0j0b0fue4dp9/content_types/regionDescriptionText) */
export type RegionDescriptionTextSeoArgs = {
  preview?: Maybe<Scalars['Boolean']>;
  locale?: Maybe<Scalars['String']>;
  where?: Maybe<SeoFilter>;
};


/** Predefined filter that has a SEO friendly slug and statically generated, crawlable contents. The text is displayed at the bottom of the page, mostly for search engines. [See type definition](https://app.contentful.com/spaces/0j0b0fue4dp9/content_types/regionDescriptionText) */
export type RegionDescriptionTextRegionDescriptionArgs = {
  locale?: Maybe<Scalars['String']>;
};


/** Predefined filter that has a SEO friendly slug and statically generated, crawlable contents. The text is displayed at the bottom of the page, mostly for search engines. [See type definition](https://app.contentful.com/spaces/0j0b0fue4dp9/content_types/regionDescriptionText) */
export type RegionDescriptionTextCityArgs = {
  locale?: Maybe<Scalars['String']>;
};


/** Predefined filter that has a SEO friendly slug and statically generated, crawlable contents. The text is displayed at the bottom of the page, mostly for search engines. [See type definition](https://app.contentful.com/spaces/0j0b0fue4dp9/content_types/regionDescriptionText) */
export type RegionDescriptionTextLocationArgs = {
  locale?: Maybe<Scalars['String']>;
};


/** Predefined filter that has a SEO friendly slug and statically generated, crawlable contents. The text is displayed at the bottom of the page, mostly for search engines. [See type definition](https://app.contentful.com/spaces/0j0b0fue4dp9/content_types/regionDescriptionText) */
export type RegionDescriptionTextConstructionAgeArgs = {
  locale?: Maybe<Scalars['String']>;
};


/** Predefined filter that has a SEO friendly slug and statically generated, crawlable contents. The text is displayed at the bottom of the page, mostly for search engines. [See type definition](https://app.contentful.com/spaces/0j0b0fue4dp9/content_types/regionDescriptionText) */
export type RegionDescriptionTextOtherFilterArgs = {
  locale?: Maybe<Scalars['String']>;
};


/** Predefined filter that has a SEO friendly slug and statically generated, crawlable contents. The text is displayed at the bottom of the page, mostly for search engines. [See type definition](https://app.contentful.com/spaces/0j0b0fue4dp9/content_types/regionDescriptionText) */
export type RegionDescriptionTextRentedArgs = {
  locale?: Maybe<Scalars['String']>;
};


/** Predefined filter that has a SEO friendly slug and statically generated, crawlable contents. The text is displayed at the bottom of the page, mostly for search engines. [See type definition](https://app.contentful.com/spaces/0j0b0fue4dp9/content_types/regionDescriptionText) */
export type RegionDescriptionTextRsCategoryArgs = {
  locale?: Maybe<Scalars['String']>;
};


/** Predefined filter that has a SEO friendly slug and statically generated, crawlable contents. The text is displayed at the bottom of the page, mostly for search engines. [See type definition](https://app.contentful.com/spaces/0j0b0fue4dp9/content_types/regionDescriptionText) */
export type RegionDescriptionTextRoomsMinArgs = {
  locale?: Maybe<Scalars['String']>;
};


/** Predefined filter that has a SEO friendly slug and statically generated, crawlable contents. The text is displayed at the bottom of the page, mostly for search engines. [See type definition](https://app.contentful.com/spaces/0j0b0fue4dp9/content_types/regionDescriptionText) */
export type RegionDescriptionTextRoomsMaxArgs = {
  locale?: Maybe<Scalars['String']>;
};


/** Predefined filter that has a SEO friendly slug and statically generated, crawlable contents. The text is displayed at the bottom of the page, mostly for search engines. [See type definition](https://app.contentful.com/spaces/0j0b0fue4dp9/content_types/regionDescriptionText) */
export type RegionDescriptionTextSquareMetersMinArgs = {
  locale?: Maybe<Scalars['String']>;
};


/** Predefined filter that has a SEO friendly slug and statically generated, crawlable contents. The text is displayed at the bottom of the page, mostly for search engines. [See type definition](https://app.contentful.com/spaces/0j0b0fue4dp9/content_types/regionDescriptionText) */
export type RegionDescriptionTextSquareMetersMaxArgs = {
  locale?: Maybe<Scalars['String']>;
};

export type RegionDescriptionTextLinkingCollections = {
  __typename?: 'RegionDescriptionTextLinkingCollections';
  entryCollection?: Maybe<EntryCollection>;
};


export type RegionDescriptionTextLinkingCollectionsEntryCollectionArgs = {
  skip?: Maybe<Scalars['Int']>;
  limit?: Maybe<Scalars['Int']>;
  preview?: Maybe<Scalars['Boolean']>;
  locale?: Maybe<Scalars['String']>;
};

export type SeoFilter = {
  sys?: Maybe<SysFilter>;
  contentfulMetadata?: Maybe<ContentfulMetadataFilter>;
  title_exists?: Maybe<Scalars['Boolean']>;
  title?: Maybe<Scalars['String']>;
  title_not?: Maybe<Scalars['String']>;
  title_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  title_not_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  title_contains?: Maybe<Scalars['String']>;
  title_not_contains?: Maybe<Scalars['String']>;
  keywords_exists?: Maybe<Scalars['Boolean']>;
  keywords_contains_all?: Maybe<Array<Maybe<Scalars['String']>>>;
  keywords_contains_some?: Maybe<Array<Maybe<Scalars['String']>>>;
  keywords_contains_none?: Maybe<Array<Maybe<Scalars['String']>>>;
  description_exists?: Maybe<Scalars['Boolean']>;
  description?: Maybe<Scalars['String']>;
  description_not?: Maybe<Scalars['String']>;
  description_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  description_not_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  description_contains?: Maybe<Scalars['String']>;
  description_not_contains?: Maybe<Scalars['String']>;
  noFollowNoIndex_exists?: Maybe<Scalars['Boolean']>;
  noFollowNoIndex?: Maybe<Scalars['Boolean']>;
  noFollowNoIndex_not?: Maybe<Scalars['Boolean']>;
  OR?: Maybe<Array<Maybe<SeoFilter>>>;
  AND?: Maybe<Array<Maybe<SeoFilter>>>;
};

export type RegionDescriptionTextRegionDescription = {
  __typename?: 'RegionDescriptionTextRegionDescription';
  json: Scalars['JSON'];
  links: RegionDescriptionTextRegionDescriptionLinks;
};

export type RegionDescriptionTextRegionDescriptionLinks = {
  __typename?: 'RegionDescriptionTextRegionDescriptionLinks';
  entries: RegionDescriptionTextRegionDescriptionEntries;
  assets: RegionDescriptionTextRegionDescriptionAssets;
  resources: RegionDescriptionTextRegionDescriptionResources;
};

export type RegionDescriptionTextRegionDescriptionEntries = {
  __typename?: 'RegionDescriptionTextRegionDescriptionEntries';
  inline: Array<Maybe<Entry>>;
  hyperlink: Array<Maybe<Entry>>;
  block: Array<Maybe<Entry>>;
};

export type RegionDescriptionTextRegionDescriptionAssets = {
  __typename?: 'RegionDescriptionTextRegionDescriptionAssets';
  hyperlink: Array<Maybe<Asset>>;
  block: Array<Maybe<Asset>>;
};

export type RegionDescriptionTextRegionDescriptionResources = {
  __typename?: 'RegionDescriptionTextRegionDescriptionResources';
  block: Array<RegionDescriptionTextRegionDescriptionResourcesBlock>;
  inline: Array<RegionDescriptionTextRegionDescriptionResourcesInline>;
  hyperlink: Array<RegionDescriptionTextRegionDescriptionResourcesHyperlink>;
};

export type RegionDescriptionTextRegionDescriptionResourcesBlock = ResourceLink & {
  __typename?: 'RegionDescriptionTextRegionDescriptionResourcesBlock';
  sys: ResourceSys;
};

export type RegionDescriptionTextRegionDescriptionResourcesInline = ResourceLink & {
  __typename?: 'RegionDescriptionTextRegionDescriptionResourcesInline';
  sys: ResourceSys;
};

export type RegionDescriptionTextRegionDescriptionResourcesHyperlink = ResourceLink & {
  __typename?: 'RegionDescriptionTextRegionDescriptionResourcesHyperlink';
  sys: ResourceSys;
};

export enum SeoLinkingCollectionsRegionDescriptionTextCollectionOrder {
  InternalDescriptionAsc = 'internalDescription_ASC',
  InternalDescriptionDesc = 'internalDescription_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  CityAsc = 'city_ASC',
  CityDesc = 'city_DESC',
  LocationAsc = 'location_ASC',
  LocationDesc = 'location_DESC',
  ConstructionAgeAsc = 'constructionAge_ASC',
  ConstructionAgeDesc = 'constructionAge_DESC',
  RentedAsc = 'rented_ASC',
  RentedDesc = 'rented_DESC',
  RoomsMinAsc = 'roomsMin_ASC',
  RoomsMinDesc = 'roomsMin_DESC',
  RoomsMaxAsc = 'roomsMax_ASC',
  RoomsMaxDesc = 'roomsMax_DESC',
  SquareMetersMinAsc = 'squareMetersMin_ASC',
  SquareMetersMinDesc = 'squareMetersMin_DESC',
  SquareMetersMaxAsc = 'squareMetersMax_ASC',
  SquareMetersMaxDesc = 'squareMetersMax_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum SeoLinkingCollectionsStaticPageCollectionOrder {
  PageTitleAsc = 'pageTitle_ASC',
  PageTitleDesc = 'pageTitle_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  StandaloneAsc = 'standalone_ASC',
  StandaloneDesc = 'standalone_DESC',
  ShowNewsletterFooterAsc = 'showNewsletterFooter_ASC',
  ShowNewsletterFooterDesc = 'showNewsletterFooter_DESC',
  ShowContactFooterAsc = 'showContactFooter_ASC',
  ShowContactFooterDesc = 'showContactFooter_DESC',
  PageTagAsc = 'pageTag_ASC',
  PageTagDesc = 'pageTag_DESC',
  NewsTypeAsc = 'newsType_ASC',
  NewsTypeDesc = 'newsType_DESC',
  RemovePaddingBottomAsc = 'removePaddingBottom_ASC',
  RemovePaddingBottomDesc = 'removePaddingBottom_DESC',
  RegionAsc = 'region_ASC',
  RegionDesc = 'region_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export type HeroImageFilter = {
  sys?: Maybe<SysFilter>;
  contentfulMetadata?: Maybe<ContentfulMetadataFilter>;
  backgroundImage_exists?: Maybe<Scalars['Boolean']>;
  title_exists?: Maybe<Scalars['Boolean']>;
  title?: Maybe<Scalars['String']>;
  title_not?: Maybe<Scalars['String']>;
  title_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  title_not_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  title_contains?: Maybe<Scalars['String']>;
  title_not_contains?: Maybe<Scalars['String']>;
  subtitle_exists?: Maybe<Scalars['Boolean']>;
  subtitle?: Maybe<Scalars['String']>;
  subtitle_not?: Maybe<Scalars['String']>;
  subtitle_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  subtitle_not_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  subtitle_contains?: Maybe<Scalars['String']>;
  subtitle_not_contains?: Maybe<Scalars['String']>;
  size_exists?: Maybe<Scalars['Boolean']>;
  size?: Maybe<Scalars['String']>;
  size_not?: Maybe<Scalars['String']>;
  size_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  size_not_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  size_contains?: Maybe<Scalars['String']>;
  size_not_contains?: Maybe<Scalars['String']>;
  OR?: Maybe<Array<Maybe<HeroImageFilter>>>;
  AND?: Maybe<Array<Maybe<HeroImageFilter>>>;
};

export type StaticPageBlocksCollection = {
  __typename?: 'StaticPageBlocksCollection';
  total: Scalars['Int'];
  skip: Scalars['Int'];
  limit: Scalars['Int'];
  items: Array<Maybe<StaticPageBlocksItem>>;
};

export type StaticPageBlocksItem = BarChartWithBackground | BlockAccordion | BlockAccordionEntry | BlockAnalystRating | BlockBigTitleNavigation | BlockCallToActionButton | BlockCustom | BlockFullsizeImage | BlockHiddenWithConsent | BlockHighlightRealEstate | BlockImageGallery | BlockLinkSection | BlockOneColumn | BlockPartnerGrid | BlockPersonAccordion | BlockRibbon | BlockRichText | BlockSlider | BlockStockPrice | BlockSubNavigation | BlockTable | BlockTextCloud | BlockThreeColumn | BlockTwoColumn | BlockVideo | LatestDownload;

export type StaticPageBlocksFilter = {
  sys?: Maybe<SysFilter>;
  contentfulMetadata?: Maybe<ContentfulMetadataFilter>;
  OR?: Maybe<Array<Maybe<StaticPageBlocksFilter>>>;
  AND?: Maybe<Array<Maybe<StaticPageBlocksFilter>>>;
};

export enum HeroImageLinkingCollectionsStaticPageCollectionOrder {
  PageTitleAsc = 'pageTitle_ASC',
  PageTitleDesc = 'pageTitle_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  StandaloneAsc = 'standalone_ASC',
  StandaloneDesc = 'standalone_DESC',
  ShowNewsletterFooterAsc = 'showNewsletterFooter_ASC',
  ShowNewsletterFooterDesc = 'showNewsletterFooter_DESC',
  ShowContactFooterAsc = 'showContactFooter_ASC',
  ShowContactFooterDesc = 'showContactFooter_DESC',
  PageTagAsc = 'pageTag_ASC',
  PageTagDesc = 'pageTag_DESC',
  NewsTypeAsc = 'newsType_ASC',
  NewsTypeDesc = 'newsType_DESC',
  RemovePaddingBottomAsc = 'removePaddingBottom_ASC',
  RemovePaddingBottomDesc = 'removePaddingBottom_DESC',
  RegionAsc = 'region_ASC',
  RegionDesc = 'region_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export type BlockRibbonCollection = {
  __typename?: 'BlockRibbonCollection';
  total: Scalars['Int'];
  skip: Scalars['Int'];
  limit: Scalars['Int'];
  items: Array<Maybe<BlockRibbon>>;
};

export type BlockSliderEntryCollection = {
  __typename?: 'BlockSliderEntryCollection';
  total: Scalars['Int'];
  skip: Scalars['Int'];
  limit: Scalars['Int'];
  items: Array<Maybe<BlockSliderEntry>>;
};

export type BlockFullsizeImageCollection = {
  __typename?: 'BlockFullsizeImageCollection';
  total: Scalars['Int'];
  skip: Scalars['Int'];
  limit: Scalars['Int'];
  items: Array<Maybe<BlockFullsizeImage>>;
};

export type BlockAnalystRatingCollection = {
  __typename?: 'BlockAnalystRatingCollection';
  total: Scalars['Int'];
  skip: Scalars['Int'];
  limit: Scalars['Int'];
  items: Array<Maybe<BlockAnalystRating>>;
};

export type BlockImageGalleryCollection = {
  __typename?: 'BlockImageGalleryCollection';
  total: Scalars['Int'];
  skip: Scalars['Int'];
  limit: Scalars['Int'];
  items: Array<Maybe<BlockImageGallery>>;
};

export type HighlightedRealEstateCollection = {
  __typename?: 'HighlightedRealEstateCollection';
  total: Scalars['Int'];
  skip: Scalars['Int'];
  limit: Scalars['Int'];
  items: Array<Maybe<HighlightedRealEstate>>;
};

export type PartnerCollection = {
  __typename?: 'PartnerCollection';
  total: Scalars['Int'];
  skip: Scalars['Int'];
  limit: Scalars['Int'];
  items: Array<Maybe<Partner>>;
};

export type ProjectLinkCollection = {
  __typename?: 'ProjectLinkCollection';
  total: Scalars['Int'];
  skip: Scalars['Int'];
  limit: Scalars['Int'];
  items: Array<Maybe<ProjectLink>>;
};

/** [See type definition](https://app.contentful.com/spaces/0j0b0fue4dp9/content_types/projectLink) */
export type ProjectLink = Entry & _Node & {
  __typename?: 'ProjectLink';
  sys: Sys;
  contentfulMetadata: ContentfulMetadata;
  linkedFrom?: Maybe<ProjectLinkLinkingCollections>;
  _id: Scalars['ID'];
  title?: Maybe<Scalars['String']>;
  link?: Maybe<Scalars['String']>;
  backgroundImage?: Maybe<Asset>;
};


/** [See type definition](https://app.contentful.com/spaces/0j0b0fue4dp9/content_types/projectLink) */
export type ProjectLinkLinkedFromArgs = {
  allowedLocales?: Maybe<Array<Maybe<Scalars['String']>>>;
};


/** [See type definition](https://app.contentful.com/spaces/0j0b0fue4dp9/content_types/projectLink) */
export type ProjectLinkTitleArgs = {
  locale?: Maybe<Scalars['String']>;
};


/** [See type definition](https://app.contentful.com/spaces/0j0b0fue4dp9/content_types/projectLink) */
export type ProjectLinkLinkArgs = {
  locale?: Maybe<Scalars['String']>;
};


/** [See type definition](https://app.contentful.com/spaces/0j0b0fue4dp9/content_types/projectLink) */
export type ProjectLinkBackgroundImageArgs = {
  preview?: Maybe<Scalars['Boolean']>;
  locale?: Maybe<Scalars['String']>;
};

export type ProjectLinkLinkingCollections = {
  __typename?: 'ProjectLinkLinkingCollections';
  entryCollection?: Maybe<EntryCollection>;
  blockProjectLinkSectionCollection?: Maybe<BlockProjectLinkSectionCollection>;
};


export type ProjectLinkLinkingCollectionsEntryCollectionArgs = {
  skip?: Maybe<Scalars['Int']>;
  limit?: Maybe<Scalars['Int']>;
  preview?: Maybe<Scalars['Boolean']>;
  locale?: Maybe<Scalars['String']>;
};


export type ProjectLinkLinkingCollectionsBlockProjectLinkSectionCollectionArgs = {
  skip?: Maybe<Scalars['Int']>;
  limit?: Maybe<Scalars['Int']>;
  preview?: Maybe<Scalars['Boolean']>;
  locale?: Maybe<Scalars['String']>;
  order?: Maybe<Array<Maybe<ProjectLinkLinkingCollectionsBlockProjectLinkSectionCollectionOrder>>>;
};

export type BlockProjectLinkSectionCollection = {
  __typename?: 'BlockProjectLinkSectionCollection';
  total: Scalars['Int'];
  skip: Scalars['Int'];
  limit: Scalars['Int'];
  items: Array<Maybe<BlockProjectLinkSection>>;
};

/** A section containing links to external resources (pages, videos etc.) on project pages. [See type definition](https://app.contentful.com/spaces/0j0b0fue4dp9/content_types/blockProjectLinkSection) */
export type BlockProjectLinkSection = Entry & _Node & {
  __typename?: 'BlockProjectLinkSection';
  sys: Sys;
  contentfulMetadata: ContentfulMetadata;
  linkedFrom?: Maybe<BlockProjectLinkSectionLinkingCollections>;
  _id: Scalars['ID'];
  propstackProjectId?: Maybe<Scalars['Int']>;
  title?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  projectLinksCollection?: Maybe<BlockProjectLinkSectionProjectLinksCollection>;
};


/** A section containing links to external resources (pages, videos etc.) on project pages. [See type definition](https://app.contentful.com/spaces/0j0b0fue4dp9/content_types/blockProjectLinkSection) */
export type BlockProjectLinkSectionLinkedFromArgs = {
  allowedLocales?: Maybe<Array<Maybe<Scalars['String']>>>;
};


/** A section containing links to external resources (pages, videos etc.) on project pages. [See type definition](https://app.contentful.com/spaces/0j0b0fue4dp9/content_types/blockProjectLinkSection) */
export type BlockProjectLinkSectionPropstackProjectIdArgs = {
  locale?: Maybe<Scalars['String']>;
};


/** A section containing links to external resources (pages, videos etc.) on project pages. [See type definition](https://app.contentful.com/spaces/0j0b0fue4dp9/content_types/blockProjectLinkSection) */
export type BlockProjectLinkSectionTitleArgs = {
  locale?: Maybe<Scalars['String']>;
};


/** A section containing links to external resources (pages, videos etc.) on project pages. [See type definition](https://app.contentful.com/spaces/0j0b0fue4dp9/content_types/blockProjectLinkSection) */
export type BlockProjectLinkSectionDescriptionArgs = {
  locale?: Maybe<Scalars['String']>;
};


/** A section containing links to external resources (pages, videos etc.) on project pages. [See type definition](https://app.contentful.com/spaces/0j0b0fue4dp9/content_types/blockProjectLinkSection) */
export type BlockProjectLinkSectionProjectLinksCollectionArgs = {
  skip?: Maybe<Scalars['Int']>;
  limit?: Maybe<Scalars['Int']>;
  preview?: Maybe<Scalars['Boolean']>;
  locale?: Maybe<Scalars['String']>;
  where?: Maybe<ProjectLinkFilter>;
  order?: Maybe<Array<Maybe<BlockProjectLinkSectionProjectLinksCollectionOrder>>>;
};

export type BlockProjectLinkSectionLinkingCollections = {
  __typename?: 'BlockProjectLinkSectionLinkingCollections';
  entryCollection?: Maybe<EntryCollection>;
};


export type BlockProjectLinkSectionLinkingCollectionsEntryCollectionArgs = {
  skip?: Maybe<Scalars['Int']>;
  limit?: Maybe<Scalars['Int']>;
  preview?: Maybe<Scalars['Boolean']>;
  locale?: Maybe<Scalars['String']>;
};

export type BlockProjectLinkSectionProjectLinksCollection = {
  __typename?: 'BlockProjectLinkSectionProjectLinksCollection';
  total: Scalars['Int'];
  skip: Scalars['Int'];
  limit: Scalars['Int'];
  items: Array<Maybe<ProjectLink>>;
};

export type ProjectLinkFilter = {
  sys?: Maybe<SysFilter>;
  contentfulMetadata?: Maybe<ContentfulMetadataFilter>;
  title_exists?: Maybe<Scalars['Boolean']>;
  title?: Maybe<Scalars['String']>;
  title_not?: Maybe<Scalars['String']>;
  title_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  title_not_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  title_contains?: Maybe<Scalars['String']>;
  title_not_contains?: Maybe<Scalars['String']>;
  link_exists?: Maybe<Scalars['Boolean']>;
  link?: Maybe<Scalars['String']>;
  link_not?: Maybe<Scalars['String']>;
  link_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  link_not_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  link_contains?: Maybe<Scalars['String']>;
  link_not_contains?: Maybe<Scalars['String']>;
  backgroundImage_exists?: Maybe<Scalars['Boolean']>;
  OR?: Maybe<Array<Maybe<ProjectLinkFilter>>>;
  AND?: Maybe<Array<Maybe<ProjectLinkFilter>>>;
};

export enum BlockProjectLinkSectionProjectLinksCollectionOrder {
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC',
  LinkAsc = 'link_ASC',
  LinkDesc = 'link_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum ProjectLinkLinkingCollectionsBlockProjectLinkSectionCollectionOrder {
  PropstackProjectIdAsc = 'propstackProjectId_ASC',
  PropstackProjectIdDesc = 'propstackProjectId_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export type ProjectImageMapCollection = {
  __typename?: 'ProjectImageMapCollection';
  total: Scalars['Int'];
  skip: Scalars['Int'];
  limit: Scalars['Int'];
  items: Array<Maybe<ProjectImageMap>>;
};

/** [See type definition](https://app.contentful.com/spaces/0j0b0fue4dp9/content_types/projectImageMap) */
export type ProjectImageMap = Entry & _Node & {
  __typename?: 'ProjectImageMap';
  sys: Sys;
  contentfulMetadata: ContentfulMetadata;
  linkedFrom?: Maybe<ProjectImageMapLinkingCollections>;
  _id: Scalars['ID'];
  internalName?: Maybe<Scalars['String']>;
  propstackProjectId?: Maybe<Scalars['Int']>;
  imagesCollection?: Maybe<AssetCollection>;
  imageMapAreas?: Maybe<Scalars['JSON']>;
};


/** [See type definition](https://app.contentful.com/spaces/0j0b0fue4dp9/content_types/projectImageMap) */
export type ProjectImageMapLinkedFromArgs = {
  allowedLocales?: Maybe<Array<Maybe<Scalars['String']>>>;
};


/** [See type definition](https://app.contentful.com/spaces/0j0b0fue4dp9/content_types/projectImageMap) */
export type ProjectImageMapInternalNameArgs = {
  locale?: Maybe<Scalars['String']>;
};


/** [See type definition](https://app.contentful.com/spaces/0j0b0fue4dp9/content_types/projectImageMap) */
export type ProjectImageMapPropstackProjectIdArgs = {
  locale?: Maybe<Scalars['String']>;
};


/** [See type definition](https://app.contentful.com/spaces/0j0b0fue4dp9/content_types/projectImageMap) */
export type ProjectImageMapImagesCollectionArgs = {
  skip?: Maybe<Scalars['Int']>;
  limit?: Maybe<Scalars['Int']>;
  preview?: Maybe<Scalars['Boolean']>;
  locale?: Maybe<Scalars['String']>;
};


/** [See type definition](https://app.contentful.com/spaces/0j0b0fue4dp9/content_types/projectImageMap) */
export type ProjectImageMapImageMapAreasArgs = {
  locale?: Maybe<Scalars['String']>;
};

export type ProjectImageMapLinkingCollections = {
  __typename?: 'ProjectImageMapLinkingCollections';
  entryCollection?: Maybe<EntryCollection>;
};


export type ProjectImageMapLinkingCollectionsEntryCollectionArgs = {
  skip?: Maybe<Scalars['Int']>;
  limit?: Maybe<Scalars['Int']>;
  preview?: Maybe<Scalars['Boolean']>;
  locale?: Maybe<Scalars['String']>;
};

export type DownloadableFileCollection = {
  __typename?: 'DownloadableFileCollection';
  total: Scalars['Int'];
  skip: Scalars['Int'];
  limit: Scalars['Int'];
  items: Array<Maybe<DownloadableFile>>;
};

/** [See type definition](https://app.contentful.com/spaces/0j0b0fue4dp9/content_types/downloadableFile) */
export type DownloadableFile = Entry & _Node & {
  __typename?: 'DownloadableFile';
  sys: Sys;
  contentfulMetadata: ContentfulMetadata;
  linkedFrom?: Maybe<DownloadableFileLinkingCollections>;
  _id: Scalars['ID'];
  title?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
  file?: Maybe<Asset>;
  publishDate?: Maybe<Scalars['DateTime']>;
};


/** [See type definition](https://app.contentful.com/spaces/0j0b0fue4dp9/content_types/downloadableFile) */
export type DownloadableFileLinkedFromArgs = {
  allowedLocales?: Maybe<Array<Maybe<Scalars['String']>>>;
};


/** [See type definition](https://app.contentful.com/spaces/0j0b0fue4dp9/content_types/downloadableFile) */
export type DownloadableFileTitleArgs = {
  locale?: Maybe<Scalars['String']>;
};


/** [See type definition](https://app.contentful.com/spaces/0j0b0fue4dp9/content_types/downloadableFile) */
export type DownloadableFileTypeArgs = {
  locale?: Maybe<Scalars['String']>;
};


/** [See type definition](https://app.contentful.com/spaces/0j0b0fue4dp9/content_types/downloadableFile) */
export type DownloadableFileFileArgs = {
  preview?: Maybe<Scalars['Boolean']>;
  locale?: Maybe<Scalars['String']>;
};


/** [See type definition](https://app.contentful.com/spaces/0j0b0fue4dp9/content_types/downloadableFile) */
export type DownloadableFilePublishDateArgs = {
  locale?: Maybe<Scalars['String']>;
};

export type DownloadableFileLinkingCollections = {
  __typename?: 'DownloadableFileLinkingCollections';
  entryCollection?: Maybe<EntryCollection>;
};


export type DownloadableFileLinkingCollectionsEntryCollectionArgs = {
  skip?: Maybe<Scalars['Int']>;
  limit?: Maybe<Scalars['Int']>;
  preview?: Maybe<Scalars['Boolean']>;
  locale?: Maybe<Scalars['String']>;
};

export type PersonAccordionEntryCollection = {
  __typename?: 'PersonAccordionEntryCollection';
  total: Scalars['Int'];
  skip: Scalars['Int'];
  limit: Scalars['Int'];
  items: Array<Maybe<PersonAccordionEntry>>;
};

export type AssetFilter = {
  sys?: Maybe<SysFilter>;
  contentfulMetadata?: Maybe<ContentfulMetadataFilter>;
  title_exists?: Maybe<Scalars['Boolean']>;
  title?: Maybe<Scalars['String']>;
  title_not?: Maybe<Scalars['String']>;
  title_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  title_not_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  title_contains?: Maybe<Scalars['String']>;
  title_not_contains?: Maybe<Scalars['String']>;
  description_exists?: Maybe<Scalars['Boolean']>;
  description?: Maybe<Scalars['String']>;
  description_not?: Maybe<Scalars['String']>;
  description_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  description_not_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  description_contains?: Maybe<Scalars['String']>;
  description_not_contains?: Maybe<Scalars['String']>;
  url_exists?: Maybe<Scalars['Boolean']>;
  url?: Maybe<Scalars['String']>;
  url_not?: Maybe<Scalars['String']>;
  url_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  url_not_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  url_contains?: Maybe<Scalars['String']>;
  url_not_contains?: Maybe<Scalars['String']>;
  size_exists?: Maybe<Scalars['Boolean']>;
  size?: Maybe<Scalars['Int']>;
  size_not?: Maybe<Scalars['Int']>;
  size_in?: Maybe<Array<Maybe<Scalars['Int']>>>;
  size_not_in?: Maybe<Array<Maybe<Scalars['Int']>>>;
  size_gt?: Maybe<Scalars['Int']>;
  size_gte?: Maybe<Scalars['Int']>;
  size_lt?: Maybe<Scalars['Int']>;
  size_lte?: Maybe<Scalars['Int']>;
  contentType_exists?: Maybe<Scalars['Boolean']>;
  contentType?: Maybe<Scalars['String']>;
  contentType_not?: Maybe<Scalars['String']>;
  contentType_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  contentType_not_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  contentType_contains?: Maybe<Scalars['String']>;
  contentType_not_contains?: Maybe<Scalars['String']>;
  fileName_exists?: Maybe<Scalars['Boolean']>;
  fileName?: Maybe<Scalars['String']>;
  fileName_not?: Maybe<Scalars['String']>;
  fileName_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  fileName_not_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  fileName_contains?: Maybe<Scalars['String']>;
  fileName_not_contains?: Maybe<Scalars['String']>;
  width_exists?: Maybe<Scalars['Boolean']>;
  width?: Maybe<Scalars['Int']>;
  width_not?: Maybe<Scalars['Int']>;
  width_in?: Maybe<Array<Maybe<Scalars['Int']>>>;
  width_not_in?: Maybe<Array<Maybe<Scalars['Int']>>>;
  width_gt?: Maybe<Scalars['Int']>;
  width_gte?: Maybe<Scalars['Int']>;
  width_lt?: Maybe<Scalars['Int']>;
  width_lte?: Maybe<Scalars['Int']>;
  height_exists?: Maybe<Scalars['Boolean']>;
  height?: Maybe<Scalars['Int']>;
  height_not?: Maybe<Scalars['Int']>;
  height_in?: Maybe<Array<Maybe<Scalars['Int']>>>;
  height_not_in?: Maybe<Array<Maybe<Scalars['Int']>>>;
  height_gt?: Maybe<Scalars['Int']>;
  height_gte?: Maybe<Scalars['Int']>;
  height_lt?: Maybe<Scalars['Int']>;
  height_lte?: Maybe<Scalars['Int']>;
  OR?: Maybe<Array<Maybe<AssetFilter>>>;
  AND?: Maybe<Array<Maybe<AssetFilter>>>;
};

export enum AssetOrder {
  UrlAsc = 'url_ASC',
  UrlDesc = 'url_DESC',
  SizeAsc = 'size_ASC',
  SizeDesc = 'size_DESC',
  ContentTypeAsc = 'contentType_ASC',
  ContentTypeDesc = 'contentType_DESC',
  FileNameAsc = 'fileName_ASC',
  FileNameDesc = 'fileName_DESC',
  WidthAsc = 'width_ASC',
  WidthDesc = 'width_DESC',
  HeightAsc = 'height_ASC',
  HeightDesc = 'height_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export type RegionDescriptionTextFilter = {
  seo?: Maybe<CfSeoNestedFilter>;
  sys?: Maybe<SysFilter>;
  contentfulMetadata?: Maybe<ContentfulMetadataFilter>;
  internalDescription_exists?: Maybe<Scalars['Boolean']>;
  internalDescription?: Maybe<Scalars['String']>;
  internalDescription_not?: Maybe<Scalars['String']>;
  internalDescription_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  internalDescription_not_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  internalDescription_contains?: Maybe<Scalars['String']>;
  internalDescription_not_contains?: Maybe<Scalars['String']>;
  slug_exists?: Maybe<Scalars['Boolean']>;
  slug?: Maybe<Scalars['String']>;
  slug_not?: Maybe<Scalars['String']>;
  slug_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  slug_not_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  slug_contains?: Maybe<Scalars['String']>;
  slug_not_contains?: Maybe<Scalars['String']>;
  seo_exists?: Maybe<Scalars['Boolean']>;
  regionDescription_exists?: Maybe<Scalars['Boolean']>;
  regionDescription_contains?: Maybe<Scalars['String']>;
  regionDescription_not_contains?: Maybe<Scalars['String']>;
  city_exists?: Maybe<Scalars['Boolean']>;
  city?: Maybe<Scalars['String']>;
  city_not?: Maybe<Scalars['String']>;
  city_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  city_not_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  city_contains?: Maybe<Scalars['String']>;
  city_not_contains?: Maybe<Scalars['String']>;
  location_exists?: Maybe<Scalars['Boolean']>;
  location?: Maybe<Scalars['String']>;
  location_not?: Maybe<Scalars['String']>;
  location_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  location_not_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  location_contains?: Maybe<Scalars['String']>;
  location_not_contains?: Maybe<Scalars['String']>;
  constructionAge_exists?: Maybe<Scalars['Boolean']>;
  constructionAge?: Maybe<Scalars['String']>;
  constructionAge_not?: Maybe<Scalars['String']>;
  constructionAge_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  constructionAge_not_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  constructionAge_contains?: Maybe<Scalars['String']>;
  constructionAge_not_contains?: Maybe<Scalars['String']>;
  otherFilter_exists?: Maybe<Scalars['Boolean']>;
  otherFilter_contains_all?: Maybe<Array<Maybe<Scalars['String']>>>;
  otherFilter_contains_some?: Maybe<Array<Maybe<Scalars['String']>>>;
  otherFilter_contains_none?: Maybe<Array<Maybe<Scalars['String']>>>;
  rented_exists?: Maybe<Scalars['Boolean']>;
  rented?: Maybe<Scalars['String']>;
  rented_not?: Maybe<Scalars['String']>;
  rented_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  rented_not_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  rented_contains?: Maybe<Scalars['String']>;
  rented_not_contains?: Maybe<Scalars['String']>;
  rsCategory_exists?: Maybe<Scalars['Boolean']>;
  rsCategory_contains_all?: Maybe<Array<Maybe<Scalars['String']>>>;
  rsCategory_contains_some?: Maybe<Array<Maybe<Scalars['String']>>>;
  rsCategory_contains_none?: Maybe<Array<Maybe<Scalars['String']>>>;
  roomsMin_exists?: Maybe<Scalars['Boolean']>;
  roomsMin?: Maybe<Scalars['Int']>;
  roomsMin_not?: Maybe<Scalars['Int']>;
  roomsMin_in?: Maybe<Array<Maybe<Scalars['Int']>>>;
  roomsMin_not_in?: Maybe<Array<Maybe<Scalars['Int']>>>;
  roomsMin_gt?: Maybe<Scalars['Int']>;
  roomsMin_gte?: Maybe<Scalars['Int']>;
  roomsMin_lt?: Maybe<Scalars['Int']>;
  roomsMin_lte?: Maybe<Scalars['Int']>;
  roomsMax_exists?: Maybe<Scalars['Boolean']>;
  roomsMax?: Maybe<Scalars['Int']>;
  roomsMax_not?: Maybe<Scalars['Int']>;
  roomsMax_in?: Maybe<Array<Maybe<Scalars['Int']>>>;
  roomsMax_not_in?: Maybe<Array<Maybe<Scalars['Int']>>>;
  roomsMax_gt?: Maybe<Scalars['Int']>;
  roomsMax_gte?: Maybe<Scalars['Int']>;
  roomsMax_lt?: Maybe<Scalars['Int']>;
  roomsMax_lte?: Maybe<Scalars['Int']>;
  squareMetersMin_exists?: Maybe<Scalars['Boolean']>;
  squareMetersMin?: Maybe<Scalars['Int']>;
  squareMetersMin_not?: Maybe<Scalars['Int']>;
  squareMetersMin_in?: Maybe<Array<Maybe<Scalars['Int']>>>;
  squareMetersMin_not_in?: Maybe<Array<Maybe<Scalars['Int']>>>;
  squareMetersMin_gt?: Maybe<Scalars['Int']>;
  squareMetersMin_gte?: Maybe<Scalars['Int']>;
  squareMetersMin_lt?: Maybe<Scalars['Int']>;
  squareMetersMin_lte?: Maybe<Scalars['Int']>;
  squareMetersMax_exists?: Maybe<Scalars['Boolean']>;
  squareMetersMax?: Maybe<Scalars['Int']>;
  squareMetersMax_not?: Maybe<Scalars['Int']>;
  squareMetersMax_in?: Maybe<Array<Maybe<Scalars['Int']>>>;
  squareMetersMax_not_in?: Maybe<Array<Maybe<Scalars['Int']>>>;
  squareMetersMax_gt?: Maybe<Scalars['Int']>;
  squareMetersMax_gte?: Maybe<Scalars['Int']>;
  squareMetersMax_lt?: Maybe<Scalars['Int']>;
  squareMetersMax_lte?: Maybe<Scalars['Int']>;
  OR?: Maybe<Array<Maybe<RegionDescriptionTextFilter>>>;
  AND?: Maybe<Array<Maybe<RegionDescriptionTextFilter>>>;
};

export enum RegionDescriptionTextOrder {
  InternalDescriptionAsc = 'internalDescription_ASC',
  InternalDescriptionDesc = 'internalDescription_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  CityAsc = 'city_ASC',
  CityDesc = 'city_DESC',
  LocationAsc = 'location_ASC',
  LocationDesc = 'location_DESC',
  ConstructionAgeAsc = 'constructionAge_ASC',
  ConstructionAgeDesc = 'constructionAge_DESC',
  RentedAsc = 'rented_ASC',
  RentedDesc = 'rented_DESC',
  RoomsMinAsc = 'roomsMin_ASC',
  RoomsMinDesc = 'roomsMin_DESC',
  RoomsMaxAsc = 'roomsMax_ASC',
  RoomsMaxDesc = 'roomsMax_DESC',
  SquareMetersMinAsc = 'squareMetersMin_ASC',
  SquareMetersMinDesc = 'squareMetersMin_DESC',
  SquareMetersMaxAsc = 'squareMetersMax_ASC',
  SquareMetersMaxDesc = 'squareMetersMax_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export type BlockTableCollection = {
  __typename?: 'BlockTableCollection';
  total: Scalars['Int'];
  skip: Scalars['Int'];
  limit: Scalars['Int'];
  items: Array<Maybe<BlockTable>>;
};

export type BlockTableFilter = {
  sys?: Maybe<SysFilter>;
  contentfulMetadata?: Maybe<ContentfulMetadataFilter>;
  title_exists?: Maybe<Scalars['Boolean']>;
  title?: Maybe<Scalars['String']>;
  title_not?: Maybe<Scalars['String']>;
  title_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  title_not_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  title_contains?: Maybe<Scalars['String']>;
  title_not_contains?: Maybe<Scalars['String']>;
  table_exists?: Maybe<Scalars['Boolean']>;
  variant_exists?: Maybe<Scalars['Boolean']>;
  variant?: Maybe<Scalars['String']>;
  variant_not?: Maybe<Scalars['String']>;
  variant_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  variant_not_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  variant_contains?: Maybe<Scalars['String']>;
  variant_not_contains?: Maybe<Scalars['String']>;
  OR?: Maybe<Array<Maybe<BlockTableFilter>>>;
  AND?: Maybe<Array<Maybe<BlockTableFilter>>>;
};

export enum BlockTableOrder {
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC',
  VariantAsc = 'variant_ASC',
  VariantDesc = 'variant_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum NavBarEntryOrder {
  LabelAsc = 'label_ASC',
  LabelDesc = 'label_DESC',
  PositionAsc = 'position_ASC',
  PositionDesc = 'position_DESC',
  NavTypeAsc = 'navType_ASC',
  NavTypeDesc = 'navType_DESC',
  UrlAsc = 'url_ASC',
  UrlDesc = 'url_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

/** Footer component that is dispayed within the predesigned Footer at the bottom of the page. The provided content will show up on the left side. There should only be one Footer published at a time, so it is clear to the website which one to show. [See type definition](https://app.contentful.com/spaces/0j0b0fue4dp9/content_types/footer) */
export type Footer = Entry & _Node & {
  __typename?: 'Footer';
  sys: Sys;
  contentfulMetadata: ContentfulMetadata;
  linkedFrom?: Maybe<FooterLinkingCollections>;
  _id: Scalars['ID'];
  internalDescription?: Maybe<Scalars['String']>;
  richtext?: Maybe<FooterRichtext>;
  phone?: Maybe<Scalars['String']>;
  fax?: Maybe<Scalars['String']>;
};


/** Footer component that is dispayed within the predesigned Footer at the bottom of the page. The provided content will show up on the left side. There should only be one Footer published at a time, so it is clear to the website which one to show. [See type definition](https://app.contentful.com/spaces/0j0b0fue4dp9/content_types/footer) */
export type FooterLinkedFromArgs = {
  allowedLocales?: Maybe<Array<Maybe<Scalars['String']>>>;
};


/** Footer component that is dispayed within the predesigned Footer at the bottom of the page. The provided content will show up on the left side. There should only be one Footer published at a time, so it is clear to the website which one to show. [See type definition](https://app.contentful.com/spaces/0j0b0fue4dp9/content_types/footer) */
export type FooterInternalDescriptionArgs = {
  locale?: Maybe<Scalars['String']>;
};


/** Footer component that is dispayed within the predesigned Footer at the bottom of the page. The provided content will show up on the left side. There should only be one Footer published at a time, so it is clear to the website which one to show. [See type definition](https://app.contentful.com/spaces/0j0b0fue4dp9/content_types/footer) */
export type FooterRichtextArgs = {
  locale?: Maybe<Scalars['String']>;
};


/** Footer component that is dispayed within the predesigned Footer at the bottom of the page. The provided content will show up on the left side. There should only be one Footer published at a time, so it is clear to the website which one to show. [See type definition](https://app.contentful.com/spaces/0j0b0fue4dp9/content_types/footer) */
export type FooterPhoneArgs = {
  locale?: Maybe<Scalars['String']>;
};


/** Footer component that is dispayed within the predesigned Footer at the bottom of the page. The provided content will show up on the left side. There should only be one Footer published at a time, so it is clear to the website which one to show. [See type definition](https://app.contentful.com/spaces/0j0b0fue4dp9/content_types/footer) */
export type FooterFaxArgs = {
  locale?: Maybe<Scalars['String']>;
};

export type FooterLinkingCollections = {
  __typename?: 'FooterLinkingCollections';
  entryCollection?: Maybe<EntryCollection>;
};


export type FooterLinkingCollectionsEntryCollectionArgs = {
  skip?: Maybe<Scalars['Int']>;
  limit?: Maybe<Scalars['Int']>;
  preview?: Maybe<Scalars['Boolean']>;
  locale?: Maybe<Scalars['String']>;
};

export type FooterRichtext = {
  __typename?: 'FooterRichtext';
  json: Scalars['JSON'];
  links: FooterRichtextLinks;
};

export type FooterRichtextLinks = {
  __typename?: 'FooterRichtextLinks';
  entries: FooterRichtextEntries;
  assets: FooterRichtextAssets;
  resources: FooterRichtextResources;
};

export type FooterRichtextEntries = {
  __typename?: 'FooterRichtextEntries';
  inline: Array<Maybe<Entry>>;
  hyperlink: Array<Maybe<Entry>>;
  block: Array<Maybe<Entry>>;
};

export type FooterRichtextAssets = {
  __typename?: 'FooterRichtextAssets';
  hyperlink: Array<Maybe<Asset>>;
  block: Array<Maybe<Asset>>;
};

export type FooterRichtextResources = {
  __typename?: 'FooterRichtextResources';
  block: Array<FooterRichtextResourcesBlock>;
  inline: Array<FooterRichtextResourcesInline>;
  hyperlink: Array<FooterRichtextResourcesHyperlink>;
};

export type FooterRichtextResourcesBlock = ResourceLink & {
  __typename?: 'FooterRichtextResourcesBlock';
  sys: ResourceSys;
};

export type FooterRichtextResourcesInline = ResourceLink & {
  __typename?: 'FooterRichtextResourcesInline';
  sys: ResourceSys;
};

export type FooterRichtextResourcesHyperlink = ResourceLink & {
  __typename?: 'FooterRichtextResourcesHyperlink';
  sys: ResourceSys;
};

export type FooterCollection = {
  __typename?: 'FooterCollection';
  total: Scalars['Int'];
  skip: Scalars['Int'];
  limit: Scalars['Int'];
  items: Array<Maybe<Footer>>;
};

export type FooterFilter = {
  sys?: Maybe<SysFilter>;
  contentfulMetadata?: Maybe<ContentfulMetadataFilter>;
  internalDescription_exists?: Maybe<Scalars['Boolean']>;
  internalDescription?: Maybe<Scalars['String']>;
  internalDescription_not?: Maybe<Scalars['String']>;
  internalDescription_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  internalDescription_not_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  internalDescription_contains?: Maybe<Scalars['String']>;
  internalDescription_not_contains?: Maybe<Scalars['String']>;
  richtext_exists?: Maybe<Scalars['Boolean']>;
  richtext_contains?: Maybe<Scalars['String']>;
  richtext_not_contains?: Maybe<Scalars['String']>;
  phone_exists?: Maybe<Scalars['Boolean']>;
  phone?: Maybe<Scalars['String']>;
  phone_not?: Maybe<Scalars['String']>;
  phone_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  phone_not_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  phone_contains?: Maybe<Scalars['String']>;
  phone_not_contains?: Maybe<Scalars['String']>;
  fax_exists?: Maybe<Scalars['Boolean']>;
  fax?: Maybe<Scalars['String']>;
  fax_not?: Maybe<Scalars['String']>;
  fax_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  fax_not_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  fax_contains?: Maybe<Scalars['String']>;
  fax_not_contains?: Maybe<Scalars['String']>;
  OR?: Maybe<Array<Maybe<FooterFilter>>>;
  AND?: Maybe<Array<Maybe<FooterFilter>>>;
};

export enum FooterOrder {
  InternalDescriptionAsc = 'internalDescription_ASC',
  InternalDescriptionDesc = 'internalDescription_DESC',
  PhoneAsc = 'phone_ASC',
  PhoneDesc = 'phone_DESC',
  FaxAsc = 'fax_ASC',
  FaxDesc = 'fax_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export type BlockCustomCollection = {
  __typename?: 'BlockCustomCollection';
  total: Scalars['Int'];
  skip: Scalars['Int'];
  limit: Scalars['Int'];
  items: Array<Maybe<BlockCustom>>;
};

export type BlockCustomFilter = {
  sys?: Maybe<SysFilter>;
  contentfulMetadata?: Maybe<ContentfulMetadataFilter>;
  customBlockType_exists?: Maybe<Scalars['Boolean']>;
  customBlockType?: Maybe<Scalars['String']>;
  customBlockType_not?: Maybe<Scalars['String']>;
  customBlockType_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  customBlockType_not_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  customBlockType_contains?: Maybe<Scalars['String']>;
  customBlockType_not_contains?: Maybe<Scalars['String']>;
  OR?: Maybe<Array<Maybe<BlockCustomFilter>>>;
  AND?: Maybe<Array<Maybe<BlockCustomFilter>>>;
};

export enum BlockCustomOrder {
  CustomBlockTypeAsc = 'customBlockType_ASC',
  CustomBlockTypeDesc = 'customBlockType_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum BlockBigTitleNavigationOrder {
  InternalDescriptionAsc = 'internalDescription_ASC',
  InternalDescriptionDesc = 'internalDescription_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC',
  SubTitleAsc = 'subTitle_ASC',
  SubTitleDesc = 'subTitle_DESC',
  ButtonTextAsc = 'buttonText_ASC',
  ButtonTextDesc = 'buttonText_DESC',
  UrlAsc = 'url_ASC',
  UrlDesc = 'url_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export type SeoCollection = {
  __typename?: 'SeoCollection';
  total: Scalars['Int'];
  skip: Scalars['Int'];
  limit: Scalars['Int'];
  items: Array<Maybe<Seo>>;
};

export enum SeoOrder {
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC',
  NoFollowNoIndexAsc = 'noFollowNoIndex_ASC',
  NoFollowNoIndexDesc = 'noFollowNoIndex_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum StaticPageOrder {
  PageTitleAsc = 'pageTitle_ASC',
  PageTitleDesc = 'pageTitle_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  StandaloneAsc = 'standalone_ASC',
  StandaloneDesc = 'standalone_DESC',
  ShowNewsletterFooterAsc = 'showNewsletterFooter_ASC',
  ShowNewsletterFooterDesc = 'showNewsletterFooter_DESC',
  ShowContactFooterAsc = 'showContactFooter_ASC',
  ShowContactFooterDesc = 'showContactFooter_DESC',
  PageTagAsc = 'pageTag_ASC',
  PageTagDesc = 'pageTag_DESC',
  NewsTypeAsc = 'newsType_ASC',
  NewsTypeDesc = 'newsType_DESC',
  RemovePaddingBottomAsc = 'removePaddingBottom_ASC',
  RemovePaddingBottomDesc = 'removePaddingBottom_DESC',
  RegionAsc = 'region_ASC',
  RegionDesc = 'region_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export type BlockHiddenWithConsentFilter = {
  childBlocks?: Maybe<CfchildBlocksMultiTypeNestedFilter>;
  sys?: Maybe<SysFilter>;
  contentfulMetadata?: Maybe<ContentfulMetadataFilter>;
  consentType_exists?: Maybe<Scalars['Boolean']>;
  consentType?: Maybe<Scalars['String']>;
  consentType_not?: Maybe<Scalars['String']>;
  consentType_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  consentType_not_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  consentType_contains?: Maybe<Scalars['String']>;
  consentType_not_contains?: Maybe<Scalars['String']>;
  childBlocksCollection_exists?: Maybe<Scalars['Boolean']>;
  OR?: Maybe<Array<Maybe<BlockHiddenWithConsentFilter>>>;
  AND?: Maybe<Array<Maybe<BlockHiddenWithConsentFilter>>>;
};

export type CfchildBlocksMultiTypeNestedFilter = {
  sys?: Maybe<SysFilter>;
  contentfulMetadata?: Maybe<ContentfulMetadataFilter>;
  OR?: Maybe<Array<Maybe<CfchildBlocksMultiTypeNestedFilter>>>;
  AND?: Maybe<Array<Maybe<CfchildBlocksMultiTypeNestedFilter>>>;
};

export enum BlockHiddenWithConsentOrder {
  ConsentTypeAsc = 'consentType_ASC',
  ConsentTypeDesc = 'consentType_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export type BlockCallToActionButtonCollection = {
  __typename?: 'BlockCallToActionButtonCollection';
  total: Scalars['Int'];
  skip: Scalars['Int'];
  limit: Scalars['Int'];
  items: Array<Maybe<BlockCallToActionButton>>;
};

export type BlockCallToActionButtonFilter = {
  sys?: Maybe<SysFilter>;
  contentfulMetadata?: Maybe<ContentfulMetadataFilter>;
  label_exists?: Maybe<Scalars['Boolean']>;
  label?: Maybe<Scalars['String']>;
  label_not?: Maybe<Scalars['String']>;
  label_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  label_not_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  label_contains?: Maybe<Scalars['String']>;
  label_not_contains?: Maybe<Scalars['String']>;
  url_exists?: Maybe<Scalars['Boolean']>;
  url?: Maybe<Scalars['String']>;
  url_not?: Maybe<Scalars['String']>;
  url_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  url_not_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  url_contains?: Maybe<Scalars['String']>;
  url_not_contains?: Maybe<Scalars['String']>;
  hideIcon_exists?: Maybe<Scalars['Boolean']>;
  hideIcon?: Maybe<Scalars['Boolean']>;
  hideIcon_not?: Maybe<Scalars['Boolean']>;
  useNewWindow_exists?: Maybe<Scalars['Boolean']>;
  useNewWindow?: Maybe<Scalars['Boolean']>;
  useNewWindow_not?: Maybe<Scalars['Boolean']>;
  color_exists?: Maybe<Scalars['Boolean']>;
  color?: Maybe<Scalars['String']>;
  color_not?: Maybe<Scalars['String']>;
  color_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  color_not_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  color_contains?: Maybe<Scalars['String']>;
  color_not_contains?: Maybe<Scalars['String']>;
  variant_exists?: Maybe<Scalars['Boolean']>;
  variant?: Maybe<Scalars['String']>;
  variant_not?: Maybe<Scalars['String']>;
  variant_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  variant_not_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  variant_contains?: Maybe<Scalars['String']>;
  variant_not_contains?: Maybe<Scalars['String']>;
  OR?: Maybe<Array<Maybe<BlockCallToActionButtonFilter>>>;
  AND?: Maybe<Array<Maybe<BlockCallToActionButtonFilter>>>;
};

export enum BlockCallToActionButtonOrder {
  LabelAsc = 'label_ASC',
  LabelDesc = 'label_DESC',
  UrlAsc = 'url_ASC',
  UrlDesc = 'url_DESC',
  HideIconAsc = 'hideIcon_ASC',
  HideIconDesc = 'hideIcon_DESC',
  UseNewWindowAsc = 'useNewWindow_ASC',
  UseNewWindowDesc = 'useNewWindow_DESC',
  ColorAsc = 'color_ASC',
  ColorDesc = 'color_DESC',
  VariantAsc = 'variant_ASC',
  VariantDesc = 'variant_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum HeroImageOrder {
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC',
  SubtitleAsc = 'subtitle_ASC',
  SubtitleDesc = 'subtitle_DESC',
  SizeAsc = 'size_ASC',
  SizeDesc = 'size_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export type BlockSpeechBubbleCollection = {
  __typename?: 'BlockSpeechBubbleCollection';
  total: Scalars['Int'];
  skip: Scalars['Int'];
  limit: Scalars['Int'];
  items: Array<Maybe<BlockSpeechBubble>>;
};

export type BlockSpeechBubbleFilter = {
  sys?: Maybe<SysFilter>;
  contentfulMetadata?: Maybe<ContentfulMetadataFilter>;
  internalDescription_exists?: Maybe<Scalars['Boolean']>;
  internalDescription?: Maybe<Scalars['String']>;
  internalDescription_not?: Maybe<Scalars['String']>;
  internalDescription_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  internalDescription_not_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  internalDescription_contains?: Maybe<Scalars['String']>;
  internalDescription_not_contains?: Maybe<Scalars['String']>;
  text_exists?: Maybe<Scalars['Boolean']>;
  text?: Maybe<Scalars['String']>;
  text_not?: Maybe<Scalars['String']>;
  text_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  text_not_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  text_contains?: Maybe<Scalars['String']>;
  text_not_contains?: Maybe<Scalars['String']>;
  variant_exists?: Maybe<Scalars['Boolean']>;
  variant?: Maybe<Scalars['String']>;
  variant_not?: Maybe<Scalars['String']>;
  variant_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  variant_not_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  variant_contains?: Maybe<Scalars['String']>;
  variant_not_contains?: Maybe<Scalars['String']>;
  OR?: Maybe<Array<Maybe<BlockSpeechBubbleFilter>>>;
  AND?: Maybe<Array<Maybe<BlockSpeechBubbleFilter>>>;
};

export enum BlockSpeechBubbleOrder {
  InternalDescriptionAsc = 'internalDescription_ASC',
  InternalDescriptionDesc = 'internalDescription_DESC',
  VariantAsc = 'variant_ASC',
  VariantDesc = 'variant_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export type BlockRibbonFilter = {
  sys?: Maybe<SysFilter>;
  contentfulMetadata?: Maybe<ContentfulMetadataFilter>;
  heading1_exists?: Maybe<Scalars['Boolean']>;
  heading1?: Maybe<Scalars['String']>;
  heading1_not?: Maybe<Scalars['String']>;
  heading1_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  heading1_not_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  heading1_contains?: Maybe<Scalars['String']>;
  heading1_not_contains?: Maybe<Scalars['String']>;
  subheading1_exists?: Maybe<Scalars['Boolean']>;
  subheading1?: Maybe<Scalars['String']>;
  subheading1_not?: Maybe<Scalars['String']>;
  subheading1_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  subheading1_not_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  subheading1_contains?: Maybe<Scalars['String']>;
  subheading1_not_contains?: Maybe<Scalars['String']>;
  heading2_exists?: Maybe<Scalars['Boolean']>;
  heading2?: Maybe<Scalars['String']>;
  heading2_not?: Maybe<Scalars['String']>;
  heading2_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  heading2_not_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  heading2_contains?: Maybe<Scalars['String']>;
  heading2_not_contains?: Maybe<Scalars['String']>;
  subheading2_exists?: Maybe<Scalars['Boolean']>;
  subheading2?: Maybe<Scalars['String']>;
  subheading2_not?: Maybe<Scalars['String']>;
  subheading2_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  subheading2_not_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  subheading2_contains?: Maybe<Scalars['String']>;
  subheading2_not_contains?: Maybe<Scalars['String']>;
  heading3_exists?: Maybe<Scalars['Boolean']>;
  heading3?: Maybe<Scalars['String']>;
  heading3_not?: Maybe<Scalars['String']>;
  heading3_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  heading3_not_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  heading3_contains?: Maybe<Scalars['String']>;
  heading3_not_contains?: Maybe<Scalars['String']>;
  subheading3_exists?: Maybe<Scalars['Boolean']>;
  subheading3?: Maybe<Scalars['String']>;
  subheading3_not?: Maybe<Scalars['String']>;
  subheading3_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  subheading3_not_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  subheading3_contains?: Maybe<Scalars['String']>;
  subheading3_not_contains?: Maybe<Scalars['String']>;
  heading4_exists?: Maybe<Scalars['Boolean']>;
  heading4?: Maybe<Scalars['String']>;
  heading4_not?: Maybe<Scalars['String']>;
  heading4_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  heading4_not_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  heading4_contains?: Maybe<Scalars['String']>;
  heading4_not_contains?: Maybe<Scalars['String']>;
  subheading4_exists?: Maybe<Scalars['Boolean']>;
  subheading4?: Maybe<Scalars['String']>;
  subheading4_not?: Maybe<Scalars['String']>;
  subheading4_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  subheading4_not_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  subheading4_contains?: Maybe<Scalars['String']>;
  subheading4_not_contains?: Maybe<Scalars['String']>;
  overlayImage_exists?: Maybe<Scalars['Boolean']>;
  variant_exists?: Maybe<Scalars['Boolean']>;
  variant?: Maybe<Scalars['String']>;
  variant_not?: Maybe<Scalars['String']>;
  variant_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  variant_not_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  variant_contains?: Maybe<Scalars['String']>;
  variant_not_contains?: Maybe<Scalars['String']>;
  OR?: Maybe<Array<Maybe<BlockRibbonFilter>>>;
  AND?: Maybe<Array<Maybe<BlockRibbonFilter>>>;
};

export enum BlockRibbonOrder {
  Heading1Asc = 'heading1_ASC',
  Heading1Desc = 'heading1_DESC',
  Subheading1Asc = 'subheading1_ASC',
  Subheading1Desc = 'subheading1_DESC',
  Heading2Asc = 'heading2_ASC',
  Heading2Desc = 'heading2_DESC',
  Subheading2Asc = 'subheading2_ASC',
  Subheading2Desc = 'subheading2_DESC',
  Heading3Asc = 'heading3_ASC',
  Heading3Desc = 'heading3_DESC',
  Subheading3Asc = 'subheading3_ASC',
  Subheading3Desc = 'subheading3_DESC',
  Heading4Asc = 'heading4_ASC',
  Heading4Desc = 'heading4_DESC',
  Subheading4Asc = 'subheading4_ASC',
  Subheading4Desc = 'subheading4_DESC',
  VariantAsc = 'variant_ASC',
  VariantDesc = 'variant_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum BlockSliderEntryOrder {
  InternalDescriptionAsc = 'internalDescription_ASC',
  InternalDescriptionDesc = 'internalDescription_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export type BlockSliderFilter = {
  slides?: Maybe<CfBlockSliderEntryNestedFilter>;
  sys?: Maybe<SysFilter>;
  contentfulMetadata?: Maybe<ContentfulMetadataFilter>;
  slidesCollection_exists?: Maybe<Scalars['Boolean']>;
  internalDescription_exists?: Maybe<Scalars['Boolean']>;
  internalDescription?: Maybe<Scalars['String']>;
  internalDescription_not?: Maybe<Scalars['String']>;
  internalDescription_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  internalDescription_not_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  internalDescription_contains?: Maybe<Scalars['String']>;
  internalDescription_not_contains?: Maybe<Scalars['String']>;
  OR?: Maybe<Array<Maybe<BlockSliderFilter>>>;
  AND?: Maybe<Array<Maybe<BlockSliderFilter>>>;
};

export type CfBlockSliderEntryNestedFilter = {
  sys?: Maybe<SysFilter>;
  contentfulMetadata?: Maybe<ContentfulMetadataFilter>;
  richText_exists?: Maybe<Scalars['Boolean']>;
  richText_contains?: Maybe<Scalars['String']>;
  richText_not_contains?: Maybe<Scalars['String']>;
  image_exists?: Maybe<Scalars['Boolean']>;
  internalDescription_exists?: Maybe<Scalars['Boolean']>;
  internalDescription?: Maybe<Scalars['String']>;
  internalDescription_not?: Maybe<Scalars['String']>;
  internalDescription_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  internalDescription_not_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  internalDescription_contains?: Maybe<Scalars['String']>;
  internalDescription_not_contains?: Maybe<Scalars['String']>;
  OR?: Maybe<Array<Maybe<CfBlockSliderEntryNestedFilter>>>;
  AND?: Maybe<Array<Maybe<CfBlockSliderEntryNestedFilter>>>;
};

export enum BlockSliderOrder {
  InternalDescriptionAsc = 'internalDescription_ASC',
  InternalDescriptionDesc = 'internalDescription_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export type LexiconArticleFilter = {
  blocks?: Maybe<CfBlockRichTextNestedFilter>;
  sys?: Maybe<SysFilter>;
  contentfulMetadata?: Maybe<ContentfulMetadataFilter>;
  title_exists?: Maybe<Scalars['Boolean']>;
  title?: Maybe<Scalars['String']>;
  title_not?: Maybe<Scalars['String']>;
  title_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  title_not_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  title_contains?: Maybe<Scalars['String']>;
  title_not_contains?: Maybe<Scalars['String']>;
  slug_exists?: Maybe<Scalars['Boolean']>;
  slug?: Maybe<Scalars['String']>;
  slug_not?: Maybe<Scalars['String']>;
  slug_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  slug_not_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  slug_contains?: Maybe<Scalars['String']>;
  slug_not_contains?: Maybe<Scalars['String']>;
  lexiconLetter_exists?: Maybe<Scalars['Boolean']>;
  lexiconLetter?: Maybe<Scalars['String']>;
  lexiconLetter_not?: Maybe<Scalars['String']>;
  lexiconLetter_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  lexiconLetter_not_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  lexiconLetter_contains?: Maybe<Scalars['String']>;
  lexiconLetter_not_contains?: Maybe<Scalars['String']>;
  previewText_exists?: Maybe<Scalars['Boolean']>;
  previewText?: Maybe<Scalars['String']>;
  previewText_not?: Maybe<Scalars['String']>;
  previewText_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  previewText_not_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  previewText_contains?: Maybe<Scalars['String']>;
  previewText_not_contains?: Maybe<Scalars['String']>;
  blocksCollection_exists?: Maybe<Scalars['Boolean']>;
  OR?: Maybe<Array<Maybe<LexiconArticleFilter>>>;
  AND?: Maybe<Array<Maybe<LexiconArticleFilter>>>;
};

export type CfBlockRichTextNestedFilter = {
  sys?: Maybe<SysFilter>;
  contentfulMetadata?: Maybe<ContentfulMetadataFilter>;
  internalDescription_exists?: Maybe<Scalars['Boolean']>;
  internalDescription?: Maybe<Scalars['String']>;
  internalDescription_not?: Maybe<Scalars['String']>;
  internalDescription_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  internalDescription_not_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  internalDescription_contains?: Maybe<Scalars['String']>;
  internalDescription_not_contains?: Maybe<Scalars['String']>;
  richText_exists?: Maybe<Scalars['Boolean']>;
  richText_contains?: Maybe<Scalars['String']>;
  richText_not_contains?: Maybe<Scalars['String']>;
  textAlignCenter_exists?: Maybe<Scalars['Boolean']>;
  textAlignCenter?: Maybe<Scalars['Boolean']>;
  textAlignCenter_not?: Maybe<Scalars['Boolean']>;
  superscript_exists?: Maybe<Scalars['Boolean']>;
  superscript?: Maybe<Scalars['String']>;
  superscript_not?: Maybe<Scalars['String']>;
  superscript_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  superscript_not_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  superscript_contains?: Maybe<Scalars['String']>;
  superscript_not_contains?: Maybe<Scalars['String']>;
  superscriptFontSize_exists?: Maybe<Scalars['Boolean']>;
  superscriptFontSize?: Maybe<Scalars['String']>;
  superscriptFontSize_not?: Maybe<Scalars['String']>;
  superscriptFontSize_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  superscriptFontSize_not_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  superscriptFontSize_contains?: Maybe<Scalars['String']>;
  superscriptFontSize_not_contains?: Maybe<Scalars['String']>;
  OR?: Maybe<Array<Maybe<CfBlockRichTextNestedFilter>>>;
  AND?: Maybe<Array<Maybe<CfBlockRichTextNestedFilter>>>;
};

export enum LexiconArticleOrder {
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  LexiconLetterAsc = 'lexiconLetter_ASC',
  LexiconLetterDesc = 'lexiconLetter_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export type BlockTextCloudCollection = {
  __typename?: 'BlockTextCloudCollection';
  total: Scalars['Int'];
  skip: Scalars['Int'];
  limit: Scalars['Int'];
  items: Array<Maybe<BlockTextCloud>>;
};

export type BlockTextCloudFilter = {
  sys?: Maybe<SysFilter>;
  contentfulMetadata?: Maybe<ContentfulMetadataFilter>;
  fieldName1_exists?: Maybe<Scalars['Boolean']>;
  fieldName1?: Maybe<Scalars['String']>;
  fieldName1_not?: Maybe<Scalars['String']>;
  fieldName1_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  fieldName1_not_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  fieldName1_contains?: Maybe<Scalars['String']>;
  fieldName1_not_contains?: Maybe<Scalars['String']>;
  fieldName2_exists?: Maybe<Scalars['Boolean']>;
  fieldName2?: Maybe<Scalars['String']>;
  fieldName2_not?: Maybe<Scalars['String']>;
  fieldName2_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  fieldName2_not_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  fieldName2_contains?: Maybe<Scalars['String']>;
  fieldName2_not_contains?: Maybe<Scalars['String']>;
  fieldName3_exists?: Maybe<Scalars['Boolean']>;
  fieldName3?: Maybe<Scalars['String']>;
  fieldName3_not?: Maybe<Scalars['String']>;
  fieldName3_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  fieldName3_not_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  fieldName3_contains?: Maybe<Scalars['String']>;
  fieldName3_not_contains?: Maybe<Scalars['String']>;
  fieldName4_exists?: Maybe<Scalars['Boolean']>;
  fieldName4?: Maybe<Scalars['String']>;
  fieldName4_not?: Maybe<Scalars['String']>;
  fieldName4_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  fieldName4_not_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  fieldName4_contains?: Maybe<Scalars['String']>;
  fieldName4_not_contains?: Maybe<Scalars['String']>;
  fieldName5_exists?: Maybe<Scalars['Boolean']>;
  fieldName5?: Maybe<Scalars['String']>;
  fieldName5_not?: Maybe<Scalars['String']>;
  fieldName5_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  fieldName5_not_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  fieldName5_contains?: Maybe<Scalars['String']>;
  fieldName5_not_contains?: Maybe<Scalars['String']>;
  OR?: Maybe<Array<Maybe<BlockTextCloudFilter>>>;
  AND?: Maybe<Array<Maybe<BlockTextCloudFilter>>>;
};

export enum BlockTextCloudOrder {
  FieldName1Asc = 'fieldName1_ASC',
  FieldName1Desc = 'fieldName1_DESC',
  FieldName2Asc = 'fieldName2_ASC',
  FieldName2Desc = 'fieldName2_DESC',
  FieldName3Asc = 'fieldName3_ASC',
  FieldName3Desc = 'fieldName3_DESC',
  FieldName4Asc = 'fieldName4_ASC',
  FieldName4Desc = 'fieldName4_DESC',
  FieldName5Asc = 'fieldName5_ASC',
  FieldName5Desc = 'fieldName5_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export type BlockFullsizeImageFilter = {
  sys?: Maybe<SysFilter>;
  contentfulMetadata?: Maybe<ContentfulMetadataFilter>;
  internalDescription_exists?: Maybe<Scalars['Boolean']>;
  internalDescription?: Maybe<Scalars['String']>;
  internalDescription_not?: Maybe<Scalars['String']>;
  internalDescription_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  internalDescription_not_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  internalDescription_contains?: Maybe<Scalars['String']>;
  internalDescription_not_contains?: Maybe<Scalars['String']>;
  image_exists?: Maybe<Scalars['Boolean']>;
  downloadFile_exists?: Maybe<Scalars['Boolean']>;
  maxWidthParent_exists?: Maybe<Scalars['Boolean']>;
  maxWidthParent?: Maybe<Scalars['Boolean']>;
  maxWidthParent_not?: Maybe<Scalars['Boolean']>;
  OR?: Maybe<Array<Maybe<BlockFullsizeImageFilter>>>;
  AND?: Maybe<Array<Maybe<BlockFullsizeImageFilter>>>;
};

export enum BlockFullsizeImageOrder {
  InternalDescriptionAsc = 'internalDescription_ASC',
  InternalDescriptionDesc = 'internalDescription_DESC',
  MaxWidthParentAsc = 'maxWidthParent_ASC',
  MaxWidthParentDesc = 'maxWidthParent_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export type BlockOneColumnFilter = {
  mainColumn?: Maybe<CfmainColumnMultiTypeNestedFilter>;
  sys?: Maybe<SysFilter>;
  contentfulMetadata?: Maybe<ContentfulMetadataFilter>;
  internalDescription_exists?: Maybe<Scalars['Boolean']>;
  internalDescription?: Maybe<Scalars['String']>;
  internalDescription_not?: Maybe<Scalars['String']>;
  internalDescription_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  internalDescription_not_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  internalDescription_contains?: Maybe<Scalars['String']>;
  internalDescription_not_contains?: Maybe<Scalars['String']>;
  mainColumnCollection_exists?: Maybe<Scalars['Boolean']>;
  enableBlackBackground_exists?: Maybe<Scalars['Boolean']>;
  enableBlackBackground?: Maybe<Scalars['Boolean']>;
  enableBlackBackground_not?: Maybe<Scalars['Boolean']>;
  backgroundImage_exists?: Maybe<Scalars['Boolean']>;
  smallMainColumnOverImage_exists?: Maybe<Scalars['Boolean']>;
  smallMainColumnOverImage?: Maybe<Scalars['Boolean']>;
  smallMainColumnOverImage_not?: Maybe<Scalars['Boolean']>;
  backgroundColor_exists?: Maybe<Scalars['Boolean']>;
  backgroundColor?: Maybe<Scalars['String']>;
  backgroundColor_not?: Maybe<Scalars['String']>;
  backgroundColor_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  backgroundColor_not_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  backgroundColor_contains?: Maybe<Scalars['String']>;
  backgroundColor_not_contains?: Maybe<Scalars['String']>;
  padding_exists?: Maybe<Scalars['Boolean']>;
  padding?: Maybe<Scalars['String']>;
  padding_not?: Maybe<Scalars['String']>;
  padding_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  padding_not_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  padding_contains?: Maybe<Scalars['String']>;
  padding_not_contains?: Maybe<Scalars['String']>;
  withExtraPadding_exists?: Maybe<Scalars['Boolean']>;
  withExtraPadding?: Maybe<Scalars['Boolean']>;
  withExtraPadding_not?: Maybe<Scalars['Boolean']>;
  OR?: Maybe<Array<Maybe<BlockOneColumnFilter>>>;
  AND?: Maybe<Array<Maybe<BlockOneColumnFilter>>>;
};

export type CfmainColumnMultiTypeNestedFilter = {
  sys?: Maybe<SysFilter>;
  contentfulMetadata?: Maybe<ContentfulMetadataFilter>;
  OR?: Maybe<Array<Maybe<CfmainColumnMultiTypeNestedFilter>>>;
  AND?: Maybe<Array<Maybe<CfmainColumnMultiTypeNestedFilter>>>;
};

export enum BlockOneColumnOrder {
  InternalDescriptionAsc = 'internalDescription_ASC',
  InternalDescriptionDesc = 'internalDescription_DESC',
  EnableBlackBackgroundAsc = 'enableBlackBackground_ASC',
  EnableBlackBackgroundDesc = 'enableBlackBackground_DESC',
  SmallMainColumnOverImageAsc = 'smallMainColumnOverImage_ASC',
  SmallMainColumnOverImageDesc = 'smallMainColumnOverImage_DESC',
  BackgroundColorAsc = 'backgroundColor_ASC',
  BackgroundColorDesc = 'backgroundColor_DESC',
  PaddingAsc = 'padding_ASC',
  PaddingDesc = 'padding_DESC',
  WithExtraPaddingAsc = 'withExtraPadding_ASC',
  WithExtraPaddingDesc = 'withExtraPadding_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export type BlockRichTextCollection = {
  __typename?: 'BlockRichTextCollection';
  total: Scalars['Int'];
  skip: Scalars['Int'];
  limit: Scalars['Int'];
  items: Array<Maybe<BlockRichText>>;
};

export enum BlockRichTextOrder {
  InternalDescriptionAsc = 'internalDescription_ASC',
  InternalDescriptionDesc = 'internalDescription_DESC',
  TextAlignCenterAsc = 'textAlignCenter_ASC',
  TextAlignCenterDesc = 'textAlignCenter_DESC',
  SuperscriptAsc = 'superscript_ASC',
  SuperscriptDesc = 'superscript_DESC',
  SuperscriptFontSizeAsc = 'superscriptFontSize_ASC',
  SuperscriptFontSizeDesc = 'superscriptFontSize_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export type BlockTwoColumnFilter = {
  leftColumn?: Maybe<CfleftColumnMultiTypeNestedFilter>;
  rightColumn?: Maybe<CfrightColumnMultiTypeNestedFilter>;
  sys?: Maybe<SysFilter>;
  contentfulMetadata?: Maybe<ContentfulMetadataFilter>;
  internalDescription_exists?: Maybe<Scalars['Boolean']>;
  internalDescription?: Maybe<Scalars['String']>;
  internalDescription_not?: Maybe<Scalars['String']>;
  internalDescription_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  internalDescription_not_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  internalDescription_contains?: Maybe<Scalars['String']>;
  internalDescription_not_contains?: Maybe<Scalars['String']>;
  leftColumnCollection_exists?: Maybe<Scalars['Boolean']>;
  rightColumnCollection_exists?: Maybe<Scalars['Boolean']>;
  rightColumnOffset_exists?: Maybe<Scalars['Boolean']>;
  rightColumnOffset?: Maybe<Scalars['Boolean']>;
  rightColumnOffset_not?: Maybe<Scalars['Boolean']>;
  verticalCenterLeftColumn_exists?: Maybe<Scalars['Boolean']>;
  verticalCenterLeftColumn?: Maybe<Scalars['Boolean']>;
  verticalCenterLeftColumn_not?: Maybe<Scalars['Boolean']>;
  verticalCenterRightColumn_exists?: Maybe<Scalars['Boolean']>;
  verticalCenterRightColumn?: Maybe<Scalars['Boolean']>;
  verticalCenterRightColumn_not?: Maybe<Scalars['Boolean']>;
  leftColumnTextRight_exists?: Maybe<Scalars['Boolean']>;
  leftColumnTextRight?: Maybe<Scalars['Boolean']>;
  leftColumnTextRight_not?: Maybe<Scalars['Boolean']>;
  variant_exists?: Maybe<Scalars['Boolean']>;
  variant?: Maybe<Scalars['String']>;
  variant_not?: Maybe<Scalars['String']>;
  variant_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  variant_not_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  variant_contains?: Maybe<Scalars['String']>;
  variant_not_contains?: Maybe<Scalars['String']>;
  mobileColumnOrder_exists?: Maybe<Scalars['Boolean']>;
  mobileColumnOrder?: Maybe<Scalars['String']>;
  mobileColumnOrder_not?: Maybe<Scalars['String']>;
  mobileColumnOrder_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  mobileColumnOrder_not_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  mobileColumnOrder_contains?: Maybe<Scalars['String']>;
  mobileColumnOrder_not_contains?: Maybe<Scalars['String']>;
  appendContactAndNewsletterCTAs_exists?: Maybe<Scalars['Boolean']>;
  appendContactAndNewsletterCTAs?: Maybe<Scalars['Boolean']>;
  appendContactAndNewsletterCTAs_not?: Maybe<Scalars['Boolean']>;
  OR?: Maybe<Array<Maybe<BlockTwoColumnFilter>>>;
  AND?: Maybe<Array<Maybe<BlockTwoColumnFilter>>>;
};

export type CfleftColumnMultiTypeNestedFilter = {
  sys?: Maybe<SysFilter>;
  contentfulMetadata?: Maybe<ContentfulMetadataFilter>;
  OR?: Maybe<Array<Maybe<CfleftColumnMultiTypeNestedFilter>>>;
  AND?: Maybe<Array<Maybe<CfleftColumnMultiTypeNestedFilter>>>;
};

export type CfrightColumnMultiTypeNestedFilter = {
  sys?: Maybe<SysFilter>;
  contentfulMetadata?: Maybe<ContentfulMetadataFilter>;
  OR?: Maybe<Array<Maybe<CfrightColumnMultiTypeNestedFilter>>>;
  AND?: Maybe<Array<Maybe<CfrightColumnMultiTypeNestedFilter>>>;
};

export enum BlockTwoColumnOrder {
  InternalDescriptionAsc = 'internalDescription_ASC',
  InternalDescriptionDesc = 'internalDescription_DESC',
  RightColumnOffsetAsc = 'rightColumnOffset_ASC',
  RightColumnOffsetDesc = 'rightColumnOffset_DESC',
  VerticalCenterLeftColumnAsc = 'verticalCenterLeftColumn_ASC',
  VerticalCenterLeftColumnDesc = 'verticalCenterLeftColumn_DESC',
  VerticalCenterRightColumnAsc = 'verticalCenterRightColumn_ASC',
  VerticalCenterRightColumnDesc = 'verticalCenterRightColumn_DESC',
  LeftColumnTextRightAsc = 'leftColumnTextRight_ASC',
  LeftColumnTextRightDesc = 'leftColumnTextRight_DESC',
  VariantAsc = 'variant_ASC',
  VariantDesc = 'variant_DESC',
  MobileColumnOrderAsc = 'mobileColumnOrder_ASC',
  MobileColumnOrderDesc = 'mobileColumnOrder_DESC',
  AppendContactAndNewsletterCtAsAsc = 'appendContactAndNewsletterCTAs_ASC',
  AppendContactAndNewsletterCtAsDesc = 'appendContactAndNewsletterCTAs_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export type BlockAccordionFilter = {
  accordionEntry?: Maybe<CfBlockAccordionEntryNestedFilter>;
  sys?: Maybe<SysFilter>;
  contentfulMetadata?: Maybe<ContentfulMetadataFilter>;
  internalDescription_exists?: Maybe<Scalars['Boolean']>;
  internalDescription?: Maybe<Scalars['String']>;
  internalDescription_not?: Maybe<Scalars['String']>;
  internalDescription_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  internalDescription_not_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  internalDescription_contains?: Maybe<Scalars['String']>;
  internalDescription_not_contains?: Maybe<Scalars['String']>;
  accordionEntryCollection_exists?: Maybe<Scalars['Boolean']>;
  aquaColor_exists?: Maybe<Scalars['Boolean']>;
  aquaColor?: Maybe<Scalars['Boolean']>;
  aquaColor_not?: Maybe<Scalars['Boolean']>;
  smallSize_exists?: Maybe<Scalars['Boolean']>;
  smallSize?: Maybe<Scalars['Boolean']>;
  smallSize_not?: Maybe<Scalars['Boolean']>;
  widgetType_exists?: Maybe<Scalars['Boolean']>;
  widgetType?: Maybe<Scalars['String']>;
  widgetType_not?: Maybe<Scalars['String']>;
  widgetType_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  widgetType_not_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  widgetType_contains?: Maybe<Scalars['String']>;
  widgetType_not_contains?: Maybe<Scalars['String']>;
  isControlled_exists?: Maybe<Scalars['Boolean']>;
  isControlled?: Maybe<Scalars['Boolean']>;
  isControlled_not?: Maybe<Scalars['Boolean']>;
  OR?: Maybe<Array<Maybe<BlockAccordionFilter>>>;
  AND?: Maybe<Array<Maybe<BlockAccordionFilter>>>;
};

export type CfBlockAccordionEntryNestedFilter = {
  sys?: Maybe<SysFilter>;
  contentfulMetadata?: Maybe<ContentfulMetadataFilter>;
  title_exists?: Maybe<Scalars['Boolean']>;
  title?: Maybe<Scalars['String']>;
  title_not?: Maybe<Scalars['String']>;
  title_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  title_not_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  title_contains?: Maybe<Scalars['String']>;
  title_not_contains?: Maybe<Scalars['String']>;
  blocksCollection_exists?: Maybe<Scalars['Boolean']>;
  titleWhenExpanded_exists?: Maybe<Scalars['Boolean']>;
  titleWhenExpanded?: Maybe<Scalars['String']>;
  titleWhenExpanded_not?: Maybe<Scalars['String']>;
  titleWhenExpanded_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  titleWhenExpanded_not_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  titleWhenExpanded_contains?: Maybe<Scalars['String']>;
  titleWhenExpanded_not_contains?: Maybe<Scalars['String']>;
  OR?: Maybe<Array<Maybe<CfBlockAccordionEntryNestedFilter>>>;
  AND?: Maybe<Array<Maybe<CfBlockAccordionEntryNestedFilter>>>;
};

export enum BlockAccordionOrder {
  InternalDescriptionAsc = 'internalDescription_ASC',
  InternalDescriptionDesc = 'internalDescription_DESC',
  AquaColorAsc = 'aquaColor_ASC',
  AquaColorDesc = 'aquaColor_DESC',
  SmallSizeAsc = 'smallSize_ASC',
  SmallSizeDesc = 'smallSize_DESC',
  WidgetTypeAsc = 'widgetType_ASC',
  WidgetTypeDesc = 'widgetType_DESC',
  IsControlledAsc = 'isControlled_ASC',
  IsControlledDesc = 'isControlled_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export type BlockAnalystRatingFilter = {
  sys?: Maybe<SysFilter>;
  contentfulMetadata?: Maybe<ContentfulMetadataFilter>;
  name_exists?: Maybe<Scalars['Boolean']>;
  name?: Maybe<Scalars['String']>;
  name_not?: Maybe<Scalars['String']>;
  name_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  name_not_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  name_contains?: Maybe<Scalars['String']>;
  name_not_contains?: Maybe<Scalars['String']>;
  company_exists?: Maybe<Scalars['Boolean']>;
  company?: Maybe<Scalars['String']>;
  company_not?: Maybe<Scalars['String']>;
  company_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  company_not_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  company_contains?: Maybe<Scalars['String']>;
  company_not_contains?: Maybe<Scalars['String']>;
  targetPrice_exists?: Maybe<Scalars['Boolean']>;
  targetPrice?: Maybe<Scalars['Float']>;
  targetPrice_not?: Maybe<Scalars['Float']>;
  targetPrice_in?: Maybe<Array<Maybe<Scalars['Float']>>>;
  targetPrice_not_in?: Maybe<Array<Maybe<Scalars['Float']>>>;
  targetPrice_gt?: Maybe<Scalars['Float']>;
  targetPrice_gte?: Maybe<Scalars['Float']>;
  targetPrice_lt?: Maybe<Scalars['Float']>;
  targetPrice_lte?: Maybe<Scalars['Float']>;
  date_exists?: Maybe<Scalars['Boolean']>;
  date?: Maybe<Scalars['DateTime']>;
  date_not?: Maybe<Scalars['DateTime']>;
  date_in?: Maybe<Array<Maybe<Scalars['DateTime']>>>;
  date_not_in?: Maybe<Array<Maybe<Scalars['DateTime']>>>;
  date_gt?: Maybe<Scalars['DateTime']>;
  date_gte?: Maybe<Scalars['DateTime']>;
  date_lt?: Maybe<Scalars['DateTime']>;
  date_lte?: Maybe<Scalars['DateTime']>;
  recommendation_exists?: Maybe<Scalars['Boolean']>;
  recommendation?: Maybe<Scalars['String']>;
  recommendation_not?: Maybe<Scalars['String']>;
  recommendation_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  recommendation_not_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  recommendation_contains?: Maybe<Scalars['String']>;
  recommendation_not_contains?: Maybe<Scalars['String']>;
  download_exists?: Maybe<Scalars['Boolean']>;
  coverageCurrentlySuspended_exists?: Maybe<Scalars['Boolean']>;
  coverageCurrentlySuspended?: Maybe<Scalars['Boolean']>;
  coverageCurrentlySuspended_not?: Maybe<Scalars['Boolean']>;
  noteText_exists?: Maybe<Scalars['Boolean']>;
  noteText?: Maybe<Scalars['String']>;
  noteText_not?: Maybe<Scalars['String']>;
  noteText_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  noteText_not_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  noteText_contains?: Maybe<Scalars['String']>;
  noteText_not_contains?: Maybe<Scalars['String']>;
  OR?: Maybe<Array<Maybe<BlockAnalystRatingFilter>>>;
  AND?: Maybe<Array<Maybe<BlockAnalystRatingFilter>>>;
};

export enum BlockAnalystRatingOrder {
  NameAsc = 'name_ASC',
  NameDesc = 'name_DESC',
  CompanyAsc = 'company_ASC',
  CompanyDesc = 'company_DESC',
  TargetPriceAsc = 'targetPrice_ASC',
  TargetPriceDesc = 'targetPrice_DESC',
  DateAsc = 'date_ASC',
  DateDesc = 'date_DESC',
  RecommendationAsc = 'recommendation_ASC',
  RecommendationDesc = 'recommendation_DESC',
  CoverageCurrentlySuspendedAsc = 'coverageCurrentlySuspended_ASC',
  CoverageCurrentlySuspendedDesc = 'coverageCurrentlySuspended_DESC',
  NoteTextAsc = 'noteText_ASC',
  NoteTextDesc = 'noteText_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum BlockAccordionEntryOrder {
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC',
  TitleWhenExpandedAsc = 'titleWhenExpanded_ASC',
  TitleWhenExpandedDesc = 'titleWhenExpanded_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export type BlockImageGalleryFilter = {
  sys?: Maybe<SysFilter>;
  contentfulMetadata?: Maybe<ContentfulMetadataFilter>;
  size_exists?: Maybe<Scalars['Boolean']>;
  size?: Maybe<Scalars['String']>;
  size_not?: Maybe<Scalars['String']>;
  size_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  size_not_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  size_contains?: Maybe<Scalars['String']>;
  size_not_contains?: Maybe<Scalars['String']>;
  imagesCollection_exists?: Maybe<Scalars['Boolean']>;
  OR?: Maybe<Array<Maybe<BlockImageGalleryFilter>>>;
  AND?: Maybe<Array<Maybe<BlockImageGalleryFilter>>>;
};

export enum BlockImageGalleryOrder {
  SizeAsc = 'size_ASC',
  SizeDesc = 'size_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export type NewsArticleFilter = {
  blocks?: Maybe<CfblocksMultiTypeNestedFilter>;
  contacts?: Maybe<CfNewsArticleContactNestedFilter>;
  sys?: Maybe<SysFilter>;
  contentfulMetadata?: Maybe<ContentfulMetadataFilter>;
  newsType_exists?: Maybe<Scalars['Boolean']>;
  newsType?: Maybe<Scalars['String']>;
  newsType_not?: Maybe<Scalars['String']>;
  newsType_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  newsType_not_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  newsType_contains?: Maybe<Scalars['String']>;
  newsType_not_contains?: Maybe<Scalars['String']>;
  title_exists?: Maybe<Scalars['Boolean']>;
  title?: Maybe<Scalars['String']>;
  title_not?: Maybe<Scalars['String']>;
  title_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  title_not_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  title_contains?: Maybe<Scalars['String']>;
  title_not_contains?: Maybe<Scalars['String']>;
  slug_exists?: Maybe<Scalars['Boolean']>;
  slug?: Maybe<Scalars['String']>;
  slug_not?: Maybe<Scalars['String']>;
  slug_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  slug_not_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  slug_contains?: Maybe<Scalars['String']>;
  slug_not_contains?: Maybe<Scalars['String']>;
  image_exists?: Maybe<Scalars['Boolean']>;
  date_exists?: Maybe<Scalars['Boolean']>;
  date?: Maybe<Scalars['DateTime']>;
  date_not?: Maybe<Scalars['DateTime']>;
  date_in?: Maybe<Array<Maybe<Scalars['DateTime']>>>;
  date_not_in?: Maybe<Array<Maybe<Scalars['DateTime']>>>;
  date_gt?: Maybe<Scalars['DateTime']>;
  date_gte?: Maybe<Scalars['DateTime']>;
  date_lt?: Maybe<Scalars['DateTime']>;
  date_lte?: Maybe<Scalars['DateTime']>;
  hideDate_exists?: Maybe<Scalars['Boolean']>;
  hideDate?: Maybe<Scalars['Boolean']>;
  hideDate_not?: Maybe<Scalars['Boolean']>;
  previewText_exists?: Maybe<Scalars['Boolean']>;
  previewText?: Maybe<Scalars['String']>;
  previewText_not?: Maybe<Scalars['String']>;
  previewText_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  previewText_not_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  previewText_contains?: Maybe<Scalars['String']>;
  previewText_not_contains?: Maybe<Scalars['String']>;
  blocksCollection_exists?: Maybe<Scalars['Boolean']>;
  contactsCollection_exists?: Maybe<Scalars['Boolean']>;
  file_exists?: Maybe<Scalars['Boolean']>;
  OR?: Maybe<Array<Maybe<NewsArticleFilter>>>;
  AND?: Maybe<Array<Maybe<NewsArticleFilter>>>;
};

export type CfNewsArticleContactNestedFilter = {
  sys?: Maybe<SysFilter>;
  contentfulMetadata?: Maybe<ContentfulMetadataFilter>;
  title_exists?: Maybe<Scalars['Boolean']>;
  title?: Maybe<Scalars['String']>;
  title_not?: Maybe<Scalars['String']>;
  title_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  title_not_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  title_contains?: Maybe<Scalars['String']>;
  title_not_contains?: Maybe<Scalars['String']>;
  fullName_exists?: Maybe<Scalars['Boolean']>;
  fullName?: Maybe<Scalars['String']>;
  fullName_not?: Maybe<Scalars['String']>;
  fullName_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  fullName_not_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  fullName_contains?: Maybe<Scalars['String']>;
  fullName_not_contains?: Maybe<Scalars['String']>;
  company_exists?: Maybe<Scalars['Boolean']>;
  company?: Maybe<Scalars['String']>;
  company_not?: Maybe<Scalars['String']>;
  company_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  company_not_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  company_contains?: Maybe<Scalars['String']>;
  company_not_contains?: Maybe<Scalars['String']>;
  street_exists?: Maybe<Scalars['Boolean']>;
  street?: Maybe<Scalars['String']>;
  street_not?: Maybe<Scalars['String']>;
  street_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  street_not_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  street_contains?: Maybe<Scalars['String']>;
  street_not_contains?: Maybe<Scalars['String']>;
  postcode_exists?: Maybe<Scalars['Boolean']>;
  postcode?: Maybe<Scalars['String']>;
  postcode_not?: Maybe<Scalars['String']>;
  postcode_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  postcode_not_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  postcode_contains?: Maybe<Scalars['String']>;
  postcode_not_contains?: Maybe<Scalars['String']>;
  email_exists?: Maybe<Scalars['Boolean']>;
  email?: Maybe<Scalars['String']>;
  email_not?: Maybe<Scalars['String']>;
  email_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  email_not_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  email_contains?: Maybe<Scalars['String']>;
  email_not_contains?: Maybe<Scalars['String']>;
  telefon_exists?: Maybe<Scalars['Boolean']>;
  telefon?: Maybe<Scalars['String']>;
  telefon_not?: Maybe<Scalars['String']>;
  telefon_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  telefon_not_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  telefon_contains?: Maybe<Scalars['String']>;
  telefon_not_contains?: Maybe<Scalars['String']>;
  OR?: Maybe<Array<Maybe<CfNewsArticleContactNestedFilter>>>;
  AND?: Maybe<Array<Maybe<CfNewsArticleContactNestedFilter>>>;
};

export enum NewsArticleOrder {
  NewsTypeAsc = 'newsType_ASC',
  NewsTypeDesc = 'newsType_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  DateAsc = 'date_ASC',
  DateDesc = 'date_DESC',
  HideDateAsc = 'hideDate_ASC',
  HideDateDesc = 'hideDate_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export type BlockSubNavigationFilter = {
  navBarEntries?: Maybe<CfNavBarEntryNestedFilter>;
  sys?: Maybe<SysFilter>;
  contentfulMetadata?: Maybe<ContentfulMetadataFilter>;
  internalDescription_exists?: Maybe<Scalars['Boolean']>;
  internalDescription?: Maybe<Scalars['String']>;
  internalDescription_not?: Maybe<Scalars['String']>;
  internalDescription_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  internalDescription_not_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  internalDescription_contains?: Maybe<Scalars['String']>;
  internalDescription_not_contains?: Maybe<Scalars['String']>;
  navBarEntriesCollection_exists?: Maybe<Scalars['Boolean']>;
  OR?: Maybe<Array<Maybe<BlockSubNavigationFilter>>>;
  AND?: Maybe<Array<Maybe<BlockSubNavigationFilter>>>;
};

export enum BlockSubNavigationOrder {
  InternalDescriptionAsc = 'internalDescription_ASC',
  InternalDescriptionDesc = 'internalDescription_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export type BlockHighlightRealEstateFilter = {
  bigTitleNavigation?: Maybe<CfBlockBigTitleNavigationNestedFilter>;
  highlightedRealEstates?: Maybe<CfHighlightedRealEstateNestedFilter>;
  sys?: Maybe<SysFilter>;
  contentfulMetadata?: Maybe<ContentfulMetadataFilter>;
  internalDescription_exists?: Maybe<Scalars['Boolean']>;
  internalDescription?: Maybe<Scalars['String']>;
  internalDescription_not?: Maybe<Scalars['String']>;
  internalDescription_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  internalDescription_not_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  internalDescription_contains?: Maybe<Scalars['String']>;
  internalDescription_not_contains?: Maybe<Scalars['String']>;
  bigTitleNavigation_exists?: Maybe<Scalars['Boolean']>;
  highlightedRealEstatesCollection_exists?: Maybe<Scalars['Boolean']>;
  variant_exists?: Maybe<Scalars['Boolean']>;
  variant?: Maybe<Scalars['String']>;
  variant_not?: Maybe<Scalars['String']>;
  variant_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  variant_not_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  variant_contains?: Maybe<Scalars['String']>;
  variant_not_contains?: Maybe<Scalars['String']>;
  OR?: Maybe<Array<Maybe<BlockHighlightRealEstateFilter>>>;
  AND?: Maybe<Array<Maybe<BlockHighlightRealEstateFilter>>>;
};

export type CfBlockBigTitleNavigationNestedFilter = {
  sys?: Maybe<SysFilter>;
  contentfulMetadata?: Maybe<ContentfulMetadataFilter>;
  internalDescription_exists?: Maybe<Scalars['Boolean']>;
  internalDescription?: Maybe<Scalars['String']>;
  internalDescription_not?: Maybe<Scalars['String']>;
  internalDescription_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  internalDescription_not_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  internalDescription_contains?: Maybe<Scalars['String']>;
  internalDescription_not_contains?: Maybe<Scalars['String']>;
  title_exists?: Maybe<Scalars['Boolean']>;
  title?: Maybe<Scalars['String']>;
  title_not?: Maybe<Scalars['String']>;
  title_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  title_not_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  title_contains?: Maybe<Scalars['String']>;
  title_not_contains?: Maybe<Scalars['String']>;
  subTitle_exists?: Maybe<Scalars['Boolean']>;
  subTitle?: Maybe<Scalars['String']>;
  subTitle_not?: Maybe<Scalars['String']>;
  subTitle_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  subTitle_not_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  subTitle_contains?: Maybe<Scalars['String']>;
  subTitle_not_contains?: Maybe<Scalars['String']>;
  staticPageReference_exists?: Maybe<Scalars['Boolean']>;
  buttonText_exists?: Maybe<Scalars['Boolean']>;
  buttonText?: Maybe<Scalars['String']>;
  buttonText_not?: Maybe<Scalars['String']>;
  buttonText_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  buttonText_not_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  buttonText_contains?: Maybe<Scalars['String']>;
  buttonText_not_contains?: Maybe<Scalars['String']>;
  additionalInfoText_exists?: Maybe<Scalars['Boolean']>;
  additionalInfoText?: Maybe<Scalars['String']>;
  additionalInfoText_not?: Maybe<Scalars['String']>;
  additionalInfoText_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  additionalInfoText_not_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  additionalInfoText_contains?: Maybe<Scalars['String']>;
  additionalInfoText_not_contains?: Maybe<Scalars['String']>;
  url_exists?: Maybe<Scalars['Boolean']>;
  url?: Maybe<Scalars['String']>;
  url_not?: Maybe<Scalars['String']>;
  url_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  url_not_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  url_contains?: Maybe<Scalars['String']>;
  url_not_contains?: Maybe<Scalars['String']>;
  OR?: Maybe<Array<Maybe<CfBlockBigTitleNavigationNestedFilter>>>;
  AND?: Maybe<Array<Maybe<CfBlockBigTitleNavigationNestedFilter>>>;
};

export type CfHighlightedRealEstateNestedFilter = {
  sys?: Maybe<SysFilter>;
  contentfulMetadata?: Maybe<ContentfulMetadataFilter>;
  internalDescription_exists?: Maybe<Scalars['Boolean']>;
  internalDescription?: Maybe<Scalars['String']>;
  internalDescription_not?: Maybe<Scalars['String']>;
  internalDescription_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  internalDescription_not_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  internalDescription_contains?: Maybe<Scalars['String']>;
  internalDescription_not_contains?: Maybe<Scalars['String']>;
  title_exists?: Maybe<Scalars['Boolean']>;
  title?: Maybe<Scalars['String']>;
  title_not?: Maybe<Scalars['String']>;
  title_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  title_not_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  title_contains?: Maybe<Scalars['String']>;
  title_not_contains?: Maybe<Scalars['String']>;
  subTitle_exists?: Maybe<Scalars['Boolean']>;
  subTitle?: Maybe<Scalars['String']>;
  subTitle_not?: Maybe<Scalars['String']>;
  subTitle_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  subTitle_not_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  subTitle_contains?: Maybe<Scalars['String']>;
  subTitle_not_contains?: Maybe<Scalars['String']>;
  rooms_exists?: Maybe<Scalars['Boolean']>;
  rooms?: Maybe<Scalars['String']>;
  rooms_not?: Maybe<Scalars['String']>;
  rooms_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  rooms_not_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  rooms_contains?: Maybe<Scalars['String']>;
  rooms_not_contains?: Maybe<Scalars['String']>;
  squareMeter_exists?: Maybe<Scalars['Boolean']>;
  squareMeter?: Maybe<Scalars['String']>;
  squareMeter_not?: Maybe<Scalars['String']>;
  squareMeter_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  squareMeter_not_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  squareMeter_contains?: Maybe<Scalars['String']>;
  squareMeter_not_contains?: Maybe<Scalars['String']>;
  price_exists?: Maybe<Scalars['Boolean']>;
  price?: Maybe<Scalars['String']>;
  price_not?: Maybe<Scalars['String']>;
  price_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  price_not_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  price_contains?: Maybe<Scalars['String']>;
  price_not_contains?: Maybe<Scalars['String']>;
  pricePerSquareMeter_exists?: Maybe<Scalars['Boolean']>;
  pricePerSquareMeter?: Maybe<Scalars['String']>;
  pricePerSquareMeter_not?: Maybe<Scalars['String']>;
  pricePerSquareMeter_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  pricePerSquareMeter_not_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  pricePerSquareMeter_contains?: Maybe<Scalars['String']>;
  pricePerSquareMeter_not_contains?: Maybe<Scalars['String']>;
  slug_exists?: Maybe<Scalars['Boolean']>;
  slug?: Maybe<Scalars['String']>;
  slug_not?: Maybe<Scalars['String']>;
  slug_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  slug_not_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  slug_contains?: Maybe<Scalars['String']>;
  slug_not_contains?: Maybe<Scalars['String']>;
  image_exists?: Maybe<Scalars['Boolean']>;
  isComingSoonProject_exists?: Maybe<Scalars['Boolean']>;
  isComingSoonProject?: Maybe<Scalars['Boolean']>;
  isComingSoonProject_not?: Maybe<Scalars['Boolean']>;
  OR?: Maybe<Array<Maybe<CfHighlightedRealEstateNestedFilter>>>;
  AND?: Maybe<Array<Maybe<CfHighlightedRealEstateNestedFilter>>>;
};

export enum BlockHighlightRealEstateOrder {
  InternalDescriptionAsc = 'internalDescription_ASC',
  InternalDescriptionDesc = 'internalDescription_DESC',
  VariantAsc = 'variant_ASC',
  VariantDesc = 'variant_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum HighlightedRealEstateOrder {
  InternalDescriptionAsc = 'internalDescription_ASC',
  InternalDescriptionDesc = 'internalDescription_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC',
  SubTitleAsc = 'subTitle_ASC',
  SubTitleDesc = 'subTitle_DESC',
  RoomsAsc = 'rooms_ASC',
  RoomsDesc = 'rooms_DESC',
  SquareMeterAsc = 'squareMeter_ASC',
  SquareMeterDesc = 'squareMeter_DESC',
  PriceAsc = 'price_ASC',
  PriceDesc = 'price_DESC',
  PricePerSquareMeterAsc = 'pricePerSquareMeter_ASC',
  PricePerSquareMeterDesc = 'pricePerSquareMeter_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  IsComingSoonProjectAsc = 'isComingSoonProject_ASC',
  IsComingSoonProjectDesc = 'isComingSoonProject_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export type BlockLinkSectionFilter = {
  linkSectionEntries?: Maybe<CfLinkSectionEntryNestedFilter>;
  sys?: Maybe<SysFilter>;
  contentfulMetadata?: Maybe<ContentfulMetadataFilter>;
  title_exists?: Maybe<Scalars['Boolean']>;
  title?: Maybe<Scalars['String']>;
  title_not?: Maybe<Scalars['String']>;
  title_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  title_not_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  title_contains?: Maybe<Scalars['String']>;
  title_not_contains?: Maybe<Scalars['String']>;
  linkSectionEntriesCollection_exists?: Maybe<Scalars['Boolean']>;
  OR?: Maybe<Array<Maybe<BlockLinkSectionFilter>>>;
  AND?: Maybe<Array<Maybe<BlockLinkSectionFilter>>>;
};

export type CfLinkSectionEntryNestedFilter = {
  sys?: Maybe<SysFilter>;
  contentfulMetadata?: Maybe<ContentfulMetadataFilter>;
  title_exists?: Maybe<Scalars['Boolean']>;
  title?: Maybe<Scalars['String']>;
  title_not?: Maybe<Scalars['String']>;
  title_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  title_not_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  title_contains?: Maybe<Scalars['String']>;
  title_not_contains?: Maybe<Scalars['String']>;
  subTitle_exists?: Maybe<Scalars['Boolean']>;
  subTitle?: Maybe<Scalars['String']>;
  subTitle_not?: Maybe<Scalars['String']>;
  subTitle_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  subTitle_not_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  subTitle_contains?: Maybe<Scalars['String']>;
  subTitle_not_contains?: Maybe<Scalars['String']>;
  href_exists?: Maybe<Scalars['Boolean']>;
  href?: Maybe<Scalars['String']>;
  href_not?: Maybe<Scalars['String']>;
  href_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  href_not_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  href_contains?: Maybe<Scalars['String']>;
  href_not_contains?: Maybe<Scalars['String']>;
  OR?: Maybe<Array<Maybe<CfLinkSectionEntryNestedFilter>>>;
  AND?: Maybe<Array<Maybe<CfLinkSectionEntryNestedFilter>>>;
};

export enum BlockLinkSectionOrder {
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export type LinkSectionEntryCollection = {
  __typename?: 'LinkSectionEntryCollection';
  total: Scalars['Int'];
  skip: Scalars['Int'];
  limit: Scalars['Int'];
  items: Array<Maybe<LinkSectionEntry>>;
};

export enum LinkSectionEntryOrder {
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC',
  SubTitleAsc = 'subTitle_ASC',
  SubTitleDesc = 'subTitle_DESC',
  HrefAsc = 'href_ASC',
  HrefDesc = 'href_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export type ProjectPageFilter = {
  blocksBelowImages?: Maybe<CfblocksBelowImagesMultiTypeNestedFilter>;
  sys?: Maybe<SysFilter>;
  contentfulMetadata?: Maybe<ContentfulMetadataFilter>;
  internal_name_exists?: Maybe<Scalars['Boolean']>;
  internal_name?: Maybe<Scalars['String']>;
  internal_name_not?: Maybe<Scalars['String']>;
  internal_name_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  internal_name_not_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  internal_name_contains?: Maybe<Scalars['String']>;
  internal_name_not_contains?: Maybe<Scalars['String']>;
  propstackProjectId_exists?: Maybe<Scalars['Boolean']>;
  propstackProjectId?: Maybe<Scalars['Int']>;
  propstackProjectId_not?: Maybe<Scalars['Int']>;
  propstackProjectId_in?: Maybe<Array<Maybe<Scalars['Int']>>>;
  propstackProjectId_not_in?: Maybe<Array<Maybe<Scalars['Int']>>>;
  propstackProjectId_gt?: Maybe<Scalars['Int']>;
  propstackProjectId_gte?: Maybe<Scalars['Int']>;
  propstackProjectId_lt?: Maybe<Scalars['Int']>;
  propstackProjectId_lte?: Maybe<Scalars['Int']>;
  blocksBelowImagesCollection_exists?: Maybe<Scalars['Boolean']>;
  OR?: Maybe<Array<Maybe<ProjectPageFilter>>>;
  AND?: Maybe<Array<Maybe<ProjectPageFilter>>>;
};

export type CfblocksBelowImagesMultiTypeNestedFilter = {
  sys?: Maybe<SysFilter>;
  contentfulMetadata?: Maybe<ContentfulMetadataFilter>;
  OR?: Maybe<Array<Maybe<CfblocksBelowImagesMultiTypeNestedFilter>>>;
  AND?: Maybe<Array<Maybe<CfblocksBelowImagesMultiTypeNestedFilter>>>;
};

export enum ProjectPageOrder {
  InternalNameAsc = 'internal_name_ASC',
  InternalNameDesc = 'internal_name_DESC',
  PropstackProjectIdAsc = 'propstackProjectId_ASC',
  PropstackProjectIdDesc = 'propstackProjectId_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export type BlockVideoCollection = {
  __typename?: 'BlockVideoCollection';
  total: Scalars['Int'];
  skip: Scalars['Int'];
  limit: Scalars['Int'];
  items: Array<Maybe<BlockVideo>>;
};

export type BlockVideoFilter = {
  sys?: Maybe<SysFilter>;
  contentfulMetadata?: Maybe<ContentfulMetadataFilter>;
  internalName_exists?: Maybe<Scalars['Boolean']>;
  internalName?: Maybe<Scalars['String']>;
  internalName_not?: Maybe<Scalars['String']>;
  internalName_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  internalName_not_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  internalName_contains?: Maybe<Scalars['String']>;
  internalName_not_contains?: Maybe<Scalars['String']>;
  headline_exists?: Maybe<Scalars['Boolean']>;
  headline?: Maybe<Scalars['String']>;
  headline_not?: Maybe<Scalars['String']>;
  headline_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  headline_not_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  headline_contains?: Maybe<Scalars['String']>;
  headline_not_contains?: Maybe<Scalars['String']>;
  href_exists?: Maybe<Scalars['Boolean']>;
  href?: Maybe<Scalars['String']>;
  href_not?: Maybe<Scalars['String']>;
  href_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  href_not_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  href_contains?: Maybe<Scalars['String']>;
  href_not_contains?: Maybe<Scalars['String']>;
  OR?: Maybe<Array<Maybe<BlockVideoFilter>>>;
  AND?: Maybe<Array<Maybe<BlockVideoFilter>>>;
};

export enum BlockVideoOrder {
  InternalNameAsc = 'internalName_ASC',
  InternalNameDesc = 'internalName_DESC',
  HeadlineAsc = 'headline_ASC',
  HeadlineDesc = 'headline_DESC',
  HrefAsc = 'href_ASC',
  HrefDesc = 'href_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum PartnerOrder {
  InternalDescriptionAsc = 'internalDescription_ASC',
  InternalDescriptionDesc = 'internalDescription_DESC',
  PartnerTextAsc = 'partnerText_ASC',
  PartnerTextDesc = 'partnerText_DESC',
  HrefAsc = 'href_ASC',
  HrefDesc = 'href_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum ProjectLinkOrder {
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC',
  LinkAsc = 'link_ASC',
  LinkDesc = 'link_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export type ProjectImageMapFilter = {
  sys?: Maybe<SysFilter>;
  contentfulMetadata?: Maybe<ContentfulMetadataFilter>;
  internal_name_exists?: Maybe<Scalars['Boolean']>;
  internal_name?: Maybe<Scalars['String']>;
  internal_name_not?: Maybe<Scalars['String']>;
  internal_name_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  internal_name_not_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  internal_name_contains?: Maybe<Scalars['String']>;
  internal_name_not_contains?: Maybe<Scalars['String']>;
  propstackProjectId_exists?: Maybe<Scalars['Boolean']>;
  propstackProjectId?: Maybe<Scalars['Int']>;
  propstackProjectId_not?: Maybe<Scalars['Int']>;
  propstackProjectId_in?: Maybe<Array<Maybe<Scalars['Int']>>>;
  propstackProjectId_not_in?: Maybe<Array<Maybe<Scalars['Int']>>>;
  propstackProjectId_gt?: Maybe<Scalars['Int']>;
  propstackProjectId_gte?: Maybe<Scalars['Int']>;
  propstackProjectId_lt?: Maybe<Scalars['Int']>;
  propstackProjectId_lte?: Maybe<Scalars['Int']>;
  imagesCollection_exists?: Maybe<Scalars['Boolean']>;
  imageMapAreas_exists?: Maybe<Scalars['Boolean']>;
  OR?: Maybe<Array<Maybe<ProjectImageMapFilter>>>;
  AND?: Maybe<Array<Maybe<ProjectImageMapFilter>>>;
};

export enum ProjectImageMapOrder {
  InternalNameAsc = 'internal_name_ASC',
  InternalNameDesc = 'internal_name_DESC',
  PropstackProjectIdAsc = 'propstackProjectId_ASC',
  PropstackProjectIdDesc = 'propstackProjectId_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export type BlockProjectLinkSectionFilter = {
  projectLinks?: Maybe<CfProjectLinkNestedFilter>;
  sys?: Maybe<SysFilter>;
  contentfulMetadata?: Maybe<ContentfulMetadataFilter>;
  propstackProjectId_exists?: Maybe<Scalars['Boolean']>;
  propstackProjectId?: Maybe<Scalars['Int']>;
  propstackProjectId_not?: Maybe<Scalars['Int']>;
  propstackProjectId_in?: Maybe<Array<Maybe<Scalars['Int']>>>;
  propstackProjectId_not_in?: Maybe<Array<Maybe<Scalars['Int']>>>;
  propstackProjectId_gt?: Maybe<Scalars['Int']>;
  propstackProjectId_gte?: Maybe<Scalars['Int']>;
  propstackProjectId_lt?: Maybe<Scalars['Int']>;
  propstackProjectId_lte?: Maybe<Scalars['Int']>;
  title_exists?: Maybe<Scalars['Boolean']>;
  title?: Maybe<Scalars['String']>;
  title_not?: Maybe<Scalars['String']>;
  title_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  title_not_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  title_contains?: Maybe<Scalars['String']>;
  title_not_contains?: Maybe<Scalars['String']>;
  description_exists?: Maybe<Scalars['Boolean']>;
  description?: Maybe<Scalars['String']>;
  description_not?: Maybe<Scalars['String']>;
  description_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  description_not_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  description_contains?: Maybe<Scalars['String']>;
  description_not_contains?: Maybe<Scalars['String']>;
  projectLinksCollection_exists?: Maybe<Scalars['Boolean']>;
  OR?: Maybe<Array<Maybe<BlockProjectLinkSectionFilter>>>;
  AND?: Maybe<Array<Maybe<BlockProjectLinkSectionFilter>>>;
};

export type CfProjectLinkNestedFilter = {
  sys?: Maybe<SysFilter>;
  contentfulMetadata?: Maybe<ContentfulMetadataFilter>;
  title_exists?: Maybe<Scalars['Boolean']>;
  title?: Maybe<Scalars['String']>;
  title_not?: Maybe<Scalars['String']>;
  title_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  title_not_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  title_contains?: Maybe<Scalars['String']>;
  title_not_contains?: Maybe<Scalars['String']>;
  link_exists?: Maybe<Scalars['Boolean']>;
  link?: Maybe<Scalars['String']>;
  link_not?: Maybe<Scalars['String']>;
  link_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  link_not_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  link_contains?: Maybe<Scalars['String']>;
  link_not_contains?: Maybe<Scalars['String']>;
  backgroundImage_exists?: Maybe<Scalars['Boolean']>;
  OR?: Maybe<Array<Maybe<CfProjectLinkNestedFilter>>>;
  AND?: Maybe<Array<Maybe<CfProjectLinkNestedFilter>>>;
};

export enum BlockProjectLinkSectionOrder {
  PropstackProjectIdAsc = 'propstackProjectId_ASC',
  PropstackProjectIdDesc = 'propstackProjectId_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export type DownloadableFileFilter = {
  sys?: Maybe<SysFilter>;
  contentfulMetadata?: Maybe<ContentfulMetadataFilter>;
  title_exists?: Maybe<Scalars['Boolean']>;
  title?: Maybe<Scalars['String']>;
  title_not?: Maybe<Scalars['String']>;
  title_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  title_not_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  title_contains?: Maybe<Scalars['String']>;
  title_not_contains?: Maybe<Scalars['String']>;
  type_exists?: Maybe<Scalars['Boolean']>;
  type?: Maybe<Scalars['String']>;
  type_not?: Maybe<Scalars['String']>;
  type_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  type_not_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  type_contains?: Maybe<Scalars['String']>;
  type_not_contains?: Maybe<Scalars['String']>;
  file_exists?: Maybe<Scalars['Boolean']>;
  publishDate_exists?: Maybe<Scalars['Boolean']>;
  publishDate?: Maybe<Scalars['DateTime']>;
  publishDate_not?: Maybe<Scalars['DateTime']>;
  publishDate_in?: Maybe<Array<Maybe<Scalars['DateTime']>>>;
  publishDate_not_in?: Maybe<Array<Maybe<Scalars['DateTime']>>>;
  publishDate_gt?: Maybe<Scalars['DateTime']>;
  publishDate_gte?: Maybe<Scalars['DateTime']>;
  publishDate_lt?: Maybe<Scalars['DateTime']>;
  publishDate_lte?: Maybe<Scalars['DateTime']>;
  OR?: Maybe<Array<Maybe<DownloadableFileFilter>>>;
  AND?: Maybe<Array<Maybe<DownloadableFileFilter>>>;
};

export enum DownloadableFileOrder {
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC',
  TypeAsc = 'type_ASC',
  TypeDesc = 'type_DESC',
  PublishDateAsc = 'publishDate_ASC',
  PublishDateDesc = 'publishDate_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum PersonAccordionEntryOrder {
  FullNameAsc = 'fullName_ASC',
  FullNameDesc = 'fullName_DESC',
  JobTitleAsc = 'jobTitle_ASC',
  JobTitleDesc = 'jobTitle_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export type BlockPartnerGridFilter = {
  partners?: Maybe<CfPartnerNestedFilter>;
  sys?: Maybe<SysFilter>;
  contentfulMetadata?: Maybe<ContentfulMetadataFilter>;
  partnersCollection_exists?: Maybe<Scalars['Boolean']>;
  OR?: Maybe<Array<Maybe<BlockPartnerGridFilter>>>;
  AND?: Maybe<Array<Maybe<BlockPartnerGridFilter>>>;
};

export type CfPartnerNestedFilter = {
  sys?: Maybe<SysFilter>;
  contentfulMetadata?: Maybe<ContentfulMetadataFilter>;
  internalDescription_exists?: Maybe<Scalars['Boolean']>;
  internalDescription?: Maybe<Scalars['String']>;
  internalDescription_not?: Maybe<Scalars['String']>;
  internalDescription_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  internalDescription_not_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  internalDescription_contains?: Maybe<Scalars['String']>;
  internalDescription_not_contains?: Maybe<Scalars['String']>;
  partnerText_exists?: Maybe<Scalars['Boolean']>;
  partnerText?: Maybe<Scalars['String']>;
  partnerText_not?: Maybe<Scalars['String']>;
  partnerText_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  partnerText_not_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  partnerText_contains?: Maybe<Scalars['String']>;
  partnerText_not_contains?: Maybe<Scalars['String']>;
  partnerImage_exists?: Maybe<Scalars['Boolean']>;
  href_exists?: Maybe<Scalars['Boolean']>;
  href?: Maybe<Scalars['String']>;
  href_not?: Maybe<Scalars['String']>;
  href_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  href_not_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  href_contains?: Maybe<Scalars['String']>;
  href_not_contains?: Maybe<Scalars['String']>;
  OR?: Maybe<Array<Maybe<CfPartnerNestedFilter>>>;
  AND?: Maybe<Array<Maybe<CfPartnerNestedFilter>>>;
};

export enum BlockPartnerGridOrder {
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export type BlockStockPriceCollection = {
  __typename?: 'BlockStockPriceCollection';
  total: Scalars['Int'];
  skip: Scalars['Int'];
  limit: Scalars['Int'];
  items: Array<Maybe<BlockStockPrice>>;
};

export type BlockStockPriceFilter = {
  sys?: Maybe<SysFilter>;
  contentfulMetadata?: Maybe<ContentfulMetadataFilter>;
  title_exists?: Maybe<Scalars['Boolean']>;
  title?: Maybe<Scalars['String']>;
  title_not?: Maybe<Scalars['String']>;
  title_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  title_not_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  title_contains?: Maybe<Scalars['String']>;
  title_not_contains?: Maybe<Scalars['String']>;
  stockPriceDescription_exists?: Maybe<Scalars['Boolean']>;
  stockPriceDescription?: Maybe<Scalars['String']>;
  stockPriceDescription_not?: Maybe<Scalars['String']>;
  stockPriceDescription_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  stockPriceDescription_not_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  stockPriceDescription_contains?: Maybe<Scalars['String']>;
  stockPriceDescription_not_contains?: Maybe<Scalars['String']>;
  OR?: Maybe<Array<Maybe<BlockStockPriceFilter>>>;
  AND?: Maybe<Array<Maybe<BlockStockPriceFilter>>>;
};

export enum BlockStockPriceOrder {
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export type NavigationEntryFilter = {
  staticPage?: Maybe<CfStaticPageNestedFilter>;
  sys?: Maybe<SysFilter>;
  contentfulMetadata?: Maybe<ContentfulMetadataFilter>;
  image_exists?: Maybe<Scalars['Boolean']>;
  title_exists?: Maybe<Scalars['Boolean']>;
  title?: Maybe<Scalars['String']>;
  title_not?: Maybe<Scalars['String']>;
  title_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  title_not_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  title_contains?: Maybe<Scalars['String']>;
  title_not_contains?: Maybe<Scalars['String']>;
  subTitle_exists?: Maybe<Scalars['Boolean']>;
  subTitle?: Maybe<Scalars['String']>;
  subTitle_not?: Maybe<Scalars['String']>;
  subTitle_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  subTitle_not_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  subTitle_contains?: Maybe<Scalars['String']>;
  subTitle_not_contains?: Maybe<Scalars['String']>;
  staticPage_exists?: Maybe<Scalars['Boolean']>;
  buttonText_exists?: Maybe<Scalars['Boolean']>;
  buttonText?: Maybe<Scalars['String']>;
  buttonText_not?: Maybe<Scalars['String']>;
  buttonText_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  buttonText_not_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  buttonText_contains?: Maybe<Scalars['String']>;
  buttonText_not_contains?: Maybe<Scalars['String']>;
  OR?: Maybe<Array<Maybe<NavigationEntryFilter>>>;
  AND?: Maybe<Array<Maybe<NavigationEntryFilter>>>;
};

export enum NavigationEntryOrder {
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC',
  ButtonTextAsc = 'buttonText_ASC',
  ButtonTextDesc = 'buttonText_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export type LatestDownloadCollection = {
  __typename?: 'LatestDownloadCollection';
  total: Scalars['Int'];
  skip: Scalars['Int'];
  limit: Scalars['Int'];
  items: Array<Maybe<LatestDownload>>;
};

export type LatestDownloadFilter = {
  sys?: Maybe<SysFilter>;
  contentfulMetadata?: Maybe<ContentfulMetadataFilter>;
  internalDescription_exists?: Maybe<Scalars['Boolean']>;
  internalDescription?: Maybe<Scalars['String']>;
  internalDescription_not?: Maybe<Scalars['String']>;
  internalDescription_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  internalDescription_not_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  internalDescription_contains?: Maybe<Scalars['String']>;
  internalDescription_not_contains?: Maybe<Scalars['String']>;
  type_exists?: Maybe<Scalars['Boolean']>;
  type?: Maybe<Scalars['String']>;
  type_not?: Maybe<Scalars['String']>;
  type_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  type_not_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  type_contains?: Maybe<Scalars['String']>;
  type_not_contains?: Maybe<Scalars['String']>;
  OR?: Maybe<Array<Maybe<LatestDownloadFilter>>>;
  AND?: Maybe<Array<Maybe<LatestDownloadFilter>>>;
};

export enum LatestDownloadOrder {
  InternalDescriptionAsc = 'internalDescription_ASC',
  InternalDescriptionDesc = 'internalDescription_DESC',
  TypeAsc = 'type_ASC',
  TypeDesc = 'type_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export type BlockThreeColumnCollection = {
  __typename?: 'BlockThreeColumnCollection';
  total: Scalars['Int'];
  skip: Scalars['Int'];
  limit: Scalars['Int'];
  items: Array<Maybe<BlockThreeColumn>>;
};

export type BlockThreeColumnFilter = {
  sys?: Maybe<SysFilter>;
  contentfulMetadata?: Maybe<ContentfulMetadataFilter>;
  internalDescription_exists?: Maybe<Scalars['Boolean']>;
  internalDescription?: Maybe<Scalars['String']>;
  internalDescription_not?: Maybe<Scalars['String']>;
  internalDescription_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  internalDescription_not_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  internalDescription_contains?: Maybe<Scalars['String']>;
  internalDescription_not_contains?: Maybe<Scalars['String']>;
  leftColumnCollection_exists?: Maybe<Scalars['Boolean']>;
  middleColumnCollection_exists?: Maybe<Scalars['Boolean']>;
  rightColumnCollection_exists?: Maybe<Scalars['Boolean']>;
  OR?: Maybe<Array<Maybe<BlockThreeColumnFilter>>>;
  AND?: Maybe<Array<Maybe<BlockThreeColumnFilter>>>;
};

export enum BlockThreeColumnOrder {
  InternalDescriptionAsc = 'internalDescription_ASC',
  InternalDescriptionDesc = 'internalDescription_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export type NewsArticleContactCollection = {
  __typename?: 'NewsArticleContactCollection';
  total: Scalars['Int'];
  skip: Scalars['Int'];
  limit: Scalars['Int'];
  items: Array<Maybe<NewsArticleContact>>;
};

export enum NewsArticleContactOrder {
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC',
  FullNameAsc = 'fullName_ASC',
  FullNameDesc = 'fullName_DESC',
  CompanyAsc = 'company_ASC',
  CompanyDesc = 'company_DESC',
  StreetAsc = 'street_ASC',
  StreetDesc = 'street_DESC',
  PostcodeAsc = 'postcode_ASC',
  PostcodeDesc = 'postcode_DESC',
  EmailAsc = 'email_ASC',
  EmailDesc = 'email_DESC',
  TelefonAsc = 'telefon_ASC',
  TelefonDesc = 'telefon_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export type BarChartWithBackgroundCollection = {
  __typename?: 'BarChartWithBackgroundCollection';
  total: Scalars['Int'];
  skip: Scalars['Int'];
  limit: Scalars['Int'];
  items: Array<Maybe<BarChartWithBackground>>;
};

export type BarChartWithBackgroundFilter = {
  sys?: Maybe<SysFilter>;
  contentfulMetadata?: Maybe<ContentfulMetadataFilter>;
  title_exists?: Maybe<Scalars['Boolean']>;
  title?: Maybe<Scalars['String']>;
  title_not?: Maybe<Scalars['String']>;
  title_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  title_not_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  title_contains?: Maybe<Scalars['String']>;
  title_not_contains?: Maybe<Scalars['String']>;
  bars_exists?: Maybe<Scalars['Boolean']>;
  OR?: Maybe<Array<Maybe<BarChartWithBackgroundFilter>>>;
  AND?: Maybe<Array<Maybe<BarChartWithBackgroundFilter>>>;
};

export enum BarChartWithBackgroundOrder {
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export type BlockPersonAccordionFilter = {
  personEntries?: Maybe<CfPersonAccordionEntryNestedFilter>;
  sys?: Maybe<SysFilter>;
  contentfulMetadata?: Maybe<ContentfulMetadataFilter>;
  title_exists?: Maybe<Scalars['Boolean']>;
  title?: Maybe<Scalars['String']>;
  title_not?: Maybe<Scalars['String']>;
  title_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  title_not_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  title_contains?: Maybe<Scalars['String']>;
  title_not_contains?: Maybe<Scalars['String']>;
  personEntriesCollection_exists?: Maybe<Scalars['Boolean']>;
  OR?: Maybe<Array<Maybe<BlockPersonAccordionFilter>>>;
  AND?: Maybe<Array<Maybe<BlockPersonAccordionFilter>>>;
};

export type CfPersonAccordionEntryNestedFilter = {
  sys?: Maybe<SysFilter>;
  contentfulMetadata?: Maybe<ContentfulMetadataFilter>;
  fullName_exists?: Maybe<Scalars['Boolean']>;
  fullName?: Maybe<Scalars['String']>;
  fullName_not?: Maybe<Scalars['String']>;
  fullName_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  fullName_not_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  fullName_contains?: Maybe<Scalars['String']>;
  fullName_not_contains?: Maybe<Scalars['String']>;
  jobTitle_exists?: Maybe<Scalars['Boolean']>;
  jobTitle?: Maybe<Scalars['String']>;
  jobTitle_not?: Maybe<Scalars['String']>;
  jobTitle_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  jobTitle_not_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  jobTitle_contains?: Maybe<Scalars['String']>;
  jobTitle_not_contains?: Maybe<Scalars['String']>;
  description_exists?: Maybe<Scalars['Boolean']>;
  description?: Maybe<Scalars['String']>;
  description_not?: Maybe<Scalars['String']>;
  description_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  description_not_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  description_contains?: Maybe<Scalars['String']>;
  description_not_contains?: Maybe<Scalars['String']>;
  portraitImage_exists?: Maybe<Scalars['Boolean']>;
  OR?: Maybe<Array<Maybe<CfPersonAccordionEntryNestedFilter>>>;
  AND?: Maybe<Array<Maybe<CfPersonAccordionEntryNestedFilter>>>;
};

export enum BlockPersonAccordionOrder {
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export type EntryFilter = {
  sys?: Maybe<SysFilter>;
  contentfulMetadata?: Maybe<ContentfulMetadataFilter>;
  OR?: Maybe<Array<Maybe<EntryFilter>>>;
  AND?: Maybe<Array<Maybe<EntryFilter>>>;
};

export enum EntryOrder {
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

type EntryId_HeroImage_Fragment = (
  { __typename?: 'HeroImage' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type EntryId_StaticPage_Fragment = (
  { __typename?: 'StaticPage' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type EntryId_NavBarEntry_Fragment = (
  { __typename?: 'NavBarEntry' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type EntryId_BlockSubNavigation_Fragment = (
  { __typename?: 'BlockSubNavigation' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type EntryId_BlockBigTitleNavigation_Fragment = (
  { __typename?: 'BlockBigTitleNavigation' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type EntryId_BlockHiddenWithConsent_Fragment = (
  { __typename?: 'BlockHiddenWithConsent' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type EntryId_BlockAccordion_Fragment = (
  { __typename?: 'BlockAccordion' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type EntryId_BlockOneColumn_Fragment = (
  { __typename?: 'BlockOneColumn' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type EntryId_BlockAnalystRating_Fragment = (
  { __typename?: 'BlockAnalystRating' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type EntryId_BlockCallToActionButton_Fragment = (
  { __typename?: 'BlockCallToActionButton' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type EntryId_BlockTwoColumn_Fragment = (
  { __typename?: 'BlockTwoColumn' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type EntryId_BlockAccordionEntry_Fragment = (
  { __typename?: 'BlockAccordionEntry' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type EntryId_NewsArticle_Fragment = (
  { __typename?: 'NewsArticle' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type EntryId_BlockRichText_Fragment = (
  { __typename?: 'BlockRichText' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type EntryId_LexiconArticle_Fragment = (
  { __typename?: 'LexiconArticle' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type EntryId_ProjectPage_Fragment = (
  { __typename?: 'ProjectPage' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type EntryId_BarChartWithBackground_Fragment = (
  { __typename?: 'BarChartWithBackground' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type EntryId_BlockCustom_Fragment = (
  { __typename?: 'BlockCustom' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type EntryId_BlockFullsizeImage_Fragment = (
  { __typename?: 'BlockFullsizeImage' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type EntryId_BlockHighlightRealEstate_Fragment = (
  { __typename?: 'BlockHighlightRealEstate' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type EntryId_HighlightedRealEstate_Fragment = (
  { __typename?: 'HighlightedRealEstate' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type EntryId_BlockPartnerGrid_Fragment = (
  { __typename?: 'BlockPartnerGrid' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type EntryId_Partner_Fragment = (
  { __typename?: 'Partner' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type EntryId_BlockPersonAccordion_Fragment = (
  { __typename?: 'BlockPersonAccordion' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type EntryId_PersonAccordionEntry_Fragment = (
  { __typename?: 'PersonAccordionEntry' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type EntryId_BlockRibbon_Fragment = (
  { __typename?: 'BlockRibbon' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type EntryId_BlockTable_Fragment = (
  { __typename?: 'BlockTable' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type EntryId_BlockThreeColumn_Fragment = (
  { __typename?: 'BlockThreeColumn' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type EntryId_BlockVideo_Fragment = (
  { __typename?: 'BlockVideo' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type EntryId_NewsArticleContact_Fragment = (
  { __typename?: 'NewsArticleContact' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type EntryId_BlockSpeechBubble_Fragment = (
  { __typename?: 'BlockSpeechBubble' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type EntryId_LatestDownload_Fragment = (
  { __typename?: 'LatestDownload' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type EntryId_NavigationEntry_Fragment = (
  { __typename?: 'NavigationEntry' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type EntryId_BlockLinkSection_Fragment = (
  { __typename?: 'BlockLinkSection' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type EntryId_LinkSectionEntry_Fragment = (
  { __typename?: 'LinkSectionEntry' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type EntryId_BlockStockPrice_Fragment = (
  { __typename?: 'BlockStockPrice' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type EntryId_BlockImageGallery_Fragment = (
  { __typename?: 'BlockImageGallery' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type EntryId_BlockSlider_Fragment = (
  { __typename?: 'BlockSlider' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type EntryId_BlockSliderEntry_Fragment = (
  { __typename?: 'BlockSliderEntry' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type EntryId_BlockTextCloud_Fragment = (
  { __typename?: 'BlockTextCloud' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type EntryId_Seo_Fragment = (
  { __typename?: 'Seo' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type EntryId_RegionDescriptionText_Fragment = (
  { __typename?: 'RegionDescriptionText' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type EntryId_ProjectLink_Fragment = (
  { __typename?: 'ProjectLink' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type EntryId_BlockProjectLinkSection_Fragment = (
  { __typename?: 'BlockProjectLinkSection' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type EntryId_ProjectImageMap_Fragment = (
  { __typename?: 'ProjectImageMap' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type EntryId_DownloadableFile_Fragment = (
  { __typename?: 'DownloadableFile' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type EntryId_Footer_Fragment = (
  { __typename?: 'Footer' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

export type EntryIdFragment = EntryId_HeroImage_Fragment | EntryId_StaticPage_Fragment | EntryId_NavBarEntry_Fragment | EntryId_BlockSubNavigation_Fragment | EntryId_BlockBigTitleNavigation_Fragment | EntryId_BlockHiddenWithConsent_Fragment | EntryId_BlockAccordion_Fragment | EntryId_BlockOneColumn_Fragment | EntryId_BlockAnalystRating_Fragment | EntryId_BlockCallToActionButton_Fragment | EntryId_BlockTwoColumn_Fragment | EntryId_BlockAccordionEntry_Fragment | EntryId_NewsArticle_Fragment | EntryId_BlockRichText_Fragment | EntryId_LexiconArticle_Fragment | EntryId_ProjectPage_Fragment | EntryId_BarChartWithBackground_Fragment | EntryId_BlockCustom_Fragment | EntryId_BlockFullsizeImage_Fragment | EntryId_BlockHighlightRealEstate_Fragment | EntryId_HighlightedRealEstate_Fragment | EntryId_BlockPartnerGrid_Fragment | EntryId_Partner_Fragment | EntryId_BlockPersonAccordion_Fragment | EntryId_PersonAccordionEntry_Fragment | EntryId_BlockRibbon_Fragment | EntryId_BlockTable_Fragment | EntryId_BlockThreeColumn_Fragment | EntryId_BlockVideo_Fragment | EntryId_NewsArticleContact_Fragment | EntryId_BlockSpeechBubble_Fragment | EntryId_LatestDownload_Fragment | EntryId_NavigationEntry_Fragment | EntryId_BlockLinkSection_Fragment | EntryId_LinkSectionEntry_Fragment | EntryId_BlockStockPrice_Fragment | EntryId_BlockImageGallery_Fragment | EntryId_BlockSlider_Fragment | EntryId_BlockSliderEntry_Fragment | EntryId_BlockTextCloud_Fragment | EntryId_Seo_Fragment | EntryId_RegionDescriptionText_Fragment | EntryId_ProjectLink_Fragment | EntryId_BlockProjectLinkSection_Fragment | EntryId_ProjectImageMap_Fragment | EntryId_DownloadableFile_Fragment | EntryId_Footer_Fragment;

export type FullAssetFragment = (
  { __typename?: 'Asset' }
  & Pick<Asset, 'title' | 'description' | 'contentType' | 'fileName' | 'size' | 'url' | 'width' | 'height'>
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

export type FullHyperlinkFragment = (
  { __typename?: 'Asset' }
  & Pick<Asset, 'url' | 'title' | 'description' | 'contentType' | 'fileName' | 'size'>
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

export type GetAllNewsArticleByTypeQueryVariables = Exact<{
  newsType?: Maybe<Scalars['String']>;
  locale?: Maybe<Scalars['String']>;
  slug?: Maybe<Scalars['String']>;
}>;


export type GetAllNewsArticleByTypeQuery = (
  { __typename?: 'Query' }
  & { allNewsArticles?: Maybe<(
    { __typename?: 'NewsArticleCollection' }
    & { items: Array<Maybe<(
      { __typename?: 'NewsArticle' }
      & AllNewsArticleFragment
    )>> }
  )> }
);

export type AllNewsArticleFragment = (
  { __typename?: 'NewsArticle' }
  & Pick<NewsArticle, 'title' | 'date' | 'slug'>
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

export type GetFooterQueryVariables = Exact<{
  locale?: Maybe<Scalars['String']>;
  preview?: Maybe<Scalars['Boolean']>;
}>;


export type GetFooterQuery = (
  { __typename?: 'Query' }
  & { footer?: Maybe<(
    { __typename?: 'FooterCollection' }
    & { items: Array<Maybe<(
      { __typename?: 'Footer' }
      & FooterFragment
    )>> }
  )> }
);

export type FooterFragment = (
  { __typename?: 'Footer' }
  & Pick<Footer, 'phone' | 'fax'>
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ), richtext?: Maybe<(
    { __typename?: 'FooterRichtext' }
    & Pick<FooterRichtext, 'json'>
    & { links: (
      { __typename?: 'FooterRichtextLinks' }
      & { assets: (
        { __typename?: 'FooterRichtextAssets' }
        & { block: Array<Maybe<(
          { __typename?: 'Asset' }
          & FullAssetFragment
        )>>, hyperlink: Array<Maybe<(
          { __typename?: 'Asset' }
          & FullHyperlinkFragment
        )>> }
      ) }
    ) }
  )> }
);

export type GetLexiconArticleBySlugQueryVariables = Exact<{
  locale?: Maybe<Scalars['String']>;
  preview?: Maybe<Scalars['Boolean']>;
  slug?: Maybe<Scalars['String']>;
}>;


export type GetLexiconArticleBySlugQuery = (
  { __typename?: 'Query' }
  & { lexiconArticle?: Maybe<(
    { __typename?: 'LexiconArticleCollection' }
    & { items: Array<Maybe<(
      { __typename?: 'LexiconArticle' }
      & FullLexiconArticleFragment
    )>> }
  )> }
);

export type FullLexiconArticleFragment = (
  { __typename?: 'LexiconArticle' }
  & Pick<LexiconArticle, 'lexiconLetter' | 'title' | 'previewText' | 'slug'>
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ), blocks?: Maybe<(
    { __typename?: 'LexiconArticleBlocksCollection' }
    & { items: Array<Maybe<(
      { __typename?: 'BlockRichText' }
      & EntryId_BlockRichText_Fragment
    )>> }
  )> }
  & LexiconArticleLocaleSlugsFragment
);

export type GetLexiconArticlePreviewsQueryVariables = Exact<{
  locale?: Maybe<Scalars['String']>;
  preview?: Maybe<Scalars['Boolean']>;
  lexiconLetter?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  skip?: Maybe<Scalars['Int']>;
}>;


export type GetLexiconArticlePreviewsQuery = (
  { __typename?: 'Query' }
  & { lexiconArticles?: Maybe<(
    { __typename?: 'LexiconArticleCollection' }
    & Pick<LexiconArticleCollection, 'total'>
    & { items: Array<Maybe<(
      { __typename?: 'LexiconArticle' }
      & LexiconArticlePreviewFragment
    )>> }
  )> }
);

export type GetTopLexiconArticlePreviewsQueryVariables = Exact<{
  locale?: Maybe<Scalars['String']>;
  preview?: Maybe<Scalars['Boolean']>;
  lexiconLetter?: Maybe<Scalars['String']>;
}>;


export type GetTopLexiconArticlePreviewsQuery = (
  { __typename?: 'Query' }
  & { lexiconArticles?: Maybe<(
    { __typename?: 'LexiconArticleCollection' }
    & { items: Array<Maybe<(
      { __typename?: 'LexiconArticle' }
      & LexiconArticlePreviewFragment
    )>> }
  )> }
);

export type GetLexiconArticlePreviewsOfLetterQueryVariables = Exact<{
  locale?: Maybe<Scalars['String']>;
  preview?: Maybe<Scalars['Boolean']>;
  slug?: Maybe<Scalars['String']>;
  letter?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
}>;


export type GetLexiconArticlePreviewsOfLetterQuery = (
  { __typename?: 'Query' }
  & { otherLexiconArticles?: Maybe<(
    { __typename?: 'LexiconArticleCollection' }
    & { items: Array<Maybe<(
      { __typename?: 'LexiconArticle' }
      & LexiconArticlePreviewFragment
    )>> }
  )> }
);

export type LexiconArticlePreviewFragment = (
  { __typename?: 'LexiconArticle' }
  & Pick<LexiconArticle, 'lexiconLetter' | 'title' | 'slug' | 'previewText'>
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

export type GetLexiconArticleSlugsQueryVariables = Exact<{
  locale?: Maybe<Scalars['String']>;
  preview?: Maybe<Scalars['Boolean']>;
}>;


export type GetLexiconArticleSlugsQuery = (
  { __typename?: 'Query' }
  & { lexiconArticles?: Maybe<(
    { __typename?: 'LexiconArticleCollection' }
    & { items: Array<Maybe<(
      { __typename?: 'LexiconArticle' }
      & Pick<LexiconArticle, 'slug' | 'lexiconLetter'>
      & { sys: (
        { __typename?: 'Sys' }
        & Pick<Sys, 'id'>
      ) }
    )>> }
  )> }
);

export type GetLexiconArticlesFullTextQueryVariables = Exact<{
  locale?: Maybe<Scalars['String']>;
  preview?: Maybe<Scalars['Boolean']>;
  lexiconLetter?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  skip?: Maybe<Scalars['Int']>;
}>;


export type GetLexiconArticlesFullTextQuery = (
  { __typename?: 'Query' }
  & { lexiconArticles?: Maybe<(
    { __typename?: 'LexiconArticleCollection' }
    & Pick<LexiconArticleCollection, 'total'>
    & { items: Array<Maybe<(
      { __typename?: 'LexiconArticle' }
      & LexiconArticleFullTextFragment
    )>> }
  )> }
);

export type LexiconArticleFullTextFragment = (
  { __typename?: 'LexiconArticle' }
  & { blocksCollection?: Maybe<(
    { __typename?: 'LexiconArticleBlocksCollection' }
    & Pick<LexiconArticleBlocksCollection, 'total'>
    & { items: Array<Maybe<(
      { __typename: 'BlockRichText' }
      & { richText?: Maybe<(
        { __typename?: 'BlockRichTextRichText' }
        & Pick<BlockRichTextRichText, 'json'>
      )> }
    )>> }
  )> }
  & LexiconArticlePreviewFragment
);

export type GetNavBarEntriesQueryVariables = Exact<{
  locale?: Maybe<Scalars['String']>;
  preview?: Maybe<Scalars['Boolean']>;
}>;


export type GetNavBarEntriesQuery = (
  { __typename?: 'Query' }
  & { navBarEntries?: Maybe<(
    { __typename?: 'NavBarEntryCollection' }
    & { items: Array<Maybe<(
      { __typename?: 'NavBarEntry' }
      & FullNavBarEntryFragment
    )>> }
  )> }
);

export type FullNavBarEntryFragment = (
  { __typename?: 'NavBarEntry' }
  & Pick<NavBarEntry, 'label' | 'navType' | 'position' | 'url'>
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ), staticPage?: Maybe<(
    { __typename?: 'StaticPage' }
    & Pick<StaticPage, 'slug'>
  )>, subEntriesCollection?: Maybe<(
    { __typename?: 'NavBarEntrySubEntriesCollection' }
    & { items: Array<Maybe<(
      { __typename?: 'NavBarEntry' }
      & SubEntryFragment
    )>> }
  )> }
);

export type SubEntryFragment = (
  { __typename?: 'NavBarEntry' }
  & Pick<NavBarEntry, 'label' | 'navType' | 'position' | 'url'>
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ), staticPage?: Maybe<(
    { __typename?: 'StaticPage' }
    & Pick<StaticPage, 'slug'>
  )> }
);

export type GetNewsArticleBySlugQueryVariables = Exact<{
  locale?: Maybe<Scalars['String']>;
  preview?: Maybe<Scalars['Boolean']>;
  slug?: Maybe<Scalars['String']>;
}>;


export type GetNewsArticleBySlugQuery = (
  { __typename?: 'Query' }
  & { newsArticle?: Maybe<(
    { __typename?: 'NewsArticleCollection' }
    & { items: Array<Maybe<(
      { __typename?: 'NewsArticle' }
      & FullNewsArticleFragment
    )>> }
  )> }
);

export type FullNewsArticleFragment = (
  { __typename?: 'NewsArticle' }
  & Pick<NewsArticle, 'newsType' | 'title' | 'date' | 'hideDate' | 'previewText' | 'slug'>
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ), image?: Maybe<(
    { __typename?: 'Asset' }
    & FullAssetFragment
  )>, blocks?: Maybe<(
    { __typename?: 'NewsArticleBlocksCollection' }
    & { items: Array<Maybe<(
      { __typename?: 'BlockAccordion' }
      & EntryId_BlockAccordion_Fragment
    ) | (
      { __typename?: 'BlockAccordionEntry' }
      & EntryId_BlockAccordionEntry_Fragment
    ) | (
      { __typename?: 'BlockCallToActionButton' }
      & EntryId_BlockCallToActionButton_Fragment
    ) | (
      { __typename?: 'BlockRichText' }
      & EntryId_BlockRichText_Fragment
    ) | (
      { __typename?: 'BlockTable' }
      & EntryId_BlockTable_Fragment
    ) | (
      { __typename?: 'BlockTwoColumn' }
      & EntryId_BlockTwoColumn_Fragment
    )>> }
  )>, contacts?: Maybe<(
    { __typename?: 'NewsArticleContactsCollection' }
    & { items: Array<Maybe<(
      { __typename?: 'NewsArticleContact' }
      & FullNewsContactFragment
    )>> }
  )> }
  & NewsArticleLocaleSlugsFragment
  & NewsArticleFileFragment
);

export type FullNewsContactFragment = (
  { __typename?: 'NewsArticleContact' }
  & Pick<NewsArticleContact, 'title' | 'fullName' | 'company' | 'street' | 'postcode' | 'email' | 'telefon'>
  & EntryId_NewsArticleContact_Fragment
);

export type NewsArticleFileFragment = (
  { __typename?: 'NewsArticle' }
  & { file?: Maybe<(
    { __typename?: 'Asset' }
    & Pick<Asset, 'contentType' | 'url' | 'title' | 'description'>
    & { sys: (
      { __typename?: 'Sys' }
      & Pick<Sys, 'id'>
    ) }
  )> }
);

export type GetNewsArticlePreviewsQueryVariables = Exact<{
  locale?: Maybe<Scalars['String']>;
  preview?: Maybe<Scalars['Boolean']>;
  newsType?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  skip?: Maybe<Scalars['Int']>;
}>;


export type GetNewsArticlePreviewsQuery = (
  { __typename?: 'Query' }
  & { newsArticles?: Maybe<(
    { __typename?: 'NewsArticleCollection' }
    & Pick<NewsArticleCollection, 'total'>
    & { items: Array<Maybe<(
      { __typename?: 'NewsArticle' }
      & { image?: Maybe<(
        { __typename?: 'Asset' }
        & FullAssetFragment
      )> }
      & OtherNewsArticleFragment
    )>> }
  )> }
);

export type GetTopNewsArticlePreviewsQueryVariables = Exact<{
  locale?: Maybe<Scalars['String']>;
  preview?: Maybe<Scalars['Boolean']>;
  newsType?: Maybe<Scalars['String']>;
}>;


export type GetTopNewsArticlePreviewsQuery = (
  { __typename?: 'Query' }
  & { newsArticles?: Maybe<(
    { __typename?: 'NewsArticleCollection' }
    & { items: Array<Maybe<(
      { __typename?: 'NewsArticle' }
      & OtherNewsArticleFragment
    )>> }
  )> }
);

export type GetNewsArticlePreviewsOfLocationQueryVariables = Exact<{
  locale?: Maybe<Scalars['String']>;
  preview?: Maybe<Scalars['Boolean']>;
  city?: Maybe<Scalars['String']>;
  newsType?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
}>;


export type GetNewsArticlePreviewsOfLocationQuery = (
  { __typename?: 'Query' }
  & { newsArticles?: Maybe<(
    { __typename?: 'NewsArticleCollection' }
    & { items: Array<Maybe<(
      { __typename?: 'NewsArticle' }
      & OtherNewsArticleFragment
    )>> }
  )> }
);

export type GetNewsArticlePreviewsOfThreeNewsTypeQueryVariables = Exact<{
  locale?: Maybe<Scalars['String']>;
  preview?: Maybe<Scalars['Boolean']>;
  newsTypes?: Maybe<Array<Maybe<Scalars['String']>> | Maybe<Scalars['String']>>;
  limit?: Maybe<Scalars['Int']>;
}>;


export type GetNewsArticlePreviewsOfThreeNewsTypeQuery = (
  { __typename?: 'Query' }
  & { newsArticles?: Maybe<(
    { __typename?: 'NewsArticleCollection' }
    & { items: Array<Maybe<(
      { __typename?: 'NewsArticle' }
      & OtherNewsArticleFragment
    )>> }
  )> }
);

export type GetNewsArticleSlugsQueryVariables = Exact<{
  locale?: Maybe<Scalars['String']>;
  preview?: Maybe<Scalars['Boolean']>;
  skip?: Maybe<Scalars['Int']>;
}>;


export type GetNewsArticleSlugsQuery = (
  { __typename?: 'Query' }
  & { newsArticles?: Maybe<(
    { __typename?: 'NewsArticleCollection' }
    & Pick<NewsArticleCollection, 'total'>
    & { items: Array<Maybe<(
      { __typename?: 'NewsArticle' }
      & Pick<NewsArticle, 'slug' | 'newsType'>
      & { sys: (
        { __typename?: 'Sys' }
        & Pick<Sys, 'id'>
      ) }
    )>> }
  )> }
);

export type GetNewsArticlesFullTextQueryVariables = Exact<{
  locale?: Maybe<Scalars['String']>;
  preview?: Maybe<Scalars['Boolean']>;
  newsType?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  skip?: Maybe<Scalars['Int']>;
}>;


export type GetNewsArticlesFullTextQuery = (
  { __typename?: 'Query' }
  & { newsArticles?: Maybe<(
    { __typename?: 'NewsArticleCollection' }
    & Pick<NewsArticleCollection, 'total'>
    & { items: Array<Maybe<(
      { __typename?: 'NewsArticle' }
      & NewsArticleFullTextFragment
    )>> }
  )> }
);

export type NewsArticleFullTextFragment = (
  { __typename?: 'NewsArticle' }
  & { image?: Maybe<(
    { __typename?: 'Asset' }
    & FullAssetFragment
  )>, blocksCollection?: Maybe<(
    { __typename?: 'NewsArticleBlocksCollection' }
    & Pick<NewsArticleBlocksCollection, 'total'>
    & { items: Array<Maybe<{ __typename: 'BlockAccordion' } | { __typename: 'BlockAccordionEntry' } | { __typename: 'BlockCallToActionButton' } | (
      { __typename: 'BlockRichText' }
      & { richText?: Maybe<(
        { __typename?: 'BlockRichTextRichText' }
        & Pick<BlockRichTextRichText, 'json'>
      )> }
    ) | { __typename: 'BlockTable' } | { __typename: 'BlockTwoColumn' }>> }
  )> }
  & OtherNewsArticleFragment
);

export type GetOtherNewsArticlePreviewsOfTypeQueryVariables = Exact<{
  locale?: Maybe<Scalars['String']>;
  preview?: Maybe<Scalars['Boolean']>;
  slug?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
}>;


export type GetOtherNewsArticlePreviewsOfTypeQuery = (
  { __typename?: 'Query' }
  & { otherNewsArticles?: Maybe<(
    { __typename?: 'NewsArticleCollection' }
    & { items: Array<Maybe<(
      { __typename?: 'NewsArticle' }
      & OtherNewsArticleFragment
    )>> }
  )> }
);

export type OtherNewsArticleFragment = (
  { __typename?: 'NewsArticle' }
  & Pick<NewsArticle, 'newsType' | 'title' | 'date' | 'hideDate' | 'slug' | 'previewText'>
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ), image?: Maybe<(
    { __typename?: 'Asset' }
    & FullAssetFragment
  )> }
  & NewsArticleFileFragment
);

export type GetProjectImageMapByIdQueryVariables = Exact<{
  locale?: Maybe<Scalars['String']>;
  preview?: Maybe<Scalars['Boolean']>;
  projectId?: Maybe<Scalars['Int']>;
}>;


export type GetProjectImageMapByIdQuery = (
  { __typename?: 'Query' }
  & { imageMap?: Maybe<(
    { __typename?: 'ProjectImageMapCollection' }
    & { items: Array<Maybe<(
      { __typename?: 'ProjectImageMap' }
      & FullProjectImageMapFragment
    )>> }
  )> }
);

export type FullProjectImageMapFragment = (
  { __typename?: 'ProjectImageMap' }
  & Pick<ProjectImageMap, 'propstackProjectId' | 'imageMapAreas'>
  & { imagesCollection?: Maybe<(
    { __typename?: 'AssetCollection' }
    & { items: Array<Maybe<(
      { __typename?: 'Asset' }
      & Pick<Asset, 'url' | 'width' | 'height'>
    )>> }
  )> }
);

export type GetProjectLinkSectionByIdQueryVariables = Exact<{
  locale?: Maybe<Scalars['String']>;
  preview?: Maybe<Scalars['Boolean']>;
  projectId?: Maybe<Scalars['Int']>;
}>;


export type GetProjectLinkSectionByIdQuery = (
  { __typename?: 'Query' }
  & { projectLinkSection?: Maybe<(
    { __typename?: 'BlockProjectLinkSectionCollection' }
    & { items: Array<Maybe<(
      { __typename?: 'BlockProjectLinkSection' }
      & ProjectLinkSectionFragment
    )>> }
  )> }
);

export type ProjectLinkSectionFragment = (
  { __typename?: 'BlockProjectLinkSection' }
  & Pick<BlockProjectLinkSection, 'propstackProjectId' | 'title' | 'description'>
  & { projectLinksCollection?: Maybe<(
    { __typename?: 'BlockProjectLinkSectionProjectLinksCollection' }
    & { items: Array<Maybe<(
      { __typename?: 'ProjectLink' }
      & Pick<ProjectLink, 'title' | 'link'>
      & { backgroundImage?: Maybe<(
        { __typename?: 'Asset' }
        & FullAssetFragment
      )> }
    )>> }
  )> }
);

export type GetProjectPageByIdQueryVariables = Exact<{
  locale?: Maybe<Scalars['String']>;
  preview?: Maybe<Scalars['Boolean']>;
  projectId?: Maybe<Scalars['Int']>;
}>;


export type GetProjectPageByIdQuery = (
  { __typename?: 'Query' }
  & { pages?: Maybe<(
    { __typename?: 'ProjectPageCollection' }
    & { items: Array<Maybe<(
      { __typename?: 'ProjectPage' }
      & FullProjectPageFragment
    )>> }
  )> }
);

export type FullProjectPageFragment = (
  { __typename?: 'ProjectPage' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ), blocksBelowImagesCollection?: Maybe<(
    { __typename?: 'ProjectPageBlocksBelowImagesCollection' }
    & { items: Array<Maybe<(
      { __typename?: 'BarChartWithBackground' }
      & EntryId_BarChartWithBackground_Fragment
    ) | (
      { __typename?: 'BlockAccordion' }
      & EntryId_BlockAccordion_Fragment
    ) | (
      { __typename?: 'BlockAccordionEntry' }
      & EntryId_BlockAccordionEntry_Fragment
    ) | (
      { __typename?: 'BlockBigTitleNavigation' }
      & EntryId_BlockBigTitleNavigation_Fragment
    ) | (
      { __typename?: 'BlockCallToActionButton' }
      & EntryId_BlockCallToActionButton_Fragment
    ) | (
      { __typename?: 'BlockCustom' }
      & EntryId_BlockCustom_Fragment
    ) | (
      { __typename?: 'BlockFullsizeImage' }
      & EntryId_BlockFullsizeImage_Fragment
    ) | (
      { __typename?: 'BlockHighlightRealEstate' }
      & EntryId_BlockHighlightRealEstate_Fragment
    ) | (
      { __typename?: 'BlockPartnerGrid' }
      & EntryId_BlockPartnerGrid_Fragment
    ) | (
      { __typename?: 'BlockPersonAccordion' }
      & EntryId_BlockPersonAccordion_Fragment
    ) | (
      { __typename?: 'BlockRibbon' }
      & EntryId_BlockRibbon_Fragment
    ) | (
      { __typename?: 'BlockRichText' }
      & EntryId_BlockRichText_Fragment
    ) | (
      { __typename?: 'BlockTable' }
      & EntryId_BlockTable_Fragment
    ) | (
      { __typename?: 'BlockThreeColumn' }
      & EntryId_BlockThreeColumn_Fragment
    ) | (
      { __typename?: 'BlockTwoColumn' }
      & EntryId_BlockTwoColumn_Fragment
    ) | (
      { __typename?: 'BlockVideo' }
      & EntryId_BlockVideo_Fragment
    )>> }
  )> }
);

export type GetAllStaticFiltersQueryVariables = Exact<{
  locale?: Maybe<Scalars['String']>;
  preview?: Maybe<Scalars['Boolean']>;
}>;


export type GetAllStaticFiltersQuery = (
  { __typename?: 'Query' }
  & { staticFilters?: Maybe<(
    { __typename?: 'RegionDescriptionTextCollection' }
    & { items: Array<Maybe<(
      { __typename?: 'RegionDescriptionText' }
      & StaticFilterFragment
    )>> }
  )> }
);

export type StaticFilterFragment = (
  { __typename?: 'RegionDescriptionText' }
  & Pick<RegionDescriptionText, 'slug' | 'city' | 'location' | 'otherFilter' | 'constructionAge' | 'rented' | 'rsCategory' | 'roomsMin' | 'roomsMax' | 'squareMetersMin' | 'squareMetersMax'>
  & { seo?: Maybe<(
    { __typename?: 'Seo' }
    & Pick<Seo, 'title' | 'description'>
  )>, seoText?: Maybe<(
    { __typename?: 'RegionDescriptionTextRegionDescription' }
    & Pick<RegionDescriptionTextRegionDescription, 'json'>
  )> }
);

type FullBlock_HeroImage_Fragment = (
  { __typename?: 'HeroImage' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type FullBlock_StaticPage_Fragment = (
  { __typename?: 'StaticPage' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type FullBlock_NavBarEntry_Fragment = (
  { __typename?: 'NavBarEntry' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type FullBlock_BlockSubNavigation_Fragment = (
  { __typename?: 'BlockSubNavigation' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
  & BlockSubNavigationFragment
);

type FullBlock_BlockBigTitleNavigation_Fragment = (
  { __typename?: 'BlockBigTitleNavigation' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
  & BlockBigTitleNavigationFragment
);

type FullBlock_BlockHiddenWithConsent_Fragment = (
  { __typename?: 'BlockHiddenWithConsent' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type FullBlock_BlockAccordion_Fragment = (
  { __typename?: 'BlockAccordion' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
  & AccordionFragment
);

type FullBlock_BlockOneColumn_Fragment = (
  { __typename?: 'BlockOneColumn' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
  & OneColumnLayoutFragment
);

type FullBlock_BlockAnalystRating_Fragment = (
  { __typename?: 'BlockAnalystRating' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
  & BlockAnalystRatingFragment
);

type FullBlock_BlockCallToActionButton_Fragment = (
  { __typename?: 'BlockCallToActionButton' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
  & FullBlockCallToActionButtonFragment
);

type FullBlock_BlockTwoColumn_Fragment = (
  { __typename?: 'BlockTwoColumn' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
  & TwoColumnLayoutFragment
);

type FullBlock_BlockAccordionEntry_Fragment = (
  { __typename?: 'BlockAccordionEntry' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
  & AccordionEntryFragment
);

type FullBlock_NewsArticle_Fragment = (
  { __typename?: 'NewsArticle' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type FullBlock_BlockRichText_Fragment = (
  { __typename?: 'BlockRichText' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
  & FullBlockRichTextFragment
);

type FullBlock_LexiconArticle_Fragment = (
  { __typename?: 'LexiconArticle' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type FullBlock_ProjectPage_Fragment = (
  { __typename?: 'ProjectPage' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type FullBlock_BarChartWithBackground_Fragment = (
  { __typename?: 'BarChartWithBackground' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
  & BarChartWithBackgroundFragment
);

type FullBlock_BlockCustom_Fragment = (
  { __typename?: 'BlockCustom' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
  & CustomBlockFragment
);

type FullBlock_BlockFullsizeImage_Fragment = (
  { __typename?: 'BlockFullsizeImage' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
  & FullBlockFullsizeImageFragment
);

type FullBlock_BlockHighlightRealEstate_Fragment = (
  { __typename?: 'BlockHighlightRealEstate' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
  & BlockHighlightRealEstateFragment
);

type FullBlock_HighlightedRealEstate_Fragment = (
  { __typename?: 'HighlightedRealEstate' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type FullBlock_BlockPartnerGrid_Fragment = (
  { __typename?: 'BlockPartnerGrid' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
  & BlockPartnerGridFragment
);

type FullBlock_Partner_Fragment = (
  { __typename?: 'Partner' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type FullBlock_BlockPersonAccordion_Fragment = (
  { __typename?: 'BlockPersonAccordion' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
  & PersonAccordionFragment
);

type FullBlock_PersonAccordionEntry_Fragment = (
  { __typename?: 'PersonAccordionEntry' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
  & PersonAccordionEntryFragment
);

type FullBlock_BlockRibbon_Fragment = (
  { __typename?: 'BlockRibbon' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
  & FullBlockRibbonFragment
);

type FullBlock_BlockTable_Fragment = (
  { __typename?: 'BlockTable' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
  & FullBlockTableFragment
);

type FullBlock_BlockThreeColumn_Fragment = (
  { __typename?: 'BlockThreeColumn' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
  & BlockThreeColumnFragment
);

type FullBlock_BlockVideo_Fragment = (
  { __typename?: 'BlockVideo' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
  & BlockVideoFragment
);

type FullBlock_NewsArticleContact_Fragment = (
  { __typename?: 'NewsArticleContact' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type FullBlock_BlockSpeechBubble_Fragment = (
  { __typename?: 'BlockSpeechBubble' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
  & BlockSpeechBubbleFragment
);

type FullBlock_LatestDownload_Fragment = (
  { __typename?: 'LatestDownload' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
  & LatestDownloadFragment
);

type FullBlock_NavigationEntry_Fragment = (
  { __typename?: 'NavigationEntry' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
  & NavigationEntryFragment
);

type FullBlock_BlockLinkSection_Fragment = (
  { __typename?: 'BlockLinkSection' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
  & BlockLinkSectionFragment
);

type FullBlock_LinkSectionEntry_Fragment = (
  { __typename?: 'LinkSectionEntry' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type FullBlock_BlockStockPrice_Fragment = (
  { __typename?: 'BlockStockPrice' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
  & BlockStockPriceFragment
);

type FullBlock_BlockImageGallery_Fragment = (
  { __typename?: 'BlockImageGallery' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
  & BlockImageGalleryFragment
);

type FullBlock_BlockSlider_Fragment = (
  { __typename?: 'BlockSlider' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
  & BlockSliderFragment
);

type FullBlock_BlockSliderEntry_Fragment = (
  { __typename?: 'BlockSliderEntry' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
  & BlockSliderEntryFragment
);

type FullBlock_BlockTextCloud_Fragment = (
  { __typename?: 'BlockTextCloud' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
  & BlockTextCloudFragment
);

type FullBlock_Seo_Fragment = (
  { __typename?: 'Seo' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type FullBlock_RegionDescriptionText_Fragment = (
  { __typename?: 'RegionDescriptionText' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type FullBlock_ProjectLink_Fragment = (
  { __typename?: 'ProjectLink' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type FullBlock_BlockProjectLinkSection_Fragment = (
  { __typename?: 'BlockProjectLinkSection' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type FullBlock_ProjectImageMap_Fragment = (
  { __typename?: 'ProjectImageMap' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type FullBlock_DownloadableFile_Fragment = (
  { __typename?: 'DownloadableFile' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type FullBlock_Footer_Fragment = (
  { __typename?: 'Footer' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

export type FullBlockFragment = FullBlock_HeroImage_Fragment | FullBlock_StaticPage_Fragment | FullBlock_NavBarEntry_Fragment | FullBlock_BlockSubNavigation_Fragment | FullBlock_BlockBigTitleNavigation_Fragment | FullBlock_BlockHiddenWithConsent_Fragment | FullBlock_BlockAccordion_Fragment | FullBlock_BlockOneColumn_Fragment | FullBlock_BlockAnalystRating_Fragment | FullBlock_BlockCallToActionButton_Fragment | FullBlock_BlockTwoColumn_Fragment | FullBlock_BlockAccordionEntry_Fragment | FullBlock_NewsArticle_Fragment | FullBlock_BlockRichText_Fragment | FullBlock_LexiconArticle_Fragment | FullBlock_ProjectPage_Fragment | FullBlock_BarChartWithBackground_Fragment | FullBlock_BlockCustom_Fragment | FullBlock_BlockFullsizeImage_Fragment | FullBlock_BlockHighlightRealEstate_Fragment | FullBlock_HighlightedRealEstate_Fragment | FullBlock_BlockPartnerGrid_Fragment | FullBlock_Partner_Fragment | FullBlock_BlockPersonAccordion_Fragment | FullBlock_PersonAccordionEntry_Fragment | FullBlock_BlockRibbon_Fragment | FullBlock_BlockTable_Fragment | FullBlock_BlockThreeColumn_Fragment | FullBlock_BlockVideo_Fragment | FullBlock_NewsArticleContact_Fragment | FullBlock_BlockSpeechBubble_Fragment | FullBlock_LatestDownload_Fragment | FullBlock_NavigationEntry_Fragment | FullBlock_BlockLinkSection_Fragment | FullBlock_LinkSectionEntry_Fragment | FullBlock_BlockStockPrice_Fragment | FullBlock_BlockImageGallery_Fragment | FullBlock_BlockSlider_Fragment | FullBlock_BlockSliderEntry_Fragment | FullBlock_BlockTextCloud_Fragment | FullBlock_Seo_Fragment | FullBlock_RegionDescriptionText_Fragment | FullBlock_ProjectLink_Fragment | FullBlock_BlockProjectLinkSection_Fragment | FullBlock_ProjectImageMap_Fragment | FullBlock_DownloadableFile_Fragment | FullBlock_Footer_Fragment;

export type FullBlockFullsizeImageFragment = (
  { __typename?: 'BlockFullsizeImage' }
  & Pick<BlockFullsizeImage, 'maxWidthParent'>
  & { image?: Maybe<(
    { __typename?: 'Asset' }
    & FullAssetFragment
  )>, downloadFile?: Maybe<(
    { __typename?: 'Asset' }
    & FullAssetFragment
  )> }
);

export type FullBlockRichTextFragment = (
  { __typename?: 'BlockRichText' }
  & Pick<BlockRichText, 'textAlignCenter' | 'superscript' | 'superscriptFontSize'>
  & { richText?: Maybe<(
    { __typename?: 'BlockRichTextRichText' }
    & Pick<BlockRichTextRichText, 'json'>
    & { links: (
      { __typename?: 'BlockRichTextRichTextLinks' }
      & { assets: (
        { __typename?: 'BlockRichTextRichTextAssets' }
        & { block: Array<Maybe<(
          { __typename?: 'Asset' }
          & FullAssetFragment
        )>>, hyperlink: Array<Maybe<(
          { __typename?: 'Asset' }
          & FullHyperlinkFragment
        )>> }
      ) }
    ) }
  )> }
);

export type FullBlockCallToActionButtonFragment = (
  { __typename?: 'BlockCallToActionButton' }
  & Pick<BlockCallToActionButton, 'label' | 'url' | 'hideIcon' | 'useNewWindow' | 'variant' | 'color'>
);

export type TwoColumnLayoutFragment = (
  { __typename?: 'BlockTwoColumn' }
  & Pick<BlockTwoColumn, 'rightColumnOffset' | 'verticalCenterLeftColumn' | 'verticalCenterRightColumn' | 'leftColumnTextRight' | 'variant' | 'mobileColumnOrder' | 'appendContactAndNewsletterCtAs'>
  & { leftColumnCollection?: Maybe<(
    { __typename?: 'BlockTwoColumnLeftColumnCollection' }
    & { items: Array<Maybe<(
      { __typename?: 'BlockAccordion' }
      & EntryId_BlockAccordion_Fragment
    ) | (
      { __typename?: 'BlockBigTitleNavigation' }
      & EntryId_BlockBigTitleNavigation_Fragment
    ) | (
      { __typename?: 'BlockCallToActionButton' }
      & EntryId_BlockCallToActionButton_Fragment
    ) | (
      { __typename?: 'BlockCustom' }
      & EntryId_BlockCustom_Fragment
    ) | (
      { __typename?: 'BlockFullsizeImage' }
      & EntryId_BlockFullsizeImage_Fragment
    ) | (
      { __typename?: 'BlockRichText' }
      & EntryId_BlockRichText_Fragment
    ) | (
      { __typename?: 'BlockSpeechBubble' }
      & EntryId_BlockSpeechBubble_Fragment
    ) | (
      { __typename?: 'LatestDownload' }
      & EntryId_LatestDownload_Fragment
    ) | (
      { __typename?: 'NavigationEntry' }
      & EntryId_NavigationEntry_Fragment
    )>> }
  )>, rightColumnCollection?: Maybe<(
    { __typename?: 'BlockTwoColumnRightColumnCollection' }
    & { items: Array<Maybe<(
      { __typename?: 'BlockAccordion' }
      & EntryId_BlockAccordion_Fragment
    ) | (
      { __typename?: 'BlockBigTitleNavigation' }
      & EntryId_BlockBigTitleNavigation_Fragment
    ) | (
      { __typename?: 'BlockCallToActionButton' }
      & EntryId_BlockCallToActionButton_Fragment
    ) | (
      { __typename?: 'BlockCustom' }
      & EntryId_BlockCustom_Fragment
    ) | (
      { __typename?: 'BlockFullsizeImage' }
      & EntryId_BlockFullsizeImage_Fragment
    ) | (
      { __typename?: 'BlockRichText' }
      & EntryId_BlockRichText_Fragment
    ) | (
      { __typename?: 'BlockSpeechBubble' }
      & EntryId_BlockSpeechBubble_Fragment
    ) | (
      { __typename?: 'LatestDownload' }
      & EntryId_LatestDownload_Fragment
    ) | (
      { __typename?: 'NavigationEntry' }
      & EntryId_NavigationEntry_Fragment
    )>> }
  )> }
);

export type OneColumnLayoutFragment = (
  { __typename?: 'BlockOneColumn' }
  & Pick<BlockOneColumn, 'smallMainColumnOverImage' | 'enableBlackBackground' | 'backgroundColor' | 'withExtraPadding' | 'padding'>
  & { mainColumnCollection?: Maybe<(
    { __typename?: 'BlockOneColumnMainColumnCollection' }
    & { items: Array<Maybe<(
      { __typename?: 'BlockAccordion' }
      & EntryId_BlockAccordion_Fragment
    ) | (
      { __typename?: 'BlockAnalystRating' }
      & EntryId_BlockAnalystRating_Fragment
    ) | (
      { __typename?: 'BlockBigTitleNavigation' }
      & EntryId_BlockBigTitleNavigation_Fragment
    ) | (
      { __typename?: 'BlockCallToActionButton' }
      & EntryId_BlockCallToActionButton_Fragment
    ) | (
      { __typename?: 'BlockCustom' }
      & EntryId_BlockCustom_Fragment
    ) | (
      { __typename?: 'BlockFullsizeImage' }
      & EntryId_BlockFullsizeImage_Fragment
    ) | (
      { __typename?: 'BlockHighlightRealEstate' }
      & EntryId_BlockHighlightRealEstate_Fragment
    ) | (
      { __typename?: 'BlockLinkSection' }
      & EntryId_BlockLinkSection_Fragment
    ) | (
      { __typename?: 'BlockOneColumn' }
      & EntryId_BlockOneColumn_Fragment
    ) | (
      { __typename?: 'BlockPartnerGrid' }
      & EntryId_BlockPartnerGrid_Fragment
    ) | (
      { __typename?: 'BlockPersonAccordion' }
      & EntryId_BlockPersonAccordion_Fragment
    ) | (
      { __typename?: 'BlockRibbon' }
      & EntryId_BlockRibbon_Fragment
    ) | (
      { __typename?: 'BlockRichText' }
      & EntryId_BlockRichText_Fragment
    ) | (
      { __typename?: 'BlockStockPrice' }
      & EntryId_BlockStockPrice_Fragment
    ) | (
      { __typename?: 'BlockTable' }
      & EntryId_BlockTable_Fragment
    ) | (
      { __typename?: 'BlockThreeColumn' }
      & EntryId_BlockThreeColumn_Fragment
    ) | (
      { __typename?: 'BlockTwoColumn' }
      & EntryId_BlockTwoColumn_Fragment
    ) | (
      { __typename?: 'BlockVideo' }
      & EntryId_BlockVideo_Fragment
    )>> }
  )>, backgroundImage?: Maybe<(
    { __typename?: 'Asset' }
    & FullAssetFragment
  )> }
);

export type BlockThreeColumnFragment = (
  { __typename?: 'BlockThreeColumn' }
  & { leftColumnCollection?: Maybe<(
    { __typename?: 'BlockThreeColumnLeftColumnCollection' }
    & { items: Array<Maybe<(
      { __typename?: 'HeroImage' }
      & EntryId_HeroImage_Fragment
    ) | (
      { __typename?: 'StaticPage' }
      & EntryId_StaticPage_Fragment
    ) | (
      { __typename?: 'NavBarEntry' }
      & EntryId_NavBarEntry_Fragment
    ) | (
      { __typename?: 'BlockSubNavigation' }
      & EntryId_BlockSubNavigation_Fragment
    ) | (
      { __typename?: 'BlockBigTitleNavigation' }
      & EntryId_BlockBigTitleNavigation_Fragment
    ) | (
      { __typename?: 'BlockHiddenWithConsent' }
      & EntryId_BlockHiddenWithConsent_Fragment
    ) | (
      { __typename?: 'BlockAccordion' }
      & EntryId_BlockAccordion_Fragment
    ) | (
      { __typename?: 'BlockOneColumn' }
      & EntryId_BlockOneColumn_Fragment
    ) | (
      { __typename?: 'BlockAnalystRating' }
      & EntryId_BlockAnalystRating_Fragment
    ) | (
      { __typename?: 'BlockCallToActionButton' }
      & EntryId_BlockCallToActionButton_Fragment
    ) | (
      { __typename?: 'BlockTwoColumn' }
      & EntryId_BlockTwoColumn_Fragment
    ) | (
      { __typename?: 'BlockAccordionEntry' }
      & EntryId_BlockAccordionEntry_Fragment
    ) | (
      { __typename?: 'NewsArticle' }
      & EntryId_NewsArticle_Fragment
    ) | (
      { __typename?: 'BlockRichText' }
      & EntryId_BlockRichText_Fragment
    ) | (
      { __typename?: 'LexiconArticle' }
      & EntryId_LexiconArticle_Fragment
    ) | (
      { __typename?: 'ProjectPage' }
      & EntryId_ProjectPage_Fragment
    ) | (
      { __typename?: 'BarChartWithBackground' }
      & EntryId_BarChartWithBackground_Fragment
    ) | (
      { __typename?: 'BlockCustom' }
      & EntryId_BlockCustom_Fragment
    ) | (
      { __typename?: 'BlockFullsizeImage' }
      & EntryId_BlockFullsizeImage_Fragment
    ) | (
      { __typename?: 'BlockHighlightRealEstate' }
      & EntryId_BlockHighlightRealEstate_Fragment
    ) | (
      { __typename?: 'HighlightedRealEstate' }
      & EntryId_HighlightedRealEstate_Fragment
    ) | (
      { __typename?: 'BlockPartnerGrid' }
      & EntryId_BlockPartnerGrid_Fragment
    ) | (
      { __typename?: 'Partner' }
      & EntryId_Partner_Fragment
    ) | (
      { __typename?: 'BlockPersonAccordion' }
      & EntryId_BlockPersonAccordion_Fragment
    ) | (
      { __typename?: 'PersonAccordionEntry' }
      & EntryId_PersonAccordionEntry_Fragment
    ) | (
      { __typename?: 'BlockRibbon' }
      & EntryId_BlockRibbon_Fragment
    ) | (
      { __typename?: 'BlockTable' }
      & EntryId_BlockTable_Fragment
    ) | (
      { __typename?: 'BlockThreeColumn' }
      & EntryId_BlockThreeColumn_Fragment
    ) | (
      { __typename?: 'BlockVideo' }
      & EntryId_BlockVideo_Fragment
    ) | (
      { __typename?: 'NewsArticleContact' }
      & EntryId_NewsArticleContact_Fragment
    ) | (
      { __typename?: 'BlockSpeechBubble' }
      & EntryId_BlockSpeechBubble_Fragment
    ) | (
      { __typename?: 'LatestDownload' }
      & EntryId_LatestDownload_Fragment
    ) | (
      { __typename?: 'NavigationEntry' }
      & EntryId_NavigationEntry_Fragment
    ) | (
      { __typename?: 'BlockLinkSection' }
      & EntryId_BlockLinkSection_Fragment
    ) | (
      { __typename?: 'LinkSectionEntry' }
      & EntryId_LinkSectionEntry_Fragment
    ) | (
      { __typename?: 'BlockStockPrice' }
      & EntryId_BlockStockPrice_Fragment
    ) | (
      { __typename?: 'BlockImageGallery' }
      & EntryId_BlockImageGallery_Fragment
    ) | (
      { __typename?: 'BlockSlider' }
      & EntryId_BlockSlider_Fragment
    ) | (
      { __typename?: 'BlockSliderEntry' }
      & EntryId_BlockSliderEntry_Fragment
    ) | (
      { __typename?: 'BlockTextCloud' }
      & EntryId_BlockTextCloud_Fragment
    ) | (
      { __typename?: 'Seo' }
      & EntryId_Seo_Fragment
    ) | (
      { __typename?: 'RegionDescriptionText' }
      & EntryId_RegionDescriptionText_Fragment
    ) | (
      { __typename?: 'ProjectLink' }
      & EntryId_ProjectLink_Fragment
    ) | (
      { __typename?: 'BlockProjectLinkSection' }
      & EntryId_BlockProjectLinkSection_Fragment
    ) | (
      { __typename?: 'ProjectImageMap' }
      & EntryId_ProjectImageMap_Fragment
    ) | (
      { __typename?: 'DownloadableFile' }
      & EntryId_DownloadableFile_Fragment
    ) | (
      { __typename?: 'Footer' }
      & EntryId_Footer_Fragment
    )>> }
  )>, middleColumnCollection?: Maybe<(
    { __typename?: 'BlockThreeColumnMiddleColumnCollection' }
    & { items: Array<Maybe<(
      { __typename?: 'HeroImage' }
      & EntryId_HeroImage_Fragment
    ) | (
      { __typename?: 'StaticPage' }
      & EntryId_StaticPage_Fragment
    ) | (
      { __typename?: 'NavBarEntry' }
      & EntryId_NavBarEntry_Fragment
    ) | (
      { __typename?: 'BlockSubNavigation' }
      & EntryId_BlockSubNavigation_Fragment
    ) | (
      { __typename?: 'BlockBigTitleNavigation' }
      & EntryId_BlockBigTitleNavigation_Fragment
    ) | (
      { __typename?: 'BlockHiddenWithConsent' }
      & EntryId_BlockHiddenWithConsent_Fragment
    ) | (
      { __typename?: 'BlockAccordion' }
      & EntryId_BlockAccordion_Fragment
    ) | (
      { __typename?: 'BlockOneColumn' }
      & EntryId_BlockOneColumn_Fragment
    ) | (
      { __typename?: 'BlockAnalystRating' }
      & EntryId_BlockAnalystRating_Fragment
    ) | (
      { __typename?: 'BlockCallToActionButton' }
      & EntryId_BlockCallToActionButton_Fragment
    ) | (
      { __typename?: 'BlockTwoColumn' }
      & EntryId_BlockTwoColumn_Fragment
    ) | (
      { __typename?: 'BlockAccordionEntry' }
      & EntryId_BlockAccordionEntry_Fragment
    ) | (
      { __typename?: 'NewsArticle' }
      & EntryId_NewsArticle_Fragment
    ) | (
      { __typename?: 'BlockRichText' }
      & EntryId_BlockRichText_Fragment
    ) | (
      { __typename?: 'LexiconArticle' }
      & EntryId_LexiconArticle_Fragment
    ) | (
      { __typename?: 'ProjectPage' }
      & EntryId_ProjectPage_Fragment
    ) | (
      { __typename?: 'BarChartWithBackground' }
      & EntryId_BarChartWithBackground_Fragment
    ) | (
      { __typename?: 'BlockCustom' }
      & EntryId_BlockCustom_Fragment
    ) | (
      { __typename?: 'BlockFullsizeImage' }
      & EntryId_BlockFullsizeImage_Fragment
    ) | (
      { __typename?: 'BlockHighlightRealEstate' }
      & EntryId_BlockHighlightRealEstate_Fragment
    ) | (
      { __typename?: 'HighlightedRealEstate' }
      & EntryId_HighlightedRealEstate_Fragment
    ) | (
      { __typename?: 'BlockPartnerGrid' }
      & EntryId_BlockPartnerGrid_Fragment
    ) | (
      { __typename?: 'Partner' }
      & EntryId_Partner_Fragment
    ) | (
      { __typename?: 'BlockPersonAccordion' }
      & EntryId_BlockPersonAccordion_Fragment
    ) | (
      { __typename?: 'PersonAccordionEntry' }
      & EntryId_PersonAccordionEntry_Fragment
    ) | (
      { __typename?: 'BlockRibbon' }
      & EntryId_BlockRibbon_Fragment
    ) | (
      { __typename?: 'BlockTable' }
      & EntryId_BlockTable_Fragment
    ) | (
      { __typename?: 'BlockThreeColumn' }
      & EntryId_BlockThreeColumn_Fragment
    ) | (
      { __typename?: 'BlockVideo' }
      & EntryId_BlockVideo_Fragment
    ) | (
      { __typename?: 'NewsArticleContact' }
      & EntryId_NewsArticleContact_Fragment
    ) | (
      { __typename?: 'BlockSpeechBubble' }
      & EntryId_BlockSpeechBubble_Fragment
    ) | (
      { __typename?: 'LatestDownload' }
      & EntryId_LatestDownload_Fragment
    ) | (
      { __typename?: 'NavigationEntry' }
      & EntryId_NavigationEntry_Fragment
    ) | (
      { __typename?: 'BlockLinkSection' }
      & EntryId_BlockLinkSection_Fragment
    ) | (
      { __typename?: 'LinkSectionEntry' }
      & EntryId_LinkSectionEntry_Fragment
    ) | (
      { __typename?: 'BlockStockPrice' }
      & EntryId_BlockStockPrice_Fragment
    ) | (
      { __typename?: 'BlockImageGallery' }
      & EntryId_BlockImageGallery_Fragment
    ) | (
      { __typename?: 'BlockSlider' }
      & EntryId_BlockSlider_Fragment
    ) | (
      { __typename?: 'BlockSliderEntry' }
      & EntryId_BlockSliderEntry_Fragment
    ) | (
      { __typename?: 'BlockTextCloud' }
      & EntryId_BlockTextCloud_Fragment
    ) | (
      { __typename?: 'Seo' }
      & EntryId_Seo_Fragment
    ) | (
      { __typename?: 'RegionDescriptionText' }
      & EntryId_RegionDescriptionText_Fragment
    ) | (
      { __typename?: 'ProjectLink' }
      & EntryId_ProjectLink_Fragment
    ) | (
      { __typename?: 'BlockProjectLinkSection' }
      & EntryId_BlockProjectLinkSection_Fragment
    ) | (
      { __typename?: 'ProjectImageMap' }
      & EntryId_ProjectImageMap_Fragment
    ) | (
      { __typename?: 'DownloadableFile' }
      & EntryId_DownloadableFile_Fragment
    ) | (
      { __typename?: 'Footer' }
      & EntryId_Footer_Fragment
    )>> }
  )>, rightColumnCollection?: Maybe<(
    { __typename?: 'BlockThreeColumnRightColumnCollection' }
    & { items: Array<Maybe<(
      { __typename?: 'HeroImage' }
      & EntryId_HeroImage_Fragment
    ) | (
      { __typename?: 'StaticPage' }
      & EntryId_StaticPage_Fragment
    ) | (
      { __typename?: 'NavBarEntry' }
      & EntryId_NavBarEntry_Fragment
    ) | (
      { __typename?: 'BlockSubNavigation' }
      & EntryId_BlockSubNavigation_Fragment
    ) | (
      { __typename?: 'BlockBigTitleNavigation' }
      & EntryId_BlockBigTitleNavigation_Fragment
    ) | (
      { __typename?: 'BlockHiddenWithConsent' }
      & EntryId_BlockHiddenWithConsent_Fragment
    ) | (
      { __typename?: 'BlockAccordion' }
      & EntryId_BlockAccordion_Fragment
    ) | (
      { __typename?: 'BlockOneColumn' }
      & EntryId_BlockOneColumn_Fragment
    ) | (
      { __typename?: 'BlockAnalystRating' }
      & EntryId_BlockAnalystRating_Fragment
    ) | (
      { __typename?: 'BlockCallToActionButton' }
      & EntryId_BlockCallToActionButton_Fragment
    ) | (
      { __typename?: 'BlockTwoColumn' }
      & EntryId_BlockTwoColumn_Fragment
    ) | (
      { __typename?: 'BlockAccordionEntry' }
      & EntryId_BlockAccordionEntry_Fragment
    ) | (
      { __typename?: 'NewsArticle' }
      & EntryId_NewsArticle_Fragment
    ) | (
      { __typename?: 'BlockRichText' }
      & EntryId_BlockRichText_Fragment
    ) | (
      { __typename?: 'LexiconArticle' }
      & EntryId_LexiconArticle_Fragment
    ) | (
      { __typename?: 'ProjectPage' }
      & EntryId_ProjectPage_Fragment
    ) | (
      { __typename?: 'BarChartWithBackground' }
      & EntryId_BarChartWithBackground_Fragment
    ) | (
      { __typename?: 'BlockCustom' }
      & EntryId_BlockCustom_Fragment
    ) | (
      { __typename?: 'BlockFullsizeImage' }
      & EntryId_BlockFullsizeImage_Fragment
    ) | (
      { __typename?: 'BlockHighlightRealEstate' }
      & EntryId_BlockHighlightRealEstate_Fragment
    ) | (
      { __typename?: 'HighlightedRealEstate' }
      & EntryId_HighlightedRealEstate_Fragment
    ) | (
      { __typename?: 'BlockPartnerGrid' }
      & EntryId_BlockPartnerGrid_Fragment
    ) | (
      { __typename?: 'Partner' }
      & EntryId_Partner_Fragment
    ) | (
      { __typename?: 'BlockPersonAccordion' }
      & EntryId_BlockPersonAccordion_Fragment
    ) | (
      { __typename?: 'PersonAccordionEntry' }
      & EntryId_PersonAccordionEntry_Fragment
    ) | (
      { __typename?: 'BlockRibbon' }
      & EntryId_BlockRibbon_Fragment
    ) | (
      { __typename?: 'BlockTable' }
      & EntryId_BlockTable_Fragment
    ) | (
      { __typename?: 'BlockThreeColumn' }
      & EntryId_BlockThreeColumn_Fragment
    ) | (
      { __typename?: 'BlockVideo' }
      & EntryId_BlockVideo_Fragment
    ) | (
      { __typename?: 'NewsArticleContact' }
      & EntryId_NewsArticleContact_Fragment
    ) | (
      { __typename?: 'BlockSpeechBubble' }
      & EntryId_BlockSpeechBubble_Fragment
    ) | (
      { __typename?: 'LatestDownload' }
      & EntryId_LatestDownload_Fragment
    ) | (
      { __typename?: 'NavigationEntry' }
      & EntryId_NavigationEntry_Fragment
    ) | (
      { __typename?: 'BlockLinkSection' }
      & EntryId_BlockLinkSection_Fragment
    ) | (
      { __typename?: 'LinkSectionEntry' }
      & EntryId_LinkSectionEntry_Fragment
    ) | (
      { __typename?: 'BlockStockPrice' }
      & EntryId_BlockStockPrice_Fragment
    ) | (
      { __typename?: 'BlockImageGallery' }
      & EntryId_BlockImageGallery_Fragment
    ) | (
      { __typename?: 'BlockSlider' }
      & EntryId_BlockSlider_Fragment
    ) | (
      { __typename?: 'BlockSliderEntry' }
      & EntryId_BlockSliderEntry_Fragment
    ) | (
      { __typename?: 'BlockTextCloud' }
      & EntryId_BlockTextCloud_Fragment
    ) | (
      { __typename?: 'Seo' }
      & EntryId_Seo_Fragment
    ) | (
      { __typename?: 'RegionDescriptionText' }
      & EntryId_RegionDescriptionText_Fragment
    ) | (
      { __typename?: 'ProjectLink' }
      & EntryId_ProjectLink_Fragment
    ) | (
      { __typename?: 'BlockProjectLinkSection' }
      & EntryId_BlockProjectLinkSection_Fragment
    ) | (
      { __typename?: 'ProjectImageMap' }
      & EntryId_ProjectImageMap_Fragment
    ) | (
      { __typename?: 'DownloadableFile' }
      & EntryId_DownloadableFile_Fragment
    ) | (
      { __typename?: 'Footer' }
      & EntryId_Footer_Fragment
    )>> }
  )> }
);

export type AccordionFragment = (
  { __typename?: 'BlockAccordion' }
  & Pick<BlockAccordion, 'aquaColor' | 'smallSize' | 'widgetType' | 'isControlled'>
  & { accordionEntryCollection?: Maybe<(
    { __typename?: 'BlockAccordionAccordionEntryCollection' }
    & { items: Array<Maybe<(
      { __typename?: 'BlockAccordionEntry' }
      & EntryId_BlockAccordionEntry_Fragment
    )>> }
  )> }
);

export type AccordionEntryFragment = (
  { __typename?: 'BlockAccordionEntry' }
  & Pick<BlockAccordionEntry, 'title' | 'titleWhenExpanded'>
  & { blocksCollection?: Maybe<(
    { __typename?: 'BlockAccordionEntryBlocksCollection' }
    & { items: Array<Maybe<(
      { __typename?: 'BlockCallToActionButton' }
      & EntryId_BlockCallToActionButton_Fragment
    ) | (
      { __typename?: 'BlockCustom' }
      & EntryId_BlockCustom_Fragment
    ) | (
      { __typename?: 'BlockRichText' }
      & EntryId_BlockRichText_Fragment
    ) | (
      { __typename?: 'BlockTable' }
      & EntryId_BlockTable_Fragment
    ) | (
      { __typename?: 'BlockTwoColumn' }
      & EntryId_BlockTwoColumn_Fragment
    )>> }
  )> }
);

export type CustomBlockFragment = (
  { __typename?: 'BlockCustom' }
  & Pick<BlockCustom, 'customBlockType'>
);

export type PersonAccordionFragment = (
  { __typename?: 'BlockPersonAccordion' }
  & Pick<BlockPersonAccordion, 'title'>
  & { personEntriesCollection?: Maybe<(
    { __typename?: 'BlockPersonAccordionPersonEntriesCollection' }
    & { items: Array<Maybe<(
      { __typename?: 'PersonAccordionEntry' }
      & Pick<PersonAccordionEntry, 'fullName'>
      & EntryId_PersonAccordionEntry_Fragment
    )>> }
  )> }
);

export type PersonAccordionEntryFragment = (
  { __typename?: 'PersonAccordionEntry' }
  & Pick<PersonAccordionEntry, 'fullName' | 'jobTitle' | 'description'>
  & { portraitImage?: Maybe<(
    { __typename?: 'Asset' }
    & FullAssetFragment
  )> }
  & EntryId_PersonAccordionEntry_Fragment
);

export type BarChartWithBackgroundFragment = (
  { __typename?: 'BarChartWithBackground' }
  & Pick<BarChartWithBackground, 'title' | 'bars'>
);

export type FullBlockTableFragment = (
  { __typename?: 'BlockTable' }
  & Pick<BlockTable, 'title' | 'variant' | 'table'>
);

export type FullBlockRibbonFragment = (
  { __typename?: 'BlockRibbon' }
  & Pick<BlockRibbon, 'heading1' | 'subheading1' | 'heading2' | 'subheading2' | 'heading3' | 'subheading3' | 'heading4' | 'subheading4' | 'variant'>
  & { overlayImage?: Maybe<(
    { __typename?: 'Asset' }
    & FullAssetFragment
  )> }
  & EntryId_BlockRibbon_Fragment
);

export type LatestDownloadFragment = (
  { __typename?: 'LatestDownload' }
  & Pick<LatestDownload, 'type'>
);

export type BlockImageGalleryFragment = (
  { __typename?: 'BlockImageGallery' }
  & Pick<BlockImageGallery, 'size'>
  & { imagesCollection?: Maybe<(
    { __typename?: 'AssetCollection' }
    & { items: Array<Maybe<(
      { __typename?: 'Asset' }
      & FullAssetFragment
    )>> }
  )> }
);

export type BlockSliderFragment = (
  { __typename?: 'BlockSlider' }
  & { slidesCollection?: Maybe<(
    { __typename?: 'BlockSliderSlidesCollection' }
    & { items: Array<Maybe<(
      { __typename?: 'BlockSliderEntry' }
      & EntryId_BlockSliderEntry_Fragment
    )>> }
  )> }
);

export type BlockSliderEntryFragment = (
  { __typename?: 'BlockSliderEntry' }
  & { image?: Maybe<(
    { __typename?: 'Asset' }
    & FullAssetFragment
  )>, richText?: Maybe<(
    { __typename?: 'BlockSliderEntryRichText' }
    & Pick<BlockSliderEntryRichText, 'json'>
    & { links: (
      { __typename?: 'BlockSliderEntryRichTextLinks' }
      & { assets: (
        { __typename?: 'BlockSliderEntryRichTextAssets' }
        & { block: Array<Maybe<(
          { __typename?: 'Asset' }
          & FullAssetFragment
        )>>, hyperlink: Array<Maybe<(
          { __typename?: 'Asset' }
          & FullHyperlinkFragment
        )>> }
      ) }
    ) }
  )> }
);

export type NavigationEntryFragment = (
  { __typename?: 'NavigationEntry' }
  & Pick<NavigationEntry, 'title' | 'subTitle' | 'buttonText'>
  & { image?: Maybe<(
    { __typename?: 'Asset' }
    & FullAssetFragment
  )>, staticPage?: Maybe<(
    { __typename?: 'StaticPage' }
    & Pick<StaticPage, 'slug'>
  )> }
);

export type BlockStockPriceFragment = (
  { __typename?: 'BlockStockPrice' }
  & Pick<BlockStockPrice, 'stockPriceDescription'>
);

export type BlockBigTitleNavigationFragment = (
  { __typename?: 'BlockBigTitleNavigation' }
  & Pick<BlockBigTitleNavigation, 'title' | 'subTitle' | 'additionalInfoText' | 'buttonText' | 'url'>
  & { staticPageReference?: Maybe<(
    { __typename?: 'StaticPage' }
    & Pick<StaticPage, 'slug'>
  )> }
);

export type BlockAnalystRatingFragment = (
  { __typename?: 'BlockAnalystRating' }
  & Pick<BlockAnalystRating, 'name' | 'company' | 'targetPrice' | 'coverageCurrentlySuspended' | 'date' | 'recommendation' | 'noteText'>
  & { download?: Maybe<(
    { __typename?: 'Asset' }
    & FullAssetFragment
  )> }
);

export type BlockPartnerGridFragment = (
  { __typename?: 'BlockPartnerGrid' }
  & { partnersCollection?: Maybe<(
    { __typename?: 'BlockPartnerGridPartnersCollection' }
    & { items: Array<Maybe<(
      { __typename?: 'Partner' }
      & Pick<Partner, 'partnerText' | 'href'>
      & { partnerImage?: Maybe<(
        { __typename?: 'Asset' }
        & FullAssetFragment
      )> }
    )>> }
  )> }
);

export type BlockHighlightRealEstateFragment = (
  { __typename?: 'BlockHighlightRealEstate' }
  & Pick<BlockHighlightRealEstate, 'variant'>
  & { highlightedRealEstatesCollection?: Maybe<(
    { __typename?: 'BlockHighlightRealEstateHighlightedRealEstatesCollection' }
    & { items: Array<Maybe<(
      { __typename?: 'HighlightedRealEstate' }
      & Pick<HighlightedRealEstate, 'title' | 'subTitle' | 'rooms' | 'squareMeter' | 'price' | 'pricePerSquareMeter' | 'slug' | 'isComingSoonProject'>
      & { image?: Maybe<(
        { __typename?: 'Asset' }
        & FullAssetFragment
      )> }
      & EntryId_HighlightedRealEstate_Fragment
    )>> }
  )>, bigTitleNavigation?: Maybe<(
    { __typename?: 'BlockBigTitleNavigation' }
    & BlockBigTitleNavigationFragment
  )> }
);

export type BlockVideoFragment = (
  { __typename?: 'BlockVideo' }
  & Pick<BlockVideo, 'headline' | 'href'>
);

export type BlockLinkSectionFragment = (
  { __typename?: 'BlockLinkSection' }
  & Pick<BlockLinkSection, 'title'>
  & { linkSectionEntriesCollection?: Maybe<(
    { __typename?: 'BlockLinkSectionLinkSectionEntriesCollection' }
    & { items: Array<Maybe<(
      { __typename?: 'LinkSectionEntry' }
      & Pick<LinkSectionEntry, 'title' | 'subTitle' | 'href'>
    )>> }
  )> }
);

export type BlockSubNavigationFragment = (
  { __typename?: 'BlockSubNavigation' }
  & { navBarEntriesCollection?: Maybe<(
    { __typename?: 'BlockSubNavigationNavBarEntriesCollection' }
    & { items: Array<Maybe<(
      { __typename?: 'NavBarEntry' }
      & FullNavBarEntryFragment
    )>> }
  )> }
);

export type BlockTextCloudFragment = (
  { __typename?: 'BlockTextCloud' }
  & Pick<BlockTextCloud, 'fieldName1' | 'fieldName2' | 'fieldName3' | 'fieldName4' | 'fieldName5'>
);

export type BlockSpeechBubbleFragment = (
  { __typename?: 'BlockSpeechBubble' }
  & Pick<BlockSpeechBubble, 'text' | 'variant'>
);

export type BlockHiddenWithConsentFragment = (
  { __typename?: 'BlockHiddenWithConsent' }
  & Pick<BlockHiddenWithConsent, 'consentType'>
  & { childBlocksCollection?: Maybe<(
    { __typename?: 'BlockHiddenWithConsentChildBlocksCollection' }
    & { items: Array<Maybe<(
      { __typename?: 'BlockAccordion' }
      & EntryId_BlockAccordion_Fragment
    ) | (
      { __typename?: 'BlockBigTitleNavigation' }
      & EntryId_BlockBigTitleNavigation_Fragment
    ) | (
      { __typename?: 'BlockCallToActionButton' }
      & EntryId_BlockCallToActionButton_Fragment
    ) | (
      { __typename?: 'BlockCustom' }
      & EntryId_BlockCustom_Fragment
    ) | (
      { __typename?: 'BlockFullsizeImage' }
      & EntryId_BlockFullsizeImage_Fragment
    ) | (
      { __typename?: 'BlockHighlightRealEstate' }
      & EntryId_BlockHighlightRealEstate_Fragment
    ) | (
      { __typename?: 'BlockImageGallery' }
      & EntryId_BlockImageGallery_Fragment
    ) | (
      { __typename?: 'BlockLinkSection' }
      & EntryId_BlockLinkSection_Fragment
    ) | (
      { __typename?: 'BlockOneColumn' }
      & EntryId_BlockOneColumn_Fragment
    ) | (
      { __typename?: 'BlockPersonAccordion' }
      & EntryId_BlockPersonAccordion_Fragment
    ) | (
      { __typename?: 'BlockRibbon' }
      & EntryId_BlockRibbon_Fragment
    ) | (
      { __typename?: 'BlockRichText' }
      & EntryId_BlockRichText_Fragment
    ) | (
      { __typename?: 'BlockSlider' }
      & EntryId_BlockSlider_Fragment
    ) | (
      { __typename?: 'BlockSpeechBubble' }
      & EntryId_BlockSpeechBubble_Fragment
    ) | (
      { __typename?: 'BlockTable' }
      & EntryId_BlockTable_Fragment
    ) | (
      { __typename?: 'BlockTextCloud' }
      & EntryId_BlockTextCloud_Fragment
    ) | (
      { __typename?: 'BlockThreeColumn' }
      & EntryId_BlockThreeColumn_Fragment
    ) | (
      { __typename?: 'BlockTwoColumn' }
      & EntryId_BlockTwoColumn_Fragment
    ) | (
      { __typename?: 'BlockVideo' }
      & EntryId_BlockVideo_Fragment
    ) | (
      { __typename?: 'HighlightedRealEstate' }
      & EntryId_HighlightedRealEstate_Fragment
    ) | (
      { __typename?: 'PersonAccordionEntry' }
      & EntryId_PersonAccordionEntry_Fragment
    )>> }
  )> }
);

export type BlockHiddenWithConsentWithoutChildrenFragment = (
  { __typename?: 'BlockHiddenWithConsent' }
  & Pick<BlockHiddenWithConsent, 'consentType'>
);

export type GetAccordionByIdQueryVariables = Exact<{
  locale?: Maybe<Scalars['String']>;
  preview?: Maybe<Scalars['Boolean']>;
  id: Scalars['String'];
}>;


export type GetAccordionByIdQuery = (
  { __typename?: 'Query' }
  & { entryCollection?: Maybe<(
    { __typename?: 'EntryCollection' }
    & { items: Array<Maybe<(
      { __typename?: 'HeroImage' }
      & AccordionEntryPoint_HeroImage_Fragment
    ) | (
      { __typename?: 'StaticPage' }
      & AccordionEntryPoint_StaticPage_Fragment
    ) | (
      { __typename?: 'NavBarEntry' }
      & AccordionEntryPoint_NavBarEntry_Fragment
    ) | (
      { __typename?: 'BlockSubNavigation' }
      & AccordionEntryPoint_BlockSubNavigation_Fragment
    ) | (
      { __typename?: 'BlockBigTitleNavigation' }
      & AccordionEntryPoint_BlockBigTitleNavigation_Fragment
    ) | (
      { __typename?: 'BlockHiddenWithConsent' }
      & AccordionEntryPoint_BlockHiddenWithConsent_Fragment
    ) | (
      { __typename?: 'BlockAccordion' }
      & AccordionEntryPoint_BlockAccordion_Fragment
    ) | (
      { __typename?: 'BlockOneColumn' }
      & AccordionEntryPoint_BlockOneColumn_Fragment
    ) | (
      { __typename?: 'BlockAnalystRating' }
      & AccordionEntryPoint_BlockAnalystRating_Fragment
    ) | (
      { __typename?: 'BlockCallToActionButton' }
      & AccordionEntryPoint_BlockCallToActionButton_Fragment
    ) | (
      { __typename?: 'BlockTwoColumn' }
      & AccordionEntryPoint_BlockTwoColumn_Fragment
    ) | (
      { __typename?: 'BlockAccordionEntry' }
      & AccordionEntryPoint_BlockAccordionEntry_Fragment
    ) | (
      { __typename?: 'NewsArticle' }
      & AccordionEntryPoint_NewsArticle_Fragment
    ) | (
      { __typename?: 'BlockRichText' }
      & AccordionEntryPoint_BlockRichText_Fragment
    ) | (
      { __typename?: 'LexiconArticle' }
      & AccordionEntryPoint_LexiconArticle_Fragment
    ) | (
      { __typename?: 'ProjectPage' }
      & AccordionEntryPoint_ProjectPage_Fragment
    ) | (
      { __typename?: 'BarChartWithBackground' }
      & AccordionEntryPoint_BarChartWithBackground_Fragment
    ) | (
      { __typename?: 'BlockCustom' }
      & AccordionEntryPoint_BlockCustom_Fragment
    ) | (
      { __typename?: 'BlockFullsizeImage' }
      & AccordionEntryPoint_BlockFullsizeImage_Fragment
    ) | (
      { __typename?: 'BlockHighlightRealEstate' }
      & AccordionEntryPoint_BlockHighlightRealEstate_Fragment
    ) | (
      { __typename?: 'HighlightedRealEstate' }
      & AccordionEntryPoint_HighlightedRealEstate_Fragment
    ) | (
      { __typename?: 'BlockPartnerGrid' }
      & AccordionEntryPoint_BlockPartnerGrid_Fragment
    ) | (
      { __typename?: 'Partner' }
      & AccordionEntryPoint_Partner_Fragment
    ) | (
      { __typename?: 'BlockPersonAccordion' }
      & AccordionEntryPoint_BlockPersonAccordion_Fragment
    ) | (
      { __typename?: 'PersonAccordionEntry' }
      & AccordionEntryPoint_PersonAccordionEntry_Fragment
    ) | (
      { __typename?: 'BlockRibbon' }
      & AccordionEntryPoint_BlockRibbon_Fragment
    ) | (
      { __typename?: 'BlockTable' }
      & AccordionEntryPoint_BlockTable_Fragment
    ) | (
      { __typename?: 'BlockThreeColumn' }
      & AccordionEntryPoint_BlockThreeColumn_Fragment
    ) | (
      { __typename?: 'BlockVideo' }
      & AccordionEntryPoint_BlockVideo_Fragment
    ) | (
      { __typename?: 'NewsArticleContact' }
      & AccordionEntryPoint_NewsArticleContact_Fragment
    ) | (
      { __typename?: 'BlockSpeechBubble' }
      & AccordionEntryPoint_BlockSpeechBubble_Fragment
    ) | (
      { __typename?: 'LatestDownload' }
      & AccordionEntryPoint_LatestDownload_Fragment
    ) | (
      { __typename?: 'NavigationEntry' }
      & AccordionEntryPoint_NavigationEntry_Fragment
    ) | (
      { __typename?: 'BlockLinkSection' }
      & AccordionEntryPoint_BlockLinkSection_Fragment
    ) | (
      { __typename?: 'LinkSectionEntry' }
      & AccordionEntryPoint_LinkSectionEntry_Fragment
    ) | (
      { __typename?: 'BlockStockPrice' }
      & AccordionEntryPoint_BlockStockPrice_Fragment
    ) | (
      { __typename?: 'BlockImageGallery' }
      & AccordionEntryPoint_BlockImageGallery_Fragment
    ) | (
      { __typename?: 'BlockSlider' }
      & AccordionEntryPoint_BlockSlider_Fragment
    ) | (
      { __typename?: 'BlockSliderEntry' }
      & AccordionEntryPoint_BlockSliderEntry_Fragment
    ) | (
      { __typename?: 'BlockTextCloud' }
      & AccordionEntryPoint_BlockTextCloud_Fragment
    ) | (
      { __typename?: 'Seo' }
      & AccordionEntryPoint_Seo_Fragment
    ) | (
      { __typename?: 'RegionDescriptionText' }
      & AccordionEntryPoint_RegionDescriptionText_Fragment
    ) | (
      { __typename?: 'ProjectLink' }
      & AccordionEntryPoint_ProjectLink_Fragment
    ) | (
      { __typename?: 'BlockProjectLinkSection' }
      & AccordionEntryPoint_BlockProjectLinkSection_Fragment
    ) | (
      { __typename?: 'ProjectImageMap' }
      & AccordionEntryPoint_ProjectImageMap_Fragment
    ) | (
      { __typename?: 'DownloadableFile' }
      & AccordionEntryPoint_DownloadableFile_Fragment
    ) | (
      { __typename?: 'Footer' }
      & AccordionEntryPoint_Footer_Fragment
    )>> }
  )> }
);

type AccordionEntryPoint_HeroImage_Fragment = (
  { __typename?: 'HeroImage' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type AccordionEntryPoint_StaticPage_Fragment = (
  { __typename?: 'StaticPage' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type AccordionEntryPoint_NavBarEntry_Fragment = (
  { __typename?: 'NavBarEntry' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type AccordionEntryPoint_BlockSubNavigation_Fragment = (
  { __typename?: 'BlockSubNavigation' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type AccordionEntryPoint_BlockBigTitleNavigation_Fragment = (
  { __typename?: 'BlockBigTitleNavigation' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type AccordionEntryPoint_BlockHiddenWithConsent_Fragment = (
  { __typename?: 'BlockHiddenWithConsent' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type AccordionEntryPoint_BlockAccordion_Fragment = (
  { __typename?: 'BlockAccordion' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
  & AccordionFragment
);

type AccordionEntryPoint_BlockOneColumn_Fragment = (
  { __typename?: 'BlockOneColumn' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type AccordionEntryPoint_BlockAnalystRating_Fragment = (
  { __typename?: 'BlockAnalystRating' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type AccordionEntryPoint_BlockCallToActionButton_Fragment = (
  { __typename?: 'BlockCallToActionButton' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type AccordionEntryPoint_BlockTwoColumn_Fragment = (
  { __typename?: 'BlockTwoColumn' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type AccordionEntryPoint_BlockAccordionEntry_Fragment = (
  { __typename?: 'BlockAccordionEntry' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type AccordionEntryPoint_NewsArticle_Fragment = (
  { __typename?: 'NewsArticle' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type AccordionEntryPoint_BlockRichText_Fragment = (
  { __typename?: 'BlockRichText' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type AccordionEntryPoint_LexiconArticle_Fragment = (
  { __typename?: 'LexiconArticle' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type AccordionEntryPoint_ProjectPage_Fragment = (
  { __typename?: 'ProjectPage' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type AccordionEntryPoint_BarChartWithBackground_Fragment = (
  { __typename?: 'BarChartWithBackground' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type AccordionEntryPoint_BlockCustom_Fragment = (
  { __typename?: 'BlockCustom' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type AccordionEntryPoint_BlockFullsizeImage_Fragment = (
  { __typename?: 'BlockFullsizeImage' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type AccordionEntryPoint_BlockHighlightRealEstate_Fragment = (
  { __typename?: 'BlockHighlightRealEstate' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type AccordionEntryPoint_HighlightedRealEstate_Fragment = (
  { __typename?: 'HighlightedRealEstate' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type AccordionEntryPoint_BlockPartnerGrid_Fragment = (
  { __typename?: 'BlockPartnerGrid' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type AccordionEntryPoint_Partner_Fragment = (
  { __typename?: 'Partner' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type AccordionEntryPoint_BlockPersonAccordion_Fragment = (
  { __typename?: 'BlockPersonAccordion' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type AccordionEntryPoint_PersonAccordionEntry_Fragment = (
  { __typename?: 'PersonAccordionEntry' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type AccordionEntryPoint_BlockRibbon_Fragment = (
  { __typename?: 'BlockRibbon' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type AccordionEntryPoint_BlockTable_Fragment = (
  { __typename?: 'BlockTable' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type AccordionEntryPoint_BlockThreeColumn_Fragment = (
  { __typename?: 'BlockThreeColumn' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type AccordionEntryPoint_BlockVideo_Fragment = (
  { __typename?: 'BlockVideo' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type AccordionEntryPoint_NewsArticleContact_Fragment = (
  { __typename?: 'NewsArticleContact' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type AccordionEntryPoint_BlockSpeechBubble_Fragment = (
  { __typename?: 'BlockSpeechBubble' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type AccordionEntryPoint_LatestDownload_Fragment = (
  { __typename?: 'LatestDownload' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type AccordionEntryPoint_NavigationEntry_Fragment = (
  { __typename?: 'NavigationEntry' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type AccordionEntryPoint_BlockLinkSection_Fragment = (
  { __typename?: 'BlockLinkSection' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type AccordionEntryPoint_LinkSectionEntry_Fragment = (
  { __typename?: 'LinkSectionEntry' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type AccordionEntryPoint_BlockStockPrice_Fragment = (
  { __typename?: 'BlockStockPrice' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type AccordionEntryPoint_BlockImageGallery_Fragment = (
  { __typename?: 'BlockImageGallery' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type AccordionEntryPoint_BlockSlider_Fragment = (
  { __typename?: 'BlockSlider' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type AccordionEntryPoint_BlockSliderEntry_Fragment = (
  { __typename?: 'BlockSliderEntry' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type AccordionEntryPoint_BlockTextCloud_Fragment = (
  { __typename?: 'BlockTextCloud' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type AccordionEntryPoint_Seo_Fragment = (
  { __typename?: 'Seo' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type AccordionEntryPoint_RegionDescriptionText_Fragment = (
  { __typename?: 'RegionDescriptionText' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type AccordionEntryPoint_ProjectLink_Fragment = (
  { __typename?: 'ProjectLink' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type AccordionEntryPoint_BlockProjectLinkSection_Fragment = (
  { __typename?: 'BlockProjectLinkSection' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type AccordionEntryPoint_ProjectImageMap_Fragment = (
  { __typename?: 'ProjectImageMap' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type AccordionEntryPoint_DownloadableFile_Fragment = (
  { __typename?: 'DownloadableFile' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type AccordionEntryPoint_Footer_Fragment = (
  { __typename?: 'Footer' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

export type AccordionEntryPointFragment = AccordionEntryPoint_HeroImage_Fragment | AccordionEntryPoint_StaticPage_Fragment | AccordionEntryPoint_NavBarEntry_Fragment | AccordionEntryPoint_BlockSubNavigation_Fragment | AccordionEntryPoint_BlockBigTitleNavigation_Fragment | AccordionEntryPoint_BlockHiddenWithConsent_Fragment | AccordionEntryPoint_BlockAccordion_Fragment | AccordionEntryPoint_BlockOneColumn_Fragment | AccordionEntryPoint_BlockAnalystRating_Fragment | AccordionEntryPoint_BlockCallToActionButton_Fragment | AccordionEntryPoint_BlockTwoColumn_Fragment | AccordionEntryPoint_BlockAccordionEntry_Fragment | AccordionEntryPoint_NewsArticle_Fragment | AccordionEntryPoint_BlockRichText_Fragment | AccordionEntryPoint_LexiconArticle_Fragment | AccordionEntryPoint_ProjectPage_Fragment | AccordionEntryPoint_BarChartWithBackground_Fragment | AccordionEntryPoint_BlockCustom_Fragment | AccordionEntryPoint_BlockFullsizeImage_Fragment | AccordionEntryPoint_BlockHighlightRealEstate_Fragment | AccordionEntryPoint_HighlightedRealEstate_Fragment | AccordionEntryPoint_BlockPartnerGrid_Fragment | AccordionEntryPoint_Partner_Fragment | AccordionEntryPoint_BlockPersonAccordion_Fragment | AccordionEntryPoint_PersonAccordionEntry_Fragment | AccordionEntryPoint_BlockRibbon_Fragment | AccordionEntryPoint_BlockTable_Fragment | AccordionEntryPoint_BlockThreeColumn_Fragment | AccordionEntryPoint_BlockVideo_Fragment | AccordionEntryPoint_NewsArticleContact_Fragment | AccordionEntryPoint_BlockSpeechBubble_Fragment | AccordionEntryPoint_LatestDownload_Fragment | AccordionEntryPoint_NavigationEntry_Fragment | AccordionEntryPoint_BlockLinkSection_Fragment | AccordionEntryPoint_LinkSectionEntry_Fragment | AccordionEntryPoint_BlockStockPrice_Fragment | AccordionEntryPoint_BlockImageGallery_Fragment | AccordionEntryPoint_BlockSlider_Fragment | AccordionEntryPoint_BlockSliderEntry_Fragment | AccordionEntryPoint_BlockTextCloud_Fragment | AccordionEntryPoint_Seo_Fragment | AccordionEntryPoint_RegionDescriptionText_Fragment | AccordionEntryPoint_ProjectLink_Fragment | AccordionEntryPoint_BlockProjectLinkSection_Fragment | AccordionEntryPoint_ProjectImageMap_Fragment | AccordionEntryPoint_DownloadableFile_Fragment | AccordionEntryPoint_Footer_Fragment;

export type GetAccordionEntryByIdQueryVariables = Exact<{
  locale?: Maybe<Scalars['String']>;
  preview?: Maybe<Scalars['Boolean']>;
  id: Scalars['String'];
}>;


export type GetAccordionEntryByIdQuery = (
  { __typename?: 'Query' }
  & { entryCollection?: Maybe<(
    { __typename?: 'EntryCollection' }
    & { items: Array<Maybe<(
      { __typename?: 'HeroImage' }
      & AccordionEntryEntryPoint_HeroImage_Fragment
    ) | (
      { __typename?: 'StaticPage' }
      & AccordionEntryEntryPoint_StaticPage_Fragment
    ) | (
      { __typename?: 'NavBarEntry' }
      & AccordionEntryEntryPoint_NavBarEntry_Fragment
    ) | (
      { __typename?: 'BlockSubNavigation' }
      & AccordionEntryEntryPoint_BlockSubNavigation_Fragment
    ) | (
      { __typename?: 'BlockBigTitleNavigation' }
      & AccordionEntryEntryPoint_BlockBigTitleNavigation_Fragment
    ) | (
      { __typename?: 'BlockHiddenWithConsent' }
      & AccordionEntryEntryPoint_BlockHiddenWithConsent_Fragment
    ) | (
      { __typename?: 'BlockAccordion' }
      & AccordionEntryEntryPoint_BlockAccordion_Fragment
    ) | (
      { __typename?: 'BlockOneColumn' }
      & AccordionEntryEntryPoint_BlockOneColumn_Fragment
    ) | (
      { __typename?: 'BlockAnalystRating' }
      & AccordionEntryEntryPoint_BlockAnalystRating_Fragment
    ) | (
      { __typename?: 'BlockCallToActionButton' }
      & AccordionEntryEntryPoint_BlockCallToActionButton_Fragment
    ) | (
      { __typename?: 'BlockTwoColumn' }
      & AccordionEntryEntryPoint_BlockTwoColumn_Fragment
    ) | (
      { __typename?: 'BlockAccordionEntry' }
      & AccordionEntryEntryPoint_BlockAccordionEntry_Fragment
    ) | (
      { __typename?: 'NewsArticle' }
      & AccordionEntryEntryPoint_NewsArticle_Fragment
    ) | (
      { __typename?: 'BlockRichText' }
      & AccordionEntryEntryPoint_BlockRichText_Fragment
    ) | (
      { __typename?: 'LexiconArticle' }
      & AccordionEntryEntryPoint_LexiconArticle_Fragment
    ) | (
      { __typename?: 'ProjectPage' }
      & AccordionEntryEntryPoint_ProjectPage_Fragment
    ) | (
      { __typename?: 'BarChartWithBackground' }
      & AccordionEntryEntryPoint_BarChartWithBackground_Fragment
    ) | (
      { __typename?: 'BlockCustom' }
      & AccordionEntryEntryPoint_BlockCustom_Fragment
    ) | (
      { __typename?: 'BlockFullsizeImage' }
      & AccordionEntryEntryPoint_BlockFullsizeImage_Fragment
    ) | (
      { __typename?: 'BlockHighlightRealEstate' }
      & AccordionEntryEntryPoint_BlockHighlightRealEstate_Fragment
    ) | (
      { __typename?: 'HighlightedRealEstate' }
      & AccordionEntryEntryPoint_HighlightedRealEstate_Fragment
    ) | (
      { __typename?: 'BlockPartnerGrid' }
      & AccordionEntryEntryPoint_BlockPartnerGrid_Fragment
    ) | (
      { __typename?: 'Partner' }
      & AccordionEntryEntryPoint_Partner_Fragment
    ) | (
      { __typename?: 'BlockPersonAccordion' }
      & AccordionEntryEntryPoint_BlockPersonAccordion_Fragment
    ) | (
      { __typename?: 'PersonAccordionEntry' }
      & AccordionEntryEntryPoint_PersonAccordionEntry_Fragment
    ) | (
      { __typename?: 'BlockRibbon' }
      & AccordionEntryEntryPoint_BlockRibbon_Fragment
    ) | (
      { __typename?: 'BlockTable' }
      & AccordionEntryEntryPoint_BlockTable_Fragment
    ) | (
      { __typename?: 'BlockThreeColumn' }
      & AccordionEntryEntryPoint_BlockThreeColumn_Fragment
    ) | (
      { __typename?: 'BlockVideo' }
      & AccordionEntryEntryPoint_BlockVideo_Fragment
    ) | (
      { __typename?: 'NewsArticleContact' }
      & AccordionEntryEntryPoint_NewsArticleContact_Fragment
    ) | (
      { __typename?: 'BlockSpeechBubble' }
      & AccordionEntryEntryPoint_BlockSpeechBubble_Fragment
    ) | (
      { __typename?: 'LatestDownload' }
      & AccordionEntryEntryPoint_LatestDownload_Fragment
    ) | (
      { __typename?: 'NavigationEntry' }
      & AccordionEntryEntryPoint_NavigationEntry_Fragment
    ) | (
      { __typename?: 'BlockLinkSection' }
      & AccordionEntryEntryPoint_BlockLinkSection_Fragment
    ) | (
      { __typename?: 'LinkSectionEntry' }
      & AccordionEntryEntryPoint_LinkSectionEntry_Fragment
    ) | (
      { __typename?: 'BlockStockPrice' }
      & AccordionEntryEntryPoint_BlockStockPrice_Fragment
    ) | (
      { __typename?: 'BlockImageGallery' }
      & AccordionEntryEntryPoint_BlockImageGallery_Fragment
    ) | (
      { __typename?: 'BlockSlider' }
      & AccordionEntryEntryPoint_BlockSlider_Fragment
    ) | (
      { __typename?: 'BlockSliderEntry' }
      & AccordionEntryEntryPoint_BlockSliderEntry_Fragment
    ) | (
      { __typename?: 'BlockTextCloud' }
      & AccordionEntryEntryPoint_BlockTextCloud_Fragment
    ) | (
      { __typename?: 'Seo' }
      & AccordionEntryEntryPoint_Seo_Fragment
    ) | (
      { __typename?: 'RegionDescriptionText' }
      & AccordionEntryEntryPoint_RegionDescriptionText_Fragment
    ) | (
      { __typename?: 'ProjectLink' }
      & AccordionEntryEntryPoint_ProjectLink_Fragment
    ) | (
      { __typename?: 'BlockProjectLinkSection' }
      & AccordionEntryEntryPoint_BlockProjectLinkSection_Fragment
    ) | (
      { __typename?: 'ProjectImageMap' }
      & AccordionEntryEntryPoint_ProjectImageMap_Fragment
    ) | (
      { __typename?: 'DownloadableFile' }
      & AccordionEntryEntryPoint_DownloadableFile_Fragment
    ) | (
      { __typename?: 'Footer' }
      & AccordionEntryEntryPoint_Footer_Fragment
    )>> }
  )> }
);

type AccordionEntryEntryPoint_HeroImage_Fragment = (
  { __typename?: 'HeroImage' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type AccordionEntryEntryPoint_StaticPage_Fragment = (
  { __typename?: 'StaticPage' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type AccordionEntryEntryPoint_NavBarEntry_Fragment = (
  { __typename?: 'NavBarEntry' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type AccordionEntryEntryPoint_BlockSubNavigation_Fragment = (
  { __typename?: 'BlockSubNavigation' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type AccordionEntryEntryPoint_BlockBigTitleNavigation_Fragment = (
  { __typename?: 'BlockBigTitleNavigation' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type AccordionEntryEntryPoint_BlockHiddenWithConsent_Fragment = (
  { __typename?: 'BlockHiddenWithConsent' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type AccordionEntryEntryPoint_BlockAccordion_Fragment = (
  { __typename?: 'BlockAccordion' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type AccordionEntryEntryPoint_BlockOneColumn_Fragment = (
  { __typename?: 'BlockOneColumn' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type AccordionEntryEntryPoint_BlockAnalystRating_Fragment = (
  { __typename?: 'BlockAnalystRating' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type AccordionEntryEntryPoint_BlockCallToActionButton_Fragment = (
  { __typename?: 'BlockCallToActionButton' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type AccordionEntryEntryPoint_BlockTwoColumn_Fragment = (
  { __typename?: 'BlockTwoColumn' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type AccordionEntryEntryPoint_BlockAccordionEntry_Fragment = (
  { __typename?: 'BlockAccordionEntry' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
  & AccordionEntryFragment
);

type AccordionEntryEntryPoint_NewsArticle_Fragment = (
  { __typename?: 'NewsArticle' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type AccordionEntryEntryPoint_BlockRichText_Fragment = (
  { __typename?: 'BlockRichText' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type AccordionEntryEntryPoint_LexiconArticle_Fragment = (
  { __typename?: 'LexiconArticle' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type AccordionEntryEntryPoint_ProjectPage_Fragment = (
  { __typename?: 'ProjectPage' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type AccordionEntryEntryPoint_BarChartWithBackground_Fragment = (
  { __typename?: 'BarChartWithBackground' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type AccordionEntryEntryPoint_BlockCustom_Fragment = (
  { __typename?: 'BlockCustom' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type AccordionEntryEntryPoint_BlockFullsizeImage_Fragment = (
  { __typename?: 'BlockFullsizeImage' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type AccordionEntryEntryPoint_BlockHighlightRealEstate_Fragment = (
  { __typename?: 'BlockHighlightRealEstate' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type AccordionEntryEntryPoint_HighlightedRealEstate_Fragment = (
  { __typename?: 'HighlightedRealEstate' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type AccordionEntryEntryPoint_BlockPartnerGrid_Fragment = (
  { __typename?: 'BlockPartnerGrid' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type AccordionEntryEntryPoint_Partner_Fragment = (
  { __typename?: 'Partner' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type AccordionEntryEntryPoint_BlockPersonAccordion_Fragment = (
  { __typename?: 'BlockPersonAccordion' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type AccordionEntryEntryPoint_PersonAccordionEntry_Fragment = (
  { __typename?: 'PersonAccordionEntry' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type AccordionEntryEntryPoint_BlockRibbon_Fragment = (
  { __typename?: 'BlockRibbon' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type AccordionEntryEntryPoint_BlockTable_Fragment = (
  { __typename?: 'BlockTable' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type AccordionEntryEntryPoint_BlockThreeColumn_Fragment = (
  { __typename?: 'BlockThreeColumn' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type AccordionEntryEntryPoint_BlockVideo_Fragment = (
  { __typename?: 'BlockVideo' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type AccordionEntryEntryPoint_NewsArticleContact_Fragment = (
  { __typename?: 'NewsArticleContact' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type AccordionEntryEntryPoint_BlockSpeechBubble_Fragment = (
  { __typename?: 'BlockSpeechBubble' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type AccordionEntryEntryPoint_LatestDownload_Fragment = (
  { __typename?: 'LatestDownload' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type AccordionEntryEntryPoint_NavigationEntry_Fragment = (
  { __typename?: 'NavigationEntry' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type AccordionEntryEntryPoint_BlockLinkSection_Fragment = (
  { __typename?: 'BlockLinkSection' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type AccordionEntryEntryPoint_LinkSectionEntry_Fragment = (
  { __typename?: 'LinkSectionEntry' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type AccordionEntryEntryPoint_BlockStockPrice_Fragment = (
  { __typename?: 'BlockStockPrice' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type AccordionEntryEntryPoint_BlockImageGallery_Fragment = (
  { __typename?: 'BlockImageGallery' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type AccordionEntryEntryPoint_BlockSlider_Fragment = (
  { __typename?: 'BlockSlider' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type AccordionEntryEntryPoint_BlockSliderEntry_Fragment = (
  { __typename?: 'BlockSliderEntry' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type AccordionEntryEntryPoint_BlockTextCloud_Fragment = (
  { __typename?: 'BlockTextCloud' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type AccordionEntryEntryPoint_Seo_Fragment = (
  { __typename?: 'Seo' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type AccordionEntryEntryPoint_RegionDescriptionText_Fragment = (
  { __typename?: 'RegionDescriptionText' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type AccordionEntryEntryPoint_ProjectLink_Fragment = (
  { __typename?: 'ProjectLink' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type AccordionEntryEntryPoint_BlockProjectLinkSection_Fragment = (
  { __typename?: 'BlockProjectLinkSection' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type AccordionEntryEntryPoint_ProjectImageMap_Fragment = (
  { __typename?: 'ProjectImageMap' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type AccordionEntryEntryPoint_DownloadableFile_Fragment = (
  { __typename?: 'DownloadableFile' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type AccordionEntryEntryPoint_Footer_Fragment = (
  { __typename?: 'Footer' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

export type AccordionEntryEntryPointFragment = AccordionEntryEntryPoint_HeroImage_Fragment | AccordionEntryEntryPoint_StaticPage_Fragment | AccordionEntryEntryPoint_NavBarEntry_Fragment | AccordionEntryEntryPoint_BlockSubNavigation_Fragment | AccordionEntryEntryPoint_BlockBigTitleNavigation_Fragment | AccordionEntryEntryPoint_BlockHiddenWithConsent_Fragment | AccordionEntryEntryPoint_BlockAccordion_Fragment | AccordionEntryEntryPoint_BlockOneColumn_Fragment | AccordionEntryEntryPoint_BlockAnalystRating_Fragment | AccordionEntryEntryPoint_BlockCallToActionButton_Fragment | AccordionEntryEntryPoint_BlockTwoColumn_Fragment | AccordionEntryEntryPoint_BlockAccordionEntry_Fragment | AccordionEntryEntryPoint_NewsArticle_Fragment | AccordionEntryEntryPoint_BlockRichText_Fragment | AccordionEntryEntryPoint_LexiconArticle_Fragment | AccordionEntryEntryPoint_ProjectPage_Fragment | AccordionEntryEntryPoint_BarChartWithBackground_Fragment | AccordionEntryEntryPoint_BlockCustom_Fragment | AccordionEntryEntryPoint_BlockFullsizeImage_Fragment | AccordionEntryEntryPoint_BlockHighlightRealEstate_Fragment | AccordionEntryEntryPoint_HighlightedRealEstate_Fragment | AccordionEntryEntryPoint_BlockPartnerGrid_Fragment | AccordionEntryEntryPoint_Partner_Fragment | AccordionEntryEntryPoint_BlockPersonAccordion_Fragment | AccordionEntryEntryPoint_PersonAccordionEntry_Fragment | AccordionEntryEntryPoint_BlockRibbon_Fragment | AccordionEntryEntryPoint_BlockTable_Fragment | AccordionEntryEntryPoint_BlockThreeColumn_Fragment | AccordionEntryEntryPoint_BlockVideo_Fragment | AccordionEntryEntryPoint_NewsArticleContact_Fragment | AccordionEntryEntryPoint_BlockSpeechBubble_Fragment | AccordionEntryEntryPoint_LatestDownload_Fragment | AccordionEntryEntryPoint_NavigationEntry_Fragment | AccordionEntryEntryPoint_BlockLinkSection_Fragment | AccordionEntryEntryPoint_LinkSectionEntry_Fragment | AccordionEntryEntryPoint_BlockStockPrice_Fragment | AccordionEntryEntryPoint_BlockImageGallery_Fragment | AccordionEntryEntryPoint_BlockSlider_Fragment | AccordionEntryEntryPoint_BlockSliderEntry_Fragment | AccordionEntryEntryPoint_BlockTextCloud_Fragment | AccordionEntryEntryPoint_Seo_Fragment | AccordionEntryEntryPoint_RegionDescriptionText_Fragment | AccordionEntryEntryPoint_ProjectLink_Fragment | AccordionEntryEntryPoint_BlockProjectLinkSection_Fragment | AccordionEntryEntryPoint_ProjectImageMap_Fragment | AccordionEntryEntryPoint_DownloadableFile_Fragment | AccordionEntryEntryPoint_Footer_Fragment;

export type GetBarChartWithBackgroundByIdQueryVariables = Exact<{
  locale?: Maybe<Scalars['String']>;
  preview?: Maybe<Scalars['Boolean']>;
  id: Scalars['String'];
}>;


export type GetBarChartWithBackgroundByIdQuery = (
  { __typename?: 'Query' }
  & { entryCollection?: Maybe<(
    { __typename?: 'EntryCollection' }
    & { items: Array<Maybe<(
      { __typename?: 'HeroImage' }
      & BarChartWithBackgroundEntryPoint_HeroImage_Fragment
    ) | (
      { __typename?: 'StaticPage' }
      & BarChartWithBackgroundEntryPoint_StaticPage_Fragment
    ) | (
      { __typename?: 'NavBarEntry' }
      & BarChartWithBackgroundEntryPoint_NavBarEntry_Fragment
    ) | (
      { __typename?: 'BlockSubNavigation' }
      & BarChartWithBackgroundEntryPoint_BlockSubNavigation_Fragment
    ) | (
      { __typename?: 'BlockBigTitleNavigation' }
      & BarChartWithBackgroundEntryPoint_BlockBigTitleNavigation_Fragment
    ) | (
      { __typename?: 'BlockHiddenWithConsent' }
      & BarChartWithBackgroundEntryPoint_BlockHiddenWithConsent_Fragment
    ) | (
      { __typename?: 'BlockAccordion' }
      & BarChartWithBackgroundEntryPoint_BlockAccordion_Fragment
    ) | (
      { __typename?: 'BlockOneColumn' }
      & BarChartWithBackgroundEntryPoint_BlockOneColumn_Fragment
    ) | (
      { __typename?: 'BlockAnalystRating' }
      & BarChartWithBackgroundEntryPoint_BlockAnalystRating_Fragment
    ) | (
      { __typename?: 'BlockCallToActionButton' }
      & BarChartWithBackgroundEntryPoint_BlockCallToActionButton_Fragment
    ) | (
      { __typename?: 'BlockTwoColumn' }
      & BarChartWithBackgroundEntryPoint_BlockTwoColumn_Fragment
    ) | (
      { __typename?: 'BlockAccordionEntry' }
      & BarChartWithBackgroundEntryPoint_BlockAccordionEntry_Fragment
    ) | (
      { __typename?: 'NewsArticle' }
      & BarChartWithBackgroundEntryPoint_NewsArticle_Fragment
    ) | (
      { __typename?: 'BlockRichText' }
      & BarChartWithBackgroundEntryPoint_BlockRichText_Fragment
    ) | (
      { __typename?: 'LexiconArticle' }
      & BarChartWithBackgroundEntryPoint_LexiconArticle_Fragment
    ) | (
      { __typename?: 'ProjectPage' }
      & BarChartWithBackgroundEntryPoint_ProjectPage_Fragment
    ) | (
      { __typename?: 'BarChartWithBackground' }
      & BarChartWithBackgroundEntryPoint_BarChartWithBackground_Fragment
    ) | (
      { __typename?: 'BlockCustom' }
      & BarChartWithBackgroundEntryPoint_BlockCustom_Fragment
    ) | (
      { __typename?: 'BlockFullsizeImage' }
      & BarChartWithBackgroundEntryPoint_BlockFullsizeImage_Fragment
    ) | (
      { __typename?: 'BlockHighlightRealEstate' }
      & BarChartWithBackgroundEntryPoint_BlockHighlightRealEstate_Fragment
    ) | (
      { __typename?: 'HighlightedRealEstate' }
      & BarChartWithBackgroundEntryPoint_HighlightedRealEstate_Fragment
    ) | (
      { __typename?: 'BlockPartnerGrid' }
      & BarChartWithBackgroundEntryPoint_BlockPartnerGrid_Fragment
    ) | (
      { __typename?: 'Partner' }
      & BarChartWithBackgroundEntryPoint_Partner_Fragment
    ) | (
      { __typename?: 'BlockPersonAccordion' }
      & BarChartWithBackgroundEntryPoint_BlockPersonAccordion_Fragment
    ) | (
      { __typename?: 'PersonAccordionEntry' }
      & BarChartWithBackgroundEntryPoint_PersonAccordionEntry_Fragment
    ) | (
      { __typename?: 'BlockRibbon' }
      & BarChartWithBackgroundEntryPoint_BlockRibbon_Fragment
    ) | (
      { __typename?: 'BlockTable' }
      & BarChartWithBackgroundEntryPoint_BlockTable_Fragment
    ) | (
      { __typename?: 'BlockThreeColumn' }
      & BarChartWithBackgroundEntryPoint_BlockThreeColumn_Fragment
    ) | (
      { __typename?: 'BlockVideo' }
      & BarChartWithBackgroundEntryPoint_BlockVideo_Fragment
    ) | (
      { __typename?: 'NewsArticleContact' }
      & BarChartWithBackgroundEntryPoint_NewsArticleContact_Fragment
    ) | (
      { __typename?: 'BlockSpeechBubble' }
      & BarChartWithBackgroundEntryPoint_BlockSpeechBubble_Fragment
    ) | (
      { __typename?: 'LatestDownload' }
      & BarChartWithBackgroundEntryPoint_LatestDownload_Fragment
    ) | (
      { __typename?: 'NavigationEntry' }
      & BarChartWithBackgroundEntryPoint_NavigationEntry_Fragment
    ) | (
      { __typename?: 'BlockLinkSection' }
      & BarChartWithBackgroundEntryPoint_BlockLinkSection_Fragment
    ) | (
      { __typename?: 'LinkSectionEntry' }
      & BarChartWithBackgroundEntryPoint_LinkSectionEntry_Fragment
    ) | (
      { __typename?: 'BlockStockPrice' }
      & BarChartWithBackgroundEntryPoint_BlockStockPrice_Fragment
    ) | (
      { __typename?: 'BlockImageGallery' }
      & BarChartWithBackgroundEntryPoint_BlockImageGallery_Fragment
    ) | (
      { __typename?: 'BlockSlider' }
      & BarChartWithBackgroundEntryPoint_BlockSlider_Fragment
    ) | (
      { __typename?: 'BlockSliderEntry' }
      & BarChartWithBackgroundEntryPoint_BlockSliderEntry_Fragment
    ) | (
      { __typename?: 'BlockTextCloud' }
      & BarChartWithBackgroundEntryPoint_BlockTextCloud_Fragment
    ) | (
      { __typename?: 'Seo' }
      & BarChartWithBackgroundEntryPoint_Seo_Fragment
    ) | (
      { __typename?: 'RegionDescriptionText' }
      & BarChartWithBackgroundEntryPoint_RegionDescriptionText_Fragment
    ) | (
      { __typename?: 'ProjectLink' }
      & BarChartWithBackgroundEntryPoint_ProjectLink_Fragment
    ) | (
      { __typename?: 'BlockProjectLinkSection' }
      & BarChartWithBackgroundEntryPoint_BlockProjectLinkSection_Fragment
    ) | (
      { __typename?: 'ProjectImageMap' }
      & BarChartWithBackgroundEntryPoint_ProjectImageMap_Fragment
    ) | (
      { __typename?: 'DownloadableFile' }
      & BarChartWithBackgroundEntryPoint_DownloadableFile_Fragment
    ) | (
      { __typename?: 'Footer' }
      & BarChartWithBackgroundEntryPoint_Footer_Fragment
    )>> }
  )> }
);

type BarChartWithBackgroundEntryPoint_HeroImage_Fragment = (
  { __typename?: 'HeroImage' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type BarChartWithBackgroundEntryPoint_StaticPage_Fragment = (
  { __typename?: 'StaticPage' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type BarChartWithBackgroundEntryPoint_NavBarEntry_Fragment = (
  { __typename?: 'NavBarEntry' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type BarChartWithBackgroundEntryPoint_BlockSubNavigation_Fragment = (
  { __typename?: 'BlockSubNavigation' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type BarChartWithBackgroundEntryPoint_BlockBigTitleNavigation_Fragment = (
  { __typename?: 'BlockBigTitleNavigation' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type BarChartWithBackgroundEntryPoint_BlockHiddenWithConsent_Fragment = (
  { __typename?: 'BlockHiddenWithConsent' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type BarChartWithBackgroundEntryPoint_BlockAccordion_Fragment = (
  { __typename?: 'BlockAccordion' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type BarChartWithBackgroundEntryPoint_BlockOneColumn_Fragment = (
  { __typename?: 'BlockOneColumn' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type BarChartWithBackgroundEntryPoint_BlockAnalystRating_Fragment = (
  { __typename?: 'BlockAnalystRating' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type BarChartWithBackgroundEntryPoint_BlockCallToActionButton_Fragment = (
  { __typename?: 'BlockCallToActionButton' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type BarChartWithBackgroundEntryPoint_BlockTwoColumn_Fragment = (
  { __typename?: 'BlockTwoColumn' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type BarChartWithBackgroundEntryPoint_BlockAccordionEntry_Fragment = (
  { __typename?: 'BlockAccordionEntry' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type BarChartWithBackgroundEntryPoint_NewsArticle_Fragment = (
  { __typename?: 'NewsArticle' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type BarChartWithBackgroundEntryPoint_BlockRichText_Fragment = (
  { __typename?: 'BlockRichText' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type BarChartWithBackgroundEntryPoint_LexiconArticle_Fragment = (
  { __typename?: 'LexiconArticle' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type BarChartWithBackgroundEntryPoint_ProjectPage_Fragment = (
  { __typename?: 'ProjectPage' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type BarChartWithBackgroundEntryPoint_BarChartWithBackground_Fragment = (
  { __typename?: 'BarChartWithBackground' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
  & BarChartWithBackgroundFragment
);

type BarChartWithBackgroundEntryPoint_BlockCustom_Fragment = (
  { __typename?: 'BlockCustom' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type BarChartWithBackgroundEntryPoint_BlockFullsizeImage_Fragment = (
  { __typename?: 'BlockFullsizeImage' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type BarChartWithBackgroundEntryPoint_BlockHighlightRealEstate_Fragment = (
  { __typename?: 'BlockHighlightRealEstate' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type BarChartWithBackgroundEntryPoint_HighlightedRealEstate_Fragment = (
  { __typename?: 'HighlightedRealEstate' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type BarChartWithBackgroundEntryPoint_BlockPartnerGrid_Fragment = (
  { __typename?: 'BlockPartnerGrid' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type BarChartWithBackgroundEntryPoint_Partner_Fragment = (
  { __typename?: 'Partner' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type BarChartWithBackgroundEntryPoint_BlockPersonAccordion_Fragment = (
  { __typename?: 'BlockPersonAccordion' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type BarChartWithBackgroundEntryPoint_PersonAccordionEntry_Fragment = (
  { __typename?: 'PersonAccordionEntry' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type BarChartWithBackgroundEntryPoint_BlockRibbon_Fragment = (
  { __typename?: 'BlockRibbon' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type BarChartWithBackgroundEntryPoint_BlockTable_Fragment = (
  { __typename?: 'BlockTable' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type BarChartWithBackgroundEntryPoint_BlockThreeColumn_Fragment = (
  { __typename?: 'BlockThreeColumn' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type BarChartWithBackgroundEntryPoint_BlockVideo_Fragment = (
  { __typename?: 'BlockVideo' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type BarChartWithBackgroundEntryPoint_NewsArticleContact_Fragment = (
  { __typename?: 'NewsArticleContact' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type BarChartWithBackgroundEntryPoint_BlockSpeechBubble_Fragment = (
  { __typename?: 'BlockSpeechBubble' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type BarChartWithBackgroundEntryPoint_LatestDownload_Fragment = (
  { __typename?: 'LatestDownload' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type BarChartWithBackgroundEntryPoint_NavigationEntry_Fragment = (
  { __typename?: 'NavigationEntry' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type BarChartWithBackgroundEntryPoint_BlockLinkSection_Fragment = (
  { __typename?: 'BlockLinkSection' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type BarChartWithBackgroundEntryPoint_LinkSectionEntry_Fragment = (
  { __typename?: 'LinkSectionEntry' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type BarChartWithBackgroundEntryPoint_BlockStockPrice_Fragment = (
  { __typename?: 'BlockStockPrice' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type BarChartWithBackgroundEntryPoint_BlockImageGallery_Fragment = (
  { __typename?: 'BlockImageGallery' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type BarChartWithBackgroundEntryPoint_BlockSlider_Fragment = (
  { __typename?: 'BlockSlider' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type BarChartWithBackgroundEntryPoint_BlockSliderEntry_Fragment = (
  { __typename?: 'BlockSliderEntry' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type BarChartWithBackgroundEntryPoint_BlockTextCloud_Fragment = (
  { __typename?: 'BlockTextCloud' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type BarChartWithBackgroundEntryPoint_Seo_Fragment = (
  { __typename?: 'Seo' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type BarChartWithBackgroundEntryPoint_RegionDescriptionText_Fragment = (
  { __typename?: 'RegionDescriptionText' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type BarChartWithBackgroundEntryPoint_ProjectLink_Fragment = (
  { __typename?: 'ProjectLink' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type BarChartWithBackgroundEntryPoint_BlockProjectLinkSection_Fragment = (
  { __typename?: 'BlockProjectLinkSection' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type BarChartWithBackgroundEntryPoint_ProjectImageMap_Fragment = (
  { __typename?: 'ProjectImageMap' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type BarChartWithBackgroundEntryPoint_DownloadableFile_Fragment = (
  { __typename?: 'DownloadableFile' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type BarChartWithBackgroundEntryPoint_Footer_Fragment = (
  { __typename?: 'Footer' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

export type BarChartWithBackgroundEntryPointFragment = BarChartWithBackgroundEntryPoint_HeroImage_Fragment | BarChartWithBackgroundEntryPoint_StaticPage_Fragment | BarChartWithBackgroundEntryPoint_NavBarEntry_Fragment | BarChartWithBackgroundEntryPoint_BlockSubNavigation_Fragment | BarChartWithBackgroundEntryPoint_BlockBigTitleNavigation_Fragment | BarChartWithBackgroundEntryPoint_BlockHiddenWithConsent_Fragment | BarChartWithBackgroundEntryPoint_BlockAccordion_Fragment | BarChartWithBackgroundEntryPoint_BlockOneColumn_Fragment | BarChartWithBackgroundEntryPoint_BlockAnalystRating_Fragment | BarChartWithBackgroundEntryPoint_BlockCallToActionButton_Fragment | BarChartWithBackgroundEntryPoint_BlockTwoColumn_Fragment | BarChartWithBackgroundEntryPoint_BlockAccordionEntry_Fragment | BarChartWithBackgroundEntryPoint_NewsArticle_Fragment | BarChartWithBackgroundEntryPoint_BlockRichText_Fragment | BarChartWithBackgroundEntryPoint_LexiconArticle_Fragment | BarChartWithBackgroundEntryPoint_ProjectPage_Fragment | BarChartWithBackgroundEntryPoint_BarChartWithBackground_Fragment | BarChartWithBackgroundEntryPoint_BlockCustom_Fragment | BarChartWithBackgroundEntryPoint_BlockFullsizeImage_Fragment | BarChartWithBackgroundEntryPoint_BlockHighlightRealEstate_Fragment | BarChartWithBackgroundEntryPoint_HighlightedRealEstate_Fragment | BarChartWithBackgroundEntryPoint_BlockPartnerGrid_Fragment | BarChartWithBackgroundEntryPoint_Partner_Fragment | BarChartWithBackgroundEntryPoint_BlockPersonAccordion_Fragment | BarChartWithBackgroundEntryPoint_PersonAccordionEntry_Fragment | BarChartWithBackgroundEntryPoint_BlockRibbon_Fragment | BarChartWithBackgroundEntryPoint_BlockTable_Fragment | BarChartWithBackgroundEntryPoint_BlockThreeColumn_Fragment | BarChartWithBackgroundEntryPoint_BlockVideo_Fragment | BarChartWithBackgroundEntryPoint_NewsArticleContact_Fragment | BarChartWithBackgroundEntryPoint_BlockSpeechBubble_Fragment | BarChartWithBackgroundEntryPoint_LatestDownload_Fragment | BarChartWithBackgroundEntryPoint_NavigationEntry_Fragment | BarChartWithBackgroundEntryPoint_BlockLinkSection_Fragment | BarChartWithBackgroundEntryPoint_LinkSectionEntry_Fragment | BarChartWithBackgroundEntryPoint_BlockStockPrice_Fragment | BarChartWithBackgroundEntryPoint_BlockImageGallery_Fragment | BarChartWithBackgroundEntryPoint_BlockSlider_Fragment | BarChartWithBackgroundEntryPoint_BlockSliderEntry_Fragment | BarChartWithBackgroundEntryPoint_BlockTextCloud_Fragment | BarChartWithBackgroundEntryPoint_Seo_Fragment | BarChartWithBackgroundEntryPoint_RegionDescriptionText_Fragment | BarChartWithBackgroundEntryPoint_ProjectLink_Fragment | BarChartWithBackgroundEntryPoint_BlockProjectLinkSection_Fragment | BarChartWithBackgroundEntryPoint_ProjectImageMap_Fragment | BarChartWithBackgroundEntryPoint_DownloadableFile_Fragment | BarChartWithBackgroundEntryPoint_Footer_Fragment;

export type GetBlockAnalystRatingByIdQueryVariables = Exact<{
  locale?: Maybe<Scalars['String']>;
  preview?: Maybe<Scalars['Boolean']>;
  id: Scalars['String'];
}>;


export type GetBlockAnalystRatingByIdQuery = (
  { __typename?: 'Query' }
  & { entryCollection?: Maybe<(
    { __typename?: 'EntryCollection' }
    & { items: Array<Maybe<(
      { __typename?: 'HeroImage' }
      & BlockAnalystRatingEntryPoint_HeroImage_Fragment
    ) | (
      { __typename?: 'StaticPage' }
      & BlockAnalystRatingEntryPoint_StaticPage_Fragment
    ) | (
      { __typename?: 'NavBarEntry' }
      & BlockAnalystRatingEntryPoint_NavBarEntry_Fragment
    ) | (
      { __typename?: 'BlockSubNavigation' }
      & BlockAnalystRatingEntryPoint_BlockSubNavigation_Fragment
    ) | (
      { __typename?: 'BlockBigTitleNavigation' }
      & BlockAnalystRatingEntryPoint_BlockBigTitleNavigation_Fragment
    ) | (
      { __typename?: 'BlockHiddenWithConsent' }
      & BlockAnalystRatingEntryPoint_BlockHiddenWithConsent_Fragment
    ) | (
      { __typename?: 'BlockAccordion' }
      & BlockAnalystRatingEntryPoint_BlockAccordion_Fragment
    ) | (
      { __typename?: 'BlockOneColumn' }
      & BlockAnalystRatingEntryPoint_BlockOneColumn_Fragment
    ) | (
      { __typename?: 'BlockAnalystRating' }
      & BlockAnalystRatingEntryPoint_BlockAnalystRating_Fragment
    ) | (
      { __typename?: 'BlockCallToActionButton' }
      & BlockAnalystRatingEntryPoint_BlockCallToActionButton_Fragment
    ) | (
      { __typename?: 'BlockTwoColumn' }
      & BlockAnalystRatingEntryPoint_BlockTwoColumn_Fragment
    ) | (
      { __typename?: 'BlockAccordionEntry' }
      & BlockAnalystRatingEntryPoint_BlockAccordionEntry_Fragment
    ) | (
      { __typename?: 'NewsArticle' }
      & BlockAnalystRatingEntryPoint_NewsArticle_Fragment
    ) | (
      { __typename?: 'BlockRichText' }
      & BlockAnalystRatingEntryPoint_BlockRichText_Fragment
    ) | (
      { __typename?: 'LexiconArticle' }
      & BlockAnalystRatingEntryPoint_LexiconArticle_Fragment
    ) | (
      { __typename?: 'ProjectPage' }
      & BlockAnalystRatingEntryPoint_ProjectPage_Fragment
    ) | (
      { __typename?: 'BarChartWithBackground' }
      & BlockAnalystRatingEntryPoint_BarChartWithBackground_Fragment
    ) | (
      { __typename?: 'BlockCustom' }
      & BlockAnalystRatingEntryPoint_BlockCustom_Fragment
    ) | (
      { __typename?: 'BlockFullsizeImage' }
      & BlockAnalystRatingEntryPoint_BlockFullsizeImage_Fragment
    ) | (
      { __typename?: 'BlockHighlightRealEstate' }
      & BlockAnalystRatingEntryPoint_BlockHighlightRealEstate_Fragment
    ) | (
      { __typename?: 'HighlightedRealEstate' }
      & BlockAnalystRatingEntryPoint_HighlightedRealEstate_Fragment
    ) | (
      { __typename?: 'BlockPartnerGrid' }
      & BlockAnalystRatingEntryPoint_BlockPartnerGrid_Fragment
    ) | (
      { __typename?: 'Partner' }
      & BlockAnalystRatingEntryPoint_Partner_Fragment
    ) | (
      { __typename?: 'BlockPersonAccordion' }
      & BlockAnalystRatingEntryPoint_BlockPersonAccordion_Fragment
    ) | (
      { __typename?: 'PersonAccordionEntry' }
      & BlockAnalystRatingEntryPoint_PersonAccordionEntry_Fragment
    ) | (
      { __typename?: 'BlockRibbon' }
      & BlockAnalystRatingEntryPoint_BlockRibbon_Fragment
    ) | (
      { __typename?: 'BlockTable' }
      & BlockAnalystRatingEntryPoint_BlockTable_Fragment
    ) | (
      { __typename?: 'BlockThreeColumn' }
      & BlockAnalystRatingEntryPoint_BlockThreeColumn_Fragment
    ) | (
      { __typename?: 'BlockVideo' }
      & BlockAnalystRatingEntryPoint_BlockVideo_Fragment
    ) | (
      { __typename?: 'NewsArticleContact' }
      & BlockAnalystRatingEntryPoint_NewsArticleContact_Fragment
    ) | (
      { __typename?: 'BlockSpeechBubble' }
      & BlockAnalystRatingEntryPoint_BlockSpeechBubble_Fragment
    ) | (
      { __typename?: 'LatestDownload' }
      & BlockAnalystRatingEntryPoint_LatestDownload_Fragment
    ) | (
      { __typename?: 'NavigationEntry' }
      & BlockAnalystRatingEntryPoint_NavigationEntry_Fragment
    ) | (
      { __typename?: 'BlockLinkSection' }
      & BlockAnalystRatingEntryPoint_BlockLinkSection_Fragment
    ) | (
      { __typename?: 'LinkSectionEntry' }
      & BlockAnalystRatingEntryPoint_LinkSectionEntry_Fragment
    ) | (
      { __typename?: 'BlockStockPrice' }
      & BlockAnalystRatingEntryPoint_BlockStockPrice_Fragment
    ) | (
      { __typename?: 'BlockImageGallery' }
      & BlockAnalystRatingEntryPoint_BlockImageGallery_Fragment
    ) | (
      { __typename?: 'BlockSlider' }
      & BlockAnalystRatingEntryPoint_BlockSlider_Fragment
    ) | (
      { __typename?: 'BlockSliderEntry' }
      & BlockAnalystRatingEntryPoint_BlockSliderEntry_Fragment
    ) | (
      { __typename?: 'BlockTextCloud' }
      & BlockAnalystRatingEntryPoint_BlockTextCloud_Fragment
    ) | (
      { __typename?: 'Seo' }
      & BlockAnalystRatingEntryPoint_Seo_Fragment
    ) | (
      { __typename?: 'RegionDescriptionText' }
      & BlockAnalystRatingEntryPoint_RegionDescriptionText_Fragment
    ) | (
      { __typename?: 'ProjectLink' }
      & BlockAnalystRatingEntryPoint_ProjectLink_Fragment
    ) | (
      { __typename?: 'BlockProjectLinkSection' }
      & BlockAnalystRatingEntryPoint_BlockProjectLinkSection_Fragment
    ) | (
      { __typename?: 'ProjectImageMap' }
      & BlockAnalystRatingEntryPoint_ProjectImageMap_Fragment
    ) | (
      { __typename?: 'DownloadableFile' }
      & BlockAnalystRatingEntryPoint_DownloadableFile_Fragment
    ) | (
      { __typename?: 'Footer' }
      & BlockAnalystRatingEntryPoint_Footer_Fragment
    )>> }
  )> }
);

type BlockAnalystRatingEntryPoint_HeroImage_Fragment = (
  { __typename?: 'HeroImage' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type BlockAnalystRatingEntryPoint_StaticPage_Fragment = (
  { __typename?: 'StaticPage' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type BlockAnalystRatingEntryPoint_NavBarEntry_Fragment = (
  { __typename?: 'NavBarEntry' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type BlockAnalystRatingEntryPoint_BlockSubNavigation_Fragment = (
  { __typename?: 'BlockSubNavigation' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type BlockAnalystRatingEntryPoint_BlockBigTitleNavigation_Fragment = (
  { __typename?: 'BlockBigTitleNavigation' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type BlockAnalystRatingEntryPoint_BlockHiddenWithConsent_Fragment = (
  { __typename?: 'BlockHiddenWithConsent' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type BlockAnalystRatingEntryPoint_BlockAccordion_Fragment = (
  { __typename?: 'BlockAccordion' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type BlockAnalystRatingEntryPoint_BlockOneColumn_Fragment = (
  { __typename?: 'BlockOneColumn' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type BlockAnalystRatingEntryPoint_BlockAnalystRating_Fragment = (
  { __typename?: 'BlockAnalystRating' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
  & BlockAnalystRatingFragment
);

type BlockAnalystRatingEntryPoint_BlockCallToActionButton_Fragment = (
  { __typename?: 'BlockCallToActionButton' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type BlockAnalystRatingEntryPoint_BlockTwoColumn_Fragment = (
  { __typename?: 'BlockTwoColumn' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type BlockAnalystRatingEntryPoint_BlockAccordionEntry_Fragment = (
  { __typename?: 'BlockAccordionEntry' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type BlockAnalystRatingEntryPoint_NewsArticle_Fragment = (
  { __typename?: 'NewsArticle' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type BlockAnalystRatingEntryPoint_BlockRichText_Fragment = (
  { __typename?: 'BlockRichText' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type BlockAnalystRatingEntryPoint_LexiconArticle_Fragment = (
  { __typename?: 'LexiconArticle' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type BlockAnalystRatingEntryPoint_ProjectPage_Fragment = (
  { __typename?: 'ProjectPage' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type BlockAnalystRatingEntryPoint_BarChartWithBackground_Fragment = (
  { __typename?: 'BarChartWithBackground' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type BlockAnalystRatingEntryPoint_BlockCustom_Fragment = (
  { __typename?: 'BlockCustom' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type BlockAnalystRatingEntryPoint_BlockFullsizeImage_Fragment = (
  { __typename?: 'BlockFullsizeImage' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type BlockAnalystRatingEntryPoint_BlockHighlightRealEstate_Fragment = (
  { __typename?: 'BlockHighlightRealEstate' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type BlockAnalystRatingEntryPoint_HighlightedRealEstate_Fragment = (
  { __typename?: 'HighlightedRealEstate' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type BlockAnalystRatingEntryPoint_BlockPartnerGrid_Fragment = (
  { __typename?: 'BlockPartnerGrid' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type BlockAnalystRatingEntryPoint_Partner_Fragment = (
  { __typename?: 'Partner' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type BlockAnalystRatingEntryPoint_BlockPersonAccordion_Fragment = (
  { __typename?: 'BlockPersonAccordion' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type BlockAnalystRatingEntryPoint_PersonAccordionEntry_Fragment = (
  { __typename?: 'PersonAccordionEntry' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type BlockAnalystRatingEntryPoint_BlockRibbon_Fragment = (
  { __typename?: 'BlockRibbon' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type BlockAnalystRatingEntryPoint_BlockTable_Fragment = (
  { __typename?: 'BlockTable' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type BlockAnalystRatingEntryPoint_BlockThreeColumn_Fragment = (
  { __typename?: 'BlockThreeColumn' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type BlockAnalystRatingEntryPoint_BlockVideo_Fragment = (
  { __typename?: 'BlockVideo' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type BlockAnalystRatingEntryPoint_NewsArticleContact_Fragment = (
  { __typename?: 'NewsArticleContact' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type BlockAnalystRatingEntryPoint_BlockSpeechBubble_Fragment = (
  { __typename?: 'BlockSpeechBubble' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type BlockAnalystRatingEntryPoint_LatestDownload_Fragment = (
  { __typename?: 'LatestDownload' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type BlockAnalystRatingEntryPoint_NavigationEntry_Fragment = (
  { __typename?: 'NavigationEntry' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type BlockAnalystRatingEntryPoint_BlockLinkSection_Fragment = (
  { __typename?: 'BlockLinkSection' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type BlockAnalystRatingEntryPoint_LinkSectionEntry_Fragment = (
  { __typename?: 'LinkSectionEntry' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type BlockAnalystRatingEntryPoint_BlockStockPrice_Fragment = (
  { __typename?: 'BlockStockPrice' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type BlockAnalystRatingEntryPoint_BlockImageGallery_Fragment = (
  { __typename?: 'BlockImageGallery' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type BlockAnalystRatingEntryPoint_BlockSlider_Fragment = (
  { __typename?: 'BlockSlider' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type BlockAnalystRatingEntryPoint_BlockSliderEntry_Fragment = (
  { __typename?: 'BlockSliderEntry' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type BlockAnalystRatingEntryPoint_BlockTextCloud_Fragment = (
  { __typename?: 'BlockTextCloud' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type BlockAnalystRatingEntryPoint_Seo_Fragment = (
  { __typename?: 'Seo' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type BlockAnalystRatingEntryPoint_RegionDescriptionText_Fragment = (
  { __typename?: 'RegionDescriptionText' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type BlockAnalystRatingEntryPoint_ProjectLink_Fragment = (
  { __typename?: 'ProjectLink' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type BlockAnalystRatingEntryPoint_BlockProjectLinkSection_Fragment = (
  { __typename?: 'BlockProjectLinkSection' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type BlockAnalystRatingEntryPoint_ProjectImageMap_Fragment = (
  { __typename?: 'ProjectImageMap' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type BlockAnalystRatingEntryPoint_DownloadableFile_Fragment = (
  { __typename?: 'DownloadableFile' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type BlockAnalystRatingEntryPoint_Footer_Fragment = (
  { __typename?: 'Footer' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

export type BlockAnalystRatingEntryPointFragment = BlockAnalystRatingEntryPoint_HeroImage_Fragment | BlockAnalystRatingEntryPoint_StaticPage_Fragment | BlockAnalystRatingEntryPoint_NavBarEntry_Fragment | BlockAnalystRatingEntryPoint_BlockSubNavigation_Fragment | BlockAnalystRatingEntryPoint_BlockBigTitleNavigation_Fragment | BlockAnalystRatingEntryPoint_BlockHiddenWithConsent_Fragment | BlockAnalystRatingEntryPoint_BlockAccordion_Fragment | BlockAnalystRatingEntryPoint_BlockOneColumn_Fragment | BlockAnalystRatingEntryPoint_BlockAnalystRating_Fragment | BlockAnalystRatingEntryPoint_BlockCallToActionButton_Fragment | BlockAnalystRatingEntryPoint_BlockTwoColumn_Fragment | BlockAnalystRatingEntryPoint_BlockAccordionEntry_Fragment | BlockAnalystRatingEntryPoint_NewsArticle_Fragment | BlockAnalystRatingEntryPoint_BlockRichText_Fragment | BlockAnalystRatingEntryPoint_LexiconArticle_Fragment | BlockAnalystRatingEntryPoint_ProjectPage_Fragment | BlockAnalystRatingEntryPoint_BarChartWithBackground_Fragment | BlockAnalystRatingEntryPoint_BlockCustom_Fragment | BlockAnalystRatingEntryPoint_BlockFullsizeImage_Fragment | BlockAnalystRatingEntryPoint_BlockHighlightRealEstate_Fragment | BlockAnalystRatingEntryPoint_HighlightedRealEstate_Fragment | BlockAnalystRatingEntryPoint_BlockPartnerGrid_Fragment | BlockAnalystRatingEntryPoint_Partner_Fragment | BlockAnalystRatingEntryPoint_BlockPersonAccordion_Fragment | BlockAnalystRatingEntryPoint_PersonAccordionEntry_Fragment | BlockAnalystRatingEntryPoint_BlockRibbon_Fragment | BlockAnalystRatingEntryPoint_BlockTable_Fragment | BlockAnalystRatingEntryPoint_BlockThreeColumn_Fragment | BlockAnalystRatingEntryPoint_BlockVideo_Fragment | BlockAnalystRatingEntryPoint_NewsArticleContact_Fragment | BlockAnalystRatingEntryPoint_BlockSpeechBubble_Fragment | BlockAnalystRatingEntryPoint_LatestDownload_Fragment | BlockAnalystRatingEntryPoint_NavigationEntry_Fragment | BlockAnalystRatingEntryPoint_BlockLinkSection_Fragment | BlockAnalystRatingEntryPoint_LinkSectionEntry_Fragment | BlockAnalystRatingEntryPoint_BlockStockPrice_Fragment | BlockAnalystRatingEntryPoint_BlockImageGallery_Fragment | BlockAnalystRatingEntryPoint_BlockSlider_Fragment | BlockAnalystRatingEntryPoint_BlockSliderEntry_Fragment | BlockAnalystRatingEntryPoint_BlockTextCloud_Fragment | BlockAnalystRatingEntryPoint_Seo_Fragment | BlockAnalystRatingEntryPoint_RegionDescriptionText_Fragment | BlockAnalystRatingEntryPoint_ProjectLink_Fragment | BlockAnalystRatingEntryPoint_BlockProjectLinkSection_Fragment | BlockAnalystRatingEntryPoint_ProjectImageMap_Fragment | BlockAnalystRatingEntryPoint_DownloadableFile_Fragment | BlockAnalystRatingEntryPoint_Footer_Fragment;

export type GetBlockBigTitleNavigationByIdQueryVariables = Exact<{
  locale?: Maybe<Scalars['String']>;
  preview?: Maybe<Scalars['Boolean']>;
  id: Scalars['String'];
}>;


export type GetBlockBigTitleNavigationByIdQuery = (
  { __typename?: 'Query' }
  & { entryCollection?: Maybe<(
    { __typename?: 'EntryCollection' }
    & { items: Array<Maybe<(
      { __typename?: 'HeroImage' }
      & BlockBigTitleNavigationEntryPoint_HeroImage_Fragment
    ) | (
      { __typename?: 'StaticPage' }
      & BlockBigTitleNavigationEntryPoint_StaticPage_Fragment
    ) | (
      { __typename?: 'NavBarEntry' }
      & BlockBigTitleNavigationEntryPoint_NavBarEntry_Fragment
    ) | (
      { __typename?: 'BlockSubNavigation' }
      & BlockBigTitleNavigationEntryPoint_BlockSubNavigation_Fragment
    ) | (
      { __typename?: 'BlockBigTitleNavigation' }
      & BlockBigTitleNavigationEntryPoint_BlockBigTitleNavigation_Fragment
    ) | (
      { __typename?: 'BlockHiddenWithConsent' }
      & BlockBigTitleNavigationEntryPoint_BlockHiddenWithConsent_Fragment
    ) | (
      { __typename?: 'BlockAccordion' }
      & BlockBigTitleNavigationEntryPoint_BlockAccordion_Fragment
    ) | (
      { __typename?: 'BlockOneColumn' }
      & BlockBigTitleNavigationEntryPoint_BlockOneColumn_Fragment
    ) | (
      { __typename?: 'BlockAnalystRating' }
      & BlockBigTitleNavigationEntryPoint_BlockAnalystRating_Fragment
    ) | (
      { __typename?: 'BlockCallToActionButton' }
      & BlockBigTitleNavigationEntryPoint_BlockCallToActionButton_Fragment
    ) | (
      { __typename?: 'BlockTwoColumn' }
      & BlockBigTitleNavigationEntryPoint_BlockTwoColumn_Fragment
    ) | (
      { __typename?: 'BlockAccordionEntry' }
      & BlockBigTitleNavigationEntryPoint_BlockAccordionEntry_Fragment
    ) | (
      { __typename?: 'NewsArticle' }
      & BlockBigTitleNavigationEntryPoint_NewsArticle_Fragment
    ) | (
      { __typename?: 'BlockRichText' }
      & BlockBigTitleNavigationEntryPoint_BlockRichText_Fragment
    ) | (
      { __typename?: 'LexiconArticle' }
      & BlockBigTitleNavigationEntryPoint_LexiconArticle_Fragment
    ) | (
      { __typename?: 'ProjectPage' }
      & BlockBigTitleNavigationEntryPoint_ProjectPage_Fragment
    ) | (
      { __typename?: 'BarChartWithBackground' }
      & BlockBigTitleNavigationEntryPoint_BarChartWithBackground_Fragment
    ) | (
      { __typename?: 'BlockCustom' }
      & BlockBigTitleNavigationEntryPoint_BlockCustom_Fragment
    ) | (
      { __typename?: 'BlockFullsizeImage' }
      & BlockBigTitleNavigationEntryPoint_BlockFullsizeImage_Fragment
    ) | (
      { __typename?: 'BlockHighlightRealEstate' }
      & BlockBigTitleNavigationEntryPoint_BlockHighlightRealEstate_Fragment
    ) | (
      { __typename?: 'HighlightedRealEstate' }
      & BlockBigTitleNavigationEntryPoint_HighlightedRealEstate_Fragment
    ) | (
      { __typename?: 'BlockPartnerGrid' }
      & BlockBigTitleNavigationEntryPoint_BlockPartnerGrid_Fragment
    ) | (
      { __typename?: 'Partner' }
      & BlockBigTitleNavigationEntryPoint_Partner_Fragment
    ) | (
      { __typename?: 'BlockPersonAccordion' }
      & BlockBigTitleNavigationEntryPoint_BlockPersonAccordion_Fragment
    ) | (
      { __typename?: 'PersonAccordionEntry' }
      & BlockBigTitleNavigationEntryPoint_PersonAccordionEntry_Fragment
    ) | (
      { __typename?: 'BlockRibbon' }
      & BlockBigTitleNavigationEntryPoint_BlockRibbon_Fragment
    ) | (
      { __typename?: 'BlockTable' }
      & BlockBigTitleNavigationEntryPoint_BlockTable_Fragment
    ) | (
      { __typename?: 'BlockThreeColumn' }
      & BlockBigTitleNavigationEntryPoint_BlockThreeColumn_Fragment
    ) | (
      { __typename?: 'BlockVideo' }
      & BlockBigTitleNavigationEntryPoint_BlockVideo_Fragment
    ) | (
      { __typename?: 'NewsArticleContact' }
      & BlockBigTitleNavigationEntryPoint_NewsArticleContact_Fragment
    ) | (
      { __typename?: 'BlockSpeechBubble' }
      & BlockBigTitleNavigationEntryPoint_BlockSpeechBubble_Fragment
    ) | (
      { __typename?: 'LatestDownload' }
      & BlockBigTitleNavigationEntryPoint_LatestDownload_Fragment
    ) | (
      { __typename?: 'NavigationEntry' }
      & BlockBigTitleNavigationEntryPoint_NavigationEntry_Fragment
    ) | (
      { __typename?: 'BlockLinkSection' }
      & BlockBigTitleNavigationEntryPoint_BlockLinkSection_Fragment
    ) | (
      { __typename?: 'LinkSectionEntry' }
      & BlockBigTitleNavigationEntryPoint_LinkSectionEntry_Fragment
    ) | (
      { __typename?: 'BlockStockPrice' }
      & BlockBigTitleNavigationEntryPoint_BlockStockPrice_Fragment
    ) | (
      { __typename?: 'BlockImageGallery' }
      & BlockBigTitleNavigationEntryPoint_BlockImageGallery_Fragment
    ) | (
      { __typename?: 'BlockSlider' }
      & BlockBigTitleNavigationEntryPoint_BlockSlider_Fragment
    ) | (
      { __typename?: 'BlockSliderEntry' }
      & BlockBigTitleNavigationEntryPoint_BlockSliderEntry_Fragment
    ) | (
      { __typename?: 'BlockTextCloud' }
      & BlockBigTitleNavigationEntryPoint_BlockTextCloud_Fragment
    ) | (
      { __typename?: 'Seo' }
      & BlockBigTitleNavigationEntryPoint_Seo_Fragment
    ) | (
      { __typename?: 'RegionDescriptionText' }
      & BlockBigTitleNavigationEntryPoint_RegionDescriptionText_Fragment
    ) | (
      { __typename?: 'ProjectLink' }
      & BlockBigTitleNavigationEntryPoint_ProjectLink_Fragment
    ) | (
      { __typename?: 'BlockProjectLinkSection' }
      & BlockBigTitleNavigationEntryPoint_BlockProjectLinkSection_Fragment
    ) | (
      { __typename?: 'ProjectImageMap' }
      & BlockBigTitleNavigationEntryPoint_ProjectImageMap_Fragment
    ) | (
      { __typename?: 'DownloadableFile' }
      & BlockBigTitleNavigationEntryPoint_DownloadableFile_Fragment
    ) | (
      { __typename?: 'Footer' }
      & BlockBigTitleNavigationEntryPoint_Footer_Fragment
    )>> }
  )> }
);

type BlockBigTitleNavigationEntryPoint_HeroImage_Fragment = (
  { __typename?: 'HeroImage' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type BlockBigTitleNavigationEntryPoint_StaticPage_Fragment = (
  { __typename?: 'StaticPage' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type BlockBigTitleNavigationEntryPoint_NavBarEntry_Fragment = (
  { __typename?: 'NavBarEntry' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type BlockBigTitleNavigationEntryPoint_BlockSubNavigation_Fragment = (
  { __typename?: 'BlockSubNavigation' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type BlockBigTitleNavigationEntryPoint_BlockBigTitleNavigation_Fragment = (
  { __typename?: 'BlockBigTitleNavigation' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
  & BlockBigTitleNavigationFragment
);

type BlockBigTitleNavigationEntryPoint_BlockHiddenWithConsent_Fragment = (
  { __typename?: 'BlockHiddenWithConsent' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type BlockBigTitleNavigationEntryPoint_BlockAccordion_Fragment = (
  { __typename?: 'BlockAccordion' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type BlockBigTitleNavigationEntryPoint_BlockOneColumn_Fragment = (
  { __typename?: 'BlockOneColumn' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type BlockBigTitleNavigationEntryPoint_BlockAnalystRating_Fragment = (
  { __typename?: 'BlockAnalystRating' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type BlockBigTitleNavigationEntryPoint_BlockCallToActionButton_Fragment = (
  { __typename?: 'BlockCallToActionButton' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type BlockBigTitleNavigationEntryPoint_BlockTwoColumn_Fragment = (
  { __typename?: 'BlockTwoColumn' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type BlockBigTitleNavigationEntryPoint_BlockAccordionEntry_Fragment = (
  { __typename?: 'BlockAccordionEntry' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type BlockBigTitleNavigationEntryPoint_NewsArticle_Fragment = (
  { __typename?: 'NewsArticle' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type BlockBigTitleNavigationEntryPoint_BlockRichText_Fragment = (
  { __typename?: 'BlockRichText' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type BlockBigTitleNavigationEntryPoint_LexiconArticle_Fragment = (
  { __typename?: 'LexiconArticle' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type BlockBigTitleNavigationEntryPoint_ProjectPage_Fragment = (
  { __typename?: 'ProjectPage' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type BlockBigTitleNavigationEntryPoint_BarChartWithBackground_Fragment = (
  { __typename?: 'BarChartWithBackground' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type BlockBigTitleNavigationEntryPoint_BlockCustom_Fragment = (
  { __typename?: 'BlockCustom' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type BlockBigTitleNavigationEntryPoint_BlockFullsizeImage_Fragment = (
  { __typename?: 'BlockFullsizeImage' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type BlockBigTitleNavigationEntryPoint_BlockHighlightRealEstate_Fragment = (
  { __typename?: 'BlockHighlightRealEstate' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type BlockBigTitleNavigationEntryPoint_HighlightedRealEstate_Fragment = (
  { __typename?: 'HighlightedRealEstate' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type BlockBigTitleNavigationEntryPoint_BlockPartnerGrid_Fragment = (
  { __typename?: 'BlockPartnerGrid' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type BlockBigTitleNavigationEntryPoint_Partner_Fragment = (
  { __typename?: 'Partner' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type BlockBigTitleNavigationEntryPoint_BlockPersonAccordion_Fragment = (
  { __typename?: 'BlockPersonAccordion' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type BlockBigTitleNavigationEntryPoint_PersonAccordionEntry_Fragment = (
  { __typename?: 'PersonAccordionEntry' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type BlockBigTitleNavigationEntryPoint_BlockRibbon_Fragment = (
  { __typename?: 'BlockRibbon' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type BlockBigTitleNavigationEntryPoint_BlockTable_Fragment = (
  { __typename?: 'BlockTable' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type BlockBigTitleNavigationEntryPoint_BlockThreeColumn_Fragment = (
  { __typename?: 'BlockThreeColumn' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type BlockBigTitleNavigationEntryPoint_BlockVideo_Fragment = (
  { __typename?: 'BlockVideo' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type BlockBigTitleNavigationEntryPoint_NewsArticleContact_Fragment = (
  { __typename?: 'NewsArticleContact' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type BlockBigTitleNavigationEntryPoint_BlockSpeechBubble_Fragment = (
  { __typename?: 'BlockSpeechBubble' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type BlockBigTitleNavigationEntryPoint_LatestDownload_Fragment = (
  { __typename?: 'LatestDownload' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type BlockBigTitleNavigationEntryPoint_NavigationEntry_Fragment = (
  { __typename?: 'NavigationEntry' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type BlockBigTitleNavigationEntryPoint_BlockLinkSection_Fragment = (
  { __typename?: 'BlockLinkSection' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type BlockBigTitleNavigationEntryPoint_LinkSectionEntry_Fragment = (
  { __typename?: 'LinkSectionEntry' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type BlockBigTitleNavigationEntryPoint_BlockStockPrice_Fragment = (
  { __typename?: 'BlockStockPrice' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type BlockBigTitleNavigationEntryPoint_BlockImageGallery_Fragment = (
  { __typename?: 'BlockImageGallery' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type BlockBigTitleNavigationEntryPoint_BlockSlider_Fragment = (
  { __typename?: 'BlockSlider' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type BlockBigTitleNavigationEntryPoint_BlockSliderEntry_Fragment = (
  { __typename?: 'BlockSliderEntry' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type BlockBigTitleNavigationEntryPoint_BlockTextCloud_Fragment = (
  { __typename?: 'BlockTextCloud' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type BlockBigTitleNavigationEntryPoint_Seo_Fragment = (
  { __typename?: 'Seo' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type BlockBigTitleNavigationEntryPoint_RegionDescriptionText_Fragment = (
  { __typename?: 'RegionDescriptionText' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type BlockBigTitleNavigationEntryPoint_ProjectLink_Fragment = (
  { __typename?: 'ProjectLink' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type BlockBigTitleNavigationEntryPoint_BlockProjectLinkSection_Fragment = (
  { __typename?: 'BlockProjectLinkSection' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type BlockBigTitleNavigationEntryPoint_ProjectImageMap_Fragment = (
  { __typename?: 'ProjectImageMap' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type BlockBigTitleNavigationEntryPoint_DownloadableFile_Fragment = (
  { __typename?: 'DownloadableFile' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type BlockBigTitleNavigationEntryPoint_Footer_Fragment = (
  { __typename?: 'Footer' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

export type BlockBigTitleNavigationEntryPointFragment = BlockBigTitleNavigationEntryPoint_HeroImage_Fragment | BlockBigTitleNavigationEntryPoint_StaticPage_Fragment | BlockBigTitleNavigationEntryPoint_NavBarEntry_Fragment | BlockBigTitleNavigationEntryPoint_BlockSubNavigation_Fragment | BlockBigTitleNavigationEntryPoint_BlockBigTitleNavigation_Fragment | BlockBigTitleNavigationEntryPoint_BlockHiddenWithConsent_Fragment | BlockBigTitleNavigationEntryPoint_BlockAccordion_Fragment | BlockBigTitleNavigationEntryPoint_BlockOneColumn_Fragment | BlockBigTitleNavigationEntryPoint_BlockAnalystRating_Fragment | BlockBigTitleNavigationEntryPoint_BlockCallToActionButton_Fragment | BlockBigTitleNavigationEntryPoint_BlockTwoColumn_Fragment | BlockBigTitleNavigationEntryPoint_BlockAccordionEntry_Fragment | BlockBigTitleNavigationEntryPoint_NewsArticle_Fragment | BlockBigTitleNavigationEntryPoint_BlockRichText_Fragment | BlockBigTitleNavigationEntryPoint_LexiconArticle_Fragment | BlockBigTitleNavigationEntryPoint_ProjectPage_Fragment | BlockBigTitleNavigationEntryPoint_BarChartWithBackground_Fragment | BlockBigTitleNavigationEntryPoint_BlockCustom_Fragment | BlockBigTitleNavigationEntryPoint_BlockFullsizeImage_Fragment | BlockBigTitleNavigationEntryPoint_BlockHighlightRealEstate_Fragment | BlockBigTitleNavigationEntryPoint_HighlightedRealEstate_Fragment | BlockBigTitleNavigationEntryPoint_BlockPartnerGrid_Fragment | BlockBigTitleNavigationEntryPoint_Partner_Fragment | BlockBigTitleNavigationEntryPoint_BlockPersonAccordion_Fragment | BlockBigTitleNavigationEntryPoint_PersonAccordionEntry_Fragment | BlockBigTitleNavigationEntryPoint_BlockRibbon_Fragment | BlockBigTitleNavigationEntryPoint_BlockTable_Fragment | BlockBigTitleNavigationEntryPoint_BlockThreeColumn_Fragment | BlockBigTitleNavigationEntryPoint_BlockVideo_Fragment | BlockBigTitleNavigationEntryPoint_NewsArticleContact_Fragment | BlockBigTitleNavigationEntryPoint_BlockSpeechBubble_Fragment | BlockBigTitleNavigationEntryPoint_LatestDownload_Fragment | BlockBigTitleNavigationEntryPoint_NavigationEntry_Fragment | BlockBigTitleNavigationEntryPoint_BlockLinkSection_Fragment | BlockBigTitleNavigationEntryPoint_LinkSectionEntry_Fragment | BlockBigTitleNavigationEntryPoint_BlockStockPrice_Fragment | BlockBigTitleNavigationEntryPoint_BlockImageGallery_Fragment | BlockBigTitleNavigationEntryPoint_BlockSlider_Fragment | BlockBigTitleNavigationEntryPoint_BlockSliderEntry_Fragment | BlockBigTitleNavigationEntryPoint_BlockTextCloud_Fragment | BlockBigTitleNavigationEntryPoint_Seo_Fragment | BlockBigTitleNavigationEntryPoint_RegionDescriptionText_Fragment | BlockBigTitleNavigationEntryPoint_ProjectLink_Fragment | BlockBigTitleNavigationEntryPoint_BlockProjectLinkSection_Fragment | BlockBigTitleNavigationEntryPoint_ProjectImageMap_Fragment | BlockBigTitleNavigationEntryPoint_DownloadableFile_Fragment | BlockBigTitleNavigationEntryPoint_Footer_Fragment;

export type GetBlockHiddenWithConsentByIdQueryVariables = Exact<{
  locale?: Maybe<Scalars['String']>;
  preview?: Maybe<Scalars['Boolean']>;
  id: Scalars['String'];
}>;


export type GetBlockHiddenWithConsentByIdQuery = (
  { __typename?: 'Query' }
  & { entryCollection?: Maybe<(
    { __typename?: 'EntryCollection' }
    & { items: Array<Maybe<(
      { __typename?: 'HeroImage' }
      & BlockHiddenWithConsentEntryPoint_HeroImage_Fragment
    ) | (
      { __typename?: 'StaticPage' }
      & BlockHiddenWithConsentEntryPoint_StaticPage_Fragment
    ) | (
      { __typename?: 'NavBarEntry' }
      & BlockHiddenWithConsentEntryPoint_NavBarEntry_Fragment
    ) | (
      { __typename?: 'BlockSubNavigation' }
      & BlockHiddenWithConsentEntryPoint_BlockSubNavigation_Fragment
    ) | (
      { __typename?: 'BlockBigTitleNavigation' }
      & BlockHiddenWithConsentEntryPoint_BlockBigTitleNavigation_Fragment
    ) | (
      { __typename?: 'BlockHiddenWithConsent' }
      & BlockHiddenWithConsentEntryPoint_BlockHiddenWithConsent_Fragment
    ) | (
      { __typename?: 'BlockAccordion' }
      & BlockHiddenWithConsentEntryPoint_BlockAccordion_Fragment
    ) | (
      { __typename?: 'BlockOneColumn' }
      & BlockHiddenWithConsentEntryPoint_BlockOneColumn_Fragment
    ) | (
      { __typename?: 'BlockAnalystRating' }
      & BlockHiddenWithConsentEntryPoint_BlockAnalystRating_Fragment
    ) | (
      { __typename?: 'BlockCallToActionButton' }
      & BlockHiddenWithConsentEntryPoint_BlockCallToActionButton_Fragment
    ) | (
      { __typename?: 'BlockTwoColumn' }
      & BlockHiddenWithConsentEntryPoint_BlockTwoColumn_Fragment
    ) | (
      { __typename?: 'BlockAccordionEntry' }
      & BlockHiddenWithConsentEntryPoint_BlockAccordionEntry_Fragment
    ) | (
      { __typename?: 'NewsArticle' }
      & BlockHiddenWithConsentEntryPoint_NewsArticle_Fragment
    ) | (
      { __typename?: 'BlockRichText' }
      & BlockHiddenWithConsentEntryPoint_BlockRichText_Fragment
    ) | (
      { __typename?: 'LexiconArticle' }
      & BlockHiddenWithConsentEntryPoint_LexiconArticle_Fragment
    ) | (
      { __typename?: 'ProjectPage' }
      & BlockHiddenWithConsentEntryPoint_ProjectPage_Fragment
    ) | (
      { __typename?: 'BarChartWithBackground' }
      & BlockHiddenWithConsentEntryPoint_BarChartWithBackground_Fragment
    ) | (
      { __typename?: 'BlockCustom' }
      & BlockHiddenWithConsentEntryPoint_BlockCustom_Fragment
    ) | (
      { __typename?: 'BlockFullsizeImage' }
      & BlockHiddenWithConsentEntryPoint_BlockFullsizeImage_Fragment
    ) | (
      { __typename?: 'BlockHighlightRealEstate' }
      & BlockHiddenWithConsentEntryPoint_BlockHighlightRealEstate_Fragment
    ) | (
      { __typename?: 'HighlightedRealEstate' }
      & BlockHiddenWithConsentEntryPoint_HighlightedRealEstate_Fragment
    ) | (
      { __typename?: 'BlockPartnerGrid' }
      & BlockHiddenWithConsentEntryPoint_BlockPartnerGrid_Fragment
    ) | (
      { __typename?: 'Partner' }
      & BlockHiddenWithConsentEntryPoint_Partner_Fragment
    ) | (
      { __typename?: 'BlockPersonAccordion' }
      & BlockHiddenWithConsentEntryPoint_BlockPersonAccordion_Fragment
    ) | (
      { __typename?: 'PersonAccordionEntry' }
      & BlockHiddenWithConsentEntryPoint_PersonAccordionEntry_Fragment
    ) | (
      { __typename?: 'BlockRibbon' }
      & BlockHiddenWithConsentEntryPoint_BlockRibbon_Fragment
    ) | (
      { __typename?: 'BlockTable' }
      & BlockHiddenWithConsentEntryPoint_BlockTable_Fragment
    ) | (
      { __typename?: 'BlockThreeColumn' }
      & BlockHiddenWithConsentEntryPoint_BlockThreeColumn_Fragment
    ) | (
      { __typename?: 'BlockVideo' }
      & BlockHiddenWithConsentEntryPoint_BlockVideo_Fragment
    ) | (
      { __typename?: 'NewsArticleContact' }
      & BlockHiddenWithConsentEntryPoint_NewsArticleContact_Fragment
    ) | (
      { __typename?: 'BlockSpeechBubble' }
      & BlockHiddenWithConsentEntryPoint_BlockSpeechBubble_Fragment
    ) | (
      { __typename?: 'LatestDownload' }
      & BlockHiddenWithConsentEntryPoint_LatestDownload_Fragment
    ) | (
      { __typename?: 'NavigationEntry' }
      & BlockHiddenWithConsentEntryPoint_NavigationEntry_Fragment
    ) | (
      { __typename?: 'BlockLinkSection' }
      & BlockHiddenWithConsentEntryPoint_BlockLinkSection_Fragment
    ) | (
      { __typename?: 'LinkSectionEntry' }
      & BlockHiddenWithConsentEntryPoint_LinkSectionEntry_Fragment
    ) | (
      { __typename?: 'BlockStockPrice' }
      & BlockHiddenWithConsentEntryPoint_BlockStockPrice_Fragment
    ) | (
      { __typename?: 'BlockImageGallery' }
      & BlockHiddenWithConsentEntryPoint_BlockImageGallery_Fragment
    ) | (
      { __typename?: 'BlockSlider' }
      & BlockHiddenWithConsentEntryPoint_BlockSlider_Fragment
    ) | (
      { __typename?: 'BlockSliderEntry' }
      & BlockHiddenWithConsentEntryPoint_BlockSliderEntry_Fragment
    ) | (
      { __typename?: 'BlockTextCloud' }
      & BlockHiddenWithConsentEntryPoint_BlockTextCloud_Fragment
    ) | (
      { __typename?: 'Seo' }
      & BlockHiddenWithConsentEntryPoint_Seo_Fragment
    ) | (
      { __typename?: 'RegionDescriptionText' }
      & BlockHiddenWithConsentEntryPoint_RegionDescriptionText_Fragment
    ) | (
      { __typename?: 'ProjectLink' }
      & BlockHiddenWithConsentEntryPoint_ProjectLink_Fragment
    ) | (
      { __typename?: 'BlockProjectLinkSection' }
      & BlockHiddenWithConsentEntryPoint_BlockProjectLinkSection_Fragment
    ) | (
      { __typename?: 'ProjectImageMap' }
      & BlockHiddenWithConsentEntryPoint_ProjectImageMap_Fragment
    ) | (
      { __typename?: 'DownloadableFile' }
      & BlockHiddenWithConsentEntryPoint_DownloadableFile_Fragment
    ) | (
      { __typename?: 'Footer' }
      & BlockHiddenWithConsentEntryPoint_Footer_Fragment
    )>> }
  )> }
);

type BlockHiddenWithConsentEntryPoint_HeroImage_Fragment = (
  { __typename?: 'HeroImage' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type BlockHiddenWithConsentEntryPoint_StaticPage_Fragment = (
  { __typename?: 'StaticPage' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type BlockHiddenWithConsentEntryPoint_NavBarEntry_Fragment = (
  { __typename?: 'NavBarEntry' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type BlockHiddenWithConsentEntryPoint_BlockSubNavigation_Fragment = (
  { __typename?: 'BlockSubNavigation' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type BlockHiddenWithConsentEntryPoint_BlockBigTitleNavigation_Fragment = (
  { __typename?: 'BlockBigTitleNavigation' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type BlockHiddenWithConsentEntryPoint_BlockHiddenWithConsent_Fragment = (
  { __typename?: 'BlockHiddenWithConsent' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
  & BlockHiddenWithConsentFragment
);

type BlockHiddenWithConsentEntryPoint_BlockAccordion_Fragment = (
  { __typename?: 'BlockAccordion' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type BlockHiddenWithConsentEntryPoint_BlockOneColumn_Fragment = (
  { __typename?: 'BlockOneColumn' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type BlockHiddenWithConsentEntryPoint_BlockAnalystRating_Fragment = (
  { __typename?: 'BlockAnalystRating' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type BlockHiddenWithConsentEntryPoint_BlockCallToActionButton_Fragment = (
  { __typename?: 'BlockCallToActionButton' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type BlockHiddenWithConsentEntryPoint_BlockTwoColumn_Fragment = (
  { __typename?: 'BlockTwoColumn' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type BlockHiddenWithConsentEntryPoint_BlockAccordionEntry_Fragment = (
  { __typename?: 'BlockAccordionEntry' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type BlockHiddenWithConsentEntryPoint_NewsArticle_Fragment = (
  { __typename?: 'NewsArticle' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type BlockHiddenWithConsentEntryPoint_BlockRichText_Fragment = (
  { __typename?: 'BlockRichText' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type BlockHiddenWithConsentEntryPoint_LexiconArticle_Fragment = (
  { __typename?: 'LexiconArticle' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type BlockHiddenWithConsentEntryPoint_ProjectPage_Fragment = (
  { __typename?: 'ProjectPage' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type BlockHiddenWithConsentEntryPoint_BarChartWithBackground_Fragment = (
  { __typename?: 'BarChartWithBackground' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type BlockHiddenWithConsentEntryPoint_BlockCustom_Fragment = (
  { __typename?: 'BlockCustom' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type BlockHiddenWithConsentEntryPoint_BlockFullsizeImage_Fragment = (
  { __typename?: 'BlockFullsizeImage' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type BlockHiddenWithConsentEntryPoint_BlockHighlightRealEstate_Fragment = (
  { __typename?: 'BlockHighlightRealEstate' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type BlockHiddenWithConsentEntryPoint_HighlightedRealEstate_Fragment = (
  { __typename?: 'HighlightedRealEstate' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type BlockHiddenWithConsentEntryPoint_BlockPartnerGrid_Fragment = (
  { __typename?: 'BlockPartnerGrid' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type BlockHiddenWithConsentEntryPoint_Partner_Fragment = (
  { __typename?: 'Partner' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type BlockHiddenWithConsentEntryPoint_BlockPersonAccordion_Fragment = (
  { __typename?: 'BlockPersonAccordion' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type BlockHiddenWithConsentEntryPoint_PersonAccordionEntry_Fragment = (
  { __typename?: 'PersonAccordionEntry' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type BlockHiddenWithConsentEntryPoint_BlockRibbon_Fragment = (
  { __typename?: 'BlockRibbon' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type BlockHiddenWithConsentEntryPoint_BlockTable_Fragment = (
  { __typename?: 'BlockTable' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type BlockHiddenWithConsentEntryPoint_BlockThreeColumn_Fragment = (
  { __typename?: 'BlockThreeColumn' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type BlockHiddenWithConsentEntryPoint_BlockVideo_Fragment = (
  { __typename?: 'BlockVideo' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type BlockHiddenWithConsentEntryPoint_NewsArticleContact_Fragment = (
  { __typename?: 'NewsArticleContact' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type BlockHiddenWithConsentEntryPoint_BlockSpeechBubble_Fragment = (
  { __typename?: 'BlockSpeechBubble' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type BlockHiddenWithConsentEntryPoint_LatestDownload_Fragment = (
  { __typename?: 'LatestDownload' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type BlockHiddenWithConsentEntryPoint_NavigationEntry_Fragment = (
  { __typename?: 'NavigationEntry' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type BlockHiddenWithConsentEntryPoint_BlockLinkSection_Fragment = (
  { __typename?: 'BlockLinkSection' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type BlockHiddenWithConsentEntryPoint_LinkSectionEntry_Fragment = (
  { __typename?: 'LinkSectionEntry' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type BlockHiddenWithConsentEntryPoint_BlockStockPrice_Fragment = (
  { __typename?: 'BlockStockPrice' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type BlockHiddenWithConsentEntryPoint_BlockImageGallery_Fragment = (
  { __typename?: 'BlockImageGallery' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type BlockHiddenWithConsentEntryPoint_BlockSlider_Fragment = (
  { __typename?: 'BlockSlider' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type BlockHiddenWithConsentEntryPoint_BlockSliderEntry_Fragment = (
  { __typename?: 'BlockSliderEntry' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type BlockHiddenWithConsentEntryPoint_BlockTextCloud_Fragment = (
  { __typename?: 'BlockTextCloud' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type BlockHiddenWithConsentEntryPoint_Seo_Fragment = (
  { __typename?: 'Seo' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type BlockHiddenWithConsentEntryPoint_RegionDescriptionText_Fragment = (
  { __typename?: 'RegionDescriptionText' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type BlockHiddenWithConsentEntryPoint_ProjectLink_Fragment = (
  { __typename?: 'ProjectLink' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type BlockHiddenWithConsentEntryPoint_BlockProjectLinkSection_Fragment = (
  { __typename?: 'BlockProjectLinkSection' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type BlockHiddenWithConsentEntryPoint_ProjectImageMap_Fragment = (
  { __typename?: 'ProjectImageMap' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type BlockHiddenWithConsentEntryPoint_DownloadableFile_Fragment = (
  { __typename?: 'DownloadableFile' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type BlockHiddenWithConsentEntryPoint_Footer_Fragment = (
  { __typename?: 'Footer' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

export type BlockHiddenWithConsentEntryPointFragment = BlockHiddenWithConsentEntryPoint_HeroImage_Fragment | BlockHiddenWithConsentEntryPoint_StaticPage_Fragment | BlockHiddenWithConsentEntryPoint_NavBarEntry_Fragment | BlockHiddenWithConsentEntryPoint_BlockSubNavigation_Fragment | BlockHiddenWithConsentEntryPoint_BlockBigTitleNavigation_Fragment | BlockHiddenWithConsentEntryPoint_BlockHiddenWithConsent_Fragment | BlockHiddenWithConsentEntryPoint_BlockAccordion_Fragment | BlockHiddenWithConsentEntryPoint_BlockOneColumn_Fragment | BlockHiddenWithConsentEntryPoint_BlockAnalystRating_Fragment | BlockHiddenWithConsentEntryPoint_BlockCallToActionButton_Fragment | BlockHiddenWithConsentEntryPoint_BlockTwoColumn_Fragment | BlockHiddenWithConsentEntryPoint_BlockAccordionEntry_Fragment | BlockHiddenWithConsentEntryPoint_NewsArticle_Fragment | BlockHiddenWithConsentEntryPoint_BlockRichText_Fragment | BlockHiddenWithConsentEntryPoint_LexiconArticle_Fragment | BlockHiddenWithConsentEntryPoint_ProjectPage_Fragment | BlockHiddenWithConsentEntryPoint_BarChartWithBackground_Fragment | BlockHiddenWithConsentEntryPoint_BlockCustom_Fragment | BlockHiddenWithConsentEntryPoint_BlockFullsizeImage_Fragment | BlockHiddenWithConsentEntryPoint_BlockHighlightRealEstate_Fragment | BlockHiddenWithConsentEntryPoint_HighlightedRealEstate_Fragment | BlockHiddenWithConsentEntryPoint_BlockPartnerGrid_Fragment | BlockHiddenWithConsentEntryPoint_Partner_Fragment | BlockHiddenWithConsentEntryPoint_BlockPersonAccordion_Fragment | BlockHiddenWithConsentEntryPoint_PersonAccordionEntry_Fragment | BlockHiddenWithConsentEntryPoint_BlockRibbon_Fragment | BlockHiddenWithConsentEntryPoint_BlockTable_Fragment | BlockHiddenWithConsentEntryPoint_BlockThreeColumn_Fragment | BlockHiddenWithConsentEntryPoint_BlockVideo_Fragment | BlockHiddenWithConsentEntryPoint_NewsArticleContact_Fragment | BlockHiddenWithConsentEntryPoint_BlockSpeechBubble_Fragment | BlockHiddenWithConsentEntryPoint_LatestDownload_Fragment | BlockHiddenWithConsentEntryPoint_NavigationEntry_Fragment | BlockHiddenWithConsentEntryPoint_BlockLinkSection_Fragment | BlockHiddenWithConsentEntryPoint_LinkSectionEntry_Fragment | BlockHiddenWithConsentEntryPoint_BlockStockPrice_Fragment | BlockHiddenWithConsentEntryPoint_BlockImageGallery_Fragment | BlockHiddenWithConsentEntryPoint_BlockSlider_Fragment | BlockHiddenWithConsentEntryPoint_BlockSliderEntry_Fragment | BlockHiddenWithConsentEntryPoint_BlockTextCloud_Fragment | BlockHiddenWithConsentEntryPoint_Seo_Fragment | BlockHiddenWithConsentEntryPoint_RegionDescriptionText_Fragment | BlockHiddenWithConsentEntryPoint_ProjectLink_Fragment | BlockHiddenWithConsentEntryPoint_BlockProjectLinkSection_Fragment | BlockHiddenWithConsentEntryPoint_ProjectImageMap_Fragment | BlockHiddenWithConsentEntryPoint_DownloadableFile_Fragment | BlockHiddenWithConsentEntryPoint_Footer_Fragment;

export type GetBlockHiddenWithConsentWithoutChildrenByIdQueryVariables = Exact<{
  locale?: Maybe<Scalars['String']>;
  preview?: Maybe<Scalars['Boolean']>;
  id: Scalars['String'];
}>;


export type GetBlockHiddenWithConsentWithoutChildrenByIdQuery = (
  { __typename?: 'Query' }
  & { entryCollection?: Maybe<(
    { __typename?: 'EntryCollection' }
    & { items: Array<Maybe<(
      { __typename?: 'HeroImage' }
      & BlockHiddenWithConsentWithoutChildrenEntryPoint_HeroImage_Fragment
    ) | (
      { __typename?: 'StaticPage' }
      & BlockHiddenWithConsentWithoutChildrenEntryPoint_StaticPage_Fragment
    ) | (
      { __typename?: 'NavBarEntry' }
      & BlockHiddenWithConsentWithoutChildrenEntryPoint_NavBarEntry_Fragment
    ) | (
      { __typename?: 'BlockSubNavigation' }
      & BlockHiddenWithConsentWithoutChildrenEntryPoint_BlockSubNavigation_Fragment
    ) | (
      { __typename?: 'BlockBigTitleNavigation' }
      & BlockHiddenWithConsentWithoutChildrenEntryPoint_BlockBigTitleNavigation_Fragment
    ) | (
      { __typename?: 'BlockHiddenWithConsent' }
      & BlockHiddenWithConsentWithoutChildrenEntryPoint_BlockHiddenWithConsent_Fragment
    ) | (
      { __typename?: 'BlockAccordion' }
      & BlockHiddenWithConsentWithoutChildrenEntryPoint_BlockAccordion_Fragment
    ) | (
      { __typename?: 'BlockOneColumn' }
      & BlockHiddenWithConsentWithoutChildrenEntryPoint_BlockOneColumn_Fragment
    ) | (
      { __typename?: 'BlockAnalystRating' }
      & BlockHiddenWithConsentWithoutChildrenEntryPoint_BlockAnalystRating_Fragment
    ) | (
      { __typename?: 'BlockCallToActionButton' }
      & BlockHiddenWithConsentWithoutChildrenEntryPoint_BlockCallToActionButton_Fragment
    ) | (
      { __typename?: 'BlockTwoColumn' }
      & BlockHiddenWithConsentWithoutChildrenEntryPoint_BlockTwoColumn_Fragment
    ) | (
      { __typename?: 'BlockAccordionEntry' }
      & BlockHiddenWithConsentWithoutChildrenEntryPoint_BlockAccordionEntry_Fragment
    ) | (
      { __typename?: 'NewsArticle' }
      & BlockHiddenWithConsentWithoutChildrenEntryPoint_NewsArticle_Fragment
    ) | (
      { __typename?: 'BlockRichText' }
      & BlockHiddenWithConsentWithoutChildrenEntryPoint_BlockRichText_Fragment
    ) | (
      { __typename?: 'LexiconArticle' }
      & BlockHiddenWithConsentWithoutChildrenEntryPoint_LexiconArticle_Fragment
    ) | (
      { __typename?: 'ProjectPage' }
      & BlockHiddenWithConsentWithoutChildrenEntryPoint_ProjectPage_Fragment
    ) | (
      { __typename?: 'BarChartWithBackground' }
      & BlockHiddenWithConsentWithoutChildrenEntryPoint_BarChartWithBackground_Fragment
    ) | (
      { __typename?: 'BlockCustom' }
      & BlockHiddenWithConsentWithoutChildrenEntryPoint_BlockCustom_Fragment
    ) | (
      { __typename?: 'BlockFullsizeImage' }
      & BlockHiddenWithConsentWithoutChildrenEntryPoint_BlockFullsizeImage_Fragment
    ) | (
      { __typename?: 'BlockHighlightRealEstate' }
      & BlockHiddenWithConsentWithoutChildrenEntryPoint_BlockHighlightRealEstate_Fragment
    ) | (
      { __typename?: 'HighlightedRealEstate' }
      & BlockHiddenWithConsentWithoutChildrenEntryPoint_HighlightedRealEstate_Fragment
    ) | (
      { __typename?: 'BlockPartnerGrid' }
      & BlockHiddenWithConsentWithoutChildrenEntryPoint_BlockPartnerGrid_Fragment
    ) | (
      { __typename?: 'Partner' }
      & BlockHiddenWithConsentWithoutChildrenEntryPoint_Partner_Fragment
    ) | (
      { __typename?: 'BlockPersonAccordion' }
      & BlockHiddenWithConsentWithoutChildrenEntryPoint_BlockPersonAccordion_Fragment
    ) | (
      { __typename?: 'PersonAccordionEntry' }
      & BlockHiddenWithConsentWithoutChildrenEntryPoint_PersonAccordionEntry_Fragment
    ) | (
      { __typename?: 'BlockRibbon' }
      & BlockHiddenWithConsentWithoutChildrenEntryPoint_BlockRibbon_Fragment
    ) | (
      { __typename?: 'BlockTable' }
      & BlockHiddenWithConsentWithoutChildrenEntryPoint_BlockTable_Fragment
    ) | (
      { __typename?: 'BlockThreeColumn' }
      & BlockHiddenWithConsentWithoutChildrenEntryPoint_BlockThreeColumn_Fragment
    ) | (
      { __typename?: 'BlockVideo' }
      & BlockHiddenWithConsentWithoutChildrenEntryPoint_BlockVideo_Fragment
    ) | (
      { __typename?: 'NewsArticleContact' }
      & BlockHiddenWithConsentWithoutChildrenEntryPoint_NewsArticleContact_Fragment
    ) | (
      { __typename?: 'BlockSpeechBubble' }
      & BlockHiddenWithConsentWithoutChildrenEntryPoint_BlockSpeechBubble_Fragment
    ) | (
      { __typename?: 'LatestDownload' }
      & BlockHiddenWithConsentWithoutChildrenEntryPoint_LatestDownload_Fragment
    ) | (
      { __typename?: 'NavigationEntry' }
      & BlockHiddenWithConsentWithoutChildrenEntryPoint_NavigationEntry_Fragment
    ) | (
      { __typename?: 'BlockLinkSection' }
      & BlockHiddenWithConsentWithoutChildrenEntryPoint_BlockLinkSection_Fragment
    ) | (
      { __typename?: 'LinkSectionEntry' }
      & BlockHiddenWithConsentWithoutChildrenEntryPoint_LinkSectionEntry_Fragment
    ) | (
      { __typename?: 'BlockStockPrice' }
      & BlockHiddenWithConsentWithoutChildrenEntryPoint_BlockStockPrice_Fragment
    ) | (
      { __typename?: 'BlockImageGallery' }
      & BlockHiddenWithConsentWithoutChildrenEntryPoint_BlockImageGallery_Fragment
    ) | (
      { __typename?: 'BlockSlider' }
      & BlockHiddenWithConsentWithoutChildrenEntryPoint_BlockSlider_Fragment
    ) | (
      { __typename?: 'BlockSliderEntry' }
      & BlockHiddenWithConsentWithoutChildrenEntryPoint_BlockSliderEntry_Fragment
    ) | (
      { __typename?: 'BlockTextCloud' }
      & BlockHiddenWithConsentWithoutChildrenEntryPoint_BlockTextCloud_Fragment
    ) | (
      { __typename?: 'Seo' }
      & BlockHiddenWithConsentWithoutChildrenEntryPoint_Seo_Fragment
    ) | (
      { __typename?: 'RegionDescriptionText' }
      & BlockHiddenWithConsentWithoutChildrenEntryPoint_RegionDescriptionText_Fragment
    ) | (
      { __typename?: 'ProjectLink' }
      & BlockHiddenWithConsentWithoutChildrenEntryPoint_ProjectLink_Fragment
    ) | (
      { __typename?: 'BlockProjectLinkSection' }
      & BlockHiddenWithConsentWithoutChildrenEntryPoint_BlockProjectLinkSection_Fragment
    ) | (
      { __typename?: 'ProjectImageMap' }
      & BlockHiddenWithConsentWithoutChildrenEntryPoint_ProjectImageMap_Fragment
    ) | (
      { __typename?: 'DownloadableFile' }
      & BlockHiddenWithConsentWithoutChildrenEntryPoint_DownloadableFile_Fragment
    ) | (
      { __typename?: 'Footer' }
      & BlockHiddenWithConsentWithoutChildrenEntryPoint_Footer_Fragment
    )>> }
  )> }
);

type BlockHiddenWithConsentWithoutChildrenEntryPoint_HeroImage_Fragment = (
  { __typename?: 'HeroImage' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type BlockHiddenWithConsentWithoutChildrenEntryPoint_StaticPage_Fragment = (
  { __typename?: 'StaticPage' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type BlockHiddenWithConsentWithoutChildrenEntryPoint_NavBarEntry_Fragment = (
  { __typename?: 'NavBarEntry' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type BlockHiddenWithConsentWithoutChildrenEntryPoint_BlockSubNavigation_Fragment = (
  { __typename?: 'BlockSubNavigation' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type BlockHiddenWithConsentWithoutChildrenEntryPoint_BlockBigTitleNavigation_Fragment = (
  { __typename?: 'BlockBigTitleNavigation' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type BlockHiddenWithConsentWithoutChildrenEntryPoint_BlockHiddenWithConsent_Fragment = (
  { __typename?: 'BlockHiddenWithConsent' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
  & BlockHiddenWithConsentWithoutChildrenFragment
);

type BlockHiddenWithConsentWithoutChildrenEntryPoint_BlockAccordion_Fragment = (
  { __typename?: 'BlockAccordion' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type BlockHiddenWithConsentWithoutChildrenEntryPoint_BlockOneColumn_Fragment = (
  { __typename?: 'BlockOneColumn' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type BlockHiddenWithConsentWithoutChildrenEntryPoint_BlockAnalystRating_Fragment = (
  { __typename?: 'BlockAnalystRating' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type BlockHiddenWithConsentWithoutChildrenEntryPoint_BlockCallToActionButton_Fragment = (
  { __typename?: 'BlockCallToActionButton' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type BlockHiddenWithConsentWithoutChildrenEntryPoint_BlockTwoColumn_Fragment = (
  { __typename?: 'BlockTwoColumn' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type BlockHiddenWithConsentWithoutChildrenEntryPoint_BlockAccordionEntry_Fragment = (
  { __typename?: 'BlockAccordionEntry' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type BlockHiddenWithConsentWithoutChildrenEntryPoint_NewsArticle_Fragment = (
  { __typename?: 'NewsArticle' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type BlockHiddenWithConsentWithoutChildrenEntryPoint_BlockRichText_Fragment = (
  { __typename?: 'BlockRichText' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type BlockHiddenWithConsentWithoutChildrenEntryPoint_LexiconArticle_Fragment = (
  { __typename?: 'LexiconArticle' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type BlockHiddenWithConsentWithoutChildrenEntryPoint_ProjectPage_Fragment = (
  { __typename?: 'ProjectPage' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type BlockHiddenWithConsentWithoutChildrenEntryPoint_BarChartWithBackground_Fragment = (
  { __typename?: 'BarChartWithBackground' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type BlockHiddenWithConsentWithoutChildrenEntryPoint_BlockCustom_Fragment = (
  { __typename?: 'BlockCustom' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type BlockHiddenWithConsentWithoutChildrenEntryPoint_BlockFullsizeImage_Fragment = (
  { __typename?: 'BlockFullsizeImage' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type BlockHiddenWithConsentWithoutChildrenEntryPoint_BlockHighlightRealEstate_Fragment = (
  { __typename?: 'BlockHighlightRealEstate' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type BlockHiddenWithConsentWithoutChildrenEntryPoint_HighlightedRealEstate_Fragment = (
  { __typename?: 'HighlightedRealEstate' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type BlockHiddenWithConsentWithoutChildrenEntryPoint_BlockPartnerGrid_Fragment = (
  { __typename?: 'BlockPartnerGrid' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type BlockHiddenWithConsentWithoutChildrenEntryPoint_Partner_Fragment = (
  { __typename?: 'Partner' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type BlockHiddenWithConsentWithoutChildrenEntryPoint_BlockPersonAccordion_Fragment = (
  { __typename?: 'BlockPersonAccordion' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type BlockHiddenWithConsentWithoutChildrenEntryPoint_PersonAccordionEntry_Fragment = (
  { __typename?: 'PersonAccordionEntry' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type BlockHiddenWithConsentWithoutChildrenEntryPoint_BlockRibbon_Fragment = (
  { __typename?: 'BlockRibbon' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type BlockHiddenWithConsentWithoutChildrenEntryPoint_BlockTable_Fragment = (
  { __typename?: 'BlockTable' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type BlockHiddenWithConsentWithoutChildrenEntryPoint_BlockThreeColumn_Fragment = (
  { __typename?: 'BlockThreeColumn' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type BlockHiddenWithConsentWithoutChildrenEntryPoint_BlockVideo_Fragment = (
  { __typename?: 'BlockVideo' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type BlockHiddenWithConsentWithoutChildrenEntryPoint_NewsArticleContact_Fragment = (
  { __typename?: 'NewsArticleContact' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type BlockHiddenWithConsentWithoutChildrenEntryPoint_BlockSpeechBubble_Fragment = (
  { __typename?: 'BlockSpeechBubble' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type BlockHiddenWithConsentWithoutChildrenEntryPoint_LatestDownload_Fragment = (
  { __typename?: 'LatestDownload' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type BlockHiddenWithConsentWithoutChildrenEntryPoint_NavigationEntry_Fragment = (
  { __typename?: 'NavigationEntry' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type BlockHiddenWithConsentWithoutChildrenEntryPoint_BlockLinkSection_Fragment = (
  { __typename?: 'BlockLinkSection' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type BlockHiddenWithConsentWithoutChildrenEntryPoint_LinkSectionEntry_Fragment = (
  { __typename?: 'LinkSectionEntry' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type BlockHiddenWithConsentWithoutChildrenEntryPoint_BlockStockPrice_Fragment = (
  { __typename?: 'BlockStockPrice' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type BlockHiddenWithConsentWithoutChildrenEntryPoint_BlockImageGallery_Fragment = (
  { __typename?: 'BlockImageGallery' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type BlockHiddenWithConsentWithoutChildrenEntryPoint_BlockSlider_Fragment = (
  { __typename?: 'BlockSlider' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type BlockHiddenWithConsentWithoutChildrenEntryPoint_BlockSliderEntry_Fragment = (
  { __typename?: 'BlockSliderEntry' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type BlockHiddenWithConsentWithoutChildrenEntryPoint_BlockTextCloud_Fragment = (
  { __typename?: 'BlockTextCloud' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type BlockHiddenWithConsentWithoutChildrenEntryPoint_Seo_Fragment = (
  { __typename?: 'Seo' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type BlockHiddenWithConsentWithoutChildrenEntryPoint_RegionDescriptionText_Fragment = (
  { __typename?: 'RegionDescriptionText' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type BlockHiddenWithConsentWithoutChildrenEntryPoint_ProjectLink_Fragment = (
  { __typename?: 'ProjectLink' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type BlockHiddenWithConsentWithoutChildrenEntryPoint_BlockProjectLinkSection_Fragment = (
  { __typename?: 'BlockProjectLinkSection' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type BlockHiddenWithConsentWithoutChildrenEntryPoint_ProjectImageMap_Fragment = (
  { __typename?: 'ProjectImageMap' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type BlockHiddenWithConsentWithoutChildrenEntryPoint_DownloadableFile_Fragment = (
  { __typename?: 'DownloadableFile' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type BlockHiddenWithConsentWithoutChildrenEntryPoint_Footer_Fragment = (
  { __typename?: 'Footer' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

export type BlockHiddenWithConsentWithoutChildrenEntryPointFragment = BlockHiddenWithConsentWithoutChildrenEntryPoint_HeroImage_Fragment | BlockHiddenWithConsentWithoutChildrenEntryPoint_StaticPage_Fragment | BlockHiddenWithConsentWithoutChildrenEntryPoint_NavBarEntry_Fragment | BlockHiddenWithConsentWithoutChildrenEntryPoint_BlockSubNavigation_Fragment | BlockHiddenWithConsentWithoutChildrenEntryPoint_BlockBigTitleNavigation_Fragment | BlockHiddenWithConsentWithoutChildrenEntryPoint_BlockHiddenWithConsent_Fragment | BlockHiddenWithConsentWithoutChildrenEntryPoint_BlockAccordion_Fragment | BlockHiddenWithConsentWithoutChildrenEntryPoint_BlockOneColumn_Fragment | BlockHiddenWithConsentWithoutChildrenEntryPoint_BlockAnalystRating_Fragment | BlockHiddenWithConsentWithoutChildrenEntryPoint_BlockCallToActionButton_Fragment | BlockHiddenWithConsentWithoutChildrenEntryPoint_BlockTwoColumn_Fragment | BlockHiddenWithConsentWithoutChildrenEntryPoint_BlockAccordionEntry_Fragment | BlockHiddenWithConsentWithoutChildrenEntryPoint_NewsArticle_Fragment | BlockHiddenWithConsentWithoutChildrenEntryPoint_BlockRichText_Fragment | BlockHiddenWithConsentWithoutChildrenEntryPoint_LexiconArticle_Fragment | BlockHiddenWithConsentWithoutChildrenEntryPoint_ProjectPage_Fragment | BlockHiddenWithConsentWithoutChildrenEntryPoint_BarChartWithBackground_Fragment | BlockHiddenWithConsentWithoutChildrenEntryPoint_BlockCustom_Fragment | BlockHiddenWithConsentWithoutChildrenEntryPoint_BlockFullsizeImage_Fragment | BlockHiddenWithConsentWithoutChildrenEntryPoint_BlockHighlightRealEstate_Fragment | BlockHiddenWithConsentWithoutChildrenEntryPoint_HighlightedRealEstate_Fragment | BlockHiddenWithConsentWithoutChildrenEntryPoint_BlockPartnerGrid_Fragment | BlockHiddenWithConsentWithoutChildrenEntryPoint_Partner_Fragment | BlockHiddenWithConsentWithoutChildrenEntryPoint_BlockPersonAccordion_Fragment | BlockHiddenWithConsentWithoutChildrenEntryPoint_PersonAccordionEntry_Fragment | BlockHiddenWithConsentWithoutChildrenEntryPoint_BlockRibbon_Fragment | BlockHiddenWithConsentWithoutChildrenEntryPoint_BlockTable_Fragment | BlockHiddenWithConsentWithoutChildrenEntryPoint_BlockThreeColumn_Fragment | BlockHiddenWithConsentWithoutChildrenEntryPoint_BlockVideo_Fragment | BlockHiddenWithConsentWithoutChildrenEntryPoint_NewsArticleContact_Fragment | BlockHiddenWithConsentWithoutChildrenEntryPoint_BlockSpeechBubble_Fragment | BlockHiddenWithConsentWithoutChildrenEntryPoint_LatestDownload_Fragment | BlockHiddenWithConsentWithoutChildrenEntryPoint_NavigationEntry_Fragment | BlockHiddenWithConsentWithoutChildrenEntryPoint_BlockLinkSection_Fragment | BlockHiddenWithConsentWithoutChildrenEntryPoint_LinkSectionEntry_Fragment | BlockHiddenWithConsentWithoutChildrenEntryPoint_BlockStockPrice_Fragment | BlockHiddenWithConsentWithoutChildrenEntryPoint_BlockImageGallery_Fragment | BlockHiddenWithConsentWithoutChildrenEntryPoint_BlockSlider_Fragment | BlockHiddenWithConsentWithoutChildrenEntryPoint_BlockSliderEntry_Fragment | BlockHiddenWithConsentWithoutChildrenEntryPoint_BlockTextCloud_Fragment | BlockHiddenWithConsentWithoutChildrenEntryPoint_Seo_Fragment | BlockHiddenWithConsentWithoutChildrenEntryPoint_RegionDescriptionText_Fragment | BlockHiddenWithConsentWithoutChildrenEntryPoint_ProjectLink_Fragment | BlockHiddenWithConsentWithoutChildrenEntryPoint_BlockProjectLinkSection_Fragment | BlockHiddenWithConsentWithoutChildrenEntryPoint_ProjectImageMap_Fragment | BlockHiddenWithConsentWithoutChildrenEntryPoint_DownloadableFile_Fragment | BlockHiddenWithConsentWithoutChildrenEntryPoint_Footer_Fragment;

export type GetBlockHighlightRealEstateByIdQueryVariables = Exact<{
  locale?: Maybe<Scalars['String']>;
  preview?: Maybe<Scalars['Boolean']>;
  id: Scalars['String'];
}>;


export type GetBlockHighlightRealEstateByIdQuery = (
  { __typename?: 'Query' }
  & { entryCollection?: Maybe<(
    { __typename?: 'EntryCollection' }
    & { items: Array<Maybe<(
      { __typename?: 'HeroImage' }
      & BlockHighlightRealEstateEntryPoint_HeroImage_Fragment
    ) | (
      { __typename?: 'StaticPage' }
      & BlockHighlightRealEstateEntryPoint_StaticPage_Fragment
    ) | (
      { __typename?: 'NavBarEntry' }
      & BlockHighlightRealEstateEntryPoint_NavBarEntry_Fragment
    ) | (
      { __typename?: 'BlockSubNavigation' }
      & BlockHighlightRealEstateEntryPoint_BlockSubNavigation_Fragment
    ) | (
      { __typename?: 'BlockBigTitleNavigation' }
      & BlockHighlightRealEstateEntryPoint_BlockBigTitleNavigation_Fragment
    ) | (
      { __typename?: 'BlockHiddenWithConsent' }
      & BlockHighlightRealEstateEntryPoint_BlockHiddenWithConsent_Fragment
    ) | (
      { __typename?: 'BlockAccordion' }
      & BlockHighlightRealEstateEntryPoint_BlockAccordion_Fragment
    ) | (
      { __typename?: 'BlockOneColumn' }
      & BlockHighlightRealEstateEntryPoint_BlockOneColumn_Fragment
    ) | (
      { __typename?: 'BlockAnalystRating' }
      & BlockHighlightRealEstateEntryPoint_BlockAnalystRating_Fragment
    ) | (
      { __typename?: 'BlockCallToActionButton' }
      & BlockHighlightRealEstateEntryPoint_BlockCallToActionButton_Fragment
    ) | (
      { __typename?: 'BlockTwoColumn' }
      & BlockHighlightRealEstateEntryPoint_BlockTwoColumn_Fragment
    ) | (
      { __typename?: 'BlockAccordionEntry' }
      & BlockHighlightRealEstateEntryPoint_BlockAccordionEntry_Fragment
    ) | (
      { __typename?: 'NewsArticle' }
      & BlockHighlightRealEstateEntryPoint_NewsArticle_Fragment
    ) | (
      { __typename?: 'BlockRichText' }
      & BlockHighlightRealEstateEntryPoint_BlockRichText_Fragment
    ) | (
      { __typename?: 'LexiconArticle' }
      & BlockHighlightRealEstateEntryPoint_LexiconArticle_Fragment
    ) | (
      { __typename?: 'ProjectPage' }
      & BlockHighlightRealEstateEntryPoint_ProjectPage_Fragment
    ) | (
      { __typename?: 'BarChartWithBackground' }
      & BlockHighlightRealEstateEntryPoint_BarChartWithBackground_Fragment
    ) | (
      { __typename?: 'BlockCustom' }
      & BlockHighlightRealEstateEntryPoint_BlockCustom_Fragment
    ) | (
      { __typename?: 'BlockFullsizeImage' }
      & BlockHighlightRealEstateEntryPoint_BlockFullsizeImage_Fragment
    ) | (
      { __typename?: 'BlockHighlightRealEstate' }
      & BlockHighlightRealEstateEntryPoint_BlockHighlightRealEstate_Fragment
    ) | (
      { __typename?: 'HighlightedRealEstate' }
      & BlockHighlightRealEstateEntryPoint_HighlightedRealEstate_Fragment
    ) | (
      { __typename?: 'BlockPartnerGrid' }
      & BlockHighlightRealEstateEntryPoint_BlockPartnerGrid_Fragment
    ) | (
      { __typename?: 'Partner' }
      & BlockHighlightRealEstateEntryPoint_Partner_Fragment
    ) | (
      { __typename?: 'BlockPersonAccordion' }
      & BlockHighlightRealEstateEntryPoint_BlockPersonAccordion_Fragment
    ) | (
      { __typename?: 'PersonAccordionEntry' }
      & BlockHighlightRealEstateEntryPoint_PersonAccordionEntry_Fragment
    ) | (
      { __typename?: 'BlockRibbon' }
      & BlockHighlightRealEstateEntryPoint_BlockRibbon_Fragment
    ) | (
      { __typename?: 'BlockTable' }
      & BlockHighlightRealEstateEntryPoint_BlockTable_Fragment
    ) | (
      { __typename?: 'BlockThreeColumn' }
      & BlockHighlightRealEstateEntryPoint_BlockThreeColumn_Fragment
    ) | (
      { __typename?: 'BlockVideo' }
      & BlockHighlightRealEstateEntryPoint_BlockVideo_Fragment
    ) | (
      { __typename?: 'NewsArticleContact' }
      & BlockHighlightRealEstateEntryPoint_NewsArticleContact_Fragment
    ) | (
      { __typename?: 'BlockSpeechBubble' }
      & BlockHighlightRealEstateEntryPoint_BlockSpeechBubble_Fragment
    ) | (
      { __typename?: 'LatestDownload' }
      & BlockHighlightRealEstateEntryPoint_LatestDownload_Fragment
    ) | (
      { __typename?: 'NavigationEntry' }
      & BlockHighlightRealEstateEntryPoint_NavigationEntry_Fragment
    ) | (
      { __typename?: 'BlockLinkSection' }
      & BlockHighlightRealEstateEntryPoint_BlockLinkSection_Fragment
    ) | (
      { __typename?: 'LinkSectionEntry' }
      & BlockHighlightRealEstateEntryPoint_LinkSectionEntry_Fragment
    ) | (
      { __typename?: 'BlockStockPrice' }
      & BlockHighlightRealEstateEntryPoint_BlockStockPrice_Fragment
    ) | (
      { __typename?: 'BlockImageGallery' }
      & BlockHighlightRealEstateEntryPoint_BlockImageGallery_Fragment
    ) | (
      { __typename?: 'BlockSlider' }
      & BlockHighlightRealEstateEntryPoint_BlockSlider_Fragment
    ) | (
      { __typename?: 'BlockSliderEntry' }
      & BlockHighlightRealEstateEntryPoint_BlockSliderEntry_Fragment
    ) | (
      { __typename?: 'BlockTextCloud' }
      & BlockHighlightRealEstateEntryPoint_BlockTextCloud_Fragment
    ) | (
      { __typename?: 'Seo' }
      & BlockHighlightRealEstateEntryPoint_Seo_Fragment
    ) | (
      { __typename?: 'RegionDescriptionText' }
      & BlockHighlightRealEstateEntryPoint_RegionDescriptionText_Fragment
    ) | (
      { __typename?: 'ProjectLink' }
      & BlockHighlightRealEstateEntryPoint_ProjectLink_Fragment
    ) | (
      { __typename?: 'BlockProjectLinkSection' }
      & BlockHighlightRealEstateEntryPoint_BlockProjectLinkSection_Fragment
    ) | (
      { __typename?: 'ProjectImageMap' }
      & BlockHighlightRealEstateEntryPoint_ProjectImageMap_Fragment
    ) | (
      { __typename?: 'DownloadableFile' }
      & BlockHighlightRealEstateEntryPoint_DownloadableFile_Fragment
    ) | (
      { __typename?: 'Footer' }
      & BlockHighlightRealEstateEntryPoint_Footer_Fragment
    )>> }
  )> }
);

type BlockHighlightRealEstateEntryPoint_HeroImage_Fragment = (
  { __typename?: 'HeroImage' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type BlockHighlightRealEstateEntryPoint_StaticPage_Fragment = (
  { __typename?: 'StaticPage' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type BlockHighlightRealEstateEntryPoint_NavBarEntry_Fragment = (
  { __typename?: 'NavBarEntry' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type BlockHighlightRealEstateEntryPoint_BlockSubNavigation_Fragment = (
  { __typename?: 'BlockSubNavigation' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type BlockHighlightRealEstateEntryPoint_BlockBigTitleNavigation_Fragment = (
  { __typename?: 'BlockBigTitleNavigation' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type BlockHighlightRealEstateEntryPoint_BlockHiddenWithConsent_Fragment = (
  { __typename?: 'BlockHiddenWithConsent' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type BlockHighlightRealEstateEntryPoint_BlockAccordion_Fragment = (
  { __typename?: 'BlockAccordion' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type BlockHighlightRealEstateEntryPoint_BlockOneColumn_Fragment = (
  { __typename?: 'BlockOneColumn' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type BlockHighlightRealEstateEntryPoint_BlockAnalystRating_Fragment = (
  { __typename?: 'BlockAnalystRating' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type BlockHighlightRealEstateEntryPoint_BlockCallToActionButton_Fragment = (
  { __typename?: 'BlockCallToActionButton' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type BlockHighlightRealEstateEntryPoint_BlockTwoColumn_Fragment = (
  { __typename?: 'BlockTwoColumn' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type BlockHighlightRealEstateEntryPoint_BlockAccordionEntry_Fragment = (
  { __typename?: 'BlockAccordionEntry' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type BlockHighlightRealEstateEntryPoint_NewsArticle_Fragment = (
  { __typename?: 'NewsArticle' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type BlockHighlightRealEstateEntryPoint_BlockRichText_Fragment = (
  { __typename?: 'BlockRichText' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type BlockHighlightRealEstateEntryPoint_LexiconArticle_Fragment = (
  { __typename?: 'LexiconArticle' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type BlockHighlightRealEstateEntryPoint_ProjectPage_Fragment = (
  { __typename?: 'ProjectPage' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type BlockHighlightRealEstateEntryPoint_BarChartWithBackground_Fragment = (
  { __typename?: 'BarChartWithBackground' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type BlockHighlightRealEstateEntryPoint_BlockCustom_Fragment = (
  { __typename?: 'BlockCustom' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type BlockHighlightRealEstateEntryPoint_BlockFullsizeImage_Fragment = (
  { __typename?: 'BlockFullsizeImage' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type BlockHighlightRealEstateEntryPoint_BlockHighlightRealEstate_Fragment = (
  { __typename?: 'BlockHighlightRealEstate' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
  & BlockHighlightRealEstateFragment
);

type BlockHighlightRealEstateEntryPoint_HighlightedRealEstate_Fragment = (
  { __typename?: 'HighlightedRealEstate' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type BlockHighlightRealEstateEntryPoint_BlockPartnerGrid_Fragment = (
  { __typename?: 'BlockPartnerGrid' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type BlockHighlightRealEstateEntryPoint_Partner_Fragment = (
  { __typename?: 'Partner' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type BlockHighlightRealEstateEntryPoint_BlockPersonAccordion_Fragment = (
  { __typename?: 'BlockPersonAccordion' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type BlockHighlightRealEstateEntryPoint_PersonAccordionEntry_Fragment = (
  { __typename?: 'PersonAccordionEntry' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type BlockHighlightRealEstateEntryPoint_BlockRibbon_Fragment = (
  { __typename?: 'BlockRibbon' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type BlockHighlightRealEstateEntryPoint_BlockTable_Fragment = (
  { __typename?: 'BlockTable' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type BlockHighlightRealEstateEntryPoint_BlockThreeColumn_Fragment = (
  { __typename?: 'BlockThreeColumn' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type BlockHighlightRealEstateEntryPoint_BlockVideo_Fragment = (
  { __typename?: 'BlockVideo' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type BlockHighlightRealEstateEntryPoint_NewsArticleContact_Fragment = (
  { __typename?: 'NewsArticleContact' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type BlockHighlightRealEstateEntryPoint_BlockSpeechBubble_Fragment = (
  { __typename?: 'BlockSpeechBubble' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type BlockHighlightRealEstateEntryPoint_LatestDownload_Fragment = (
  { __typename?: 'LatestDownload' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type BlockHighlightRealEstateEntryPoint_NavigationEntry_Fragment = (
  { __typename?: 'NavigationEntry' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type BlockHighlightRealEstateEntryPoint_BlockLinkSection_Fragment = (
  { __typename?: 'BlockLinkSection' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type BlockHighlightRealEstateEntryPoint_LinkSectionEntry_Fragment = (
  { __typename?: 'LinkSectionEntry' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type BlockHighlightRealEstateEntryPoint_BlockStockPrice_Fragment = (
  { __typename?: 'BlockStockPrice' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type BlockHighlightRealEstateEntryPoint_BlockImageGallery_Fragment = (
  { __typename?: 'BlockImageGallery' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type BlockHighlightRealEstateEntryPoint_BlockSlider_Fragment = (
  { __typename?: 'BlockSlider' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type BlockHighlightRealEstateEntryPoint_BlockSliderEntry_Fragment = (
  { __typename?: 'BlockSliderEntry' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type BlockHighlightRealEstateEntryPoint_BlockTextCloud_Fragment = (
  { __typename?: 'BlockTextCloud' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type BlockHighlightRealEstateEntryPoint_Seo_Fragment = (
  { __typename?: 'Seo' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type BlockHighlightRealEstateEntryPoint_RegionDescriptionText_Fragment = (
  { __typename?: 'RegionDescriptionText' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type BlockHighlightRealEstateEntryPoint_ProjectLink_Fragment = (
  { __typename?: 'ProjectLink' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type BlockHighlightRealEstateEntryPoint_BlockProjectLinkSection_Fragment = (
  { __typename?: 'BlockProjectLinkSection' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type BlockHighlightRealEstateEntryPoint_ProjectImageMap_Fragment = (
  { __typename?: 'ProjectImageMap' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type BlockHighlightRealEstateEntryPoint_DownloadableFile_Fragment = (
  { __typename?: 'DownloadableFile' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type BlockHighlightRealEstateEntryPoint_Footer_Fragment = (
  { __typename?: 'Footer' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

export type BlockHighlightRealEstateEntryPointFragment = BlockHighlightRealEstateEntryPoint_HeroImage_Fragment | BlockHighlightRealEstateEntryPoint_StaticPage_Fragment | BlockHighlightRealEstateEntryPoint_NavBarEntry_Fragment | BlockHighlightRealEstateEntryPoint_BlockSubNavigation_Fragment | BlockHighlightRealEstateEntryPoint_BlockBigTitleNavigation_Fragment | BlockHighlightRealEstateEntryPoint_BlockHiddenWithConsent_Fragment | BlockHighlightRealEstateEntryPoint_BlockAccordion_Fragment | BlockHighlightRealEstateEntryPoint_BlockOneColumn_Fragment | BlockHighlightRealEstateEntryPoint_BlockAnalystRating_Fragment | BlockHighlightRealEstateEntryPoint_BlockCallToActionButton_Fragment | BlockHighlightRealEstateEntryPoint_BlockTwoColumn_Fragment | BlockHighlightRealEstateEntryPoint_BlockAccordionEntry_Fragment | BlockHighlightRealEstateEntryPoint_NewsArticle_Fragment | BlockHighlightRealEstateEntryPoint_BlockRichText_Fragment | BlockHighlightRealEstateEntryPoint_LexiconArticle_Fragment | BlockHighlightRealEstateEntryPoint_ProjectPage_Fragment | BlockHighlightRealEstateEntryPoint_BarChartWithBackground_Fragment | BlockHighlightRealEstateEntryPoint_BlockCustom_Fragment | BlockHighlightRealEstateEntryPoint_BlockFullsizeImage_Fragment | BlockHighlightRealEstateEntryPoint_BlockHighlightRealEstate_Fragment | BlockHighlightRealEstateEntryPoint_HighlightedRealEstate_Fragment | BlockHighlightRealEstateEntryPoint_BlockPartnerGrid_Fragment | BlockHighlightRealEstateEntryPoint_Partner_Fragment | BlockHighlightRealEstateEntryPoint_BlockPersonAccordion_Fragment | BlockHighlightRealEstateEntryPoint_PersonAccordionEntry_Fragment | BlockHighlightRealEstateEntryPoint_BlockRibbon_Fragment | BlockHighlightRealEstateEntryPoint_BlockTable_Fragment | BlockHighlightRealEstateEntryPoint_BlockThreeColumn_Fragment | BlockHighlightRealEstateEntryPoint_BlockVideo_Fragment | BlockHighlightRealEstateEntryPoint_NewsArticleContact_Fragment | BlockHighlightRealEstateEntryPoint_BlockSpeechBubble_Fragment | BlockHighlightRealEstateEntryPoint_LatestDownload_Fragment | BlockHighlightRealEstateEntryPoint_NavigationEntry_Fragment | BlockHighlightRealEstateEntryPoint_BlockLinkSection_Fragment | BlockHighlightRealEstateEntryPoint_LinkSectionEntry_Fragment | BlockHighlightRealEstateEntryPoint_BlockStockPrice_Fragment | BlockHighlightRealEstateEntryPoint_BlockImageGallery_Fragment | BlockHighlightRealEstateEntryPoint_BlockSlider_Fragment | BlockHighlightRealEstateEntryPoint_BlockSliderEntry_Fragment | BlockHighlightRealEstateEntryPoint_BlockTextCloud_Fragment | BlockHighlightRealEstateEntryPoint_Seo_Fragment | BlockHighlightRealEstateEntryPoint_RegionDescriptionText_Fragment | BlockHighlightRealEstateEntryPoint_ProjectLink_Fragment | BlockHighlightRealEstateEntryPoint_BlockProjectLinkSection_Fragment | BlockHighlightRealEstateEntryPoint_ProjectImageMap_Fragment | BlockHighlightRealEstateEntryPoint_DownloadableFile_Fragment | BlockHighlightRealEstateEntryPoint_Footer_Fragment;

export type GetBlockImageGalleryByIdQueryVariables = Exact<{
  locale?: Maybe<Scalars['String']>;
  preview?: Maybe<Scalars['Boolean']>;
  id: Scalars['String'];
}>;


export type GetBlockImageGalleryByIdQuery = (
  { __typename?: 'Query' }
  & { entryCollection?: Maybe<(
    { __typename?: 'EntryCollection' }
    & { items: Array<Maybe<(
      { __typename?: 'HeroImage' }
      & BlockImageGalleryEntryPoint_HeroImage_Fragment
    ) | (
      { __typename?: 'StaticPage' }
      & BlockImageGalleryEntryPoint_StaticPage_Fragment
    ) | (
      { __typename?: 'NavBarEntry' }
      & BlockImageGalleryEntryPoint_NavBarEntry_Fragment
    ) | (
      { __typename?: 'BlockSubNavigation' }
      & BlockImageGalleryEntryPoint_BlockSubNavigation_Fragment
    ) | (
      { __typename?: 'BlockBigTitleNavigation' }
      & BlockImageGalleryEntryPoint_BlockBigTitleNavigation_Fragment
    ) | (
      { __typename?: 'BlockHiddenWithConsent' }
      & BlockImageGalleryEntryPoint_BlockHiddenWithConsent_Fragment
    ) | (
      { __typename?: 'BlockAccordion' }
      & BlockImageGalleryEntryPoint_BlockAccordion_Fragment
    ) | (
      { __typename?: 'BlockOneColumn' }
      & BlockImageGalleryEntryPoint_BlockOneColumn_Fragment
    ) | (
      { __typename?: 'BlockAnalystRating' }
      & BlockImageGalleryEntryPoint_BlockAnalystRating_Fragment
    ) | (
      { __typename?: 'BlockCallToActionButton' }
      & BlockImageGalleryEntryPoint_BlockCallToActionButton_Fragment
    ) | (
      { __typename?: 'BlockTwoColumn' }
      & BlockImageGalleryEntryPoint_BlockTwoColumn_Fragment
    ) | (
      { __typename?: 'BlockAccordionEntry' }
      & BlockImageGalleryEntryPoint_BlockAccordionEntry_Fragment
    ) | (
      { __typename?: 'NewsArticle' }
      & BlockImageGalleryEntryPoint_NewsArticle_Fragment
    ) | (
      { __typename?: 'BlockRichText' }
      & BlockImageGalleryEntryPoint_BlockRichText_Fragment
    ) | (
      { __typename?: 'LexiconArticle' }
      & BlockImageGalleryEntryPoint_LexiconArticle_Fragment
    ) | (
      { __typename?: 'ProjectPage' }
      & BlockImageGalleryEntryPoint_ProjectPage_Fragment
    ) | (
      { __typename?: 'BarChartWithBackground' }
      & BlockImageGalleryEntryPoint_BarChartWithBackground_Fragment
    ) | (
      { __typename?: 'BlockCustom' }
      & BlockImageGalleryEntryPoint_BlockCustom_Fragment
    ) | (
      { __typename?: 'BlockFullsizeImage' }
      & BlockImageGalleryEntryPoint_BlockFullsizeImage_Fragment
    ) | (
      { __typename?: 'BlockHighlightRealEstate' }
      & BlockImageGalleryEntryPoint_BlockHighlightRealEstate_Fragment
    ) | (
      { __typename?: 'HighlightedRealEstate' }
      & BlockImageGalleryEntryPoint_HighlightedRealEstate_Fragment
    ) | (
      { __typename?: 'BlockPartnerGrid' }
      & BlockImageGalleryEntryPoint_BlockPartnerGrid_Fragment
    ) | (
      { __typename?: 'Partner' }
      & BlockImageGalleryEntryPoint_Partner_Fragment
    ) | (
      { __typename?: 'BlockPersonAccordion' }
      & BlockImageGalleryEntryPoint_BlockPersonAccordion_Fragment
    ) | (
      { __typename?: 'PersonAccordionEntry' }
      & BlockImageGalleryEntryPoint_PersonAccordionEntry_Fragment
    ) | (
      { __typename?: 'BlockRibbon' }
      & BlockImageGalleryEntryPoint_BlockRibbon_Fragment
    ) | (
      { __typename?: 'BlockTable' }
      & BlockImageGalleryEntryPoint_BlockTable_Fragment
    ) | (
      { __typename?: 'BlockThreeColumn' }
      & BlockImageGalleryEntryPoint_BlockThreeColumn_Fragment
    ) | (
      { __typename?: 'BlockVideo' }
      & BlockImageGalleryEntryPoint_BlockVideo_Fragment
    ) | (
      { __typename?: 'NewsArticleContact' }
      & BlockImageGalleryEntryPoint_NewsArticleContact_Fragment
    ) | (
      { __typename?: 'BlockSpeechBubble' }
      & BlockImageGalleryEntryPoint_BlockSpeechBubble_Fragment
    ) | (
      { __typename?: 'LatestDownload' }
      & BlockImageGalleryEntryPoint_LatestDownload_Fragment
    ) | (
      { __typename?: 'NavigationEntry' }
      & BlockImageGalleryEntryPoint_NavigationEntry_Fragment
    ) | (
      { __typename?: 'BlockLinkSection' }
      & BlockImageGalleryEntryPoint_BlockLinkSection_Fragment
    ) | (
      { __typename?: 'LinkSectionEntry' }
      & BlockImageGalleryEntryPoint_LinkSectionEntry_Fragment
    ) | (
      { __typename?: 'BlockStockPrice' }
      & BlockImageGalleryEntryPoint_BlockStockPrice_Fragment
    ) | (
      { __typename?: 'BlockImageGallery' }
      & BlockImageGalleryEntryPoint_BlockImageGallery_Fragment
    ) | (
      { __typename?: 'BlockSlider' }
      & BlockImageGalleryEntryPoint_BlockSlider_Fragment
    ) | (
      { __typename?: 'BlockSliderEntry' }
      & BlockImageGalleryEntryPoint_BlockSliderEntry_Fragment
    ) | (
      { __typename?: 'BlockTextCloud' }
      & BlockImageGalleryEntryPoint_BlockTextCloud_Fragment
    ) | (
      { __typename?: 'Seo' }
      & BlockImageGalleryEntryPoint_Seo_Fragment
    ) | (
      { __typename?: 'RegionDescriptionText' }
      & BlockImageGalleryEntryPoint_RegionDescriptionText_Fragment
    ) | (
      { __typename?: 'ProjectLink' }
      & BlockImageGalleryEntryPoint_ProjectLink_Fragment
    ) | (
      { __typename?: 'BlockProjectLinkSection' }
      & BlockImageGalleryEntryPoint_BlockProjectLinkSection_Fragment
    ) | (
      { __typename?: 'ProjectImageMap' }
      & BlockImageGalleryEntryPoint_ProjectImageMap_Fragment
    ) | (
      { __typename?: 'DownloadableFile' }
      & BlockImageGalleryEntryPoint_DownloadableFile_Fragment
    ) | (
      { __typename?: 'Footer' }
      & BlockImageGalleryEntryPoint_Footer_Fragment
    )>> }
  )> }
);

type BlockImageGalleryEntryPoint_HeroImage_Fragment = (
  { __typename?: 'HeroImage' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type BlockImageGalleryEntryPoint_StaticPage_Fragment = (
  { __typename?: 'StaticPage' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type BlockImageGalleryEntryPoint_NavBarEntry_Fragment = (
  { __typename?: 'NavBarEntry' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type BlockImageGalleryEntryPoint_BlockSubNavigation_Fragment = (
  { __typename?: 'BlockSubNavigation' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type BlockImageGalleryEntryPoint_BlockBigTitleNavigation_Fragment = (
  { __typename?: 'BlockBigTitleNavigation' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type BlockImageGalleryEntryPoint_BlockHiddenWithConsent_Fragment = (
  { __typename?: 'BlockHiddenWithConsent' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type BlockImageGalleryEntryPoint_BlockAccordion_Fragment = (
  { __typename?: 'BlockAccordion' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type BlockImageGalleryEntryPoint_BlockOneColumn_Fragment = (
  { __typename?: 'BlockOneColumn' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type BlockImageGalleryEntryPoint_BlockAnalystRating_Fragment = (
  { __typename?: 'BlockAnalystRating' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type BlockImageGalleryEntryPoint_BlockCallToActionButton_Fragment = (
  { __typename?: 'BlockCallToActionButton' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type BlockImageGalleryEntryPoint_BlockTwoColumn_Fragment = (
  { __typename?: 'BlockTwoColumn' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type BlockImageGalleryEntryPoint_BlockAccordionEntry_Fragment = (
  { __typename?: 'BlockAccordionEntry' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type BlockImageGalleryEntryPoint_NewsArticle_Fragment = (
  { __typename?: 'NewsArticle' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type BlockImageGalleryEntryPoint_BlockRichText_Fragment = (
  { __typename?: 'BlockRichText' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type BlockImageGalleryEntryPoint_LexiconArticle_Fragment = (
  { __typename?: 'LexiconArticle' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type BlockImageGalleryEntryPoint_ProjectPage_Fragment = (
  { __typename?: 'ProjectPage' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type BlockImageGalleryEntryPoint_BarChartWithBackground_Fragment = (
  { __typename?: 'BarChartWithBackground' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type BlockImageGalleryEntryPoint_BlockCustom_Fragment = (
  { __typename?: 'BlockCustom' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type BlockImageGalleryEntryPoint_BlockFullsizeImage_Fragment = (
  { __typename?: 'BlockFullsizeImage' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type BlockImageGalleryEntryPoint_BlockHighlightRealEstate_Fragment = (
  { __typename?: 'BlockHighlightRealEstate' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type BlockImageGalleryEntryPoint_HighlightedRealEstate_Fragment = (
  { __typename?: 'HighlightedRealEstate' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type BlockImageGalleryEntryPoint_BlockPartnerGrid_Fragment = (
  { __typename?: 'BlockPartnerGrid' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type BlockImageGalleryEntryPoint_Partner_Fragment = (
  { __typename?: 'Partner' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type BlockImageGalleryEntryPoint_BlockPersonAccordion_Fragment = (
  { __typename?: 'BlockPersonAccordion' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type BlockImageGalleryEntryPoint_PersonAccordionEntry_Fragment = (
  { __typename?: 'PersonAccordionEntry' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type BlockImageGalleryEntryPoint_BlockRibbon_Fragment = (
  { __typename?: 'BlockRibbon' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type BlockImageGalleryEntryPoint_BlockTable_Fragment = (
  { __typename?: 'BlockTable' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type BlockImageGalleryEntryPoint_BlockThreeColumn_Fragment = (
  { __typename?: 'BlockThreeColumn' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type BlockImageGalleryEntryPoint_BlockVideo_Fragment = (
  { __typename?: 'BlockVideo' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type BlockImageGalleryEntryPoint_NewsArticleContact_Fragment = (
  { __typename?: 'NewsArticleContact' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type BlockImageGalleryEntryPoint_BlockSpeechBubble_Fragment = (
  { __typename?: 'BlockSpeechBubble' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type BlockImageGalleryEntryPoint_LatestDownload_Fragment = (
  { __typename?: 'LatestDownload' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type BlockImageGalleryEntryPoint_NavigationEntry_Fragment = (
  { __typename?: 'NavigationEntry' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type BlockImageGalleryEntryPoint_BlockLinkSection_Fragment = (
  { __typename?: 'BlockLinkSection' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type BlockImageGalleryEntryPoint_LinkSectionEntry_Fragment = (
  { __typename?: 'LinkSectionEntry' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type BlockImageGalleryEntryPoint_BlockStockPrice_Fragment = (
  { __typename?: 'BlockStockPrice' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type BlockImageGalleryEntryPoint_BlockImageGallery_Fragment = (
  { __typename?: 'BlockImageGallery' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
  & BlockImageGalleryFragment
);

type BlockImageGalleryEntryPoint_BlockSlider_Fragment = (
  { __typename?: 'BlockSlider' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type BlockImageGalleryEntryPoint_BlockSliderEntry_Fragment = (
  { __typename?: 'BlockSliderEntry' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type BlockImageGalleryEntryPoint_BlockTextCloud_Fragment = (
  { __typename?: 'BlockTextCloud' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type BlockImageGalleryEntryPoint_Seo_Fragment = (
  { __typename?: 'Seo' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type BlockImageGalleryEntryPoint_RegionDescriptionText_Fragment = (
  { __typename?: 'RegionDescriptionText' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type BlockImageGalleryEntryPoint_ProjectLink_Fragment = (
  { __typename?: 'ProjectLink' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type BlockImageGalleryEntryPoint_BlockProjectLinkSection_Fragment = (
  { __typename?: 'BlockProjectLinkSection' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type BlockImageGalleryEntryPoint_ProjectImageMap_Fragment = (
  { __typename?: 'ProjectImageMap' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type BlockImageGalleryEntryPoint_DownloadableFile_Fragment = (
  { __typename?: 'DownloadableFile' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type BlockImageGalleryEntryPoint_Footer_Fragment = (
  { __typename?: 'Footer' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

export type BlockImageGalleryEntryPointFragment = BlockImageGalleryEntryPoint_HeroImage_Fragment | BlockImageGalleryEntryPoint_StaticPage_Fragment | BlockImageGalleryEntryPoint_NavBarEntry_Fragment | BlockImageGalleryEntryPoint_BlockSubNavigation_Fragment | BlockImageGalleryEntryPoint_BlockBigTitleNavigation_Fragment | BlockImageGalleryEntryPoint_BlockHiddenWithConsent_Fragment | BlockImageGalleryEntryPoint_BlockAccordion_Fragment | BlockImageGalleryEntryPoint_BlockOneColumn_Fragment | BlockImageGalleryEntryPoint_BlockAnalystRating_Fragment | BlockImageGalleryEntryPoint_BlockCallToActionButton_Fragment | BlockImageGalleryEntryPoint_BlockTwoColumn_Fragment | BlockImageGalleryEntryPoint_BlockAccordionEntry_Fragment | BlockImageGalleryEntryPoint_NewsArticle_Fragment | BlockImageGalleryEntryPoint_BlockRichText_Fragment | BlockImageGalleryEntryPoint_LexiconArticle_Fragment | BlockImageGalleryEntryPoint_ProjectPage_Fragment | BlockImageGalleryEntryPoint_BarChartWithBackground_Fragment | BlockImageGalleryEntryPoint_BlockCustom_Fragment | BlockImageGalleryEntryPoint_BlockFullsizeImage_Fragment | BlockImageGalleryEntryPoint_BlockHighlightRealEstate_Fragment | BlockImageGalleryEntryPoint_HighlightedRealEstate_Fragment | BlockImageGalleryEntryPoint_BlockPartnerGrid_Fragment | BlockImageGalleryEntryPoint_Partner_Fragment | BlockImageGalleryEntryPoint_BlockPersonAccordion_Fragment | BlockImageGalleryEntryPoint_PersonAccordionEntry_Fragment | BlockImageGalleryEntryPoint_BlockRibbon_Fragment | BlockImageGalleryEntryPoint_BlockTable_Fragment | BlockImageGalleryEntryPoint_BlockThreeColumn_Fragment | BlockImageGalleryEntryPoint_BlockVideo_Fragment | BlockImageGalleryEntryPoint_NewsArticleContact_Fragment | BlockImageGalleryEntryPoint_BlockSpeechBubble_Fragment | BlockImageGalleryEntryPoint_LatestDownload_Fragment | BlockImageGalleryEntryPoint_NavigationEntry_Fragment | BlockImageGalleryEntryPoint_BlockLinkSection_Fragment | BlockImageGalleryEntryPoint_LinkSectionEntry_Fragment | BlockImageGalleryEntryPoint_BlockStockPrice_Fragment | BlockImageGalleryEntryPoint_BlockImageGallery_Fragment | BlockImageGalleryEntryPoint_BlockSlider_Fragment | BlockImageGalleryEntryPoint_BlockSliderEntry_Fragment | BlockImageGalleryEntryPoint_BlockTextCloud_Fragment | BlockImageGalleryEntryPoint_Seo_Fragment | BlockImageGalleryEntryPoint_RegionDescriptionText_Fragment | BlockImageGalleryEntryPoint_ProjectLink_Fragment | BlockImageGalleryEntryPoint_BlockProjectLinkSection_Fragment | BlockImageGalleryEntryPoint_ProjectImageMap_Fragment | BlockImageGalleryEntryPoint_DownloadableFile_Fragment | BlockImageGalleryEntryPoint_Footer_Fragment;

export type GetBlockLinkSectionByIdQueryVariables = Exact<{
  locale?: Maybe<Scalars['String']>;
  preview?: Maybe<Scalars['Boolean']>;
  id: Scalars['String'];
}>;


export type GetBlockLinkSectionByIdQuery = (
  { __typename?: 'Query' }
  & { entryCollection?: Maybe<(
    { __typename?: 'EntryCollection' }
    & { items: Array<Maybe<(
      { __typename?: 'HeroImage' }
      & BlockLinkSectionEntryPoint_HeroImage_Fragment
    ) | (
      { __typename?: 'StaticPage' }
      & BlockLinkSectionEntryPoint_StaticPage_Fragment
    ) | (
      { __typename?: 'NavBarEntry' }
      & BlockLinkSectionEntryPoint_NavBarEntry_Fragment
    ) | (
      { __typename?: 'BlockSubNavigation' }
      & BlockLinkSectionEntryPoint_BlockSubNavigation_Fragment
    ) | (
      { __typename?: 'BlockBigTitleNavigation' }
      & BlockLinkSectionEntryPoint_BlockBigTitleNavigation_Fragment
    ) | (
      { __typename?: 'BlockHiddenWithConsent' }
      & BlockLinkSectionEntryPoint_BlockHiddenWithConsent_Fragment
    ) | (
      { __typename?: 'BlockAccordion' }
      & BlockLinkSectionEntryPoint_BlockAccordion_Fragment
    ) | (
      { __typename?: 'BlockOneColumn' }
      & BlockLinkSectionEntryPoint_BlockOneColumn_Fragment
    ) | (
      { __typename?: 'BlockAnalystRating' }
      & BlockLinkSectionEntryPoint_BlockAnalystRating_Fragment
    ) | (
      { __typename?: 'BlockCallToActionButton' }
      & BlockLinkSectionEntryPoint_BlockCallToActionButton_Fragment
    ) | (
      { __typename?: 'BlockTwoColumn' }
      & BlockLinkSectionEntryPoint_BlockTwoColumn_Fragment
    ) | (
      { __typename?: 'BlockAccordionEntry' }
      & BlockLinkSectionEntryPoint_BlockAccordionEntry_Fragment
    ) | (
      { __typename?: 'NewsArticle' }
      & BlockLinkSectionEntryPoint_NewsArticle_Fragment
    ) | (
      { __typename?: 'BlockRichText' }
      & BlockLinkSectionEntryPoint_BlockRichText_Fragment
    ) | (
      { __typename?: 'LexiconArticle' }
      & BlockLinkSectionEntryPoint_LexiconArticle_Fragment
    ) | (
      { __typename?: 'ProjectPage' }
      & BlockLinkSectionEntryPoint_ProjectPage_Fragment
    ) | (
      { __typename?: 'BarChartWithBackground' }
      & BlockLinkSectionEntryPoint_BarChartWithBackground_Fragment
    ) | (
      { __typename?: 'BlockCustom' }
      & BlockLinkSectionEntryPoint_BlockCustom_Fragment
    ) | (
      { __typename?: 'BlockFullsizeImage' }
      & BlockLinkSectionEntryPoint_BlockFullsizeImage_Fragment
    ) | (
      { __typename?: 'BlockHighlightRealEstate' }
      & BlockLinkSectionEntryPoint_BlockHighlightRealEstate_Fragment
    ) | (
      { __typename?: 'HighlightedRealEstate' }
      & BlockLinkSectionEntryPoint_HighlightedRealEstate_Fragment
    ) | (
      { __typename?: 'BlockPartnerGrid' }
      & BlockLinkSectionEntryPoint_BlockPartnerGrid_Fragment
    ) | (
      { __typename?: 'Partner' }
      & BlockLinkSectionEntryPoint_Partner_Fragment
    ) | (
      { __typename?: 'BlockPersonAccordion' }
      & BlockLinkSectionEntryPoint_BlockPersonAccordion_Fragment
    ) | (
      { __typename?: 'PersonAccordionEntry' }
      & BlockLinkSectionEntryPoint_PersonAccordionEntry_Fragment
    ) | (
      { __typename?: 'BlockRibbon' }
      & BlockLinkSectionEntryPoint_BlockRibbon_Fragment
    ) | (
      { __typename?: 'BlockTable' }
      & BlockLinkSectionEntryPoint_BlockTable_Fragment
    ) | (
      { __typename?: 'BlockThreeColumn' }
      & BlockLinkSectionEntryPoint_BlockThreeColumn_Fragment
    ) | (
      { __typename?: 'BlockVideo' }
      & BlockLinkSectionEntryPoint_BlockVideo_Fragment
    ) | (
      { __typename?: 'NewsArticleContact' }
      & BlockLinkSectionEntryPoint_NewsArticleContact_Fragment
    ) | (
      { __typename?: 'BlockSpeechBubble' }
      & BlockLinkSectionEntryPoint_BlockSpeechBubble_Fragment
    ) | (
      { __typename?: 'LatestDownload' }
      & BlockLinkSectionEntryPoint_LatestDownload_Fragment
    ) | (
      { __typename?: 'NavigationEntry' }
      & BlockLinkSectionEntryPoint_NavigationEntry_Fragment
    ) | (
      { __typename?: 'BlockLinkSection' }
      & BlockLinkSectionEntryPoint_BlockLinkSection_Fragment
    ) | (
      { __typename?: 'LinkSectionEntry' }
      & BlockLinkSectionEntryPoint_LinkSectionEntry_Fragment
    ) | (
      { __typename?: 'BlockStockPrice' }
      & BlockLinkSectionEntryPoint_BlockStockPrice_Fragment
    ) | (
      { __typename?: 'BlockImageGallery' }
      & BlockLinkSectionEntryPoint_BlockImageGallery_Fragment
    ) | (
      { __typename?: 'BlockSlider' }
      & BlockLinkSectionEntryPoint_BlockSlider_Fragment
    ) | (
      { __typename?: 'BlockSliderEntry' }
      & BlockLinkSectionEntryPoint_BlockSliderEntry_Fragment
    ) | (
      { __typename?: 'BlockTextCloud' }
      & BlockLinkSectionEntryPoint_BlockTextCloud_Fragment
    ) | (
      { __typename?: 'Seo' }
      & BlockLinkSectionEntryPoint_Seo_Fragment
    ) | (
      { __typename?: 'RegionDescriptionText' }
      & BlockLinkSectionEntryPoint_RegionDescriptionText_Fragment
    ) | (
      { __typename?: 'ProjectLink' }
      & BlockLinkSectionEntryPoint_ProjectLink_Fragment
    ) | (
      { __typename?: 'BlockProjectLinkSection' }
      & BlockLinkSectionEntryPoint_BlockProjectLinkSection_Fragment
    ) | (
      { __typename?: 'ProjectImageMap' }
      & BlockLinkSectionEntryPoint_ProjectImageMap_Fragment
    ) | (
      { __typename?: 'DownloadableFile' }
      & BlockLinkSectionEntryPoint_DownloadableFile_Fragment
    ) | (
      { __typename?: 'Footer' }
      & BlockLinkSectionEntryPoint_Footer_Fragment
    )>> }
  )> }
);

type BlockLinkSectionEntryPoint_HeroImage_Fragment = (
  { __typename?: 'HeroImage' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type BlockLinkSectionEntryPoint_StaticPage_Fragment = (
  { __typename?: 'StaticPage' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type BlockLinkSectionEntryPoint_NavBarEntry_Fragment = (
  { __typename?: 'NavBarEntry' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type BlockLinkSectionEntryPoint_BlockSubNavigation_Fragment = (
  { __typename?: 'BlockSubNavigation' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type BlockLinkSectionEntryPoint_BlockBigTitleNavigation_Fragment = (
  { __typename?: 'BlockBigTitleNavigation' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type BlockLinkSectionEntryPoint_BlockHiddenWithConsent_Fragment = (
  { __typename?: 'BlockHiddenWithConsent' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type BlockLinkSectionEntryPoint_BlockAccordion_Fragment = (
  { __typename?: 'BlockAccordion' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type BlockLinkSectionEntryPoint_BlockOneColumn_Fragment = (
  { __typename?: 'BlockOneColumn' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type BlockLinkSectionEntryPoint_BlockAnalystRating_Fragment = (
  { __typename?: 'BlockAnalystRating' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type BlockLinkSectionEntryPoint_BlockCallToActionButton_Fragment = (
  { __typename?: 'BlockCallToActionButton' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type BlockLinkSectionEntryPoint_BlockTwoColumn_Fragment = (
  { __typename?: 'BlockTwoColumn' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type BlockLinkSectionEntryPoint_BlockAccordionEntry_Fragment = (
  { __typename?: 'BlockAccordionEntry' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type BlockLinkSectionEntryPoint_NewsArticle_Fragment = (
  { __typename?: 'NewsArticle' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type BlockLinkSectionEntryPoint_BlockRichText_Fragment = (
  { __typename?: 'BlockRichText' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type BlockLinkSectionEntryPoint_LexiconArticle_Fragment = (
  { __typename?: 'LexiconArticle' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type BlockLinkSectionEntryPoint_ProjectPage_Fragment = (
  { __typename?: 'ProjectPage' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type BlockLinkSectionEntryPoint_BarChartWithBackground_Fragment = (
  { __typename?: 'BarChartWithBackground' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type BlockLinkSectionEntryPoint_BlockCustom_Fragment = (
  { __typename?: 'BlockCustom' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type BlockLinkSectionEntryPoint_BlockFullsizeImage_Fragment = (
  { __typename?: 'BlockFullsizeImage' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type BlockLinkSectionEntryPoint_BlockHighlightRealEstate_Fragment = (
  { __typename?: 'BlockHighlightRealEstate' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type BlockLinkSectionEntryPoint_HighlightedRealEstate_Fragment = (
  { __typename?: 'HighlightedRealEstate' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type BlockLinkSectionEntryPoint_BlockPartnerGrid_Fragment = (
  { __typename?: 'BlockPartnerGrid' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type BlockLinkSectionEntryPoint_Partner_Fragment = (
  { __typename?: 'Partner' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type BlockLinkSectionEntryPoint_BlockPersonAccordion_Fragment = (
  { __typename?: 'BlockPersonAccordion' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type BlockLinkSectionEntryPoint_PersonAccordionEntry_Fragment = (
  { __typename?: 'PersonAccordionEntry' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type BlockLinkSectionEntryPoint_BlockRibbon_Fragment = (
  { __typename?: 'BlockRibbon' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type BlockLinkSectionEntryPoint_BlockTable_Fragment = (
  { __typename?: 'BlockTable' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type BlockLinkSectionEntryPoint_BlockThreeColumn_Fragment = (
  { __typename?: 'BlockThreeColumn' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type BlockLinkSectionEntryPoint_BlockVideo_Fragment = (
  { __typename?: 'BlockVideo' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type BlockLinkSectionEntryPoint_NewsArticleContact_Fragment = (
  { __typename?: 'NewsArticleContact' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type BlockLinkSectionEntryPoint_BlockSpeechBubble_Fragment = (
  { __typename?: 'BlockSpeechBubble' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type BlockLinkSectionEntryPoint_LatestDownload_Fragment = (
  { __typename?: 'LatestDownload' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type BlockLinkSectionEntryPoint_NavigationEntry_Fragment = (
  { __typename?: 'NavigationEntry' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type BlockLinkSectionEntryPoint_BlockLinkSection_Fragment = (
  { __typename?: 'BlockLinkSection' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
  & BlockLinkSectionFragment
);

type BlockLinkSectionEntryPoint_LinkSectionEntry_Fragment = (
  { __typename?: 'LinkSectionEntry' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type BlockLinkSectionEntryPoint_BlockStockPrice_Fragment = (
  { __typename?: 'BlockStockPrice' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type BlockLinkSectionEntryPoint_BlockImageGallery_Fragment = (
  { __typename?: 'BlockImageGallery' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type BlockLinkSectionEntryPoint_BlockSlider_Fragment = (
  { __typename?: 'BlockSlider' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type BlockLinkSectionEntryPoint_BlockSliderEntry_Fragment = (
  { __typename?: 'BlockSliderEntry' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type BlockLinkSectionEntryPoint_BlockTextCloud_Fragment = (
  { __typename?: 'BlockTextCloud' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type BlockLinkSectionEntryPoint_Seo_Fragment = (
  { __typename?: 'Seo' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type BlockLinkSectionEntryPoint_RegionDescriptionText_Fragment = (
  { __typename?: 'RegionDescriptionText' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type BlockLinkSectionEntryPoint_ProjectLink_Fragment = (
  { __typename?: 'ProjectLink' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type BlockLinkSectionEntryPoint_BlockProjectLinkSection_Fragment = (
  { __typename?: 'BlockProjectLinkSection' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type BlockLinkSectionEntryPoint_ProjectImageMap_Fragment = (
  { __typename?: 'ProjectImageMap' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type BlockLinkSectionEntryPoint_DownloadableFile_Fragment = (
  { __typename?: 'DownloadableFile' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type BlockLinkSectionEntryPoint_Footer_Fragment = (
  { __typename?: 'Footer' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

export type BlockLinkSectionEntryPointFragment = BlockLinkSectionEntryPoint_HeroImage_Fragment | BlockLinkSectionEntryPoint_StaticPage_Fragment | BlockLinkSectionEntryPoint_NavBarEntry_Fragment | BlockLinkSectionEntryPoint_BlockSubNavigation_Fragment | BlockLinkSectionEntryPoint_BlockBigTitleNavigation_Fragment | BlockLinkSectionEntryPoint_BlockHiddenWithConsent_Fragment | BlockLinkSectionEntryPoint_BlockAccordion_Fragment | BlockLinkSectionEntryPoint_BlockOneColumn_Fragment | BlockLinkSectionEntryPoint_BlockAnalystRating_Fragment | BlockLinkSectionEntryPoint_BlockCallToActionButton_Fragment | BlockLinkSectionEntryPoint_BlockTwoColumn_Fragment | BlockLinkSectionEntryPoint_BlockAccordionEntry_Fragment | BlockLinkSectionEntryPoint_NewsArticle_Fragment | BlockLinkSectionEntryPoint_BlockRichText_Fragment | BlockLinkSectionEntryPoint_LexiconArticle_Fragment | BlockLinkSectionEntryPoint_ProjectPage_Fragment | BlockLinkSectionEntryPoint_BarChartWithBackground_Fragment | BlockLinkSectionEntryPoint_BlockCustom_Fragment | BlockLinkSectionEntryPoint_BlockFullsizeImage_Fragment | BlockLinkSectionEntryPoint_BlockHighlightRealEstate_Fragment | BlockLinkSectionEntryPoint_HighlightedRealEstate_Fragment | BlockLinkSectionEntryPoint_BlockPartnerGrid_Fragment | BlockLinkSectionEntryPoint_Partner_Fragment | BlockLinkSectionEntryPoint_BlockPersonAccordion_Fragment | BlockLinkSectionEntryPoint_PersonAccordionEntry_Fragment | BlockLinkSectionEntryPoint_BlockRibbon_Fragment | BlockLinkSectionEntryPoint_BlockTable_Fragment | BlockLinkSectionEntryPoint_BlockThreeColumn_Fragment | BlockLinkSectionEntryPoint_BlockVideo_Fragment | BlockLinkSectionEntryPoint_NewsArticleContact_Fragment | BlockLinkSectionEntryPoint_BlockSpeechBubble_Fragment | BlockLinkSectionEntryPoint_LatestDownload_Fragment | BlockLinkSectionEntryPoint_NavigationEntry_Fragment | BlockLinkSectionEntryPoint_BlockLinkSection_Fragment | BlockLinkSectionEntryPoint_LinkSectionEntry_Fragment | BlockLinkSectionEntryPoint_BlockStockPrice_Fragment | BlockLinkSectionEntryPoint_BlockImageGallery_Fragment | BlockLinkSectionEntryPoint_BlockSlider_Fragment | BlockLinkSectionEntryPoint_BlockSliderEntry_Fragment | BlockLinkSectionEntryPoint_BlockTextCloud_Fragment | BlockLinkSectionEntryPoint_Seo_Fragment | BlockLinkSectionEntryPoint_RegionDescriptionText_Fragment | BlockLinkSectionEntryPoint_ProjectLink_Fragment | BlockLinkSectionEntryPoint_BlockProjectLinkSection_Fragment | BlockLinkSectionEntryPoint_ProjectImageMap_Fragment | BlockLinkSectionEntryPoint_DownloadableFile_Fragment | BlockLinkSectionEntryPoint_Footer_Fragment;

export type GetBlockPartnerGridByIdQueryVariables = Exact<{
  locale?: Maybe<Scalars['String']>;
  preview?: Maybe<Scalars['Boolean']>;
  id: Scalars['String'];
}>;


export type GetBlockPartnerGridByIdQuery = (
  { __typename?: 'Query' }
  & { entryCollection?: Maybe<(
    { __typename?: 'EntryCollection' }
    & { items: Array<Maybe<(
      { __typename?: 'HeroImage' }
      & BlockPartnerGridEntryPoint_HeroImage_Fragment
    ) | (
      { __typename?: 'StaticPage' }
      & BlockPartnerGridEntryPoint_StaticPage_Fragment
    ) | (
      { __typename?: 'NavBarEntry' }
      & BlockPartnerGridEntryPoint_NavBarEntry_Fragment
    ) | (
      { __typename?: 'BlockSubNavigation' }
      & BlockPartnerGridEntryPoint_BlockSubNavigation_Fragment
    ) | (
      { __typename?: 'BlockBigTitleNavigation' }
      & BlockPartnerGridEntryPoint_BlockBigTitleNavigation_Fragment
    ) | (
      { __typename?: 'BlockHiddenWithConsent' }
      & BlockPartnerGridEntryPoint_BlockHiddenWithConsent_Fragment
    ) | (
      { __typename?: 'BlockAccordion' }
      & BlockPartnerGridEntryPoint_BlockAccordion_Fragment
    ) | (
      { __typename?: 'BlockOneColumn' }
      & BlockPartnerGridEntryPoint_BlockOneColumn_Fragment
    ) | (
      { __typename?: 'BlockAnalystRating' }
      & BlockPartnerGridEntryPoint_BlockAnalystRating_Fragment
    ) | (
      { __typename?: 'BlockCallToActionButton' }
      & BlockPartnerGridEntryPoint_BlockCallToActionButton_Fragment
    ) | (
      { __typename?: 'BlockTwoColumn' }
      & BlockPartnerGridEntryPoint_BlockTwoColumn_Fragment
    ) | (
      { __typename?: 'BlockAccordionEntry' }
      & BlockPartnerGridEntryPoint_BlockAccordionEntry_Fragment
    ) | (
      { __typename?: 'NewsArticle' }
      & BlockPartnerGridEntryPoint_NewsArticle_Fragment
    ) | (
      { __typename?: 'BlockRichText' }
      & BlockPartnerGridEntryPoint_BlockRichText_Fragment
    ) | (
      { __typename?: 'LexiconArticle' }
      & BlockPartnerGridEntryPoint_LexiconArticle_Fragment
    ) | (
      { __typename?: 'ProjectPage' }
      & BlockPartnerGridEntryPoint_ProjectPage_Fragment
    ) | (
      { __typename?: 'BarChartWithBackground' }
      & BlockPartnerGridEntryPoint_BarChartWithBackground_Fragment
    ) | (
      { __typename?: 'BlockCustom' }
      & BlockPartnerGridEntryPoint_BlockCustom_Fragment
    ) | (
      { __typename?: 'BlockFullsizeImage' }
      & BlockPartnerGridEntryPoint_BlockFullsizeImage_Fragment
    ) | (
      { __typename?: 'BlockHighlightRealEstate' }
      & BlockPartnerGridEntryPoint_BlockHighlightRealEstate_Fragment
    ) | (
      { __typename?: 'HighlightedRealEstate' }
      & BlockPartnerGridEntryPoint_HighlightedRealEstate_Fragment
    ) | (
      { __typename?: 'BlockPartnerGrid' }
      & BlockPartnerGridEntryPoint_BlockPartnerGrid_Fragment
    ) | (
      { __typename?: 'Partner' }
      & BlockPartnerGridEntryPoint_Partner_Fragment
    ) | (
      { __typename?: 'BlockPersonAccordion' }
      & BlockPartnerGridEntryPoint_BlockPersonAccordion_Fragment
    ) | (
      { __typename?: 'PersonAccordionEntry' }
      & BlockPartnerGridEntryPoint_PersonAccordionEntry_Fragment
    ) | (
      { __typename?: 'BlockRibbon' }
      & BlockPartnerGridEntryPoint_BlockRibbon_Fragment
    ) | (
      { __typename?: 'BlockTable' }
      & BlockPartnerGridEntryPoint_BlockTable_Fragment
    ) | (
      { __typename?: 'BlockThreeColumn' }
      & BlockPartnerGridEntryPoint_BlockThreeColumn_Fragment
    ) | (
      { __typename?: 'BlockVideo' }
      & BlockPartnerGridEntryPoint_BlockVideo_Fragment
    ) | (
      { __typename?: 'NewsArticleContact' }
      & BlockPartnerGridEntryPoint_NewsArticleContact_Fragment
    ) | (
      { __typename?: 'BlockSpeechBubble' }
      & BlockPartnerGridEntryPoint_BlockSpeechBubble_Fragment
    ) | (
      { __typename?: 'LatestDownload' }
      & BlockPartnerGridEntryPoint_LatestDownload_Fragment
    ) | (
      { __typename?: 'NavigationEntry' }
      & BlockPartnerGridEntryPoint_NavigationEntry_Fragment
    ) | (
      { __typename?: 'BlockLinkSection' }
      & BlockPartnerGridEntryPoint_BlockLinkSection_Fragment
    ) | (
      { __typename?: 'LinkSectionEntry' }
      & BlockPartnerGridEntryPoint_LinkSectionEntry_Fragment
    ) | (
      { __typename?: 'BlockStockPrice' }
      & BlockPartnerGridEntryPoint_BlockStockPrice_Fragment
    ) | (
      { __typename?: 'BlockImageGallery' }
      & BlockPartnerGridEntryPoint_BlockImageGallery_Fragment
    ) | (
      { __typename?: 'BlockSlider' }
      & BlockPartnerGridEntryPoint_BlockSlider_Fragment
    ) | (
      { __typename?: 'BlockSliderEntry' }
      & BlockPartnerGridEntryPoint_BlockSliderEntry_Fragment
    ) | (
      { __typename?: 'BlockTextCloud' }
      & BlockPartnerGridEntryPoint_BlockTextCloud_Fragment
    ) | (
      { __typename?: 'Seo' }
      & BlockPartnerGridEntryPoint_Seo_Fragment
    ) | (
      { __typename?: 'RegionDescriptionText' }
      & BlockPartnerGridEntryPoint_RegionDescriptionText_Fragment
    ) | (
      { __typename?: 'ProjectLink' }
      & BlockPartnerGridEntryPoint_ProjectLink_Fragment
    ) | (
      { __typename?: 'BlockProjectLinkSection' }
      & BlockPartnerGridEntryPoint_BlockProjectLinkSection_Fragment
    ) | (
      { __typename?: 'ProjectImageMap' }
      & BlockPartnerGridEntryPoint_ProjectImageMap_Fragment
    ) | (
      { __typename?: 'DownloadableFile' }
      & BlockPartnerGridEntryPoint_DownloadableFile_Fragment
    ) | (
      { __typename?: 'Footer' }
      & BlockPartnerGridEntryPoint_Footer_Fragment
    )>> }
  )> }
);

type BlockPartnerGridEntryPoint_HeroImage_Fragment = (
  { __typename?: 'HeroImage' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type BlockPartnerGridEntryPoint_StaticPage_Fragment = (
  { __typename?: 'StaticPage' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type BlockPartnerGridEntryPoint_NavBarEntry_Fragment = (
  { __typename?: 'NavBarEntry' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type BlockPartnerGridEntryPoint_BlockSubNavigation_Fragment = (
  { __typename?: 'BlockSubNavigation' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type BlockPartnerGridEntryPoint_BlockBigTitleNavigation_Fragment = (
  { __typename?: 'BlockBigTitleNavigation' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type BlockPartnerGridEntryPoint_BlockHiddenWithConsent_Fragment = (
  { __typename?: 'BlockHiddenWithConsent' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type BlockPartnerGridEntryPoint_BlockAccordion_Fragment = (
  { __typename?: 'BlockAccordion' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type BlockPartnerGridEntryPoint_BlockOneColumn_Fragment = (
  { __typename?: 'BlockOneColumn' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type BlockPartnerGridEntryPoint_BlockAnalystRating_Fragment = (
  { __typename?: 'BlockAnalystRating' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type BlockPartnerGridEntryPoint_BlockCallToActionButton_Fragment = (
  { __typename?: 'BlockCallToActionButton' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type BlockPartnerGridEntryPoint_BlockTwoColumn_Fragment = (
  { __typename?: 'BlockTwoColumn' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type BlockPartnerGridEntryPoint_BlockAccordionEntry_Fragment = (
  { __typename?: 'BlockAccordionEntry' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type BlockPartnerGridEntryPoint_NewsArticle_Fragment = (
  { __typename?: 'NewsArticle' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type BlockPartnerGridEntryPoint_BlockRichText_Fragment = (
  { __typename?: 'BlockRichText' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type BlockPartnerGridEntryPoint_LexiconArticle_Fragment = (
  { __typename?: 'LexiconArticle' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type BlockPartnerGridEntryPoint_ProjectPage_Fragment = (
  { __typename?: 'ProjectPage' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type BlockPartnerGridEntryPoint_BarChartWithBackground_Fragment = (
  { __typename?: 'BarChartWithBackground' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type BlockPartnerGridEntryPoint_BlockCustom_Fragment = (
  { __typename?: 'BlockCustom' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type BlockPartnerGridEntryPoint_BlockFullsizeImage_Fragment = (
  { __typename?: 'BlockFullsizeImage' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type BlockPartnerGridEntryPoint_BlockHighlightRealEstate_Fragment = (
  { __typename?: 'BlockHighlightRealEstate' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type BlockPartnerGridEntryPoint_HighlightedRealEstate_Fragment = (
  { __typename?: 'HighlightedRealEstate' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type BlockPartnerGridEntryPoint_BlockPartnerGrid_Fragment = (
  { __typename?: 'BlockPartnerGrid' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
  & BlockPartnerGridFragment
);

type BlockPartnerGridEntryPoint_Partner_Fragment = (
  { __typename?: 'Partner' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type BlockPartnerGridEntryPoint_BlockPersonAccordion_Fragment = (
  { __typename?: 'BlockPersonAccordion' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type BlockPartnerGridEntryPoint_PersonAccordionEntry_Fragment = (
  { __typename?: 'PersonAccordionEntry' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type BlockPartnerGridEntryPoint_BlockRibbon_Fragment = (
  { __typename?: 'BlockRibbon' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type BlockPartnerGridEntryPoint_BlockTable_Fragment = (
  { __typename?: 'BlockTable' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type BlockPartnerGridEntryPoint_BlockThreeColumn_Fragment = (
  { __typename?: 'BlockThreeColumn' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type BlockPartnerGridEntryPoint_BlockVideo_Fragment = (
  { __typename?: 'BlockVideo' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type BlockPartnerGridEntryPoint_NewsArticleContact_Fragment = (
  { __typename?: 'NewsArticleContact' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type BlockPartnerGridEntryPoint_BlockSpeechBubble_Fragment = (
  { __typename?: 'BlockSpeechBubble' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type BlockPartnerGridEntryPoint_LatestDownload_Fragment = (
  { __typename?: 'LatestDownload' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type BlockPartnerGridEntryPoint_NavigationEntry_Fragment = (
  { __typename?: 'NavigationEntry' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type BlockPartnerGridEntryPoint_BlockLinkSection_Fragment = (
  { __typename?: 'BlockLinkSection' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type BlockPartnerGridEntryPoint_LinkSectionEntry_Fragment = (
  { __typename?: 'LinkSectionEntry' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type BlockPartnerGridEntryPoint_BlockStockPrice_Fragment = (
  { __typename?: 'BlockStockPrice' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type BlockPartnerGridEntryPoint_BlockImageGallery_Fragment = (
  { __typename?: 'BlockImageGallery' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type BlockPartnerGridEntryPoint_BlockSlider_Fragment = (
  { __typename?: 'BlockSlider' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type BlockPartnerGridEntryPoint_BlockSliderEntry_Fragment = (
  { __typename?: 'BlockSliderEntry' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type BlockPartnerGridEntryPoint_BlockTextCloud_Fragment = (
  { __typename?: 'BlockTextCloud' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type BlockPartnerGridEntryPoint_Seo_Fragment = (
  { __typename?: 'Seo' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type BlockPartnerGridEntryPoint_RegionDescriptionText_Fragment = (
  { __typename?: 'RegionDescriptionText' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type BlockPartnerGridEntryPoint_ProjectLink_Fragment = (
  { __typename?: 'ProjectLink' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type BlockPartnerGridEntryPoint_BlockProjectLinkSection_Fragment = (
  { __typename?: 'BlockProjectLinkSection' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type BlockPartnerGridEntryPoint_ProjectImageMap_Fragment = (
  { __typename?: 'ProjectImageMap' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type BlockPartnerGridEntryPoint_DownloadableFile_Fragment = (
  { __typename?: 'DownloadableFile' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type BlockPartnerGridEntryPoint_Footer_Fragment = (
  { __typename?: 'Footer' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

export type BlockPartnerGridEntryPointFragment = BlockPartnerGridEntryPoint_HeroImage_Fragment | BlockPartnerGridEntryPoint_StaticPage_Fragment | BlockPartnerGridEntryPoint_NavBarEntry_Fragment | BlockPartnerGridEntryPoint_BlockSubNavigation_Fragment | BlockPartnerGridEntryPoint_BlockBigTitleNavigation_Fragment | BlockPartnerGridEntryPoint_BlockHiddenWithConsent_Fragment | BlockPartnerGridEntryPoint_BlockAccordion_Fragment | BlockPartnerGridEntryPoint_BlockOneColumn_Fragment | BlockPartnerGridEntryPoint_BlockAnalystRating_Fragment | BlockPartnerGridEntryPoint_BlockCallToActionButton_Fragment | BlockPartnerGridEntryPoint_BlockTwoColumn_Fragment | BlockPartnerGridEntryPoint_BlockAccordionEntry_Fragment | BlockPartnerGridEntryPoint_NewsArticle_Fragment | BlockPartnerGridEntryPoint_BlockRichText_Fragment | BlockPartnerGridEntryPoint_LexiconArticle_Fragment | BlockPartnerGridEntryPoint_ProjectPage_Fragment | BlockPartnerGridEntryPoint_BarChartWithBackground_Fragment | BlockPartnerGridEntryPoint_BlockCustom_Fragment | BlockPartnerGridEntryPoint_BlockFullsizeImage_Fragment | BlockPartnerGridEntryPoint_BlockHighlightRealEstate_Fragment | BlockPartnerGridEntryPoint_HighlightedRealEstate_Fragment | BlockPartnerGridEntryPoint_BlockPartnerGrid_Fragment | BlockPartnerGridEntryPoint_Partner_Fragment | BlockPartnerGridEntryPoint_BlockPersonAccordion_Fragment | BlockPartnerGridEntryPoint_PersonAccordionEntry_Fragment | BlockPartnerGridEntryPoint_BlockRibbon_Fragment | BlockPartnerGridEntryPoint_BlockTable_Fragment | BlockPartnerGridEntryPoint_BlockThreeColumn_Fragment | BlockPartnerGridEntryPoint_BlockVideo_Fragment | BlockPartnerGridEntryPoint_NewsArticleContact_Fragment | BlockPartnerGridEntryPoint_BlockSpeechBubble_Fragment | BlockPartnerGridEntryPoint_LatestDownload_Fragment | BlockPartnerGridEntryPoint_NavigationEntry_Fragment | BlockPartnerGridEntryPoint_BlockLinkSection_Fragment | BlockPartnerGridEntryPoint_LinkSectionEntry_Fragment | BlockPartnerGridEntryPoint_BlockStockPrice_Fragment | BlockPartnerGridEntryPoint_BlockImageGallery_Fragment | BlockPartnerGridEntryPoint_BlockSlider_Fragment | BlockPartnerGridEntryPoint_BlockSliderEntry_Fragment | BlockPartnerGridEntryPoint_BlockTextCloud_Fragment | BlockPartnerGridEntryPoint_Seo_Fragment | BlockPartnerGridEntryPoint_RegionDescriptionText_Fragment | BlockPartnerGridEntryPoint_ProjectLink_Fragment | BlockPartnerGridEntryPoint_BlockProjectLinkSection_Fragment | BlockPartnerGridEntryPoint_ProjectImageMap_Fragment | BlockPartnerGridEntryPoint_DownloadableFile_Fragment | BlockPartnerGridEntryPoint_Footer_Fragment;

export type GetBlockSliderByIdQueryVariables = Exact<{
  locale?: Maybe<Scalars['String']>;
  preview?: Maybe<Scalars['Boolean']>;
  id: Scalars['String'];
}>;


export type GetBlockSliderByIdQuery = (
  { __typename?: 'Query' }
  & { entryCollection?: Maybe<(
    { __typename?: 'EntryCollection' }
    & { items: Array<Maybe<(
      { __typename?: 'HeroImage' }
      & BlockSliderEntryPoint_HeroImage_Fragment
    ) | (
      { __typename?: 'StaticPage' }
      & BlockSliderEntryPoint_StaticPage_Fragment
    ) | (
      { __typename?: 'NavBarEntry' }
      & BlockSliderEntryPoint_NavBarEntry_Fragment
    ) | (
      { __typename?: 'BlockSubNavigation' }
      & BlockSliderEntryPoint_BlockSubNavigation_Fragment
    ) | (
      { __typename?: 'BlockBigTitleNavigation' }
      & BlockSliderEntryPoint_BlockBigTitleNavigation_Fragment
    ) | (
      { __typename?: 'BlockHiddenWithConsent' }
      & BlockSliderEntryPoint_BlockHiddenWithConsent_Fragment
    ) | (
      { __typename?: 'BlockAccordion' }
      & BlockSliderEntryPoint_BlockAccordion_Fragment
    ) | (
      { __typename?: 'BlockOneColumn' }
      & BlockSliderEntryPoint_BlockOneColumn_Fragment
    ) | (
      { __typename?: 'BlockAnalystRating' }
      & BlockSliderEntryPoint_BlockAnalystRating_Fragment
    ) | (
      { __typename?: 'BlockCallToActionButton' }
      & BlockSliderEntryPoint_BlockCallToActionButton_Fragment
    ) | (
      { __typename?: 'BlockTwoColumn' }
      & BlockSliderEntryPoint_BlockTwoColumn_Fragment
    ) | (
      { __typename?: 'BlockAccordionEntry' }
      & BlockSliderEntryPoint_BlockAccordionEntry_Fragment
    ) | (
      { __typename?: 'NewsArticle' }
      & BlockSliderEntryPoint_NewsArticle_Fragment
    ) | (
      { __typename?: 'BlockRichText' }
      & BlockSliderEntryPoint_BlockRichText_Fragment
    ) | (
      { __typename?: 'LexiconArticle' }
      & BlockSliderEntryPoint_LexiconArticle_Fragment
    ) | (
      { __typename?: 'ProjectPage' }
      & BlockSliderEntryPoint_ProjectPage_Fragment
    ) | (
      { __typename?: 'BarChartWithBackground' }
      & BlockSliderEntryPoint_BarChartWithBackground_Fragment
    ) | (
      { __typename?: 'BlockCustom' }
      & BlockSliderEntryPoint_BlockCustom_Fragment
    ) | (
      { __typename?: 'BlockFullsizeImage' }
      & BlockSliderEntryPoint_BlockFullsizeImage_Fragment
    ) | (
      { __typename?: 'BlockHighlightRealEstate' }
      & BlockSliderEntryPoint_BlockHighlightRealEstate_Fragment
    ) | (
      { __typename?: 'HighlightedRealEstate' }
      & BlockSliderEntryPoint_HighlightedRealEstate_Fragment
    ) | (
      { __typename?: 'BlockPartnerGrid' }
      & BlockSliderEntryPoint_BlockPartnerGrid_Fragment
    ) | (
      { __typename?: 'Partner' }
      & BlockSliderEntryPoint_Partner_Fragment
    ) | (
      { __typename?: 'BlockPersonAccordion' }
      & BlockSliderEntryPoint_BlockPersonAccordion_Fragment
    ) | (
      { __typename?: 'PersonAccordionEntry' }
      & BlockSliderEntryPoint_PersonAccordionEntry_Fragment
    ) | (
      { __typename?: 'BlockRibbon' }
      & BlockSliderEntryPoint_BlockRibbon_Fragment
    ) | (
      { __typename?: 'BlockTable' }
      & BlockSliderEntryPoint_BlockTable_Fragment
    ) | (
      { __typename?: 'BlockThreeColumn' }
      & BlockSliderEntryPoint_BlockThreeColumn_Fragment
    ) | (
      { __typename?: 'BlockVideo' }
      & BlockSliderEntryPoint_BlockVideo_Fragment
    ) | (
      { __typename?: 'NewsArticleContact' }
      & BlockSliderEntryPoint_NewsArticleContact_Fragment
    ) | (
      { __typename?: 'BlockSpeechBubble' }
      & BlockSliderEntryPoint_BlockSpeechBubble_Fragment
    ) | (
      { __typename?: 'LatestDownload' }
      & BlockSliderEntryPoint_LatestDownload_Fragment
    ) | (
      { __typename?: 'NavigationEntry' }
      & BlockSliderEntryPoint_NavigationEntry_Fragment
    ) | (
      { __typename?: 'BlockLinkSection' }
      & BlockSliderEntryPoint_BlockLinkSection_Fragment
    ) | (
      { __typename?: 'LinkSectionEntry' }
      & BlockSliderEntryPoint_LinkSectionEntry_Fragment
    ) | (
      { __typename?: 'BlockStockPrice' }
      & BlockSliderEntryPoint_BlockStockPrice_Fragment
    ) | (
      { __typename?: 'BlockImageGallery' }
      & BlockSliderEntryPoint_BlockImageGallery_Fragment
    ) | (
      { __typename?: 'BlockSlider' }
      & BlockSliderEntryPoint_BlockSlider_Fragment
    ) | (
      { __typename?: 'BlockSliderEntry' }
      & BlockSliderEntryPoint_BlockSliderEntry_Fragment
    ) | (
      { __typename?: 'BlockTextCloud' }
      & BlockSliderEntryPoint_BlockTextCloud_Fragment
    ) | (
      { __typename?: 'Seo' }
      & BlockSliderEntryPoint_Seo_Fragment
    ) | (
      { __typename?: 'RegionDescriptionText' }
      & BlockSliderEntryPoint_RegionDescriptionText_Fragment
    ) | (
      { __typename?: 'ProjectLink' }
      & BlockSliderEntryPoint_ProjectLink_Fragment
    ) | (
      { __typename?: 'BlockProjectLinkSection' }
      & BlockSliderEntryPoint_BlockProjectLinkSection_Fragment
    ) | (
      { __typename?: 'ProjectImageMap' }
      & BlockSliderEntryPoint_ProjectImageMap_Fragment
    ) | (
      { __typename?: 'DownloadableFile' }
      & BlockSliderEntryPoint_DownloadableFile_Fragment
    ) | (
      { __typename?: 'Footer' }
      & BlockSliderEntryPoint_Footer_Fragment
    )>> }
  )> }
);

type BlockSliderEntryPoint_HeroImage_Fragment = (
  { __typename?: 'HeroImage' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type BlockSliderEntryPoint_StaticPage_Fragment = (
  { __typename?: 'StaticPage' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type BlockSliderEntryPoint_NavBarEntry_Fragment = (
  { __typename?: 'NavBarEntry' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type BlockSliderEntryPoint_BlockSubNavigation_Fragment = (
  { __typename?: 'BlockSubNavigation' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type BlockSliderEntryPoint_BlockBigTitleNavigation_Fragment = (
  { __typename?: 'BlockBigTitleNavigation' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type BlockSliderEntryPoint_BlockHiddenWithConsent_Fragment = (
  { __typename?: 'BlockHiddenWithConsent' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type BlockSliderEntryPoint_BlockAccordion_Fragment = (
  { __typename?: 'BlockAccordion' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type BlockSliderEntryPoint_BlockOneColumn_Fragment = (
  { __typename?: 'BlockOneColumn' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type BlockSliderEntryPoint_BlockAnalystRating_Fragment = (
  { __typename?: 'BlockAnalystRating' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type BlockSliderEntryPoint_BlockCallToActionButton_Fragment = (
  { __typename?: 'BlockCallToActionButton' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type BlockSliderEntryPoint_BlockTwoColumn_Fragment = (
  { __typename?: 'BlockTwoColumn' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type BlockSliderEntryPoint_BlockAccordionEntry_Fragment = (
  { __typename?: 'BlockAccordionEntry' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type BlockSliderEntryPoint_NewsArticle_Fragment = (
  { __typename?: 'NewsArticle' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type BlockSliderEntryPoint_BlockRichText_Fragment = (
  { __typename?: 'BlockRichText' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type BlockSliderEntryPoint_LexiconArticle_Fragment = (
  { __typename?: 'LexiconArticle' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type BlockSliderEntryPoint_ProjectPage_Fragment = (
  { __typename?: 'ProjectPage' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type BlockSliderEntryPoint_BarChartWithBackground_Fragment = (
  { __typename?: 'BarChartWithBackground' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type BlockSliderEntryPoint_BlockCustom_Fragment = (
  { __typename?: 'BlockCustom' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type BlockSliderEntryPoint_BlockFullsizeImage_Fragment = (
  { __typename?: 'BlockFullsizeImage' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type BlockSliderEntryPoint_BlockHighlightRealEstate_Fragment = (
  { __typename?: 'BlockHighlightRealEstate' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type BlockSliderEntryPoint_HighlightedRealEstate_Fragment = (
  { __typename?: 'HighlightedRealEstate' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type BlockSliderEntryPoint_BlockPartnerGrid_Fragment = (
  { __typename?: 'BlockPartnerGrid' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type BlockSliderEntryPoint_Partner_Fragment = (
  { __typename?: 'Partner' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type BlockSliderEntryPoint_BlockPersonAccordion_Fragment = (
  { __typename?: 'BlockPersonAccordion' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type BlockSliderEntryPoint_PersonAccordionEntry_Fragment = (
  { __typename?: 'PersonAccordionEntry' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type BlockSliderEntryPoint_BlockRibbon_Fragment = (
  { __typename?: 'BlockRibbon' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type BlockSliderEntryPoint_BlockTable_Fragment = (
  { __typename?: 'BlockTable' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type BlockSliderEntryPoint_BlockThreeColumn_Fragment = (
  { __typename?: 'BlockThreeColumn' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type BlockSliderEntryPoint_BlockVideo_Fragment = (
  { __typename?: 'BlockVideo' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type BlockSliderEntryPoint_NewsArticleContact_Fragment = (
  { __typename?: 'NewsArticleContact' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type BlockSliderEntryPoint_BlockSpeechBubble_Fragment = (
  { __typename?: 'BlockSpeechBubble' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type BlockSliderEntryPoint_LatestDownload_Fragment = (
  { __typename?: 'LatestDownload' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type BlockSliderEntryPoint_NavigationEntry_Fragment = (
  { __typename?: 'NavigationEntry' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type BlockSliderEntryPoint_BlockLinkSection_Fragment = (
  { __typename?: 'BlockLinkSection' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type BlockSliderEntryPoint_LinkSectionEntry_Fragment = (
  { __typename?: 'LinkSectionEntry' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type BlockSliderEntryPoint_BlockStockPrice_Fragment = (
  { __typename?: 'BlockStockPrice' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type BlockSliderEntryPoint_BlockImageGallery_Fragment = (
  { __typename?: 'BlockImageGallery' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type BlockSliderEntryPoint_BlockSlider_Fragment = (
  { __typename?: 'BlockSlider' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
  & BlockSliderFragment
);

type BlockSliderEntryPoint_BlockSliderEntry_Fragment = (
  { __typename?: 'BlockSliderEntry' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type BlockSliderEntryPoint_BlockTextCloud_Fragment = (
  { __typename?: 'BlockTextCloud' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type BlockSliderEntryPoint_Seo_Fragment = (
  { __typename?: 'Seo' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type BlockSliderEntryPoint_RegionDescriptionText_Fragment = (
  { __typename?: 'RegionDescriptionText' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type BlockSliderEntryPoint_ProjectLink_Fragment = (
  { __typename?: 'ProjectLink' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type BlockSliderEntryPoint_BlockProjectLinkSection_Fragment = (
  { __typename?: 'BlockProjectLinkSection' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type BlockSliderEntryPoint_ProjectImageMap_Fragment = (
  { __typename?: 'ProjectImageMap' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type BlockSliderEntryPoint_DownloadableFile_Fragment = (
  { __typename?: 'DownloadableFile' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type BlockSliderEntryPoint_Footer_Fragment = (
  { __typename?: 'Footer' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

export type BlockSliderEntryPointFragment = BlockSliderEntryPoint_HeroImage_Fragment | BlockSliderEntryPoint_StaticPage_Fragment | BlockSliderEntryPoint_NavBarEntry_Fragment | BlockSliderEntryPoint_BlockSubNavigation_Fragment | BlockSliderEntryPoint_BlockBigTitleNavigation_Fragment | BlockSliderEntryPoint_BlockHiddenWithConsent_Fragment | BlockSliderEntryPoint_BlockAccordion_Fragment | BlockSliderEntryPoint_BlockOneColumn_Fragment | BlockSliderEntryPoint_BlockAnalystRating_Fragment | BlockSliderEntryPoint_BlockCallToActionButton_Fragment | BlockSliderEntryPoint_BlockTwoColumn_Fragment | BlockSliderEntryPoint_BlockAccordionEntry_Fragment | BlockSliderEntryPoint_NewsArticle_Fragment | BlockSliderEntryPoint_BlockRichText_Fragment | BlockSliderEntryPoint_LexiconArticle_Fragment | BlockSliderEntryPoint_ProjectPage_Fragment | BlockSliderEntryPoint_BarChartWithBackground_Fragment | BlockSliderEntryPoint_BlockCustom_Fragment | BlockSliderEntryPoint_BlockFullsizeImage_Fragment | BlockSliderEntryPoint_BlockHighlightRealEstate_Fragment | BlockSliderEntryPoint_HighlightedRealEstate_Fragment | BlockSliderEntryPoint_BlockPartnerGrid_Fragment | BlockSliderEntryPoint_Partner_Fragment | BlockSliderEntryPoint_BlockPersonAccordion_Fragment | BlockSliderEntryPoint_PersonAccordionEntry_Fragment | BlockSliderEntryPoint_BlockRibbon_Fragment | BlockSliderEntryPoint_BlockTable_Fragment | BlockSliderEntryPoint_BlockThreeColumn_Fragment | BlockSliderEntryPoint_BlockVideo_Fragment | BlockSliderEntryPoint_NewsArticleContact_Fragment | BlockSliderEntryPoint_BlockSpeechBubble_Fragment | BlockSliderEntryPoint_LatestDownload_Fragment | BlockSliderEntryPoint_NavigationEntry_Fragment | BlockSliderEntryPoint_BlockLinkSection_Fragment | BlockSliderEntryPoint_LinkSectionEntry_Fragment | BlockSliderEntryPoint_BlockStockPrice_Fragment | BlockSliderEntryPoint_BlockImageGallery_Fragment | BlockSliderEntryPoint_BlockSlider_Fragment | BlockSliderEntryPoint_BlockSliderEntry_Fragment | BlockSliderEntryPoint_BlockTextCloud_Fragment | BlockSliderEntryPoint_Seo_Fragment | BlockSliderEntryPoint_RegionDescriptionText_Fragment | BlockSliderEntryPoint_ProjectLink_Fragment | BlockSliderEntryPoint_BlockProjectLinkSection_Fragment | BlockSliderEntryPoint_ProjectImageMap_Fragment | BlockSliderEntryPoint_DownloadableFile_Fragment | BlockSliderEntryPoint_Footer_Fragment;

export type GetBlockSliderEntryByIdQueryVariables = Exact<{
  locale?: Maybe<Scalars['String']>;
  preview?: Maybe<Scalars['Boolean']>;
  id: Scalars['String'];
}>;


export type GetBlockSliderEntryByIdQuery = (
  { __typename?: 'Query' }
  & { entryCollection?: Maybe<(
    { __typename?: 'EntryCollection' }
    & { items: Array<Maybe<(
      { __typename?: 'HeroImage' }
      & BlockSliderEntryEntryPoint_HeroImage_Fragment
    ) | (
      { __typename?: 'StaticPage' }
      & BlockSliderEntryEntryPoint_StaticPage_Fragment
    ) | (
      { __typename?: 'NavBarEntry' }
      & BlockSliderEntryEntryPoint_NavBarEntry_Fragment
    ) | (
      { __typename?: 'BlockSubNavigation' }
      & BlockSliderEntryEntryPoint_BlockSubNavigation_Fragment
    ) | (
      { __typename?: 'BlockBigTitleNavigation' }
      & BlockSliderEntryEntryPoint_BlockBigTitleNavigation_Fragment
    ) | (
      { __typename?: 'BlockHiddenWithConsent' }
      & BlockSliderEntryEntryPoint_BlockHiddenWithConsent_Fragment
    ) | (
      { __typename?: 'BlockAccordion' }
      & BlockSliderEntryEntryPoint_BlockAccordion_Fragment
    ) | (
      { __typename?: 'BlockOneColumn' }
      & BlockSliderEntryEntryPoint_BlockOneColumn_Fragment
    ) | (
      { __typename?: 'BlockAnalystRating' }
      & BlockSliderEntryEntryPoint_BlockAnalystRating_Fragment
    ) | (
      { __typename?: 'BlockCallToActionButton' }
      & BlockSliderEntryEntryPoint_BlockCallToActionButton_Fragment
    ) | (
      { __typename?: 'BlockTwoColumn' }
      & BlockSliderEntryEntryPoint_BlockTwoColumn_Fragment
    ) | (
      { __typename?: 'BlockAccordionEntry' }
      & BlockSliderEntryEntryPoint_BlockAccordionEntry_Fragment
    ) | (
      { __typename?: 'NewsArticle' }
      & BlockSliderEntryEntryPoint_NewsArticle_Fragment
    ) | (
      { __typename?: 'BlockRichText' }
      & BlockSliderEntryEntryPoint_BlockRichText_Fragment
    ) | (
      { __typename?: 'LexiconArticle' }
      & BlockSliderEntryEntryPoint_LexiconArticle_Fragment
    ) | (
      { __typename?: 'ProjectPage' }
      & BlockSliderEntryEntryPoint_ProjectPage_Fragment
    ) | (
      { __typename?: 'BarChartWithBackground' }
      & BlockSliderEntryEntryPoint_BarChartWithBackground_Fragment
    ) | (
      { __typename?: 'BlockCustom' }
      & BlockSliderEntryEntryPoint_BlockCustom_Fragment
    ) | (
      { __typename?: 'BlockFullsizeImage' }
      & BlockSliderEntryEntryPoint_BlockFullsizeImage_Fragment
    ) | (
      { __typename?: 'BlockHighlightRealEstate' }
      & BlockSliderEntryEntryPoint_BlockHighlightRealEstate_Fragment
    ) | (
      { __typename?: 'HighlightedRealEstate' }
      & BlockSliderEntryEntryPoint_HighlightedRealEstate_Fragment
    ) | (
      { __typename?: 'BlockPartnerGrid' }
      & BlockSliderEntryEntryPoint_BlockPartnerGrid_Fragment
    ) | (
      { __typename?: 'Partner' }
      & BlockSliderEntryEntryPoint_Partner_Fragment
    ) | (
      { __typename?: 'BlockPersonAccordion' }
      & BlockSliderEntryEntryPoint_BlockPersonAccordion_Fragment
    ) | (
      { __typename?: 'PersonAccordionEntry' }
      & BlockSliderEntryEntryPoint_PersonAccordionEntry_Fragment
    ) | (
      { __typename?: 'BlockRibbon' }
      & BlockSliderEntryEntryPoint_BlockRibbon_Fragment
    ) | (
      { __typename?: 'BlockTable' }
      & BlockSliderEntryEntryPoint_BlockTable_Fragment
    ) | (
      { __typename?: 'BlockThreeColumn' }
      & BlockSliderEntryEntryPoint_BlockThreeColumn_Fragment
    ) | (
      { __typename?: 'BlockVideo' }
      & BlockSliderEntryEntryPoint_BlockVideo_Fragment
    ) | (
      { __typename?: 'NewsArticleContact' }
      & BlockSliderEntryEntryPoint_NewsArticleContact_Fragment
    ) | (
      { __typename?: 'BlockSpeechBubble' }
      & BlockSliderEntryEntryPoint_BlockSpeechBubble_Fragment
    ) | (
      { __typename?: 'LatestDownload' }
      & BlockSliderEntryEntryPoint_LatestDownload_Fragment
    ) | (
      { __typename?: 'NavigationEntry' }
      & BlockSliderEntryEntryPoint_NavigationEntry_Fragment
    ) | (
      { __typename?: 'BlockLinkSection' }
      & BlockSliderEntryEntryPoint_BlockLinkSection_Fragment
    ) | (
      { __typename?: 'LinkSectionEntry' }
      & BlockSliderEntryEntryPoint_LinkSectionEntry_Fragment
    ) | (
      { __typename?: 'BlockStockPrice' }
      & BlockSliderEntryEntryPoint_BlockStockPrice_Fragment
    ) | (
      { __typename?: 'BlockImageGallery' }
      & BlockSliderEntryEntryPoint_BlockImageGallery_Fragment
    ) | (
      { __typename?: 'BlockSlider' }
      & BlockSliderEntryEntryPoint_BlockSlider_Fragment
    ) | (
      { __typename?: 'BlockSliderEntry' }
      & BlockSliderEntryEntryPoint_BlockSliderEntry_Fragment
    ) | (
      { __typename?: 'BlockTextCloud' }
      & BlockSliderEntryEntryPoint_BlockTextCloud_Fragment
    ) | (
      { __typename?: 'Seo' }
      & BlockSliderEntryEntryPoint_Seo_Fragment
    ) | (
      { __typename?: 'RegionDescriptionText' }
      & BlockSliderEntryEntryPoint_RegionDescriptionText_Fragment
    ) | (
      { __typename?: 'ProjectLink' }
      & BlockSliderEntryEntryPoint_ProjectLink_Fragment
    ) | (
      { __typename?: 'BlockProjectLinkSection' }
      & BlockSliderEntryEntryPoint_BlockProjectLinkSection_Fragment
    ) | (
      { __typename?: 'ProjectImageMap' }
      & BlockSliderEntryEntryPoint_ProjectImageMap_Fragment
    ) | (
      { __typename?: 'DownloadableFile' }
      & BlockSliderEntryEntryPoint_DownloadableFile_Fragment
    ) | (
      { __typename?: 'Footer' }
      & BlockSliderEntryEntryPoint_Footer_Fragment
    )>> }
  )> }
);

type BlockSliderEntryEntryPoint_HeroImage_Fragment = (
  { __typename?: 'HeroImage' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type BlockSliderEntryEntryPoint_StaticPage_Fragment = (
  { __typename?: 'StaticPage' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type BlockSliderEntryEntryPoint_NavBarEntry_Fragment = (
  { __typename?: 'NavBarEntry' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type BlockSliderEntryEntryPoint_BlockSubNavigation_Fragment = (
  { __typename?: 'BlockSubNavigation' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type BlockSliderEntryEntryPoint_BlockBigTitleNavigation_Fragment = (
  { __typename?: 'BlockBigTitleNavigation' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type BlockSliderEntryEntryPoint_BlockHiddenWithConsent_Fragment = (
  { __typename?: 'BlockHiddenWithConsent' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type BlockSliderEntryEntryPoint_BlockAccordion_Fragment = (
  { __typename?: 'BlockAccordion' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type BlockSliderEntryEntryPoint_BlockOneColumn_Fragment = (
  { __typename?: 'BlockOneColumn' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type BlockSliderEntryEntryPoint_BlockAnalystRating_Fragment = (
  { __typename?: 'BlockAnalystRating' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type BlockSliderEntryEntryPoint_BlockCallToActionButton_Fragment = (
  { __typename?: 'BlockCallToActionButton' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type BlockSliderEntryEntryPoint_BlockTwoColumn_Fragment = (
  { __typename?: 'BlockTwoColumn' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type BlockSliderEntryEntryPoint_BlockAccordionEntry_Fragment = (
  { __typename?: 'BlockAccordionEntry' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type BlockSliderEntryEntryPoint_NewsArticle_Fragment = (
  { __typename?: 'NewsArticle' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type BlockSliderEntryEntryPoint_BlockRichText_Fragment = (
  { __typename?: 'BlockRichText' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type BlockSliderEntryEntryPoint_LexiconArticle_Fragment = (
  { __typename?: 'LexiconArticle' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type BlockSliderEntryEntryPoint_ProjectPage_Fragment = (
  { __typename?: 'ProjectPage' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type BlockSliderEntryEntryPoint_BarChartWithBackground_Fragment = (
  { __typename?: 'BarChartWithBackground' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type BlockSliderEntryEntryPoint_BlockCustom_Fragment = (
  { __typename?: 'BlockCustom' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type BlockSliderEntryEntryPoint_BlockFullsizeImage_Fragment = (
  { __typename?: 'BlockFullsizeImage' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type BlockSliderEntryEntryPoint_BlockHighlightRealEstate_Fragment = (
  { __typename?: 'BlockHighlightRealEstate' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type BlockSliderEntryEntryPoint_HighlightedRealEstate_Fragment = (
  { __typename?: 'HighlightedRealEstate' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type BlockSliderEntryEntryPoint_BlockPartnerGrid_Fragment = (
  { __typename?: 'BlockPartnerGrid' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type BlockSliderEntryEntryPoint_Partner_Fragment = (
  { __typename?: 'Partner' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type BlockSliderEntryEntryPoint_BlockPersonAccordion_Fragment = (
  { __typename?: 'BlockPersonAccordion' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type BlockSliderEntryEntryPoint_PersonAccordionEntry_Fragment = (
  { __typename?: 'PersonAccordionEntry' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type BlockSliderEntryEntryPoint_BlockRibbon_Fragment = (
  { __typename?: 'BlockRibbon' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type BlockSliderEntryEntryPoint_BlockTable_Fragment = (
  { __typename?: 'BlockTable' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type BlockSliderEntryEntryPoint_BlockThreeColumn_Fragment = (
  { __typename?: 'BlockThreeColumn' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type BlockSliderEntryEntryPoint_BlockVideo_Fragment = (
  { __typename?: 'BlockVideo' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type BlockSliderEntryEntryPoint_NewsArticleContact_Fragment = (
  { __typename?: 'NewsArticleContact' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type BlockSliderEntryEntryPoint_BlockSpeechBubble_Fragment = (
  { __typename?: 'BlockSpeechBubble' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type BlockSliderEntryEntryPoint_LatestDownload_Fragment = (
  { __typename?: 'LatestDownload' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type BlockSliderEntryEntryPoint_NavigationEntry_Fragment = (
  { __typename?: 'NavigationEntry' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type BlockSliderEntryEntryPoint_BlockLinkSection_Fragment = (
  { __typename?: 'BlockLinkSection' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type BlockSliderEntryEntryPoint_LinkSectionEntry_Fragment = (
  { __typename?: 'LinkSectionEntry' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type BlockSliderEntryEntryPoint_BlockStockPrice_Fragment = (
  { __typename?: 'BlockStockPrice' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type BlockSliderEntryEntryPoint_BlockImageGallery_Fragment = (
  { __typename?: 'BlockImageGallery' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type BlockSliderEntryEntryPoint_BlockSlider_Fragment = (
  { __typename?: 'BlockSlider' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type BlockSliderEntryEntryPoint_BlockSliderEntry_Fragment = (
  { __typename?: 'BlockSliderEntry' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
  & BlockSliderEntryFragment
);

type BlockSliderEntryEntryPoint_BlockTextCloud_Fragment = (
  { __typename?: 'BlockTextCloud' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type BlockSliderEntryEntryPoint_Seo_Fragment = (
  { __typename?: 'Seo' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type BlockSliderEntryEntryPoint_RegionDescriptionText_Fragment = (
  { __typename?: 'RegionDescriptionText' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type BlockSliderEntryEntryPoint_ProjectLink_Fragment = (
  { __typename?: 'ProjectLink' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type BlockSliderEntryEntryPoint_BlockProjectLinkSection_Fragment = (
  { __typename?: 'BlockProjectLinkSection' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type BlockSliderEntryEntryPoint_ProjectImageMap_Fragment = (
  { __typename?: 'ProjectImageMap' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type BlockSliderEntryEntryPoint_DownloadableFile_Fragment = (
  { __typename?: 'DownloadableFile' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type BlockSliderEntryEntryPoint_Footer_Fragment = (
  { __typename?: 'Footer' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

export type BlockSliderEntryEntryPointFragment = BlockSliderEntryEntryPoint_HeroImage_Fragment | BlockSliderEntryEntryPoint_StaticPage_Fragment | BlockSliderEntryEntryPoint_NavBarEntry_Fragment | BlockSliderEntryEntryPoint_BlockSubNavigation_Fragment | BlockSliderEntryEntryPoint_BlockBigTitleNavigation_Fragment | BlockSliderEntryEntryPoint_BlockHiddenWithConsent_Fragment | BlockSliderEntryEntryPoint_BlockAccordion_Fragment | BlockSliderEntryEntryPoint_BlockOneColumn_Fragment | BlockSliderEntryEntryPoint_BlockAnalystRating_Fragment | BlockSliderEntryEntryPoint_BlockCallToActionButton_Fragment | BlockSliderEntryEntryPoint_BlockTwoColumn_Fragment | BlockSliderEntryEntryPoint_BlockAccordionEntry_Fragment | BlockSliderEntryEntryPoint_NewsArticle_Fragment | BlockSliderEntryEntryPoint_BlockRichText_Fragment | BlockSliderEntryEntryPoint_LexiconArticle_Fragment | BlockSliderEntryEntryPoint_ProjectPage_Fragment | BlockSliderEntryEntryPoint_BarChartWithBackground_Fragment | BlockSliderEntryEntryPoint_BlockCustom_Fragment | BlockSliderEntryEntryPoint_BlockFullsizeImage_Fragment | BlockSliderEntryEntryPoint_BlockHighlightRealEstate_Fragment | BlockSliderEntryEntryPoint_HighlightedRealEstate_Fragment | BlockSliderEntryEntryPoint_BlockPartnerGrid_Fragment | BlockSliderEntryEntryPoint_Partner_Fragment | BlockSliderEntryEntryPoint_BlockPersonAccordion_Fragment | BlockSliderEntryEntryPoint_PersonAccordionEntry_Fragment | BlockSliderEntryEntryPoint_BlockRibbon_Fragment | BlockSliderEntryEntryPoint_BlockTable_Fragment | BlockSliderEntryEntryPoint_BlockThreeColumn_Fragment | BlockSliderEntryEntryPoint_BlockVideo_Fragment | BlockSliderEntryEntryPoint_NewsArticleContact_Fragment | BlockSliderEntryEntryPoint_BlockSpeechBubble_Fragment | BlockSliderEntryEntryPoint_LatestDownload_Fragment | BlockSliderEntryEntryPoint_NavigationEntry_Fragment | BlockSliderEntryEntryPoint_BlockLinkSection_Fragment | BlockSliderEntryEntryPoint_LinkSectionEntry_Fragment | BlockSliderEntryEntryPoint_BlockStockPrice_Fragment | BlockSliderEntryEntryPoint_BlockImageGallery_Fragment | BlockSliderEntryEntryPoint_BlockSlider_Fragment | BlockSliderEntryEntryPoint_BlockSliderEntry_Fragment | BlockSliderEntryEntryPoint_BlockTextCloud_Fragment | BlockSliderEntryEntryPoint_Seo_Fragment | BlockSliderEntryEntryPoint_RegionDescriptionText_Fragment | BlockSliderEntryEntryPoint_ProjectLink_Fragment | BlockSliderEntryEntryPoint_BlockProjectLinkSection_Fragment | BlockSliderEntryEntryPoint_ProjectImageMap_Fragment | BlockSliderEntryEntryPoint_DownloadableFile_Fragment | BlockSliderEntryEntryPoint_Footer_Fragment;

export type GetBlockSpeechBubbleByIdQueryVariables = Exact<{
  locale?: Maybe<Scalars['String']>;
  preview?: Maybe<Scalars['Boolean']>;
  id: Scalars['String'];
}>;


export type GetBlockSpeechBubbleByIdQuery = (
  { __typename?: 'Query' }
  & { entryCollection?: Maybe<(
    { __typename?: 'EntryCollection' }
    & { items: Array<Maybe<(
      { __typename?: 'HeroImage' }
      & BlockSpeechBubbleEntryPoint_HeroImage_Fragment
    ) | (
      { __typename?: 'StaticPage' }
      & BlockSpeechBubbleEntryPoint_StaticPage_Fragment
    ) | (
      { __typename?: 'NavBarEntry' }
      & BlockSpeechBubbleEntryPoint_NavBarEntry_Fragment
    ) | (
      { __typename?: 'BlockSubNavigation' }
      & BlockSpeechBubbleEntryPoint_BlockSubNavigation_Fragment
    ) | (
      { __typename?: 'BlockBigTitleNavigation' }
      & BlockSpeechBubbleEntryPoint_BlockBigTitleNavigation_Fragment
    ) | (
      { __typename?: 'BlockHiddenWithConsent' }
      & BlockSpeechBubbleEntryPoint_BlockHiddenWithConsent_Fragment
    ) | (
      { __typename?: 'BlockAccordion' }
      & BlockSpeechBubbleEntryPoint_BlockAccordion_Fragment
    ) | (
      { __typename?: 'BlockOneColumn' }
      & BlockSpeechBubbleEntryPoint_BlockOneColumn_Fragment
    ) | (
      { __typename?: 'BlockAnalystRating' }
      & BlockSpeechBubbleEntryPoint_BlockAnalystRating_Fragment
    ) | (
      { __typename?: 'BlockCallToActionButton' }
      & BlockSpeechBubbleEntryPoint_BlockCallToActionButton_Fragment
    ) | (
      { __typename?: 'BlockTwoColumn' }
      & BlockSpeechBubbleEntryPoint_BlockTwoColumn_Fragment
    ) | (
      { __typename?: 'BlockAccordionEntry' }
      & BlockSpeechBubbleEntryPoint_BlockAccordionEntry_Fragment
    ) | (
      { __typename?: 'NewsArticle' }
      & BlockSpeechBubbleEntryPoint_NewsArticle_Fragment
    ) | (
      { __typename?: 'BlockRichText' }
      & BlockSpeechBubbleEntryPoint_BlockRichText_Fragment
    ) | (
      { __typename?: 'LexiconArticle' }
      & BlockSpeechBubbleEntryPoint_LexiconArticle_Fragment
    ) | (
      { __typename?: 'ProjectPage' }
      & BlockSpeechBubbleEntryPoint_ProjectPage_Fragment
    ) | (
      { __typename?: 'BarChartWithBackground' }
      & BlockSpeechBubbleEntryPoint_BarChartWithBackground_Fragment
    ) | (
      { __typename?: 'BlockCustom' }
      & BlockSpeechBubbleEntryPoint_BlockCustom_Fragment
    ) | (
      { __typename?: 'BlockFullsizeImage' }
      & BlockSpeechBubbleEntryPoint_BlockFullsizeImage_Fragment
    ) | (
      { __typename?: 'BlockHighlightRealEstate' }
      & BlockSpeechBubbleEntryPoint_BlockHighlightRealEstate_Fragment
    ) | (
      { __typename?: 'HighlightedRealEstate' }
      & BlockSpeechBubbleEntryPoint_HighlightedRealEstate_Fragment
    ) | (
      { __typename?: 'BlockPartnerGrid' }
      & BlockSpeechBubbleEntryPoint_BlockPartnerGrid_Fragment
    ) | (
      { __typename?: 'Partner' }
      & BlockSpeechBubbleEntryPoint_Partner_Fragment
    ) | (
      { __typename?: 'BlockPersonAccordion' }
      & BlockSpeechBubbleEntryPoint_BlockPersonAccordion_Fragment
    ) | (
      { __typename?: 'PersonAccordionEntry' }
      & BlockSpeechBubbleEntryPoint_PersonAccordionEntry_Fragment
    ) | (
      { __typename?: 'BlockRibbon' }
      & BlockSpeechBubbleEntryPoint_BlockRibbon_Fragment
    ) | (
      { __typename?: 'BlockTable' }
      & BlockSpeechBubbleEntryPoint_BlockTable_Fragment
    ) | (
      { __typename?: 'BlockThreeColumn' }
      & BlockSpeechBubbleEntryPoint_BlockThreeColumn_Fragment
    ) | (
      { __typename?: 'BlockVideo' }
      & BlockSpeechBubbleEntryPoint_BlockVideo_Fragment
    ) | (
      { __typename?: 'NewsArticleContact' }
      & BlockSpeechBubbleEntryPoint_NewsArticleContact_Fragment
    ) | (
      { __typename?: 'BlockSpeechBubble' }
      & BlockSpeechBubbleEntryPoint_BlockSpeechBubble_Fragment
    ) | (
      { __typename?: 'LatestDownload' }
      & BlockSpeechBubbleEntryPoint_LatestDownload_Fragment
    ) | (
      { __typename?: 'NavigationEntry' }
      & BlockSpeechBubbleEntryPoint_NavigationEntry_Fragment
    ) | (
      { __typename?: 'BlockLinkSection' }
      & BlockSpeechBubbleEntryPoint_BlockLinkSection_Fragment
    ) | (
      { __typename?: 'LinkSectionEntry' }
      & BlockSpeechBubbleEntryPoint_LinkSectionEntry_Fragment
    ) | (
      { __typename?: 'BlockStockPrice' }
      & BlockSpeechBubbleEntryPoint_BlockStockPrice_Fragment
    ) | (
      { __typename?: 'BlockImageGallery' }
      & BlockSpeechBubbleEntryPoint_BlockImageGallery_Fragment
    ) | (
      { __typename?: 'BlockSlider' }
      & BlockSpeechBubbleEntryPoint_BlockSlider_Fragment
    ) | (
      { __typename?: 'BlockSliderEntry' }
      & BlockSpeechBubbleEntryPoint_BlockSliderEntry_Fragment
    ) | (
      { __typename?: 'BlockTextCloud' }
      & BlockSpeechBubbleEntryPoint_BlockTextCloud_Fragment
    ) | (
      { __typename?: 'Seo' }
      & BlockSpeechBubbleEntryPoint_Seo_Fragment
    ) | (
      { __typename?: 'RegionDescriptionText' }
      & BlockSpeechBubbleEntryPoint_RegionDescriptionText_Fragment
    ) | (
      { __typename?: 'ProjectLink' }
      & BlockSpeechBubbleEntryPoint_ProjectLink_Fragment
    ) | (
      { __typename?: 'BlockProjectLinkSection' }
      & BlockSpeechBubbleEntryPoint_BlockProjectLinkSection_Fragment
    ) | (
      { __typename?: 'ProjectImageMap' }
      & BlockSpeechBubbleEntryPoint_ProjectImageMap_Fragment
    ) | (
      { __typename?: 'DownloadableFile' }
      & BlockSpeechBubbleEntryPoint_DownloadableFile_Fragment
    ) | (
      { __typename?: 'Footer' }
      & BlockSpeechBubbleEntryPoint_Footer_Fragment
    )>> }
  )> }
);

type BlockSpeechBubbleEntryPoint_HeroImage_Fragment = (
  { __typename?: 'HeroImage' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type BlockSpeechBubbleEntryPoint_StaticPage_Fragment = (
  { __typename?: 'StaticPage' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type BlockSpeechBubbleEntryPoint_NavBarEntry_Fragment = (
  { __typename?: 'NavBarEntry' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type BlockSpeechBubbleEntryPoint_BlockSubNavigation_Fragment = (
  { __typename?: 'BlockSubNavigation' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type BlockSpeechBubbleEntryPoint_BlockBigTitleNavigation_Fragment = (
  { __typename?: 'BlockBigTitleNavigation' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type BlockSpeechBubbleEntryPoint_BlockHiddenWithConsent_Fragment = (
  { __typename?: 'BlockHiddenWithConsent' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type BlockSpeechBubbleEntryPoint_BlockAccordion_Fragment = (
  { __typename?: 'BlockAccordion' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type BlockSpeechBubbleEntryPoint_BlockOneColumn_Fragment = (
  { __typename?: 'BlockOneColumn' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type BlockSpeechBubbleEntryPoint_BlockAnalystRating_Fragment = (
  { __typename?: 'BlockAnalystRating' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type BlockSpeechBubbleEntryPoint_BlockCallToActionButton_Fragment = (
  { __typename?: 'BlockCallToActionButton' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type BlockSpeechBubbleEntryPoint_BlockTwoColumn_Fragment = (
  { __typename?: 'BlockTwoColumn' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type BlockSpeechBubbleEntryPoint_BlockAccordionEntry_Fragment = (
  { __typename?: 'BlockAccordionEntry' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type BlockSpeechBubbleEntryPoint_NewsArticle_Fragment = (
  { __typename?: 'NewsArticle' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type BlockSpeechBubbleEntryPoint_BlockRichText_Fragment = (
  { __typename?: 'BlockRichText' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type BlockSpeechBubbleEntryPoint_LexiconArticle_Fragment = (
  { __typename?: 'LexiconArticle' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type BlockSpeechBubbleEntryPoint_ProjectPage_Fragment = (
  { __typename?: 'ProjectPage' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type BlockSpeechBubbleEntryPoint_BarChartWithBackground_Fragment = (
  { __typename?: 'BarChartWithBackground' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type BlockSpeechBubbleEntryPoint_BlockCustom_Fragment = (
  { __typename?: 'BlockCustom' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type BlockSpeechBubbleEntryPoint_BlockFullsizeImage_Fragment = (
  { __typename?: 'BlockFullsizeImage' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type BlockSpeechBubbleEntryPoint_BlockHighlightRealEstate_Fragment = (
  { __typename?: 'BlockHighlightRealEstate' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type BlockSpeechBubbleEntryPoint_HighlightedRealEstate_Fragment = (
  { __typename?: 'HighlightedRealEstate' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type BlockSpeechBubbleEntryPoint_BlockPartnerGrid_Fragment = (
  { __typename?: 'BlockPartnerGrid' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type BlockSpeechBubbleEntryPoint_Partner_Fragment = (
  { __typename?: 'Partner' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type BlockSpeechBubbleEntryPoint_BlockPersonAccordion_Fragment = (
  { __typename?: 'BlockPersonAccordion' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type BlockSpeechBubbleEntryPoint_PersonAccordionEntry_Fragment = (
  { __typename?: 'PersonAccordionEntry' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type BlockSpeechBubbleEntryPoint_BlockRibbon_Fragment = (
  { __typename?: 'BlockRibbon' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type BlockSpeechBubbleEntryPoint_BlockTable_Fragment = (
  { __typename?: 'BlockTable' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type BlockSpeechBubbleEntryPoint_BlockThreeColumn_Fragment = (
  { __typename?: 'BlockThreeColumn' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type BlockSpeechBubbleEntryPoint_BlockVideo_Fragment = (
  { __typename?: 'BlockVideo' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type BlockSpeechBubbleEntryPoint_NewsArticleContact_Fragment = (
  { __typename?: 'NewsArticleContact' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type BlockSpeechBubbleEntryPoint_BlockSpeechBubble_Fragment = (
  { __typename?: 'BlockSpeechBubble' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
  & BlockSpeechBubbleFragment
);

type BlockSpeechBubbleEntryPoint_LatestDownload_Fragment = (
  { __typename?: 'LatestDownload' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type BlockSpeechBubbleEntryPoint_NavigationEntry_Fragment = (
  { __typename?: 'NavigationEntry' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type BlockSpeechBubbleEntryPoint_BlockLinkSection_Fragment = (
  { __typename?: 'BlockLinkSection' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type BlockSpeechBubbleEntryPoint_LinkSectionEntry_Fragment = (
  { __typename?: 'LinkSectionEntry' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type BlockSpeechBubbleEntryPoint_BlockStockPrice_Fragment = (
  { __typename?: 'BlockStockPrice' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type BlockSpeechBubbleEntryPoint_BlockImageGallery_Fragment = (
  { __typename?: 'BlockImageGallery' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type BlockSpeechBubbleEntryPoint_BlockSlider_Fragment = (
  { __typename?: 'BlockSlider' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type BlockSpeechBubbleEntryPoint_BlockSliderEntry_Fragment = (
  { __typename?: 'BlockSliderEntry' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type BlockSpeechBubbleEntryPoint_BlockTextCloud_Fragment = (
  { __typename?: 'BlockTextCloud' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type BlockSpeechBubbleEntryPoint_Seo_Fragment = (
  { __typename?: 'Seo' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type BlockSpeechBubbleEntryPoint_RegionDescriptionText_Fragment = (
  { __typename?: 'RegionDescriptionText' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type BlockSpeechBubbleEntryPoint_ProjectLink_Fragment = (
  { __typename?: 'ProjectLink' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type BlockSpeechBubbleEntryPoint_BlockProjectLinkSection_Fragment = (
  { __typename?: 'BlockProjectLinkSection' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type BlockSpeechBubbleEntryPoint_ProjectImageMap_Fragment = (
  { __typename?: 'ProjectImageMap' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type BlockSpeechBubbleEntryPoint_DownloadableFile_Fragment = (
  { __typename?: 'DownloadableFile' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type BlockSpeechBubbleEntryPoint_Footer_Fragment = (
  { __typename?: 'Footer' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

export type BlockSpeechBubbleEntryPointFragment = BlockSpeechBubbleEntryPoint_HeroImage_Fragment | BlockSpeechBubbleEntryPoint_StaticPage_Fragment | BlockSpeechBubbleEntryPoint_NavBarEntry_Fragment | BlockSpeechBubbleEntryPoint_BlockSubNavigation_Fragment | BlockSpeechBubbleEntryPoint_BlockBigTitleNavigation_Fragment | BlockSpeechBubbleEntryPoint_BlockHiddenWithConsent_Fragment | BlockSpeechBubbleEntryPoint_BlockAccordion_Fragment | BlockSpeechBubbleEntryPoint_BlockOneColumn_Fragment | BlockSpeechBubbleEntryPoint_BlockAnalystRating_Fragment | BlockSpeechBubbleEntryPoint_BlockCallToActionButton_Fragment | BlockSpeechBubbleEntryPoint_BlockTwoColumn_Fragment | BlockSpeechBubbleEntryPoint_BlockAccordionEntry_Fragment | BlockSpeechBubbleEntryPoint_NewsArticle_Fragment | BlockSpeechBubbleEntryPoint_BlockRichText_Fragment | BlockSpeechBubbleEntryPoint_LexiconArticle_Fragment | BlockSpeechBubbleEntryPoint_ProjectPage_Fragment | BlockSpeechBubbleEntryPoint_BarChartWithBackground_Fragment | BlockSpeechBubbleEntryPoint_BlockCustom_Fragment | BlockSpeechBubbleEntryPoint_BlockFullsizeImage_Fragment | BlockSpeechBubbleEntryPoint_BlockHighlightRealEstate_Fragment | BlockSpeechBubbleEntryPoint_HighlightedRealEstate_Fragment | BlockSpeechBubbleEntryPoint_BlockPartnerGrid_Fragment | BlockSpeechBubbleEntryPoint_Partner_Fragment | BlockSpeechBubbleEntryPoint_BlockPersonAccordion_Fragment | BlockSpeechBubbleEntryPoint_PersonAccordionEntry_Fragment | BlockSpeechBubbleEntryPoint_BlockRibbon_Fragment | BlockSpeechBubbleEntryPoint_BlockTable_Fragment | BlockSpeechBubbleEntryPoint_BlockThreeColumn_Fragment | BlockSpeechBubbleEntryPoint_BlockVideo_Fragment | BlockSpeechBubbleEntryPoint_NewsArticleContact_Fragment | BlockSpeechBubbleEntryPoint_BlockSpeechBubble_Fragment | BlockSpeechBubbleEntryPoint_LatestDownload_Fragment | BlockSpeechBubbleEntryPoint_NavigationEntry_Fragment | BlockSpeechBubbleEntryPoint_BlockLinkSection_Fragment | BlockSpeechBubbleEntryPoint_LinkSectionEntry_Fragment | BlockSpeechBubbleEntryPoint_BlockStockPrice_Fragment | BlockSpeechBubbleEntryPoint_BlockImageGallery_Fragment | BlockSpeechBubbleEntryPoint_BlockSlider_Fragment | BlockSpeechBubbleEntryPoint_BlockSliderEntry_Fragment | BlockSpeechBubbleEntryPoint_BlockTextCloud_Fragment | BlockSpeechBubbleEntryPoint_Seo_Fragment | BlockSpeechBubbleEntryPoint_RegionDescriptionText_Fragment | BlockSpeechBubbleEntryPoint_ProjectLink_Fragment | BlockSpeechBubbleEntryPoint_BlockProjectLinkSection_Fragment | BlockSpeechBubbleEntryPoint_ProjectImageMap_Fragment | BlockSpeechBubbleEntryPoint_DownloadableFile_Fragment | BlockSpeechBubbleEntryPoint_Footer_Fragment;

export type GetBlockStockPriceByIdQueryVariables = Exact<{
  locale?: Maybe<Scalars['String']>;
  preview?: Maybe<Scalars['Boolean']>;
  id: Scalars['String'];
}>;


export type GetBlockStockPriceByIdQuery = (
  { __typename?: 'Query' }
  & { entryCollection?: Maybe<(
    { __typename?: 'EntryCollection' }
    & { items: Array<Maybe<(
      { __typename?: 'HeroImage' }
      & BlockStockPriceEntryPoint_HeroImage_Fragment
    ) | (
      { __typename?: 'StaticPage' }
      & BlockStockPriceEntryPoint_StaticPage_Fragment
    ) | (
      { __typename?: 'NavBarEntry' }
      & BlockStockPriceEntryPoint_NavBarEntry_Fragment
    ) | (
      { __typename?: 'BlockSubNavigation' }
      & BlockStockPriceEntryPoint_BlockSubNavigation_Fragment
    ) | (
      { __typename?: 'BlockBigTitleNavigation' }
      & BlockStockPriceEntryPoint_BlockBigTitleNavigation_Fragment
    ) | (
      { __typename?: 'BlockHiddenWithConsent' }
      & BlockStockPriceEntryPoint_BlockHiddenWithConsent_Fragment
    ) | (
      { __typename?: 'BlockAccordion' }
      & BlockStockPriceEntryPoint_BlockAccordion_Fragment
    ) | (
      { __typename?: 'BlockOneColumn' }
      & BlockStockPriceEntryPoint_BlockOneColumn_Fragment
    ) | (
      { __typename?: 'BlockAnalystRating' }
      & BlockStockPriceEntryPoint_BlockAnalystRating_Fragment
    ) | (
      { __typename?: 'BlockCallToActionButton' }
      & BlockStockPriceEntryPoint_BlockCallToActionButton_Fragment
    ) | (
      { __typename?: 'BlockTwoColumn' }
      & BlockStockPriceEntryPoint_BlockTwoColumn_Fragment
    ) | (
      { __typename?: 'BlockAccordionEntry' }
      & BlockStockPriceEntryPoint_BlockAccordionEntry_Fragment
    ) | (
      { __typename?: 'NewsArticle' }
      & BlockStockPriceEntryPoint_NewsArticle_Fragment
    ) | (
      { __typename?: 'BlockRichText' }
      & BlockStockPriceEntryPoint_BlockRichText_Fragment
    ) | (
      { __typename?: 'LexiconArticle' }
      & BlockStockPriceEntryPoint_LexiconArticle_Fragment
    ) | (
      { __typename?: 'ProjectPage' }
      & BlockStockPriceEntryPoint_ProjectPage_Fragment
    ) | (
      { __typename?: 'BarChartWithBackground' }
      & BlockStockPriceEntryPoint_BarChartWithBackground_Fragment
    ) | (
      { __typename?: 'BlockCustom' }
      & BlockStockPriceEntryPoint_BlockCustom_Fragment
    ) | (
      { __typename?: 'BlockFullsizeImage' }
      & BlockStockPriceEntryPoint_BlockFullsizeImage_Fragment
    ) | (
      { __typename?: 'BlockHighlightRealEstate' }
      & BlockStockPriceEntryPoint_BlockHighlightRealEstate_Fragment
    ) | (
      { __typename?: 'HighlightedRealEstate' }
      & BlockStockPriceEntryPoint_HighlightedRealEstate_Fragment
    ) | (
      { __typename?: 'BlockPartnerGrid' }
      & BlockStockPriceEntryPoint_BlockPartnerGrid_Fragment
    ) | (
      { __typename?: 'Partner' }
      & BlockStockPriceEntryPoint_Partner_Fragment
    ) | (
      { __typename?: 'BlockPersonAccordion' }
      & BlockStockPriceEntryPoint_BlockPersonAccordion_Fragment
    ) | (
      { __typename?: 'PersonAccordionEntry' }
      & BlockStockPriceEntryPoint_PersonAccordionEntry_Fragment
    ) | (
      { __typename?: 'BlockRibbon' }
      & BlockStockPriceEntryPoint_BlockRibbon_Fragment
    ) | (
      { __typename?: 'BlockTable' }
      & BlockStockPriceEntryPoint_BlockTable_Fragment
    ) | (
      { __typename?: 'BlockThreeColumn' }
      & BlockStockPriceEntryPoint_BlockThreeColumn_Fragment
    ) | (
      { __typename?: 'BlockVideo' }
      & BlockStockPriceEntryPoint_BlockVideo_Fragment
    ) | (
      { __typename?: 'NewsArticleContact' }
      & BlockStockPriceEntryPoint_NewsArticleContact_Fragment
    ) | (
      { __typename?: 'BlockSpeechBubble' }
      & BlockStockPriceEntryPoint_BlockSpeechBubble_Fragment
    ) | (
      { __typename?: 'LatestDownload' }
      & BlockStockPriceEntryPoint_LatestDownload_Fragment
    ) | (
      { __typename?: 'NavigationEntry' }
      & BlockStockPriceEntryPoint_NavigationEntry_Fragment
    ) | (
      { __typename?: 'BlockLinkSection' }
      & BlockStockPriceEntryPoint_BlockLinkSection_Fragment
    ) | (
      { __typename?: 'LinkSectionEntry' }
      & BlockStockPriceEntryPoint_LinkSectionEntry_Fragment
    ) | (
      { __typename?: 'BlockStockPrice' }
      & BlockStockPriceEntryPoint_BlockStockPrice_Fragment
    ) | (
      { __typename?: 'BlockImageGallery' }
      & BlockStockPriceEntryPoint_BlockImageGallery_Fragment
    ) | (
      { __typename?: 'BlockSlider' }
      & BlockStockPriceEntryPoint_BlockSlider_Fragment
    ) | (
      { __typename?: 'BlockSliderEntry' }
      & BlockStockPriceEntryPoint_BlockSliderEntry_Fragment
    ) | (
      { __typename?: 'BlockTextCloud' }
      & BlockStockPriceEntryPoint_BlockTextCloud_Fragment
    ) | (
      { __typename?: 'Seo' }
      & BlockStockPriceEntryPoint_Seo_Fragment
    ) | (
      { __typename?: 'RegionDescriptionText' }
      & BlockStockPriceEntryPoint_RegionDescriptionText_Fragment
    ) | (
      { __typename?: 'ProjectLink' }
      & BlockStockPriceEntryPoint_ProjectLink_Fragment
    ) | (
      { __typename?: 'BlockProjectLinkSection' }
      & BlockStockPriceEntryPoint_BlockProjectLinkSection_Fragment
    ) | (
      { __typename?: 'ProjectImageMap' }
      & BlockStockPriceEntryPoint_ProjectImageMap_Fragment
    ) | (
      { __typename?: 'DownloadableFile' }
      & BlockStockPriceEntryPoint_DownloadableFile_Fragment
    ) | (
      { __typename?: 'Footer' }
      & BlockStockPriceEntryPoint_Footer_Fragment
    )>> }
  )> }
);

type BlockStockPriceEntryPoint_HeroImage_Fragment = (
  { __typename?: 'HeroImage' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type BlockStockPriceEntryPoint_StaticPage_Fragment = (
  { __typename?: 'StaticPage' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type BlockStockPriceEntryPoint_NavBarEntry_Fragment = (
  { __typename?: 'NavBarEntry' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type BlockStockPriceEntryPoint_BlockSubNavigation_Fragment = (
  { __typename?: 'BlockSubNavigation' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type BlockStockPriceEntryPoint_BlockBigTitleNavigation_Fragment = (
  { __typename?: 'BlockBigTitleNavigation' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type BlockStockPriceEntryPoint_BlockHiddenWithConsent_Fragment = (
  { __typename?: 'BlockHiddenWithConsent' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type BlockStockPriceEntryPoint_BlockAccordion_Fragment = (
  { __typename?: 'BlockAccordion' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type BlockStockPriceEntryPoint_BlockOneColumn_Fragment = (
  { __typename?: 'BlockOneColumn' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type BlockStockPriceEntryPoint_BlockAnalystRating_Fragment = (
  { __typename?: 'BlockAnalystRating' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type BlockStockPriceEntryPoint_BlockCallToActionButton_Fragment = (
  { __typename?: 'BlockCallToActionButton' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type BlockStockPriceEntryPoint_BlockTwoColumn_Fragment = (
  { __typename?: 'BlockTwoColumn' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type BlockStockPriceEntryPoint_BlockAccordionEntry_Fragment = (
  { __typename?: 'BlockAccordionEntry' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type BlockStockPriceEntryPoint_NewsArticle_Fragment = (
  { __typename?: 'NewsArticle' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type BlockStockPriceEntryPoint_BlockRichText_Fragment = (
  { __typename?: 'BlockRichText' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type BlockStockPriceEntryPoint_LexiconArticle_Fragment = (
  { __typename?: 'LexiconArticle' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type BlockStockPriceEntryPoint_ProjectPage_Fragment = (
  { __typename?: 'ProjectPage' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type BlockStockPriceEntryPoint_BarChartWithBackground_Fragment = (
  { __typename?: 'BarChartWithBackground' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type BlockStockPriceEntryPoint_BlockCustom_Fragment = (
  { __typename?: 'BlockCustom' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type BlockStockPriceEntryPoint_BlockFullsizeImage_Fragment = (
  { __typename?: 'BlockFullsizeImage' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type BlockStockPriceEntryPoint_BlockHighlightRealEstate_Fragment = (
  { __typename?: 'BlockHighlightRealEstate' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type BlockStockPriceEntryPoint_HighlightedRealEstate_Fragment = (
  { __typename?: 'HighlightedRealEstate' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type BlockStockPriceEntryPoint_BlockPartnerGrid_Fragment = (
  { __typename?: 'BlockPartnerGrid' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type BlockStockPriceEntryPoint_Partner_Fragment = (
  { __typename?: 'Partner' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type BlockStockPriceEntryPoint_BlockPersonAccordion_Fragment = (
  { __typename?: 'BlockPersonAccordion' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type BlockStockPriceEntryPoint_PersonAccordionEntry_Fragment = (
  { __typename?: 'PersonAccordionEntry' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type BlockStockPriceEntryPoint_BlockRibbon_Fragment = (
  { __typename?: 'BlockRibbon' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type BlockStockPriceEntryPoint_BlockTable_Fragment = (
  { __typename?: 'BlockTable' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type BlockStockPriceEntryPoint_BlockThreeColumn_Fragment = (
  { __typename?: 'BlockThreeColumn' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type BlockStockPriceEntryPoint_BlockVideo_Fragment = (
  { __typename?: 'BlockVideo' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type BlockStockPriceEntryPoint_NewsArticleContact_Fragment = (
  { __typename?: 'NewsArticleContact' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type BlockStockPriceEntryPoint_BlockSpeechBubble_Fragment = (
  { __typename?: 'BlockSpeechBubble' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type BlockStockPriceEntryPoint_LatestDownload_Fragment = (
  { __typename?: 'LatestDownload' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type BlockStockPriceEntryPoint_NavigationEntry_Fragment = (
  { __typename?: 'NavigationEntry' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type BlockStockPriceEntryPoint_BlockLinkSection_Fragment = (
  { __typename?: 'BlockLinkSection' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type BlockStockPriceEntryPoint_LinkSectionEntry_Fragment = (
  { __typename?: 'LinkSectionEntry' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type BlockStockPriceEntryPoint_BlockStockPrice_Fragment = (
  { __typename?: 'BlockStockPrice' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
  & BlockStockPriceFragment
);

type BlockStockPriceEntryPoint_BlockImageGallery_Fragment = (
  { __typename?: 'BlockImageGallery' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type BlockStockPriceEntryPoint_BlockSlider_Fragment = (
  { __typename?: 'BlockSlider' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type BlockStockPriceEntryPoint_BlockSliderEntry_Fragment = (
  { __typename?: 'BlockSliderEntry' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type BlockStockPriceEntryPoint_BlockTextCloud_Fragment = (
  { __typename?: 'BlockTextCloud' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type BlockStockPriceEntryPoint_Seo_Fragment = (
  { __typename?: 'Seo' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type BlockStockPriceEntryPoint_RegionDescriptionText_Fragment = (
  { __typename?: 'RegionDescriptionText' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type BlockStockPriceEntryPoint_ProjectLink_Fragment = (
  { __typename?: 'ProjectLink' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type BlockStockPriceEntryPoint_BlockProjectLinkSection_Fragment = (
  { __typename?: 'BlockProjectLinkSection' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type BlockStockPriceEntryPoint_ProjectImageMap_Fragment = (
  { __typename?: 'ProjectImageMap' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type BlockStockPriceEntryPoint_DownloadableFile_Fragment = (
  { __typename?: 'DownloadableFile' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type BlockStockPriceEntryPoint_Footer_Fragment = (
  { __typename?: 'Footer' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

export type BlockStockPriceEntryPointFragment = BlockStockPriceEntryPoint_HeroImage_Fragment | BlockStockPriceEntryPoint_StaticPage_Fragment | BlockStockPriceEntryPoint_NavBarEntry_Fragment | BlockStockPriceEntryPoint_BlockSubNavigation_Fragment | BlockStockPriceEntryPoint_BlockBigTitleNavigation_Fragment | BlockStockPriceEntryPoint_BlockHiddenWithConsent_Fragment | BlockStockPriceEntryPoint_BlockAccordion_Fragment | BlockStockPriceEntryPoint_BlockOneColumn_Fragment | BlockStockPriceEntryPoint_BlockAnalystRating_Fragment | BlockStockPriceEntryPoint_BlockCallToActionButton_Fragment | BlockStockPriceEntryPoint_BlockTwoColumn_Fragment | BlockStockPriceEntryPoint_BlockAccordionEntry_Fragment | BlockStockPriceEntryPoint_NewsArticle_Fragment | BlockStockPriceEntryPoint_BlockRichText_Fragment | BlockStockPriceEntryPoint_LexiconArticle_Fragment | BlockStockPriceEntryPoint_ProjectPage_Fragment | BlockStockPriceEntryPoint_BarChartWithBackground_Fragment | BlockStockPriceEntryPoint_BlockCustom_Fragment | BlockStockPriceEntryPoint_BlockFullsizeImage_Fragment | BlockStockPriceEntryPoint_BlockHighlightRealEstate_Fragment | BlockStockPriceEntryPoint_HighlightedRealEstate_Fragment | BlockStockPriceEntryPoint_BlockPartnerGrid_Fragment | BlockStockPriceEntryPoint_Partner_Fragment | BlockStockPriceEntryPoint_BlockPersonAccordion_Fragment | BlockStockPriceEntryPoint_PersonAccordionEntry_Fragment | BlockStockPriceEntryPoint_BlockRibbon_Fragment | BlockStockPriceEntryPoint_BlockTable_Fragment | BlockStockPriceEntryPoint_BlockThreeColumn_Fragment | BlockStockPriceEntryPoint_BlockVideo_Fragment | BlockStockPriceEntryPoint_NewsArticleContact_Fragment | BlockStockPriceEntryPoint_BlockSpeechBubble_Fragment | BlockStockPriceEntryPoint_LatestDownload_Fragment | BlockStockPriceEntryPoint_NavigationEntry_Fragment | BlockStockPriceEntryPoint_BlockLinkSection_Fragment | BlockStockPriceEntryPoint_LinkSectionEntry_Fragment | BlockStockPriceEntryPoint_BlockStockPrice_Fragment | BlockStockPriceEntryPoint_BlockImageGallery_Fragment | BlockStockPriceEntryPoint_BlockSlider_Fragment | BlockStockPriceEntryPoint_BlockSliderEntry_Fragment | BlockStockPriceEntryPoint_BlockTextCloud_Fragment | BlockStockPriceEntryPoint_Seo_Fragment | BlockStockPriceEntryPoint_RegionDescriptionText_Fragment | BlockStockPriceEntryPoint_ProjectLink_Fragment | BlockStockPriceEntryPoint_BlockProjectLinkSection_Fragment | BlockStockPriceEntryPoint_ProjectImageMap_Fragment | BlockStockPriceEntryPoint_DownloadableFile_Fragment | BlockStockPriceEntryPoint_Footer_Fragment;

export type GetBlockSubNavigationByIdQueryVariables = Exact<{
  locale?: Maybe<Scalars['String']>;
  preview?: Maybe<Scalars['Boolean']>;
  id: Scalars['String'];
}>;


export type GetBlockSubNavigationByIdQuery = (
  { __typename?: 'Query' }
  & { entryCollection?: Maybe<(
    { __typename?: 'EntryCollection' }
    & { items: Array<Maybe<(
      { __typename?: 'HeroImage' }
      & BlockSubNavigationEntryPoint_HeroImage_Fragment
    ) | (
      { __typename?: 'StaticPage' }
      & BlockSubNavigationEntryPoint_StaticPage_Fragment
    ) | (
      { __typename?: 'NavBarEntry' }
      & BlockSubNavigationEntryPoint_NavBarEntry_Fragment
    ) | (
      { __typename?: 'BlockSubNavigation' }
      & BlockSubNavigationEntryPoint_BlockSubNavigation_Fragment
    ) | (
      { __typename?: 'BlockBigTitleNavigation' }
      & BlockSubNavigationEntryPoint_BlockBigTitleNavigation_Fragment
    ) | (
      { __typename?: 'BlockHiddenWithConsent' }
      & BlockSubNavigationEntryPoint_BlockHiddenWithConsent_Fragment
    ) | (
      { __typename?: 'BlockAccordion' }
      & BlockSubNavigationEntryPoint_BlockAccordion_Fragment
    ) | (
      { __typename?: 'BlockOneColumn' }
      & BlockSubNavigationEntryPoint_BlockOneColumn_Fragment
    ) | (
      { __typename?: 'BlockAnalystRating' }
      & BlockSubNavigationEntryPoint_BlockAnalystRating_Fragment
    ) | (
      { __typename?: 'BlockCallToActionButton' }
      & BlockSubNavigationEntryPoint_BlockCallToActionButton_Fragment
    ) | (
      { __typename?: 'BlockTwoColumn' }
      & BlockSubNavigationEntryPoint_BlockTwoColumn_Fragment
    ) | (
      { __typename?: 'BlockAccordionEntry' }
      & BlockSubNavigationEntryPoint_BlockAccordionEntry_Fragment
    ) | (
      { __typename?: 'NewsArticle' }
      & BlockSubNavigationEntryPoint_NewsArticle_Fragment
    ) | (
      { __typename?: 'BlockRichText' }
      & BlockSubNavigationEntryPoint_BlockRichText_Fragment
    ) | (
      { __typename?: 'LexiconArticle' }
      & BlockSubNavigationEntryPoint_LexiconArticle_Fragment
    ) | (
      { __typename?: 'ProjectPage' }
      & BlockSubNavigationEntryPoint_ProjectPage_Fragment
    ) | (
      { __typename?: 'BarChartWithBackground' }
      & BlockSubNavigationEntryPoint_BarChartWithBackground_Fragment
    ) | (
      { __typename?: 'BlockCustom' }
      & BlockSubNavigationEntryPoint_BlockCustom_Fragment
    ) | (
      { __typename?: 'BlockFullsizeImage' }
      & BlockSubNavigationEntryPoint_BlockFullsizeImage_Fragment
    ) | (
      { __typename?: 'BlockHighlightRealEstate' }
      & BlockSubNavigationEntryPoint_BlockHighlightRealEstate_Fragment
    ) | (
      { __typename?: 'HighlightedRealEstate' }
      & BlockSubNavigationEntryPoint_HighlightedRealEstate_Fragment
    ) | (
      { __typename?: 'BlockPartnerGrid' }
      & BlockSubNavigationEntryPoint_BlockPartnerGrid_Fragment
    ) | (
      { __typename?: 'Partner' }
      & BlockSubNavigationEntryPoint_Partner_Fragment
    ) | (
      { __typename?: 'BlockPersonAccordion' }
      & BlockSubNavigationEntryPoint_BlockPersonAccordion_Fragment
    ) | (
      { __typename?: 'PersonAccordionEntry' }
      & BlockSubNavigationEntryPoint_PersonAccordionEntry_Fragment
    ) | (
      { __typename?: 'BlockRibbon' }
      & BlockSubNavigationEntryPoint_BlockRibbon_Fragment
    ) | (
      { __typename?: 'BlockTable' }
      & BlockSubNavigationEntryPoint_BlockTable_Fragment
    ) | (
      { __typename?: 'BlockThreeColumn' }
      & BlockSubNavigationEntryPoint_BlockThreeColumn_Fragment
    ) | (
      { __typename?: 'BlockVideo' }
      & BlockSubNavigationEntryPoint_BlockVideo_Fragment
    ) | (
      { __typename?: 'NewsArticleContact' }
      & BlockSubNavigationEntryPoint_NewsArticleContact_Fragment
    ) | (
      { __typename?: 'BlockSpeechBubble' }
      & BlockSubNavigationEntryPoint_BlockSpeechBubble_Fragment
    ) | (
      { __typename?: 'LatestDownload' }
      & BlockSubNavigationEntryPoint_LatestDownload_Fragment
    ) | (
      { __typename?: 'NavigationEntry' }
      & BlockSubNavigationEntryPoint_NavigationEntry_Fragment
    ) | (
      { __typename?: 'BlockLinkSection' }
      & BlockSubNavigationEntryPoint_BlockLinkSection_Fragment
    ) | (
      { __typename?: 'LinkSectionEntry' }
      & BlockSubNavigationEntryPoint_LinkSectionEntry_Fragment
    ) | (
      { __typename?: 'BlockStockPrice' }
      & BlockSubNavigationEntryPoint_BlockStockPrice_Fragment
    ) | (
      { __typename?: 'BlockImageGallery' }
      & BlockSubNavigationEntryPoint_BlockImageGallery_Fragment
    ) | (
      { __typename?: 'BlockSlider' }
      & BlockSubNavigationEntryPoint_BlockSlider_Fragment
    ) | (
      { __typename?: 'BlockSliderEntry' }
      & BlockSubNavigationEntryPoint_BlockSliderEntry_Fragment
    ) | (
      { __typename?: 'BlockTextCloud' }
      & BlockSubNavigationEntryPoint_BlockTextCloud_Fragment
    ) | (
      { __typename?: 'Seo' }
      & BlockSubNavigationEntryPoint_Seo_Fragment
    ) | (
      { __typename?: 'RegionDescriptionText' }
      & BlockSubNavigationEntryPoint_RegionDescriptionText_Fragment
    ) | (
      { __typename?: 'ProjectLink' }
      & BlockSubNavigationEntryPoint_ProjectLink_Fragment
    ) | (
      { __typename?: 'BlockProjectLinkSection' }
      & BlockSubNavigationEntryPoint_BlockProjectLinkSection_Fragment
    ) | (
      { __typename?: 'ProjectImageMap' }
      & BlockSubNavigationEntryPoint_ProjectImageMap_Fragment
    ) | (
      { __typename?: 'DownloadableFile' }
      & BlockSubNavigationEntryPoint_DownloadableFile_Fragment
    ) | (
      { __typename?: 'Footer' }
      & BlockSubNavigationEntryPoint_Footer_Fragment
    )>> }
  )> }
);

type BlockSubNavigationEntryPoint_HeroImage_Fragment = (
  { __typename?: 'HeroImage' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type BlockSubNavigationEntryPoint_StaticPage_Fragment = (
  { __typename?: 'StaticPage' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type BlockSubNavigationEntryPoint_NavBarEntry_Fragment = (
  { __typename?: 'NavBarEntry' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type BlockSubNavigationEntryPoint_BlockSubNavigation_Fragment = (
  { __typename?: 'BlockSubNavigation' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
  & BlockSubNavigationFragment
);

type BlockSubNavigationEntryPoint_BlockBigTitleNavigation_Fragment = (
  { __typename?: 'BlockBigTitleNavigation' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type BlockSubNavigationEntryPoint_BlockHiddenWithConsent_Fragment = (
  { __typename?: 'BlockHiddenWithConsent' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type BlockSubNavigationEntryPoint_BlockAccordion_Fragment = (
  { __typename?: 'BlockAccordion' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type BlockSubNavigationEntryPoint_BlockOneColumn_Fragment = (
  { __typename?: 'BlockOneColumn' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type BlockSubNavigationEntryPoint_BlockAnalystRating_Fragment = (
  { __typename?: 'BlockAnalystRating' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type BlockSubNavigationEntryPoint_BlockCallToActionButton_Fragment = (
  { __typename?: 'BlockCallToActionButton' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type BlockSubNavigationEntryPoint_BlockTwoColumn_Fragment = (
  { __typename?: 'BlockTwoColumn' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type BlockSubNavigationEntryPoint_BlockAccordionEntry_Fragment = (
  { __typename?: 'BlockAccordionEntry' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type BlockSubNavigationEntryPoint_NewsArticle_Fragment = (
  { __typename?: 'NewsArticle' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type BlockSubNavigationEntryPoint_BlockRichText_Fragment = (
  { __typename?: 'BlockRichText' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type BlockSubNavigationEntryPoint_LexiconArticle_Fragment = (
  { __typename?: 'LexiconArticle' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type BlockSubNavigationEntryPoint_ProjectPage_Fragment = (
  { __typename?: 'ProjectPage' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type BlockSubNavigationEntryPoint_BarChartWithBackground_Fragment = (
  { __typename?: 'BarChartWithBackground' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type BlockSubNavigationEntryPoint_BlockCustom_Fragment = (
  { __typename?: 'BlockCustom' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type BlockSubNavigationEntryPoint_BlockFullsizeImage_Fragment = (
  { __typename?: 'BlockFullsizeImage' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type BlockSubNavigationEntryPoint_BlockHighlightRealEstate_Fragment = (
  { __typename?: 'BlockHighlightRealEstate' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type BlockSubNavigationEntryPoint_HighlightedRealEstate_Fragment = (
  { __typename?: 'HighlightedRealEstate' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type BlockSubNavigationEntryPoint_BlockPartnerGrid_Fragment = (
  { __typename?: 'BlockPartnerGrid' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type BlockSubNavigationEntryPoint_Partner_Fragment = (
  { __typename?: 'Partner' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type BlockSubNavigationEntryPoint_BlockPersonAccordion_Fragment = (
  { __typename?: 'BlockPersonAccordion' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type BlockSubNavigationEntryPoint_PersonAccordionEntry_Fragment = (
  { __typename?: 'PersonAccordionEntry' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type BlockSubNavigationEntryPoint_BlockRibbon_Fragment = (
  { __typename?: 'BlockRibbon' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type BlockSubNavigationEntryPoint_BlockTable_Fragment = (
  { __typename?: 'BlockTable' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type BlockSubNavigationEntryPoint_BlockThreeColumn_Fragment = (
  { __typename?: 'BlockThreeColumn' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type BlockSubNavigationEntryPoint_BlockVideo_Fragment = (
  { __typename?: 'BlockVideo' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type BlockSubNavigationEntryPoint_NewsArticleContact_Fragment = (
  { __typename?: 'NewsArticleContact' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type BlockSubNavigationEntryPoint_BlockSpeechBubble_Fragment = (
  { __typename?: 'BlockSpeechBubble' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type BlockSubNavigationEntryPoint_LatestDownload_Fragment = (
  { __typename?: 'LatestDownload' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type BlockSubNavigationEntryPoint_NavigationEntry_Fragment = (
  { __typename?: 'NavigationEntry' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type BlockSubNavigationEntryPoint_BlockLinkSection_Fragment = (
  { __typename?: 'BlockLinkSection' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type BlockSubNavigationEntryPoint_LinkSectionEntry_Fragment = (
  { __typename?: 'LinkSectionEntry' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type BlockSubNavigationEntryPoint_BlockStockPrice_Fragment = (
  { __typename?: 'BlockStockPrice' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type BlockSubNavigationEntryPoint_BlockImageGallery_Fragment = (
  { __typename?: 'BlockImageGallery' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type BlockSubNavigationEntryPoint_BlockSlider_Fragment = (
  { __typename?: 'BlockSlider' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type BlockSubNavigationEntryPoint_BlockSliderEntry_Fragment = (
  { __typename?: 'BlockSliderEntry' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type BlockSubNavigationEntryPoint_BlockTextCloud_Fragment = (
  { __typename?: 'BlockTextCloud' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type BlockSubNavigationEntryPoint_Seo_Fragment = (
  { __typename?: 'Seo' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type BlockSubNavigationEntryPoint_RegionDescriptionText_Fragment = (
  { __typename?: 'RegionDescriptionText' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type BlockSubNavigationEntryPoint_ProjectLink_Fragment = (
  { __typename?: 'ProjectLink' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type BlockSubNavigationEntryPoint_BlockProjectLinkSection_Fragment = (
  { __typename?: 'BlockProjectLinkSection' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type BlockSubNavigationEntryPoint_ProjectImageMap_Fragment = (
  { __typename?: 'ProjectImageMap' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type BlockSubNavigationEntryPoint_DownloadableFile_Fragment = (
  { __typename?: 'DownloadableFile' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type BlockSubNavigationEntryPoint_Footer_Fragment = (
  { __typename?: 'Footer' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

export type BlockSubNavigationEntryPointFragment = BlockSubNavigationEntryPoint_HeroImage_Fragment | BlockSubNavigationEntryPoint_StaticPage_Fragment | BlockSubNavigationEntryPoint_NavBarEntry_Fragment | BlockSubNavigationEntryPoint_BlockSubNavigation_Fragment | BlockSubNavigationEntryPoint_BlockBigTitleNavigation_Fragment | BlockSubNavigationEntryPoint_BlockHiddenWithConsent_Fragment | BlockSubNavigationEntryPoint_BlockAccordion_Fragment | BlockSubNavigationEntryPoint_BlockOneColumn_Fragment | BlockSubNavigationEntryPoint_BlockAnalystRating_Fragment | BlockSubNavigationEntryPoint_BlockCallToActionButton_Fragment | BlockSubNavigationEntryPoint_BlockTwoColumn_Fragment | BlockSubNavigationEntryPoint_BlockAccordionEntry_Fragment | BlockSubNavigationEntryPoint_NewsArticle_Fragment | BlockSubNavigationEntryPoint_BlockRichText_Fragment | BlockSubNavigationEntryPoint_LexiconArticle_Fragment | BlockSubNavigationEntryPoint_ProjectPage_Fragment | BlockSubNavigationEntryPoint_BarChartWithBackground_Fragment | BlockSubNavigationEntryPoint_BlockCustom_Fragment | BlockSubNavigationEntryPoint_BlockFullsizeImage_Fragment | BlockSubNavigationEntryPoint_BlockHighlightRealEstate_Fragment | BlockSubNavigationEntryPoint_HighlightedRealEstate_Fragment | BlockSubNavigationEntryPoint_BlockPartnerGrid_Fragment | BlockSubNavigationEntryPoint_Partner_Fragment | BlockSubNavigationEntryPoint_BlockPersonAccordion_Fragment | BlockSubNavigationEntryPoint_PersonAccordionEntry_Fragment | BlockSubNavigationEntryPoint_BlockRibbon_Fragment | BlockSubNavigationEntryPoint_BlockTable_Fragment | BlockSubNavigationEntryPoint_BlockThreeColumn_Fragment | BlockSubNavigationEntryPoint_BlockVideo_Fragment | BlockSubNavigationEntryPoint_NewsArticleContact_Fragment | BlockSubNavigationEntryPoint_BlockSpeechBubble_Fragment | BlockSubNavigationEntryPoint_LatestDownload_Fragment | BlockSubNavigationEntryPoint_NavigationEntry_Fragment | BlockSubNavigationEntryPoint_BlockLinkSection_Fragment | BlockSubNavigationEntryPoint_LinkSectionEntry_Fragment | BlockSubNavigationEntryPoint_BlockStockPrice_Fragment | BlockSubNavigationEntryPoint_BlockImageGallery_Fragment | BlockSubNavigationEntryPoint_BlockSlider_Fragment | BlockSubNavigationEntryPoint_BlockSliderEntry_Fragment | BlockSubNavigationEntryPoint_BlockTextCloud_Fragment | BlockSubNavigationEntryPoint_Seo_Fragment | BlockSubNavigationEntryPoint_RegionDescriptionText_Fragment | BlockSubNavigationEntryPoint_ProjectLink_Fragment | BlockSubNavigationEntryPoint_BlockProjectLinkSection_Fragment | BlockSubNavigationEntryPoint_ProjectImageMap_Fragment | BlockSubNavigationEntryPoint_DownloadableFile_Fragment | BlockSubNavigationEntryPoint_Footer_Fragment;

export type GetBlockTextCloudByIdQueryVariables = Exact<{
  locale?: Maybe<Scalars['String']>;
  preview?: Maybe<Scalars['Boolean']>;
  id: Scalars['String'];
}>;


export type GetBlockTextCloudByIdQuery = (
  { __typename?: 'Query' }
  & { entryCollection?: Maybe<(
    { __typename?: 'EntryCollection' }
    & { items: Array<Maybe<(
      { __typename?: 'HeroImage' }
      & BlockTextCloudEntryPoint_HeroImage_Fragment
    ) | (
      { __typename?: 'StaticPage' }
      & BlockTextCloudEntryPoint_StaticPage_Fragment
    ) | (
      { __typename?: 'NavBarEntry' }
      & BlockTextCloudEntryPoint_NavBarEntry_Fragment
    ) | (
      { __typename?: 'BlockSubNavigation' }
      & BlockTextCloudEntryPoint_BlockSubNavigation_Fragment
    ) | (
      { __typename?: 'BlockBigTitleNavigation' }
      & BlockTextCloudEntryPoint_BlockBigTitleNavigation_Fragment
    ) | (
      { __typename?: 'BlockHiddenWithConsent' }
      & BlockTextCloudEntryPoint_BlockHiddenWithConsent_Fragment
    ) | (
      { __typename?: 'BlockAccordion' }
      & BlockTextCloudEntryPoint_BlockAccordion_Fragment
    ) | (
      { __typename?: 'BlockOneColumn' }
      & BlockTextCloudEntryPoint_BlockOneColumn_Fragment
    ) | (
      { __typename?: 'BlockAnalystRating' }
      & BlockTextCloudEntryPoint_BlockAnalystRating_Fragment
    ) | (
      { __typename?: 'BlockCallToActionButton' }
      & BlockTextCloudEntryPoint_BlockCallToActionButton_Fragment
    ) | (
      { __typename?: 'BlockTwoColumn' }
      & BlockTextCloudEntryPoint_BlockTwoColumn_Fragment
    ) | (
      { __typename?: 'BlockAccordionEntry' }
      & BlockTextCloudEntryPoint_BlockAccordionEntry_Fragment
    ) | (
      { __typename?: 'NewsArticle' }
      & BlockTextCloudEntryPoint_NewsArticle_Fragment
    ) | (
      { __typename?: 'BlockRichText' }
      & BlockTextCloudEntryPoint_BlockRichText_Fragment
    ) | (
      { __typename?: 'LexiconArticle' }
      & BlockTextCloudEntryPoint_LexiconArticle_Fragment
    ) | (
      { __typename?: 'ProjectPage' }
      & BlockTextCloudEntryPoint_ProjectPage_Fragment
    ) | (
      { __typename?: 'BarChartWithBackground' }
      & BlockTextCloudEntryPoint_BarChartWithBackground_Fragment
    ) | (
      { __typename?: 'BlockCustom' }
      & BlockTextCloudEntryPoint_BlockCustom_Fragment
    ) | (
      { __typename?: 'BlockFullsizeImage' }
      & BlockTextCloudEntryPoint_BlockFullsizeImage_Fragment
    ) | (
      { __typename?: 'BlockHighlightRealEstate' }
      & BlockTextCloudEntryPoint_BlockHighlightRealEstate_Fragment
    ) | (
      { __typename?: 'HighlightedRealEstate' }
      & BlockTextCloudEntryPoint_HighlightedRealEstate_Fragment
    ) | (
      { __typename?: 'BlockPartnerGrid' }
      & BlockTextCloudEntryPoint_BlockPartnerGrid_Fragment
    ) | (
      { __typename?: 'Partner' }
      & BlockTextCloudEntryPoint_Partner_Fragment
    ) | (
      { __typename?: 'BlockPersonAccordion' }
      & BlockTextCloudEntryPoint_BlockPersonAccordion_Fragment
    ) | (
      { __typename?: 'PersonAccordionEntry' }
      & BlockTextCloudEntryPoint_PersonAccordionEntry_Fragment
    ) | (
      { __typename?: 'BlockRibbon' }
      & BlockTextCloudEntryPoint_BlockRibbon_Fragment
    ) | (
      { __typename?: 'BlockTable' }
      & BlockTextCloudEntryPoint_BlockTable_Fragment
    ) | (
      { __typename?: 'BlockThreeColumn' }
      & BlockTextCloudEntryPoint_BlockThreeColumn_Fragment
    ) | (
      { __typename?: 'BlockVideo' }
      & BlockTextCloudEntryPoint_BlockVideo_Fragment
    ) | (
      { __typename?: 'NewsArticleContact' }
      & BlockTextCloudEntryPoint_NewsArticleContact_Fragment
    ) | (
      { __typename?: 'BlockSpeechBubble' }
      & BlockTextCloudEntryPoint_BlockSpeechBubble_Fragment
    ) | (
      { __typename?: 'LatestDownload' }
      & BlockTextCloudEntryPoint_LatestDownload_Fragment
    ) | (
      { __typename?: 'NavigationEntry' }
      & BlockTextCloudEntryPoint_NavigationEntry_Fragment
    ) | (
      { __typename?: 'BlockLinkSection' }
      & BlockTextCloudEntryPoint_BlockLinkSection_Fragment
    ) | (
      { __typename?: 'LinkSectionEntry' }
      & BlockTextCloudEntryPoint_LinkSectionEntry_Fragment
    ) | (
      { __typename?: 'BlockStockPrice' }
      & BlockTextCloudEntryPoint_BlockStockPrice_Fragment
    ) | (
      { __typename?: 'BlockImageGallery' }
      & BlockTextCloudEntryPoint_BlockImageGallery_Fragment
    ) | (
      { __typename?: 'BlockSlider' }
      & BlockTextCloudEntryPoint_BlockSlider_Fragment
    ) | (
      { __typename?: 'BlockSliderEntry' }
      & BlockTextCloudEntryPoint_BlockSliderEntry_Fragment
    ) | (
      { __typename?: 'BlockTextCloud' }
      & BlockTextCloudEntryPoint_BlockTextCloud_Fragment
    ) | (
      { __typename?: 'Seo' }
      & BlockTextCloudEntryPoint_Seo_Fragment
    ) | (
      { __typename?: 'RegionDescriptionText' }
      & BlockTextCloudEntryPoint_RegionDescriptionText_Fragment
    ) | (
      { __typename?: 'ProjectLink' }
      & BlockTextCloudEntryPoint_ProjectLink_Fragment
    ) | (
      { __typename?: 'BlockProjectLinkSection' }
      & BlockTextCloudEntryPoint_BlockProjectLinkSection_Fragment
    ) | (
      { __typename?: 'ProjectImageMap' }
      & BlockTextCloudEntryPoint_ProjectImageMap_Fragment
    ) | (
      { __typename?: 'DownloadableFile' }
      & BlockTextCloudEntryPoint_DownloadableFile_Fragment
    ) | (
      { __typename?: 'Footer' }
      & BlockTextCloudEntryPoint_Footer_Fragment
    )>> }
  )> }
);

type BlockTextCloudEntryPoint_HeroImage_Fragment = (
  { __typename?: 'HeroImage' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type BlockTextCloudEntryPoint_StaticPage_Fragment = (
  { __typename?: 'StaticPage' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type BlockTextCloudEntryPoint_NavBarEntry_Fragment = (
  { __typename?: 'NavBarEntry' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type BlockTextCloudEntryPoint_BlockSubNavigation_Fragment = (
  { __typename?: 'BlockSubNavigation' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type BlockTextCloudEntryPoint_BlockBigTitleNavigation_Fragment = (
  { __typename?: 'BlockBigTitleNavigation' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type BlockTextCloudEntryPoint_BlockHiddenWithConsent_Fragment = (
  { __typename?: 'BlockHiddenWithConsent' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type BlockTextCloudEntryPoint_BlockAccordion_Fragment = (
  { __typename?: 'BlockAccordion' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type BlockTextCloudEntryPoint_BlockOneColumn_Fragment = (
  { __typename?: 'BlockOneColumn' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type BlockTextCloudEntryPoint_BlockAnalystRating_Fragment = (
  { __typename?: 'BlockAnalystRating' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type BlockTextCloudEntryPoint_BlockCallToActionButton_Fragment = (
  { __typename?: 'BlockCallToActionButton' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type BlockTextCloudEntryPoint_BlockTwoColumn_Fragment = (
  { __typename?: 'BlockTwoColumn' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type BlockTextCloudEntryPoint_BlockAccordionEntry_Fragment = (
  { __typename?: 'BlockAccordionEntry' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type BlockTextCloudEntryPoint_NewsArticle_Fragment = (
  { __typename?: 'NewsArticle' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type BlockTextCloudEntryPoint_BlockRichText_Fragment = (
  { __typename?: 'BlockRichText' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type BlockTextCloudEntryPoint_LexiconArticle_Fragment = (
  { __typename?: 'LexiconArticle' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type BlockTextCloudEntryPoint_ProjectPage_Fragment = (
  { __typename?: 'ProjectPage' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type BlockTextCloudEntryPoint_BarChartWithBackground_Fragment = (
  { __typename?: 'BarChartWithBackground' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type BlockTextCloudEntryPoint_BlockCustom_Fragment = (
  { __typename?: 'BlockCustom' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type BlockTextCloudEntryPoint_BlockFullsizeImage_Fragment = (
  { __typename?: 'BlockFullsizeImage' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type BlockTextCloudEntryPoint_BlockHighlightRealEstate_Fragment = (
  { __typename?: 'BlockHighlightRealEstate' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type BlockTextCloudEntryPoint_HighlightedRealEstate_Fragment = (
  { __typename?: 'HighlightedRealEstate' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type BlockTextCloudEntryPoint_BlockPartnerGrid_Fragment = (
  { __typename?: 'BlockPartnerGrid' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type BlockTextCloudEntryPoint_Partner_Fragment = (
  { __typename?: 'Partner' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type BlockTextCloudEntryPoint_BlockPersonAccordion_Fragment = (
  { __typename?: 'BlockPersonAccordion' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type BlockTextCloudEntryPoint_PersonAccordionEntry_Fragment = (
  { __typename?: 'PersonAccordionEntry' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type BlockTextCloudEntryPoint_BlockRibbon_Fragment = (
  { __typename?: 'BlockRibbon' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type BlockTextCloudEntryPoint_BlockTable_Fragment = (
  { __typename?: 'BlockTable' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type BlockTextCloudEntryPoint_BlockThreeColumn_Fragment = (
  { __typename?: 'BlockThreeColumn' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type BlockTextCloudEntryPoint_BlockVideo_Fragment = (
  { __typename?: 'BlockVideo' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type BlockTextCloudEntryPoint_NewsArticleContact_Fragment = (
  { __typename?: 'NewsArticleContact' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type BlockTextCloudEntryPoint_BlockSpeechBubble_Fragment = (
  { __typename?: 'BlockSpeechBubble' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type BlockTextCloudEntryPoint_LatestDownload_Fragment = (
  { __typename?: 'LatestDownload' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type BlockTextCloudEntryPoint_NavigationEntry_Fragment = (
  { __typename?: 'NavigationEntry' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type BlockTextCloudEntryPoint_BlockLinkSection_Fragment = (
  { __typename?: 'BlockLinkSection' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type BlockTextCloudEntryPoint_LinkSectionEntry_Fragment = (
  { __typename?: 'LinkSectionEntry' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type BlockTextCloudEntryPoint_BlockStockPrice_Fragment = (
  { __typename?: 'BlockStockPrice' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type BlockTextCloudEntryPoint_BlockImageGallery_Fragment = (
  { __typename?: 'BlockImageGallery' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type BlockTextCloudEntryPoint_BlockSlider_Fragment = (
  { __typename?: 'BlockSlider' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type BlockTextCloudEntryPoint_BlockSliderEntry_Fragment = (
  { __typename?: 'BlockSliderEntry' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type BlockTextCloudEntryPoint_BlockTextCloud_Fragment = (
  { __typename?: 'BlockTextCloud' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
  & BlockTextCloudFragment
);

type BlockTextCloudEntryPoint_Seo_Fragment = (
  { __typename?: 'Seo' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type BlockTextCloudEntryPoint_RegionDescriptionText_Fragment = (
  { __typename?: 'RegionDescriptionText' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type BlockTextCloudEntryPoint_ProjectLink_Fragment = (
  { __typename?: 'ProjectLink' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type BlockTextCloudEntryPoint_BlockProjectLinkSection_Fragment = (
  { __typename?: 'BlockProjectLinkSection' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type BlockTextCloudEntryPoint_ProjectImageMap_Fragment = (
  { __typename?: 'ProjectImageMap' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type BlockTextCloudEntryPoint_DownloadableFile_Fragment = (
  { __typename?: 'DownloadableFile' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type BlockTextCloudEntryPoint_Footer_Fragment = (
  { __typename?: 'Footer' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

export type BlockTextCloudEntryPointFragment = BlockTextCloudEntryPoint_HeroImage_Fragment | BlockTextCloudEntryPoint_StaticPage_Fragment | BlockTextCloudEntryPoint_NavBarEntry_Fragment | BlockTextCloudEntryPoint_BlockSubNavigation_Fragment | BlockTextCloudEntryPoint_BlockBigTitleNavigation_Fragment | BlockTextCloudEntryPoint_BlockHiddenWithConsent_Fragment | BlockTextCloudEntryPoint_BlockAccordion_Fragment | BlockTextCloudEntryPoint_BlockOneColumn_Fragment | BlockTextCloudEntryPoint_BlockAnalystRating_Fragment | BlockTextCloudEntryPoint_BlockCallToActionButton_Fragment | BlockTextCloudEntryPoint_BlockTwoColumn_Fragment | BlockTextCloudEntryPoint_BlockAccordionEntry_Fragment | BlockTextCloudEntryPoint_NewsArticle_Fragment | BlockTextCloudEntryPoint_BlockRichText_Fragment | BlockTextCloudEntryPoint_LexiconArticle_Fragment | BlockTextCloudEntryPoint_ProjectPage_Fragment | BlockTextCloudEntryPoint_BarChartWithBackground_Fragment | BlockTextCloudEntryPoint_BlockCustom_Fragment | BlockTextCloudEntryPoint_BlockFullsizeImage_Fragment | BlockTextCloudEntryPoint_BlockHighlightRealEstate_Fragment | BlockTextCloudEntryPoint_HighlightedRealEstate_Fragment | BlockTextCloudEntryPoint_BlockPartnerGrid_Fragment | BlockTextCloudEntryPoint_Partner_Fragment | BlockTextCloudEntryPoint_BlockPersonAccordion_Fragment | BlockTextCloudEntryPoint_PersonAccordionEntry_Fragment | BlockTextCloudEntryPoint_BlockRibbon_Fragment | BlockTextCloudEntryPoint_BlockTable_Fragment | BlockTextCloudEntryPoint_BlockThreeColumn_Fragment | BlockTextCloudEntryPoint_BlockVideo_Fragment | BlockTextCloudEntryPoint_NewsArticleContact_Fragment | BlockTextCloudEntryPoint_BlockSpeechBubble_Fragment | BlockTextCloudEntryPoint_LatestDownload_Fragment | BlockTextCloudEntryPoint_NavigationEntry_Fragment | BlockTextCloudEntryPoint_BlockLinkSection_Fragment | BlockTextCloudEntryPoint_LinkSectionEntry_Fragment | BlockTextCloudEntryPoint_BlockStockPrice_Fragment | BlockTextCloudEntryPoint_BlockImageGallery_Fragment | BlockTextCloudEntryPoint_BlockSlider_Fragment | BlockTextCloudEntryPoint_BlockSliderEntry_Fragment | BlockTextCloudEntryPoint_BlockTextCloud_Fragment | BlockTextCloudEntryPoint_Seo_Fragment | BlockTextCloudEntryPoint_RegionDescriptionText_Fragment | BlockTextCloudEntryPoint_ProjectLink_Fragment | BlockTextCloudEntryPoint_BlockProjectLinkSection_Fragment | BlockTextCloudEntryPoint_ProjectImageMap_Fragment | BlockTextCloudEntryPoint_DownloadableFile_Fragment | BlockTextCloudEntryPoint_Footer_Fragment;

export type GetBlockThreeColumnByIdQueryVariables = Exact<{
  locale?: Maybe<Scalars['String']>;
  preview?: Maybe<Scalars['Boolean']>;
  id: Scalars['String'];
}>;


export type GetBlockThreeColumnByIdQuery = (
  { __typename?: 'Query' }
  & { entryCollection?: Maybe<(
    { __typename?: 'EntryCollection' }
    & { items: Array<Maybe<(
      { __typename?: 'HeroImage' }
      & BlockThreeColumnEntryPoint_HeroImage_Fragment
    ) | (
      { __typename?: 'StaticPage' }
      & BlockThreeColumnEntryPoint_StaticPage_Fragment
    ) | (
      { __typename?: 'NavBarEntry' }
      & BlockThreeColumnEntryPoint_NavBarEntry_Fragment
    ) | (
      { __typename?: 'BlockSubNavigation' }
      & BlockThreeColumnEntryPoint_BlockSubNavigation_Fragment
    ) | (
      { __typename?: 'BlockBigTitleNavigation' }
      & BlockThreeColumnEntryPoint_BlockBigTitleNavigation_Fragment
    ) | (
      { __typename?: 'BlockHiddenWithConsent' }
      & BlockThreeColumnEntryPoint_BlockHiddenWithConsent_Fragment
    ) | (
      { __typename?: 'BlockAccordion' }
      & BlockThreeColumnEntryPoint_BlockAccordion_Fragment
    ) | (
      { __typename?: 'BlockOneColumn' }
      & BlockThreeColumnEntryPoint_BlockOneColumn_Fragment
    ) | (
      { __typename?: 'BlockAnalystRating' }
      & BlockThreeColumnEntryPoint_BlockAnalystRating_Fragment
    ) | (
      { __typename?: 'BlockCallToActionButton' }
      & BlockThreeColumnEntryPoint_BlockCallToActionButton_Fragment
    ) | (
      { __typename?: 'BlockTwoColumn' }
      & BlockThreeColumnEntryPoint_BlockTwoColumn_Fragment
    ) | (
      { __typename?: 'BlockAccordionEntry' }
      & BlockThreeColumnEntryPoint_BlockAccordionEntry_Fragment
    ) | (
      { __typename?: 'NewsArticle' }
      & BlockThreeColumnEntryPoint_NewsArticle_Fragment
    ) | (
      { __typename?: 'BlockRichText' }
      & BlockThreeColumnEntryPoint_BlockRichText_Fragment
    ) | (
      { __typename?: 'LexiconArticle' }
      & BlockThreeColumnEntryPoint_LexiconArticle_Fragment
    ) | (
      { __typename?: 'ProjectPage' }
      & BlockThreeColumnEntryPoint_ProjectPage_Fragment
    ) | (
      { __typename?: 'BarChartWithBackground' }
      & BlockThreeColumnEntryPoint_BarChartWithBackground_Fragment
    ) | (
      { __typename?: 'BlockCustom' }
      & BlockThreeColumnEntryPoint_BlockCustom_Fragment
    ) | (
      { __typename?: 'BlockFullsizeImage' }
      & BlockThreeColumnEntryPoint_BlockFullsizeImage_Fragment
    ) | (
      { __typename?: 'BlockHighlightRealEstate' }
      & BlockThreeColumnEntryPoint_BlockHighlightRealEstate_Fragment
    ) | (
      { __typename?: 'HighlightedRealEstate' }
      & BlockThreeColumnEntryPoint_HighlightedRealEstate_Fragment
    ) | (
      { __typename?: 'BlockPartnerGrid' }
      & BlockThreeColumnEntryPoint_BlockPartnerGrid_Fragment
    ) | (
      { __typename?: 'Partner' }
      & BlockThreeColumnEntryPoint_Partner_Fragment
    ) | (
      { __typename?: 'BlockPersonAccordion' }
      & BlockThreeColumnEntryPoint_BlockPersonAccordion_Fragment
    ) | (
      { __typename?: 'PersonAccordionEntry' }
      & BlockThreeColumnEntryPoint_PersonAccordionEntry_Fragment
    ) | (
      { __typename?: 'BlockRibbon' }
      & BlockThreeColumnEntryPoint_BlockRibbon_Fragment
    ) | (
      { __typename?: 'BlockTable' }
      & BlockThreeColumnEntryPoint_BlockTable_Fragment
    ) | (
      { __typename?: 'BlockThreeColumn' }
      & BlockThreeColumnEntryPoint_BlockThreeColumn_Fragment
    ) | (
      { __typename?: 'BlockVideo' }
      & BlockThreeColumnEntryPoint_BlockVideo_Fragment
    ) | (
      { __typename?: 'NewsArticleContact' }
      & BlockThreeColumnEntryPoint_NewsArticleContact_Fragment
    ) | (
      { __typename?: 'BlockSpeechBubble' }
      & BlockThreeColumnEntryPoint_BlockSpeechBubble_Fragment
    ) | (
      { __typename?: 'LatestDownload' }
      & BlockThreeColumnEntryPoint_LatestDownload_Fragment
    ) | (
      { __typename?: 'NavigationEntry' }
      & BlockThreeColumnEntryPoint_NavigationEntry_Fragment
    ) | (
      { __typename?: 'BlockLinkSection' }
      & BlockThreeColumnEntryPoint_BlockLinkSection_Fragment
    ) | (
      { __typename?: 'LinkSectionEntry' }
      & BlockThreeColumnEntryPoint_LinkSectionEntry_Fragment
    ) | (
      { __typename?: 'BlockStockPrice' }
      & BlockThreeColumnEntryPoint_BlockStockPrice_Fragment
    ) | (
      { __typename?: 'BlockImageGallery' }
      & BlockThreeColumnEntryPoint_BlockImageGallery_Fragment
    ) | (
      { __typename?: 'BlockSlider' }
      & BlockThreeColumnEntryPoint_BlockSlider_Fragment
    ) | (
      { __typename?: 'BlockSliderEntry' }
      & BlockThreeColumnEntryPoint_BlockSliderEntry_Fragment
    ) | (
      { __typename?: 'BlockTextCloud' }
      & BlockThreeColumnEntryPoint_BlockTextCloud_Fragment
    ) | (
      { __typename?: 'Seo' }
      & BlockThreeColumnEntryPoint_Seo_Fragment
    ) | (
      { __typename?: 'RegionDescriptionText' }
      & BlockThreeColumnEntryPoint_RegionDescriptionText_Fragment
    ) | (
      { __typename?: 'ProjectLink' }
      & BlockThreeColumnEntryPoint_ProjectLink_Fragment
    ) | (
      { __typename?: 'BlockProjectLinkSection' }
      & BlockThreeColumnEntryPoint_BlockProjectLinkSection_Fragment
    ) | (
      { __typename?: 'ProjectImageMap' }
      & BlockThreeColumnEntryPoint_ProjectImageMap_Fragment
    ) | (
      { __typename?: 'DownloadableFile' }
      & BlockThreeColumnEntryPoint_DownloadableFile_Fragment
    ) | (
      { __typename?: 'Footer' }
      & BlockThreeColumnEntryPoint_Footer_Fragment
    )>> }
  )> }
);

type BlockThreeColumnEntryPoint_HeroImage_Fragment = (
  { __typename?: 'HeroImage' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type BlockThreeColumnEntryPoint_StaticPage_Fragment = (
  { __typename?: 'StaticPage' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type BlockThreeColumnEntryPoint_NavBarEntry_Fragment = (
  { __typename?: 'NavBarEntry' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type BlockThreeColumnEntryPoint_BlockSubNavigation_Fragment = (
  { __typename?: 'BlockSubNavigation' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type BlockThreeColumnEntryPoint_BlockBigTitleNavigation_Fragment = (
  { __typename?: 'BlockBigTitleNavigation' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type BlockThreeColumnEntryPoint_BlockHiddenWithConsent_Fragment = (
  { __typename?: 'BlockHiddenWithConsent' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type BlockThreeColumnEntryPoint_BlockAccordion_Fragment = (
  { __typename?: 'BlockAccordion' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type BlockThreeColumnEntryPoint_BlockOneColumn_Fragment = (
  { __typename?: 'BlockOneColumn' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type BlockThreeColumnEntryPoint_BlockAnalystRating_Fragment = (
  { __typename?: 'BlockAnalystRating' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type BlockThreeColumnEntryPoint_BlockCallToActionButton_Fragment = (
  { __typename?: 'BlockCallToActionButton' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type BlockThreeColumnEntryPoint_BlockTwoColumn_Fragment = (
  { __typename?: 'BlockTwoColumn' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type BlockThreeColumnEntryPoint_BlockAccordionEntry_Fragment = (
  { __typename?: 'BlockAccordionEntry' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type BlockThreeColumnEntryPoint_NewsArticle_Fragment = (
  { __typename?: 'NewsArticle' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type BlockThreeColumnEntryPoint_BlockRichText_Fragment = (
  { __typename?: 'BlockRichText' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type BlockThreeColumnEntryPoint_LexiconArticle_Fragment = (
  { __typename?: 'LexiconArticle' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type BlockThreeColumnEntryPoint_ProjectPage_Fragment = (
  { __typename?: 'ProjectPage' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type BlockThreeColumnEntryPoint_BarChartWithBackground_Fragment = (
  { __typename?: 'BarChartWithBackground' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type BlockThreeColumnEntryPoint_BlockCustom_Fragment = (
  { __typename?: 'BlockCustom' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type BlockThreeColumnEntryPoint_BlockFullsizeImage_Fragment = (
  { __typename?: 'BlockFullsizeImage' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type BlockThreeColumnEntryPoint_BlockHighlightRealEstate_Fragment = (
  { __typename?: 'BlockHighlightRealEstate' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type BlockThreeColumnEntryPoint_HighlightedRealEstate_Fragment = (
  { __typename?: 'HighlightedRealEstate' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type BlockThreeColumnEntryPoint_BlockPartnerGrid_Fragment = (
  { __typename?: 'BlockPartnerGrid' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type BlockThreeColumnEntryPoint_Partner_Fragment = (
  { __typename?: 'Partner' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type BlockThreeColumnEntryPoint_BlockPersonAccordion_Fragment = (
  { __typename?: 'BlockPersonAccordion' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type BlockThreeColumnEntryPoint_PersonAccordionEntry_Fragment = (
  { __typename?: 'PersonAccordionEntry' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type BlockThreeColumnEntryPoint_BlockRibbon_Fragment = (
  { __typename?: 'BlockRibbon' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type BlockThreeColumnEntryPoint_BlockTable_Fragment = (
  { __typename?: 'BlockTable' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type BlockThreeColumnEntryPoint_BlockThreeColumn_Fragment = (
  { __typename?: 'BlockThreeColumn' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
  & BlockThreeColumnFragment
);

type BlockThreeColumnEntryPoint_BlockVideo_Fragment = (
  { __typename?: 'BlockVideo' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type BlockThreeColumnEntryPoint_NewsArticleContact_Fragment = (
  { __typename?: 'NewsArticleContact' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type BlockThreeColumnEntryPoint_BlockSpeechBubble_Fragment = (
  { __typename?: 'BlockSpeechBubble' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type BlockThreeColumnEntryPoint_LatestDownload_Fragment = (
  { __typename?: 'LatestDownload' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type BlockThreeColumnEntryPoint_NavigationEntry_Fragment = (
  { __typename?: 'NavigationEntry' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type BlockThreeColumnEntryPoint_BlockLinkSection_Fragment = (
  { __typename?: 'BlockLinkSection' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type BlockThreeColumnEntryPoint_LinkSectionEntry_Fragment = (
  { __typename?: 'LinkSectionEntry' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type BlockThreeColumnEntryPoint_BlockStockPrice_Fragment = (
  { __typename?: 'BlockStockPrice' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type BlockThreeColumnEntryPoint_BlockImageGallery_Fragment = (
  { __typename?: 'BlockImageGallery' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type BlockThreeColumnEntryPoint_BlockSlider_Fragment = (
  { __typename?: 'BlockSlider' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type BlockThreeColumnEntryPoint_BlockSliderEntry_Fragment = (
  { __typename?: 'BlockSliderEntry' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type BlockThreeColumnEntryPoint_BlockTextCloud_Fragment = (
  { __typename?: 'BlockTextCloud' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type BlockThreeColumnEntryPoint_Seo_Fragment = (
  { __typename?: 'Seo' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type BlockThreeColumnEntryPoint_RegionDescriptionText_Fragment = (
  { __typename?: 'RegionDescriptionText' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type BlockThreeColumnEntryPoint_ProjectLink_Fragment = (
  { __typename?: 'ProjectLink' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type BlockThreeColumnEntryPoint_BlockProjectLinkSection_Fragment = (
  { __typename?: 'BlockProjectLinkSection' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type BlockThreeColumnEntryPoint_ProjectImageMap_Fragment = (
  { __typename?: 'ProjectImageMap' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type BlockThreeColumnEntryPoint_DownloadableFile_Fragment = (
  { __typename?: 'DownloadableFile' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type BlockThreeColumnEntryPoint_Footer_Fragment = (
  { __typename?: 'Footer' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

export type BlockThreeColumnEntryPointFragment = BlockThreeColumnEntryPoint_HeroImage_Fragment | BlockThreeColumnEntryPoint_StaticPage_Fragment | BlockThreeColumnEntryPoint_NavBarEntry_Fragment | BlockThreeColumnEntryPoint_BlockSubNavigation_Fragment | BlockThreeColumnEntryPoint_BlockBigTitleNavigation_Fragment | BlockThreeColumnEntryPoint_BlockHiddenWithConsent_Fragment | BlockThreeColumnEntryPoint_BlockAccordion_Fragment | BlockThreeColumnEntryPoint_BlockOneColumn_Fragment | BlockThreeColumnEntryPoint_BlockAnalystRating_Fragment | BlockThreeColumnEntryPoint_BlockCallToActionButton_Fragment | BlockThreeColumnEntryPoint_BlockTwoColumn_Fragment | BlockThreeColumnEntryPoint_BlockAccordionEntry_Fragment | BlockThreeColumnEntryPoint_NewsArticle_Fragment | BlockThreeColumnEntryPoint_BlockRichText_Fragment | BlockThreeColumnEntryPoint_LexiconArticle_Fragment | BlockThreeColumnEntryPoint_ProjectPage_Fragment | BlockThreeColumnEntryPoint_BarChartWithBackground_Fragment | BlockThreeColumnEntryPoint_BlockCustom_Fragment | BlockThreeColumnEntryPoint_BlockFullsizeImage_Fragment | BlockThreeColumnEntryPoint_BlockHighlightRealEstate_Fragment | BlockThreeColumnEntryPoint_HighlightedRealEstate_Fragment | BlockThreeColumnEntryPoint_BlockPartnerGrid_Fragment | BlockThreeColumnEntryPoint_Partner_Fragment | BlockThreeColumnEntryPoint_BlockPersonAccordion_Fragment | BlockThreeColumnEntryPoint_PersonAccordionEntry_Fragment | BlockThreeColumnEntryPoint_BlockRibbon_Fragment | BlockThreeColumnEntryPoint_BlockTable_Fragment | BlockThreeColumnEntryPoint_BlockThreeColumn_Fragment | BlockThreeColumnEntryPoint_BlockVideo_Fragment | BlockThreeColumnEntryPoint_NewsArticleContact_Fragment | BlockThreeColumnEntryPoint_BlockSpeechBubble_Fragment | BlockThreeColumnEntryPoint_LatestDownload_Fragment | BlockThreeColumnEntryPoint_NavigationEntry_Fragment | BlockThreeColumnEntryPoint_BlockLinkSection_Fragment | BlockThreeColumnEntryPoint_LinkSectionEntry_Fragment | BlockThreeColumnEntryPoint_BlockStockPrice_Fragment | BlockThreeColumnEntryPoint_BlockImageGallery_Fragment | BlockThreeColumnEntryPoint_BlockSlider_Fragment | BlockThreeColumnEntryPoint_BlockSliderEntry_Fragment | BlockThreeColumnEntryPoint_BlockTextCloud_Fragment | BlockThreeColumnEntryPoint_Seo_Fragment | BlockThreeColumnEntryPoint_RegionDescriptionText_Fragment | BlockThreeColumnEntryPoint_ProjectLink_Fragment | BlockThreeColumnEntryPoint_BlockProjectLinkSection_Fragment | BlockThreeColumnEntryPoint_ProjectImageMap_Fragment | BlockThreeColumnEntryPoint_DownloadableFile_Fragment | BlockThreeColumnEntryPoint_Footer_Fragment;

export type GetBlockVideoByIdQueryVariables = Exact<{
  locale?: Maybe<Scalars['String']>;
  preview?: Maybe<Scalars['Boolean']>;
  id: Scalars['String'];
}>;


export type GetBlockVideoByIdQuery = (
  { __typename?: 'Query' }
  & { entryCollection?: Maybe<(
    { __typename?: 'EntryCollection' }
    & { items: Array<Maybe<(
      { __typename?: 'HeroImage' }
      & BlockVideoEntryPoint_HeroImage_Fragment
    ) | (
      { __typename?: 'StaticPage' }
      & BlockVideoEntryPoint_StaticPage_Fragment
    ) | (
      { __typename?: 'NavBarEntry' }
      & BlockVideoEntryPoint_NavBarEntry_Fragment
    ) | (
      { __typename?: 'BlockSubNavigation' }
      & BlockVideoEntryPoint_BlockSubNavigation_Fragment
    ) | (
      { __typename?: 'BlockBigTitleNavigation' }
      & BlockVideoEntryPoint_BlockBigTitleNavigation_Fragment
    ) | (
      { __typename?: 'BlockHiddenWithConsent' }
      & BlockVideoEntryPoint_BlockHiddenWithConsent_Fragment
    ) | (
      { __typename?: 'BlockAccordion' }
      & BlockVideoEntryPoint_BlockAccordion_Fragment
    ) | (
      { __typename?: 'BlockOneColumn' }
      & BlockVideoEntryPoint_BlockOneColumn_Fragment
    ) | (
      { __typename?: 'BlockAnalystRating' }
      & BlockVideoEntryPoint_BlockAnalystRating_Fragment
    ) | (
      { __typename?: 'BlockCallToActionButton' }
      & BlockVideoEntryPoint_BlockCallToActionButton_Fragment
    ) | (
      { __typename?: 'BlockTwoColumn' }
      & BlockVideoEntryPoint_BlockTwoColumn_Fragment
    ) | (
      { __typename?: 'BlockAccordionEntry' }
      & BlockVideoEntryPoint_BlockAccordionEntry_Fragment
    ) | (
      { __typename?: 'NewsArticle' }
      & BlockVideoEntryPoint_NewsArticle_Fragment
    ) | (
      { __typename?: 'BlockRichText' }
      & BlockVideoEntryPoint_BlockRichText_Fragment
    ) | (
      { __typename?: 'LexiconArticle' }
      & BlockVideoEntryPoint_LexiconArticle_Fragment
    ) | (
      { __typename?: 'ProjectPage' }
      & BlockVideoEntryPoint_ProjectPage_Fragment
    ) | (
      { __typename?: 'BarChartWithBackground' }
      & BlockVideoEntryPoint_BarChartWithBackground_Fragment
    ) | (
      { __typename?: 'BlockCustom' }
      & BlockVideoEntryPoint_BlockCustom_Fragment
    ) | (
      { __typename?: 'BlockFullsizeImage' }
      & BlockVideoEntryPoint_BlockFullsizeImage_Fragment
    ) | (
      { __typename?: 'BlockHighlightRealEstate' }
      & BlockVideoEntryPoint_BlockHighlightRealEstate_Fragment
    ) | (
      { __typename?: 'HighlightedRealEstate' }
      & BlockVideoEntryPoint_HighlightedRealEstate_Fragment
    ) | (
      { __typename?: 'BlockPartnerGrid' }
      & BlockVideoEntryPoint_BlockPartnerGrid_Fragment
    ) | (
      { __typename?: 'Partner' }
      & BlockVideoEntryPoint_Partner_Fragment
    ) | (
      { __typename?: 'BlockPersonAccordion' }
      & BlockVideoEntryPoint_BlockPersonAccordion_Fragment
    ) | (
      { __typename?: 'PersonAccordionEntry' }
      & BlockVideoEntryPoint_PersonAccordionEntry_Fragment
    ) | (
      { __typename?: 'BlockRibbon' }
      & BlockVideoEntryPoint_BlockRibbon_Fragment
    ) | (
      { __typename?: 'BlockTable' }
      & BlockVideoEntryPoint_BlockTable_Fragment
    ) | (
      { __typename?: 'BlockThreeColumn' }
      & BlockVideoEntryPoint_BlockThreeColumn_Fragment
    ) | (
      { __typename?: 'BlockVideo' }
      & BlockVideoEntryPoint_BlockVideo_Fragment
    ) | (
      { __typename?: 'NewsArticleContact' }
      & BlockVideoEntryPoint_NewsArticleContact_Fragment
    ) | (
      { __typename?: 'BlockSpeechBubble' }
      & BlockVideoEntryPoint_BlockSpeechBubble_Fragment
    ) | (
      { __typename?: 'LatestDownload' }
      & BlockVideoEntryPoint_LatestDownload_Fragment
    ) | (
      { __typename?: 'NavigationEntry' }
      & BlockVideoEntryPoint_NavigationEntry_Fragment
    ) | (
      { __typename?: 'BlockLinkSection' }
      & BlockVideoEntryPoint_BlockLinkSection_Fragment
    ) | (
      { __typename?: 'LinkSectionEntry' }
      & BlockVideoEntryPoint_LinkSectionEntry_Fragment
    ) | (
      { __typename?: 'BlockStockPrice' }
      & BlockVideoEntryPoint_BlockStockPrice_Fragment
    ) | (
      { __typename?: 'BlockImageGallery' }
      & BlockVideoEntryPoint_BlockImageGallery_Fragment
    ) | (
      { __typename?: 'BlockSlider' }
      & BlockVideoEntryPoint_BlockSlider_Fragment
    ) | (
      { __typename?: 'BlockSliderEntry' }
      & BlockVideoEntryPoint_BlockSliderEntry_Fragment
    ) | (
      { __typename?: 'BlockTextCloud' }
      & BlockVideoEntryPoint_BlockTextCloud_Fragment
    ) | (
      { __typename?: 'Seo' }
      & BlockVideoEntryPoint_Seo_Fragment
    ) | (
      { __typename?: 'RegionDescriptionText' }
      & BlockVideoEntryPoint_RegionDescriptionText_Fragment
    ) | (
      { __typename?: 'ProjectLink' }
      & BlockVideoEntryPoint_ProjectLink_Fragment
    ) | (
      { __typename?: 'BlockProjectLinkSection' }
      & BlockVideoEntryPoint_BlockProjectLinkSection_Fragment
    ) | (
      { __typename?: 'ProjectImageMap' }
      & BlockVideoEntryPoint_ProjectImageMap_Fragment
    ) | (
      { __typename?: 'DownloadableFile' }
      & BlockVideoEntryPoint_DownloadableFile_Fragment
    ) | (
      { __typename?: 'Footer' }
      & BlockVideoEntryPoint_Footer_Fragment
    )>> }
  )> }
);

type BlockVideoEntryPoint_HeroImage_Fragment = (
  { __typename?: 'HeroImage' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type BlockVideoEntryPoint_StaticPage_Fragment = (
  { __typename?: 'StaticPage' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type BlockVideoEntryPoint_NavBarEntry_Fragment = (
  { __typename?: 'NavBarEntry' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type BlockVideoEntryPoint_BlockSubNavigation_Fragment = (
  { __typename?: 'BlockSubNavigation' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type BlockVideoEntryPoint_BlockBigTitleNavigation_Fragment = (
  { __typename?: 'BlockBigTitleNavigation' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type BlockVideoEntryPoint_BlockHiddenWithConsent_Fragment = (
  { __typename?: 'BlockHiddenWithConsent' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type BlockVideoEntryPoint_BlockAccordion_Fragment = (
  { __typename?: 'BlockAccordion' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type BlockVideoEntryPoint_BlockOneColumn_Fragment = (
  { __typename?: 'BlockOneColumn' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type BlockVideoEntryPoint_BlockAnalystRating_Fragment = (
  { __typename?: 'BlockAnalystRating' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type BlockVideoEntryPoint_BlockCallToActionButton_Fragment = (
  { __typename?: 'BlockCallToActionButton' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type BlockVideoEntryPoint_BlockTwoColumn_Fragment = (
  { __typename?: 'BlockTwoColumn' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type BlockVideoEntryPoint_BlockAccordionEntry_Fragment = (
  { __typename?: 'BlockAccordionEntry' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type BlockVideoEntryPoint_NewsArticle_Fragment = (
  { __typename?: 'NewsArticle' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type BlockVideoEntryPoint_BlockRichText_Fragment = (
  { __typename?: 'BlockRichText' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type BlockVideoEntryPoint_LexiconArticle_Fragment = (
  { __typename?: 'LexiconArticle' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type BlockVideoEntryPoint_ProjectPage_Fragment = (
  { __typename?: 'ProjectPage' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type BlockVideoEntryPoint_BarChartWithBackground_Fragment = (
  { __typename?: 'BarChartWithBackground' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type BlockVideoEntryPoint_BlockCustom_Fragment = (
  { __typename?: 'BlockCustom' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type BlockVideoEntryPoint_BlockFullsizeImage_Fragment = (
  { __typename?: 'BlockFullsizeImage' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type BlockVideoEntryPoint_BlockHighlightRealEstate_Fragment = (
  { __typename?: 'BlockHighlightRealEstate' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type BlockVideoEntryPoint_HighlightedRealEstate_Fragment = (
  { __typename?: 'HighlightedRealEstate' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type BlockVideoEntryPoint_BlockPartnerGrid_Fragment = (
  { __typename?: 'BlockPartnerGrid' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type BlockVideoEntryPoint_Partner_Fragment = (
  { __typename?: 'Partner' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type BlockVideoEntryPoint_BlockPersonAccordion_Fragment = (
  { __typename?: 'BlockPersonAccordion' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type BlockVideoEntryPoint_PersonAccordionEntry_Fragment = (
  { __typename?: 'PersonAccordionEntry' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type BlockVideoEntryPoint_BlockRibbon_Fragment = (
  { __typename?: 'BlockRibbon' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type BlockVideoEntryPoint_BlockTable_Fragment = (
  { __typename?: 'BlockTable' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type BlockVideoEntryPoint_BlockThreeColumn_Fragment = (
  { __typename?: 'BlockThreeColumn' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type BlockVideoEntryPoint_BlockVideo_Fragment = (
  { __typename?: 'BlockVideo' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
  & BlockVideoFragment
);

type BlockVideoEntryPoint_NewsArticleContact_Fragment = (
  { __typename?: 'NewsArticleContact' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type BlockVideoEntryPoint_BlockSpeechBubble_Fragment = (
  { __typename?: 'BlockSpeechBubble' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type BlockVideoEntryPoint_LatestDownload_Fragment = (
  { __typename?: 'LatestDownload' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type BlockVideoEntryPoint_NavigationEntry_Fragment = (
  { __typename?: 'NavigationEntry' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type BlockVideoEntryPoint_BlockLinkSection_Fragment = (
  { __typename?: 'BlockLinkSection' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type BlockVideoEntryPoint_LinkSectionEntry_Fragment = (
  { __typename?: 'LinkSectionEntry' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type BlockVideoEntryPoint_BlockStockPrice_Fragment = (
  { __typename?: 'BlockStockPrice' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type BlockVideoEntryPoint_BlockImageGallery_Fragment = (
  { __typename?: 'BlockImageGallery' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type BlockVideoEntryPoint_BlockSlider_Fragment = (
  { __typename?: 'BlockSlider' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type BlockVideoEntryPoint_BlockSliderEntry_Fragment = (
  { __typename?: 'BlockSliderEntry' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type BlockVideoEntryPoint_BlockTextCloud_Fragment = (
  { __typename?: 'BlockTextCloud' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type BlockVideoEntryPoint_Seo_Fragment = (
  { __typename?: 'Seo' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type BlockVideoEntryPoint_RegionDescriptionText_Fragment = (
  { __typename?: 'RegionDescriptionText' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type BlockVideoEntryPoint_ProjectLink_Fragment = (
  { __typename?: 'ProjectLink' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type BlockVideoEntryPoint_BlockProjectLinkSection_Fragment = (
  { __typename?: 'BlockProjectLinkSection' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type BlockVideoEntryPoint_ProjectImageMap_Fragment = (
  { __typename?: 'ProjectImageMap' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type BlockVideoEntryPoint_DownloadableFile_Fragment = (
  { __typename?: 'DownloadableFile' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type BlockVideoEntryPoint_Footer_Fragment = (
  { __typename?: 'Footer' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

export type BlockVideoEntryPointFragment = BlockVideoEntryPoint_HeroImage_Fragment | BlockVideoEntryPoint_StaticPage_Fragment | BlockVideoEntryPoint_NavBarEntry_Fragment | BlockVideoEntryPoint_BlockSubNavigation_Fragment | BlockVideoEntryPoint_BlockBigTitleNavigation_Fragment | BlockVideoEntryPoint_BlockHiddenWithConsent_Fragment | BlockVideoEntryPoint_BlockAccordion_Fragment | BlockVideoEntryPoint_BlockOneColumn_Fragment | BlockVideoEntryPoint_BlockAnalystRating_Fragment | BlockVideoEntryPoint_BlockCallToActionButton_Fragment | BlockVideoEntryPoint_BlockTwoColumn_Fragment | BlockVideoEntryPoint_BlockAccordionEntry_Fragment | BlockVideoEntryPoint_NewsArticle_Fragment | BlockVideoEntryPoint_BlockRichText_Fragment | BlockVideoEntryPoint_LexiconArticle_Fragment | BlockVideoEntryPoint_ProjectPage_Fragment | BlockVideoEntryPoint_BarChartWithBackground_Fragment | BlockVideoEntryPoint_BlockCustom_Fragment | BlockVideoEntryPoint_BlockFullsizeImage_Fragment | BlockVideoEntryPoint_BlockHighlightRealEstate_Fragment | BlockVideoEntryPoint_HighlightedRealEstate_Fragment | BlockVideoEntryPoint_BlockPartnerGrid_Fragment | BlockVideoEntryPoint_Partner_Fragment | BlockVideoEntryPoint_BlockPersonAccordion_Fragment | BlockVideoEntryPoint_PersonAccordionEntry_Fragment | BlockVideoEntryPoint_BlockRibbon_Fragment | BlockVideoEntryPoint_BlockTable_Fragment | BlockVideoEntryPoint_BlockThreeColumn_Fragment | BlockVideoEntryPoint_BlockVideo_Fragment | BlockVideoEntryPoint_NewsArticleContact_Fragment | BlockVideoEntryPoint_BlockSpeechBubble_Fragment | BlockVideoEntryPoint_LatestDownload_Fragment | BlockVideoEntryPoint_NavigationEntry_Fragment | BlockVideoEntryPoint_BlockLinkSection_Fragment | BlockVideoEntryPoint_LinkSectionEntry_Fragment | BlockVideoEntryPoint_BlockStockPrice_Fragment | BlockVideoEntryPoint_BlockImageGallery_Fragment | BlockVideoEntryPoint_BlockSlider_Fragment | BlockVideoEntryPoint_BlockSliderEntry_Fragment | BlockVideoEntryPoint_BlockTextCloud_Fragment | BlockVideoEntryPoint_Seo_Fragment | BlockVideoEntryPoint_RegionDescriptionText_Fragment | BlockVideoEntryPoint_ProjectLink_Fragment | BlockVideoEntryPoint_BlockProjectLinkSection_Fragment | BlockVideoEntryPoint_ProjectImageMap_Fragment | BlockVideoEntryPoint_DownloadableFile_Fragment | BlockVideoEntryPoint_Footer_Fragment;

export type GetCustomBlockByIdQueryVariables = Exact<{
  locale?: Maybe<Scalars['String']>;
  preview?: Maybe<Scalars['Boolean']>;
  id: Scalars['String'];
}>;


export type GetCustomBlockByIdQuery = (
  { __typename?: 'Query' }
  & { entryCollection?: Maybe<(
    { __typename?: 'EntryCollection' }
    & { items: Array<Maybe<(
      { __typename?: 'HeroImage' }
      & CustomBlockEntryPoint_HeroImage_Fragment
    ) | (
      { __typename?: 'StaticPage' }
      & CustomBlockEntryPoint_StaticPage_Fragment
    ) | (
      { __typename?: 'NavBarEntry' }
      & CustomBlockEntryPoint_NavBarEntry_Fragment
    ) | (
      { __typename?: 'BlockSubNavigation' }
      & CustomBlockEntryPoint_BlockSubNavigation_Fragment
    ) | (
      { __typename?: 'BlockBigTitleNavigation' }
      & CustomBlockEntryPoint_BlockBigTitleNavigation_Fragment
    ) | (
      { __typename?: 'BlockHiddenWithConsent' }
      & CustomBlockEntryPoint_BlockHiddenWithConsent_Fragment
    ) | (
      { __typename?: 'BlockAccordion' }
      & CustomBlockEntryPoint_BlockAccordion_Fragment
    ) | (
      { __typename?: 'BlockOneColumn' }
      & CustomBlockEntryPoint_BlockOneColumn_Fragment
    ) | (
      { __typename?: 'BlockAnalystRating' }
      & CustomBlockEntryPoint_BlockAnalystRating_Fragment
    ) | (
      { __typename?: 'BlockCallToActionButton' }
      & CustomBlockEntryPoint_BlockCallToActionButton_Fragment
    ) | (
      { __typename?: 'BlockTwoColumn' }
      & CustomBlockEntryPoint_BlockTwoColumn_Fragment
    ) | (
      { __typename?: 'BlockAccordionEntry' }
      & CustomBlockEntryPoint_BlockAccordionEntry_Fragment
    ) | (
      { __typename?: 'NewsArticle' }
      & CustomBlockEntryPoint_NewsArticle_Fragment
    ) | (
      { __typename?: 'BlockRichText' }
      & CustomBlockEntryPoint_BlockRichText_Fragment
    ) | (
      { __typename?: 'LexiconArticle' }
      & CustomBlockEntryPoint_LexiconArticle_Fragment
    ) | (
      { __typename?: 'ProjectPage' }
      & CustomBlockEntryPoint_ProjectPage_Fragment
    ) | (
      { __typename?: 'BarChartWithBackground' }
      & CustomBlockEntryPoint_BarChartWithBackground_Fragment
    ) | (
      { __typename?: 'BlockCustom' }
      & CustomBlockEntryPoint_BlockCustom_Fragment
    ) | (
      { __typename?: 'BlockFullsizeImage' }
      & CustomBlockEntryPoint_BlockFullsizeImage_Fragment
    ) | (
      { __typename?: 'BlockHighlightRealEstate' }
      & CustomBlockEntryPoint_BlockHighlightRealEstate_Fragment
    ) | (
      { __typename?: 'HighlightedRealEstate' }
      & CustomBlockEntryPoint_HighlightedRealEstate_Fragment
    ) | (
      { __typename?: 'BlockPartnerGrid' }
      & CustomBlockEntryPoint_BlockPartnerGrid_Fragment
    ) | (
      { __typename?: 'Partner' }
      & CustomBlockEntryPoint_Partner_Fragment
    ) | (
      { __typename?: 'BlockPersonAccordion' }
      & CustomBlockEntryPoint_BlockPersonAccordion_Fragment
    ) | (
      { __typename?: 'PersonAccordionEntry' }
      & CustomBlockEntryPoint_PersonAccordionEntry_Fragment
    ) | (
      { __typename?: 'BlockRibbon' }
      & CustomBlockEntryPoint_BlockRibbon_Fragment
    ) | (
      { __typename?: 'BlockTable' }
      & CustomBlockEntryPoint_BlockTable_Fragment
    ) | (
      { __typename?: 'BlockThreeColumn' }
      & CustomBlockEntryPoint_BlockThreeColumn_Fragment
    ) | (
      { __typename?: 'BlockVideo' }
      & CustomBlockEntryPoint_BlockVideo_Fragment
    ) | (
      { __typename?: 'NewsArticleContact' }
      & CustomBlockEntryPoint_NewsArticleContact_Fragment
    ) | (
      { __typename?: 'BlockSpeechBubble' }
      & CustomBlockEntryPoint_BlockSpeechBubble_Fragment
    ) | (
      { __typename?: 'LatestDownload' }
      & CustomBlockEntryPoint_LatestDownload_Fragment
    ) | (
      { __typename?: 'NavigationEntry' }
      & CustomBlockEntryPoint_NavigationEntry_Fragment
    ) | (
      { __typename?: 'BlockLinkSection' }
      & CustomBlockEntryPoint_BlockLinkSection_Fragment
    ) | (
      { __typename?: 'LinkSectionEntry' }
      & CustomBlockEntryPoint_LinkSectionEntry_Fragment
    ) | (
      { __typename?: 'BlockStockPrice' }
      & CustomBlockEntryPoint_BlockStockPrice_Fragment
    ) | (
      { __typename?: 'BlockImageGallery' }
      & CustomBlockEntryPoint_BlockImageGallery_Fragment
    ) | (
      { __typename?: 'BlockSlider' }
      & CustomBlockEntryPoint_BlockSlider_Fragment
    ) | (
      { __typename?: 'BlockSliderEntry' }
      & CustomBlockEntryPoint_BlockSliderEntry_Fragment
    ) | (
      { __typename?: 'BlockTextCloud' }
      & CustomBlockEntryPoint_BlockTextCloud_Fragment
    ) | (
      { __typename?: 'Seo' }
      & CustomBlockEntryPoint_Seo_Fragment
    ) | (
      { __typename?: 'RegionDescriptionText' }
      & CustomBlockEntryPoint_RegionDescriptionText_Fragment
    ) | (
      { __typename?: 'ProjectLink' }
      & CustomBlockEntryPoint_ProjectLink_Fragment
    ) | (
      { __typename?: 'BlockProjectLinkSection' }
      & CustomBlockEntryPoint_BlockProjectLinkSection_Fragment
    ) | (
      { __typename?: 'ProjectImageMap' }
      & CustomBlockEntryPoint_ProjectImageMap_Fragment
    ) | (
      { __typename?: 'DownloadableFile' }
      & CustomBlockEntryPoint_DownloadableFile_Fragment
    ) | (
      { __typename?: 'Footer' }
      & CustomBlockEntryPoint_Footer_Fragment
    )>> }
  )> }
);

type CustomBlockEntryPoint_HeroImage_Fragment = (
  { __typename?: 'HeroImage' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type CustomBlockEntryPoint_StaticPage_Fragment = (
  { __typename?: 'StaticPage' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type CustomBlockEntryPoint_NavBarEntry_Fragment = (
  { __typename?: 'NavBarEntry' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type CustomBlockEntryPoint_BlockSubNavigation_Fragment = (
  { __typename?: 'BlockSubNavigation' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type CustomBlockEntryPoint_BlockBigTitleNavigation_Fragment = (
  { __typename?: 'BlockBigTitleNavigation' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type CustomBlockEntryPoint_BlockHiddenWithConsent_Fragment = (
  { __typename?: 'BlockHiddenWithConsent' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type CustomBlockEntryPoint_BlockAccordion_Fragment = (
  { __typename?: 'BlockAccordion' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type CustomBlockEntryPoint_BlockOneColumn_Fragment = (
  { __typename?: 'BlockOneColumn' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type CustomBlockEntryPoint_BlockAnalystRating_Fragment = (
  { __typename?: 'BlockAnalystRating' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type CustomBlockEntryPoint_BlockCallToActionButton_Fragment = (
  { __typename?: 'BlockCallToActionButton' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type CustomBlockEntryPoint_BlockTwoColumn_Fragment = (
  { __typename?: 'BlockTwoColumn' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type CustomBlockEntryPoint_BlockAccordionEntry_Fragment = (
  { __typename?: 'BlockAccordionEntry' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type CustomBlockEntryPoint_NewsArticle_Fragment = (
  { __typename?: 'NewsArticle' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type CustomBlockEntryPoint_BlockRichText_Fragment = (
  { __typename?: 'BlockRichText' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type CustomBlockEntryPoint_LexiconArticle_Fragment = (
  { __typename?: 'LexiconArticle' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type CustomBlockEntryPoint_ProjectPage_Fragment = (
  { __typename?: 'ProjectPage' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type CustomBlockEntryPoint_BarChartWithBackground_Fragment = (
  { __typename?: 'BarChartWithBackground' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type CustomBlockEntryPoint_BlockCustom_Fragment = (
  { __typename?: 'BlockCustom' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
  & CustomBlockFragment
);

type CustomBlockEntryPoint_BlockFullsizeImage_Fragment = (
  { __typename?: 'BlockFullsizeImage' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type CustomBlockEntryPoint_BlockHighlightRealEstate_Fragment = (
  { __typename?: 'BlockHighlightRealEstate' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type CustomBlockEntryPoint_HighlightedRealEstate_Fragment = (
  { __typename?: 'HighlightedRealEstate' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type CustomBlockEntryPoint_BlockPartnerGrid_Fragment = (
  { __typename?: 'BlockPartnerGrid' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type CustomBlockEntryPoint_Partner_Fragment = (
  { __typename?: 'Partner' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type CustomBlockEntryPoint_BlockPersonAccordion_Fragment = (
  { __typename?: 'BlockPersonAccordion' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type CustomBlockEntryPoint_PersonAccordionEntry_Fragment = (
  { __typename?: 'PersonAccordionEntry' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type CustomBlockEntryPoint_BlockRibbon_Fragment = (
  { __typename?: 'BlockRibbon' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type CustomBlockEntryPoint_BlockTable_Fragment = (
  { __typename?: 'BlockTable' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type CustomBlockEntryPoint_BlockThreeColumn_Fragment = (
  { __typename?: 'BlockThreeColumn' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type CustomBlockEntryPoint_BlockVideo_Fragment = (
  { __typename?: 'BlockVideo' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type CustomBlockEntryPoint_NewsArticleContact_Fragment = (
  { __typename?: 'NewsArticleContact' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type CustomBlockEntryPoint_BlockSpeechBubble_Fragment = (
  { __typename?: 'BlockSpeechBubble' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type CustomBlockEntryPoint_LatestDownload_Fragment = (
  { __typename?: 'LatestDownload' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type CustomBlockEntryPoint_NavigationEntry_Fragment = (
  { __typename?: 'NavigationEntry' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type CustomBlockEntryPoint_BlockLinkSection_Fragment = (
  { __typename?: 'BlockLinkSection' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type CustomBlockEntryPoint_LinkSectionEntry_Fragment = (
  { __typename?: 'LinkSectionEntry' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type CustomBlockEntryPoint_BlockStockPrice_Fragment = (
  { __typename?: 'BlockStockPrice' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type CustomBlockEntryPoint_BlockImageGallery_Fragment = (
  { __typename?: 'BlockImageGallery' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type CustomBlockEntryPoint_BlockSlider_Fragment = (
  { __typename?: 'BlockSlider' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type CustomBlockEntryPoint_BlockSliderEntry_Fragment = (
  { __typename?: 'BlockSliderEntry' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type CustomBlockEntryPoint_BlockTextCloud_Fragment = (
  { __typename?: 'BlockTextCloud' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type CustomBlockEntryPoint_Seo_Fragment = (
  { __typename?: 'Seo' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type CustomBlockEntryPoint_RegionDescriptionText_Fragment = (
  { __typename?: 'RegionDescriptionText' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type CustomBlockEntryPoint_ProjectLink_Fragment = (
  { __typename?: 'ProjectLink' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type CustomBlockEntryPoint_BlockProjectLinkSection_Fragment = (
  { __typename?: 'BlockProjectLinkSection' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type CustomBlockEntryPoint_ProjectImageMap_Fragment = (
  { __typename?: 'ProjectImageMap' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type CustomBlockEntryPoint_DownloadableFile_Fragment = (
  { __typename?: 'DownloadableFile' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type CustomBlockEntryPoint_Footer_Fragment = (
  { __typename?: 'Footer' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

export type CustomBlockEntryPointFragment = CustomBlockEntryPoint_HeroImage_Fragment | CustomBlockEntryPoint_StaticPage_Fragment | CustomBlockEntryPoint_NavBarEntry_Fragment | CustomBlockEntryPoint_BlockSubNavigation_Fragment | CustomBlockEntryPoint_BlockBigTitleNavigation_Fragment | CustomBlockEntryPoint_BlockHiddenWithConsent_Fragment | CustomBlockEntryPoint_BlockAccordion_Fragment | CustomBlockEntryPoint_BlockOneColumn_Fragment | CustomBlockEntryPoint_BlockAnalystRating_Fragment | CustomBlockEntryPoint_BlockCallToActionButton_Fragment | CustomBlockEntryPoint_BlockTwoColumn_Fragment | CustomBlockEntryPoint_BlockAccordionEntry_Fragment | CustomBlockEntryPoint_NewsArticle_Fragment | CustomBlockEntryPoint_BlockRichText_Fragment | CustomBlockEntryPoint_LexiconArticle_Fragment | CustomBlockEntryPoint_ProjectPage_Fragment | CustomBlockEntryPoint_BarChartWithBackground_Fragment | CustomBlockEntryPoint_BlockCustom_Fragment | CustomBlockEntryPoint_BlockFullsizeImage_Fragment | CustomBlockEntryPoint_BlockHighlightRealEstate_Fragment | CustomBlockEntryPoint_HighlightedRealEstate_Fragment | CustomBlockEntryPoint_BlockPartnerGrid_Fragment | CustomBlockEntryPoint_Partner_Fragment | CustomBlockEntryPoint_BlockPersonAccordion_Fragment | CustomBlockEntryPoint_PersonAccordionEntry_Fragment | CustomBlockEntryPoint_BlockRibbon_Fragment | CustomBlockEntryPoint_BlockTable_Fragment | CustomBlockEntryPoint_BlockThreeColumn_Fragment | CustomBlockEntryPoint_BlockVideo_Fragment | CustomBlockEntryPoint_NewsArticleContact_Fragment | CustomBlockEntryPoint_BlockSpeechBubble_Fragment | CustomBlockEntryPoint_LatestDownload_Fragment | CustomBlockEntryPoint_NavigationEntry_Fragment | CustomBlockEntryPoint_BlockLinkSection_Fragment | CustomBlockEntryPoint_LinkSectionEntry_Fragment | CustomBlockEntryPoint_BlockStockPrice_Fragment | CustomBlockEntryPoint_BlockImageGallery_Fragment | CustomBlockEntryPoint_BlockSlider_Fragment | CustomBlockEntryPoint_BlockSliderEntry_Fragment | CustomBlockEntryPoint_BlockTextCloud_Fragment | CustomBlockEntryPoint_Seo_Fragment | CustomBlockEntryPoint_RegionDescriptionText_Fragment | CustomBlockEntryPoint_ProjectLink_Fragment | CustomBlockEntryPoint_BlockProjectLinkSection_Fragment | CustomBlockEntryPoint_ProjectImageMap_Fragment | CustomBlockEntryPoint_DownloadableFile_Fragment | CustomBlockEntryPoint_Footer_Fragment;

export type GetFullBlockCallToActionButtonByIdQueryVariables = Exact<{
  locale?: Maybe<Scalars['String']>;
  preview?: Maybe<Scalars['Boolean']>;
  id: Scalars['String'];
}>;


export type GetFullBlockCallToActionButtonByIdQuery = (
  { __typename?: 'Query' }
  & { entryCollection?: Maybe<(
    { __typename?: 'EntryCollection' }
    & { items: Array<Maybe<(
      { __typename?: 'HeroImage' }
      & FullBlockCallToActionButtonEntryPoint_HeroImage_Fragment
    ) | (
      { __typename?: 'StaticPage' }
      & FullBlockCallToActionButtonEntryPoint_StaticPage_Fragment
    ) | (
      { __typename?: 'NavBarEntry' }
      & FullBlockCallToActionButtonEntryPoint_NavBarEntry_Fragment
    ) | (
      { __typename?: 'BlockSubNavigation' }
      & FullBlockCallToActionButtonEntryPoint_BlockSubNavigation_Fragment
    ) | (
      { __typename?: 'BlockBigTitleNavigation' }
      & FullBlockCallToActionButtonEntryPoint_BlockBigTitleNavigation_Fragment
    ) | (
      { __typename?: 'BlockHiddenWithConsent' }
      & FullBlockCallToActionButtonEntryPoint_BlockHiddenWithConsent_Fragment
    ) | (
      { __typename?: 'BlockAccordion' }
      & FullBlockCallToActionButtonEntryPoint_BlockAccordion_Fragment
    ) | (
      { __typename?: 'BlockOneColumn' }
      & FullBlockCallToActionButtonEntryPoint_BlockOneColumn_Fragment
    ) | (
      { __typename?: 'BlockAnalystRating' }
      & FullBlockCallToActionButtonEntryPoint_BlockAnalystRating_Fragment
    ) | (
      { __typename?: 'BlockCallToActionButton' }
      & FullBlockCallToActionButtonEntryPoint_BlockCallToActionButton_Fragment
    ) | (
      { __typename?: 'BlockTwoColumn' }
      & FullBlockCallToActionButtonEntryPoint_BlockTwoColumn_Fragment
    ) | (
      { __typename?: 'BlockAccordionEntry' }
      & FullBlockCallToActionButtonEntryPoint_BlockAccordionEntry_Fragment
    ) | (
      { __typename?: 'NewsArticle' }
      & FullBlockCallToActionButtonEntryPoint_NewsArticle_Fragment
    ) | (
      { __typename?: 'BlockRichText' }
      & FullBlockCallToActionButtonEntryPoint_BlockRichText_Fragment
    ) | (
      { __typename?: 'LexiconArticle' }
      & FullBlockCallToActionButtonEntryPoint_LexiconArticle_Fragment
    ) | (
      { __typename?: 'ProjectPage' }
      & FullBlockCallToActionButtonEntryPoint_ProjectPage_Fragment
    ) | (
      { __typename?: 'BarChartWithBackground' }
      & FullBlockCallToActionButtonEntryPoint_BarChartWithBackground_Fragment
    ) | (
      { __typename?: 'BlockCustom' }
      & FullBlockCallToActionButtonEntryPoint_BlockCustom_Fragment
    ) | (
      { __typename?: 'BlockFullsizeImage' }
      & FullBlockCallToActionButtonEntryPoint_BlockFullsizeImage_Fragment
    ) | (
      { __typename?: 'BlockHighlightRealEstate' }
      & FullBlockCallToActionButtonEntryPoint_BlockHighlightRealEstate_Fragment
    ) | (
      { __typename?: 'HighlightedRealEstate' }
      & FullBlockCallToActionButtonEntryPoint_HighlightedRealEstate_Fragment
    ) | (
      { __typename?: 'BlockPartnerGrid' }
      & FullBlockCallToActionButtonEntryPoint_BlockPartnerGrid_Fragment
    ) | (
      { __typename?: 'Partner' }
      & FullBlockCallToActionButtonEntryPoint_Partner_Fragment
    ) | (
      { __typename?: 'BlockPersonAccordion' }
      & FullBlockCallToActionButtonEntryPoint_BlockPersonAccordion_Fragment
    ) | (
      { __typename?: 'PersonAccordionEntry' }
      & FullBlockCallToActionButtonEntryPoint_PersonAccordionEntry_Fragment
    ) | (
      { __typename?: 'BlockRibbon' }
      & FullBlockCallToActionButtonEntryPoint_BlockRibbon_Fragment
    ) | (
      { __typename?: 'BlockTable' }
      & FullBlockCallToActionButtonEntryPoint_BlockTable_Fragment
    ) | (
      { __typename?: 'BlockThreeColumn' }
      & FullBlockCallToActionButtonEntryPoint_BlockThreeColumn_Fragment
    ) | (
      { __typename?: 'BlockVideo' }
      & FullBlockCallToActionButtonEntryPoint_BlockVideo_Fragment
    ) | (
      { __typename?: 'NewsArticleContact' }
      & FullBlockCallToActionButtonEntryPoint_NewsArticleContact_Fragment
    ) | (
      { __typename?: 'BlockSpeechBubble' }
      & FullBlockCallToActionButtonEntryPoint_BlockSpeechBubble_Fragment
    ) | (
      { __typename?: 'LatestDownload' }
      & FullBlockCallToActionButtonEntryPoint_LatestDownload_Fragment
    ) | (
      { __typename?: 'NavigationEntry' }
      & FullBlockCallToActionButtonEntryPoint_NavigationEntry_Fragment
    ) | (
      { __typename?: 'BlockLinkSection' }
      & FullBlockCallToActionButtonEntryPoint_BlockLinkSection_Fragment
    ) | (
      { __typename?: 'LinkSectionEntry' }
      & FullBlockCallToActionButtonEntryPoint_LinkSectionEntry_Fragment
    ) | (
      { __typename?: 'BlockStockPrice' }
      & FullBlockCallToActionButtonEntryPoint_BlockStockPrice_Fragment
    ) | (
      { __typename?: 'BlockImageGallery' }
      & FullBlockCallToActionButtonEntryPoint_BlockImageGallery_Fragment
    ) | (
      { __typename?: 'BlockSlider' }
      & FullBlockCallToActionButtonEntryPoint_BlockSlider_Fragment
    ) | (
      { __typename?: 'BlockSliderEntry' }
      & FullBlockCallToActionButtonEntryPoint_BlockSliderEntry_Fragment
    ) | (
      { __typename?: 'BlockTextCloud' }
      & FullBlockCallToActionButtonEntryPoint_BlockTextCloud_Fragment
    ) | (
      { __typename?: 'Seo' }
      & FullBlockCallToActionButtonEntryPoint_Seo_Fragment
    ) | (
      { __typename?: 'RegionDescriptionText' }
      & FullBlockCallToActionButtonEntryPoint_RegionDescriptionText_Fragment
    ) | (
      { __typename?: 'ProjectLink' }
      & FullBlockCallToActionButtonEntryPoint_ProjectLink_Fragment
    ) | (
      { __typename?: 'BlockProjectLinkSection' }
      & FullBlockCallToActionButtonEntryPoint_BlockProjectLinkSection_Fragment
    ) | (
      { __typename?: 'ProjectImageMap' }
      & FullBlockCallToActionButtonEntryPoint_ProjectImageMap_Fragment
    ) | (
      { __typename?: 'DownloadableFile' }
      & FullBlockCallToActionButtonEntryPoint_DownloadableFile_Fragment
    ) | (
      { __typename?: 'Footer' }
      & FullBlockCallToActionButtonEntryPoint_Footer_Fragment
    )>> }
  )> }
);

type FullBlockCallToActionButtonEntryPoint_HeroImage_Fragment = (
  { __typename?: 'HeroImage' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type FullBlockCallToActionButtonEntryPoint_StaticPage_Fragment = (
  { __typename?: 'StaticPage' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type FullBlockCallToActionButtonEntryPoint_NavBarEntry_Fragment = (
  { __typename?: 'NavBarEntry' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type FullBlockCallToActionButtonEntryPoint_BlockSubNavigation_Fragment = (
  { __typename?: 'BlockSubNavigation' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type FullBlockCallToActionButtonEntryPoint_BlockBigTitleNavigation_Fragment = (
  { __typename?: 'BlockBigTitleNavigation' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type FullBlockCallToActionButtonEntryPoint_BlockHiddenWithConsent_Fragment = (
  { __typename?: 'BlockHiddenWithConsent' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type FullBlockCallToActionButtonEntryPoint_BlockAccordion_Fragment = (
  { __typename?: 'BlockAccordion' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type FullBlockCallToActionButtonEntryPoint_BlockOneColumn_Fragment = (
  { __typename?: 'BlockOneColumn' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type FullBlockCallToActionButtonEntryPoint_BlockAnalystRating_Fragment = (
  { __typename?: 'BlockAnalystRating' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type FullBlockCallToActionButtonEntryPoint_BlockCallToActionButton_Fragment = (
  { __typename?: 'BlockCallToActionButton' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
  & FullBlockCallToActionButtonFragment
);

type FullBlockCallToActionButtonEntryPoint_BlockTwoColumn_Fragment = (
  { __typename?: 'BlockTwoColumn' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type FullBlockCallToActionButtonEntryPoint_BlockAccordionEntry_Fragment = (
  { __typename?: 'BlockAccordionEntry' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type FullBlockCallToActionButtonEntryPoint_NewsArticle_Fragment = (
  { __typename?: 'NewsArticle' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type FullBlockCallToActionButtonEntryPoint_BlockRichText_Fragment = (
  { __typename?: 'BlockRichText' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type FullBlockCallToActionButtonEntryPoint_LexiconArticle_Fragment = (
  { __typename?: 'LexiconArticle' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type FullBlockCallToActionButtonEntryPoint_ProjectPage_Fragment = (
  { __typename?: 'ProjectPage' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type FullBlockCallToActionButtonEntryPoint_BarChartWithBackground_Fragment = (
  { __typename?: 'BarChartWithBackground' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type FullBlockCallToActionButtonEntryPoint_BlockCustom_Fragment = (
  { __typename?: 'BlockCustom' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type FullBlockCallToActionButtonEntryPoint_BlockFullsizeImage_Fragment = (
  { __typename?: 'BlockFullsizeImage' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type FullBlockCallToActionButtonEntryPoint_BlockHighlightRealEstate_Fragment = (
  { __typename?: 'BlockHighlightRealEstate' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type FullBlockCallToActionButtonEntryPoint_HighlightedRealEstate_Fragment = (
  { __typename?: 'HighlightedRealEstate' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type FullBlockCallToActionButtonEntryPoint_BlockPartnerGrid_Fragment = (
  { __typename?: 'BlockPartnerGrid' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type FullBlockCallToActionButtonEntryPoint_Partner_Fragment = (
  { __typename?: 'Partner' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type FullBlockCallToActionButtonEntryPoint_BlockPersonAccordion_Fragment = (
  { __typename?: 'BlockPersonAccordion' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type FullBlockCallToActionButtonEntryPoint_PersonAccordionEntry_Fragment = (
  { __typename?: 'PersonAccordionEntry' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type FullBlockCallToActionButtonEntryPoint_BlockRibbon_Fragment = (
  { __typename?: 'BlockRibbon' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type FullBlockCallToActionButtonEntryPoint_BlockTable_Fragment = (
  { __typename?: 'BlockTable' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type FullBlockCallToActionButtonEntryPoint_BlockThreeColumn_Fragment = (
  { __typename?: 'BlockThreeColumn' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type FullBlockCallToActionButtonEntryPoint_BlockVideo_Fragment = (
  { __typename?: 'BlockVideo' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type FullBlockCallToActionButtonEntryPoint_NewsArticleContact_Fragment = (
  { __typename?: 'NewsArticleContact' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type FullBlockCallToActionButtonEntryPoint_BlockSpeechBubble_Fragment = (
  { __typename?: 'BlockSpeechBubble' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type FullBlockCallToActionButtonEntryPoint_LatestDownload_Fragment = (
  { __typename?: 'LatestDownload' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type FullBlockCallToActionButtonEntryPoint_NavigationEntry_Fragment = (
  { __typename?: 'NavigationEntry' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type FullBlockCallToActionButtonEntryPoint_BlockLinkSection_Fragment = (
  { __typename?: 'BlockLinkSection' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type FullBlockCallToActionButtonEntryPoint_LinkSectionEntry_Fragment = (
  { __typename?: 'LinkSectionEntry' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type FullBlockCallToActionButtonEntryPoint_BlockStockPrice_Fragment = (
  { __typename?: 'BlockStockPrice' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type FullBlockCallToActionButtonEntryPoint_BlockImageGallery_Fragment = (
  { __typename?: 'BlockImageGallery' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type FullBlockCallToActionButtonEntryPoint_BlockSlider_Fragment = (
  { __typename?: 'BlockSlider' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type FullBlockCallToActionButtonEntryPoint_BlockSliderEntry_Fragment = (
  { __typename?: 'BlockSliderEntry' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type FullBlockCallToActionButtonEntryPoint_BlockTextCloud_Fragment = (
  { __typename?: 'BlockTextCloud' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type FullBlockCallToActionButtonEntryPoint_Seo_Fragment = (
  { __typename?: 'Seo' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type FullBlockCallToActionButtonEntryPoint_RegionDescriptionText_Fragment = (
  { __typename?: 'RegionDescriptionText' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type FullBlockCallToActionButtonEntryPoint_ProjectLink_Fragment = (
  { __typename?: 'ProjectLink' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type FullBlockCallToActionButtonEntryPoint_BlockProjectLinkSection_Fragment = (
  { __typename?: 'BlockProjectLinkSection' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type FullBlockCallToActionButtonEntryPoint_ProjectImageMap_Fragment = (
  { __typename?: 'ProjectImageMap' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type FullBlockCallToActionButtonEntryPoint_DownloadableFile_Fragment = (
  { __typename?: 'DownloadableFile' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type FullBlockCallToActionButtonEntryPoint_Footer_Fragment = (
  { __typename?: 'Footer' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

export type FullBlockCallToActionButtonEntryPointFragment = FullBlockCallToActionButtonEntryPoint_HeroImage_Fragment | FullBlockCallToActionButtonEntryPoint_StaticPage_Fragment | FullBlockCallToActionButtonEntryPoint_NavBarEntry_Fragment | FullBlockCallToActionButtonEntryPoint_BlockSubNavigation_Fragment | FullBlockCallToActionButtonEntryPoint_BlockBigTitleNavigation_Fragment | FullBlockCallToActionButtonEntryPoint_BlockHiddenWithConsent_Fragment | FullBlockCallToActionButtonEntryPoint_BlockAccordion_Fragment | FullBlockCallToActionButtonEntryPoint_BlockOneColumn_Fragment | FullBlockCallToActionButtonEntryPoint_BlockAnalystRating_Fragment | FullBlockCallToActionButtonEntryPoint_BlockCallToActionButton_Fragment | FullBlockCallToActionButtonEntryPoint_BlockTwoColumn_Fragment | FullBlockCallToActionButtonEntryPoint_BlockAccordionEntry_Fragment | FullBlockCallToActionButtonEntryPoint_NewsArticle_Fragment | FullBlockCallToActionButtonEntryPoint_BlockRichText_Fragment | FullBlockCallToActionButtonEntryPoint_LexiconArticle_Fragment | FullBlockCallToActionButtonEntryPoint_ProjectPage_Fragment | FullBlockCallToActionButtonEntryPoint_BarChartWithBackground_Fragment | FullBlockCallToActionButtonEntryPoint_BlockCustom_Fragment | FullBlockCallToActionButtonEntryPoint_BlockFullsizeImage_Fragment | FullBlockCallToActionButtonEntryPoint_BlockHighlightRealEstate_Fragment | FullBlockCallToActionButtonEntryPoint_HighlightedRealEstate_Fragment | FullBlockCallToActionButtonEntryPoint_BlockPartnerGrid_Fragment | FullBlockCallToActionButtonEntryPoint_Partner_Fragment | FullBlockCallToActionButtonEntryPoint_BlockPersonAccordion_Fragment | FullBlockCallToActionButtonEntryPoint_PersonAccordionEntry_Fragment | FullBlockCallToActionButtonEntryPoint_BlockRibbon_Fragment | FullBlockCallToActionButtonEntryPoint_BlockTable_Fragment | FullBlockCallToActionButtonEntryPoint_BlockThreeColumn_Fragment | FullBlockCallToActionButtonEntryPoint_BlockVideo_Fragment | FullBlockCallToActionButtonEntryPoint_NewsArticleContact_Fragment | FullBlockCallToActionButtonEntryPoint_BlockSpeechBubble_Fragment | FullBlockCallToActionButtonEntryPoint_LatestDownload_Fragment | FullBlockCallToActionButtonEntryPoint_NavigationEntry_Fragment | FullBlockCallToActionButtonEntryPoint_BlockLinkSection_Fragment | FullBlockCallToActionButtonEntryPoint_LinkSectionEntry_Fragment | FullBlockCallToActionButtonEntryPoint_BlockStockPrice_Fragment | FullBlockCallToActionButtonEntryPoint_BlockImageGallery_Fragment | FullBlockCallToActionButtonEntryPoint_BlockSlider_Fragment | FullBlockCallToActionButtonEntryPoint_BlockSliderEntry_Fragment | FullBlockCallToActionButtonEntryPoint_BlockTextCloud_Fragment | FullBlockCallToActionButtonEntryPoint_Seo_Fragment | FullBlockCallToActionButtonEntryPoint_RegionDescriptionText_Fragment | FullBlockCallToActionButtonEntryPoint_ProjectLink_Fragment | FullBlockCallToActionButtonEntryPoint_BlockProjectLinkSection_Fragment | FullBlockCallToActionButtonEntryPoint_ProjectImageMap_Fragment | FullBlockCallToActionButtonEntryPoint_DownloadableFile_Fragment | FullBlockCallToActionButtonEntryPoint_Footer_Fragment;

export type GetFullBlockFullsizeImageByIdQueryVariables = Exact<{
  locale?: Maybe<Scalars['String']>;
  preview?: Maybe<Scalars['Boolean']>;
  id: Scalars['String'];
}>;


export type GetFullBlockFullsizeImageByIdQuery = (
  { __typename?: 'Query' }
  & { entryCollection?: Maybe<(
    { __typename?: 'EntryCollection' }
    & { items: Array<Maybe<(
      { __typename?: 'HeroImage' }
      & FullBlockFullsizeImageEntryPoint_HeroImage_Fragment
    ) | (
      { __typename?: 'StaticPage' }
      & FullBlockFullsizeImageEntryPoint_StaticPage_Fragment
    ) | (
      { __typename?: 'NavBarEntry' }
      & FullBlockFullsizeImageEntryPoint_NavBarEntry_Fragment
    ) | (
      { __typename?: 'BlockSubNavigation' }
      & FullBlockFullsizeImageEntryPoint_BlockSubNavigation_Fragment
    ) | (
      { __typename?: 'BlockBigTitleNavigation' }
      & FullBlockFullsizeImageEntryPoint_BlockBigTitleNavigation_Fragment
    ) | (
      { __typename?: 'BlockHiddenWithConsent' }
      & FullBlockFullsizeImageEntryPoint_BlockHiddenWithConsent_Fragment
    ) | (
      { __typename?: 'BlockAccordion' }
      & FullBlockFullsizeImageEntryPoint_BlockAccordion_Fragment
    ) | (
      { __typename?: 'BlockOneColumn' }
      & FullBlockFullsizeImageEntryPoint_BlockOneColumn_Fragment
    ) | (
      { __typename?: 'BlockAnalystRating' }
      & FullBlockFullsizeImageEntryPoint_BlockAnalystRating_Fragment
    ) | (
      { __typename?: 'BlockCallToActionButton' }
      & FullBlockFullsizeImageEntryPoint_BlockCallToActionButton_Fragment
    ) | (
      { __typename?: 'BlockTwoColumn' }
      & FullBlockFullsizeImageEntryPoint_BlockTwoColumn_Fragment
    ) | (
      { __typename?: 'BlockAccordionEntry' }
      & FullBlockFullsizeImageEntryPoint_BlockAccordionEntry_Fragment
    ) | (
      { __typename?: 'NewsArticle' }
      & FullBlockFullsizeImageEntryPoint_NewsArticle_Fragment
    ) | (
      { __typename?: 'BlockRichText' }
      & FullBlockFullsizeImageEntryPoint_BlockRichText_Fragment
    ) | (
      { __typename?: 'LexiconArticle' }
      & FullBlockFullsizeImageEntryPoint_LexiconArticle_Fragment
    ) | (
      { __typename?: 'ProjectPage' }
      & FullBlockFullsizeImageEntryPoint_ProjectPage_Fragment
    ) | (
      { __typename?: 'BarChartWithBackground' }
      & FullBlockFullsizeImageEntryPoint_BarChartWithBackground_Fragment
    ) | (
      { __typename?: 'BlockCustom' }
      & FullBlockFullsizeImageEntryPoint_BlockCustom_Fragment
    ) | (
      { __typename?: 'BlockFullsizeImage' }
      & FullBlockFullsizeImageEntryPoint_BlockFullsizeImage_Fragment
    ) | (
      { __typename?: 'BlockHighlightRealEstate' }
      & FullBlockFullsizeImageEntryPoint_BlockHighlightRealEstate_Fragment
    ) | (
      { __typename?: 'HighlightedRealEstate' }
      & FullBlockFullsizeImageEntryPoint_HighlightedRealEstate_Fragment
    ) | (
      { __typename?: 'BlockPartnerGrid' }
      & FullBlockFullsizeImageEntryPoint_BlockPartnerGrid_Fragment
    ) | (
      { __typename?: 'Partner' }
      & FullBlockFullsizeImageEntryPoint_Partner_Fragment
    ) | (
      { __typename?: 'BlockPersonAccordion' }
      & FullBlockFullsizeImageEntryPoint_BlockPersonAccordion_Fragment
    ) | (
      { __typename?: 'PersonAccordionEntry' }
      & FullBlockFullsizeImageEntryPoint_PersonAccordionEntry_Fragment
    ) | (
      { __typename?: 'BlockRibbon' }
      & FullBlockFullsizeImageEntryPoint_BlockRibbon_Fragment
    ) | (
      { __typename?: 'BlockTable' }
      & FullBlockFullsizeImageEntryPoint_BlockTable_Fragment
    ) | (
      { __typename?: 'BlockThreeColumn' }
      & FullBlockFullsizeImageEntryPoint_BlockThreeColumn_Fragment
    ) | (
      { __typename?: 'BlockVideo' }
      & FullBlockFullsizeImageEntryPoint_BlockVideo_Fragment
    ) | (
      { __typename?: 'NewsArticleContact' }
      & FullBlockFullsizeImageEntryPoint_NewsArticleContact_Fragment
    ) | (
      { __typename?: 'BlockSpeechBubble' }
      & FullBlockFullsizeImageEntryPoint_BlockSpeechBubble_Fragment
    ) | (
      { __typename?: 'LatestDownload' }
      & FullBlockFullsizeImageEntryPoint_LatestDownload_Fragment
    ) | (
      { __typename?: 'NavigationEntry' }
      & FullBlockFullsizeImageEntryPoint_NavigationEntry_Fragment
    ) | (
      { __typename?: 'BlockLinkSection' }
      & FullBlockFullsizeImageEntryPoint_BlockLinkSection_Fragment
    ) | (
      { __typename?: 'LinkSectionEntry' }
      & FullBlockFullsizeImageEntryPoint_LinkSectionEntry_Fragment
    ) | (
      { __typename?: 'BlockStockPrice' }
      & FullBlockFullsizeImageEntryPoint_BlockStockPrice_Fragment
    ) | (
      { __typename?: 'BlockImageGallery' }
      & FullBlockFullsizeImageEntryPoint_BlockImageGallery_Fragment
    ) | (
      { __typename?: 'BlockSlider' }
      & FullBlockFullsizeImageEntryPoint_BlockSlider_Fragment
    ) | (
      { __typename?: 'BlockSliderEntry' }
      & FullBlockFullsizeImageEntryPoint_BlockSliderEntry_Fragment
    ) | (
      { __typename?: 'BlockTextCloud' }
      & FullBlockFullsizeImageEntryPoint_BlockTextCloud_Fragment
    ) | (
      { __typename?: 'Seo' }
      & FullBlockFullsizeImageEntryPoint_Seo_Fragment
    ) | (
      { __typename?: 'RegionDescriptionText' }
      & FullBlockFullsizeImageEntryPoint_RegionDescriptionText_Fragment
    ) | (
      { __typename?: 'ProjectLink' }
      & FullBlockFullsizeImageEntryPoint_ProjectLink_Fragment
    ) | (
      { __typename?: 'BlockProjectLinkSection' }
      & FullBlockFullsizeImageEntryPoint_BlockProjectLinkSection_Fragment
    ) | (
      { __typename?: 'ProjectImageMap' }
      & FullBlockFullsizeImageEntryPoint_ProjectImageMap_Fragment
    ) | (
      { __typename?: 'DownloadableFile' }
      & FullBlockFullsizeImageEntryPoint_DownloadableFile_Fragment
    ) | (
      { __typename?: 'Footer' }
      & FullBlockFullsizeImageEntryPoint_Footer_Fragment
    )>> }
  )> }
);

type FullBlockFullsizeImageEntryPoint_HeroImage_Fragment = (
  { __typename?: 'HeroImage' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type FullBlockFullsizeImageEntryPoint_StaticPage_Fragment = (
  { __typename?: 'StaticPage' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type FullBlockFullsizeImageEntryPoint_NavBarEntry_Fragment = (
  { __typename?: 'NavBarEntry' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type FullBlockFullsizeImageEntryPoint_BlockSubNavigation_Fragment = (
  { __typename?: 'BlockSubNavigation' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type FullBlockFullsizeImageEntryPoint_BlockBigTitleNavigation_Fragment = (
  { __typename?: 'BlockBigTitleNavigation' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type FullBlockFullsizeImageEntryPoint_BlockHiddenWithConsent_Fragment = (
  { __typename?: 'BlockHiddenWithConsent' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type FullBlockFullsizeImageEntryPoint_BlockAccordion_Fragment = (
  { __typename?: 'BlockAccordion' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type FullBlockFullsizeImageEntryPoint_BlockOneColumn_Fragment = (
  { __typename?: 'BlockOneColumn' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type FullBlockFullsizeImageEntryPoint_BlockAnalystRating_Fragment = (
  { __typename?: 'BlockAnalystRating' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type FullBlockFullsizeImageEntryPoint_BlockCallToActionButton_Fragment = (
  { __typename?: 'BlockCallToActionButton' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type FullBlockFullsizeImageEntryPoint_BlockTwoColumn_Fragment = (
  { __typename?: 'BlockTwoColumn' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type FullBlockFullsizeImageEntryPoint_BlockAccordionEntry_Fragment = (
  { __typename?: 'BlockAccordionEntry' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type FullBlockFullsizeImageEntryPoint_NewsArticle_Fragment = (
  { __typename?: 'NewsArticle' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type FullBlockFullsizeImageEntryPoint_BlockRichText_Fragment = (
  { __typename?: 'BlockRichText' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type FullBlockFullsizeImageEntryPoint_LexiconArticle_Fragment = (
  { __typename?: 'LexiconArticle' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type FullBlockFullsizeImageEntryPoint_ProjectPage_Fragment = (
  { __typename?: 'ProjectPage' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type FullBlockFullsizeImageEntryPoint_BarChartWithBackground_Fragment = (
  { __typename?: 'BarChartWithBackground' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type FullBlockFullsizeImageEntryPoint_BlockCustom_Fragment = (
  { __typename?: 'BlockCustom' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type FullBlockFullsizeImageEntryPoint_BlockFullsizeImage_Fragment = (
  { __typename?: 'BlockFullsizeImage' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
  & FullBlockFullsizeImageFragment
);

type FullBlockFullsizeImageEntryPoint_BlockHighlightRealEstate_Fragment = (
  { __typename?: 'BlockHighlightRealEstate' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type FullBlockFullsizeImageEntryPoint_HighlightedRealEstate_Fragment = (
  { __typename?: 'HighlightedRealEstate' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type FullBlockFullsizeImageEntryPoint_BlockPartnerGrid_Fragment = (
  { __typename?: 'BlockPartnerGrid' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type FullBlockFullsizeImageEntryPoint_Partner_Fragment = (
  { __typename?: 'Partner' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type FullBlockFullsizeImageEntryPoint_BlockPersonAccordion_Fragment = (
  { __typename?: 'BlockPersonAccordion' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type FullBlockFullsizeImageEntryPoint_PersonAccordionEntry_Fragment = (
  { __typename?: 'PersonAccordionEntry' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type FullBlockFullsizeImageEntryPoint_BlockRibbon_Fragment = (
  { __typename?: 'BlockRibbon' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type FullBlockFullsizeImageEntryPoint_BlockTable_Fragment = (
  { __typename?: 'BlockTable' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type FullBlockFullsizeImageEntryPoint_BlockThreeColumn_Fragment = (
  { __typename?: 'BlockThreeColumn' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type FullBlockFullsizeImageEntryPoint_BlockVideo_Fragment = (
  { __typename?: 'BlockVideo' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type FullBlockFullsizeImageEntryPoint_NewsArticleContact_Fragment = (
  { __typename?: 'NewsArticleContact' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type FullBlockFullsizeImageEntryPoint_BlockSpeechBubble_Fragment = (
  { __typename?: 'BlockSpeechBubble' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type FullBlockFullsizeImageEntryPoint_LatestDownload_Fragment = (
  { __typename?: 'LatestDownload' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type FullBlockFullsizeImageEntryPoint_NavigationEntry_Fragment = (
  { __typename?: 'NavigationEntry' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type FullBlockFullsizeImageEntryPoint_BlockLinkSection_Fragment = (
  { __typename?: 'BlockLinkSection' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type FullBlockFullsizeImageEntryPoint_LinkSectionEntry_Fragment = (
  { __typename?: 'LinkSectionEntry' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type FullBlockFullsizeImageEntryPoint_BlockStockPrice_Fragment = (
  { __typename?: 'BlockStockPrice' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type FullBlockFullsizeImageEntryPoint_BlockImageGallery_Fragment = (
  { __typename?: 'BlockImageGallery' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type FullBlockFullsizeImageEntryPoint_BlockSlider_Fragment = (
  { __typename?: 'BlockSlider' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type FullBlockFullsizeImageEntryPoint_BlockSliderEntry_Fragment = (
  { __typename?: 'BlockSliderEntry' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type FullBlockFullsizeImageEntryPoint_BlockTextCloud_Fragment = (
  { __typename?: 'BlockTextCloud' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type FullBlockFullsizeImageEntryPoint_Seo_Fragment = (
  { __typename?: 'Seo' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type FullBlockFullsizeImageEntryPoint_RegionDescriptionText_Fragment = (
  { __typename?: 'RegionDescriptionText' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type FullBlockFullsizeImageEntryPoint_ProjectLink_Fragment = (
  { __typename?: 'ProjectLink' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type FullBlockFullsizeImageEntryPoint_BlockProjectLinkSection_Fragment = (
  { __typename?: 'BlockProjectLinkSection' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type FullBlockFullsizeImageEntryPoint_ProjectImageMap_Fragment = (
  { __typename?: 'ProjectImageMap' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type FullBlockFullsizeImageEntryPoint_DownloadableFile_Fragment = (
  { __typename?: 'DownloadableFile' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type FullBlockFullsizeImageEntryPoint_Footer_Fragment = (
  { __typename?: 'Footer' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

export type FullBlockFullsizeImageEntryPointFragment = FullBlockFullsizeImageEntryPoint_HeroImage_Fragment | FullBlockFullsizeImageEntryPoint_StaticPage_Fragment | FullBlockFullsizeImageEntryPoint_NavBarEntry_Fragment | FullBlockFullsizeImageEntryPoint_BlockSubNavigation_Fragment | FullBlockFullsizeImageEntryPoint_BlockBigTitleNavigation_Fragment | FullBlockFullsizeImageEntryPoint_BlockHiddenWithConsent_Fragment | FullBlockFullsizeImageEntryPoint_BlockAccordion_Fragment | FullBlockFullsizeImageEntryPoint_BlockOneColumn_Fragment | FullBlockFullsizeImageEntryPoint_BlockAnalystRating_Fragment | FullBlockFullsizeImageEntryPoint_BlockCallToActionButton_Fragment | FullBlockFullsizeImageEntryPoint_BlockTwoColumn_Fragment | FullBlockFullsizeImageEntryPoint_BlockAccordionEntry_Fragment | FullBlockFullsizeImageEntryPoint_NewsArticle_Fragment | FullBlockFullsizeImageEntryPoint_BlockRichText_Fragment | FullBlockFullsizeImageEntryPoint_LexiconArticle_Fragment | FullBlockFullsizeImageEntryPoint_ProjectPage_Fragment | FullBlockFullsizeImageEntryPoint_BarChartWithBackground_Fragment | FullBlockFullsizeImageEntryPoint_BlockCustom_Fragment | FullBlockFullsizeImageEntryPoint_BlockFullsizeImage_Fragment | FullBlockFullsizeImageEntryPoint_BlockHighlightRealEstate_Fragment | FullBlockFullsizeImageEntryPoint_HighlightedRealEstate_Fragment | FullBlockFullsizeImageEntryPoint_BlockPartnerGrid_Fragment | FullBlockFullsizeImageEntryPoint_Partner_Fragment | FullBlockFullsizeImageEntryPoint_BlockPersonAccordion_Fragment | FullBlockFullsizeImageEntryPoint_PersonAccordionEntry_Fragment | FullBlockFullsizeImageEntryPoint_BlockRibbon_Fragment | FullBlockFullsizeImageEntryPoint_BlockTable_Fragment | FullBlockFullsizeImageEntryPoint_BlockThreeColumn_Fragment | FullBlockFullsizeImageEntryPoint_BlockVideo_Fragment | FullBlockFullsizeImageEntryPoint_NewsArticleContact_Fragment | FullBlockFullsizeImageEntryPoint_BlockSpeechBubble_Fragment | FullBlockFullsizeImageEntryPoint_LatestDownload_Fragment | FullBlockFullsizeImageEntryPoint_NavigationEntry_Fragment | FullBlockFullsizeImageEntryPoint_BlockLinkSection_Fragment | FullBlockFullsizeImageEntryPoint_LinkSectionEntry_Fragment | FullBlockFullsizeImageEntryPoint_BlockStockPrice_Fragment | FullBlockFullsizeImageEntryPoint_BlockImageGallery_Fragment | FullBlockFullsizeImageEntryPoint_BlockSlider_Fragment | FullBlockFullsizeImageEntryPoint_BlockSliderEntry_Fragment | FullBlockFullsizeImageEntryPoint_BlockTextCloud_Fragment | FullBlockFullsizeImageEntryPoint_Seo_Fragment | FullBlockFullsizeImageEntryPoint_RegionDescriptionText_Fragment | FullBlockFullsizeImageEntryPoint_ProjectLink_Fragment | FullBlockFullsizeImageEntryPoint_BlockProjectLinkSection_Fragment | FullBlockFullsizeImageEntryPoint_ProjectImageMap_Fragment | FullBlockFullsizeImageEntryPoint_DownloadableFile_Fragment | FullBlockFullsizeImageEntryPoint_Footer_Fragment;

export type GetFullBlockRibbonByIdQueryVariables = Exact<{
  locale?: Maybe<Scalars['String']>;
  preview?: Maybe<Scalars['Boolean']>;
  id: Scalars['String'];
}>;


export type GetFullBlockRibbonByIdQuery = (
  { __typename?: 'Query' }
  & { entryCollection?: Maybe<(
    { __typename?: 'EntryCollection' }
    & { items: Array<Maybe<(
      { __typename?: 'HeroImage' }
      & FullBlockRibbonEntryPoint_HeroImage_Fragment
    ) | (
      { __typename?: 'StaticPage' }
      & FullBlockRibbonEntryPoint_StaticPage_Fragment
    ) | (
      { __typename?: 'NavBarEntry' }
      & FullBlockRibbonEntryPoint_NavBarEntry_Fragment
    ) | (
      { __typename?: 'BlockSubNavigation' }
      & FullBlockRibbonEntryPoint_BlockSubNavigation_Fragment
    ) | (
      { __typename?: 'BlockBigTitleNavigation' }
      & FullBlockRibbonEntryPoint_BlockBigTitleNavigation_Fragment
    ) | (
      { __typename?: 'BlockHiddenWithConsent' }
      & FullBlockRibbonEntryPoint_BlockHiddenWithConsent_Fragment
    ) | (
      { __typename?: 'BlockAccordion' }
      & FullBlockRibbonEntryPoint_BlockAccordion_Fragment
    ) | (
      { __typename?: 'BlockOneColumn' }
      & FullBlockRibbonEntryPoint_BlockOneColumn_Fragment
    ) | (
      { __typename?: 'BlockAnalystRating' }
      & FullBlockRibbonEntryPoint_BlockAnalystRating_Fragment
    ) | (
      { __typename?: 'BlockCallToActionButton' }
      & FullBlockRibbonEntryPoint_BlockCallToActionButton_Fragment
    ) | (
      { __typename?: 'BlockTwoColumn' }
      & FullBlockRibbonEntryPoint_BlockTwoColumn_Fragment
    ) | (
      { __typename?: 'BlockAccordionEntry' }
      & FullBlockRibbonEntryPoint_BlockAccordionEntry_Fragment
    ) | (
      { __typename?: 'NewsArticle' }
      & FullBlockRibbonEntryPoint_NewsArticle_Fragment
    ) | (
      { __typename?: 'BlockRichText' }
      & FullBlockRibbonEntryPoint_BlockRichText_Fragment
    ) | (
      { __typename?: 'LexiconArticle' }
      & FullBlockRibbonEntryPoint_LexiconArticle_Fragment
    ) | (
      { __typename?: 'ProjectPage' }
      & FullBlockRibbonEntryPoint_ProjectPage_Fragment
    ) | (
      { __typename?: 'BarChartWithBackground' }
      & FullBlockRibbonEntryPoint_BarChartWithBackground_Fragment
    ) | (
      { __typename?: 'BlockCustom' }
      & FullBlockRibbonEntryPoint_BlockCustom_Fragment
    ) | (
      { __typename?: 'BlockFullsizeImage' }
      & FullBlockRibbonEntryPoint_BlockFullsizeImage_Fragment
    ) | (
      { __typename?: 'BlockHighlightRealEstate' }
      & FullBlockRibbonEntryPoint_BlockHighlightRealEstate_Fragment
    ) | (
      { __typename?: 'HighlightedRealEstate' }
      & FullBlockRibbonEntryPoint_HighlightedRealEstate_Fragment
    ) | (
      { __typename?: 'BlockPartnerGrid' }
      & FullBlockRibbonEntryPoint_BlockPartnerGrid_Fragment
    ) | (
      { __typename?: 'Partner' }
      & FullBlockRibbonEntryPoint_Partner_Fragment
    ) | (
      { __typename?: 'BlockPersonAccordion' }
      & FullBlockRibbonEntryPoint_BlockPersonAccordion_Fragment
    ) | (
      { __typename?: 'PersonAccordionEntry' }
      & FullBlockRibbonEntryPoint_PersonAccordionEntry_Fragment
    ) | (
      { __typename?: 'BlockRibbon' }
      & FullBlockRibbonEntryPoint_BlockRibbon_Fragment
    ) | (
      { __typename?: 'BlockTable' }
      & FullBlockRibbonEntryPoint_BlockTable_Fragment
    ) | (
      { __typename?: 'BlockThreeColumn' }
      & FullBlockRibbonEntryPoint_BlockThreeColumn_Fragment
    ) | (
      { __typename?: 'BlockVideo' }
      & FullBlockRibbonEntryPoint_BlockVideo_Fragment
    ) | (
      { __typename?: 'NewsArticleContact' }
      & FullBlockRibbonEntryPoint_NewsArticleContact_Fragment
    ) | (
      { __typename?: 'BlockSpeechBubble' }
      & FullBlockRibbonEntryPoint_BlockSpeechBubble_Fragment
    ) | (
      { __typename?: 'LatestDownload' }
      & FullBlockRibbonEntryPoint_LatestDownload_Fragment
    ) | (
      { __typename?: 'NavigationEntry' }
      & FullBlockRibbonEntryPoint_NavigationEntry_Fragment
    ) | (
      { __typename?: 'BlockLinkSection' }
      & FullBlockRibbonEntryPoint_BlockLinkSection_Fragment
    ) | (
      { __typename?: 'LinkSectionEntry' }
      & FullBlockRibbonEntryPoint_LinkSectionEntry_Fragment
    ) | (
      { __typename?: 'BlockStockPrice' }
      & FullBlockRibbonEntryPoint_BlockStockPrice_Fragment
    ) | (
      { __typename?: 'BlockImageGallery' }
      & FullBlockRibbonEntryPoint_BlockImageGallery_Fragment
    ) | (
      { __typename?: 'BlockSlider' }
      & FullBlockRibbonEntryPoint_BlockSlider_Fragment
    ) | (
      { __typename?: 'BlockSliderEntry' }
      & FullBlockRibbonEntryPoint_BlockSliderEntry_Fragment
    ) | (
      { __typename?: 'BlockTextCloud' }
      & FullBlockRibbonEntryPoint_BlockTextCloud_Fragment
    ) | (
      { __typename?: 'Seo' }
      & FullBlockRibbonEntryPoint_Seo_Fragment
    ) | (
      { __typename?: 'RegionDescriptionText' }
      & FullBlockRibbonEntryPoint_RegionDescriptionText_Fragment
    ) | (
      { __typename?: 'ProjectLink' }
      & FullBlockRibbonEntryPoint_ProjectLink_Fragment
    ) | (
      { __typename?: 'BlockProjectLinkSection' }
      & FullBlockRibbonEntryPoint_BlockProjectLinkSection_Fragment
    ) | (
      { __typename?: 'ProjectImageMap' }
      & FullBlockRibbonEntryPoint_ProjectImageMap_Fragment
    ) | (
      { __typename?: 'DownloadableFile' }
      & FullBlockRibbonEntryPoint_DownloadableFile_Fragment
    ) | (
      { __typename?: 'Footer' }
      & FullBlockRibbonEntryPoint_Footer_Fragment
    )>> }
  )> }
);

type FullBlockRibbonEntryPoint_HeroImage_Fragment = (
  { __typename?: 'HeroImage' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type FullBlockRibbonEntryPoint_StaticPage_Fragment = (
  { __typename?: 'StaticPage' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type FullBlockRibbonEntryPoint_NavBarEntry_Fragment = (
  { __typename?: 'NavBarEntry' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type FullBlockRibbonEntryPoint_BlockSubNavigation_Fragment = (
  { __typename?: 'BlockSubNavigation' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type FullBlockRibbonEntryPoint_BlockBigTitleNavigation_Fragment = (
  { __typename?: 'BlockBigTitleNavigation' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type FullBlockRibbonEntryPoint_BlockHiddenWithConsent_Fragment = (
  { __typename?: 'BlockHiddenWithConsent' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type FullBlockRibbonEntryPoint_BlockAccordion_Fragment = (
  { __typename?: 'BlockAccordion' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type FullBlockRibbonEntryPoint_BlockOneColumn_Fragment = (
  { __typename?: 'BlockOneColumn' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type FullBlockRibbonEntryPoint_BlockAnalystRating_Fragment = (
  { __typename?: 'BlockAnalystRating' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type FullBlockRibbonEntryPoint_BlockCallToActionButton_Fragment = (
  { __typename?: 'BlockCallToActionButton' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type FullBlockRibbonEntryPoint_BlockTwoColumn_Fragment = (
  { __typename?: 'BlockTwoColumn' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type FullBlockRibbonEntryPoint_BlockAccordionEntry_Fragment = (
  { __typename?: 'BlockAccordionEntry' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type FullBlockRibbonEntryPoint_NewsArticle_Fragment = (
  { __typename?: 'NewsArticle' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type FullBlockRibbonEntryPoint_BlockRichText_Fragment = (
  { __typename?: 'BlockRichText' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type FullBlockRibbonEntryPoint_LexiconArticle_Fragment = (
  { __typename?: 'LexiconArticle' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type FullBlockRibbonEntryPoint_ProjectPage_Fragment = (
  { __typename?: 'ProjectPage' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type FullBlockRibbonEntryPoint_BarChartWithBackground_Fragment = (
  { __typename?: 'BarChartWithBackground' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type FullBlockRibbonEntryPoint_BlockCustom_Fragment = (
  { __typename?: 'BlockCustom' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type FullBlockRibbonEntryPoint_BlockFullsizeImage_Fragment = (
  { __typename?: 'BlockFullsizeImage' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type FullBlockRibbonEntryPoint_BlockHighlightRealEstate_Fragment = (
  { __typename?: 'BlockHighlightRealEstate' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type FullBlockRibbonEntryPoint_HighlightedRealEstate_Fragment = (
  { __typename?: 'HighlightedRealEstate' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type FullBlockRibbonEntryPoint_BlockPartnerGrid_Fragment = (
  { __typename?: 'BlockPartnerGrid' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type FullBlockRibbonEntryPoint_Partner_Fragment = (
  { __typename?: 'Partner' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type FullBlockRibbonEntryPoint_BlockPersonAccordion_Fragment = (
  { __typename?: 'BlockPersonAccordion' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type FullBlockRibbonEntryPoint_PersonAccordionEntry_Fragment = (
  { __typename?: 'PersonAccordionEntry' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type FullBlockRibbonEntryPoint_BlockRibbon_Fragment = (
  { __typename?: 'BlockRibbon' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
  & FullBlockRibbonFragment
);

type FullBlockRibbonEntryPoint_BlockTable_Fragment = (
  { __typename?: 'BlockTable' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type FullBlockRibbonEntryPoint_BlockThreeColumn_Fragment = (
  { __typename?: 'BlockThreeColumn' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type FullBlockRibbonEntryPoint_BlockVideo_Fragment = (
  { __typename?: 'BlockVideo' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type FullBlockRibbonEntryPoint_NewsArticleContact_Fragment = (
  { __typename?: 'NewsArticleContact' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type FullBlockRibbonEntryPoint_BlockSpeechBubble_Fragment = (
  { __typename?: 'BlockSpeechBubble' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type FullBlockRibbonEntryPoint_LatestDownload_Fragment = (
  { __typename?: 'LatestDownload' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type FullBlockRibbonEntryPoint_NavigationEntry_Fragment = (
  { __typename?: 'NavigationEntry' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type FullBlockRibbonEntryPoint_BlockLinkSection_Fragment = (
  { __typename?: 'BlockLinkSection' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type FullBlockRibbonEntryPoint_LinkSectionEntry_Fragment = (
  { __typename?: 'LinkSectionEntry' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type FullBlockRibbonEntryPoint_BlockStockPrice_Fragment = (
  { __typename?: 'BlockStockPrice' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type FullBlockRibbonEntryPoint_BlockImageGallery_Fragment = (
  { __typename?: 'BlockImageGallery' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type FullBlockRibbonEntryPoint_BlockSlider_Fragment = (
  { __typename?: 'BlockSlider' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type FullBlockRibbonEntryPoint_BlockSliderEntry_Fragment = (
  { __typename?: 'BlockSliderEntry' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type FullBlockRibbonEntryPoint_BlockTextCloud_Fragment = (
  { __typename?: 'BlockTextCloud' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type FullBlockRibbonEntryPoint_Seo_Fragment = (
  { __typename?: 'Seo' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type FullBlockRibbonEntryPoint_RegionDescriptionText_Fragment = (
  { __typename?: 'RegionDescriptionText' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type FullBlockRibbonEntryPoint_ProjectLink_Fragment = (
  { __typename?: 'ProjectLink' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type FullBlockRibbonEntryPoint_BlockProjectLinkSection_Fragment = (
  { __typename?: 'BlockProjectLinkSection' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type FullBlockRibbonEntryPoint_ProjectImageMap_Fragment = (
  { __typename?: 'ProjectImageMap' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type FullBlockRibbonEntryPoint_DownloadableFile_Fragment = (
  { __typename?: 'DownloadableFile' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type FullBlockRibbonEntryPoint_Footer_Fragment = (
  { __typename?: 'Footer' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

export type FullBlockRibbonEntryPointFragment = FullBlockRibbonEntryPoint_HeroImage_Fragment | FullBlockRibbonEntryPoint_StaticPage_Fragment | FullBlockRibbonEntryPoint_NavBarEntry_Fragment | FullBlockRibbonEntryPoint_BlockSubNavigation_Fragment | FullBlockRibbonEntryPoint_BlockBigTitleNavigation_Fragment | FullBlockRibbonEntryPoint_BlockHiddenWithConsent_Fragment | FullBlockRibbonEntryPoint_BlockAccordion_Fragment | FullBlockRibbonEntryPoint_BlockOneColumn_Fragment | FullBlockRibbonEntryPoint_BlockAnalystRating_Fragment | FullBlockRibbonEntryPoint_BlockCallToActionButton_Fragment | FullBlockRibbonEntryPoint_BlockTwoColumn_Fragment | FullBlockRibbonEntryPoint_BlockAccordionEntry_Fragment | FullBlockRibbonEntryPoint_NewsArticle_Fragment | FullBlockRibbonEntryPoint_BlockRichText_Fragment | FullBlockRibbonEntryPoint_LexiconArticle_Fragment | FullBlockRibbonEntryPoint_ProjectPage_Fragment | FullBlockRibbonEntryPoint_BarChartWithBackground_Fragment | FullBlockRibbonEntryPoint_BlockCustom_Fragment | FullBlockRibbonEntryPoint_BlockFullsizeImage_Fragment | FullBlockRibbonEntryPoint_BlockHighlightRealEstate_Fragment | FullBlockRibbonEntryPoint_HighlightedRealEstate_Fragment | FullBlockRibbonEntryPoint_BlockPartnerGrid_Fragment | FullBlockRibbonEntryPoint_Partner_Fragment | FullBlockRibbonEntryPoint_BlockPersonAccordion_Fragment | FullBlockRibbonEntryPoint_PersonAccordionEntry_Fragment | FullBlockRibbonEntryPoint_BlockRibbon_Fragment | FullBlockRibbonEntryPoint_BlockTable_Fragment | FullBlockRibbonEntryPoint_BlockThreeColumn_Fragment | FullBlockRibbonEntryPoint_BlockVideo_Fragment | FullBlockRibbonEntryPoint_NewsArticleContact_Fragment | FullBlockRibbonEntryPoint_BlockSpeechBubble_Fragment | FullBlockRibbonEntryPoint_LatestDownload_Fragment | FullBlockRibbonEntryPoint_NavigationEntry_Fragment | FullBlockRibbonEntryPoint_BlockLinkSection_Fragment | FullBlockRibbonEntryPoint_LinkSectionEntry_Fragment | FullBlockRibbonEntryPoint_BlockStockPrice_Fragment | FullBlockRibbonEntryPoint_BlockImageGallery_Fragment | FullBlockRibbonEntryPoint_BlockSlider_Fragment | FullBlockRibbonEntryPoint_BlockSliderEntry_Fragment | FullBlockRibbonEntryPoint_BlockTextCloud_Fragment | FullBlockRibbonEntryPoint_Seo_Fragment | FullBlockRibbonEntryPoint_RegionDescriptionText_Fragment | FullBlockRibbonEntryPoint_ProjectLink_Fragment | FullBlockRibbonEntryPoint_BlockProjectLinkSection_Fragment | FullBlockRibbonEntryPoint_ProjectImageMap_Fragment | FullBlockRibbonEntryPoint_DownloadableFile_Fragment | FullBlockRibbonEntryPoint_Footer_Fragment;

export type GetFullBlockRichTextByIdQueryVariables = Exact<{
  locale?: Maybe<Scalars['String']>;
  preview?: Maybe<Scalars['Boolean']>;
  id: Scalars['String'];
}>;


export type GetFullBlockRichTextByIdQuery = (
  { __typename?: 'Query' }
  & { entryCollection?: Maybe<(
    { __typename?: 'EntryCollection' }
    & { items: Array<Maybe<(
      { __typename?: 'HeroImage' }
      & FullBlockRichTextEntryPoint_HeroImage_Fragment
    ) | (
      { __typename?: 'StaticPage' }
      & FullBlockRichTextEntryPoint_StaticPage_Fragment
    ) | (
      { __typename?: 'NavBarEntry' }
      & FullBlockRichTextEntryPoint_NavBarEntry_Fragment
    ) | (
      { __typename?: 'BlockSubNavigation' }
      & FullBlockRichTextEntryPoint_BlockSubNavigation_Fragment
    ) | (
      { __typename?: 'BlockBigTitleNavigation' }
      & FullBlockRichTextEntryPoint_BlockBigTitleNavigation_Fragment
    ) | (
      { __typename?: 'BlockHiddenWithConsent' }
      & FullBlockRichTextEntryPoint_BlockHiddenWithConsent_Fragment
    ) | (
      { __typename?: 'BlockAccordion' }
      & FullBlockRichTextEntryPoint_BlockAccordion_Fragment
    ) | (
      { __typename?: 'BlockOneColumn' }
      & FullBlockRichTextEntryPoint_BlockOneColumn_Fragment
    ) | (
      { __typename?: 'BlockAnalystRating' }
      & FullBlockRichTextEntryPoint_BlockAnalystRating_Fragment
    ) | (
      { __typename?: 'BlockCallToActionButton' }
      & FullBlockRichTextEntryPoint_BlockCallToActionButton_Fragment
    ) | (
      { __typename?: 'BlockTwoColumn' }
      & FullBlockRichTextEntryPoint_BlockTwoColumn_Fragment
    ) | (
      { __typename?: 'BlockAccordionEntry' }
      & FullBlockRichTextEntryPoint_BlockAccordionEntry_Fragment
    ) | (
      { __typename?: 'NewsArticle' }
      & FullBlockRichTextEntryPoint_NewsArticle_Fragment
    ) | (
      { __typename?: 'BlockRichText' }
      & FullBlockRichTextEntryPoint_BlockRichText_Fragment
    ) | (
      { __typename?: 'LexiconArticle' }
      & FullBlockRichTextEntryPoint_LexiconArticle_Fragment
    ) | (
      { __typename?: 'ProjectPage' }
      & FullBlockRichTextEntryPoint_ProjectPage_Fragment
    ) | (
      { __typename?: 'BarChartWithBackground' }
      & FullBlockRichTextEntryPoint_BarChartWithBackground_Fragment
    ) | (
      { __typename?: 'BlockCustom' }
      & FullBlockRichTextEntryPoint_BlockCustom_Fragment
    ) | (
      { __typename?: 'BlockFullsizeImage' }
      & FullBlockRichTextEntryPoint_BlockFullsizeImage_Fragment
    ) | (
      { __typename?: 'BlockHighlightRealEstate' }
      & FullBlockRichTextEntryPoint_BlockHighlightRealEstate_Fragment
    ) | (
      { __typename?: 'HighlightedRealEstate' }
      & FullBlockRichTextEntryPoint_HighlightedRealEstate_Fragment
    ) | (
      { __typename?: 'BlockPartnerGrid' }
      & FullBlockRichTextEntryPoint_BlockPartnerGrid_Fragment
    ) | (
      { __typename?: 'Partner' }
      & FullBlockRichTextEntryPoint_Partner_Fragment
    ) | (
      { __typename?: 'BlockPersonAccordion' }
      & FullBlockRichTextEntryPoint_BlockPersonAccordion_Fragment
    ) | (
      { __typename?: 'PersonAccordionEntry' }
      & FullBlockRichTextEntryPoint_PersonAccordionEntry_Fragment
    ) | (
      { __typename?: 'BlockRibbon' }
      & FullBlockRichTextEntryPoint_BlockRibbon_Fragment
    ) | (
      { __typename?: 'BlockTable' }
      & FullBlockRichTextEntryPoint_BlockTable_Fragment
    ) | (
      { __typename?: 'BlockThreeColumn' }
      & FullBlockRichTextEntryPoint_BlockThreeColumn_Fragment
    ) | (
      { __typename?: 'BlockVideo' }
      & FullBlockRichTextEntryPoint_BlockVideo_Fragment
    ) | (
      { __typename?: 'NewsArticleContact' }
      & FullBlockRichTextEntryPoint_NewsArticleContact_Fragment
    ) | (
      { __typename?: 'BlockSpeechBubble' }
      & FullBlockRichTextEntryPoint_BlockSpeechBubble_Fragment
    ) | (
      { __typename?: 'LatestDownload' }
      & FullBlockRichTextEntryPoint_LatestDownload_Fragment
    ) | (
      { __typename?: 'NavigationEntry' }
      & FullBlockRichTextEntryPoint_NavigationEntry_Fragment
    ) | (
      { __typename?: 'BlockLinkSection' }
      & FullBlockRichTextEntryPoint_BlockLinkSection_Fragment
    ) | (
      { __typename?: 'LinkSectionEntry' }
      & FullBlockRichTextEntryPoint_LinkSectionEntry_Fragment
    ) | (
      { __typename?: 'BlockStockPrice' }
      & FullBlockRichTextEntryPoint_BlockStockPrice_Fragment
    ) | (
      { __typename?: 'BlockImageGallery' }
      & FullBlockRichTextEntryPoint_BlockImageGallery_Fragment
    ) | (
      { __typename?: 'BlockSlider' }
      & FullBlockRichTextEntryPoint_BlockSlider_Fragment
    ) | (
      { __typename?: 'BlockSliderEntry' }
      & FullBlockRichTextEntryPoint_BlockSliderEntry_Fragment
    ) | (
      { __typename?: 'BlockTextCloud' }
      & FullBlockRichTextEntryPoint_BlockTextCloud_Fragment
    ) | (
      { __typename?: 'Seo' }
      & FullBlockRichTextEntryPoint_Seo_Fragment
    ) | (
      { __typename?: 'RegionDescriptionText' }
      & FullBlockRichTextEntryPoint_RegionDescriptionText_Fragment
    ) | (
      { __typename?: 'ProjectLink' }
      & FullBlockRichTextEntryPoint_ProjectLink_Fragment
    ) | (
      { __typename?: 'BlockProjectLinkSection' }
      & FullBlockRichTextEntryPoint_BlockProjectLinkSection_Fragment
    ) | (
      { __typename?: 'ProjectImageMap' }
      & FullBlockRichTextEntryPoint_ProjectImageMap_Fragment
    ) | (
      { __typename?: 'DownloadableFile' }
      & FullBlockRichTextEntryPoint_DownloadableFile_Fragment
    ) | (
      { __typename?: 'Footer' }
      & FullBlockRichTextEntryPoint_Footer_Fragment
    )>> }
  )> }
);

type FullBlockRichTextEntryPoint_HeroImage_Fragment = (
  { __typename?: 'HeroImage' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type FullBlockRichTextEntryPoint_StaticPage_Fragment = (
  { __typename?: 'StaticPage' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type FullBlockRichTextEntryPoint_NavBarEntry_Fragment = (
  { __typename?: 'NavBarEntry' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type FullBlockRichTextEntryPoint_BlockSubNavigation_Fragment = (
  { __typename?: 'BlockSubNavigation' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type FullBlockRichTextEntryPoint_BlockBigTitleNavigation_Fragment = (
  { __typename?: 'BlockBigTitleNavigation' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type FullBlockRichTextEntryPoint_BlockHiddenWithConsent_Fragment = (
  { __typename?: 'BlockHiddenWithConsent' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type FullBlockRichTextEntryPoint_BlockAccordion_Fragment = (
  { __typename?: 'BlockAccordion' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type FullBlockRichTextEntryPoint_BlockOneColumn_Fragment = (
  { __typename?: 'BlockOneColumn' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type FullBlockRichTextEntryPoint_BlockAnalystRating_Fragment = (
  { __typename?: 'BlockAnalystRating' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type FullBlockRichTextEntryPoint_BlockCallToActionButton_Fragment = (
  { __typename?: 'BlockCallToActionButton' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type FullBlockRichTextEntryPoint_BlockTwoColumn_Fragment = (
  { __typename?: 'BlockTwoColumn' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type FullBlockRichTextEntryPoint_BlockAccordionEntry_Fragment = (
  { __typename?: 'BlockAccordionEntry' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type FullBlockRichTextEntryPoint_NewsArticle_Fragment = (
  { __typename?: 'NewsArticle' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type FullBlockRichTextEntryPoint_BlockRichText_Fragment = (
  { __typename?: 'BlockRichText' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
  & FullBlockRichTextFragment
);

type FullBlockRichTextEntryPoint_LexiconArticle_Fragment = (
  { __typename?: 'LexiconArticle' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type FullBlockRichTextEntryPoint_ProjectPage_Fragment = (
  { __typename?: 'ProjectPage' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type FullBlockRichTextEntryPoint_BarChartWithBackground_Fragment = (
  { __typename?: 'BarChartWithBackground' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type FullBlockRichTextEntryPoint_BlockCustom_Fragment = (
  { __typename?: 'BlockCustom' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type FullBlockRichTextEntryPoint_BlockFullsizeImage_Fragment = (
  { __typename?: 'BlockFullsizeImage' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type FullBlockRichTextEntryPoint_BlockHighlightRealEstate_Fragment = (
  { __typename?: 'BlockHighlightRealEstate' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type FullBlockRichTextEntryPoint_HighlightedRealEstate_Fragment = (
  { __typename?: 'HighlightedRealEstate' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type FullBlockRichTextEntryPoint_BlockPartnerGrid_Fragment = (
  { __typename?: 'BlockPartnerGrid' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type FullBlockRichTextEntryPoint_Partner_Fragment = (
  { __typename?: 'Partner' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type FullBlockRichTextEntryPoint_BlockPersonAccordion_Fragment = (
  { __typename?: 'BlockPersonAccordion' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type FullBlockRichTextEntryPoint_PersonAccordionEntry_Fragment = (
  { __typename?: 'PersonAccordionEntry' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type FullBlockRichTextEntryPoint_BlockRibbon_Fragment = (
  { __typename?: 'BlockRibbon' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type FullBlockRichTextEntryPoint_BlockTable_Fragment = (
  { __typename?: 'BlockTable' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type FullBlockRichTextEntryPoint_BlockThreeColumn_Fragment = (
  { __typename?: 'BlockThreeColumn' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type FullBlockRichTextEntryPoint_BlockVideo_Fragment = (
  { __typename?: 'BlockVideo' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type FullBlockRichTextEntryPoint_NewsArticleContact_Fragment = (
  { __typename?: 'NewsArticleContact' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type FullBlockRichTextEntryPoint_BlockSpeechBubble_Fragment = (
  { __typename?: 'BlockSpeechBubble' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type FullBlockRichTextEntryPoint_LatestDownload_Fragment = (
  { __typename?: 'LatestDownload' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type FullBlockRichTextEntryPoint_NavigationEntry_Fragment = (
  { __typename?: 'NavigationEntry' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type FullBlockRichTextEntryPoint_BlockLinkSection_Fragment = (
  { __typename?: 'BlockLinkSection' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type FullBlockRichTextEntryPoint_LinkSectionEntry_Fragment = (
  { __typename?: 'LinkSectionEntry' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type FullBlockRichTextEntryPoint_BlockStockPrice_Fragment = (
  { __typename?: 'BlockStockPrice' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type FullBlockRichTextEntryPoint_BlockImageGallery_Fragment = (
  { __typename?: 'BlockImageGallery' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type FullBlockRichTextEntryPoint_BlockSlider_Fragment = (
  { __typename?: 'BlockSlider' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type FullBlockRichTextEntryPoint_BlockSliderEntry_Fragment = (
  { __typename?: 'BlockSliderEntry' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type FullBlockRichTextEntryPoint_BlockTextCloud_Fragment = (
  { __typename?: 'BlockTextCloud' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type FullBlockRichTextEntryPoint_Seo_Fragment = (
  { __typename?: 'Seo' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type FullBlockRichTextEntryPoint_RegionDescriptionText_Fragment = (
  { __typename?: 'RegionDescriptionText' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type FullBlockRichTextEntryPoint_ProjectLink_Fragment = (
  { __typename?: 'ProjectLink' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type FullBlockRichTextEntryPoint_BlockProjectLinkSection_Fragment = (
  { __typename?: 'BlockProjectLinkSection' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type FullBlockRichTextEntryPoint_ProjectImageMap_Fragment = (
  { __typename?: 'ProjectImageMap' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type FullBlockRichTextEntryPoint_DownloadableFile_Fragment = (
  { __typename?: 'DownloadableFile' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type FullBlockRichTextEntryPoint_Footer_Fragment = (
  { __typename?: 'Footer' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

export type FullBlockRichTextEntryPointFragment = FullBlockRichTextEntryPoint_HeroImage_Fragment | FullBlockRichTextEntryPoint_StaticPage_Fragment | FullBlockRichTextEntryPoint_NavBarEntry_Fragment | FullBlockRichTextEntryPoint_BlockSubNavigation_Fragment | FullBlockRichTextEntryPoint_BlockBigTitleNavigation_Fragment | FullBlockRichTextEntryPoint_BlockHiddenWithConsent_Fragment | FullBlockRichTextEntryPoint_BlockAccordion_Fragment | FullBlockRichTextEntryPoint_BlockOneColumn_Fragment | FullBlockRichTextEntryPoint_BlockAnalystRating_Fragment | FullBlockRichTextEntryPoint_BlockCallToActionButton_Fragment | FullBlockRichTextEntryPoint_BlockTwoColumn_Fragment | FullBlockRichTextEntryPoint_BlockAccordionEntry_Fragment | FullBlockRichTextEntryPoint_NewsArticle_Fragment | FullBlockRichTextEntryPoint_BlockRichText_Fragment | FullBlockRichTextEntryPoint_LexiconArticle_Fragment | FullBlockRichTextEntryPoint_ProjectPage_Fragment | FullBlockRichTextEntryPoint_BarChartWithBackground_Fragment | FullBlockRichTextEntryPoint_BlockCustom_Fragment | FullBlockRichTextEntryPoint_BlockFullsizeImage_Fragment | FullBlockRichTextEntryPoint_BlockHighlightRealEstate_Fragment | FullBlockRichTextEntryPoint_HighlightedRealEstate_Fragment | FullBlockRichTextEntryPoint_BlockPartnerGrid_Fragment | FullBlockRichTextEntryPoint_Partner_Fragment | FullBlockRichTextEntryPoint_BlockPersonAccordion_Fragment | FullBlockRichTextEntryPoint_PersonAccordionEntry_Fragment | FullBlockRichTextEntryPoint_BlockRibbon_Fragment | FullBlockRichTextEntryPoint_BlockTable_Fragment | FullBlockRichTextEntryPoint_BlockThreeColumn_Fragment | FullBlockRichTextEntryPoint_BlockVideo_Fragment | FullBlockRichTextEntryPoint_NewsArticleContact_Fragment | FullBlockRichTextEntryPoint_BlockSpeechBubble_Fragment | FullBlockRichTextEntryPoint_LatestDownload_Fragment | FullBlockRichTextEntryPoint_NavigationEntry_Fragment | FullBlockRichTextEntryPoint_BlockLinkSection_Fragment | FullBlockRichTextEntryPoint_LinkSectionEntry_Fragment | FullBlockRichTextEntryPoint_BlockStockPrice_Fragment | FullBlockRichTextEntryPoint_BlockImageGallery_Fragment | FullBlockRichTextEntryPoint_BlockSlider_Fragment | FullBlockRichTextEntryPoint_BlockSliderEntry_Fragment | FullBlockRichTextEntryPoint_BlockTextCloud_Fragment | FullBlockRichTextEntryPoint_Seo_Fragment | FullBlockRichTextEntryPoint_RegionDescriptionText_Fragment | FullBlockRichTextEntryPoint_ProjectLink_Fragment | FullBlockRichTextEntryPoint_BlockProjectLinkSection_Fragment | FullBlockRichTextEntryPoint_ProjectImageMap_Fragment | FullBlockRichTextEntryPoint_DownloadableFile_Fragment | FullBlockRichTextEntryPoint_Footer_Fragment;

export type GetFullBlockTableByIdQueryVariables = Exact<{
  locale?: Maybe<Scalars['String']>;
  preview?: Maybe<Scalars['Boolean']>;
  id: Scalars['String'];
}>;


export type GetFullBlockTableByIdQuery = (
  { __typename?: 'Query' }
  & { entryCollection?: Maybe<(
    { __typename?: 'EntryCollection' }
    & { items: Array<Maybe<(
      { __typename?: 'HeroImage' }
      & FullBlockTableEntryPoint_HeroImage_Fragment
    ) | (
      { __typename?: 'StaticPage' }
      & FullBlockTableEntryPoint_StaticPage_Fragment
    ) | (
      { __typename?: 'NavBarEntry' }
      & FullBlockTableEntryPoint_NavBarEntry_Fragment
    ) | (
      { __typename?: 'BlockSubNavigation' }
      & FullBlockTableEntryPoint_BlockSubNavigation_Fragment
    ) | (
      { __typename?: 'BlockBigTitleNavigation' }
      & FullBlockTableEntryPoint_BlockBigTitleNavigation_Fragment
    ) | (
      { __typename?: 'BlockHiddenWithConsent' }
      & FullBlockTableEntryPoint_BlockHiddenWithConsent_Fragment
    ) | (
      { __typename?: 'BlockAccordion' }
      & FullBlockTableEntryPoint_BlockAccordion_Fragment
    ) | (
      { __typename?: 'BlockOneColumn' }
      & FullBlockTableEntryPoint_BlockOneColumn_Fragment
    ) | (
      { __typename?: 'BlockAnalystRating' }
      & FullBlockTableEntryPoint_BlockAnalystRating_Fragment
    ) | (
      { __typename?: 'BlockCallToActionButton' }
      & FullBlockTableEntryPoint_BlockCallToActionButton_Fragment
    ) | (
      { __typename?: 'BlockTwoColumn' }
      & FullBlockTableEntryPoint_BlockTwoColumn_Fragment
    ) | (
      { __typename?: 'BlockAccordionEntry' }
      & FullBlockTableEntryPoint_BlockAccordionEntry_Fragment
    ) | (
      { __typename?: 'NewsArticle' }
      & FullBlockTableEntryPoint_NewsArticle_Fragment
    ) | (
      { __typename?: 'BlockRichText' }
      & FullBlockTableEntryPoint_BlockRichText_Fragment
    ) | (
      { __typename?: 'LexiconArticle' }
      & FullBlockTableEntryPoint_LexiconArticle_Fragment
    ) | (
      { __typename?: 'ProjectPage' }
      & FullBlockTableEntryPoint_ProjectPage_Fragment
    ) | (
      { __typename?: 'BarChartWithBackground' }
      & FullBlockTableEntryPoint_BarChartWithBackground_Fragment
    ) | (
      { __typename?: 'BlockCustom' }
      & FullBlockTableEntryPoint_BlockCustom_Fragment
    ) | (
      { __typename?: 'BlockFullsizeImage' }
      & FullBlockTableEntryPoint_BlockFullsizeImage_Fragment
    ) | (
      { __typename?: 'BlockHighlightRealEstate' }
      & FullBlockTableEntryPoint_BlockHighlightRealEstate_Fragment
    ) | (
      { __typename?: 'HighlightedRealEstate' }
      & FullBlockTableEntryPoint_HighlightedRealEstate_Fragment
    ) | (
      { __typename?: 'BlockPartnerGrid' }
      & FullBlockTableEntryPoint_BlockPartnerGrid_Fragment
    ) | (
      { __typename?: 'Partner' }
      & FullBlockTableEntryPoint_Partner_Fragment
    ) | (
      { __typename?: 'BlockPersonAccordion' }
      & FullBlockTableEntryPoint_BlockPersonAccordion_Fragment
    ) | (
      { __typename?: 'PersonAccordionEntry' }
      & FullBlockTableEntryPoint_PersonAccordionEntry_Fragment
    ) | (
      { __typename?: 'BlockRibbon' }
      & FullBlockTableEntryPoint_BlockRibbon_Fragment
    ) | (
      { __typename?: 'BlockTable' }
      & FullBlockTableEntryPoint_BlockTable_Fragment
    ) | (
      { __typename?: 'BlockThreeColumn' }
      & FullBlockTableEntryPoint_BlockThreeColumn_Fragment
    ) | (
      { __typename?: 'BlockVideo' }
      & FullBlockTableEntryPoint_BlockVideo_Fragment
    ) | (
      { __typename?: 'NewsArticleContact' }
      & FullBlockTableEntryPoint_NewsArticleContact_Fragment
    ) | (
      { __typename?: 'BlockSpeechBubble' }
      & FullBlockTableEntryPoint_BlockSpeechBubble_Fragment
    ) | (
      { __typename?: 'LatestDownload' }
      & FullBlockTableEntryPoint_LatestDownload_Fragment
    ) | (
      { __typename?: 'NavigationEntry' }
      & FullBlockTableEntryPoint_NavigationEntry_Fragment
    ) | (
      { __typename?: 'BlockLinkSection' }
      & FullBlockTableEntryPoint_BlockLinkSection_Fragment
    ) | (
      { __typename?: 'LinkSectionEntry' }
      & FullBlockTableEntryPoint_LinkSectionEntry_Fragment
    ) | (
      { __typename?: 'BlockStockPrice' }
      & FullBlockTableEntryPoint_BlockStockPrice_Fragment
    ) | (
      { __typename?: 'BlockImageGallery' }
      & FullBlockTableEntryPoint_BlockImageGallery_Fragment
    ) | (
      { __typename?: 'BlockSlider' }
      & FullBlockTableEntryPoint_BlockSlider_Fragment
    ) | (
      { __typename?: 'BlockSliderEntry' }
      & FullBlockTableEntryPoint_BlockSliderEntry_Fragment
    ) | (
      { __typename?: 'BlockTextCloud' }
      & FullBlockTableEntryPoint_BlockTextCloud_Fragment
    ) | (
      { __typename?: 'Seo' }
      & FullBlockTableEntryPoint_Seo_Fragment
    ) | (
      { __typename?: 'RegionDescriptionText' }
      & FullBlockTableEntryPoint_RegionDescriptionText_Fragment
    ) | (
      { __typename?: 'ProjectLink' }
      & FullBlockTableEntryPoint_ProjectLink_Fragment
    ) | (
      { __typename?: 'BlockProjectLinkSection' }
      & FullBlockTableEntryPoint_BlockProjectLinkSection_Fragment
    ) | (
      { __typename?: 'ProjectImageMap' }
      & FullBlockTableEntryPoint_ProjectImageMap_Fragment
    ) | (
      { __typename?: 'DownloadableFile' }
      & FullBlockTableEntryPoint_DownloadableFile_Fragment
    ) | (
      { __typename?: 'Footer' }
      & FullBlockTableEntryPoint_Footer_Fragment
    )>> }
  )> }
);

type FullBlockTableEntryPoint_HeroImage_Fragment = (
  { __typename?: 'HeroImage' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type FullBlockTableEntryPoint_StaticPage_Fragment = (
  { __typename?: 'StaticPage' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type FullBlockTableEntryPoint_NavBarEntry_Fragment = (
  { __typename?: 'NavBarEntry' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type FullBlockTableEntryPoint_BlockSubNavigation_Fragment = (
  { __typename?: 'BlockSubNavigation' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type FullBlockTableEntryPoint_BlockBigTitleNavigation_Fragment = (
  { __typename?: 'BlockBigTitleNavigation' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type FullBlockTableEntryPoint_BlockHiddenWithConsent_Fragment = (
  { __typename?: 'BlockHiddenWithConsent' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type FullBlockTableEntryPoint_BlockAccordion_Fragment = (
  { __typename?: 'BlockAccordion' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type FullBlockTableEntryPoint_BlockOneColumn_Fragment = (
  { __typename?: 'BlockOneColumn' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type FullBlockTableEntryPoint_BlockAnalystRating_Fragment = (
  { __typename?: 'BlockAnalystRating' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type FullBlockTableEntryPoint_BlockCallToActionButton_Fragment = (
  { __typename?: 'BlockCallToActionButton' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type FullBlockTableEntryPoint_BlockTwoColumn_Fragment = (
  { __typename?: 'BlockTwoColumn' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type FullBlockTableEntryPoint_BlockAccordionEntry_Fragment = (
  { __typename?: 'BlockAccordionEntry' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type FullBlockTableEntryPoint_NewsArticle_Fragment = (
  { __typename?: 'NewsArticle' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type FullBlockTableEntryPoint_BlockRichText_Fragment = (
  { __typename?: 'BlockRichText' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type FullBlockTableEntryPoint_LexiconArticle_Fragment = (
  { __typename?: 'LexiconArticle' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type FullBlockTableEntryPoint_ProjectPage_Fragment = (
  { __typename?: 'ProjectPage' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type FullBlockTableEntryPoint_BarChartWithBackground_Fragment = (
  { __typename?: 'BarChartWithBackground' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type FullBlockTableEntryPoint_BlockCustom_Fragment = (
  { __typename?: 'BlockCustom' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type FullBlockTableEntryPoint_BlockFullsizeImage_Fragment = (
  { __typename?: 'BlockFullsizeImage' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type FullBlockTableEntryPoint_BlockHighlightRealEstate_Fragment = (
  { __typename?: 'BlockHighlightRealEstate' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type FullBlockTableEntryPoint_HighlightedRealEstate_Fragment = (
  { __typename?: 'HighlightedRealEstate' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type FullBlockTableEntryPoint_BlockPartnerGrid_Fragment = (
  { __typename?: 'BlockPartnerGrid' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type FullBlockTableEntryPoint_Partner_Fragment = (
  { __typename?: 'Partner' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type FullBlockTableEntryPoint_BlockPersonAccordion_Fragment = (
  { __typename?: 'BlockPersonAccordion' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type FullBlockTableEntryPoint_PersonAccordionEntry_Fragment = (
  { __typename?: 'PersonAccordionEntry' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type FullBlockTableEntryPoint_BlockRibbon_Fragment = (
  { __typename?: 'BlockRibbon' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type FullBlockTableEntryPoint_BlockTable_Fragment = (
  { __typename?: 'BlockTable' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
  & FullBlockTableFragment
);

type FullBlockTableEntryPoint_BlockThreeColumn_Fragment = (
  { __typename?: 'BlockThreeColumn' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type FullBlockTableEntryPoint_BlockVideo_Fragment = (
  { __typename?: 'BlockVideo' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type FullBlockTableEntryPoint_NewsArticleContact_Fragment = (
  { __typename?: 'NewsArticleContact' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type FullBlockTableEntryPoint_BlockSpeechBubble_Fragment = (
  { __typename?: 'BlockSpeechBubble' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type FullBlockTableEntryPoint_LatestDownload_Fragment = (
  { __typename?: 'LatestDownload' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type FullBlockTableEntryPoint_NavigationEntry_Fragment = (
  { __typename?: 'NavigationEntry' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type FullBlockTableEntryPoint_BlockLinkSection_Fragment = (
  { __typename?: 'BlockLinkSection' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type FullBlockTableEntryPoint_LinkSectionEntry_Fragment = (
  { __typename?: 'LinkSectionEntry' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type FullBlockTableEntryPoint_BlockStockPrice_Fragment = (
  { __typename?: 'BlockStockPrice' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type FullBlockTableEntryPoint_BlockImageGallery_Fragment = (
  { __typename?: 'BlockImageGallery' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type FullBlockTableEntryPoint_BlockSlider_Fragment = (
  { __typename?: 'BlockSlider' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type FullBlockTableEntryPoint_BlockSliderEntry_Fragment = (
  { __typename?: 'BlockSliderEntry' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type FullBlockTableEntryPoint_BlockTextCloud_Fragment = (
  { __typename?: 'BlockTextCloud' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type FullBlockTableEntryPoint_Seo_Fragment = (
  { __typename?: 'Seo' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type FullBlockTableEntryPoint_RegionDescriptionText_Fragment = (
  { __typename?: 'RegionDescriptionText' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type FullBlockTableEntryPoint_ProjectLink_Fragment = (
  { __typename?: 'ProjectLink' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type FullBlockTableEntryPoint_BlockProjectLinkSection_Fragment = (
  { __typename?: 'BlockProjectLinkSection' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type FullBlockTableEntryPoint_ProjectImageMap_Fragment = (
  { __typename?: 'ProjectImageMap' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type FullBlockTableEntryPoint_DownloadableFile_Fragment = (
  { __typename?: 'DownloadableFile' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type FullBlockTableEntryPoint_Footer_Fragment = (
  { __typename?: 'Footer' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

export type FullBlockTableEntryPointFragment = FullBlockTableEntryPoint_HeroImage_Fragment | FullBlockTableEntryPoint_StaticPage_Fragment | FullBlockTableEntryPoint_NavBarEntry_Fragment | FullBlockTableEntryPoint_BlockSubNavigation_Fragment | FullBlockTableEntryPoint_BlockBigTitleNavigation_Fragment | FullBlockTableEntryPoint_BlockHiddenWithConsent_Fragment | FullBlockTableEntryPoint_BlockAccordion_Fragment | FullBlockTableEntryPoint_BlockOneColumn_Fragment | FullBlockTableEntryPoint_BlockAnalystRating_Fragment | FullBlockTableEntryPoint_BlockCallToActionButton_Fragment | FullBlockTableEntryPoint_BlockTwoColumn_Fragment | FullBlockTableEntryPoint_BlockAccordionEntry_Fragment | FullBlockTableEntryPoint_NewsArticle_Fragment | FullBlockTableEntryPoint_BlockRichText_Fragment | FullBlockTableEntryPoint_LexiconArticle_Fragment | FullBlockTableEntryPoint_ProjectPage_Fragment | FullBlockTableEntryPoint_BarChartWithBackground_Fragment | FullBlockTableEntryPoint_BlockCustom_Fragment | FullBlockTableEntryPoint_BlockFullsizeImage_Fragment | FullBlockTableEntryPoint_BlockHighlightRealEstate_Fragment | FullBlockTableEntryPoint_HighlightedRealEstate_Fragment | FullBlockTableEntryPoint_BlockPartnerGrid_Fragment | FullBlockTableEntryPoint_Partner_Fragment | FullBlockTableEntryPoint_BlockPersonAccordion_Fragment | FullBlockTableEntryPoint_PersonAccordionEntry_Fragment | FullBlockTableEntryPoint_BlockRibbon_Fragment | FullBlockTableEntryPoint_BlockTable_Fragment | FullBlockTableEntryPoint_BlockThreeColumn_Fragment | FullBlockTableEntryPoint_BlockVideo_Fragment | FullBlockTableEntryPoint_NewsArticleContact_Fragment | FullBlockTableEntryPoint_BlockSpeechBubble_Fragment | FullBlockTableEntryPoint_LatestDownload_Fragment | FullBlockTableEntryPoint_NavigationEntry_Fragment | FullBlockTableEntryPoint_BlockLinkSection_Fragment | FullBlockTableEntryPoint_LinkSectionEntry_Fragment | FullBlockTableEntryPoint_BlockStockPrice_Fragment | FullBlockTableEntryPoint_BlockImageGallery_Fragment | FullBlockTableEntryPoint_BlockSlider_Fragment | FullBlockTableEntryPoint_BlockSliderEntry_Fragment | FullBlockTableEntryPoint_BlockTextCloud_Fragment | FullBlockTableEntryPoint_Seo_Fragment | FullBlockTableEntryPoint_RegionDescriptionText_Fragment | FullBlockTableEntryPoint_ProjectLink_Fragment | FullBlockTableEntryPoint_BlockProjectLinkSection_Fragment | FullBlockTableEntryPoint_ProjectImageMap_Fragment | FullBlockTableEntryPoint_DownloadableFile_Fragment | FullBlockTableEntryPoint_Footer_Fragment;

export type GetLatestDownloadByIdQueryVariables = Exact<{
  locale?: Maybe<Scalars['String']>;
  preview?: Maybe<Scalars['Boolean']>;
  id: Scalars['String'];
}>;


export type GetLatestDownloadByIdQuery = (
  { __typename?: 'Query' }
  & { entryCollection?: Maybe<(
    { __typename?: 'EntryCollection' }
    & { items: Array<Maybe<(
      { __typename?: 'HeroImage' }
      & LatestDownloadEntryPoint_HeroImage_Fragment
    ) | (
      { __typename?: 'StaticPage' }
      & LatestDownloadEntryPoint_StaticPage_Fragment
    ) | (
      { __typename?: 'NavBarEntry' }
      & LatestDownloadEntryPoint_NavBarEntry_Fragment
    ) | (
      { __typename?: 'BlockSubNavigation' }
      & LatestDownloadEntryPoint_BlockSubNavigation_Fragment
    ) | (
      { __typename?: 'BlockBigTitleNavigation' }
      & LatestDownloadEntryPoint_BlockBigTitleNavigation_Fragment
    ) | (
      { __typename?: 'BlockHiddenWithConsent' }
      & LatestDownloadEntryPoint_BlockHiddenWithConsent_Fragment
    ) | (
      { __typename?: 'BlockAccordion' }
      & LatestDownloadEntryPoint_BlockAccordion_Fragment
    ) | (
      { __typename?: 'BlockOneColumn' }
      & LatestDownloadEntryPoint_BlockOneColumn_Fragment
    ) | (
      { __typename?: 'BlockAnalystRating' }
      & LatestDownloadEntryPoint_BlockAnalystRating_Fragment
    ) | (
      { __typename?: 'BlockCallToActionButton' }
      & LatestDownloadEntryPoint_BlockCallToActionButton_Fragment
    ) | (
      { __typename?: 'BlockTwoColumn' }
      & LatestDownloadEntryPoint_BlockTwoColumn_Fragment
    ) | (
      { __typename?: 'BlockAccordionEntry' }
      & LatestDownloadEntryPoint_BlockAccordionEntry_Fragment
    ) | (
      { __typename?: 'NewsArticle' }
      & LatestDownloadEntryPoint_NewsArticle_Fragment
    ) | (
      { __typename?: 'BlockRichText' }
      & LatestDownloadEntryPoint_BlockRichText_Fragment
    ) | (
      { __typename?: 'LexiconArticle' }
      & LatestDownloadEntryPoint_LexiconArticle_Fragment
    ) | (
      { __typename?: 'ProjectPage' }
      & LatestDownloadEntryPoint_ProjectPage_Fragment
    ) | (
      { __typename?: 'BarChartWithBackground' }
      & LatestDownloadEntryPoint_BarChartWithBackground_Fragment
    ) | (
      { __typename?: 'BlockCustom' }
      & LatestDownloadEntryPoint_BlockCustom_Fragment
    ) | (
      { __typename?: 'BlockFullsizeImage' }
      & LatestDownloadEntryPoint_BlockFullsizeImage_Fragment
    ) | (
      { __typename?: 'BlockHighlightRealEstate' }
      & LatestDownloadEntryPoint_BlockHighlightRealEstate_Fragment
    ) | (
      { __typename?: 'HighlightedRealEstate' }
      & LatestDownloadEntryPoint_HighlightedRealEstate_Fragment
    ) | (
      { __typename?: 'BlockPartnerGrid' }
      & LatestDownloadEntryPoint_BlockPartnerGrid_Fragment
    ) | (
      { __typename?: 'Partner' }
      & LatestDownloadEntryPoint_Partner_Fragment
    ) | (
      { __typename?: 'BlockPersonAccordion' }
      & LatestDownloadEntryPoint_BlockPersonAccordion_Fragment
    ) | (
      { __typename?: 'PersonAccordionEntry' }
      & LatestDownloadEntryPoint_PersonAccordionEntry_Fragment
    ) | (
      { __typename?: 'BlockRibbon' }
      & LatestDownloadEntryPoint_BlockRibbon_Fragment
    ) | (
      { __typename?: 'BlockTable' }
      & LatestDownloadEntryPoint_BlockTable_Fragment
    ) | (
      { __typename?: 'BlockThreeColumn' }
      & LatestDownloadEntryPoint_BlockThreeColumn_Fragment
    ) | (
      { __typename?: 'BlockVideo' }
      & LatestDownloadEntryPoint_BlockVideo_Fragment
    ) | (
      { __typename?: 'NewsArticleContact' }
      & LatestDownloadEntryPoint_NewsArticleContact_Fragment
    ) | (
      { __typename?: 'BlockSpeechBubble' }
      & LatestDownloadEntryPoint_BlockSpeechBubble_Fragment
    ) | (
      { __typename?: 'LatestDownload' }
      & LatestDownloadEntryPoint_LatestDownload_Fragment
    ) | (
      { __typename?: 'NavigationEntry' }
      & LatestDownloadEntryPoint_NavigationEntry_Fragment
    ) | (
      { __typename?: 'BlockLinkSection' }
      & LatestDownloadEntryPoint_BlockLinkSection_Fragment
    ) | (
      { __typename?: 'LinkSectionEntry' }
      & LatestDownloadEntryPoint_LinkSectionEntry_Fragment
    ) | (
      { __typename?: 'BlockStockPrice' }
      & LatestDownloadEntryPoint_BlockStockPrice_Fragment
    ) | (
      { __typename?: 'BlockImageGallery' }
      & LatestDownloadEntryPoint_BlockImageGallery_Fragment
    ) | (
      { __typename?: 'BlockSlider' }
      & LatestDownloadEntryPoint_BlockSlider_Fragment
    ) | (
      { __typename?: 'BlockSliderEntry' }
      & LatestDownloadEntryPoint_BlockSliderEntry_Fragment
    ) | (
      { __typename?: 'BlockTextCloud' }
      & LatestDownloadEntryPoint_BlockTextCloud_Fragment
    ) | (
      { __typename?: 'Seo' }
      & LatestDownloadEntryPoint_Seo_Fragment
    ) | (
      { __typename?: 'RegionDescriptionText' }
      & LatestDownloadEntryPoint_RegionDescriptionText_Fragment
    ) | (
      { __typename?: 'ProjectLink' }
      & LatestDownloadEntryPoint_ProjectLink_Fragment
    ) | (
      { __typename?: 'BlockProjectLinkSection' }
      & LatestDownloadEntryPoint_BlockProjectLinkSection_Fragment
    ) | (
      { __typename?: 'ProjectImageMap' }
      & LatestDownloadEntryPoint_ProjectImageMap_Fragment
    ) | (
      { __typename?: 'DownloadableFile' }
      & LatestDownloadEntryPoint_DownloadableFile_Fragment
    ) | (
      { __typename?: 'Footer' }
      & LatestDownloadEntryPoint_Footer_Fragment
    )>> }
  )> }
);

type LatestDownloadEntryPoint_HeroImage_Fragment = (
  { __typename?: 'HeroImage' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type LatestDownloadEntryPoint_StaticPage_Fragment = (
  { __typename?: 'StaticPage' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type LatestDownloadEntryPoint_NavBarEntry_Fragment = (
  { __typename?: 'NavBarEntry' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type LatestDownloadEntryPoint_BlockSubNavigation_Fragment = (
  { __typename?: 'BlockSubNavigation' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type LatestDownloadEntryPoint_BlockBigTitleNavigation_Fragment = (
  { __typename?: 'BlockBigTitleNavigation' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type LatestDownloadEntryPoint_BlockHiddenWithConsent_Fragment = (
  { __typename?: 'BlockHiddenWithConsent' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type LatestDownloadEntryPoint_BlockAccordion_Fragment = (
  { __typename?: 'BlockAccordion' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type LatestDownloadEntryPoint_BlockOneColumn_Fragment = (
  { __typename?: 'BlockOneColumn' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type LatestDownloadEntryPoint_BlockAnalystRating_Fragment = (
  { __typename?: 'BlockAnalystRating' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type LatestDownloadEntryPoint_BlockCallToActionButton_Fragment = (
  { __typename?: 'BlockCallToActionButton' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type LatestDownloadEntryPoint_BlockTwoColumn_Fragment = (
  { __typename?: 'BlockTwoColumn' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type LatestDownloadEntryPoint_BlockAccordionEntry_Fragment = (
  { __typename?: 'BlockAccordionEntry' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type LatestDownloadEntryPoint_NewsArticle_Fragment = (
  { __typename?: 'NewsArticle' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type LatestDownloadEntryPoint_BlockRichText_Fragment = (
  { __typename?: 'BlockRichText' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type LatestDownloadEntryPoint_LexiconArticle_Fragment = (
  { __typename?: 'LexiconArticle' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type LatestDownloadEntryPoint_ProjectPage_Fragment = (
  { __typename?: 'ProjectPage' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type LatestDownloadEntryPoint_BarChartWithBackground_Fragment = (
  { __typename?: 'BarChartWithBackground' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type LatestDownloadEntryPoint_BlockCustom_Fragment = (
  { __typename?: 'BlockCustom' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type LatestDownloadEntryPoint_BlockFullsizeImage_Fragment = (
  { __typename?: 'BlockFullsizeImage' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type LatestDownloadEntryPoint_BlockHighlightRealEstate_Fragment = (
  { __typename?: 'BlockHighlightRealEstate' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type LatestDownloadEntryPoint_HighlightedRealEstate_Fragment = (
  { __typename?: 'HighlightedRealEstate' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type LatestDownloadEntryPoint_BlockPartnerGrid_Fragment = (
  { __typename?: 'BlockPartnerGrid' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type LatestDownloadEntryPoint_Partner_Fragment = (
  { __typename?: 'Partner' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type LatestDownloadEntryPoint_BlockPersonAccordion_Fragment = (
  { __typename?: 'BlockPersonAccordion' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type LatestDownloadEntryPoint_PersonAccordionEntry_Fragment = (
  { __typename?: 'PersonAccordionEntry' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type LatestDownloadEntryPoint_BlockRibbon_Fragment = (
  { __typename?: 'BlockRibbon' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type LatestDownloadEntryPoint_BlockTable_Fragment = (
  { __typename?: 'BlockTable' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type LatestDownloadEntryPoint_BlockThreeColumn_Fragment = (
  { __typename?: 'BlockThreeColumn' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type LatestDownloadEntryPoint_BlockVideo_Fragment = (
  { __typename?: 'BlockVideo' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type LatestDownloadEntryPoint_NewsArticleContact_Fragment = (
  { __typename?: 'NewsArticleContact' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type LatestDownloadEntryPoint_BlockSpeechBubble_Fragment = (
  { __typename?: 'BlockSpeechBubble' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type LatestDownloadEntryPoint_LatestDownload_Fragment = (
  { __typename?: 'LatestDownload' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
  & LatestDownloadFragment
);

type LatestDownloadEntryPoint_NavigationEntry_Fragment = (
  { __typename?: 'NavigationEntry' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type LatestDownloadEntryPoint_BlockLinkSection_Fragment = (
  { __typename?: 'BlockLinkSection' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type LatestDownloadEntryPoint_LinkSectionEntry_Fragment = (
  { __typename?: 'LinkSectionEntry' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type LatestDownloadEntryPoint_BlockStockPrice_Fragment = (
  { __typename?: 'BlockStockPrice' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type LatestDownloadEntryPoint_BlockImageGallery_Fragment = (
  { __typename?: 'BlockImageGallery' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type LatestDownloadEntryPoint_BlockSlider_Fragment = (
  { __typename?: 'BlockSlider' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type LatestDownloadEntryPoint_BlockSliderEntry_Fragment = (
  { __typename?: 'BlockSliderEntry' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type LatestDownloadEntryPoint_BlockTextCloud_Fragment = (
  { __typename?: 'BlockTextCloud' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type LatestDownloadEntryPoint_Seo_Fragment = (
  { __typename?: 'Seo' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type LatestDownloadEntryPoint_RegionDescriptionText_Fragment = (
  { __typename?: 'RegionDescriptionText' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type LatestDownloadEntryPoint_ProjectLink_Fragment = (
  { __typename?: 'ProjectLink' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type LatestDownloadEntryPoint_BlockProjectLinkSection_Fragment = (
  { __typename?: 'BlockProjectLinkSection' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type LatestDownloadEntryPoint_ProjectImageMap_Fragment = (
  { __typename?: 'ProjectImageMap' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type LatestDownloadEntryPoint_DownloadableFile_Fragment = (
  { __typename?: 'DownloadableFile' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type LatestDownloadEntryPoint_Footer_Fragment = (
  { __typename?: 'Footer' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

export type LatestDownloadEntryPointFragment = LatestDownloadEntryPoint_HeroImage_Fragment | LatestDownloadEntryPoint_StaticPage_Fragment | LatestDownloadEntryPoint_NavBarEntry_Fragment | LatestDownloadEntryPoint_BlockSubNavigation_Fragment | LatestDownloadEntryPoint_BlockBigTitleNavigation_Fragment | LatestDownloadEntryPoint_BlockHiddenWithConsent_Fragment | LatestDownloadEntryPoint_BlockAccordion_Fragment | LatestDownloadEntryPoint_BlockOneColumn_Fragment | LatestDownloadEntryPoint_BlockAnalystRating_Fragment | LatestDownloadEntryPoint_BlockCallToActionButton_Fragment | LatestDownloadEntryPoint_BlockTwoColumn_Fragment | LatestDownloadEntryPoint_BlockAccordionEntry_Fragment | LatestDownloadEntryPoint_NewsArticle_Fragment | LatestDownloadEntryPoint_BlockRichText_Fragment | LatestDownloadEntryPoint_LexiconArticle_Fragment | LatestDownloadEntryPoint_ProjectPage_Fragment | LatestDownloadEntryPoint_BarChartWithBackground_Fragment | LatestDownloadEntryPoint_BlockCustom_Fragment | LatestDownloadEntryPoint_BlockFullsizeImage_Fragment | LatestDownloadEntryPoint_BlockHighlightRealEstate_Fragment | LatestDownloadEntryPoint_HighlightedRealEstate_Fragment | LatestDownloadEntryPoint_BlockPartnerGrid_Fragment | LatestDownloadEntryPoint_Partner_Fragment | LatestDownloadEntryPoint_BlockPersonAccordion_Fragment | LatestDownloadEntryPoint_PersonAccordionEntry_Fragment | LatestDownloadEntryPoint_BlockRibbon_Fragment | LatestDownloadEntryPoint_BlockTable_Fragment | LatestDownloadEntryPoint_BlockThreeColumn_Fragment | LatestDownloadEntryPoint_BlockVideo_Fragment | LatestDownloadEntryPoint_NewsArticleContact_Fragment | LatestDownloadEntryPoint_BlockSpeechBubble_Fragment | LatestDownloadEntryPoint_LatestDownload_Fragment | LatestDownloadEntryPoint_NavigationEntry_Fragment | LatestDownloadEntryPoint_BlockLinkSection_Fragment | LatestDownloadEntryPoint_LinkSectionEntry_Fragment | LatestDownloadEntryPoint_BlockStockPrice_Fragment | LatestDownloadEntryPoint_BlockImageGallery_Fragment | LatestDownloadEntryPoint_BlockSlider_Fragment | LatestDownloadEntryPoint_BlockSliderEntry_Fragment | LatestDownloadEntryPoint_BlockTextCloud_Fragment | LatestDownloadEntryPoint_Seo_Fragment | LatestDownloadEntryPoint_RegionDescriptionText_Fragment | LatestDownloadEntryPoint_ProjectLink_Fragment | LatestDownloadEntryPoint_BlockProjectLinkSection_Fragment | LatestDownloadEntryPoint_ProjectImageMap_Fragment | LatestDownloadEntryPoint_DownloadableFile_Fragment | LatestDownloadEntryPoint_Footer_Fragment;

export type GetNavigationEntryByIdQueryVariables = Exact<{
  locale?: Maybe<Scalars['String']>;
  preview?: Maybe<Scalars['Boolean']>;
  id: Scalars['String'];
}>;


export type GetNavigationEntryByIdQuery = (
  { __typename?: 'Query' }
  & { entryCollection?: Maybe<(
    { __typename?: 'EntryCollection' }
    & { items: Array<Maybe<(
      { __typename?: 'HeroImage' }
      & NavigationEntryEntryPoint_HeroImage_Fragment
    ) | (
      { __typename?: 'StaticPage' }
      & NavigationEntryEntryPoint_StaticPage_Fragment
    ) | (
      { __typename?: 'NavBarEntry' }
      & NavigationEntryEntryPoint_NavBarEntry_Fragment
    ) | (
      { __typename?: 'BlockSubNavigation' }
      & NavigationEntryEntryPoint_BlockSubNavigation_Fragment
    ) | (
      { __typename?: 'BlockBigTitleNavigation' }
      & NavigationEntryEntryPoint_BlockBigTitleNavigation_Fragment
    ) | (
      { __typename?: 'BlockHiddenWithConsent' }
      & NavigationEntryEntryPoint_BlockHiddenWithConsent_Fragment
    ) | (
      { __typename?: 'BlockAccordion' }
      & NavigationEntryEntryPoint_BlockAccordion_Fragment
    ) | (
      { __typename?: 'BlockOneColumn' }
      & NavigationEntryEntryPoint_BlockOneColumn_Fragment
    ) | (
      { __typename?: 'BlockAnalystRating' }
      & NavigationEntryEntryPoint_BlockAnalystRating_Fragment
    ) | (
      { __typename?: 'BlockCallToActionButton' }
      & NavigationEntryEntryPoint_BlockCallToActionButton_Fragment
    ) | (
      { __typename?: 'BlockTwoColumn' }
      & NavigationEntryEntryPoint_BlockTwoColumn_Fragment
    ) | (
      { __typename?: 'BlockAccordionEntry' }
      & NavigationEntryEntryPoint_BlockAccordionEntry_Fragment
    ) | (
      { __typename?: 'NewsArticle' }
      & NavigationEntryEntryPoint_NewsArticle_Fragment
    ) | (
      { __typename?: 'BlockRichText' }
      & NavigationEntryEntryPoint_BlockRichText_Fragment
    ) | (
      { __typename?: 'LexiconArticle' }
      & NavigationEntryEntryPoint_LexiconArticle_Fragment
    ) | (
      { __typename?: 'ProjectPage' }
      & NavigationEntryEntryPoint_ProjectPage_Fragment
    ) | (
      { __typename?: 'BarChartWithBackground' }
      & NavigationEntryEntryPoint_BarChartWithBackground_Fragment
    ) | (
      { __typename?: 'BlockCustom' }
      & NavigationEntryEntryPoint_BlockCustom_Fragment
    ) | (
      { __typename?: 'BlockFullsizeImage' }
      & NavigationEntryEntryPoint_BlockFullsizeImage_Fragment
    ) | (
      { __typename?: 'BlockHighlightRealEstate' }
      & NavigationEntryEntryPoint_BlockHighlightRealEstate_Fragment
    ) | (
      { __typename?: 'HighlightedRealEstate' }
      & NavigationEntryEntryPoint_HighlightedRealEstate_Fragment
    ) | (
      { __typename?: 'BlockPartnerGrid' }
      & NavigationEntryEntryPoint_BlockPartnerGrid_Fragment
    ) | (
      { __typename?: 'Partner' }
      & NavigationEntryEntryPoint_Partner_Fragment
    ) | (
      { __typename?: 'BlockPersonAccordion' }
      & NavigationEntryEntryPoint_BlockPersonAccordion_Fragment
    ) | (
      { __typename?: 'PersonAccordionEntry' }
      & NavigationEntryEntryPoint_PersonAccordionEntry_Fragment
    ) | (
      { __typename?: 'BlockRibbon' }
      & NavigationEntryEntryPoint_BlockRibbon_Fragment
    ) | (
      { __typename?: 'BlockTable' }
      & NavigationEntryEntryPoint_BlockTable_Fragment
    ) | (
      { __typename?: 'BlockThreeColumn' }
      & NavigationEntryEntryPoint_BlockThreeColumn_Fragment
    ) | (
      { __typename?: 'BlockVideo' }
      & NavigationEntryEntryPoint_BlockVideo_Fragment
    ) | (
      { __typename?: 'NewsArticleContact' }
      & NavigationEntryEntryPoint_NewsArticleContact_Fragment
    ) | (
      { __typename?: 'BlockSpeechBubble' }
      & NavigationEntryEntryPoint_BlockSpeechBubble_Fragment
    ) | (
      { __typename?: 'LatestDownload' }
      & NavigationEntryEntryPoint_LatestDownload_Fragment
    ) | (
      { __typename?: 'NavigationEntry' }
      & NavigationEntryEntryPoint_NavigationEntry_Fragment
    ) | (
      { __typename?: 'BlockLinkSection' }
      & NavigationEntryEntryPoint_BlockLinkSection_Fragment
    ) | (
      { __typename?: 'LinkSectionEntry' }
      & NavigationEntryEntryPoint_LinkSectionEntry_Fragment
    ) | (
      { __typename?: 'BlockStockPrice' }
      & NavigationEntryEntryPoint_BlockStockPrice_Fragment
    ) | (
      { __typename?: 'BlockImageGallery' }
      & NavigationEntryEntryPoint_BlockImageGallery_Fragment
    ) | (
      { __typename?: 'BlockSlider' }
      & NavigationEntryEntryPoint_BlockSlider_Fragment
    ) | (
      { __typename?: 'BlockSliderEntry' }
      & NavigationEntryEntryPoint_BlockSliderEntry_Fragment
    ) | (
      { __typename?: 'BlockTextCloud' }
      & NavigationEntryEntryPoint_BlockTextCloud_Fragment
    ) | (
      { __typename?: 'Seo' }
      & NavigationEntryEntryPoint_Seo_Fragment
    ) | (
      { __typename?: 'RegionDescriptionText' }
      & NavigationEntryEntryPoint_RegionDescriptionText_Fragment
    ) | (
      { __typename?: 'ProjectLink' }
      & NavigationEntryEntryPoint_ProjectLink_Fragment
    ) | (
      { __typename?: 'BlockProjectLinkSection' }
      & NavigationEntryEntryPoint_BlockProjectLinkSection_Fragment
    ) | (
      { __typename?: 'ProjectImageMap' }
      & NavigationEntryEntryPoint_ProjectImageMap_Fragment
    ) | (
      { __typename?: 'DownloadableFile' }
      & NavigationEntryEntryPoint_DownloadableFile_Fragment
    ) | (
      { __typename?: 'Footer' }
      & NavigationEntryEntryPoint_Footer_Fragment
    )>> }
  )> }
);

type NavigationEntryEntryPoint_HeroImage_Fragment = (
  { __typename?: 'HeroImage' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type NavigationEntryEntryPoint_StaticPage_Fragment = (
  { __typename?: 'StaticPage' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type NavigationEntryEntryPoint_NavBarEntry_Fragment = (
  { __typename?: 'NavBarEntry' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type NavigationEntryEntryPoint_BlockSubNavigation_Fragment = (
  { __typename?: 'BlockSubNavigation' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type NavigationEntryEntryPoint_BlockBigTitleNavigation_Fragment = (
  { __typename?: 'BlockBigTitleNavigation' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type NavigationEntryEntryPoint_BlockHiddenWithConsent_Fragment = (
  { __typename?: 'BlockHiddenWithConsent' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type NavigationEntryEntryPoint_BlockAccordion_Fragment = (
  { __typename?: 'BlockAccordion' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type NavigationEntryEntryPoint_BlockOneColumn_Fragment = (
  { __typename?: 'BlockOneColumn' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type NavigationEntryEntryPoint_BlockAnalystRating_Fragment = (
  { __typename?: 'BlockAnalystRating' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type NavigationEntryEntryPoint_BlockCallToActionButton_Fragment = (
  { __typename?: 'BlockCallToActionButton' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type NavigationEntryEntryPoint_BlockTwoColumn_Fragment = (
  { __typename?: 'BlockTwoColumn' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type NavigationEntryEntryPoint_BlockAccordionEntry_Fragment = (
  { __typename?: 'BlockAccordionEntry' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type NavigationEntryEntryPoint_NewsArticle_Fragment = (
  { __typename?: 'NewsArticle' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type NavigationEntryEntryPoint_BlockRichText_Fragment = (
  { __typename?: 'BlockRichText' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type NavigationEntryEntryPoint_LexiconArticle_Fragment = (
  { __typename?: 'LexiconArticle' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type NavigationEntryEntryPoint_ProjectPage_Fragment = (
  { __typename?: 'ProjectPage' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type NavigationEntryEntryPoint_BarChartWithBackground_Fragment = (
  { __typename?: 'BarChartWithBackground' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type NavigationEntryEntryPoint_BlockCustom_Fragment = (
  { __typename?: 'BlockCustom' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type NavigationEntryEntryPoint_BlockFullsizeImage_Fragment = (
  { __typename?: 'BlockFullsizeImage' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type NavigationEntryEntryPoint_BlockHighlightRealEstate_Fragment = (
  { __typename?: 'BlockHighlightRealEstate' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type NavigationEntryEntryPoint_HighlightedRealEstate_Fragment = (
  { __typename?: 'HighlightedRealEstate' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type NavigationEntryEntryPoint_BlockPartnerGrid_Fragment = (
  { __typename?: 'BlockPartnerGrid' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type NavigationEntryEntryPoint_Partner_Fragment = (
  { __typename?: 'Partner' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type NavigationEntryEntryPoint_BlockPersonAccordion_Fragment = (
  { __typename?: 'BlockPersonAccordion' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type NavigationEntryEntryPoint_PersonAccordionEntry_Fragment = (
  { __typename?: 'PersonAccordionEntry' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type NavigationEntryEntryPoint_BlockRibbon_Fragment = (
  { __typename?: 'BlockRibbon' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type NavigationEntryEntryPoint_BlockTable_Fragment = (
  { __typename?: 'BlockTable' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type NavigationEntryEntryPoint_BlockThreeColumn_Fragment = (
  { __typename?: 'BlockThreeColumn' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type NavigationEntryEntryPoint_BlockVideo_Fragment = (
  { __typename?: 'BlockVideo' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type NavigationEntryEntryPoint_NewsArticleContact_Fragment = (
  { __typename?: 'NewsArticleContact' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type NavigationEntryEntryPoint_BlockSpeechBubble_Fragment = (
  { __typename?: 'BlockSpeechBubble' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type NavigationEntryEntryPoint_LatestDownload_Fragment = (
  { __typename?: 'LatestDownload' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type NavigationEntryEntryPoint_NavigationEntry_Fragment = (
  { __typename?: 'NavigationEntry' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
  & NavigationEntryFragment
);

type NavigationEntryEntryPoint_BlockLinkSection_Fragment = (
  { __typename?: 'BlockLinkSection' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type NavigationEntryEntryPoint_LinkSectionEntry_Fragment = (
  { __typename?: 'LinkSectionEntry' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type NavigationEntryEntryPoint_BlockStockPrice_Fragment = (
  { __typename?: 'BlockStockPrice' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type NavigationEntryEntryPoint_BlockImageGallery_Fragment = (
  { __typename?: 'BlockImageGallery' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type NavigationEntryEntryPoint_BlockSlider_Fragment = (
  { __typename?: 'BlockSlider' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type NavigationEntryEntryPoint_BlockSliderEntry_Fragment = (
  { __typename?: 'BlockSliderEntry' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type NavigationEntryEntryPoint_BlockTextCloud_Fragment = (
  { __typename?: 'BlockTextCloud' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type NavigationEntryEntryPoint_Seo_Fragment = (
  { __typename?: 'Seo' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type NavigationEntryEntryPoint_RegionDescriptionText_Fragment = (
  { __typename?: 'RegionDescriptionText' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type NavigationEntryEntryPoint_ProjectLink_Fragment = (
  { __typename?: 'ProjectLink' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type NavigationEntryEntryPoint_BlockProjectLinkSection_Fragment = (
  { __typename?: 'BlockProjectLinkSection' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type NavigationEntryEntryPoint_ProjectImageMap_Fragment = (
  { __typename?: 'ProjectImageMap' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type NavigationEntryEntryPoint_DownloadableFile_Fragment = (
  { __typename?: 'DownloadableFile' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type NavigationEntryEntryPoint_Footer_Fragment = (
  { __typename?: 'Footer' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

export type NavigationEntryEntryPointFragment = NavigationEntryEntryPoint_HeroImage_Fragment | NavigationEntryEntryPoint_StaticPage_Fragment | NavigationEntryEntryPoint_NavBarEntry_Fragment | NavigationEntryEntryPoint_BlockSubNavigation_Fragment | NavigationEntryEntryPoint_BlockBigTitleNavigation_Fragment | NavigationEntryEntryPoint_BlockHiddenWithConsent_Fragment | NavigationEntryEntryPoint_BlockAccordion_Fragment | NavigationEntryEntryPoint_BlockOneColumn_Fragment | NavigationEntryEntryPoint_BlockAnalystRating_Fragment | NavigationEntryEntryPoint_BlockCallToActionButton_Fragment | NavigationEntryEntryPoint_BlockTwoColumn_Fragment | NavigationEntryEntryPoint_BlockAccordionEntry_Fragment | NavigationEntryEntryPoint_NewsArticle_Fragment | NavigationEntryEntryPoint_BlockRichText_Fragment | NavigationEntryEntryPoint_LexiconArticle_Fragment | NavigationEntryEntryPoint_ProjectPage_Fragment | NavigationEntryEntryPoint_BarChartWithBackground_Fragment | NavigationEntryEntryPoint_BlockCustom_Fragment | NavigationEntryEntryPoint_BlockFullsizeImage_Fragment | NavigationEntryEntryPoint_BlockHighlightRealEstate_Fragment | NavigationEntryEntryPoint_HighlightedRealEstate_Fragment | NavigationEntryEntryPoint_BlockPartnerGrid_Fragment | NavigationEntryEntryPoint_Partner_Fragment | NavigationEntryEntryPoint_BlockPersonAccordion_Fragment | NavigationEntryEntryPoint_PersonAccordionEntry_Fragment | NavigationEntryEntryPoint_BlockRibbon_Fragment | NavigationEntryEntryPoint_BlockTable_Fragment | NavigationEntryEntryPoint_BlockThreeColumn_Fragment | NavigationEntryEntryPoint_BlockVideo_Fragment | NavigationEntryEntryPoint_NewsArticleContact_Fragment | NavigationEntryEntryPoint_BlockSpeechBubble_Fragment | NavigationEntryEntryPoint_LatestDownload_Fragment | NavigationEntryEntryPoint_NavigationEntry_Fragment | NavigationEntryEntryPoint_BlockLinkSection_Fragment | NavigationEntryEntryPoint_LinkSectionEntry_Fragment | NavigationEntryEntryPoint_BlockStockPrice_Fragment | NavigationEntryEntryPoint_BlockImageGallery_Fragment | NavigationEntryEntryPoint_BlockSlider_Fragment | NavigationEntryEntryPoint_BlockSliderEntry_Fragment | NavigationEntryEntryPoint_BlockTextCloud_Fragment | NavigationEntryEntryPoint_Seo_Fragment | NavigationEntryEntryPoint_RegionDescriptionText_Fragment | NavigationEntryEntryPoint_ProjectLink_Fragment | NavigationEntryEntryPoint_BlockProjectLinkSection_Fragment | NavigationEntryEntryPoint_ProjectImageMap_Fragment | NavigationEntryEntryPoint_DownloadableFile_Fragment | NavigationEntryEntryPoint_Footer_Fragment;

export type GetOneColumnLayoutByIdQueryVariables = Exact<{
  locale?: Maybe<Scalars['String']>;
  preview?: Maybe<Scalars['Boolean']>;
  id: Scalars['String'];
}>;


export type GetOneColumnLayoutByIdQuery = (
  { __typename?: 'Query' }
  & { entryCollection?: Maybe<(
    { __typename?: 'EntryCollection' }
    & { items: Array<Maybe<(
      { __typename?: 'HeroImage' }
      & OneColumnLayoutEntryPoint_HeroImage_Fragment
    ) | (
      { __typename?: 'StaticPage' }
      & OneColumnLayoutEntryPoint_StaticPage_Fragment
    ) | (
      { __typename?: 'NavBarEntry' }
      & OneColumnLayoutEntryPoint_NavBarEntry_Fragment
    ) | (
      { __typename?: 'BlockSubNavigation' }
      & OneColumnLayoutEntryPoint_BlockSubNavigation_Fragment
    ) | (
      { __typename?: 'BlockBigTitleNavigation' }
      & OneColumnLayoutEntryPoint_BlockBigTitleNavigation_Fragment
    ) | (
      { __typename?: 'BlockHiddenWithConsent' }
      & OneColumnLayoutEntryPoint_BlockHiddenWithConsent_Fragment
    ) | (
      { __typename?: 'BlockAccordion' }
      & OneColumnLayoutEntryPoint_BlockAccordion_Fragment
    ) | (
      { __typename?: 'BlockOneColumn' }
      & OneColumnLayoutEntryPoint_BlockOneColumn_Fragment
    ) | (
      { __typename?: 'BlockAnalystRating' }
      & OneColumnLayoutEntryPoint_BlockAnalystRating_Fragment
    ) | (
      { __typename?: 'BlockCallToActionButton' }
      & OneColumnLayoutEntryPoint_BlockCallToActionButton_Fragment
    ) | (
      { __typename?: 'BlockTwoColumn' }
      & OneColumnLayoutEntryPoint_BlockTwoColumn_Fragment
    ) | (
      { __typename?: 'BlockAccordionEntry' }
      & OneColumnLayoutEntryPoint_BlockAccordionEntry_Fragment
    ) | (
      { __typename?: 'NewsArticle' }
      & OneColumnLayoutEntryPoint_NewsArticle_Fragment
    ) | (
      { __typename?: 'BlockRichText' }
      & OneColumnLayoutEntryPoint_BlockRichText_Fragment
    ) | (
      { __typename?: 'LexiconArticle' }
      & OneColumnLayoutEntryPoint_LexiconArticle_Fragment
    ) | (
      { __typename?: 'ProjectPage' }
      & OneColumnLayoutEntryPoint_ProjectPage_Fragment
    ) | (
      { __typename?: 'BarChartWithBackground' }
      & OneColumnLayoutEntryPoint_BarChartWithBackground_Fragment
    ) | (
      { __typename?: 'BlockCustom' }
      & OneColumnLayoutEntryPoint_BlockCustom_Fragment
    ) | (
      { __typename?: 'BlockFullsizeImage' }
      & OneColumnLayoutEntryPoint_BlockFullsizeImage_Fragment
    ) | (
      { __typename?: 'BlockHighlightRealEstate' }
      & OneColumnLayoutEntryPoint_BlockHighlightRealEstate_Fragment
    ) | (
      { __typename?: 'HighlightedRealEstate' }
      & OneColumnLayoutEntryPoint_HighlightedRealEstate_Fragment
    ) | (
      { __typename?: 'BlockPartnerGrid' }
      & OneColumnLayoutEntryPoint_BlockPartnerGrid_Fragment
    ) | (
      { __typename?: 'Partner' }
      & OneColumnLayoutEntryPoint_Partner_Fragment
    ) | (
      { __typename?: 'BlockPersonAccordion' }
      & OneColumnLayoutEntryPoint_BlockPersonAccordion_Fragment
    ) | (
      { __typename?: 'PersonAccordionEntry' }
      & OneColumnLayoutEntryPoint_PersonAccordionEntry_Fragment
    ) | (
      { __typename?: 'BlockRibbon' }
      & OneColumnLayoutEntryPoint_BlockRibbon_Fragment
    ) | (
      { __typename?: 'BlockTable' }
      & OneColumnLayoutEntryPoint_BlockTable_Fragment
    ) | (
      { __typename?: 'BlockThreeColumn' }
      & OneColumnLayoutEntryPoint_BlockThreeColumn_Fragment
    ) | (
      { __typename?: 'BlockVideo' }
      & OneColumnLayoutEntryPoint_BlockVideo_Fragment
    ) | (
      { __typename?: 'NewsArticleContact' }
      & OneColumnLayoutEntryPoint_NewsArticleContact_Fragment
    ) | (
      { __typename?: 'BlockSpeechBubble' }
      & OneColumnLayoutEntryPoint_BlockSpeechBubble_Fragment
    ) | (
      { __typename?: 'LatestDownload' }
      & OneColumnLayoutEntryPoint_LatestDownload_Fragment
    ) | (
      { __typename?: 'NavigationEntry' }
      & OneColumnLayoutEntryPoint_NavigationEntry_Fragment
    ) | (
      { __typename?: 'BlockLinkSection' }
      & OneColumnLayoutEntryPoint_BlockLinkSection_Fragment
    ) | (
      { __typename?: 'LinkSectionEntry' }
      & OneColumnLayoutEntryPoint_LinkSectionEntry_Fragment
    ) | (
      { __typename?: 'BlockStockPrice' }
      & OneColumnLayoutEntryPoint_BlockStockPrice_Fragment
    ) | (
      { __typename?: 'BlockImageGallery' }
      & OneColumnLayoutEntryPoint_BlockImageGallery_Fragment
    ) | (
      { __typename?: 'BlockSlider' }
      & OneColumnLayoutEntryPoint_BlockSlider_Fragment
    ) | (
      { __typename?: 'BlockSliderEntry' }
      & OneColumnLayoutEntryPoint_BlockSliderEntry_Fragment
    ) | (
      { __typename?: 'BlockTextCloud' }
      & OneColumnLayoutEntryPoint_BlockTextCloud_Fragment
    ) | (
      { __typename?: 'Seo' }
      & OneColumnLayoutEntryPoint_Seo_Fragment
    ) | (
      { __typename?: 'RegionDescriptionText' }
      & OneColumnLayoutEntryPoint_RegionDescriptionText_Fragment
    ) | (
      { __typename?: 'ProjectLink' }
      & OneColumnLayoutEntryPoint_ProjectLink_Fragment
    ) | (
      { __typename?: 'BlockProjectLinkSection' }
      & OneColumnLayoutEntryPoint_BlockProjectLinkSection_Fragment
    ) | (
      { __typename?: 'ProjectImageMap' }
      & OneColumnLayoutEntryPoint_ProjectImageMap_Fragment
    ) | (
      { __typename?: 'DownloadableFile' }
      & OneColumnLayoutEntryPoint_DownloadableFile_Fragment
    ) | (
      { __typename?: 'Footer' }
      & OneColumnLayoutEntryPoint_Footer_Fragment
    )>> }
  )> }
);

type OneColumnLayoutEntryPoint_HeroImage_Fragment = (
  { __typename?: 'HeroImage' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type OneColumnLayoutEntryPoint_StaticPage_Fragment = (
  { __typename?: 'StaticPage' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type OneColumnLayoutEntryPoint_NavBarEntry_Fragment = (
  { __typename?: 'NavBarEntry' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type OneColumnLayoutEntryPoint_BlockSubNavigation_Fragment = (
  { __typename?: 'BlockSubNavigation' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type OneColumnLayoutEntryPoint_BlockBigTitleNavigation_Fragment = (
  { __typename?: 'BlockBigTitleNavigation' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type OneColumnLayoutEntryPoint_BlockHiddenWithConsent_Fragment = (
  { __typename?: 'BlockHiddenWithConsent' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type OneColumnLayoutEntryPoint_BlockAccordion_Fragment = (
  { __typename?: 'BlockAccordion' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type OneColumnLayoutEntryPoint_BlockOneColumn_Fragment = (
  { __typename?: 'BlockOneColumn' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
  & OneColumnLayoutFragment
);

type OneColumnLayoutEntryPoint_BlockAnalystRating_Fragment = (
  { __typename?: 'BlockAnalystRating' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type OneColumnLayoutEntryPoint_BlockCallToActionButton_Fragment = (
  { __typename?: 'BlockCallToActionButton' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type OneColumnLayoutEntryPoint_BlockTwoColumn_Fragment = (
  { __typename?: 'BlockTwoColumn' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type OneColumnLayoutEntryPoint_BlockAccordionEntry_Fragment = (
  { __typename?: 'BlockAccordionEntry' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type OneColumnLayoutEntryPoint_NewsArticle_Fragment = (
  { __typename?: 'NewsArticle' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type OneColumnLayoutEntryPoint_BlockRichText_Fragment = (
  { __typename?: 'BlockRichText' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type OneColumnLayoutEntryPoint_LexiconArticle_Fragment = (
  { __typename?: 'LexiconArticle' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type OneColumnLayoutEntryPoint_ProjectPage_Fragment = (
  { __typename?: 'ProjectPage' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type OneColumnLayoutEntryPoint_BarChartWithBackground_Fragment = (
  { __typename?: 'BarChartWithBackground' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type OneColumnLayoutEntryPoint_BlockCustom_Fragment = (
  { __typename?: 'BlockCustom' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type OneColumnLayoutEntryPoint_BlockFullsizeImage_Fragment = (
  { __typename?: 'BlockFullsizeImage' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type OneColumnLayoutEntryPoint_BlockHighlightRealEstate_Fragment = (
  { __typename?: 'BlockHighlightRealEstate' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type OneColumnLayoutEntryPoint_HighlightedRealEstate_Fragment = (
  { __typename?: 'HighlightedRealEstate' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type OneColumnLayoutEntryPoint_BlockPartnerGrid_Fragment = (
  { __typename?: 'BlockPartnerGrid' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type OneColumnLayoutEntryPoint_Partner_Fragment = (
  { __typename?: 'Partner' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type OneColumnLayoutEntryPoint_BlockPersonAccordion_Fragment = (
  { __typename?: 'BlockPersonAccordion' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type OneColumnLayoutEntryPoint_PersonAccordionEntry_Fragment = (
  { __typename?: 'PersonAccordionEntry' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type OneColumnLayoutEntryPoint_BlockRibbon_Fragment = (
  { __typename?: 'BlockRibbon' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type OneColumnLayoutEntryPoint_BlockTable_Fragment = (
  { __typename?: 'BlockTable' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type OneColumnLayoutEntryPoint_BlockThreeColumn_Fragment = (
  { __typename?: 'BlockThreeColumn' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type OneColumnLayoutEntryPoint_BlockVideo_Fragment = (
  { __typename?: 'BlockVideo' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type OneColumnLayoutEntryPoint_NewsArticleContact_Fragment = (
  { __typename?: 'NewsArticleContact' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type OneColumnLayoutEntryPoint_BlockSpeechBubble_Fragment = (
  { __typename?: 'BlockSpeechBubble' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type OneColumnLayoutEntryPoint_LatestDownload_Fragment = (
  { __typename?: 'LatestDownload' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type OneColumnLayoutEntryPoint_NavigationEntry_Fragment = (
  { __typename?: 'NavigationEntry' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type OneColumnLayoutEntryPoint_BlockLinkSection_Fragment = (
  { __typename?: 'BlockLinkSection' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type OneColumnLayoutEntryPoint_LinkSectionEntry_Fragment = (
  { __typename?: 'LinkSectionEntry' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type OneColumnLayoutEntryPoint_BlockStockPrice_Fragment = (
  { __typename?: 'BlockStockPrice' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type OneColumnLayoutEntryPoint_BlockImageGallery_Fragment = (
  { __typename?: 'BlockImageGallery' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type OneColumnLayoutEntryPoint_BlockSlider_Fragment = (
  { __typename?: 'BlockSlider' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type OneColumnLayoutEntryPoint_BlockSliderEntry_Fragment = (
  { __typename?: 'BlockSliderEntry' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type OneColumnLayoutEntryPoint_BlockTextCloud_Fragment = (
  { __typename?: 'BlockTextCloud' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type OneColumnLayoutEntryPoint_Seo_Fragment = (
  { __typename?: 'Seo' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type OneColumnLayoutEntryPoint_RegionDescriptionText_Fragment = (
  { __typename?: 'RegionDescriptionText' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type OneColumnLayoutEntryPoint_ProjectLink_Fragment = (
  { __typename?: 'ProjectLink' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type OneColumnLayoutEntryPoint_BlockProjectLinkSection_Fragment = (
  { __typename?: 'BlockProjectLinkSection' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type OneColumnLayoutEntryPoint_ProjectImageMap_Fragment = (
  { __typename?: 'ProjectImageMap' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type OneColumnLayoutEntryPoint_DownloadableFile_Fragment = (
  { __typename?: 'DownloadableFile' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type OneColumnLayoutEntryPoint_Footer_Fragment = (
  { __typename?: 'Footer' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

export type OneColumnLayoutEntryPointFragment = OneColumnLayoutEntryPoint_HeroImage_Fragment | OneColumnLayoutEntryPoint_StaticPage_Fragment | OneColumnLayoutEntryPoint_NavBarEntry_Fragment | OneColumnLayoutEntryPoint_BlockSubNavigation_Fragment | OneColumnLayoutEntryPoint_BlockBigTitleNavigation_Fragment | OneColumnLayoutEntryPoint_BlockHiddenWithConsent_Fragment | OneColumnLayoutEntryPoint_BlockAccordion_Fragment | OneColumnLayoutEntryPoint_BlockOneColumn_Fragment | OneColumnLayoutEntryPoint_BlockAnalystRating_Fragment | OneColumnLayoutEntryPoint_BlockCallToActionButton_Fragment | OneColumnLayoutEntryPoint_BlockTwoColumn_Fragment | OneColumnLayoutEntryPoint_BlockAccordionEntry_Fragment | OneColumnLayoutEntryPoint_NewsArticle_Fragment | OneColumnLayoutEntryPoint_BlockRichText_Fragment | OneColumnLayoutEntryPoint_LexiconArticle_Fragment | OneColumnLayoutEntryPoint_ProjectPage_Fragment | OneColumnLayoutEntryPoint_BarChartWithBackground_Fragment | OneColumnLayoutEntryPoint_BlockCustom_Fragment | OneColumnLayoutEntryPoint_BlockFullsizeImage_Fragment | OneColumnLayoutEntryPoint_BlockHighlightRealEstate_Fragment | OneColumnLayoutEntryPoint_HighlightedRealEstate_Fragment | OneColumnLayoutEntryPoint_BlockPartnerGrid_Fragment | OneColumnLayoutEntryPoint_Partner_Fragment | OneColumnLayoutEntryPoint_BlockPersonAccordion_Fragment | OneColumnLayoutEntryPoint_PersonAccordionEntry_Fragment | OneColumnLayoutEntryPoint_BlockRibbon_Fragment | OneColumnLayoutEntryPoint_BlockTable_Fragment | OneColumnLayoutEntryPoint_BlockThreeColumn_Fragment | OneColumnLayoutEntryPoint_BlockVideo_Fragment | OneColumnLayoutEntryPoint_NewsArticleContact_Fragment | OneColumnLayoutEntryPoint_BlockSpeechBubble_Fragment | OneColumnLayoutEntryPoint_LatestDownload_Fragment | OneColumnLayoutEntryPoint_NavigationEntry_Fragment | OneColumnLayoutEntryPoint_BlockLinkSection_Fragment | OneColumnLayoutEntryPoint_LinkSectionEntry_Fragment | OneColumnLayoutEntryPoint_BlockStockPrice_Fragment | OneColumnLayoutEntryPoint_BlockImageGallery_Fragment | OneColumnLayoutEntryPoint_BlockSlider_Fragment | OneColumnLayoutEntryPoint_BlockSliderEntry_Fragment | OneColumnLayoutEntryPoint_BlockTextCloud_Fragment | OneColumnLayoutEntryPoint_Seo_Fragment | OneColumnLayoutEntryPoint_RegionDescriptionText_Fragment | OneColumnLayoutEntryPoint_ProjectLink_Fragment | OneColumnLayoutEntryPoint_BlockProjectLinkSection_Fragment | OneColumnLayoutEntryPoint_ProjectImageMap_Fragment | OneColumnLayoutEntryPoint_DownloadableFile_Fragment | OneColumnLayoutEntryPoint_Footer_Fragment;

export type GetPersonAccordionByIdQueryVariables = Exact<{
  locale?: Maybe<Scalars['String']>;
  preview?: Maybe<Scalars['Boolean']>;
  id: Scalars['String'];
}>;


export type GetPersonAccordionByIdQuery = (
  { __typename?: 'Query' }
  & { entryCollection?: Maybe<(
    { __typename?: 'EntryCollection' }
    & { items: Array<Maybe<(
      { __typename?: 'HeroImage' }
      & PersonAccordionEntryPoint_HeroImage_Fragment
    ) | (
      { __typename?: 'StaticPage' }
      & PersonAccordionEntryPoint_StaticPage_Fragment
    ) | (
      { __typename?: 'NavBarEntry' }
      & PersonAccordionEntryPoint_NavBarEntry_Fragment
    ) | (
      { __typename?: 'BlockSubNavigation' }
      & PersonAccordionEntryPoint_BlockSubNavigation_Fragment
    ) | (
      { __typename?: 'BlockBigTitleNavigation' }
      & PersonAccordionEntryPoint_BlockBigTitleNavigation_Fragment
    ) | (
      { __typename?: 'BlockHiddenWithConsent' }
      & PersonAccordionEntryPoint_BlockHiddenWithConsent_Fragment
    ) | (
      { __typename?: 'BlockAccordion' }
      & PersonAccordionEntryPoint_BlockAccordion_Fragment
    ) | (
      { __typename?: 'BlockOneColumn' }
      & PersonAccordionEntryPoint_BlockOneColumn_Fragment
    ) | (
      { __typename?: 'BlockAnalystRating' }
      & PersonAccordionEntryPoint_BlockAnalystRating_Fragment
    ) | (
      { __typename?: 'BlockCallToActionButton' }
      & PersonAccordionEntryPoint_BlockCallToActionButton_Fragment
    ) | (
      { __typename?: 'BlockTwoColumn' }
      & PersonAccordionEntryPoint_BlockTwoColumn_Fragment
    ) | (
      { __typename?: 'BlockAccordionEntry' }
      & PersonAccordionEntryPoint_BlockAccordionEntry_Fragment
    ) | (
      { __typename?: 'NewsArticle' }
      & PersonAccordionEntryPoint_NewsArticle_Fragment
    ) | (
      { __typename?: 'BlockRichText' }
      & PersonAccordionEntryPoint_BlockRichText_Fragment
    ) | (
      { __typename?: 'LexiconArticle' }
      & PersonAccordionEntryPoint_LexiconArticle_Fragment
    ) | (
      { __typename?: 'ProjectPage' }
      & PersonAccordionEntryPoint_ProjectPage_Fragment
    ) | (
      { __typename?: 'BarChartWithBackground' }
      & PersonAccordionEntryPoint_BarChartWithBackground_Fragment
    ) | (
      { __typename?: 'BlockCustom' }
      & PersonAccordionEntryPoint_BlockCustom_Fragment
    ) | (
      { __typename?: 'BlockFullsizeImage' }
      & PersonAccordionEntryPoint_BlockFullsizeImage_Fragment
    ) | (
      { __typename?: 'BlockHighlightRealEstate' }
      & PersonAccordionEntryPoint_BlockHighlightRealEstate_Fragment
    ) | (
      { __typename?: 'HighlightedRealEstate' }
      & PersonAccordionEntryPoint_HighlightedRealEstate_Fragment
    ) | (
      { __typename?: 'BlockPartnerGrid' }
      & PersonAccordionEntryPoint_BlockPartnerGrid_Fragment
    ) | (
      { __typename?: 'Partner' }
      & PersonAccordionEntryPoint_Partner_Fragment
    ) | (
      { __typename?: 'BlockPersonAccordion' }
      & PersonAccordionEntryPoint_BlockPersonAccordion_Fragment
    ) | (
      { __typename?: 'PersonAccordionEntry' }
      & PersonAccordionEntryPoint_PersonAccordionEntry_Fragment
    ) | (
      { __typename?: 'BlockRibbon' }
      & PersonAccordionEntryPoint_BlockRibbon_Fragment
    ) | (
      { __typename?: 'BlockTable' }
      & PersonAccordionEntryPoint_BlockTable_Fragment
    ) | (
      { __typename?: 'BlockThreeColumn' }
      & PersonAccordionEntryPoint_BlockThreeColumn_Fragment
    ) | (
      { __typename?: 'BlockVideo' }
      & PersonAccordionEntryPoint_BlockVideo_Fragment
    ) | (
      { __typename?: 'NewsArticleContact' }
      & PersonAccordionEntryPoint_NewsArticleContact_Fragment
    ) | (
      { __typename?: 'BlockSpeechBubble' }
      & PersonAccordionEntryPoint_BlockSpeechBubble_Fragment
    ) | (
      { __typename?: 'LatestDownload' }
      & PersonAccordionEntryPoint_LatestDownload_Fragment
    ) | (
      { __typename?: 'NavigationEntry' }
      & PersonAccordionEntryPoint_NavigationEntry_Fragment
    ) | (
      { __typename?: 'BlockLinkSection' }
      & PersonAccordionEntryPoint_BlockLinkSection_Fragment
    ) | (
      { __typename?: 'LinkSectionEntry' }
      & PersonAccordionEntryPoint_LinkSectionEntry_Fragment
    ) | (
      { __typename?: 'BlockStockPrice' }
      & PersonAccordionEntryPoint_BlockStockPrice_Fragment
    ) | (
      { __typename?: 'BlockImageGallery' }
      & PersonAccordionEntryPoint_BlockImageGallery_Fragment
    ) | (
      { __typename?: 'BlockSlider' }
      & PersonAccordionEntryPoint_BlockSlider_Fragment
    ) | (
      { __typename?: 'BlockSliderEntry' }
      & PersonAccordionEntryPoint_BlockSliderEntry_Fragment
    ) | (
      { __typename?: 'BlockTextCloud' }
      & PersonAccordionEntryPoint_BlockTextCloud_Fragment
    ) | (
      { __typename?: 'Seo' }
      & PersonAccordionEntryPoint_Seo_Fragment
    ) | (
      { __typename?: 'RegionDescriptionText' }
      & PersonAccordionEntryPoint_RegionDescriptionText_Fragment
    ) | (
      { __typename?: 'ProjectLink' }
      & PersonAccordionEntryPoint_ProjectLink_Fragment
    ) | (
      { __typename?: 'BlockProjectLinkSection' }
      & PersonAccordionEntryPoint_BlockProjectLinkSection_Fragment
    ) | (
      { __typename?: 'ProjectImageMap' }
      & PersonAccordionEntryPoint_ProjectImageMap_Fragment
    ) | (
      { __typename?: 'DownloadableFile' }
      & PersonAccordionEntryPoint_DownloadableFile_Fragment
    ) | (
      { __typename?: 'Footer' }
      & PersonAccordionEntryPoint_Footer_Fragment
    )>> }
  )> }
);

type PersonAccordionEntryPoint_HeroImage_Fragment = (
  { __typename?: 'HeroImage' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type PersonAccordionEntryPoint_StaticPage_Fragment = (
  { __typename?: 'StaticPage' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type PersonAccordionEntryPoint_NavBarEntry_Fragment = (
  { __typename?: 'NavBarEntry' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type PersonAccordionEntryPoint_BlockSubNavigation_Fragment = (
  { __typename?: 'BlockSubNavigation' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type PersonAccordionEntryPoint_BlockBigTitleNavigation_Fragment = (
  { __typename?: 'BlockBigTitleNavigation' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type PersonAccordionEntryPoint_BlockHiddenWithConsent_Fragment = (
  { __typename?: 'BlockHiddenWithConsent' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type PersonAccordionEntryPoint_BlockAccordion_Fragment = (
  { __typename?: 'BlockAccordion' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type PersonAccordionEntryPoint_BlockOneColumn_Fragment = (
  { __typename?: 'BlockOneColumn' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type PersonAccordionEntryPoint_BlockAnalystRating_Fragment = (
  { __typename?: 'BlockAnalystRating' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type PersonAccordionEntryPoint_BlockCallToActionButton_Fragment = (
  { __typename?: 'BlockCallToActionButton' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type PersonAccordionEntryPoint_BlockTwoColumn_Fragment = (
  { __typename?: 'BlockTwoColumn' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type PersonAccordionEntryPoint_BlockAccordionEntry_Fragment = (
  { __typename?: 'BlockAccordionEntry' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type PersonAccordionEntryPoint_NewsArticle_Fragment = (
  { __typename?: 'NewsArticle' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type PersonAccordionEntryPoint_BlockRichText_Fragment = (
  { __typename?: 'BlockRichText' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type PersonAccordionEntryPoint_LexiconArticle_Fragment = (
  { __typename?: 'LexiconArticle' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type PersonAccordionEntryPoint_ProjectPage_Fragment = (
  { __typename?: 'ProjectPage' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type PersonAccordionEntryPoint_BarChartWithBackground_Fragment = (
  { __typename?: 'BarChartWithBackground' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type PersonAccordionEntryPoint_BlockCustom_Fragment = (
  { __typename?: 'BlockCustom' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type PersonAccordionEntryPoint_BlockFullsizeImage_Fragment = (
  { __typename?: 'BlockFullsizeImage' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type PersonAccordionEntryPoint_BlockHighlightRealEstate_Fragment = (
  { __typename?: 'BlockHighlightRealEstate' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type PersonAccordionEntryPoint_HighlightedRealEstate_Fragment = (
  { __typename?: 'HighlightedRealEstate' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type PersonAccordionEntryPoint_BlockPartnerGrid_Fragment = (
  { __typename?: 'BlockPartnerGrid' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type PersonAccordionEntryPoint_Partner_Fragment = (
  { __typename?: 'Partner' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type PersonAccordionEntryPoint_BlockPersonAccordion_Fragment = (
  { __typename?: 'BlockPersonAccordion' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
  & PersonAccordionFragment
);

type PersonAccordionEntryPoint_PersonAccordionEntry_Fragment = (
  { __typename?: 'PersonAccordionEntry' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type PersonAccordionEntryPoint_BlockRibbon_Fragment = (
  { __typename?: 'BlockRibbon' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type PersonAccordionEntryPoint_BlockTable_Fragment = (
  { __typename?: 'BlockTable' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type PersonAccordionEntryPoint_BlockThreeColumn_Fragment = (
  { __typename?: 'BlockThreeColumn' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type PersonAccordionEntryPoint_BlockVideo_Fragment = (
  { __typename?: 'BlockVideo' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type PersonAccordionEntryPoint_NewsArticleContact_Fragment = (
  { __typename?: 'NewsArticleContact' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type PersonAccordionEntryPoint_BlockSpeechBubble_Fragment = (
  { __typename?: 'BlockSpeechBubble' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type PersonAccordionEntryPoint_LatestDownload_Fragment = (
  { __typename?: 'LatestDownload' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type PersonAccordionEntryPoint_NavigationEntry_Fragment = (
  { __typename?: 'NavigationEntry' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type PersonAccordionEntryPoint_BlockLinkSection_Fragment = (
  { __typename?: 'BlockLinkSection' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type PersonAccordionEntryPoint_LinkSectionEntry_Fragment = (
  { __typename?: 'LinkSectionEntry' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type PersonAccordionEntryPoint_BlockStockPrice_Fragment = (
  { __typename?: 'BlockStockPrice' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type PersonAccordionEntryPoint_BlockImageGallery_Fragment = (
  { __typename?: 'BlockImageGallery' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type PersonAccordionEntryPoint_BlockSlider_Fragment = (
  { __typename?: 'BlockSlider' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type PersonAccordionEntryPoint_BlockSliderEntry_Fragment = (
  { __typename?: 'BlockSliderEntry' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type PersonAccordionEntryPoint_BlockTextCloud_Fragment = (
  { __typename?: 'BlockTextCloud' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type PersonAccordionEntryPoint_Seo_Fragment = (
  { __typename?: 'Seo' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type PersonAccordionEntryPoint_RegionDescriptionText_Fragment = (
  { __typename?: 'RegionDescriptionText' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type PersonAccordionEntryPoint_ProjectLink_Fragment = (
  { __typename?: 'ProjectLink' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type PersonAccordionEntryPoint_BlockProjectLinkSection_Fragment = (
  { __typename?: 'BlockProjectLinkSection' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type PersonAccordionEntryPoint_ProjectImageMap_Fragment = (
  { __typename?: 'ProjectImageMap' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type PersonAccordionEntryPoint_DownloadableFile_Fragment = (
  { __typename?: 'DownloadableFile' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type PersonAccordionEntryPoint_Footer_Fragment = (
  { __typename?: 'Footer' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

export type PersonAccordionEntryPointFragment = PersonAccordionEntryPoint_HeroImage_Fragment | PersonAccordionEntryPoint_StaticPage_Fragment | PersonAccordionEntryPoint_NavBarEntry_Fragment | PersonAccordionEntryPoint_BlockSubNavigation_Fragment | PersonAccordionEntryPoint_BlockBigTitleNavigation_Fragment | PersonAccordionEntryPoint_BlockHiddenWithConsent_Fragment | PersonAccordionEntryPoint_BlockAccordion_Fragment | PersonAccordionEntryPoint_BlockOneColumn_Fragment | PersonAccordionEntryPoint_BlockAnalystRating_Fragment | PersonAccordionEntryPoint_BlockCallToActionButton_Fragment | PersonAccordionEntryPoint_BlockTwoColumn_Fragment | PersonAccordionEntryPoint_BlockAccordionEntry_Fragment | PersonAccordionEntryPoint_NewsArticle_Fragment | PersonAccordionEntryPoint_BlockRichText_Fragment | PersonAccordionEntryPoint_LexiconArticle_Fragment | PersonAccordionEntryPoint_ProjectPage_Fragment | PersonAccordionEntryPoint_BarChartWithBackground_Fragment | PersonAccordionEntryPoint_BlockCustom_Fragment | PersonAccordionEntryPoint_BlockFullsizeImage_Fragment | PersonAccordionEntryPoint_BlockHighlightRealEstate_Fragment | PersonAccordionEntryPoint_HighlightedRealEstate_Fragment | PersonAccordionEntryPoint_BlockPartnerGrid_Fragment | PersonAccordionEntryPoint_Partner_Fragment | PersonAccordionEntryPoint_BlockPersonAccordion_Fragment | PersonAccordionEntryPoint_PersonAccordionEntry_Fragment | PersonAccordionEntryPoint_BlockRibbon_Fragment | PersonAccordionEntryPoint_BlockTable_Fragment | PersonAccordionEntryPoint_BlockThreeColumn_Fragment | PersonAccordionEntryPoint_BlockVideo_Fragment | PersonAccordionEntryPoint_NewsArticleContact_Fragment | PersonAccordionEntryPoint_BlockSpeechBubble_Fragment | PersonAccordionEntryPoint_LatestDownload_Fragment | PersonAccordionEntryPoint_NavigationEntry_Fragment | PersonAccordionEntryPoint_BlockLinkSection_Fragment | PersonAccordionEntryPoint_LinkSectionEntry_Fragment | PersonAccordionEntryPoint_BlockStockPrice_Fragment | PersonAccordionEntryPoint_BlockImageGallery_Fragment | PersonAccordionEntryPoint_BlockSlider_Fragment | PersonAccordionEntryPoint_BlockSliderEntry_Fragment | PersonAccordionEntryPoint_BlockTextCloud_Fragment | PersonAccordionEntryPoint_Seo_Fragment | PersonAccordionEntryPoint_RegionDescriptionText_Fragment | PersonAccordionEntryPoint_ProjectLink_Fragment | PersonAccordionEntryPoint_BlockProjectLinkSection_Fragment | PersonAccordionEntryPoint_ProjectImageMap_Fragment | PersonAccordionEntryPoint_DownloadableFile_Fragment | PersonAccordionEntryPoint_Footer_Fragment;

export type GetPersonAccordionEntryByIdQueryVariables = Exact<{
  locale?: Maybe<Scalars['String']>;
  preview?: Maybe<Scalars['Boolean']>;
  id: Scalars['String'];
}>;


export type GetPersonAccordionEntryByIdQuery = (
  { __typename?: 'Query' }
  & { entryCollection?: Maybe<(
    { __typename?: 'EntryCollection' }
    & { items: Array<Maybe<(
      { __typename?: 'HeroImage' }
      & PersonAccordionEntryEntryPoint_HeroImage_Fragment
    ) | (
      { __typename?: 'StaticPage' }
      & PersonAccordionEntryEntryPoint_StaticPage_Fragment
    ) | (
      { __typename?: 'NavBarEntry' }
      & PersonAccordionEntryEntryPoint_NavBarEntry_Fragment
    ) | (
      { __typename?: 'BlockSubNavigation' }
      & PersonAccordionEntryEntryPoint_BlockSubNavigation_Fragment
    ) | (
      { __typename?: 'BlockBigTitleNavigation' }
      & PersonAccordionEntryEntryPoint_BlockBigTitleNavigation_Fragment
    ) | (
      { __typename?: 'BlockHiddenWithConsent' }
      & PersonAccordionEntryEntryPoint_BlockHiddenWithConsent_Fragment
    ) | (
      { __typename?: 'BlockAccordion' }
      & PersonAccordionEntryEntryPoint_BlockAccordion_Fragment
    ) | (
      { __typename?: 'BlockOneColumn' }
      & PersonAccordionEntryEntryPoint_BlockOneColumn_Fragment
    ) | (
      { __typename?: 'BlockAnalystRating' }
      & PersonAccordionEntryEntryPoint_BlockAnalystRating_Fragment
    ) | (
      { __typename?: 'BlockCallToActionButton' }
      & PersonAccordionEntryEntryPoint_BlockCallToActionButton_Fragment
    ) | (
      { __typename?: 'BlockTwoColumn' }
      & PersonAccordionEntryEntryPoint_BlockTwoColumn_Fragment
    ) | (
      { __typename?: 'BlockAccordionEntry' }
      & PersonAccordionEntryEntryPoint_BlockAccordionEntry_Fragment
    ) | (
      { __typename?: 'NewsArticle' }
      & PersonAccordionEntryEntryPoint_NewsArticle_Fragment
    ) | (
      { __typename?: 'BlockRichText' }
      & PersonAccordionEntryEntryPoint_BlockRichText_Fragment
    ) | (
      { __typename?: 'LexiconArticle' }
      & PersonAccordionEntryEntryPoint_LexiconArticle_Fragment
    ) | (
      { __typename?: 'ProjectPage' }
      & PersonAccordionEntryEntryPoint_ProjectPage_Fragment
    ) | (
      { __typename?: 'BarChartWithBackground' }
      & PersonAccordionEntryEntryPoint_BarChartWithBackground_Fragment
    ) | (
      { __typename?: 'BlockCustom' }
      & PersonAccordionEntryEntryPoint_BlockCustom_Fragment
    ) | (
      { __typename?: 'BlockFullsizeImage' }
      & PersonAccordionEntryEntryPoint_BlockFullsizeImage_Fragment
    ) | (
      { __typename?: 'BlockHighlightRealEstate' }
      & PersonAccordionEntryEntryPoint_BlockHighlightRealEstate_Fragment
    ) | (
      { __typename?: 'HighlightedRealEstate' }
      & PersonAccordionEntryEntryPoint_HighlightedRealEstate_Fragment
    ) | (
      { __typename?: 'BlockPartnerGrid' }
      & PersonAccordionEntryEntryPoint_BlockPartnerGrid_Fragment
    ) | (
      { __typename?: 'Partner' }
      & PersonAccordionEntryEntryPoint_Partner_Fragment
    ) | (
      { __typename?: 'BlockPersonAccordion' }
      & PersonAccordionEntryEntryPoint_BlockPersonAccordion_Fragment
    ) | (
      { __typename?: 'PersonAccordionEntry' }
      & PersonAccordionEntryEntryPoint_PersonAccordionEntry_Fragment
    ) | (
      { __typename?: 'BlockRibbon' }
      & PersonAccordionEntryEntryPoint_BlockRibbon_Fragment
    ) | (
      { __typename?: 'BlockTable' }
      & PersonAccordionEntryEntryPoint_BlockTable_Fragment
    ) | (
      { __typename?: 'BlockThreeColumn' }
      & PersonAccordionEntryEntryPoint_BlockThreeColumn_Fragment
    ) | (
      { __typename?: 'BlockVideo' }
      & PersonAccordionEntryEntryPoint_BlockVideo_Fragment
    ) | (
      { __typename?: 'NewsArticleContact' }
      & PersonAccordionEntryEntryPoint_NewsArticleContact_Fragment
    ) | (
      { __typename?: 'BlockSpeechBubble' }
      & PersonAccordionEntryEntryPoint_BlockSpeechBubble_Fragment
    ) | (
      { __typename?: 'LatestDownload' }
      & PersonAccordionEntryEntryPoint_LatestDownload_Fragment
    ) | (
      { __typename?: 'NavigationEntry' }
      & PersonAccordionEntryEntryPoint_NavigationEntry_Fragment
    ) | (
      { __typename?: 'BlockLinkSection' }
      & PersonAccordionEntryEntryPoint_BlockLinkSection_Fragment
    ) | (
      { __typename?: 'LinkSectionEntry' }
      & PersonAccordionEntryEntryPoint_LinkSectionEntry_Fragment
    ) | (
      { __typename?: 'BlockStockPrice' }
      & PersonAccordionEntryEntryPoint_BlockStockPrice_Fragment
    ) | (
      { __typename?: 'BlockImageGallery' }
      & PersonAccordionEntryEntryPoint_BlockImageGallery_Fragment
    ) | (
      { __typename?: 'BlockSlider' }
      & PersonAccordionEntryEntryPoint_BlockSlider_Fragment
    ) | (
      { __typename?: 'BlockSliderEntry' }
      & PersonAccordionEntryEntryPoint_BlockSliderEntry_Fragment
    ) | (
      { __typename?: 'BlockTextCloud' }
      & PersonAccordionEntryEntryPoint_BlockTextCloud_Fragment
    ) | (
      { __typename?: 'Seo' }
      & PersonAccordionEntryEntryPoint_Seo_Fragment
    ) | (
      { __typename?: 'RegionDescriptionText' }
      & PersonAccordionEntryEntryPoint_RegionDescriptionText_Fragment
    ) | (
      { __typename?: 'ProjectLink' }
      & PersonAccordionEntryEntryPoint_ProjectLink_Fragment
    ) | (
      { __typename?: 'BlockProjectLinkSection' }
      & PersonAccordionEntryEntryPoint_BlockProjectLinkSection_Fragment
    ) | (
      { __typename?: 'ProjectImageMap' }
      & PersonAccordionEntryEntryPoint_ProjectImageMap_Fragment
    ) | (
      { __typename?: 'DownloadableFile' }
      & PersonAccordionEntryEntryPoint_DownloadableFile_Fragment
    ) | (
      { __typename?: 'Footer' }
      & PersonAccordionEntryEntryPoint_Footer_Fragment
    )>> }
  )> }
);

type PersonAccordionEntryEntryPoint_HeroImage_Fragment = (
  { __typename?: 'HeroImage' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type PersonAccordionEntryEntryPoint_StaticPage_Fragment = (
  { __typename?: 'StaticPage' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type PersonAccordionEntryEntryPoint_NavBarEntry_Fragment = (
  { __typename?: 'NavBarEntry' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type PersonAccordionEntryEntryPoint_BlockSubNavigation_Fragment = (
  { __typename?: 'BlockSubNavigation' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type PersonAccordionEntryEntryPoint_BlockBigTitleNavigation_Fragment = (
  { __typename?: 'BlockBigTitleNavigation' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type PersonAccordionEntryEntryPoint_BlockHiddenWithConsent_Fragment = (
  { __typename?: 'BlockHiddenWithConsent' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type PersonAccordionEntryEntryPoint_BlockAccordion_Fragment = (
  { __typename?: 'BlockAccordion' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type PersonAccordionEntryEntryPoint_BlockOneColumn_Fragment = (
  { __typename?: 'BlockOneColumn' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type PersonAccordionEntryEntryPoint_BlockAnalystRating_Fragment = (
  { __typename?: 'BlockAnalystRating' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type PersonAccordionEntryEntryPoint_BlockCallToActionButton_Fragment = (
  { __typename?: 'BlockCallToActionButton' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type PersonAccordionEntryEntryPoint_BlockTwoColumn_Fragment = (
  { __typename?: 'BlockTwoColumn' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type PersonAccordionEntryEntryPoint_BlockAccordionEntry_Fragment = (
  { __typename?: 'BlockAccordionEntry' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type PersonAccordionEntryEntryPoint_NewsArticle_Fragment = (
  { __typename?: 'NewsArticle' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type PersonAccordionEntryEntryPoint_BlockRichText_Fragment = (
  { __typename?: 'BlockRichText' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type PersonAccordionEntryEntryPoint_LexiconArticle_Fragment = (
  { __typename?: 'LexiconArticle' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type PersonAccordionEntryEntryPoint_ProjectPage_Fragment = (
  { __typename?: 'ProjectPage' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type PersonAccordionEntryEntryPoint_BarChartWithBackground_Fragment = (
  { __typename?: 'BarChartWithBackground' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type PersonAccordionEntryEntryPoint_BlockCustom_Fragment = (
  { __typename?: 'BlockCustom' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type PersonAccordionEntryEntryPoint_BlockFullsizeImage_Fragment = (
  { __typename?: 'BlockFullsizeImage' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type PersonAccordionEntryEntryPoint_BlockHighlightRealEstate_Fragment = (
  { __typename?: 'BlockHighlightRealEstate' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type PersonAccordionEntryEntryPoint_HighlightedRealEstate_Fragment = (
  { __typename?: 'HighlightedRealEstate' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type PersonAccordionEntryEntryPoint_BlockPartnerGrid_Fragment = (
  { __typename?: 'BlockPartnerGrid' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type PersonAccordionEntryEntryPoint_Partner_Fragment = (
  { __typename?: 'Partner' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type PersonAccordionEntryEntryPoint_BlockPersonAccordion_Fragment = (
  { __typename?: 'BlockPersonAccordion' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type PersonAccordionEntryEntryPoint_PersonAccordionEntry_Fragment = (
  { __typename?: 'PersonAccordionEntry' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
  & PersonAccordionEntryFragment
);

type PersonAccordionEntryEntryPoint_BlockRibbon_Fragment = (
  { __typename?: 'BlockRibbon' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type PersonAccordionEntryEntryPoint_BlockTable_Fragment = (
  { __typename?: 'BlockTable' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type PersonAccordionEntryEntryPoint_BlockThreeColumn_Fragment = (
  { __typename?: 'BlockThreeColumn' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type PersonAccordionEntryEntryPoint_BlockVideo_Fragment = (
  { __typename?: 'BlockVideo' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type PersonAccordionEntryEntryPoint_NewsArticleContact_Fragment = (
  { __typename?: 'NewsArticleContact' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type PersonAccordionEntryEntryPoint_BlockSpeechBubble_Fragment = (
  { __typename?: 'BlockSpeechBubble' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type PersonAccordionEntryEntryPoint_LatestDownload_Fragment = (
  { __typename?: 'LatestDownload' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type PersonAccordionEntryEntryPoint_NavigationEntry_Fragment = (
  { __typename?: 'NavigationEntry' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type PersonAccordionEntryEntryPoint_BlockLinkSection_Fragment = (
  { __typename?: 'BlockLinkSection' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type PersonAccordionEntryEntryPoint_LinkSectionEntry_Fragment = (
  { __typename?: 'LinkSectionEntry' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type PersonAccordionEntryEntryPoint_BlockStockPrice_Fragment = (
  { __typename?: 'BlockStockPrice' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type PersonAccordionEntryEntryPoint_BlockImageGallery_Fragment = (
  { __typename?: 'BlockImageGallery' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type PersonAccordionEntryEntryPoint_BlockSlider_Fragment = (
  { __typename?: 'BlockSlider' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type PersonAccordionEntryEntryPoint_BlockSliderEntry_Fragment = (
  { __typename?: 'BlockSliderEntry' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type PersonAccordionEntryEntryPoint_BlockTextCloud_Fragment = (
  { __typename?: 'BlockTextCloud' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type PersonAccordionEntryEntryPoint_Seo_Fragment = (
  { __typename?: 'Seo' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type PersonAccordionEntryEntryPoint_RegionDescriptionText_Fragment = (
  { __typename?: 'RegionDescriptionText' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type PersonAccordionEntryEntryPoint_ProjectLink_Fragment = (
  { __typename?: 'ProjectLink' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type PersonAccordionEntryEntryPoint_BlockProjectLinkSection_Fragment = (
  { __typename?: 'BlockProjectLinkSection' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type PersonAccordionEntryEntryPoint_ProjectImageMap_Fragment = (
  { __typename?: 'ProjectImageMap' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type PersonAccordionEntryEntryPoint_DownloadableFile_Fragment = (
  { __typename?: 'DownloadableFile' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type PersonAccordionEntryEntryPoint_Footer_Fragment = (
  { __typename?: 'Footer' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

export type PersonAccordionEntryEntryPointFragment = PersonAccordionEntryEntryPoint_HeroImage_Fragment | PersonAccordionEntryEntryPoint_StaticPage_Fragment | PersonAccordionEntryEntryPoint_NavBarEntry_Fragment | PersonAccordionEntryEntryPoint_BlockSubNavigation_Fragment | PersonAccordionEntryEntryPoint_BlockBigTitleNavigation_Fragment | PersonAccordionEntryEntryPoint_BlockHiddenWithConsent_Fragment | PersonAccordionEntryEntryPoint_BlockAccordion_Fragment | PersonAccordionEntryEntryPoint_BlockOneColumn_Fragment | PersonAccordionEntryEntryPoint_BlockAnalystRating_Fragment | PersonAccordionEntryEntryPoint_BlockCallToActionButton_Fragment | PersonAccordionEntryEntryPoint_BlockTwoColumn_Fragment | PersonAccordionEntryEntryPoint_BlockAccordionEntry_Fragment | PersonAccordionEntryEntryPoint_NewsArticle_Fragment | PersonAccordionEntryEntryPoint_BlockRichText_Fragment | PersonAccordionEntryEntryPoint_LexiconArticle_Fragment | PersonAccordionEntryEntryPoint_ProjectPage_Fragment | PersonAccordionEntryEntryPoint_BarChartWithBackground_Fragment | PersonAccordionEntryEntryPoint_BlockCustom_Fragment | PersonAccordionEntryEntryPoint_BlockFullsizeImage_Fragment | PersonAccordionEntryEntryPoint_BlockHighlightRealEstate_Fragment | PersonAccordionEntryEntryPoint_HighlightedRealEstate_Fragment | PersonAccordionEntryEntryPoint_BlockPartnerGrid_Fragment | PersonAccordionEntryEntryPoint_Partner_Fragment | PersonAccordionEntryEntryPoint_BlockPersonAccordion_Fragment | PersonAccordionEntryEntryPoint_PersonAccordionEntry_Fragment | PersonAccordionEntryEntryPoint_BlockRibbon_Fragment | PersonAccordionEntryEntryPoint_BlockTable_Fragment | PersonAccordionEntryEntryPoint_BlockThreeColumn_Fragment | PersonAccordionEntryEntryPoint_BlockVideo_Fragment | PersonAccordionEntryEntryPoint_NewsArticleContact_Fragment | PersonAccordionEntryEntryPoint_BlockSpeechBubble_Fragment | PersonAccordionEntryEntryPoint_LatestDownload_Fragment | PersonAccordionEntryEntryPoint_NavigationEntry_Fragment | PersonAccordionEntryEntryPoint_BlockLinkSection_Fragment | PersonAccordionEntryEntryPoint_LinkSectionEntry_Fragment | PersonAccordionEntryEntryPoint_BlockStockPrice_Fragment | PersonAccordionEntryEntryPoint_BlockImageGallery_Fragment | PersonAccordionEntryEntryPoint_BlockSlider_Fragment | PersonAccordionEntryEntryPoint_BlockSliderEntry_Fragment | PersonAccordionEntryEntryPoint_BlockTextCloud_Fragment | PersonAccordionEntryEntryPoint_Seo_Fragment | PersonAccordionEntryEntryPoint_RegionDescriptionText_Fragment | PersonAccordionEntryEntryPoint_ProjectLink_Fragment | PersonAccordionEntryEntryPoint_BlockProjectLinkSection_Fragment | PersonAccordionEntryEntryPoint_ProjectImageMap_Fragment | PersonAccordionEntryEntryPoint_DownloadableFile_Fragment | PersonAccordionEntryEntryPoint_Footer_Fragment;

export type GetTwoColumnLayoutByIdQueryVariables = Exact<{
  locale?: Maybe<Scalars['String']>;
  preview?: Maybe<Scalars['Boolean']>;
  id: Scalars['String'];
}>;


export type GetTwoColumnLayoutByIdQuery = (
  { __typename?: 'Query' }
  & { entryCollection?: Maybe<(
    { __typename?: 'EntryCollection' }
    & { items: Array<Maybe<(
      { __typename?: 'HeroImage' }
      & TwoColumnLayoutEntryPoint_HeroImage_Fragment
    ) | (
      { __typename?: 'StaticPage' }
      & TwoColumnLayoutEntryPoint_StaticPage_Fragment
    ) | (
      { __typename?: 'NavBarEntry' }
      & TwoColumnLayoutEntryPoint_NavBarEntry_Fragment
    ) | (
      { __typename?: 'BlockSubNavigation' }
      & TwoColumnLayoutEntryPoint_BlockSubNavigation_Fragment
    ) | (
      { __typename?: 'BlockBigTitleNavigation' }
      & TwoColumnLayoutEntryPoint_BlockBigTitleNavigation_Fragment
    ) | (
      { __typename?: 'BlockHiddenWithConsent' }
      & TwoColumnLayoutEntryPoint_BlockHiddenWithConsent_Fragment
    ) | (
      { __typename?: 'BlockAccordion' }
      & TwoColumnLayoutEntryPoint_BlockAccordion_Fragment
    ) | (
      { __typename?: 'BlockOneColumn' }
      & TwoColumnLayoutEntryPoint_BlockOneColumn_Fragment
    ) | (
      { __typename?: 'BlockAnalystRating' }
      & TwoColumnLayoutEntryPoint_BlockAnalystRating_Fragment
    ) | (
      { __typename?: 'BlockCallToActionButton' }
      & TwoColumnLayoutEntryPoint_BlockCallToActionButton_Fragment
    ) | (
      { __typename?: 'BlockTwoColumn' }
      & TwoColumnLayoutEntryPoint_BlockTwoColumn_Fragment
    ) | (
      { __typename?: 'BlockAccordionEntry' }
      & TwoColumnLayoutEntryPoint_BlockAccordionEntry_Fragment
    ) | (
      { __typename?: 'NewsArticle' }
      & TwoColumnLayoutEntryPoint_NewsArticle_Fragment
    ) | (
      { __typename?: 'BlockRichText' }
      & TwoColumnLayoutEntryPoint_BlockRichText_Fragment
    ) | (
      { __typename?: 'LexiconArticle' }
      & TwoColumnLayoutEntryPoint_LexiconArticle_Fragment
    ) | (
      { __typename?: 'ProjectPage' }
      & TwoColumnLayoutEntryPoint_ProjectPage_Fragment
    ) | (
      { __typename?: 'BarChartWithBackground' }
      & TwoColumnLayoutEntryPoint_BarChartWithBackground_Fragment
    ) | (
      { __typename?: 'BlockCustom' }
      & TwoColumnLayoutEntryPoint_BlockCustom_Fragment
    ) | (
      { __typename?: 'BlockFullsizeImage' }
      & TwoColumnLayoutEntryPoint_BlockFullsizeImage_Fragment
    ) | (
      { __typename?: 'BlockHighlightRealEstate' }
      & TwoColumnLayoutEntryPoint_BlockHighlightRealEstate_Fragment
    ) | (
      { __typename?: 'HighlightedRealEstate' }
      & TwoColumnLayoutEntryPoint_HighlightedRealEstate_Fragment
    ) | (
      { __typename?: 'BlockPartnerGrid' }
      & TwoColumnLayoutEntryPoint_BlockPartnerGrid_Fragment
    ) | (
      { __typename?: 'Partner' }
      & TwoColumnLayoutEntryPoint_Partner_Fragment
    ) | (
      { __typename?: 'BlockPersonAccordion' }
      & TwoColumnLayoutEntryPoint_BlockPersonAccordion_Fragment
    ) | (
      { __typename?: 'PersonAccordionEntry' }
      & TwoColumnLayoutEntryPoint_PersonAccordionEntry_Fragment
    ) | (
      { __typename?: 'BlockRibbon' }
      & TwoColumnLayoutEntryPoint_BlockRibbon_Fragment
    ) | (
      { __typename?: 'BlockTable' }
      & TwoColumnLayoutEntryPoint_BlockTable_Fragment
    ) | (
      { __typename?: 'BlockThreeColumn' }
      & TwoColumnLayoutEntryPoint_BlockThreeColumn_Fragment
    ) | (
      { __typename?: 'BlockVideo' }
      & TwoColumnLayoutEntryPoint_BlockVideo_Fragment
    ) | (
      { __typename?: 'NewsArticleContact' }
      & TwoColumnLayoutEntryPoint_NewsArticleContact_Fragment
    ) | (
      { __typename?: 'BlockSpeechBubble' }
      & TwoColumnLayoutEntryPoint_BlockSpeechBubble_Fragment
    ) | (
      { __typename?: 'LatestDownload' }
      & TwoColumnLayoutEntryPoint_LatestDownload_Fragment
    ) | (
      { __typename?: 'NavigationEntry' }
      & TwoColumnLayoutEntryPoint_NavigationEntry_Fragment
    ) | (
      { __typename?: 'BlockLinkSection' }
      & TwoColumnLayoutEntryPoint_BlockLinkSection_Fragment
    ) | (
      { __typename?: 'LinkSectionEntry' }
      & TwoColumnLayoutEntryPoint_LinkSectionEntry_Fragment
    ) | (
      { __typename?: 'BlockStockPrice' }
      & TwoColumnLayoutEntryPoint_BlockStockPrice_Fragment
    ) | (
      { __typename?: 'BlockImageGallery' }
      & TwoColumnLayoutEntryPoint_BlockImageGallery_Fragment
    ) | (
      { __typename?: 'BlockSlider' }
      & TwoColumnLayoutEntryPoint_BlockSlider_Fragment
    ) | (
      { __typename?: 'BlockSliderEntry' }
      & TwoColumnLayoutEntryPoint_BlockSliderEntry_Fragment
    ) | (
      { __typename?: 'BlockTextCloud' }
      & TwoColumnLayoutEntryPoint_BlockTextCloud_Fragment
    ) | (
      { __typename?: 'Seo' }
      & TwoColumnLayoutEntryPoint_Seo_Fragment
    ) | (
      { __typename?: 'RegionDescriptionText' }
      & TwoColumnLayoutEntryPoint_RegionDescriptionText_Fragment
    ) | (
      { __typename?: 'ProjectLink' }
      & TwoColumnLayoutEntryPoint_ProjectLink_Fragment
    ) | (
      { __typename?: 'BlockProjectLinkSection' }
      & TwoColumnLayoutEntryPoint_BlockProjectLinkSection_Fragment
    ) | (
      { __typename?: 'ProjectImageMap' }
      & TwoColumnLayoutEntryPoint_ProjectImageMap_Fragment
    ) | (
      { __typename?: 'DownloadableFile' }
      & TwoColumnLayoutEntryPoint_DownloadableFile_Fragment
    ) | (
      { __typename?: 'Footer' }
      & TwoColumnLayoutEntryPoint_Footer_Fragment
    )>> }
  )> }
);

type TwoColumnLayoutEntryPoint_HeroImage_Fragment = (
  { __typename?: 'HeroImage' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type TwoColumnLayoutEntryPoint_StaticPage_Fragment = (
  { __typename?: 'StaticPage' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type TwoColumnLayoutEntryPoint_NavBarEntry_Fragment = (
  { __typename?: 'NavBarEntry' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type TwoColumnLayoutEntryPoint_BlockSubNavigation_Fragment = (
  { __typename?: 'BlockSubNavigation' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type TwoColumnLayoutEntryPoint_BlockBigTitleNavigation_Fragment = (
  { __typename?: 'BlockBigTitleNavigation' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type TwoColumnLayoutEntryPoint_BlockHiddenWithConsent_Fragment = (
  { __typename?: 'BlockHiddenWithConsent' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type TwoColumnLayoutEntryPoint_BlockAccordion_Fragment = (
  { __typename?: 'BlockAccordion' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type TwoColumnLayoutEntryPoint_BlockOneColumn_Fragment = (
  { __typename?: 'BlockOneColumn' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type TwoColumnLayoutEntryPoint_BlockAnalystRating_Fragment = (
  { __typename?: 'BlockAnalystRating' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type TwoColumnLayoutEntryPoint_BlockCallToActionButton_Fragment = (
  { __typename?: 'BlockCallToActionButton' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type TwoColumnLayoutEntryPoint_BlockTwoColumn_Fragment = (
  { __typename?: 'BlockTwoColumn' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
  & TwoColumnLayoutFragment
);

type TwoColumnLayoutEntryPoint_BlockAccordionEntry_Fragment = (
  { __typename?: 'BlockAccordionEntry' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type TwoColumnLayoutEntryPoint_NewsArticle_Fragment = (
  { __typename?: 'NewsArticle' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type TwoColumnLayoutEntryPoint_BlockRichText_Fragment = (
  { __typename?: 'BlockRichText' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type TwoColumnLayoutEntryPoint_LexiconArticle_Fragment = (
  { __typename?: 'LexiconArticle' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type TwoColumnLayoutEntryPoint_ProjectPage_Fragment = (
  { __typename?: 'ProjectPage' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type TwoColumnLayoutEntryPoint_BarChartWithBackground_Fragment = (
  { __typename?: 'BarChartWithBackground' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type TwoColumnLayoutEntryPoint_BlockCustom_Fragment = (
  { __typename?: 'BlockCustom' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type TwoColumnLayoutEntryPoint_BlockFullsizeImage_Fragment = (
  { __typename?: 'BlockFullsizeImage' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type TwoColumnLayoutEntryPoint_BlockHighlightRealEstate_Fragment = (
  { __typename?: 'BlockHighlightRealEstate' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type TwoColumnLayoutEntryPoint_HighlightedRealEstate_Fragment = (
  { __typename?: 'HighlightedRealEstate' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type TwoColumnLayoutEntryPoint_BlockPartnerGrid_Fragment = (
  { __typename?: 'BlockPartnerGrid' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type TwoColumnLayoutEntryPoint_Partner_Fragment = (
  { __typename?: 'Partner' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type TwoColumnLayoutEntryPoint_BlockPersonAccordion_Fragment = (
  { __typename?: 'BlockPersonAccordion' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type TwoColumnLayoutEntryPoint_PersonAccordionEntry_Fragment = (
  { __typename?: 'PersonAccordionEntry' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type TwoColumnLayoutEntryPoint_BlockRibbon_Fragment = (
  { __typename?: 'BlockRibbon' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type TwoColumnLayoutEntryPoint_BlockTable_Fragment = (
  { __typename?: 'BlockTable' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type TwoColumnLayoutEntryPoint_BlockThreeColumn_Fragment = (
  { __typename?: 'BlockThreeColumn' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type TwoColumnLayoutEntryPoint_BlockVideo_Fragment = (
  { __typename?: 'BlockVideo' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type TwoColumnLayoutEntryPoint_NewsArticleContact_Fragment = (
  { __typename?: 'NewsArticleContact' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type TwoColumnLayoutEntryPoint_BlockSpeechBubble_Fragment = (
  { __typename?: 'BlockSpeechBubble' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type TwoColumnLayoutEntryPoint_LatestDownload_Fragment = (
  { __typename?: 'LatestDownload' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type TwoColumnLayoutEntryPoint_NavigationEntry_Fragment = (
  { __typename?: 'NavigationEntry' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type TwoColumnLayoutEntryPoint_BlockLinkSection_Fragment = (
  { __typename?: 'BlockLinkSection' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type TwoColumnLayoutEntryPoint_LinkSectionEntry_Fragment = (
  { __typename?: 'LinkSectionEntry' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type TwoColumnLayoutEntryPoint_BlockStockPrice_Fragment = (
  { __typename?: 'BlockStockPrice' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type TwoColumnLayoutEntryPoint_BlockImageGallery_Fragment = (
  { __typename?: 'BlockImageGallery' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type TwoColumnLayoutEntryPoint_BlockSlider_Fragment = (
  { __typename?: 'BlockSlider' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type TwoColumnLayoutEntryPoint_BlockSliderEntry_Fragment = (
  { __typename?: 'BlockSliderEntry' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type TwoColumnLayoutEntryPoint_BlockTextCloud_Fragment = (
  { __typename?: 'BlockTextCloud' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type TwoColumnLayoutEntryPoint_Seo_Fragment = (
  { __typename?: 'Seo' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type TwoColumnLayoutEntryPoint_RegionDescriptionText_Fragment = (
  { __typename?: 'RegionDescriptionText' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type TwoColumnLayoutEntryPoint_ProjectLink_Fragment = (
  { __typename?: 'ProjectLink' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type TwoColumnLayoutEntryPoint_BlockProjectLinkSection_Fragment = (
  { __typename?: 'BlockProjectLinkSection' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type TwoColumnLayoutEntryPoint_ProjectImageMap_Fragment = (
  { __typename?: 'ProjectImageMap' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type TwoColumnLayoutEntryPoint_DownloadableFile_Fragment = (
  { __typename?: 'DownloadableFile' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

type TwoColumnLayoutEntryPoint_Footer_Fragment = (
  { __typename?: 'Footer' }
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ) }
);

export type TwoColumnLayoutEntryPointFragment = TwoColumnLayoutEntryPoint_HeroImage_Fragment | TwoColumnLayoutEntryPoint_StaticPage_Fragment | TwoColumnLayoutEntryPoint_NavBarEntry_Fragment | TwoColumnLayoutEntryPoint_BlockSubNavigation_Fragment | TwoColumnLayoutEntryPoint_BlockBigTitleNavigation_Fragment | TwoColumnLayoutEntryPoint_BlockHiddenWithConsent_Fragment | TwoColumnLayoutEntryPoint_BlockAccordion_Fragment | TwoColumnLayoutEntryPoint_BlockOneColumn_Fragment | TwoColumnLayoutEntryPoint_BlockAnalystRating_Fragment | TwoColumnLayoutEntryPoint_BlockCallToActionButton_Fragment | TwoColumnLayoutEntryPoint_BlockTwoColumn_Fragment | TwoColumnLayoutEntryPoint_BlockAccordionEntry_Fragment | TwoColumnLayoutEntryPoint_NewsArticle_Fragment | TwoColumnLayoutEntryPoint_BlockRichText_Fragment | TwoColumnLayoutEntryPoint_LexiconArticle_Fragment | TwoColumnLayoutEntryPoint_ProjectPage_Fragment | TwoColumnLayoutEntryPoint_BarChartWithBackground_Fragment | TwoColumnLayoutEntryPoint_BlockCustom_Fragment | TwoColumnLayoutEntryPoint_BlockFullsizeImage_Fragment | TwoColumnLayoutEntryPoint_BlockHighlightRealEstate_Fragment | TwoColumnLayoutEntryPoint_HighlightedRealEstate_Fragment | TwoColumnLayoutEntryPoint_BlockPartnerGrid_Fragment | TwoColumnLayoutEntryPoint_Partner_Fragment | TwoColumnLayoutEntryPoint_BlockPersonAccordion_Fragment | TwoColumnLayoutEntryPoint_PersonAccordionEntry_Fragment | TwoColumnLayoutEntryPoint_BlockRibbon_Fragment | TwoColumnLayoutEntryPoint_BlockTable_Fragment | TwoColumnLayoutEntryPoint_BlockThreeColumn_Fragment | TwoColumnLayoutEntryPoint_BlockVideo_Fragment | TwoColumnLayoutEntryPoint_NewsArticleContact_Fragment | TwoColumnLayoutEntryPoint_BlockSpeechBubble_Fragment | TwoColumnLayoutEntryPoint_LatestDownload_Fragment | TwoColumnLayoutEntryPoint_NavigationEntry_Fragment | TwoColumnLayoutEntryPoint_BlockLinkSection_Fragment | TwoColumnLayoutEntryPoint_LinkSectionEntry_Fragment | TwoColumnLayoutEntryPoint_BlockStockPrice_Fragment | TwoColumnLayoutEntryPoint_BlockImageGallery_Fragment | TwoColumnLayoutEntryPoint_BlockSlider_Fragment | TwoColumnLayoutEntryPoint_BlockSliderEntry_Fragment | TwoColumnLayoutEntryPoint_BlockTextCloud_Fragment | TwoColumnLayoutEntryPoint_Seo_Fragment | TwoColumnLayoutEntryPoint_RegionDescriptionText_Fragment | TwoColumnLayoutEntryPoint_ProjectLink_Fragment | TwoColumnLayoutEntryPoint_BlockProjectLinkSection_Fragment | TwoColumnLayoutEntryPoint_ProjectImageMap_Fragment | TwoColumnLayoutEntryPoint_DownloadableFile_Fragment | TwoColumnLayoutEntryPoint_Footer_Fragment;

export type GetStaticPageSlugByIdQueryVariables = Exact<{
  locale?: Maybe<Scalars['String']>;
  preview?: Maybe<Scalars['Boolean']>;
  id: Scalars['String'];
}>;


export type GetStaticPageSlugByIdQuery = (
  { __typename?: 'Query' }
  & { page?: Maybe<(
    { __typename?: 'StaticPage' }
    & Pick<StaticPage, 'slug'>
  )> }
);

export type GetStaticPageSlugsQueryVariables = Exact<{
  locale?: Maybe<Scalars['String']>;
  preview?: Maybe<Scalars['Boolean']>;
}>;


export type GetStaticPageSlugsQuery = (
  { __typename?: 'Query' }
  & { pages?: Maybe<(
    { __typename?: 'StaticPageCollection' }
    & { items: Array<Maybe<(
      { __typename?: 'StaticPage' }
      & Pick<StaticPage, 'slug'>
      & { seo?: Maybe<(
        { __typename?: 'Seo' }
        & Pick<Seo, 'noFollowNoIndex'>
      )> }
    )>> }
  )> }
);

export type GetStaticPagesBySlugQueryVariables = Exact<{
  locale?: Maybe<Scalars['String']>;
  preview?: Maybe<Scalars['Boolean']>;
  slug?: Maybe<Scalars['String']>;
}>;


export type GetStaticPagesBySlugQuery = (
  { __typename?: 'Query' }
  & { pages?: Maybe<(
    { __typename?: 'StaticPageCollection' }
    & { items: Array<Maybe<(
      { __typename?: 'StaticPage' }
      & FullPageFragment
      & StaticPageLocaleSlugsFragment
    )>> }
  )> }
);

export type GetStaticPagesByNewsTypeQueryVariables = Exact<{
  locale?: Maybe<Scalars['String']>;
  preview?: Maybe<Scalars['Boolean']>;
  newsType?: Maybe<Scalars['String']>;
}>;


export type GetStaticPagesByNewsTypeQuery = (
  { __typename?: 'Query' }
  & { pages?: Maybe<(
    { __typename?: 'StaticPageCollection' }
    & { items: Array<Maybe<(
      { __typename?: 'StaticPage' }
      & FullPageFragment
      & StaticPageLocaleSlugsFragment
    )>> }
  )> }
);

export type FullPageFragment = (
  { __typename?: 'StaticPage' }
  & Pick<StaticPage, 'slug' | 'pageTitle' | 'standalone' | 'showNewsletterFooter' | 'showContactFooter' | 'removePaddingBottom' | 'pageTag' | 'region' | 'newsType'>
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ), seo?: Maybe<(
    { __typename?: 'Seo' }
    & Pick<Seo, 'title' | 'description' | 'noFollowNoIndex'>
  )>, blocks?: Maybe<(
    { __typename?: 'StaticPageBlocksCollection' }
    & { items: Array<Maybe<(
      { __typename?: 'BarChartWithBackground' }
      & EntryId_BarChartWithBackground_Fragment
    ) | (
      { __typename?: 'BlockAccordion' }
      & EntryId_BlockAccordion_Fragment
    ) | (
      { __typename?: 'BlockAccordionEntry' }
      & EntryId_BlockAccordionEntry_Fragment
    ) | (
      { __typename?: 'BlockAnalystRating' }
      & EntryId_BlockAnalystRating_Fragment
    ) | (
      { __typename?: 'BlockBigTitleNavigation' }
      & EntryId_BlockBigTitleNavigation_Fragment
    ) | (
      { __typename?: 'BlockCallToActionButton' }
      & EntryId_BlockCallToActionButton_Fragment
    ) | (
      { __typename?: 'BlockCustom' }
      & EntryId_BlockCustom_Fragment
    ) | (
      { __typename?: 'BlockFullsizeImage' }
      & EntryId_BlockFullsizeImage_Fragment
    ) | (
      { __typename?: 'BlockHiddenWithConsent' }
      & EntryId_BlockHiddenWithConsent_Fragment
    ) | (
      { __typename?: 'BlockHighlightRealEstate' }
      & EntryId_BlockHighlightRealEstate_Fragment
    ) | (
      { __typename?: 'BlockImageGallery' }
      & EntryId_BlockImageGallery_Fragment
    ) | (
      { __typename?: 'BlockLinkSection' }
      & EntryId_BlockLinkSection_Fragment
    ) | (
      { __typename?: 'BlockOneColumn' }
      & EntryId_BlockOneColumn_Fragment
    ) | (
      { __typename?: 'BlockPartnerGrid' }
      & EntryId_BlockPartnerGrid_Fragment
    ) | (
      { __typename?: 'BlockPersonAccordion' }
      & EntryId_BlockPersonAccordion_Fragment
    ) | (
      { __typename?: 'BlockRibbon' }
      & EntryId_BlockRibbon_Fragment
    ) | (
      { __typename?: 'BlockRichText' }
      & EntryId_BlockRichText_Fragment
    ) | (
      { __typename?: 'BlockSlider' }
      & EntryId_BlockSlider_Fragment
    ) | (
      { __typename?: 'BlockStockPrice' }
      & EntryId_BlockStockPrice_Fragment
    ) | (
      { __typename?: 'BlockSubNavigation' }
      & EntryId_BlockSubNavigation_Fragment
    ) | (
      { __typename?: 'BlockTable' }
      & EntryId_BlockTable_Fragment
    ) | (
      { __typename?: 'BlockTextCloud' }
      & EntryId_BlockTextCloud_Fragment
    ) | (
      { __typename?: 'BlockThreeColumn' }
      & EntryId_BlockThreeColumn_Fragment
    ) | (
      { __typename?: 'BlockTwoColumn' }
      & EntryId_BlockTwoColumn_Fragment
    ) | (
      { __typename?: 'BlockVideo' }
      & EntryId_BlockVideo_Fragment
    ) | (
      { __typename?: 'LatestDownload' }
      & EntryId_LatestDownload_Fragment
    )>> }
  )> }
  & StaticPageHeroImageFragment
);

export type StaticPageHeroImageFragment = (
  { __typename?: 'StaticPage' }
  & { hero?: Maybe<(
    { __typename?: 'HeroImage' }
    & Pick<HeroImage, 'title' | 'subtitle' | 'size'>
    & { backgroundImage?: Maybe<(
      { __typename?: 'Asset' }
      & FullAssetFragment
    )> }
  )> }
);

export type StaticPageLocaleSlugsFragment = (
  { __typename?: 'StaticPage' }
  & { slugDe: StaticPage['slug'], slugEn: StaticPage['slug'] }
);

export type NewsArticleLocaleSlugsFragment = (
  { __typename?: 'NewsArticle' }
  & Pick<NewsArticle, 'newsType'>
  & { slugDe: NewsArticle['slug'], slugEn: NewsArticle['slug'], titleDe: NewsArticle['title'], titleEn: NewsArticle['title'] }
);

export type LexiconArticleLocaleSlugsFragment = (
  { __typename?: 'LexiconArticle' }
  & Pick<LexiconArticle, 'lexiconLetter'>
  & { slugDe: LexiconArticle['slug'], slugEn: LexiconArticle['slug'], titleDe: LexiconArticle['title'], titleEn: LexiconArticle['title'] }
);

export type LatestDownloadByTypeQueryVariables = Exact<{
  locale?: Maybe<Scalars['String']>;
  preview?: Maybe<Scalars['Boolean']>;
  type: Scalars['String'];
}>;


export type LatestDownloadByTypeQuery = (
  { __typename?: 'Query' }
  & { latestDownload?: Maybe<(
    { __typename?: 'DownloadableFileCollection' }
    & { items: Array<Maybe<(
      { __typename?: 'DownloadableFile' }
      & FullDownloadableFileFragment
    )>> }
  )> }
);

export type FullDownloadableFileFragment = (
  { __typename?: 'DownloadableFile' }
  & Pick<DownloadableFile, 'title' | 'type' | 'publishDate'>
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Sys, 'id'>
  ), file?: Maybe<(
    { __typename?: 'Asset' }
    & Pick<Asset, 'title' | 'contentType' | 'fileName' | 'size' | 'url'>
  )> }
);

export const AllNewsArticleFragmentDoc = gql`
    fragment AllNewsArticle on NewsArticle {
  sys {
    id
  }
  title
  date
  slug
}
    `;
export const FullAssetFragmentDoc = gql`
    fragment FullAsset on Asset {
  sys {
    id
  }
  title
  description
  contentType
  fileName
  size
  url
  width
  height
}
    `;
export const FullHyperlinkFragmentDoc = gql`
    fragment FullHyperlink on Asset {
  sys {
    id
  }
  url
  title
  description
  contentType
  fileName
  size
}
    `;
export const FooterFragmentDoc = gql`
    fragment Footer on Footer {
  sys {
    id
  }
  phone
  fax
  richtext {
    json
    links {
      assets {
        block {
          ...FullAsset
        }
        hyperlink {
          ...FullHyperlink
        }
      }
    }
  }
}
    ${FullAssetFragmentDoc}
${FullHyperlinkFragmentDoc}`;
export const LexiconArticleLocaleSlugsFragmentDoc = gql`
    fragment LexiconArticleLocaleSlugs on LexiconArticle {
  lexiconLetter
  slugDe: slug(locale: "de")
  slugEn: slug(locale: "en")
  titleDe: title(locale: "de")
  titleEn: title(locale: "en")
}
    `;
export const EntryIdFragmentDoc = gql`
    fragment EntryId on Entry {
  sys {
    id
  }
}
    `;
export const FullLexiconArticleFragmentDoc = gql`
    fragment FullLexiconArticle on LexiconArticle {
  sys {
    id
  }
  lexiconLetter
  title
  previewText
  ...LexiconArticleLocaleSlugs
  slug
  blocks: blocksCollection(limit: 50) {
    items {
      ...EntryId
    }
  }
}
    ${LexiconArticleLocaleSlugsFragmentDoc}
${EntryIdFragmentDoc}`;
export const LexiconArticlePreviewFragmentDoc = gql`
    fragment LexiconArticlePreview on LexiconArticle {
  sys {
    id
  }
  lexiconLetter
  title
  slug
  previewText
}
    `;
export const LexiconArticleFullTextFragmentDoc = gql`
    fragment LexiconArticleFullText on LexiconArticle {
  ...LexiconArticlePreview
  blocksCollection(limit: 1) {
    total
    items {
      __typename
      ... on BlockRichText {
        richText {
          json
        }
      }
    }
  }
}
    ${LexiconArticlePreviewFragmentDoc}`;
export const NewsArticleLocaleSlugsFragmentDoc = gql`
    fragment NewsArticleLocaleSlugs on NewsArticle {
  newsType
  slugDe: slug(locale: "de")
  slugEn: slug(locale: "en")
  titleDe: title(locale: "de")
  titleEn: title(locale: "en")
}
    `;
export const FullNewsContactFragmentDoc = gql`
    fragment FullNewsContact on NewsArticleContact {
  ...EntryId
  title
  fullName
  company
  street
  postcode
  email
  telefon
}
    ${EntryIdFragmentDoc}`;
export const NewsArticleFileFragmentDoc = gql`
    fragment NewsArticleFile on NewsArticle {
  file {
    sys {
      id
    }
    contentType
    url
    title
    description
  }
}
    `;
export const FullNewsArticleFragmentDoc = gql`
    fragment FullNewsArticle on NewsArticle {
  sys {
    id
  }
  newsType
  title
  date
  hideDate
  previewText
  ...NewsArticleLocaleSlugs
  image {
    ...FullAsset
  }
  slug
  blocks: blocksCollection(limit: 50) {
    items {
      ...EntryId
    }
  }
  contacts: contactsCollection {
    items {
      ...FullNewsContact
    }
  }
  ...NewsArticleFile
}
    ${NewsArticleLocaleSlugsFragmentDoc}
${FullAssetFragmentDoc}
${EntryIdFragmentDoc}
${FullNewsContactFragmentDoc}
${NewsArticleFileFragmentDoc}`;
export const OtherNewsArticleFragmentDoc = gql`
    fragment OtherNewsArticle on NewsArticle {
  sys {
    id
  }
  newsType
  title
  date
  hideDate
  slug
  previewText
  ...NewsArticleFile
  image {
    ...FullAsset
  }
}
    ${NewsArticleFileFragmentDoc}
${FullAssetFragmentDoc}`;
export const NewsArticleFullTextFragmentDoc = gql`
    fragment NewsArticleFullText on NewsArticle {
  ...OtherNewsArticle
  image {
    ...FullAsset
  }
  blocksCollection(limit: 1) {
    total
    items {
      __typename
      ... on BlockRichText {
        richText {
          json
        }
      }
    }
  }
}
    ${OtherNewsArticleFragmentDoc}
${FullAssetFragmentDoc}`;
export const FullProjectImageMapFragmentDoc = gql`
    fragment FullProjectImageMap on ProjectImageMap {
  propstackProjectId
  imagesCollection {
    items {
      url
      width
      height
    }
  }
  imageMapAreas
}
    `;
export const ProjectLinkSectionFragmentDoc = gql`
    fragment ProjectLinkSection on BlockProjectLinkSection {
  propstackProjectId
  title
  description
  projectLinksCollection {
    items {
      title
      link
      backgroundImage {
        ...FullAsset
      }
    }
  }
}
    ${FullAssetFragmentDoc}`;
export const FullProjectPageFragmentDoc = gql`
    fragment FullProjectPage on ProjectPage {
  sys {
    id
  }
  blocksBelowImagesCollection(limit: 50) {
    items {
      ...EntryId
    }
  }
}
    ${EntryIdFragmentDoc}`;
export const StaticFilterFragmentDoc = gql`
    fragment StaticFilter on RegionDescriptionText {
  slug
  seo {
    title
    description
  }
  city
  location
  otherFilter
  constructionAge
  rented
  rsCategory
  roomsMin
  roomsMax
  squareMetersMin
  squareMetersMax
  seoText: regionDescription {
    json
  }
}
    `;
export const FullBlockRichTextFragmentDoc = gql`
    fragment FullBlockRichText on BlockRichText {
  textAlignCenter
  superscript
  superscriptFontSize
  richText {
    json
    links {
      assets {
        block {
          ...FullAsset
        }
        hyperlink {
          ...FullHyperlink
        }
      }
    }
  }
}
    ${FullAssetFragmentDoc}
${FullHyperlinkFragmentDoc}`;
export const FullBlockCallToActionButtonFragmentDoc = gql`
    fragment FullBlockCallToActionButton on BlockCallToActionButton {
  label
  url
  hideIcon
  useNewWindow
  variant
  color
}
    `;
export const TwoColumnLayoutFragmentDoc = gql`
    fragment TwoColumnLayout on BlockTwoColumn {
  rightColumnOffset
  leftColumnCollection(limit: 20) {
    items {
      ...EntryId
    }
  }
  rightColumnCollection(limit: 20) {
    items {
      ...EntryId
    }
  }
  verticalCenterLeftColumn
  verticalCenterRightColumn
  leftColumnTextRight
  variant
  mobileColumnOrder
  appendContactAndNewsletterCtAs
}
    ${EntryIdFragmentDoc}`;
export const BlockThreeColumnFragmentDoc = gql`
    fragment BlockThreeColumn on BlockThreeColumn {
  leftColumnCollection(limit: 20) {
    items {
      ...EntryId
    }
  }
  middleColumnCollection(limit: 20) {
    items {
      ...EntryId
    }
  }
  rightColumnCollection(limit: 20) {
    items {
      ...EntryId
    }
  }
}
    ${EntryIdFragmentDoc}`;
export const AccordionFragmentDoc = gql`
    fragment Accordion on BlockAccordion {
  accordionEntryCollection(limit: 30) {
    items {
      ...EntryId
    }
  }
  aquaColor
  smallSize
  widgetType
  isControlled
}
    ${EntryIdFragmentDoc}`;
export const AccordionEntryFragmentDoc = gql`
    fragment AccordionEntry on BlockAccordionEntry {
  title
  titleWhenExpanded
  blocksCollection(limit: 30) {
    items {
      ...EntryId
    }
  }
}
    ${EntryIdFragmentDoc}`;
export const CustomBlockFragmentDoc = gql`
    fragment CustomBlock on BlockCustom {
  customBlockType
}
    `;
export const PersonAccordionFragmentDoc = gql`
    fragment PersonAccordion on BlockPersonAccordion {
  title
  personEntriesCollection {
    items {
      fullName
      ...EntryId
    }
  }
}
    ${EntryIdFragmentDoc}`;
export const PersonAccordionEntryFragmentDoc = gql`
    fragment PersonAccordionEntry on PersonAccordionEntry {
  ...EntryId
  fullName
  jobTitle
  description
  portraitImage {
    ...FullAsset
  }
}
    ${EntryIdFragmentDoc}
${FullAssetFragmentDoc}`;
export const BarChartWithBackgroundFragmentDoc = gql`
    fragment BarChartWithBackground on BarChartWithBackground {
  title
  bars
}
    `;
export const FullBlockRibbonFragmentDoc = gql`
    fragment FullBlockRibbon on BlockRibbon {
  ...EntryId
  heading1
  subheading1
  heading2
  subheading2
  heading3
  subheading3
  heading4
  subheading4
  variant
  overlayImage {
    ...FullAsset
  }
}
    ${EntryIdFragmentDoc}
${FullAssetFragmentDoc}`;
export const FullBlockTableFragmentDoc = gql`
    fragment FullBlockTable on BlockTable {
  title
  variant
  table
}
    `;
export const LatestDownloadFragmentDoc = gql`
    fragment LatestDownload on LatestDownload {
  type
}
    `;
export const BlockImageGalleryFragmentDoc = gql`
    fragment BlockImageGallery on BlockImageGallery {
  size
  imagesCollection(limit: 20) {
    items {
      ...FullAsset
    }
  }
}
    ${FullAssetFragmentDoc}`;
export const BlockSliderFragmentDoc = gql`
    fragment BlockSlider on BlockSlider {
  slidesCollection(limit: 20) {
    items {
      ...EntryId
    }
  }
}
    ${EntryIdFragmentDoc}`;
export const BlockSliderEntryFragmentDoc = gql`
    fragment BlockSliderEntry on BlockSliderEntry {
  image {
    ...FullAsset
  }
  richText {
    json
    links {
      assets {
        block {
          ...FullAsset
        }
        hyperlink {
          ...FullHyperlink
        }
      }
    }
  }
}
    ${FullAssetFragmentDoc}
${FullHyperlinkFragmentDoc}`;
export const NavigationEntryFragmentDoc = gql`
    fragment NavigationEntry on NavigationEntry {
  image {
    ...FullAsset
  }
  title
  subTitle
  staticPage {
    slug
  }
  buttonText
}
    ${FullAssetFragmentDoc}`;
export const BlockStockPriceFragmentDoc = gql`
    fragment BlockStockPrice on BlockStockPrice {
  stockPriceDescription
}
    `;
export const FullBlockFullsizeImageFragmentDoc = gql`
    fragment FullBlockFullsizeImage on BlockFullsizeImage {
  image {
    ...FullAsset
  }
  downloadFile {
    ...FullAsset
  }
  maxWidthParent
}
    ${FullAssetFragmentDoc}`;
export const BlockBigTitleNavigationFragmentDoc = gql`
    fragment BlockBigTitleNavigation on BlockBigTitleNavigation {
  title
  subTitle
  additionalInfoText
  staticPageReference {
    slug
  }
  buttonText
  url
}
    `;
export const BlockAnalystRatingFragmentDoc = gql`
    fragment BlockAnalystRating on BlockAnalystRating {
  name
  company
  targetPrice
  coverageCurrentlySuspended
  date
  recommendation
  noteText
  download {
    ...FullAsset
  }
  coverageCurrentlySuspended
}
    ${FullAssetFragmentDoc}`;
export const BlockPartnerGridFragmentDoc = gql`
    fragment BlockPartnerGrid on BlockPartnerGrid {
  partnersCollection(limit: 20) {
    items {
      partnerText
      partnerImage {
        ...FullAsset
      }
      href
    }
  }
}
    ${FullAssetFragmentDoc}`;
export const BlockHighlightRealEstateFragmentDoc = gql`
    fragment BlockHighlightRealEstate on BlockHighlightRealEstate {
  highlightedRealEstatesCollection(limit: 5) {
    items {
      ...EntryId
      title
      subTitle
      rooms
      squareMeter
      price
      pricePerSquareMeter
      slug
      isComingSoonProject
      image {
        ...FullAsset
      }
    }
  }
  bigTitleNavigation {
    ...BlockBigTitleNavigation
  }
  variant
}
    ${EntryIdFragmentDoc}
${FullAssetFragmentDoc}
${BlockBigTitleNavigationFragmentDoc}`;
export const BlockVideoFragmentDoc = gql`
    fragment BlockVideo on BlockVideo {
  headline
  href
}
    `;
export const BlockLinkSectionFragmentDoc = gql`
    fragment BlockLinkSection on BlockLinkSection {
  title
  linkSectionEntriesCollection {
    items {
      title
      subTitle
      href
    }
  }
}
    `;
export const OneColumnLayoutFragmentDoc = gql`
    fragment OneColumnLayout on BlockOneColumn {
  mainColumnCollection(limit: 20) {
    items {
      ...EntryId
    }
  }
  backgroundImage {
    ...FullAsset
  }
  smallMainColumnOverImage
  enableBlackBackground
  backgroundColor
  withExtraPadding
  padding
}
    ${EntryIdFragmentDoc}
${FullAssetFragmentDoc}`;
export const SubEntryFragmentDoc = gql`
    fragment SubEntry on NavBarEntry {
  sys {
    id
  }
  label
  navType
  position
  staticPage {
    slug
  }
  url
}
    `;
export const FullNavBarEntryFragmentDoc = gql`
    fragment FullNavBarEntry on NavBarEntry {
  sys {
    id
  }
  label
  navType
  position
  staticPage {
    slug
  }
  url
  subEntriesCollection(limit: 10) {
    items {
      ...SubEntry
    }
  }
}
    ${SubEntryFragmentDoc}`;
export const BlockSubNavigationFragmentDoc = gql`
    fragment BlockSubNavigation on BlockSubNavigation {
  navBarEntriesCollection {
    items {
      ...FullNavBarEntry
    }
  }
}
    ${FullNavBarEntryFragmentDoc}`;
export const BlockTextCloudFragmentDoc = gql`
    fragment BlockTextCloud on BlockTextCloud {
  fieldName1
  fieldName2
  fieldName3
  fieldName4
  fieldName5
}
    `;
export const BlockSpeechBubbleFragmentDoc = gql`
    fragment BlockSpeechBubble on BlockSpeechBubble {
  text
  variant
}
    `;
export const FullBlockFragmentDoc = gql`
    fragment FullBlock on Entry {
  sys {
    id
  }
  ...FullBlockRichText
  ...FullBlockCallToActionButton
  ...TwoColumnLayout
  ...BlockThreeColumn
  ...Accordion
  ...AccordionEntry
  ...CustomBlock
  ...PersonAccordion
  ...PersonAccordionEntry
  ...BarChartWithBackground
  ...FullBlockRibbon
  ...FullBlockTable
  ...LatestDownload
  ...BlockImageGallery
  ...BlockSlider
  ...BlockSliderEntry
  ...NavigationEntry
  ...BlockStockPrice
  ...FullBlockFullsizeImage
  ...BlockBigTitleNavigation
  ...BlockAnalystRating
  ...BlockPartnerGrid
  ...BlockHighlightRealEstate
  ...BlockVideo
  ...BlockLinkSection
  ...OneColumnLayout
  ...BlockSubNavigation
  ...BlockTextCloud
  ...BlockSpeechBubble
}
    ${FullBlockRichTextFragmentDoc}
${FullBlockCallToActionButtonFragmentDoc}
${TwoColumnLayoutFragmentDoc}
${BlockThreeColumnFragmentDoc}
${AccordionFragmentDoc}
${AccordionEntryFragmentDoc}
${CustomBlockFragmentDoc}
${PersonAccordionFragmentDoc}
${PersonAccordionEntryFragmentDoc}
${BarChartWithBackgroundFragmentDoc}
${FullBlockRibbonFragmentDoc}
${FullBlockTableFragmentDoc}
${LatestDownloadFragmentDoc}
${BlockImageGalleryFragmentDoc}
${BlockSliderFragmentDoc}
${BlockSliderEntryFragmentDoc}
${NavigationEntryFragmentDoc}
${BlockStockPriceFragmentDoc}
${FullBlockFullsizeImageFragmentDoc}
${BlockBigTitleNavigationFragmentDoc}
${BlockAnalystRatingFragmentDoc}
${BlockPartnerGridFragmentDoc}
${BlockHighlightRealEstateFragmentDoc}
${BlockVideoFragmentDoc}
${BlockLinkSectionFragmentDoc}
${OneColumnLayoutFragmentDoc}
${BlockSubNavigationFragmentDoc}
${BlockTextCloudFragmentDoc}
${BlockSpeechBubbleFragmentDoc}`;
export const AccordionEntryPointFragmentDoc = gql`
    fragment AccordionEntryPoint on Entry {
  sys {
    id
  }
  ...Accordion
}
    ${AccordionFragmentDoc}`;
export const AccordionEntryEntryPointFragmentDoc = gql`
    fragment AccordionEntryEntryPoint on Entry {
  sys {
    id
  }
  ...AccordionEntry
}
    ${AccordionEntryFragmentDoc}`;
export const BarChartWithBackgroundEntryPointFragmentDoc = gql`
    fragment BarChartWithBackgroundEntryPoint on Entry {
  sys {
    id
  }
  ...BarChartWithBackground
}
    ${BarChartWithBackgroundFragmentDoc}`;
export const BlockAnalystRatingEntryPointFragmentDoc = gql`
    fragment BlockAnalystRatingEntryPoint on Entry {
  sys {
    id
  }
  ...BlockAnalystRating
}
    ${BlockAnalystRatingFragmentDoc}`;
export const BlockBigTitleNavigationEntryPointFragmentDoc = gql`
    fragment BlockBigTitleNavigationEntryPoint on Entry {
  sys {
    id
  }
  ...BlockBigTitleNavigation
}
    ${BlockBigTitleNavigationFragmentDoc}`;
export const BlockHiddenWithConsentFragmentDoc = gql`
    fragment BlockHiddenWithConsent on BlockHiddenWithConsent {
  consentType
  childBlocksCollection(limit: 20) {
    items {
      ...EntryId
    }
  }
}
    ${EntryIdFragmentDoc}`;
export const BlockHiddenWithConsentEntryPointFragmentDoc = gql`
    fragment BlockHiddenWithConsentEntryPoint on Entry {
  sys {
    id
  }
  ...BlockHiddenWithConsent
}
    ${BlockHiddenWithConsentFragmentDoc}`;
export const BlockHiddenWithConsentWithoutChildrenFragmentDoc = gql`
    fragment BlockHiddenWithConsentWithoutChildren on BlockHiddenWithConsent {
  consentType
}
    `;
export const BlockHiddenWithConsentWithoutChildrenEntryPointFragmentDoc = gql`
    fragment BlockHiddenWithConsentWithoutChildrenEntryPoint on Entry {
  sys {
    id
  }
  ...BlockHiddenWithConsentWithoutChildren
}
    ${BlockHiddenWithConsentWithoutChildrenFragmentDoc}`;
export const BlockHighlightRealEstateEntryPointFragmentDoc = gql`
    fragment BlockHighlightRealEstateEntryPoint on Entry {
  sys {
    id
  }
  ...BlockHighlightRealEstate
}
    ${BlockHighlightRealEstateFragmentDoc}`;
export const BlockImageGalleryEntryPointFragmentDoc = gql`
    fragment BlockImageGalleryEntryPoint on Entry {
  sys {
    id
  }
  ...BlockImageGallery
}
    ${BlockImageGalleryFragmentDoc}`;
export const BlockLinkSectionEntryPointFragmentDoc = gql`
    fragment BlockLinkSectionEntryPoint on Entry {
  sys {
    id
  }
  ...BlockLinkSection
}
    ${BlockLinkSectionFragmentDoc}`;
export const BlockPartnerGridEntryPointFragmentDoc = gql`
    fragment BlockPartnerGridEntryPoint on Entry {
  sys {
    id
  }
  ...BlockPartnerGrid
}
    ${BlockPartnerGridFragmentDoc}`;
export const BlockSliderEntryPointFragmentDoc = gql`
    fragment BlockSliderEntryPoint on Entry {
  sys {
    id
  }
  ...BlockSlider
}
    ${BlockSliderFragmentDoc}`;
export const BlockSliderEntryEntryPointFragmentDoc = gql`
    fragment BlockSliderEntryEntryPoint on Entry {
  sys {
    id
  }
  ...BlockSliderEntry
}
    ${BlockSliderEntryFragmentDoc}`;
export const BlockSpeechBubbleEntryPointFragmentDoc = gql`
    fragment BlockSpeechBubbleEntryPoint on Entry {
  sys {
    id
  }
  ...BlockSpeechBubble
}
    ${BlockSpeechBubbleFragmentDoc}`;
export const BlockStockPriceEntryPointFragmentDoc = gql`
    fragment BlockStockPriceEntryPoint on Entry {
  sys {
    id
  }
  ...BlockStockPrice
}
    ${BlockStockPriceFragmentDoc}`;
export const BlockSubNavigationEntryPointFragmentDoc = gql`
    fragment BlockSubNavigationEntryPoint on Entry {
  sys {
    id
  }
  ...BlockSubNavigation
}
    ${BlockSubNavigationFragmentDoc}`;
export const BlockTextCloudEntryPointFragmentDoc = gql`
    fragment BlockTextCloudEntryPoint on Entry {
  sys {
    id
  }
  ...BlockTextCloud
}
    ${BlockTextCloudFragmentDoc}`;
export const BlockThreeColumnEntryPointFragmentDoc = gql`
    fragment BlockThreeColumnEntryPoint on Entry {
  sys {
    id
  }
  ...BlockThreeColumn
}
    ${BlockThreeColumnFragmentDoc}`;
export const BlockVideoEntryPointFragmentDoc = gql`
    fragment BlockVideoEntryPoint on Entry {
  sys {
    id
  }
  ...BlockVideo
}
    ${BlockVideoFragmentDoc}`;
export const CustomBlockEntryPointFragmentDoc = gql`
    fragment CustomBlockEntryPoint on Entry {
  sys {
    id
  }
  ...CustomBlock
}
    ${CustomBlockFragmentDoc}`;
export const FullBlockCallToActionButtonEntryPointFragmentDoc = gql`
    fragment FullBlockCallToActionButtonEntryPoint on Entry {
  sys {
    id
  }
  ...FullBlockCallToActionButton
}
    ${FullBlockCallToActionButtonFragmentDoc}`;
export const FullBlockFullsizeImageEntryPointFragmentDoc = gql`
    fragment FullBlockFullsizeImageEntryPoint on Entry {
  sys {
    id
  }
  ...FullBlockFullsizeImage
}
    ${FullBlockFullsizeImageFragmentDoc}`;
export const FullBlockRibbonEntryPointFragmentDoc = gql`
    fragment FullBlockRibbonEntryPoint on Entry {
  sys {
    id
  }
  ...FullBlockRibbon
}
    ${FullBlockRibbonFragmentDoc}`;
export const FullBlockRichTextEntryPointFragmentDoc = gql`
    fragment FullBlockRichTextEntryPoint on Entry {
  sys {
    id
  }
  ...FullBlockRichText
}
    ${FullBlockRichTextFragmentDoc}`;
export const FullBlockTableEntryPointFragmentDoc = gql`
    fragment FullBlockTableEntryPoint on Entry {
  sys {
    id
  }
  ...FullBlockTable
}
    ${FullBlockTableFragmentDoc}`;
export const LatestDownloadEntryPointFragmentDoc = gql`
    fragment LatestDownloadEntryPoint on Entry {
  sys {
    id
  }
  ...LatestDownload
}
    ${LatestDownloadFragmentDoc}`;
export const NavigationEntryEntryPointFragmentDoc = gql`
    fragment NavigationEntryEntryPoint on Entry {
  sys {
    id
  }
  ...NavigationEntry
}
    ${NavigationEntryFragmentDoc}`;
export const OneColumnLayoutEntryPointFragmentDoc = gql`
    fragment OneColumnLayoutEntryPoint on Entry {
  sys {
    id
  }
  ...OneColumnLayout
}
    ${OneColumnLayoutFragmentDoc}`;
export const PersonAccordionEntryPointFragmentDoc = gql`
    fragment PersonAccordionEntryPoint on Entry {
  sys {
    id
  }
  ...PersonAccordion
}
    ${PersonAccordionFragmentDoc}`;
export const PersonAccordionEntryEntryPointFragmentDoc = gql`
    fragment PersonAccordionEntryEntryPoint on Entry {
  sys {
    id
  }
  ...PersonAccordionEntry
}
    ${PersonAccordionEntryFragmentDoc}`;
export const TwoColumnLayoutEntryPointFragmentDoc = gql`
    fragment TwoColumnLayoutEntryPoint on Entry {
  sys {
    id
  }
  ...TwoColumnLayout
}
    ${TwoColumnLayoutFragmentDoc}`;
export const StaticPageHeroImageFragmentDoc = gql`
    fragment StaticPageHeroImage on StaticPage {
  hero {
    title
    subtitle
    size
    backgroundImage {
      ...FullAsset
    }
  }
}
    ${FullAssetFragmentDoc}`;
export const FullPageFragmentDoc = gql`
    fragment FullPage on StaticPage {
  sys {
    id
  }
  slug
  pageTitle
  standalone
  showNewsletterFooter
  showContactFooter
  removePaddingBottom
  pageTag
  region
  newsType
  seo {
    title
    description
    noFollowNoIndex
  }
  ...StaticPageHeroImage
  blocks: blocksCollection(limit: 50) {
    items {
      ...EntryId
    }
  }
}
    ${StaticPageHeroImageFragmentDoc}
${EntryIdFragmentDoc}`;
export const StaticPageLocaleSlugsFragmentDoc = gql`
    fragment StaticPageLocaleSlugs on StaticPage {
  slugDe: slug(locale: "de")
  slugEn: slug(locale: "en")
}
    `;
export const FullDownloadableFileFragmentDoc = gql`
    fragment FullDownloadableFile on DownloadableFile {
  sys {
    id
  }
  title
  type
  publishDate
  file {
    title
    contentType
    fileName
    size
    url
  }
}
    `;
export const GetAllNewsArticleByTypeDocument = gql`
    query GetAllNewsArticleByType($newsType: String, $locale: String, $slug: String) {
  allNewsArticles: newsArticleCollection(
    locale: $locale
    where: {slug: $slug, newsType: $newsType, title_exists: true}
    order: date_DESC
  ) {
    items {
      ...AllNewsArticle
    }
  }
}
    ${AllNewsArticleFragmentDoc}`;

/**
 * __useGetAllNewsArticleByTypeQuery__
 *
 * To run a query within a React component, call `useGetAllNewsArticleByTypeQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllNewsArticleByTypeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllNewsArticleByTypeQuery({
 *   variables: {
 *      newsType: // value for 'newsType'
 *      locale: // value for 'locale'
 *      slug: // value for 'slug'
 *   },
 * });
 */
export function useGetAllNewsArticleByTypeQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetAllNewsArticleByTypeQuery, GetAllNewsArticleByTypeQueryVariables>) {
        return ApolloReactHooks.useQuery<GetAllNewsArticleByTypeQuery, GetAllNewsArticleByTypeQueryVariables>(GetAllNewsArticleByTypeDocument, baseOptions);
      }
export function useGetAllNewsArticleByTypeLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetAllNewsArticleByTypeQuery, GetAllNewsArticleByTypeQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetAllNewsArticleByTypeQuery, GetAllNewsArticleByTypeQueryVariables>(GetAllNewsArticleByTypeDocument, baseOptions);
        }
export type GetAllNewsArticleByTypeQueryHookResult = ReturnType<typeof useGetAllNewsArticleByTypeQuery>;
export type GetAllNewsArticleByTypeLazyQueryHookResult = ReturnType<typeof useGetAllNewsArticleByTypeLazyQuery>;
export type GetAllNewsArticleByTypeQueryResult = Apollo.QueryResult<GetAllNewsArticleByTypeQuery, GetAllNewsArticleByTypeQueryVariables>;
export const GetFooterDocument = gql`
    query GetFooter($locale: String, $preview: Boolean) {
  footer: footerCollection(locale: $locale, limit: 1, preview: $preview) {
    items {
      ...Footer
    }
  }
}
    ${FooterFragmentDoc}`;

/**
 * __useGetFooterQuery__
 *
 * To run a query within a React component, call `useGetFooterQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFooterQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFooterQuery({
 *   variables: {
 *      locale: // value for 'locale'
 *      preview: // value for 'preview'
 *   },
 * });
 */
export function useGetFooterQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetFooterQuery, GetFooterQueryVariables>) {
        return ApolloReactHooks.useQuery<GetFooterQuery, GetFooterQueryVariables>(GetFooterDocument, baseOptions);
      }
export function useGetFooterLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetFooterQuery, GetFooterQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetFooterQuery, GetFooterQueryVariables>(GetFooterDocument, baseOptions);
        }
export type GetFooterQueryHookResult = ReturnType<typeof useGetFooterQuery>;
export type GetFooterLazyQueryHookResult = ReturnType<typeof useGetFooterLazyQuery>;
export type GetFooterQueryResult = Apollo.QueryResult<GetFooterQuery, GetFooterQueryVariables>;
export const GetLexiconArticleBySlugDocument = gql`
    query GetLexiconArticleBySlug($locale: String, $preview: Boolean, $slug: String) {
  lexiconArticle: lexiconArticleCollection(
    locale: $locale
    preview: $preview
    where: {slug: $slug, title_exists: true}
    limit: 1
  ) {
    items {
      ...FullLexiconArticle
    }
  }
}
    ${FullLexiconArticleFragmentDoc}`;

/**
 * __useGetLexiconArticleBySlugQuery__
 *
 * To run a query within a React component, call `useGetLexiconArticleBySlugQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLexiconArticleBySlugQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetLexiconArticleBySlugQuery({
 *   variables: {
 *      locale: // value for 'locale'
 *      preview: // value for 'preview'
 *      slug: // value for 'slug'
 *   },
 * });
 */
export function useGetLexiconArticleBySlugQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetLexiconArticleBySlugQuery, GetLexiconArticleBySlugQueryVariables>) {
        return ApolloReactHooks.useQuery<GetLexiconArticleBySlugQuery, GetLexiconArticleBySlugQueryVariables>(GetLexiconArticleBySlugDocument, baseOptions);
      }
export function useGetLexiconArticleBySlugLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetLexiconArticleBySlugQuery, GetLexiconArticleBySlugQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetLexiconArticleBySlugQuery, GetLexiconArticleBySlugQueryVariables>(GetLexiconArticleBySlugDocument, baseOptions);
        }
export type GetLexiconArticleBySlugQueryHookResult = ReturnType<typeof useGetLexiconArticleBySlugQuery>;
export type GetLexiconArticleBySlugLazyQueryHookResult = ReturnType<typeof useGetLexiconArticleBySlugLazyQuery>;
export type GetLexiconArticleBySlugQueryResult = Apollo.QueryResult<GetLexiconArticleBySlugQuery, GetLexiconArticleBySlugQueryVariables>;
export const GetLexiconArticlePreviewsDocument = gql`
    query GetLexiconArticlePreviews($locale: String, $preview: Boolean, $lexiconLetter: String, $limit: Int = 100, $skip: Int = 0) {
  lexiconArticles: lexiconArticleCollection(
    locale: $locale
    preview: $preview
    order: title_ASC
    where: {lexiconLetter: $lexiconLetter, title_exists: true}
    skip: $skip
    limit: $limit
  ) {
    total
    items {
      ...LexiconArticlePreview
    }
  }
}
    ${LexiconArticlePreviewFragmentDoc}`;

/**
 * __useGetLexiconArticlePreviewsQuery__
 *
 * To run a query within a React component, call `useGetLexiconArticlePreviewsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLexiconArticlePreviewsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetLexiconArticlePreviewsQuery({
 *   variables: {
 *      locale: // value for 'locale'
 *      preview: // value for 'preview'
 *      lexiconLetter: // value for 'lexiconLetter'
 *      limit: // value for 'limit'
 *      skip: // value for 'skip'
 *   },
 * });
 */
export function useGetLexiconArticlePreviewsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetLexiconArticlePreviewsQuery, GetLexiconArticlePreviewsQueryVariables>) {
        return ApolloReactHooks.useQuery<GetLexiconArticlePreviewsQuery, GetLexiconArticlePreviewsQueryVariables>(GetLexiconArticlePreviewsDocument, baseOptions);
      }
export function useGetLexiconArticlePreviewsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetLexiconArticlePreviewsQuery, GetLexiconArticlePreviewsQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetLexiconArticlePreviewsQuery, GetLexiconArticlePreviewsQueryVariables>(GetLexiconArticlePreviewsDocument, baseOptions);
        }
export type GetLexiconArticlePreviewsQueryHookResult = ReturnType<typeof useGetLexiconArticlePreviewsQuery>;
export type GetLexiconArticlePreviewsLazyQueryHookResult = ReturnType<typeof useGetLexiconArticlePreviewsLazyQuery>;
export type GetLexiconArticlePreviewsQueryResult = Apollo.QueryResult<GetLexiconArticlePreviewsQuery, GetLexiconArticlePreviewsQueryVariables>;
export const GetTopLexiconArticlePreviewsDocument = gql`
    query GetTopLexiconArticlePreviews($locale: String, $preview: Boolean, $lexiconLetter: String) {
  lexiconArticles: lexiconArticleCollection(
    locale: $locale
    preview: $preview
    order: title_ASC
    limit: 3
    where: {lexiconLetter: $lexiconLetter, title_exists: true}
  ) {
    items {
      ...LexiconArticlePreview
    }
  }
}
    ${LexiconArticlePreviewFragmentDoc}`;

/**
 * __useGetTopLexiconArticlePreviewsQuery__
 *
 * To run a query within a React component, call `useGetTopLexiconArticlePreviewsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTopLexiconArticlePreviewsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTopLexiconArticlePreviewsQuery({
 *   variables: {
 *      locale: // value for 'locale'
 *      preview: // value for 'preview'
 *      lexiconLetter: // value for 'lexiconLetter'
 *   },
 * });
 */
export function useGetTopLexiconArticlePreviewsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetTopLexiconArticlePreviewsQuery, GetTopLexiconArticlePreviewsQueryVariables>) {
        return ApolloReactHooks.useQuery<GetTopLexiconArticlePreviewsQuery, GetTopLexiconArticlePreviewsQueryVariables>(GetTopLexiconArticlePreviewsDocument, baseOptions);
      }
export function useGetTopLexiconArticlePreviewsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetTopLexiconArticlePreviewsQuery, GetTopLexiconArticlePreviewsQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetTopLexiconArticlePreviewsQuery, GetTopLexiconArticlePreviewsQueryVariables>(GetTopLexiconArticlePreviewsDocument, baseOptions);
        }
export type GetTopLexiconArticlePreviewsQueryHookResult = ReturnType<typeof useGetTopLexiconArticlePreviewsQuery>;
export type GetTopLexiconArticlePreviewsLazyQueryHookResult = ReturnType<typeof useGetTopLexiconArticlePreviewsLazyQuery>;
export type GetTopLexiconArticlePreviewsQueryResult = Apollo.QueryResult<GetTopLexiconArticlePreviewsQuery, GetTopLexiconArticlePreviewsQueryVariables>;
export const GetLexiconArticlePreviewsOfLetterDocument = gql`
    query GetLexiconArticlePreviewsOfLetter($locale: String, $preview: Boolean, $slug: String, $letter: String, $limit: Int = 2) {
  otherLexiconArticles: lexiconArticleCollection(
    locale: $locale
    preview: $preview
    where: {slug_not: $slug, lexiconLetter: $letter, title_exists: true}
    limit: $limit
    order: title_ASC
  ) {
    items {
      ...LexiconArticlePreview
    }
  }
}
    ${LexiconArticlePreviewFragmentDoc}`;

/**
 * __useGetLexiconArticlePreviewsOfLetterQuery__
 *
 * To run a query within a React component, call `useGetLexiconArticlePreviewsOfLetterQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLexiconArticlePreviewsOfLetterQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetLexiconArticlePreviewsOfLetterQuery({
 *   variables: {
 *      locale: // value for 'locale'
 *      preview: // value for 'preview'
 *      slug: // value for 'slug'
 *      letter: // value for 'letter'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useGetLexiconArticlePreviewsOfLetterQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetLexiconArticlePreviewsOfLetterQuery, GetLexiconArticlePreviewsOfLetterQueryVariables>) {
        return ApolloReactHooks.useQuery<GetLexiconArticlePreviewsOfLetterQuery, GetLexiconArticlePreviewsOfLetterQueryVariables>(GetLexiconArticlePreviewsOfLetterDocument, baseOptions);
      }
export function useGetLexiconArticlePreviewsOfLetterLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetLexiconArticlePreviewsOfLetterQuery, GetLexiconArticlePreviewsOfLetterQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetLexiconArticlePreviewsOfLetterQuery, GetLexiconArticlePreviewsOfLetterQueryVariables>(GetLexiconArticlePreviewsOfLetterDocument, baseOptions);
        }
export type GetLexiconArticlePreviewsOfLetterQueryHookResult = ReturnType<typeof useGetLexiconArticlePreviewsOfLetterQuery>;
export type GetLexiconArticlePreviewsOfLetterLazyQueryHookResult = ReturnType<typeof useGetLexiconArticlePreviewsOfLetterLazyQuery>;
export type GetLexiconArticlePreviewsOfLetterQueryResult = Apollo.QueryResult<GetLexiconArticlePreviewsOfLetterQuery, GetLexiconArticlePreviewsOfLetterQueryVariables>;
export const GetLexiconArticleSlugsDocument = gql`
    query GetLexiconArticleSlugs($locale: String, $preview: Boolean) {
  lexiconArticles: lexiconArticleCollection(
    locale: $locale
    preview: $preview
    where: {title_exists: true}
  ) {
    items {
      sys {
        id
      }
      slug
      lexiconLetter
    }
  }
}
    `;

/**
 * __useGetLexiconArticleSlugsQuery__
 *
 * To run a query within a React component, call `useGetLexiconArticleSlugsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLexiconArticleSlugsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetLexiconArticleSlugsQuery({
 *   variables: {
 *      locale: // value for 'locale'
 *      preview: // value for 'preview'
 *   },
 * });
 */
export function useGetLexiconArticleSlugsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetLexiconArticleSlugsQuery, GetLexiconArticleSlugsQueryVariables>) {
        return ApolloReactHooks.useQuery<GetLexiconArticleSlugsQuery, GetLexiconArticleSlugsQueryVariables>(GetLexiconArticleSlugsDocument, baseOptions);
      }
export function useGetLexiconArticleSlugsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetLexiconArticleSlugsQuery, GetLexiconArticleSlugsQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetLexiconArticleSlugsQuery, GetLexiconArticleSlugsQueryVariables>(GetLexiconArticleSlugsDocument, baseOptions);
        }
export type GetLexiconArticleSlugsQueryHookResult = ReturnType<typeof useGetLexiconArticleSlugsQuery>;
export type GetLexiconArticleSlugsLazyQueryHookResult = ReturnType<typeof useGetLexiconArticleSlugsLazyQuery>;
export type GetLexiconArticleSlugsQueryResult = Apollo.QueryResult<GetLexiconArticleSlugsQuery, GetLexiconArticleSlugsQueryVariables>;
export const GetLexiconArticlesFullTextDocument = gql`
    query GetLexiconArticlesFullText($locale: String, $preview: Boolean, $lexiconLetter: String, $limit: Int = 100, $skip: Int = 0) {
  lexiconArticles: lexiconArticleCollection(
    locale: $locale
    preview: $preview
    order: title_ASC
    where: {lexiconLetter: $lexiconLetter, title_exists: true}
    skip: $skip
    limit: $limit
  ) {
    total
    items {
      ...LexiconArticleFullText
    }
  }
}
    ${LexiconArticleFullTextFragmentDoc}`;

/**
 * __useGetLexiconArticlesFullTextQuery__
 *
 * To run a query within a React component, call `useGetLexiconArticlesFullTextQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLexiconArticlesFullTextQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetLexiconArticlesFullTextQuery({
 *   variables: {
 *      locale: // value for 'locale'
 *      preview: // value for 'preview'
 *      lexiconLetter: // value for 'lexiconLetter'
 *      limit: // value for 'limit'
 *      skip: // value for 'skip'
 *   },
 * });
 */
export function useGetLexiconArticlesFullTextQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetLexiconArticlesFullTextQuery, GetLexiconArticlesFullTextQueryVariables>) {
        return ApolloReactHooks.useQuery<GetLexiconArticlesFullTextQuery, GetLexiconArticlesFullTextQueryVariables>(GetLexiconArticlesFullTextDocument, baseOptions);
      }
export function useGetLexiconArticlesFullTextLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetLexiconArticlesFullTextQuery, GetLexiconArticlesFullTextQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetLexiconArticlesFullTextQuery, GetLexiconArticlesFullTextQueryVariables>(GetLexiconArticlesFullTextDocument, baseOptions);
        }
export type GetLexiconArticlesFullTextQueryHookResult = ReturnType<typeof useGetLexiconArticlesFullTextQuery>;
export type GetLexiconArticlesFullTextLazyQueryHookResult = ReturnType<typeof useGetLexiconArticlesFullTextLazyQuery>;
export type GetLexiconArticlesFullTextQueryResult = Apollo.QueryResult<GetLexiconArticlesFullTextQuery, GetLexiconArticlesFullTextQueryVariables>;
export const GetNavBarEntriesDocument = gql`
    query GetNavBarEntries($locale: String, $preview: Boolean) {
  navBarEntries: navBarEntryCollection(locale: $locale, preview: $preview) {
    items {
      ...FullNavBarEntry
    }
  }
}
    ${FullNavBarEntryFragmentDoc}`;

/**
 * __useGetNavBarEntriesQuery__
 *
 * To run a query within a React component, call `useGetNavBarEntriesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetNavBarEntriesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetNavBarEntriesQuery({
 *   variables: {
 *      locale: // value for 'locale'
 *      preview: // value for 'preview'
 *   },
 * });
 */
export function useGetNavBarEntriesQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetNavBarEntriesQuery, GetNavBarEntriesQueryVariables>) {
        return ApolloReactHooks.useQuery<GetNavBarEntriesQuery, GetNavBarEntriesQueryVariables>(GetNavBarEntriesDocument, baseOptions);
      }
export function useGetNavBarEntriesLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetNavBarEntriesQuery, GetNavBarEntriesQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetNavBarEntriesQuery, GetNavBarEntriesQueryVariables>(GetNavBarEntriesDocument, baseOptions);
        }
export type GetNavBarEntriesQueryHookResult = ReturnType<typeof useGetNavBarEntriesQuery>;
export type GetNavBarEntriesLazyQueryHookResult = ReturnType<typeof useGetNavBarEntriesLazyQuery>;
export type GetNavBarEntriesQueryResult = Apollo.QueryResult<GetNavBarEntriesQuery, GetNavBarEntriesQueryVariables>;
export const GetNewsArticleBySlugDocument = gql`
    query GetNewsArticleBySlug($locale: String, $preview: Boolean, $slug: String) {
  newsArticle: newsArticleCollection(
    locale: $locale
    preview: $preview
    where: {slug: $slug, title_exists: true}
    limit: 1
  ) {
    items {
      ...FullNewsArticle
    }
  }
}
    ${FullNewsArticleFragmentDoc}`;

/**
 * __useGetNewsArticleBySlugQuery__
 *
 * To run a query within a React component, call `useGetNewsArticleBySlugQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetNewsArticleBySlugQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetNewsArticleBySlugQuery({
 *   variables: {
 *      locale: // value for 'locale'
 *      preview: // value for 'preview'
 *      slug: // value for 'slug'
 *   },
 * });
 */
export function useGetNewsArticleBySlugQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetNewsArticleBySlugQuery, GetNewsArticleBySlugQueryVariables>) {
        return ApolloReactHooks.useQuery<GetNewsArticleBySlugQuery, GetNewsArticleBySlugQueryVariables>(GetNewsArticleBySlugDocument, baseOptions);
      }
export function useGetNewsArticleBySlugLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetNewsArticleBySlugQuery, GetNewsArticleBySlugQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetNewsArticleBySlugQuery, GetNewsArticleBySlugQueryVariables>(GetNewsArticleBySlugDocument, baseOptions);
        }
export type GetNewsArticleBySlugQueryHookResult = ReturnType<typeof useGetNewsArticleBySlugQuery>;
export type GetNewsArticleBySlugLazyQueryHookResult = ReturnType<typeof useGetNewsArticleBySlugLazyQuery>;
export type GetNewsArticleBySlugQueryResult = Apollo.QueryResult<GetNewsArticleBySlugQuery, GetNewsArticleBySlugQueryVariables>;
export const GetNewsArticlePreviewsDocument = gql`
    query GetNewsArticlePreviews($locale: String, $preview: Boolean, $newsType: String, $limit: Int = 100, $skip: Int = 0) {
  newsArticles: newsArticleCollection(
    locale: $locale
    preview: $preview
    order: date_DESC
    where: {newsType: $newsType, title_exists: true}
    skip: $skip
    limit: $limit
  ) {
    total
    items {
      ...OtherNewsArticle
      image {
        ...FullAsset
      }
    }
  }
}
    ${OtherNewsArticleFragmentDoc}
${FullAssetFragmentDoc}`;

/**
 * __useGetNewsArticlePreviewsQuery__
 *
 * To run a query within a React component, call `useGetNewsArticlePreviewsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetNewsArticlePreviewsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetNewsArticlePreviewsQuery({
 *   variables: {
 *      locale: // value for 'locale'
 *      preview: // value for 'preview'
 *      newsType: // value for 'newsType'
 *      limit: // value for 'limit'
 *      skip: // value for 'skip'
 *   },
 * });
 */
export function useGetNewsArticlePreviewsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetNewsArticlePreviewsQuery, GetNewsArticlePreviewsQueryVariables>) {
        return ApolloReactHooks.useQuery<GetNewsArticlePreviewsQuery, GetNewsArticlePreviewsQueryVariables>(GetNewsArticlePreviewsDocument, baseOptions);
      }
export function useGetNewsArticlePreviewsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetNewsArticlePreviewsQuery, GetNewsArticlePreviewsQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetNewsArticlePreviewsQuery, GetNewsArticlePreviewsQueryVariables>(GetNewsArticlePreviewsDocument, baseOptions);
        }
export type GetNewsArticlePreviewsQueryHookResult = ReturnType<typeof useGetNewsArticlePreviewsQuery>;
export type GetNewsArticlePreviewsLazyQueryHookResult = ReturnType<typeof useGetNewsArticlePreviewsLazyQuery>;
export type GetNewsArticlePreviewsQueryResult = Apollo.QueryResult<GetNewsArticlePreviewsQuery, GetNewsArticlePreviewsQueryVariables>;
export const GetTopNewsArticlePreviewsDocument = gql`
    query GetTopNewsArticlePreviews($locale: String, $preview: Boolean, $newsType: String) {
  newsArticles: newsArticleCollection(
    locale: $locale
    preview: $preview
    order: date_DESC
    limit: 3
    where: {newsType: $newsType, title_exists: true}
  ) {
    items {
      ...OtherNewsArticle
    }
  }
}
    ${OtherNewsArticleFragmentDoc}`;

/**
 * __useGetTopNewsArticlePreviewsQuery__
 *
 * To run a query within a React component, call `useGetTopNewsArticlePreviewsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTopNewsArticlePreviewsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTopNewsArticlePreviewsQuery({
 *   variables: {
 *      locale: // value for 'locale'
 *      preview: // value for 'preview'
 *      newsType: // value for 'newsType'
 *   },
 * });
 */
export function useGetTopNewsArticlePreviewsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetTopNewsArticlePreviewsQuery, GetTopNewsArticlePreviewsQueryVariables>) {
        return ApolloReactHooks.useQuery<GetTopNewsArticlePreviewsQuery, GetTopNewsArticlePreviewsQueryVariables>(GetTopNewsArticlePreviewsDocument, baseOptions);
      }
export function useGetTopNewsArticlePreviewsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetTopNewsArticlePreviewsQuery, GetTopNewsArticlePreviewsQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetTopNewsArticlePreviewsQuery, GetTopNewsArticlePreviewsQueryVariables>(GetTopNewsArticlePreviewsDocument, baseOptions);
        }
export type GetTopNewsArticlePreviewsQueryHookResult = ReturnType<typeof useGetTopNewsArticlePreviewsQuery>;
export type GetTopNewsArticlePreviewsLazyQueryHookResult = ReturnType<typeof useGetTopNewsArticlePreviewsLazyQuery>;
export type GetTopNewsArticlePreviewsQueryResult = Apollo.QueryResult<GetTopNewsArticlePreviewsQuery, GetTopNewsArticlePreviewsQueryVariables>;
export const GetNewsArticlePreviewsOfLocationDocument = gql`
    query GetNewsArticlePreviewsOfLocation($locale: String, $preview: Boolean, $city: String, $newsType: String, $limit: Int = 2) {
  newsArticles: newsArticleCollection(
    locale: $locale
    preview: $preview
    where: {newsType: $newsType, OR: [{title_contains: $city}, {previewText_contains: $city}]}
    limit: $limit
    order: date_DESC
  ) {
    items {
      ...OtherNewsArticle
    }
  }
}
    ${OtherNewsArticleFragmentDoc}`;

/**
 * __useGetNewsArticlePreviewsOfLocationQuery__
 *
 * To run a query within a React component, call `useGetNewsArticlePreviewsOfLocationQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetNewsArticlePreviewsOfLocationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetNewsArticlePreviewsOfLocationQuery({
 *   variables: {
 *      locale: // value for 'locale'
 *      preview: // value for 'preview'
 *      city: // value for 'city'
 *      newsType: // value for 'newsType'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useGetNewsArticlePreviewsOfLocationQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetNewsArticlePreviewsOfLocationQuery, GetNewsArticlePreviewsOfLocationQueryVariables>) {
        return ApolloReactHooks.useQuery<GetNewsArticlePreviewsOfLocationQuery, GetNewsArticlePreviewsOfLocationQueryVariables>(GetNewsArticlePreviewsOfLocationDocument, baseOptions);
      }
export function useGetNewsArticlePreviewsOfLocationLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetNewsArticlePreviewsOfLocationQuery, GetNewsArticlePreviewsOfLocationQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetNewsArticlePreviewsOfLocationQuery, GetNewsArticlePreviewsOfLocationQueryVariables>(GetNewsArticlePreviewsOfLocationDocument, baseOptions);
        }
export type GetNewsArticlePreviewsOfLocationQueryHookResult = ReturnType<typeof useGetNewsArticlePreviewsOfLocationQuery>;
export type GetNewsArticlePreviewsOfLocationLazyQueryHookResult = ReturnType<typeof useGetNewsArticlePreviewsOfLocationLazyQuery>;
export type GetNewsArticlePreviewsOfLocationQueryResult = Apollo.QueryResult<GetNewsArticlePreviewsOfLocationQuery, GetNewsArticlePreviewsOfLocationQueryVariables>;
export const GetNewsArticlePreviewsOfThreeNewsTypeDocument = gql`
    query GetNewsArticlePreviewsOfThreeNewsType($locale: String, $preview: Boolean, $newsTypes: [String], $limit: Int = 2) {
  newsArticles: newsArticleCollection(
    locale: $locale
    preview: $preview
    where: {newsType_in: $newsTypes}
    order: date_DESC
    limit: $limit
  ) {
    items {
      ...OtherNewsArticle
    }
  }
}
    ${OtherNewsArticleFragmentDoc}`;

/**
 * __useGetNewsArticlePreviewsOfThreeNewsTypeQuery__
 *
 * To run a query within a React component, call `useGetNewsArticlePreviewsOfThreeNewsTypeQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetNewsArticlePreviewsOfThreeNewsTypeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetNewsArticlePreviewsOfThreeNewsTypeQuery({
 *   variables: {
 *      locale: // value for 'locale'
 *      preview: // value for 'preview'
 *      newsTypes: // value for 'newsTypes'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useGetNewsArticlePreviewsOfThreeNewsTypeQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetNewsArticlePreviewsOfThreeNewsTypeQuery, GetNewsArticlePreviewsOfThreeNewsTypeQueryVariables>) {
        return ApolloReactHooks.useQuery<GetNewsArticlePreviewsOfThreeNewsTypeQuery, GetNewsArticlePreviewsOfThreeNewsTypeQueryVariables>(GetNewsArticlePreviewsOfThreeNewsTypeDocument, baseOptions);
      }
export function useGetNewsArticlePreviewsOfThreeNewsTypeLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetNewsArticlePreviewsOfThreeNewsTypeQuery, GetNewsArticlePreviewsOfThreeNewsTypeQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetNewsArticlePreviewsOfThreeNewsTypeQuery, GetNewsArticlePreviewsOfThreeNewsTypeQueryVariables>(GetNewsArticlePreviewsOfThreeNewsTypeDocument, baseOptions);
        }
export type GetNewsArticlePreviewsOfThreeNewsTypeQueryHookResult = ReturnType<typeof useGetNewsArticlePreviewsOfThreeNewsTypeQuery>;
export type GetNewsArticlePreviewsOfThreeNewsTypeLazyQueryHookResult = ReturnType<typeof useGetNewsArticlePreviewsOfThreeNewsTypeLazyQuery>;
export type GetNewsArticlePreviewsOfThreeNewsTypeQueryResult = Apollo.QueryResult<GetNewsArticlePreviewsOfThreeNewsTypeQuery, GetNewsArticlePreviewsOfThreeNewsTypeQueryVariables>;
export const GetNewsArticleSlugsDocument = gql`
    query GetNewsArticleSlugs($locale: String, $preview: Boolean, $skip: Int) {
  newsArticles: newsArticleCollection(
    locale: $locale
    preview: $preview
    skip: $skip
    where: {title_exists: true}
  ) {
    total
    items {
      sys {
        id
      }
      slug
      newsType
    }
  }
}
    `;

/**
 * __useGetNewsArticleSlugsQuery__
 *
 * To run a query within a React component, call `useGetNewsArticleSlugsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetNewsArticleSlugsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetNewsArticleSlugsQuery({
 *   variables: {
 *      locale: // value for 'locale'
 *      preview: // value for 'preview'
 *      skip: // value for 'skip'
 *   },
 * });
 */
export function useGetNewsArticleSlugsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetNewsArticleSlugsQuery, GetNewsArticleSlugsQueryVariables>) {
        return ApolloReactHooks.useQuery<GetNewsArticleSlugsQuery, GetNewsArticleSlugsQueryVariables>(GetNewsArticleSlugsDocument, baseOptions);
      }
export function useGetNewsArticleSlugsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetNewsArticleSlugsQuery, GetNewsArticleSlugsQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetNewsArticleSlugsQuery, GetNewsArticleSlugsQueryVariables>(GetNewsArticleSlugsDocument, baseOptions);
        }
export type GetNewsArticleSlugsQueryHookResult = ReturnType<typeof useGetNewsArticleSlugsQuery>;
export type GetNewsArticleSlugsLazyQueryHookResult = ReturnType<typeof useGetNewsArticleSlugsLazyQuery>;
export type GetNewsArticleSlugsQueryResult = Apollo.QueryResult<GetNewsArticleSlugsQuery, GetNewsArticleSlugsQueryVariables>;
export const GetNewsArticlesFullTextDocument = gql`
    query GetNewsArticlesFullText($locale: String, $preview: Boolean, $newsType: String, $limit: Int = 100, $skip: Int = 0) {
  newsArticles: newsArticleCollection(
    locale: $locale
    preview: $preview
    order: date_DESC
    where: {newsType: $newsType, title_exists: true}
    skip: $skip
    limit: $limit
  ) {
    total
    items {
      ...NewsArticleFullText
    }
  }
}
    ${NewsArticleFullTextFragmentDoc}`;

/**
 * __useGetNewsArticlesFullTextQuery__
 *
 * To run a query within a React component, call `useGetNewsArticlesFullTextQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetNewsArticlesFullTextQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetNewsArticlesFullTextQuery({
 *   variables: {
 *      locale: // value for 'locale'
 *      preview: // value for 'preview'
 *      newsType: // value for 'newsType'
 *      limit: // value for 'limit'
 *      skip: // value for 'skip'
 *   },
 * });
 */
export function useGetNewsArticlesFullTextQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetNewsArticlesFullTextQuery, GetNewsArticlesFullTextQueryVariables>) {
        return ApolloReactHooks.useQuery<GetNewsArticlesFullTextQuery, GetNewsArticlesFullTextQueryVariables>(GetNewsArticlesFullTextDocument, baseOptions);
      }
export function useGetNewsArticlesFullTextLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetNewsArticlesFullTextQuery, GetNewsArticlesFullTextQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetNewsArticlesFullTextQuery, GetNewsArticlesFullTextQueryVariables>(GetNewsArticlesFullTextDocument, baseOptions);
        }
export type GetNewsArticlesFullTextQueryHookResult = ReturnType<typeof useGetNewsArticlesFullTextQuery>;
export type GetNewsArticlesFullTextLazyQueryHookResult = ReturnType<typeof useGetNewsArticlesFullTextLazyQuery>;
export type GetNewsArticlesFullTextQueryResult = Apollo.QueryResult<GetNewsArticlesFullTextQuery, GetNewsArticlesFullTextQueryVariables>;
export const GetOtherNewsArticlePreviewsOfTypeDocument = gql`
    query GetOtherNewsArticlePreviewsOfType($locale: String, $preview: Boolean, $slug: String, $type: String, $limit: Int = 2) {
  otherNewsArticles: newsArticleCollection(
    locale: $locale
    preview: $preview
    where: {slug_not: $slug, newsType: $type, title_exists: true}
    limit: $limit
    order: date_DESC
  ) {
    items {
      ...OtherNewsArticle
    }
  }
}
    ${OtherNewsArticleFragmentDoc}`;

/**
 * __useGetOtherNewsArticlePreviewsOfTypeQuery__
 *
 * To run a query within a React component, call `useGetOtherNewsArticlePreviewsOfTypeQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOtherNewsArticlePreviewsOfTypeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOtherNewsArticlePreviewsOfTypeQuery({
 *   variables: {
 *      locale: // value for 'locale'
 *      preview: // value for 'preview'
 *      slug: // value for 'slug'
 *      type: // value for 'type'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useGetOtherNewsArticlePreviewsOfTypeQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetOtherNewsArticlePreviewsOfTypeQuery, GetOtherNewsArticlePreviewsOfTypeQueryVariables>) {
        return ApolloReactHooks.useQuery<GetOtherNewsArticlePreviewsOfTypeQuery, GetOtherNewsArticlePreviewsOfTypeQueryVariables>(GetOtherNewsArticlePreviewsOfTypeDocument, baseOptions);
      }
export function useGetOtherNewsArticlePreviewsOfTypeLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetOtherNewsArticlePreviewsOfTypeQuery, GetOtherNewsArticlePreviewsOfTypeQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetOtherNewsArticlePreviewsOfTypeQuery, GetOtherNewsArticlePreviewsOfTypeQueryVariables>(GetOtherNewsArticlePreviewsOfTypeDocument, baseOptions);
        }
export type GetOtherNewsArticlePreviewsOfTypeQueryHookResult = ReturnType<typeof useGetOtherNewsArticlePreviewsOfTypeQuery>;
export type GetOtherNewsArticlePreviewsOfTypeLazyQueryHookResult = ReturnType<typeof useGetOtherNewsArticlePreviewsOfTypeLazyQuery>;
export type GetOtherNewsArticlePreviewsOfTypeQueryResult = Apollo.QueryResult<GetOtherNewsArticlePreviewsOfTypeQuery, GetOtherNewsArticlePreviewsOfTypeQueryVariables>;
export const GetProjectImageMapByIdDocument = gql`
    query GetProjectImageMapById($locale: String, $preview: Boolean, $projectId: Int) {
  imageMap: projectImageMapCollection(
    locale: $locale
    preview: $preview
    where: {propstackProjectId: $projectId}
    limit: 1
  ) {
    items {
      ...FullProjectImageMap
    }
  }
}
    ${FullProjectImageMapFragmentDoc}`;

/**
 * __useGetProjectImageMapByIdQuery__
 *
 * To run a query within a React component, call `useGetProjectImageMapByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProjectImageMapByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetProjectImageMapByIdQuery({
 *   variables: {
 *      locale: // value for 'locale'
 *      preview: // value for 'preview'
 *      projectId: // value for 'projectId'
 *   },
 * });
 */
export function useGetProjectImageMapByIdQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetProjectImageMapByIdQuery, GetProjectImageMapByIdQueryVariables>) {
        return ApolloReactHooks.useQuery<GetProjectImageMapByIdQuery, GetProjectImageMapByIdQueryVariables>(GetProjectImageMapByIdDocument, baseOptions);
      }
export function useGetProjectImageMapByIdLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetProjectImageMapByIdQuery, GetProjectImageMapByIdQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetProjectImageMapByIdQuery, GetProjectImageMapByIdQueryVariables>(GetProjectImageMapByIdDocument, baseOptions);
        }
export type GetProjectImageMapByIdQueryHookResult = ReturnType<typeof useGetProjectImageMapByIdQuery>;
export type GetProjectImageMapByIdLazyQueryHookResult = ReturnType<typeof useGetProjectImageMapByIdLazyQuery>;
export type GetProjectImageMapByIdQueryResult = Apollo.QueryResult<GetProjectImageMapByIdQuery, GetProjectImageMapByIdQueryVariables>;
export const GetProjectLinkSectionByIdDocument = gql`
    query GetProjectLinkSectionById($locale: String, $preview: Boolean, $projectId: Int) {
  projectLinkSection: blockProjectLinkSectionCollection(
    locale: $locale
    preview: $preview
    where: {propstackProjectId: $projectId}
    limit: 1
  ) {
    items {
      ...ProjectLinkSection
    }
  }
}
    ${ProjectLinkSectionFragmentDoc}`;

/**
 * __useGetProjectLinkSectionByIdQuery__
 *
 * To run a query within a React component, call `useGetProjectLinkSectionByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProjectLinkSectionByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetProjectLinkSectionByIdQuery({
 *   variables: {
 *      locale: // value for 'locale'
 *      preview: // value for 'preview'
 *      projectId: // value for 'projectId'
 *   },
 * });
 */
export function useGetProjectLinkSectionByIdQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetProjectLinkSectionByIdQuery, GetProjectLinkSectionByIdQueryVariables>) {
        return ApolloReactHooks.useQuery<GetProjectLinkSectionByIdQuery, GetProjectLinkSectionByIdQueryVariables>(GetProjectLinkSectionByIdDocument, baseOptions);
      }
export function useGetProjectLinkSectionByIdLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetProjectLinkSectionByIdQuery, GetProjectLinkSectionByIdQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetProjectLinkSectionByIdQuery, GetProjectLinkSectionByIdQueryVariables>(GetProjectLinkSectionByIdDocument, baseOptions);
        }
export type GetProjectLinkSectionByIdQueryHookResult = ReturnType<typeof useGetProjectLinkSectionByIdQuery>;
export type GetProjectLinkSectionByIdLazyQueryHookResult = ReturnType<typeof useGetProjectLinkSectionByIdLazyQuery>;
export type GetProjectLinkSectionByIdQueryResult = Apollo.QueryResult<GetProjectLinkSectionByIdQuery, GetProjectLinkSectionByIdQueryVariables>;
export const GetProjectPageByIdDocument = gql`
    query GetProjectPageById($locale: String, $preview: Boolean, $projectId: Int) {
  pages: projectPageCollection(
    locale: $locale
    preview: $preview
    where: {propstackProjectId: $projectId}
    limit: 1
  ) {
    items {
      ...FullProjectPage
    }
  }
}
    ${FullProjectPageFragmentDoc}`;

/**
 * __useGetProjectPageByIdQuery__
 *
 * To run a query within a React component, call `useGetProjectPageByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProjectPageByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetProjectPageByIdQuery({
 *   variables: {
 *      locale: // value for 'locale'
 *      preview: // value for 'preview'
 *      projectId: // value for 'projectId'
 *   },
 * });
 */
export function useGetProjectPageByIdQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetProjectPageByIdQuery, GetProjectPageByIdQueryVariables>) {
        return ApolloReactHooks.useQuery<GetProjectPageByIdQuery, GetProjectPageByIdQueryVariables>(GetProjectPageByIdDocument, baseOptions);
      }
export function useGetProjectPageByIdLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetProjectPageByIdQuery, GetProjectPageByIdQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetProjectPageByIdQuery, GetProjectPageByIdQueryVariables>(GetProjectPageByIdDocument, baseOptions);
        }
export type GetProjectPageByIdQueryHookResult = ReturnType<typeof useGetProjectPageByIdQuery>;
export type GetProjectPageByIdLazyQueryHookResult = ReturnType<typeof useGetProjectPageByIdLazyQuery>;
export type GetProjectPageByIdQueryResult = Apollo.QueryResult<GetProjectPageByIdQuery, GetProjectPageByIdQueryVariables>;
export const GetAllStaticFiltersDocument = gql`
    query GetAllStaticFilters($locale: String, $preview: Boolean) {
  staticFilters: regionDescriptionTextCollection(
    locale: $locale
    preview: $preview
    limit: 50
  ) {
    items {
      ...StaticFilter
    }
  }
}
    ${StaticFilterFragmentDoc}`;

/**
 * __useGetAllStaticFiltersQuery__
 *
 * To run a query within a React component, call `useGetAllStaticFiltersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllStaticFiltersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllStaticFiltersQuery({
 *   variables: {
 *      locale: // value for 'locale'
 *      preview: // value for 'preview'
 *   },
 * });
 */
export function useGetAllStaticFiltersQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetAllStaticFiltersQuery, GetAllStaticFiltersQueryVariables>) {
        return ApolloReactHooks.useQuery<GetAllStaticFiltersQuery, GetAllStaticFiltersQueryVariables>(GetAllStaticFiltersDocument, baseOptions);
      }
export function useGetAllStaticFiltersLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetAllStaticFiltersQuery, GetAllStaticFiltersQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetAllStaticFiltersQuery, GetAllStaticFiltersQueryVariables>(GetAllStaticFiltersDocument, baseOptions);
        }
export type GetAllStaticFiltersQueryHookResult = ReturnType<typeof useGetAllStaticFiltersQuery>;
export type GetAllStaticFiltersLazyQueryHookResult = ReturnType<typeof useGetAllStaticFiltersLazyQuery>;
export type GetAllStaticFiltersQueryResult = Apollo.QueryResult<GetAllStaticFiltersQuery, GetAllStaticFiltersQueryVariables>;
export const GetAccordionByIdDocument = gql`
    query GetAccordionById($locale: String, $preview: Boolean, $id: String!) {
  entryCollection(
    limit: 1
    where: {sys: {id: $id}}
    locale: $locale
    preview: $preview
  ) {
    items {
      ...AccordionEntryPoint
    }
  }
}
    ${AccordionEntryPointFragmentDoc}`;

/**
 * __useGetAccordionByIdQuery__
 *
 * To run a query within a React component, call `useGetAccordionByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAccordionByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAccordionByIdQuery({
 *   variables: {
 *      locale: // value for 'locale'
 *      preview: // value for 'preview'
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetAccordionByIdQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GetAccordionByIdQuery, GetAccordionByIdQueryVariables>) {
        return ApolloReactHooks.useQuery<GetAccordionByIdQuery, GetAccordionByIdQueryVariables>(GetAccordionByIdDocument, baseOptions);
      }
export function useGetAccordionByIdLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetAccordionByIdQuery, GetAccordionByIdQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetAccordionByIdQuery, GetAccordionByIdQueryVariables>(GetAccordionByIdDocument, baseOptions);
        }
export type GetAccordionByIdQueryHookResult = ReturnType<typeof useGetAccordionByIdQuery>;
export type GetAccordionByIdLazyQueryHookResult = ReturnType<typeof useGetAccordionByIdLazyQuery>;
export type GetAccordionByIdQueryResult = Apollo.QueryResult<GetAccordionByIdQuery, GetAccordionByIdQueryVariables>;
export const GetAccordionEntryByIdDocument = gql`
    query GetAccordionEntryById($locale: String, $preview: Boolean, $id: String!) {
  entryCollection(
    limit: 1
    where: {sys: {id: $id}}
    locale: $locale
    preview: $preview
  ) {
    items {
      ...AccordionEntryEntryPoint
    }
  }
}
    ${AccordionEntryEntryPointFragmentDoc}`;

/**
 * __useGetAccordionEntryByIdQuery__
 *
 * To run a query within a React component, call `useGetAccordionEntryByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAccordionEntryByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAccordionEntryByIdQuery({
 *   variables: {
 *      locale: // value for 'locale'
 *      preview: // value for 'preview'
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetAccordionEntryByIdQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GetAccordionEntryByIdQuery, GetAccordionEntryByIdQueryVariables>) {
        return ApolloReactHooks.useQuery<GetAccordionEntryByIdQuery, GetAccordionEntryByIdQueryVariables>(GetAccordionEntryByIdDocument, baseOptions);
      }
export function useGetAccordionEntryByIdLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetAccordionEntryByIdQuery, GetAccordionEntryByIdQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetAccordionEntryByIdQuery, GetAccordionEntryByIdQueryVariables>(GetAccordionEntryByIdDocument, baseOptions);
        }
export type GetAccordionEntryByIdQueryHookResult = ReturnType<typeof useGetAccordionEntryByIdQuery>;
export type GetAccordionEntryByIdLazyQueryHookResult = ReturnType<typeof useGetAccordionEntryByIdLazyQuery>;
export type GetAccordionEntryByIdQueryResult = Apollo.QueryResult<GetAccordionEntryByIdQuery, GetAccordionEntryByIdQueryVariables>;
export const GetBarChartWithBackgroundByIdDocument = gql`
    query GetBarChartWithBackgroundById($locale: String, $preview: Boolean, $id: String!) {
  entryCollection(
    limit: 1
    where: {sys: {id: $id}}
    locale: $locale
    preview: $preview
  ) {
    items {
      ...BarChartWithBackgroundEntryPoint
    }
  }
}
    ${BarChartWithBackgroundEntryPointFragmentDoc}`;

/**
 * __useGetBarChartWithBackgroundByIdQuery__
 *
 * To run a query within a React component, call `useGetBarChartWithBackgroundByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBarChartWithBackgroundByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetBarChartWithBackgroundByIdQuery({
 *   variables: {
 *      locale: // value for 'locale'
 *      preview: // value for 'preview'
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetBarChartWithBackgroundByIdQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GetBarChartWithBackgroundByIdQuery, GetBarChartWithBackgroundByIdQueryVariables>) {
        return ApolloReactHooks.useQuery<GetBarChartWithBackgroundByIdQuery, GetBarChartWithBackgroundByIdQueryVariables>(GetBarChartWithBackgroundByIdDocument, baseOptions);
      }
export function useGetBarChartWithBackgroundByIdLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetBarChartWithBackgroundByIdQuery, GetBarChartWithBackgroundByIdQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetBarChartWithBackgroundByIdQuery, GetBarChartWithBackgroundByIdQueryVariables>(GetBarChartWithBackgroundByIdDocument, baseOptions);
        }
export type GetBarChartWithBackgroundByIdQueryHookResult = ReturnType<typeof useGetBarChartWithBackgroundByIdQuery>;
export type GetBarChartWithBackgroundByIdLazyQueryHookResult = ReturnType<typeof useGetBarChartWithBackgroundByIdLazyQuery>;
export type GetBarChartWithBackgroundByIdQueryResult = Apollo.QueryResult<GetBarChartWithBackgroundByIdQuery, GetBarChartWithBackgroundByIdQueryVariables>;
export const GetBlockAnalystRatingByIdDocument = gql`
    query GetBlockAnalystRatingById($locale: String, $preview: Boolean, $id: String!) {
  entryCollection(
    limit: 1
    where: {sys: {id: $id}}
    locale: $locale
    preview: $preview
  ) {
    items {
      ...BlockAnalystRatingEntryPoint
    }
  }
}
    ${BlockAnalystRatingEntryPointFragmentDoc}`;

/**
 * __useGetBlockAnalystRatingByIdQuery__
 *
 * To run a query within a React component, call `useGetBlockAnalystRatingByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBlockAnalystRatingByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetBlockAnalystRatingByIdQuery({
 *   variables: {
 *      locale: // value for 'locale'
 *      preview: // value for 'preview'
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetBlockAnalystRatingByIdQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GetBlockAnalystRatingByIdQuery, GetBlockAnalystRatingByIdQueryVariables>) {
        return ApolloReactHooks.useQuery<GetBlockAnalystRatingByIdQuery, GetBlockAnalystRatingByIdQueryVariables>(GetBlockAnalystRatingByIdDocument, baseOptions);
      }
export function useGetBlockAnalystRatingByIdLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetBlockAnalystRatingByIdQuery, GetBlockAnalystRatingByIdQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetBlockAnalystRatingByIdQuery, GetBlockAnalystRatingByIdQueryVariables>(GetBlockAnalystRatingByIdDocument, baseOptions);
        }
export type GetBlockAnalystRatingByIdQueryHookResult = ReturnType<typeof useGetBlockAnalystRatingByIdQuery>;
export type GetBlockAnalystRatingByIdLazyQueryHookResult = ReturnType<typeof useGetBlockAnalystRatingByIdLazyQuery>;
export type GetBlockAnalystRatingByIdQueryResult = Apollo.QueryResult<GetBlockAnalystRatingByIdQuery, GetBlockAnalystRatingByIdQueryVariables>;
export const GetBlockBigTitleNavigationByIdDocument = gql`
    query GetBlockBigTitleNavigationById($locale: String, $preview: Boolean, $id: String!) {
  entryCollection(
    limit: 1
    where: {sys: {id: $id}}
    locale: $locale
    preview: $preview
  ) {
    items {
      ...BlockBigTitleNavigationEntryPoint
    }
  }
}
    ${BlockBigTitleNavigationEntryPointFragmentDoc}`;

/**
 * __useGetBlockBigTitleNavigationByIdQuery__
 *
 * To run a query within a React component, call `useGetBlockBigTitleNavigationByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBlockBigTitleNavigationByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetBlockBigTitleNavigationByIdQuery({
 *   variables: {
 *      locale: // value for 'locale'
 *      preview: // value for 'preview'
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetBlockBigTitleNavigationByIdQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GetBlockBigTitleNavigationByIdQuery, GetBlockBigTitleNavigationByIdQueryVariables>) {
        return ApolloReactHooks.useQuery<GetBlockBigTitleNavigationByIdQuery, GetBlockBigTitleNavigationByIdQueryVariables>(GetBlockBigTitleNavigationByIdDocument, baseOptions);
      }
export function useGetBlockBigTitleNavigationByIdLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetBlockBigTitleNavigationByIdQuery, GetBlockBigTitleNavigationByIdQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetBlockBigTitleNavigationByIdQuery, GetBlockBigTitleNavigationByIdQueryVariables>(GetBlockBigTitleNavigationByIdDocument, baseOptions);
        }
export type GetBlockBigTitleNavigationByIdQueryHookResult = ReturnType<typeof useGetBlockBigTitleNavigationByIdQuery>;
export type GetBlockBigTitleNavigationByIdLazyQueryHookResult = ReturnType<typeof useGetBlockBigTitleNavigationByIdLazyQuery>;
export type GetBlockBigTitleNavigationByIdQueryResult = Apollo.QueryResult<GetBlockBigTitleNavigationByIdQuery, GetBlockBigTitleNavigationByIdQueryVariables>;
export const GetBlockHiddenWithConsentByIdDocument = gql`
    query GetBlockHiddenWithConsentById($locale: String, $preview: Boolean, $id: String!) {
  entryCollection(
    limit: 1
    where: {sys: {id: $id}}
    locale: $locale
    preview: $preview
  ) {
    items {
      ...BlockHiddenWithConsentEntryPoint
    }
  }
}
    ${BlockHiddenWithConsentEntryPointFragmentDoc}`;

/**
 * __useGetBlockHiddenWithConsentByIdQuery__
 *
 * To run a query within a React component, call `useGetBlockHiddenWithConsentByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBlockHiddenWithConsentByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetBlockHiddenWithConsentByIdQuery({
 *   variables: {
 *      locale: // value for 'locale'
 *      preview: // value for 'preview'
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetBlockHiddenWithConsentByIdQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GetBlockHiddenWithConsentByIdQuery, GetBlockHiddenWithConsentByIdQueryVariables>) {
        return ApolloReactHooks.useQuery<GetBlockHiddenWithConsentByIdQuery, GetBlockHiddenWithConsentByIdQueryVariables>(GetBlockHiddenWithConsentByIdDocument, baseOptions);
      }
export function useGetBlockHiddenWithConsentByIdLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetBlockHiddenWithConsentByIdQuery, GetBlockHiddenWithConsentByIdQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetBlockHiddenWithConsentByIdQuery, GetBlockHiddenWithConsentByIdQueryVariables>(GetBlockHiddenWithConsentByIdDocument, baseOptions);
        }
export type GetBlockHiddenWithConsentByIdQueryHookResult = ReturnType<typeof useGetBlockHiddenWithConsentByIdQuery>;
export type GetBlockHiddenWithConsentByIdLazyQueryHookResult = ReturnType<typeof useGetBlockHiddenWithConsentByIdLazyQuery>;
export type GetBlockHiddenWithConsentByIdQueryResult = Apollo.QueryResult<GetBlockHiddenWithConsentByIdQuery, GetBlockHiddenWithConsentByIdQueryVariables>;
export const GetBlockHiddenWithConsentWithoutChildrenByIdDocument = gql`
    query GetBlockHiddenWithConsentWithoutChildrenById($locale: String, $preview: Boolean, $id: String!) {
  entryCollection(
    limit: 1
    where: {sys: {id: $id}}
    locale: $locale
    preview: $preview
  ) {
    items {
      ...BlockHiddenWithConsentWithoutChildrenEntryPoint
    }
  }
}
    ${BlockHiddenWithConsentWithoutChildrenEntryPointFragmentDoc}`;

/**
 * __useGetBlockHiddenWithConsentWithoutChildrenByIdQuery__
 *
 * To run a query within a React component, call `useGetBlockHiddenWithConsentWithoutChildrenByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBlockHiddenWithConsentWithoutChildrenByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetBlockHiddenWithConsentWithoutChildrenByIdQuery({
 *   variables: {
 *      locale: // value for 'locale'
 *      preview: // value for 'preview'
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetBlockHiddenWithConsentWithoutChildrenByIdQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GetBlockHiddenWithConsentWithoutChildrenByIdQuery, GetBlockHiddenWithConsentWithoutChildrenByIdQueryVariables>) {
        return ApolloReactHooks.useQuery<GetBlockHiddenWithConsentWithoutChildrenByIdQuery, GetBlockHiddenWithConsentWithoutChildrenByIdQueryVariables>(GetBlockHiddenWithConsentWithoutChildrenByIdDocument, baseOptions);
      }
export function useGetBlockHiddenWithConsentWithoutChildrenByIdLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetBlockHiddenWithConsentWithoutChildrenByIdQuery, GetBlockHiddenWithConsentWithoutChildrenByIdQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetBlockHiddenWithConsentWithoutChildrenByIdQuery, GetBlockHiddenWithConsentWithoutChildrenByIdQueryVariables>(GetBlockHiddenWithConsentWithoutChildrenByIdDocument, baseOptions);
        }
export type GetBlockHiddenWithConsentWithoutChildrenByIdQueryHookResult = ReturnType<typeof useGetBlockHiddenWithConsentWithoutChildrenByIdQuery>;
export type GetBlockHiddenWithConsentWithoutChildrenByIdLazyQueryHookResult = ReturnType<typeof useGetBlockHiddenWithConsentWithoutChildrenByIdLazyQuery>;
export type GetBlockHiddenWithConsentWithoutChildrenByIdQueryResult = Apollo.QueryResult<GetBlockHiddenWithConsentWithoutChildrenByIdQuery, GetBlockHiddenWithConsentWithoutChildrenByIdQueryVariables>;
export const GetBlockHighlightRealEstateByIdDocument = gql`
    query GetBlockHighlightRealEstateById($locale: String, $preview: Boolean, $id: String!) {
  entryCollection(
    limit: 1
    where: {sys: {id: $id}}
    locale: $locale
    preview: $preview
  ) {
    items {
      ...BlockHighlightRealEstateEntryPoint
    }
  }
}
    ${BlockHighlightRealEstateEntryPointFragmentDoc}`;

/**
 * __useGetBlockHighlightRealEstateByIdQuery__
 *
 * To run a query within a React component, call `useGetBlockHighlightRealEstateByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBlockHighlightRealEstateByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetBlockHighlightRealEstateByIdQuery({
 *   variables: {
 *      locale: // value for 'locale'
 *      preview: // value for 'preview'
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetBlockHighlightRealEstateByIdQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GetBlockHighlightRealEstateByIdQuery, GetBlockHighlightRealEstateByIdQueryVariables>) {
        return ApolloReactHooks.useQuery<GetBlockHighlightRealEstateByIdQuery, GetBlockHighlightRealEstateByIdQueryVariables>(GetBlockHighlightRealEstateByIdDocument, baseOptions);
      }
export function useGetBlockHighlightRealEstateByIdLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetBlockHighlightRealEstateByIdQuery, GetBlockHighlightRealEstateByIdQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetBlockHighlightRealEstateByIdQuery, GetBlockHighlightRealEstateByIdQueryVariables>(GetBlockHighlightRealEstateByIdDocument, baseOptions);
        }
export type GetBlockHighlightRealEstateByIdQueryHookResult = ReturnType<typeof useGetBlockHighlightRealEstateByIdQuery>;
export type GetBlockHighlightRealEstateByIdLazyQueryHookResult = ReturnType<typeof useGetBlockHighlightRealEstateByIdLazyQuery>;
export type GetBlockHighlightRealEstateByIdQueryResult = Apollo.QueryResult<GetBlockHighlightRealEstateByIdQuery, GetBlockHighlightRealEstateByIdQueryVariables>;
export const GetBlockImageGalleryByIdDocument = gql`
    query GetBlockImageGalleryById($locale: String, $preview: Boolean, $id: String!) {
  entryCollection(
    limit: 1
    where: {sys: {id: $id}}
    locale: $locale
    preview: $preview
  ) {
    items {
      ...BlockImageGalleryEntryPoint
    }
  }
}
    ${BlockImageGalleryEntryPointFragmentDoc}`;

/**
 * __useGetBlockImageGalleryByIdQuery__
 *
 * To run a query within a React component, call `useGetBlockImageGalleryByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBlockImageGalleryByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetBlockImageGalleryByIdQuery({
 *   variables: {
 *      locale: // value for 'locale'
 *      preview: // value for 'preview'
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetBlockImageGalleryByIdQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GetBlockImageGalleryByIdQuery, GetBlockImageGalleryByIdQueryVariables>) {
        return ApolloReactHooks.useQuery<GetBlockImageGalleryByIdQuery, GetBlockImageGalleryByIdQueryVariables>(GetBlockImageGalleryByIdDocument, baseOptions);
      }
export function useGetBlockImageGalleryByIdLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetBlockImageGalleryByIdQuery, GetBlockImageGalleryByIdQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetBlockImageGalleryByIdQuery, GetBlockImageGalleryByIdQueryVariables>(GetBlockImageGalleryByIdDocument, baseOptions);
        }
export type GetBlockImageGalleryByIdQueryHookResult = ReturnType<typeof useGetBlockImageGalleryByIdQuery>;
export type GetBlockImageGalleryByIdLazyQueryHookResult = ReturnType<typeof useGetBlockImageGalleryByIdLazyQuery>;
export type GetBlockImageGalleryByIdQueryResult = Apollo.QueryResult<GetBlockImageGalleryByIdQuery, GetBlockImageGalleryByIdQueryVariables>;
export const GetBlockLinkSectionByIdDocument = gql`
    query GetBlockLinkSectionById($locale: String, $preview: Boolean, $id: String!) {
  entryCollection(
    limit: 1
    where: {sys: {id: $id}}
    locale: $locale
    preview: $preview
  ) {
    items {
      ...BlockLinkSectionEntryPoint
    }
  }
}
    ${BlockLinkSectionEntryPointFragmentDoc}`;

/**
 * __useGetBlockLinkSectionByIdQuery__
 *
 * To run a query within a React component, call `useGetBlockLinkSectionByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBlockLinkSectionByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetBlockLinkSectionByIdQuery({
 *   variables: {
 *      locale: // value for 'locale'
 *      preview: // value for 'preview'
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetBlockLinkSectionByIdQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GetBlockLinkSectionByIdQuery, GetBlockLinkSectionByIdQueryVariables>) {
        return ApolloReactHooks.useQuery<GetBlockLinkSectionByIdQuery, GetBlockLinkSectionByIdQueryVariables>(GetBlockLinkSectionByIdDocument, baseOptions);
      }
export function useGetBlockLinkSectionByIdLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetBlockLinkSectionByIdQuery, GetBlockLinkSectionByIdQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetBlockLinkSectionByIdQuery, GetBlockLinkSectionByIdQueryVariables>(GetBlockLinkSectionByIdDocument, baseOptions);
        }
export type GetBlockLinkSectionByIdQueryHookResult = ReturnType<typeof useGetBlockLinkSectionByIdQuery>;
export type GetBlockLinkSectionByIdLazyQueryHookResult = ReturnType<typeof useGetBlockLinkSectionByIdLazyQuery>;
export type GetBlockLinkSectionByIdQueryResult = Apollo.QueryResult<GetBlockLinkSectionByIdQuery, GetBlockLinkSectionByIdQueryVariables>;
export const GetBlockPartnerGridByIdDocument = gql`
    query GetBlockPartnerGridById($locale: String, $preview: Boolean, $id: String!) {
  entryCollection(
    limit: 1
    where: {sys: {id: $id}}
    locale: $locale
    preview: $preview
  ) {
    items {
      ...BlockPartnerGridEntryPoint
    }
  }
}
    ${BlockPartnerGridEntryPointFragmentDoc}`;

/**
 * __useGetBlockPartnerGridByIdQuery__
 *
 * To run a query within a React component, call `useGetBlockPartnerGridByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBlockPartnerGridByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetBlockPartnerGridByIdQuery({
 *   variables: {
 *      locale: // value for 'locale'
 *      preview: // value for 'preview'
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetBlockPartnerGridByIdQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GetBlockPartnerGridByIdQuery, GetBlockPartnerGridByIdQueryVariables>) {
        return ApolloReactHooks.useQuery<GetBlockPartnerGridByIdQuery, GetBlockPartnerGridByIdQueryVariables>(GetBlockPartnerGridByIdDocument, baseOptions);
      }
export function useGetBlockPartnerGridByIdLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetBlockPartnerGridByIdQuery, GetBlockPartnerGridByIdQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetBlockPartnerGridByIdQuery, GetBlockPartnerGridByIdQueryVariables>(GetBlockPartnerGridByIdDocument, baseOptions);
        }
export type GetBlockPartnerGridByIdQueryHookResult = ReturnType<typeof useGetBlockPartnerGridByIdQuery>;
export type GetBlockPartnerGridByIdLazyQueryHookResult = ReturnType<typeof useGetBlockPartnerGridByIdLazyQuery>;
export type GetBlockPartnerGridByIdQueryResult = Apollo.QueryResult<GetBlockPartnerGridByIdQuery, GetBlockPartnerGridByIdQueryVariables>;
export const GetBlockSliderByIdDocument = gql`
    query GetBlockSliderById($locale: String, $preview: Boolean, $id: String!) {
  entryCollection(
    limit: 1
    where: {sys: {id: $id}}
    locale: $locale
    preview: $preview
  ) {
    items {
      ...BlockSliderEntryPoint
    }
  }
}
    ${BlockSliderEntryPointFragmentDoc}`;

/**
 * __useGetBlockSliderByIdQuery__
 *
 * To run a query within a React component, call `useGetBlockSliderByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBlockSliderByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetBlockSliderByIdQuery({
 *   variables: {
 *      locale: // value for 'locale'
 *      preview: // value for 'preview'
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetBlockSliderByIdQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GetBlockSliderByIdQuery, GetBlockSliderByIdQueryVariables>) {
        return ApolloReactHooks.useQuery<GetBlockSliderByIdQuery, GetBlockSliderByIdQueryVariables>(GetBlockSliderByIdDocument, baseOptions);
      }
export function useGetBlockSliderByIdLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetBlockSliderByIdQuery, GetBlockSliderByIdQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetBlockSliderByIdQuery, GetBlockSliderByIdQueryVariables>(GetBlockSliderByIdDocument, baseOptions);
        }
export type GetBlockSliderByIdQueryHookResult = ReturnType<typeof useGetBlockSliderByIdQuery>;
export type GetBlockSliderByIdLazyQueryHookResult = ReturnType<typeof useGetBlockSliderByIdLazyQuery>;
export type GetBlockSliderByIdQueryResult = Apollo.QueryResult<GetBlockSliderByIdQuery, GetBlockSliderByIdQueryVariables>;
export const GetBlockSliderEntryByIdDocument = gql`
    query GetBlockSliderEntryById($locale: String, $preview: Boolean, $id: String!) {
  entryCollection(
    limit: 1
    where: {sys: {id: $id}}
    locale: $locale
    preview: $preview
  ) {
    items {
      ...BlockSliderEntryEntryPoint
    }
  }
}
    ${BlockSliderEntryEntryPointFragmentDoc}`;

/**
 * __useGetBlockSliderEntryByIdQuery__
 *
 * To run a query within a React component, call `useGetBlockSliderEntryByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBlockSliderEntryByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetBlockSliderEntryByIdQuery({
 *   variables: {
 *      locale: // value for 'locale'
 *      preview: // value for 'preview'
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetBlockSliderEntryByIdQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GetBlockSliderEntryByIdQuery, GetBlockSliderEntryByIdQueryVariables>) {
        return ApolloReactHooks.useQuery<GetBlockSliderEntryByIdQuery, GetBlockSliderEntryByIdQueryVariables>(GetBlockSliderEntryByIdDocument, baseOptions);
      }
export function useGetBlockSliderEntryByIdLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetBlockSliderEntryByIdQuery, GetBlockSliderEntryByIdQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetBlockSliderEntryByIdQuery, GetBlockSliderEntryByIdQueryVariables>(GetBlockSliderEntryByIdDocument, baseOptions);
        }
export type GetBlockSliderEntryByIdQueryHookResult = ReturnType<typeof useGetBlockSliderEntryByIdQuery>;
export type GetBlockSliderEntryByIdLazyQueryHookResult = ReturnType<typeof useGetBlockSliderEntryByIdLazyQuery>;
export type GetBlockSliderEntryByIdQueryResult = Apollo.QueryResult<GetBlockSliderEntryByIdQuery, GetBlockSliderEntryByIdQueryVariables>;
export const GetBlockSpeechBubbleByIdDocument = gql`
    query GetBlockSpeechBubbleById($locale: String, $preview: Boolean, $id: String!) {
  entryCollection(
    limit: 1
    where: {sys: {id: $id}}
    locale: $locale
    preview: $preview
  ) {
    items {
      ...BlockSpeechBubbleEntryPoint
    }
  }
}
    ${BlockSpeechBubbleEntryPointFragmentDoc}`;

/**
 * __useGetBlockSpeechBubbleByIdQuery__
 *
 * To run a query within a React component, call `useGetBlockSpeechBubbleByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBlockSpeechBubbleByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetBlockSpeechBubbleByIdQuery({
 *   variables: {
 *      locale: // value for 'locale'
 *      preview: // value for 'preview'
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetBlockSpeechBubbleByIdQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GetBlockSpeechBubbleByIdQuery, GetBlockSpeechBubbleByIdQueryVariables>) {
        return ApolloReactHooks.useQuery<GetBlockSpeechBubbleByIdQuery, GetBlockSpeechBubbleByIdQueryVariables>(GetBlockSpeechBubbleByIdDocument, baseOptions);
      }
export function useGetBlockSpeechBubbleByIdLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetBlockSpeechBubbleByIdQuery, GetBlockSpeechBubbleByIdQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetBlockSpeechBubbleByIdQuery, GetBlockSpeechBubbleByIdQueryVariables>(GetBlockSpeechBubbleByIdDocument, baseOptions);
        }
export type GetBlockSpeechBubbleByIdQueryHookResult = ReturnType<typeof useGetBlockSpeechBubbleByIdQuery>;
export type GetBlockSpeechBubbleByIdLazyQueryHookResult = ReturnType<typeof useGetBlockSpeechBubbleByIdLazyQuery>;
export type GetBlockSpeechBubbleByIdQueryResult = Apollo.QueryResult<GetBlockSpeechBubbleByIdQuery, GetBlockSpeechBubbleByIdQueryVariables>;
export const GetBlockStockPriceByIdDocument = gql`
    query GetBlockStockPriceById($locale: String, $preview: Boolean, $id: String!) {
  entryCollection(
    limit: 1
    where: {sys: {id: $id}}
    locale: $locale
    preview: $preview
  ) {
    items {
      ...BlockStockPriceEntryPoint
    }
  }
}
    ${BlockStockPriceEntryPointFragmentDoc}`;

/**
 * __useGetBlockStockPriceByIdQuery__
 *
 * To run a query within a React component, call `useGetBlockStockPriceByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBlockStockPriceByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetBlockStockPriceByIdQuery({
 *   variables: {
 *      locale: // value for 'locale'
 *      preview: // value for 'preview'
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetBlockStockPriceByIdQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GetBlockStockPriceByIdQuery, GetBlockStockPriceByIdQueryVariables>) {
        return ApolloReactHooks.useQuery<GetBlockStockPriceByIdQuery, GetBlockStockPriceByIdQueryVariables>(GetBlockStockPriceByIdDocument, baseOptions);
      }
export function useGetBlockStockPriceByIdLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetBlockStockPriceByIdQuery, GetBlockStockPriceByIdQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetBlockStockPriceByIdQuery, GetBlockStockPriceByIdQueryVariables>(GetBlockStockPriceByIdDocument, baseOptions);
        }
export type GetBlockStockPriceByIdQueryHookResult = ReturnType<typeof useGetBlockStockPriceByIdQuery>;
export type GetBlockStockPriceByIdLazyQueryHookResult = ReturnType<typeof useGetBlockStockPriceByIdLazyQuery>;
export type GetBlockStockPriceByIdQueryResult = Apollo.QueryResult<GetBlockStockPriceByIdQuery, GetBlockStockPriceByIdQueryVariables>;
export const GetBlockSubNavigationByIdDocument = gql`
    query GetBlockSubNavigationById($locale: String, $preview: Boolean, $id: String!) {
  entryCollection(
    limit: 1
    where: {sys: {id: $id}}
    locale: $locale
    preview: $preview
  ) {
    items {
      ...BlockSubNavigationEntryPoint
    }
  }
}
    ${BlockSubNavigationEntryPointFragmentDoc}`;

/**
 * __useGetBlockSubNavigationByIdQuery__
 *
 * To run a query within a React component, call `useGetBlockSubNavigationByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBlockSubNavigationByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetBlockSubNavigationByIdQuery({
 *   variables: {
 *      locale: // value for 'locale'
 *      preview: // value for 'preview'
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetBlockSubNavigationByIdQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GetBlockSubNavigationByIdQuery, GetBlockSubNavigationByIdQueryVariables>) {
        return ApolloReactHooks.useQuery<GetBlockSubNavigationByIdQuery, GetBlockSubNavigationByIdQueryVariables>(GetBlockSubNavigationByIdDocument, baseOptions);
      }
export function useGetBlockSubNavigationByIdLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetBlockSubNavigationByIdQuery, GetBlockSubNavigationByIdQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetBlockSubNavigationByIdQuery, GetBlockSubNavigationByIdQueryVariables>(GetBlockSubNavigationByIdDocument, baseOptions);
        }
export type GetBlockSubNavigationByIdQueryHookResult = ReturnType<typeof useGetBlockSubNavigationByIdQuery>;
export type GetBlockSubNavigationByIdLazyQueryHookResult = ReturnType<typeof useGetBlockSubNavigationByIdLazyQuery>;
export type GetBlockSubNavigationByIdQueryResult = Apollo.QueryResult<GetBlockSubNavigationByIdQuery, GetBlockSubNavigationByIdQueryVariables>;
export const GetBlockTextCloudByIdDocument = gql`
    query GetBlockTextCloudById($locale: String, $preview: Boolean, $id: String!) {
  entryCollection(
    limit: 1
    where: {sys: {id: $id}}
    locale: $locale
    preview: $preview
  ) {
    items {
      ...BlockTextCloudEntryPoint
    }
  }
}
    ${BlockTextCloudEntryPointFragmentDoc}`;

/**
 * __useGetBlockTextCloudByIdQuery__
 *
 * To run a query within a React component, call `useGetBlockTextCloudByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBlockTextCloudByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetBlockTextCloudByIdQuery({
 *   variables: {
 *      locale: // value for 'locale'
 *      preview: // value for 'preview'
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetBlockTextCloudByIdQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GetBlockTextCloudByIdQuery, GetBlockTextCloudByIdQueryVariables>) {
        return ApolloReactHooks.useQuery<GetBlockTextCloudByIdQuery, GetBlockTextCloudByIdQueryVariables>(GetBlockTextCloudByIdDocument, baseOptions);
      }
export function useGetBlockTextCloudByIdLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetBlockTextCloudByIdQuery, GetBlockTextCloudByIdQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetBlockTextCloudByIdQuery, GetBlockTextCloudByIdQueryVariables>(GetBlockTextCloudByIdDocument, baseOptions);
        }
export type GetBlockTextCloudByIdQueryHookResult = ReturnType<typeof useGetBlockTextCloudByIdQuery>;
export type GetBlockTextCloudByIdLazyQueryHookResult = ReturnType<typeof useGetBlockTextCloudByIdLazyQuery>;
export type GetBlockTextCloudByIdQueryResult = Apollo.QueryResult<GetBlockTextCloudByIdQuery, GetBlockTextCloudByIdQueryVariables>;
export const GetBlockThreeColumnByIdDocument = gql`
    query GetBlockThreeColumnById($locale: String, $preview: Boolean, $id: String!) {
  entryCollection(
    limit: 1
    where: {sys: {id: $id}}
    locale: $locale
    preview: $preview
  ) {
    items {
      ...BlockThreeColumnEntryPoint
    }
  }
}
    ${BlockThreeColumnEntryPointFragmentDoc}`;

/**
 * __useGetBlockThreeColumnByIdQuery__
 *
 * To run a query within a React component, call `useGetBlockThreeColumnByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBlockThreeColumnByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetBlockThreeColumnByIdQuery({
 *   variables: {
 *      locale: // value for 'locale'
 *      preview: // value for 'preview'
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetBlockThreeColumnByIdQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GetBlockThreeColumnByIdQuery, GetBlockThreeColumnByIdQueryVariables>) {
        return ApolloReactHooks.useQuery<GetBlockThreeColumnByIdQuery, GetBlockThreeColumnByIdQueryVariables>(GetBlockThreeColumnByIdDocument, baseOptions);
      }
export function useGetBlockThreeColumnByIdLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetBlockThreeColumnByIdQuery, GetBlockThreeColumnByIdQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetBlockThreeColumnByIdQuery, GetBlockThreeColumnByIdQueryVariables>(GetBlockThreeColumnByIdDocument, baseOptions);
        }
export type GetBlockThreeColumnByIdQueryHookResult = ReturnType<typeof useGetBlockThreeColumnByIdQuery>;
export type GetBlockThreeColumnByIdLazyQueryHookResult = ReturnType<typeof useGetBlockThreeColumnByIdLazyQuery>;
export type GetBlockThreeColumnByIdQueryResult = Apollo.QueryResult<GetBlockThreeColumnByIdQuery, GetBlockThreeColumnByIdQueryVariables>;
export const GetBlockVideoByIdDocument = gql`
    query GetBlockVideoById($locale: String, $preview: Boolean, $id: String!) {
  entryCollection(
    limit: 1
    where: {sys: {id: $id}}
    locale: $locale
    preview: $preview
  ) {
    items {
      ...BlockVideoEntryPoint
    }
  }
}
    ${BlockVideoEntryPointFragmentDoc}`;

/**
 * __useGetBlockVideoByIdQuery__
 *
 * To run a query within a React component, call `useGetBlockVideoByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBlockVideoByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetBlockVideoByIdQuery({
 *   variables: {
 *      locale: // value for 'locale'
 *      preview: // value for 'preview'
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetBlockVideoByIdQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GetBlockVideoByIdQuery, GetBlockVideoByIdQueryVariables>) {
        return ApolloReactHooks.useQuery<GetBlockVideoByIdQuery, GetBlockVideoByIdQueryVariables>(GetBlockVideoByIdDocument, baseOptions);
      }
export function useGetBlockVideoByIdLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetBlockVideoByIdQuery, GetBlockVideoByIdQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetBlockVideoByIdQuery, GetBlockVideoByIdQueryVariables>(GetBlockVideoByIdDocument, baseOptions);
        }
export type GetBlockVideoByIdQueryHookResult = ReturnType<typeof useGetBlockVideoByIdQuery>;
export type GetBlockVideoByIdLazyQueryHookResult = ReturnType<typeof useGetBlockVideoByIdLazyQuery>;
export type GetBlockVideoByIdQueryResult = Apollo.QueryResult<GetBlockVideoByIdQuery, GetBlockVideoByIdQueryVariables>;
export const GetCustomBlockByIdDocument = gql`
    query GetCustomBlockById($locale: String, $preview: Boolean, $id: String!) {
  entryCollection(
    limit: 1
    where: {sys: {id: $id}}
    locale: $locale
    preview: $preview
  ) {
    items {
      ...CustomBlockEntryPoint
    }
  }
}
    ${CustomBlockEntryPointFragmentDoc}`;

/**
 * __useGetCustomBlockByIdQuery__
 *
 * To run a query within a React component, call `useGetCustomBlockByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCustomBlockByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCustomBlockByIdQuery({
 *   variables: {
 *      locale: // value for 'locale'
 *      preview: // value for 'preview'
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetCustomBlockByIdQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GetCustomBlockByIdQuery, GetCustomBlockByIdQueryVariables>) {
        return ApolloReactHooks.useQuery<GetCustomBlockByIdQuery, GetCustomBlockByIdQueryVariables>(GetCustomBlockByIdDocument, baseOptions);
      }
export function useGetCustomBlockByIdLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetCustomBlockByIdQuery, GetCustomBlockByIdQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetCustomBlockByIdQuery, GetCustomBlockByIdQueryVariables>(GetCustomBlockByIdDocument, baseOptions);
        }
export type GetCustomBlockByIdQueryHookResult = ReturnType<typeof useGetCustomBlockByIdQuery>;
export type GetCustomBlockByIdLazyQueryHookResult = ReturnType<typeof useGetCustomBlockByIdLazyQuery>;
export type GetCustomBlockByIdQueryResult = Apollo.QueryResult<GetCustomBlockByIdQuery, GetCustomBlockByIdQueryVariables>;
export const GetFullBlockCallToActionButtonByIdDocument = gql`
    query GetFullBlockCallToActionButtonById($locale: String, $preview: Boolean, $id: String!) {
  entryCollection(
    limit: 1
    where: {sys: {id: $id}}
    locale: $locale
    preview: $preview
  ) {
    items {
      ...FullBlockCallToActionButtonEntryPoint
    }
  }
}
    ${FullBlockCallToActionButtonEntryPointFragmentDoc}`;

/**
 * __useGetFullBlockCallToActionButtonByIdQuery__
 *
 * To run a query within a React component, call `useGetFullBlockCallToActionButtonByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFullBlockCallToActionButtonByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFullBlockCallToActionButtonByIdQuery({
 *   variables: {
 *      locale: // value for 'locale'
 *      preview: // value for 'preview'
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetFullBlockCallToActionButtonByIdQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GetFullBlockCallToActionButtonByIdQuery, GetFullBlockCallToActionButtonByIdQueryVariables>) {
        return ApolloReactHooks.useQuery<GetFullBlockCallToActionButtonByIdQuery, GetFullBlockCallToActionButtonByIdQueryVariables>(GetFullBlockCallToActionButtonByIdDocument, baseOptions);
      }
export function useGetFullBlockCallToActionButtonByIdLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetFullBlockCallToActionButtonByIdQuery, GetFullBlockCallToActionButtonByIdQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetFullBlockCallToActionButtonByIdQuery, GetFullBlockCallToActionButtonByIdQueryVariables>(GetFullBlockCallToActionButtonByIdDocument, baseOptions);
        }
export type GetFullBlockCallToActionButtonByIdQueryHookResult = ReturnType<typeof useGetFullBlockCallToActionButtonByIdQuery>;
export type GetFullBlockCallToActionButtonByIdLazyQueryHookResult = ReturnType<typeof useGetFullBlockCallToActionButtonByIdLazyQuery>;
export type GetFullBlockCallToActionButtonByIdQueryResult = Apollo.QueryResult<GetFullBlockCallToActionButtonByIdQuery, GetFullBlockCallToActionButtonByIdQueryVariables>;
export const GetFullBlockFullsizeImageByIdDocument = gql`
    query GetFullBlockFullsizeImageById($locale: String, $preview: Boolean, $id: String!) {
  entryCollection(
    limit: 1
    where: {sys: {id: $id}}
    locale: $locale
    preview: $preview
  ) {
    items {
      ...FullBlockFullsizeImageEntryPoint
    }
  }
}
    ${FullBlockFullsizeImageEntryPointFragmentDoc}`;

/**
 * __useGetFullBlockFullsizeImageByIdQuery__
 *
 * To run a query within a React component, call `useGetFullBlockFullsizeImageByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFullBlockFullsizeImageByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFullBlockFullsizeImageByIdQuery({
 *   variables: {
 *      locale: // value for 'locale'
 *      preview: // value for 'preview'
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetFullBlockFullsizeImageByIdQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GetFullBlockFullsizeImageByIdQuery, GetFullBlockFullsizeImageByIdQueryVariables>) {
        return ApolloReactHooks.useQuery<GetFullBlockFullsizeImageByIdQuery, GetFullBlockFullsizeImageByIdQueryVariables>(GetFullBlockFullsizeImageByIdDocument, baseOptions);
      }
export function useGetFullBlockFullsizeImageByIdLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetFullBlockFullsizeImageByIdQuery, GetFullBlockFullsizeImageByIdQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetFullBlockFullsizeImageByIdQuery, GetFullBlockFullsizeImageByIdQueryVariables>(GetFullBlockFullsizeImageByIdDocument, baseOptions);
        }
export type GetFullBlockFullsizeImageByIdQueryHookResult = ReturnType<typeof useGetFullBlockFullsizeImageByIdQuery>;
export type GetFullBlockFullsizeImageByIdLazyQueryHookResult = ReturnType<typeof useGetFullBlockFullsizeImageByIdLazyQuery>;
export type GetFullBlockFullsizeImageByIdQueryResult = Apollo.QueryResult<GetFullBlockFullsizeImageByIdQuery, GetFullBlockFullsizeImageByIdQueryVariables>;
export const GetFullBlockRibbonByIdDocument = gql`
    query GetFullBlockRibbonById($locale: String, $preview: Boolean, $id: String!) {
  entryCollection(
    limit: 1
    where: {sys: {id: $id}}
    locale: $locale
    preview: $preview
  ) {
    items {
      ...FullBlockRibbonEntryPoint
    }
  }
}
    ${FullBlockRibbonEntryPointFragmentDoc}`;

/**
 * __useGetFullBlockRibbonByIdQuery__
 *
 * To run a query within a React component, call `useGetFullBlockRibbonByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFullBlockRibbonByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFullBlockRibbonByIdQuery({
 *   variables: {
 *      locale: // value for 'locale'
 *      preview: // value for 'preview'
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetFullBlockRibbonByIdQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GetFullBlockRibbonByIdQuery, GetFullBlockRibbonByIdQueryVariables>) {
        return ApolloReactHooks.useQuery<GetFullBlockRibbonByIdQuery, GetFullBlockRibbonByIdQueryVariables>(GetFullBlockRibbonByIdDocument, baseOptions);
      }
export function useGetFullBlockRibbonByIdLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetFullBlockRibbonByIdQuery, GetFullBlockRibbonByIdQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetFullBlockRibbonByIdQuery, GetFullBlockRibbonByIdQueryVariables>(GetFullBlockRibbonByIdDocument, baseOptions);
        }
export type GetFullBlockRibbonByIdQueryHookResult = ReturnType<typeof useGetFullBlockRibbonByIdQuery>;
export type GetFullBlockRibbonByIdLazyQueryHookResult = ReturnType<typeof useGetFullBlockRibbonByIdLazyQuery>;
export type GetFullBlockRibbonByIdQueryResult = Apollo.QueryResult<GetFullBlockRibbonByIdQuery, GetFullBlockRibbonByIdQueryVariables>;
export const GetFullBlockRichTextByIdDocument = gql`
    query GetFullBlockRichTextById($locale: String, $preview: Boolean, $id: String!) {
  entryCollection(
    limit: 1
    where: {sys: {id: $id}}
    locale: $locale
    preview: $preview
  ) {
    items {
      ...FullBlockRichTextEntryPoint
    }
  }
}
    ${FullBlockRichTextEntryPointFragmentDoc}`;

/**
 * __useGetFullBlockRichTextByIdQuery__
 *
 * To run a query within a React component, call `useGetFullBlockRichTextByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFullBlockRichTextByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFullBlockRichTextByIdQuery({
 *   variables: {
 *      locale: // value for 'locale'
 *      preview: // value for 'preview'
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetFullBlockRichTextByIdQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GetFullBlockRichTextByIdQuery, GetFullBlockRichTextByIdQueryVariables>) {
        return ApolloReactHooks.useQuery<GetFullBlockRichTextByIdQuery, GetFullBlockRichTextByIdQueryVariables>(GetFullBlockRichTextByIdDocument, baseOptions);
      }
export function useGetFullBlockRichTextByIdLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetFullBlockRichTextByIdQuery, GetFullBlockRichTextByIdQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetFullBlockRichTextByIdQuery, GetFullBlockRichTextByIdQueryVariables>(GetFullBlockRichTextByIdDocument, baseOptions);
        }
export type GetFullBlockRichTextByIdQueryHookResult = ReturnType<typeof useGetFullBlockRichTextByIdQuery>;
export type GetFullBlockRichTextByIdLazyQueryHookResult = ReturnType<typeof useGetFullBlockRichTextByIdLazyQuery>;
export type GetFullBlockRichTextByIdQueryResult = Apollo.QueryResult<GetFullBlockRichTextByIdQuery, GetFullBlockRichTextByIdQueryVariables>;
export const GetFullBlockTableByIdDocument = gql`
    query GetFullBlockTableById($locale: String, $preview: Boolean, $id: String!) {
  entryCollection(
    limit: 1
    where: {sys: {id: $id}}
    locale: $locale
    preview: $preview
  ) {
    items {
      ...FullBlockTableEntryPoint
    }
  }
}
    ${FullBlockTableEntryPointFragmentDoc}`;

/**
 * __useGetFullBlockTableByIdQuery__
 *
 * To run a query within a React component, call `useGetFullBlockTableByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFullBlockTableByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFullBlockTableByIdQuery({
 *   variables: {
 *      locale: // value for 'locale'
 *      preview: // value for 'preview'
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetFullBlockTableByIdQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GetFullBlockTableByIdQuery, GetFullBlockTableByIdQueryVariables>) {
        return ApolloReactHooks.useQuery<GetFullBlockTableByIdQuery, GetFullBlockTableByIdQueryVariables>(GetFullBlockTableByIdDocument, baseOptions);
      }
export function useGetFullBlockTableByIdLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetFullBlockTableByIdQuery, GetFullBlockTableByIdQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetFullBlockTableByIdQuery, GetFullBlockTableByIdQueryVariables>(GetFullBlockTableByIdDocument, baseOptions);
        }
export type GetFullBlockTableByIdQueryHookResult = ReturnType<typeof useGetFullBlockTableByIdQuery>;
export type GetFullBlockTableByIdLazyQueryHookResult = ReturnType<typeof useGetFullBlockTableByIdLazyQuery>;
export type GetFullBlockTableByIdQueryResult = Apollo.QueryResult<GetFullBlockTableByIdQuery, GetFullBlockTableByIdQueryVariables>;
export const GetLatestDownloadByIdDocument = gql`
    query GetLatestDownloadById($locale: String, $preview: Boolean, $id: String!) {
  entryCollection(
    limit: 1
    where: {sys: {id: $id}}
    locale: $locale
    preview: $preview
  ) {
    items {
      ...LatestDownloadEntryPoint
    }
  }
}
    ${LatestDownloadEntryPointFragmentDoc}`;

/**
 * __useGetLatestDownloadByIdQuery__
 *
 * To run a query within a React component, call `useGetLatestDownloadByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLatestDownloadByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetLatestDownloadByIdQuery({
 *   variables: {
 *      locale: // value for 'locale'
 *      preview: // value for 'preview'
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetLatestDownloadByIdQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GetLatestDownloadByIdQuery, GetLatestDownloadByIdQueryVariables>) {
        return ApolloReactHooks.useQuery<GetLatestDownloadByIdQuery, GetLatestDownloadByIdQueryVariables>(GetLatestDownloadByIdDocument, baseOptions);
      }
export function useGetLatestDownloadByIdLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetLatestDownloadByIdQuery, GetLatestDownloadByIdQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetLatestDownloadByIdQuery, GetLatestDownloadByIdQueryVariables>(GetLatestDownloadByIdDocument, baseOptions);
        }
export type GetLatestDownloadByIdQueryHookResult = ReturnType<typeof useGetLatestDownloadByIdQuery>;
export type GetLatestDownloadByIdLazyQueryHookResult = ReturnType<typeof useGetLatestDownloadByIdLazyQuery>;
export type GetLatestDownloadByIdQueryResult = Apollo.QueryResult<GetLatestDownloadByIdQuery, GetLatestDownloadByIdQueryVariables>;
export const GetNavigationEntryByIdDocument = gql`
    query GetNavigationEntryById($locale: String, $preview: Boolean, $id: String!) {
  entryCollection(
    limit: 1
    where: {sys: {id: $id}}
    locale: $locale
    preview: $preview
  ) {
    items {
      ...NavigationEntryEntryPoint
    }
  }
}
    ${NavigationEntryEntryPointFragmentDoc}`;

/**
 * __useGetNavigationEntryByIdQuery__
 *
 * To run a query within a React component, call `useGetNavigationEntryByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetNavigationEntryByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetNavigationEntryByIdQuery({
 *   variables: {
 *      locale: // value for 'locale'
 *      preview: // value for 'preview'
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetNavigationEntryByIdQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GetNavigationEntryByIdQuery, GetNavigationEntryByIdQueryVariables>) {
        return ApolloReactHooks.useQuery<GetNavigationEntryByIdQuery, GetNavigationEntryByIdQueryVariables>(GetNavigationEntryByIdDocument, baseOptions);
      }
export function useGetNavigationEntryByIdLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetNavigationEntryByIdQuery, GetNavigationEntryByIdQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetNavigationEntryByIdQuery, GetNavigationEntryByIdQueryVariables>(GetNavigationEntryByIdDocument, baseOptions);
        }
export type GetNavigationEntryByIdQueryHookResult = ReturnType<typeof useGetNavigationEntryByIdQuery>;
export type GetNavigationEntryByIdLazyQueryHookResult = ReturnType<typeof useGetNavigationEntryByIdLazyQuery>;
export type GetNavigationEntryByIdQueryResult = Apollo.QueryResult<GetNavigationEntryByIdQuery, GetNavigationEntryByIdQueryVariables>;
export const GetOneColumnLayoutByIdDocument = gql`
    query GetOneColumnLayoutById($locale: String, $preview: Boolean, $id: String!) {
  entryCollection(
    limit: 1
    where: {sys: {id: $id}}
    locale: $locale
    preview: $preview
  ) {
    items {
      ...OneColumnLayoutEntryPoint
    }
  }
}
    ${OneColumnLayoutEntryPointFragmentDoc}`;

/**
 * __useGetOneColumnLayoutByIdQuery__
 *
 * To run a query within a React component, call `useGetOneColumnLayoutByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOneColumnLayoutByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOneColumnLayoutByIdQuery({
 *   variables: {
 *      locale: // value for 'locale'
 *      preview: // value for 'preview'
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetOneColumnLayoutByIdQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GetOneColumnLayoutByIdQuery, GetOneColumnLayoutByIdQueryVariables>) {
        return ApolloReactHooks.useQuery<GetOneColumnLayoutByIdQuery, GetOneColumnLayoutByIdQueryVariables>(GetOneColumnLayoutByIdDocument, baseOptions);
      }
export function useGetOneColumnLayoutByIdLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetOneColumnLayoutByIdQuery, GetOneColumnLayoutByIdQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetOneColumnLayoutByIdQuery, GetOneColumnLayoutByIdQueryVariables>(GetOneColumnLayoutByIdDocument, baseOptions);
        }
export type GetOneColumnLayoutByIdQueryHookResult = ReturnType<typeof useGetOneColumnLayoutByIdQuery>;
export type GetOneColumnLayoutByIdLazyQueryHookResult = ReturnType<typeof useGetOneColumnLayoutByIdLazyQuery>;
export type GetOneColumnLayoutByIdQueryResult = Apollo.QueryResult<GetOneColumnLayoutByIdQuery, GetOneColumnLayoutByIdQueryVariables>;
export const GetPersonAccordionByIdDocument = gql`
    query GetPersonAccordionById($locale: String, $preview: Boolean, $id: String!) {
  entryCollection(
    limit: 1
    where: {sys: {id: $id}}
    locale: $locale
    preview: $preview
  ) {
    items {
      ...PersonAccordionEntryPoint
    }
  }
}
    ${PersonAccordionEntryPointFragmentDoc}`;

/**
 * __useGetPersonAccordionByIdQuery__
 *
 * To run a query within a React component, call `useGetPersonAccordionByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPersonAccordionByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPersonAccordionByIdQuery({
 *   variables: {
 *      locale: // value for 'locale'
 *      preview: // value for 'preview'
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetPersonAccordionByIdQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GetPersonAccordionByIdQuery, GetPersonAccordionByIdQueryVariables>) {
        return ApolloReactHooks.useQuery<GetPersonAccordionByIdQuery, GetPersonAccordionByIdQueryVariables>(GetPersonAccordionByIdDocument, baseOptions);
      }
export function useGetPersonAccordionByIdLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetPersonAccordionByIdQuery, GetPersonAccordionByIdQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetPersonAccordionByIdQuery, GetPersonAccordionByIdQueryVariables>(GetPersonAccordionByIdDocument, baseOptions);
        }
export type GetPersonAccordionByIdQueryHookResult = ReturnType<typeof useGetPersonAccordionByIdQuery>;
export type GetPersonAccordionByIdLazyQueryHookResult = ReturnType<typeof useGetPersonAccordionByIdLazyQuery>;
export type GetPersonAccordionByIdQueryResult = Apollo.QueryResult<GetPersonAccordionByIdQuery, GetPersonAccordionByIdQueryVariables>;
export const GetPersonAccordionEntryByIdDocument = gql`
    query GetPersonAccordionEntryById($locale: String, $preview: Boolean, $id: String!) {
  entryCollection(
    limit: 1
    where: {sys: {id: $id}}
    locale: $locale
    preview: $preview
  ) {
    items {
      ...PersonAccordionEntryEntryPoint
    }
  }
}
    ${PersonAccordionEntryEntryPointFragmentDoc}`;

/**
 * __useGetPersonAccordionEntryByIdQuery__
 *
 * To run a query within a React component, call `useGetPersonAccordionEntryByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPersonAccordionEntryByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPersonAccordionEntryByIdQuery({
 *   variables: {
 *      locale: // value for 'locale'
 *      preview: // value for 'preview'
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetPersonAccordionEntryByIdQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GetPersonAccordionEntryByIdQuery, GetPersonAccordionEntryByIdQueryVariables>) {
        return ApolloReactHooks.useQuery<GetPersonAccordionEntryByIdQuery, GetPersonAccordionEntryByIdQueryVariables>(GetPersonAccordionEntryByIdDocument, baseOptions);
      }
export function useGetPersonAccordionEntryByIdLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetPersonAccordionEntryByIdQuery, GetPersonAccordionEntryByIdQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetPersonAccordionEntryByIdQuery, GetPersonAccordionEntryByIdQueryVariables>(GetPersonAccordionEntryByIdDocument, baseOptions);
        }
export type GetPersonAccordionEntryByIdQueryHookResult = ReturnType<typeof useGetPersonAccordionEntryByIdQuery>;
export type GetPersonAccordionEntryByIdLazyQueryHookResult = ReturnType<typeof useGetPersonAccordionEntryByIdLazyQuery>;
export type GetPersonAccordionEntryByIdQueryResult = Apollo.QueryResult<GetPersonAccordionEntryByIdQuery, GetPersonAccordionEntryByIdQueryVariables>;
export const GetTwoColumnLayoutByIdDocument = gql`
    query GetTwoColumnLayoutById($locale: String, $preview: Boolean, $id: String!) {
  entryCollection(
    limit: 1
    where: {sys: {id: $id}}
    locale: $locale
    preview: $preview
  ) {
    items {
      ...TwoColumnLayoutEntryPoint
    }
  }
}
    ${TwoColumnLayoutEntryPointFragmentDoc}`;

/**
 * __useGetTwoColumnLayoutByIdQuery__
 *
 * To run a query within a React component, call `useGetTwoColumnLayoutByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTwoColumnLayoutByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTwoColumnLayoutByIdQuery({
 *   variables: {
 *      locale: // value for 'locale'
 *      preview: // value for 'preview'
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetTwoColumnLayoutByIdQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GetTwoColumnLayoutByIdQuery, GetTwoColumnLayoutByIdQueryVariables>) {
        return ApolloReactHooks.useQuery<GetTwoColumnLayoutByIdQuery, GetTwoColumnLayoutByIdQueryVariables>(GetTwoColumnLayoutByIdDocument, baseOptions);
      }
export function useGetTwoColumnLayoutByIdLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetTwoColumnLayoutByIdQuery, GetTwoColumnLayoutByIdQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetTwoColumnLayoutByIdQuery, GetTwoColumnLayoutByIdQueryVariables>(GetTwoColumnLayoutByIdDocument, baseOptions);
        }
export type GetTwoColumnLayoutByIdQueryHookResult = ReturnType<typeof useGetTwoColumnLayoutByIdQuery>;
export type GetTwoColumnLayoutByIdLazyQueryHookResult = ReturnType<typeof useGetTwoColumnLayoutByIdLazyQuery>;
export type GetTwoColumnLayoutByIdQueryResult = Apollo.QueryResult<GetTwoColumnLayoutByIdQuery, GetTwoColumnLayoutByIdQueryVariables>;
export const GetStaticPageSlugByIdDocument = gql`
    query GetStaticPageSlugById($locale: String, $preview: Boolean, $id: String!) {
  page: staticPage(id: $id, locale: $locale, preview: $preview) {
    slug
  }
}
    `;

/**
 * __useGetStaticPageSlugByIdQuery__
 *
 * To run a query within a React component, call `useGetStaticPageSlugByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetStaticPageSlugByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetStaticPageSlugByIdQuery({
 *   variables: {
 *      locale: // value for 'locale'
 *      preview: // value for 'preview'
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetStaticPageSlugByIdQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GetStaticPageSlugByIdQuery, GetStaticPageSlugByIdQueryVariables>) {
        return ApolloReactHooks.useQuery<GetStaticPageSlugByIdQuery, GetStaticPageSlugByIdQueryVariables>(GetStaticPageSlugByIdDocument, baseOptions);
      }
export function useGetStaticPageSlugByIdLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetStaticPageSlugByIdQuery, GetStaticPageSlugByIdQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetStaticPageSlugByIdQuery, GetStaticPageSlugByIdQueryVariables>(GetStaticPageSlugByIdDocument, baseOptions);
        }
export type GetStaticPageSlugByIdQueryHookResult = ReturnType<typeof useGetStaticPageSlugByIdQuery>;
export type GetStaticPageSlugByIdLazyQueryHookResult = ReturnType<typeof useGetStaticPageSlugByIdLazyQuery>;
export type GetStaticPageSlugByIdQueryResult = Apollo.QueryResult<GetStaticPageSlugByIdQuery, GetStaticPageSlugByIdQueryVariables>;
export const GetStaticPageSlugsDocument = gql`
    query GetStaticPageSlugs($locale: String, $preview: Boolean) {
  pages: staticPageCollection(
    locale: $locale
    preview: $preview
    where: {OR: [{standalone: false}, {standalone_exists: false}]}
  ) {
    items {
      slug
      seo {
        noFollowNoIndex
      }
    }
  }
}
    `;

/**
 * __useGetStaticPageSlugsQuery__
 *
 * To run a query within a React component, call `useGetStaticPageSlugsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetStaticPageSlugsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetStaticPageSlugsQuery({
 *   variables: {
 *      locale: // value for 'locale'
 *      preview: // value for 'preview'
 *   },
 * });
 */
export function useGetStaticPageSlugsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetStaticPageSlugsQuery, GetStaticPageSlugsQueryVariables>) {
        return ApolloReactHooks.useQuery<GetStaticPageSlugsQuery, GetStaticPageSlugsQueryVariables>(GetStaticPageSlugsDocument, baseOptions);
      }
export function useGetStaticPageSlugsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetStaticPageSlugsQuery, GetStaticPageSlugsQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetStaticPageSlugsQuery, GetStaticPageSlugsQueryVariables>(GetStaticPageSlugsDocument, baseOptions);
        }
export type GetStaticPageSlugsQueryHookResult = ReturnType<typeof useGetStaticPageSlugsQuery>;
export type GetStaticPageSlugsLazyQueryHookResult = ReturnType<typeof useGetStaticPageSlugsLazyQuery>;
export type GetStaticPageSlugsQueryResult = Apollo.QueryResult<GetStaticPageSlugsQuery, GetStaticPageSlugsQueryVariables>;
export const GetStaticPagesBySlugDocument = gql`
    query GetStaticPagesBySlug($locale: String, $preview: Boolean, $slug: String) {
  pages: staticPageCollection(
    locale: $locale
    preview: $preview
    where: {slug: $slug}
    limit: 1
  ) {
    items {
      ...FullPage
      ...StaticPageLocaleSlugs
    }
  }
}
    ${FullPageFragmentDoc}
${StaticPageLocaleSlugsFragmentDoc}`;

/**
 * __useGetStaticPagesBySlugQuery__
 *
 * To run a query within a React component, call `useGetStaticPagesBySlugQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetStaticPagesBySlugQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetStaticPagesBySlugQuery({
 *   variables: {
 *      locale: // value for 'locale'
 *      preview: // value for 'preview'
 *      slug: // value for 'slug'
 *   },
 * });
 */
export function useGetStaticPagesBySlugQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetStaticPagesBySlugQuery, GetStaticPagesBySlugQueryVariables>) {
        return ApolloReactHooks.useQuery<GetStaticPagesBySlugQuery, GetStaticPagesBySlugQueryVariables>(GetStaticPagesBySlugDocument, baseOptions);
      }
export function useGetStaticPagesBySlugLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetStaticPagesBySlugQuery, GetStaticPagesBySlugQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetStaticPagesBySlugQuery, GetStaticPagesBySlugQueryVariables>(GetStaticPagesBySlugDocument, baseOptions);
        }
export type GetStaticPagesBySlugQueryHookResult = ReturnType<typeof useGetStaticPagesBySlugQuery>;
export type GetStaticPagesBySlugLazyQueryHookResult = ReturnType<typeof useGetStaticPagesBySlugLazyQuery>;
export type GetStaticPagesBySlugQueryResult = Apollo.QueryResult<GetStaticPagesBySlugQuery, GetStaticPagesBySlugQueryVariables>;
export const GetStaticPagesByNewsTypeDocument = gql`
    query GetStaticPagesByNewsType($locale: String, $preview: Boolean, $newsType: String) {
  pages: staticPageCollection(
    locale: $locale
    preview: $preview
    where: {newsType: $newsType}
    limit: 1
  ) {
    items {
      ...FullPage
      ...StaticPageLocaleSlugs
    }
  }
}
    ${FullPageFragmentDoc}
${StaticPageLocaleSlugsFragmentDoc}`;

/**
 * __useGetStaticPagesByNewsTypeQuery__
 *
 * To run a query within a React component, call `useGetStaticPagesByNewsTypeQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetStaticPagesByNewsTypeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetStaticPagesByNewsTypeQuery({
 *   variables: {
 *      locale: // value for 'locale'
 *      preview: // value for 'preview'
 *      newsType: // value for 'newsType'
 *   },
 * });
 */
export function useGetStaticPagesByNewsTypeQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetStaticPagesByNewsTypeQuery, GetStaticPagesByNewsTypeQueryVariables>) {
        return ApolloReactHooks.useQuery<GetStaticPagesByNewsTypeQuery, GetStaticPagesByNewsTypeQueryVariables>(GetStaticPagesByNewsTypeDocument, baseOptions);
      }
export function useGetStaticPagesByNewsTypeLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetStaticPagesByNewsTypeQuery, GetStaticPagesByNewsTypeQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetStaticPagesByNewsTypeQuery, GetStaticPagesByNewsTypeQueryVariables>(GetStaticPagesByNewsTypeDocument, baseOptions);
        }
export type GetStaticPagesByNewsTypeQueryHookResult = ReturnType<typeof useGetStaticPagesByNewsTypeQuery>;
export type GetStaticPagesByNewsTypeLazyQueryHookResult = ReturnType<typeof useGetStaticPagesByNewsTypeLazyQuery>;
export type GetStaticPagesByNewsTypeQueryResult = Apollo.QueryResult<GetStaticPagesByNewsTypeQuery, GetStaticPagesByNewsTypeQueryVariables>;
export const LatestDownloadByTypeDocument = gql`
    query LatestDownloadByType($locale: String, $preview: Boolean, $type: String!) {
  latestDownload: downloadableFileCollection(
    locale: $locale
    preview: $preview
    where: {type: $type}
    limit: 1
    order: publishDate_DESC
  ) {
    items {
      ...FullDownloadableFile
    }
  }
}
    ${FullDownloadableFileFragmentDoc}`;

/**
 * __useLatestDownloadByTypeQuery__
 *
 * To run a query within a React component, call `useLatestDownloadByTypeQuery` and pass it any options that fit your needs.
 * When your component renders, `useLatestDownloadByTypeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLatestDownloadByTypeQuery({
 *   variables: {
 *      locale: // value for 'locale'
 *      preview: // value for 'preview'
 *      type: // value for 'type'
 *   },
 * });
 */
export function useLatestDownloadByTypeQuery(baseOptions: ApolloReactHooks.QueryHookOptions<LatestDownloadByTypeQuery, LatestDownloadByTypeQueryVariables>) {
        return ApolloReactHooks.useQuery<LatestDownloadByTypeQuery, LatestDownloadByTypeQueryVariables>(LatestDownloadByTypeDocument, baseOptions);
      }
export function useLatestDownloadByTypeLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<LatestDownloadByTypeQuery, LatestDownloadByTypeQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<LatestDownloadByTypeQuery, LatestDownloadByTypeQueryVariables>(LatestDownloadByTypeDocument, baseOptions);
        }
export type LatestDownloadByTypeQueryHookResult = ReturnType<typeof useLatestDownloadByTypeQuery>;
export type LatestDownloadByTypeLazyQueryHookResult = ReturnType<typeof useLatestDownloadByTypeLazyQuery>;
export type LatestDownloadByTypeQueryResult = Apollo.QueryResult<LatestDownloadByTypeQuery, LatestDownloadByTypeQueryVariables>;

type QueryFuncOptions<TVars, TData> = Omit<Apollo.QueryOptions<TVars, TData>, 'query'> & {
  apolloClient: Apollo.ApolloClient<any>
}

type MutationFuncOptions<TVars, TData> = Omit<Apollo.MutationOptions<TData, TVars>, 'mutation'> & {
  apolloClient: Apollo.ApolloClient<any>
}

const createQueryFunc = <TVars, TData>(query: any) => ({apolloClient, ...options}: QueryFuncOptions<TVars, TData>) => {
  
  return apolloClient.query<TData, TVars>({
    query,
    ...options
  })
}

const createMutationFunc = <TVars, TData>(mutation: any) => ({apolloClient, ...options}: MutationFuncOptions<TVars, TData>) => {
  
  return apolloClient.mutate<TData, TVars>({
    mutation,
    ...options
  })
}

export const queryGetAllNewsArticleByType = createQueryFunc<GetAllNewsArticleByTypeQueryVariables, GetAllNewsArticleByTypeQuery>(GetAllNewsArticleByTypeDocument)
export const queryGetFooter = createQueryFunc<GetFooterQueryVariables, GetFooterQuery>(GetFooterDocument)
export const queryGetLexiconArticleBySlug = createQueryFunc<GetLexiconArticleBySlugQueryVariables, GetLexiconArticleBySlugQuery>(GetLexiconArticleBySlugDocument)
export const queryGetLexiconArticlePreviews = createQueryFunc<GetLexiconArticlePreviewsQueryVariables, GetLexiconArticlePreviewsQuery>(GetLexiconArticlePreviewsDocument)
export const queryGetTopLexiconArticlePreviews = createQueryFunc<GetTopLexiconArticlePreviewsQueryVariables, GetTopLexiconArticlePreviewsQuery>(GetTopLexiconArticlePreviewsDocument)
export const queryGetLexiconArticlePreviewsOfLetter = createQueryFunc<GetLexiconArticlePreviewsOfLetterQueryVariables, GetLexiconArticlePreviewsOfLetterQuery>(GetLexiconArticlePreviewsOfLetterDocument)
export const queryGetLexiconArticleSlugs = createQueryFunc<GetLexiconArticleSlugsQueryVariables, GetLexiconArticleSlugsQuery>(GetLexiconArticleSlugsDocument)
export const queryGetLexiconArticlesFullText = createQueryFunc<GetLexiconArticlesFullTextQueryVariables, GetLexiconArticlesFullTextQuery>(GetLexiconArticlesFullTextDocument)
export const queryGetNavBarEntries = createQueryFunc<GetNavBarEntriesQueryVariables, GetNavBarEntriesQuery>(GetNavBarEntriesDocument)
export const queryGetNewsArticleBySlug = createQueryFunc<GetNewsArticleBySlugQueryVariables, GetNewsArticleBySlugQuery>(GetNewsArticleBySlugDocument)
export const queryGetNewsArticlePreviews = createQueryFunc<GetNewsArticlePreviewsQueryVariables, GetNewsArticlePreviewsQuery>(GetNewsArticlePreviewsDocument)
export const queryGetTopNewsArticlePreviews = createQueryFunc<GetTopNewsArticlePreviewsQueryVariables, GetTopNewsArticlePreviewsQuery>(GetTopNewsArticlePreviewsDocument)
export const queryGetNewsArticlePreviewsOfLocation = createQueryFunc<GetNewsArticlePreviewsOfLocationQueryVariables, GetNewsArticlePreviewsOfLocationQuery>(GetNewsArticlePreviewsOfLocationDocument)
export const queryGetNewsArticlePreviewsOfThreeNewsType = createQueryFunc<GetNewsArticlePreviewsOfThreeNewsTypeQueryVariables, GetNewsArticlePreviewsOfThreeNewsTypeQuery>(GetNewsArticlePreviewsOfThreeNewsTypeDocument)
export const queryGetNewsArticleSlugs = createQueryFunc<GetNewsArticleSlugsQueryVariables, GetNewsArticleSlugsQuery>(GetNewsArticleSlugsDocument)
export const queryGetNewsArticlesFullText = createQueryFunc<GetNewsArticlesFullTextQueryVariables, GetNewsArticlesFullTextQuery>(GetNewsArticlesFullTextDocument)
export const queryGetOtherNewsArticlePreviewsOfType = createQueryFunc<GetOtherNewsArticlePreviewsOfTypeQueryVariables, GetOtherNewsArticlePreviewsOfTypeQuery>(GetOtherNewsArticlePreviewsOfTypeDocument)
export const queryGetProjectImageMapById = createQueryFunc<GetProjectImageMapByIdQueryVariables, GetProjectImageMapByIdQuery>(GetProjectImageMapByIdDocument)
export const queryGetProjectLinkSectionById = createQueryFunc<GetProjectLinkSectionByIdQueryVariables, GetProjectLinkSectionByIdQuery>(GetProjectLinkSectionByIdDocument)
export const queryGetProjectPageById = createQueryFunc<GetProjectPageByIdQueryVariables, GetProjectPageByIdQuery>(GetProjectPageByIdDocument)
export const queryGetAllStaticFilters = createQueryFunc<GetAllStaticFiltersQueryVariables, GetAllStaticFiltersQuery>(GetAllStaticFiltersDocument)
export const queryGetAccordionById = createQueryFunc<GetAccordionByIdQueryVariables, GetAccordionByIdQuery>(GetAccordionByIdDocument)
export const queryGetAccordionEntryById = createQueryFunc<GetAccordionEntryByIdQueryVariables, GetAccordionEntryByIdQuery>(GetAccordionEntryByIdDocument)
export const queryGetBarChartWithBackgroundById = createQueryFunc<GetBarChartWithBackgroundByIdQueryVariables, GetBarChartWithBackgroundByIdQuery>(GetBarChartWithBackgroundByIdDocument)
export const queryGetBlockAnalystRatingById = createQueryFunc<GetBlockAnalystRatingByIdQueryVariables, GetBlockAnalystRatingByIdQuery>(GetBlockAnalystRatingByIdDocument)
export const queryGetBlockBigTitleNavigationById = createQueryFunc<GetBlockBigTitleNavigationByIdQueryVariables, GetBlockBigTitleNavigationByIdQuery>(GetBlockBigTitleNavigationByIdDocument)
export const queryGetBlockHiddenWithConsentById = createQueryFunc<GetBlockHiddenWithConsentByIdQueryVariables, GetBlockHiddenWithConsentByIdQuery>(GetBlockHiddenWithConsentByIdDocument)
export const queryGetBlockHiddenWithConsentWithoutChildrenById = createQueryFunc<GetBlockHiddenWithConsentWithoutChildrenByIdQueryVariables, GetBlockHiddenWithConsentWithoutChildrenByIdQuery>(GetBlockHiddenWithConsentWithoutChildrenByIdDocument)
export const queryGetBlockHighlightRealEstateById = createQueryFunc<GetBlockHighlightRealEstateByIdQueryVariables, GetBlockHighlightRealEstateByIdQuery>(GetBlockHighlightRealEstateByIdDocument)
export const queryGetBlockImageGalleryById = createQueryFunc<GetBlockImageGalleryByIdQueryVariables, GetBlockImageGalleryByIdQuery>(GetBlockImageGalleryByIdDocument)
export const queryGetBlockLinkSectionById = createQueryFunc<GetBlockLinkSectionByIdQueryVariables, GetBlockLinkSectionByIdQuery>(GetBlockLinkSectionByIdDocument)
export const queryGetBlockPartnerGridById = createQueryFunc<GetBlockPartnerGridByIdQueryVariables, GetBlockPartnerGridByIdQuery>(GetBlockPartnerGridByIdDocument)
export const queryGetBlockSliderById = createQueryFunc<GetBlockSliderByIdQueryVariables, GetBlockSliderByIdQuery>(GetBlockSliderByIdDocument)
export const queryGetBlockSliderEntryById = createQueryFunc<GetBlockSliderEntryByIdQueryVariables, GetBlockSliderEntryByIdQuery>(GetBlockSliderEntryByIdDocument)
export const queryGetBlockSpeechBubbleById = createQueryFunc<GetBlockSpeechBubbleByIdQueryVariables, GetBlockSpeechBubbleByIdQuery>(GetBlockSpeechBubbleByIdDocument)
export const queryGetBlockStockPriceById = createQueryFunc<GetBlockStockPriceByIdQueryVariables, GetBlockStockPriceByIdQuery>(GetBlockStockPriceByIdDocument)
export const queryGetBlockSubNavigationById = createQueryFunc<GetBlockSubNavigationByIdQueryVariables, GetBlockSubNavigationByIdQuery>(GetBlockSubNavigationByIdDocument)
export const queryGetBlockTextCloudById = createQueryFunc<GetBlockTextCloudByIdQueryVariables, GetBlockTextCloudByIdQuery>(GetBlockTextCloudByIdDocument)
export const queryGetBlockThreeColumnById = createQueryFunc<GetBlockThreeColumnByIdQueryVariables, GetBlockThreeColumnByIdQuery>(GetBlockThreeColumnByIdDocument)
export const queryGetBlockVideoById = createQueryFunc<GetBlockVideoByIdQueryVariables, GetBlockVideoByIdQuery>(GetBlockVideoByIdDocument)
export const queryGetCustomBlockById = createQueryFunc<GetCustomBlockByIdQueryVariables, GetCustomBlockByIdQuery>(GetCustomBlockByIdDocument)
export const queryGetFullBlockCallToActionButtonById = createQueryFunc<GetFullBlockCallToActionButtonByIdQueryVariables, GetFullBlockCallToActionButtonByIdQuery>(GetFullBlockCallToActionButtonByIdDocument)
export const queryGetFullBlockFullsizeImageById = createQueryFunc<GetFullBlockFullsizeImageByIdQueryVariables, GetFullBlockFullsizeImageByIdQuery>(GetFullBlockFullsizeImageByIdDocument)
export const queryGetFullBlockRibbonById = createQueryFunc<GetFullBlockRibbonByIdQueryVariables, GetFullBlockRibbonByIdQuery>(GetFullBlockRibbonByIdDocument)
export const queryGetFullBlockRichTextById = createQueryFunc<GetFullBlockRichTextByIdQueryVariables, GetFullBlockRichTextByIdQuery>(GetFullBlockRichTextByIdDocument)
export const queryGetFullBlockTableById = createQueryFunc<GetFullBlockTableByIdQueryVariables, GetFullBlockTableByIdQuery>(GetFullBlockTableByIdDocument)
export const queryGetLatestDownloadById = createQueryFunc<GetLatestDownloadByIdQueryVariables, GetLatestDownloadByIdQuery>(GetLatestDownloadByIdDocument)
export const queryGetNavigationEntryById = createQueryFunc<GetNavigationEntryByIdQueryVariables, GetNavigationEntryByIdQuery>(GetNavigationEntryByIdDocument)
export const queryGetOneColumnLayoutById = createQueryFunc<GetOneColumnLayoutByIdQueryVariables, GetOneColumnLayoutByIdQuery>(GetOneColumnLayoutByIdDocument)
export const queryGetPersonAccordionById = createQueryFunc<GetPersonAccordionByIdQueryVariables, GetPersonAccordionByIdQuery>(GetPersonAccordionByIdDocument)
export const queryGetPersonAccordionEntryById = createQueryFunc<GetPersonAccordionEntryByIdQueryVariables, GetPersonAccordionEntryByIdQuery>(GetPersonAccordionEntryByIdDocument)
export const queryGetTwoColumnLayoutById = createQueryFunc<GetTwoColumnLayoutByIdQueryVariables, GetTwoColumnLayoutByIdQuery>(GetTwoColumnLayoutByIdDocument)
export const queryGetStaticPageSlugById = createQueryFunc<GetStaticPageSlugByIdQueryVariables, GetStaticPageSlugByIdQuery>(GetStaticPageSlugByIdDocument)
export const queryGetStaticPageSlugs = createQueryFunc<GetStaticPageSlugsQueryVariables, GetStaticPageSlugsQuery>(GetStaticPageSlugsDocument)
export const queryGetStaticPagesBySlug = createQueryFunc<GetStaticPagesBySlugQueryVariables, GetStaticPagesBySlugQuery>(GetStaticPagesBySlugDocument)
export const queryGetStaticPagesByNewsType = createQueryFunc<GetStaticPagesByNewsTypeQueryVariables, GetStaticPagesByNewsTypeQuery>(GetStaticPagesByNewsTypeDocument)
export const queryLatestDownloadByType = createQueryFunc<LatestDownloadByTypeQueryVariables, LatestDownloadByTypeQuery>(LatestDownloadByTypeDocument)